var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $7610d1aa0befc885$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
(()=>{
    var GE = Object.create;
    var d2 = Object.defineProperty;
    var CE = Object.getOwnPropertyDescriptor;
    var AE = Object.getOwnPropertyNames;
    var NE = Object.getPrototypeOf, FE = Object.prototype.hasOwnProperty;
    var ME = (e, _)=>()=>(_ || e((_ = {
                exports: {}
            }).exports, _), _.exports);
    var PE = (e, _, r, t)=>{
        if (_ && typeof _ == "object" || typeof _ == "function") for (let n of AE(_))!FE.call(e, n) && n !== r && d2(e, n, {
            get: ()=>_[n],
            enumerable: !(t = CE(_, n)) || t.enumerable
        });
        return e;
    };
    var LE = (e, _, r)=>(r = e != null ? GE(NE(e)) : {}, PE(_ || !e || !e.__esModule ? d2(r, "default", {
            value: e,
            enumerable: !0
        }) : r, e));
    var Pk = ME((uh, gh)=>{
        (function(e, _) {
            typeof define == "function" && define.amd ? define([], _) : typeof gh == "object" && typeof uh < "u" ? gh.exports = _() : e.Papa = _();
        })(uh, function e() {
            "use strict";
            var _ = typeof self < "u" ? self : typeof window < "u" ? window : _ !== void 0 ? _ : {}, r = !_.document && !!_.postMessage, t = _.IS_PAPA_WORKER || !1, n = {}, s = 0, c = {
                parse: function(F, y) {
                    var w = (y = y || {}).dynamicTyping || !1;
                    if (Q(w) && (y.dynamicTypingFunction = w, w = {}), y.dynamicTyping = w, y.transform = !!Q(y.transform) && y.transform, y.worker && c.WORKERS_SUPPORTED) {
                        var x = function() {
                            if (!c.WORKERS_SUPPORTED) return !1;
                            var C = (G = _.URL || _.webkitURL || null, $_ = e.toString(), c.BLOB_URL || (c.BLOB_URL = G.createObjectURL(new Blob([
                                "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                                "(",
                                $_,
                                ")();"
                            ], {
                                type: "text/javascript"
                            })))), A = new _.Worker(C), G, $_;
                            return A.onmessage = J, A.id = s++, n[A.id] = A;
                        }();
                        return x.userStep = y.step, x.userChunk = y.chunk, x.userComplete = y.complete, x.userError = y.error, y.step = Q(y.step), y.chunk = Q(y.chunk), y.complete = Q(y.complete), y.error = Q(y.error), delete y.worker, void x.postMessage({
                            input: F,
                            config: y,
                            workerId: x.id
                        });
                    }
                    var T = null;
                    return c.NODE_STREAM_INPUT, typeof F == "string" ? (F = function(C) {
                        return C.charCodeAt(0) === 65279 ? C.slice(1) : C;
                    }(F), T = y.download ? new v(y) : new p(y)) : F.readable === !0 && Q(F.read) && Q(F.on) ? T = new u(y) : (_.File && F instanceof File || F instanceof Object) && (T = new b(y)), T.stream(F);
                },
                unparse: function(F, y) {
                    var w = !1, x = !0, T = ",", C = `\r
`, A = '"', G = A + A, $_ = !1, i_ = null, W_ = !1;
                    (function() {
                        if (typeof y == "object") {
                            if (typeof y.delimiter != "string" || c.BAD_DELIMITERS.filter(function(p_) {
                                return y.delimiter.indexOf(p_) !== -1;
                            }).length || (T = y.delimiter), (typeof y.quotes == "boolean" || typeof y.quotes == "function" || Array.isArray(y.quotes)) && (w = y.quotes), typeof y.skipEmptyLines != "boolean" && typeof y.skipEmptyLines != "string" || ($_ = y.skipEmptyLines), typeof y.newline == "string" && (C = y.newline), typeof y.quoteChar == "string" && (A = y.quoteChar), typeof y.header == "boolean" && (x = y.header), Array.isArray(y.columns)) {
                                if (y.columns.length === 0) throw new Error("Option columns is empty");
                                i_ = y.columns;
                            }
                            y.escapeChar !== void 0 && (G = y.escapeChar + A), (typeof y.escapeFormulae == "boolean" || y.escapeFormulae instanceof RegExp) && (W_ = y.escapeFormulae instanceof RegExp ? y.escapeFormulae : /^[=+\-@\t\r].*$/);
                        }
                    })();
                    var g_ = new RegExp(z(A), "g");
                    if (typeof F == "string" && (F = JSON.parse(F)), Array.isArray(F)) {
                        if (!F.length || Array.isArray(F[0])) return U_(null, F, $_);
                        if (typeof F[0] == "object") return U_(i_ || Object.keys(F[0]), F, $_);
                    } else if (typeof F == "object") return typeof F.data == "string" && (F.data = JSON.parse(F.data)), Array.isArray(F.data) && (F.fields || (F.fields = F.meta && F.meta.fields || i_), F.fields || (F.fields = Array.isArray(F.data[0]) ? F.fields : typeof F.data[0] == "object" ? Object.keys(F.data[0]) : []), Array.isArray(F.data[0]) || typeof F.data[0] == "object" || (F.data = [
                        F.data
                    ])), U_(F.fields || [], F.data || [], $_);
                    throw new Error("Unable to serialize unrecognized input");
                    function U_(p_, pe, Fe) {
                        var n_ = "";
                        typeof p_ == "string" && (p_ = JSON.parse(p_)), typeof pe == "string" && (pe = JSON.parse(pe));
                        var N_ = Array.isArray(p_) && 0 < p_.length, H_ = !Array.isArray(pe[0]);
                        if (N_ && x) {
                            for(var P_ = 0; P_ < p_.length; P_++)0 < P_ && (n_ += T), n_ += we(p_[P_], P_);
                            0 < pe.length && (n_ += C);
                        }
                        for(var Z = 0; Z < pe.length; Z++){
                            var e_ = N_ ? p_.length : pe[Z].length, S_ = !1, h_ = N_ ? Object.keys(pe[Z]).length === 0 : pe[Z].length === 0;
                            if (Fe && !N_ && (S_ = Fe === "greedy" ? pe[Z].join("").trim() === "" : pe[Z].length === 1 && pe[Z][0].length === 0), Fe === "greedy" && N_) {
                                for(var G_ = [], de = 0; de < e_; de++){
                                    var C_ = H_ ? p_[de] : de;
                                    G_.push(pe[Z][C_]);
                                }
                                S_ = G_.join("").trim() === "";
                            }
                            if (!S_) {
                                for(var L_ = 0; L_ < e_; L_++){
                                    0 < L_ && !h_ && (n_ += T);
                                    var We = N_ && H_ ? p_[L_] : L_;
                                    n_ += we(pe[Z][We], L_);
                                }
                                Z < pe.length - 1 && (!Fe || 0 < e_ && !h_) && (n_ += C);
                            }
                        }
                        return n_;
                    }
                    function we(p_, pe) {
                        if (p_ == null) return "";
                        if (p_.constructor === Date) return JSON.stringify(p_).slice(1, 25);
                        var Fe = !1;
                        W_ && typeof p_ == "string" && W_.test(p_) && (p_ = "'" + p_, Fe = !0);
                        var n_ = p_.toString().replace(g_, G);
                        return (Fe = Fe || w === !0 || typeof w == "function" && w(p_, pe) || Array.isArray(w) && w[pe] || function(N_, H_) {
                            for(var P_ = 0; P_ < H_.length; P_++)if (-1 < N_.indexOf(H_[P_])) return !0;
                            return !1;
                        }(n_, c.BAD_DELIMITERS) || -1 < n_.indexOf(T) || n_.charAt(0) === " " || n_.charAt(n_.length - 1) === " ") ? A + n_ + A : n_;
                    }
                }
            };
            if (c.RECORD_SEP = String.fromCharCode(30), c.UNIT_SEP = String.fromCharCode(31), c.BYTE_ORDER_MARK = "\uFEFF", c.BAD_DELIMITERS = [
                "\r",
                `
`,
                '"',
                c.BYTE_ORDER_MARK
            ], c.WORKERS_SUPPORTED = !r && !!_.Worker, c.NODE_STREAM_INPUT = 1, c.LocalChunkSize = 10485760, c.RemoteChunkSize = 5242880, c.DefaultDelimiter = ",", c.Parser = L, c.ParserHandle = m, c.NetworkStreamer = v, c.FileStreamer = b, c.StringStreamer = p, c.ReadableStreamStreamer = u, _.jQuery) {
                var i = _.jQuery;
                i.fn.parse = function(F) {
                    var y = F.config || {}, w = [];
                    return this.each(function(C) {
                        if (!(i(this).prop("tagName").toUpperCase() === "INPUT" && i(this).attr("type").toLowerCase() === "file" && _.FileReader) || !this.files || this.files.length === 0) return !0;
                        for(var A = 0; A < this.files.length; A++)w.push({
                            file: this.files[A],
                            inputElem: this,
                            instanceConfig: i.extend({}, y)
                        });
                    }), x(), this;
                    function x() {
                        if (w.length !== 0) {
                            var C, A, G, $_, i_ = w[0];
                            if (Q(F.before)) {
                                var W_ = F.before(i_.file, i_.inputElem);
                                if (typeof W_ == "object") {
                                    if (W_.action === "abort") return C = "AbortError", A = i_.file, G = i_.inputElem, $_ = W_.reason, void (Q(F.error) && F.error({
                                        name: C
                                    }, A, G, $_));
                                    if (W_.action === "skip") return void T();
                                    typeof W_.config == "object" && (i_.instanceConfig = i.extend(i_.instanceConfig, W_.config));
                                } else if (W_ === "skip") return void T();
                            }
                            var g_ = i_.instanceConfig.complete;
                            i_.instanceConfig.complete = function(U_) {
                                Q(g_) && g_(U_, i_.file, i_.inputElem), T();
                            }, c.parse(i_.file, i_.instanceConfig);
                        } else Q(F.complete) && F.complete();
                    }
                    function T() {
                        w.splice(0, 1), x();
                    }
                };
            }
            function d(F) {
                this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
                    data: [],
                    errors: [],
                    meta: {}
                }, (function(y) {
                    var w = W(y);
                    w.chunkSize = parseInt(w.chunkSize), y.step || y.chunk || (w.chunkSize = null), this._handle = new m(w), (this._handle.streamer = this)._config = w;
                }).call(this, F), this.parseChunk = function(y, w) {
                    if (this.isFirstChunk && Q(this._config.beforeFirstChunk)) {
                        var x = this._config.beforeFirstChunk(y);
                        x !== void 0 && (y = x);
                    }
                    this.isFirstChunk = !1, this._halted = !1;
                    var T = this._partialLine + y;
                    this._partialLine = "";
                    var C = this._handle.parse(T, this._baseIndex, !this._finished);
                    if (!this._handle.paused() && !this._handle.aborted()) {
                        var A = C.meta.cursor;
                        this._finished || (this._partialLine = T.substring(A - this._baseIndex), this._baseIndex = A), C && C.data && (this._rowCount += C.data.length);
                        var G = this._finished || this._config.preview && this._rowCount >= this._config.preview;
                        if (t) _.postMessage({
                            results: C,
                            workerId: c.WORKER_ID,
                            finished: G
                        });
                        else if (Q(this._config.chunk) && !w) {
                            if (this._config.chunk(C, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                            C = void 0, this._completeResults = void 0;
                        }
                        return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(C.data), this._completeResults.errors = this._completeResults.errors.concat(C.errors), this._completeResults.meta = C.meta), this._completed || !G || !Q(this._config.complete) || C && C.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), G || C && C.meta.paused || this._nextChunk(), C;
                    }
                    this._halted = !0;
                }, this._sendError = function(y) {
                    Q(this._config.error) ? this._config.error(y) : t && this._config.error && _.postMessage({
                        workerId: c.WORKER_ID,
                        error: y,
                        finished: !1
                    });
                };
            }
            function v(F) {
                var y;
                (F = F || {}).chunkSize || (F.chunkSize = c.RemoteChunkSize), d.call(this, F), this._nextChunk = r ? function() {
                    this._readChunk(), this._chunkLoaded();
                } : function() {
                    this._readChunk();
                }, this.stream = function(w) {
                    this._input = w, this._nextChunk();
                }, this._readChunk = function() {
                    if (this._finished) this._chunkLoaded();
                    else {
                        if (y = new XMLHttpRequest, this._config.withCredentials && (y.withCredentials = this._config.withCredentials), r || (y.onload = a_(this._chunkLoaded, this), y.onerror = a_(this._chunkError, this)), y.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !r), this._config.downloadRequestHeaders) {
                            var w = this._config.downloadRequestHeaders;
                            for(var x in w)y.setRequestHeader(x, w[x]);
                        }
                        if (this._config.chunkSize) {
                            var T = this._start + this._config.chunkSize - 1;
                            y.setRequestHeader("Range", "bytes=" + this._start + "-" + T);
                        }
                        try {
                            y.send(this._config.downloadRequestBody);
                        } catch (C) {
                            this._chunkError(C.message);
                        }
                        r && y.status === 0 && this._chunkError();
                    }
                }, this._chunkLoaded = function() {
                    y.readyState === 4 && (y.status < 200 || 400 <= y.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : y.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(w) {
                        var x = w.getResponseHeader("Content-Range");
                        return x === null ? -1 : parseInt(x.substring(x.lastIndexOf("/") + 1));
                    }(y), this.parseChunk(y.responseText)));
                }, this._chunkError = function(w) {
                    var x = y.statusText || w;
                    this._sendError(new Error(x));
                };
            }
            function b(F) {
                var y, w;
                (F = F || {}).chunkSize || (F.chunkSize = c.LocalChunkSize), d.call(this, F);
                var x = typeof FileReader < "u";
                this.stream = function(T) {
                    this._input = T, w = T.slice || T.webkitSlice || T.mozSlice, x ? ((y = new FileReader).onload = a_(this._chunkLoaded, this), y.onerror = a_(this._chunkError, this)) : y = new FileReaderSync, this._nextChunk();
                }, this._nextChunk = function() {
                    this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
                }, this._readChunk = function() {
                    var T = this._input;
                    if (this._config.chunkSize) {
                        var C = Math.min(this._start + this._config.chunkSize, this._input.size);
                        T = w.call(T, this._start, C);
                    }
                    var A = y.readAsText(T, this._config.encoding);
                    x || this._chunkLoaded({
                        target: {
                            result: A
                        }
                    });
                }, this._chunkLoaded = function(T) {
                    this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(T.target.result);
                }, this._chunkError = function() {
                    this._sendError(y.error);
                };
            }
            function p(F) {
                var y;
                d.call(this, F = F || {}), this.stream = function(w) {
                    return y = w, this._nextChunk();
                }, this._nextChunk = function() {
                    if (!this._finished) {
                        var w, x = this._config.chunkSize;
                        return x ? (w = y.substring(0, x), y = y.substring(x)) : (w = y, y = ""), this._finished = !y, this.parseChunk(w);
                    }
                };
            }
            function u(F) {
                d.call(this, F = F || {});
                var y = [], w = !0, x = !1;
                this.pause = function() {
                    d.prototype.pause.apply(this, arguments), this._input.pause();
                }, this.resume = function() {
                    d.prototype.resume.apply(this, arguments), this._input.resume();
                }, this.stream = function(T) {
                    this._input = T, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
                }, this._checkIsFinished = function() {
                    x && y.length === 1 && (this._finished = !0);
                }, this._nextChunk = function() {
                    this._checkIsFinished(), y.length ? this.parseChunk(y.shift()) : w = !0;
                }, this._streamData = a_(function(T) {
                    try {
                        y.push(typeof T == "string" ? T : T.toString(this._config.encoding)), w && (w = !1, this._checkIsFinished(), this.parseChunk(y.shift()));
                    } catch (C) {
                        this._streamError(C);
                    }
                }, this), this._streamError = a_(function(T) {
                    this._streamCleanUp(), this._sendError(T);
                }, this), this._streamEnd = a_(function() {
                    this._streamCleanUp(), x = !0, this._streamData("");
                }, this), this._streamCleanUp = a_(function() {
                    this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
                }, this);
            }
            function m(F) {
                var y, w, x, T = Math.pow(2, 53), C = -T, A = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, G = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, $_ = this, i_ = 0, W_ = 0, g_ = !1, U_ = !1, we = [], p_ = {
                    data: [],
                    errors: [],
                    meta: {}
                };
                if (Q(F.step)) {
                    var pe = F.step;
                    F.step = function(Z) {
                        if (p_ = Z, N_()) n_();
                        else {
                            if (n_(), p_.data.length === 0) return;
                            i_ += Z.data.length, F.preview && i_ > F.preview ? w.abort() : (p_.data = p_.data[0], pe(p_, $_));
                        }
                    };
                }
                function Fe(Z) {
                    return F.skipEmptyLines === "greedy" ? Z.join("").trim() === "" : Z.length === 1 && Z[0].length === 0;
                }
                function n_() {
                    return p_ && x && (P_("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + c.DefaultDelimiter + "'"), x = !1), F.skipEmptyLines && (p_.data = p_.data.filter(function(Z) {
                        return !Fe(Z);
                    })), N_() && function() {
                        if (!p_) return;
                        function Z(S_, h_) {
                            Q(F.transformHeader) && (S_ = F.transformHeader(S_, h_)), we.push(S_);
                        }
                        if (Array.isArray(p_.data[0])) {
                            for(var e_ = 0; N_() && e_ < p_.data.length; e_++)p_.data[e_].forEach(Z);
                            p_.data.splice(0, 1);
                        } else p_.data.forEach(Z);
                    }(), function() {
                        if (!p_ || !F.header && !F.dynamicTyping && !F.transform) return p_;
                        function Z(S_, h_) {
                            var G_, de = F.header ? {} : [];
                            for(G_ = 0; G_ < S_.length; G_++){
                                var C_ = G_, L_ = S_[G_];
                                F.header && (C_ = G_ >= we.length ? "__parsed_extra" : we[G_]), F.transform && (L_ = F.transform(L_, C_)), L_ = H_(C_, L_), C_ === "__parsed_extra" ? (de[C_] = de[C_] || [], de[C_].push(L_)) : de[C_] = L_;
                            }
                            return F.header && (G_ > we.length ? P_("FieldMismatch", "TooManyFields", "Too many fields: expected " + we.length + " fields but parsed " + G_, W_ + h_) : G_ < we.length && P_("FieldMismatch", "TooFewFields", "Too few fields: expected " + we.length + " fields but parsed " + G_, W_ + h_)), de;
                        }
                        var e_ = 1;
                        return !p_.data.length || Array.isArray(p_.data[0]) ? (p_.data = p_.data.map(Z), e_ = p_.data.length) : p_.data = Z(p_.data, 0), F.header && p_.meta && (p_.meta.fields = we), W_ += e_, p_;
                    }();
                }
                function N_() {
                    return F.header && we.length === 0;
                }
                function H_(Z, e_) {
                    var S_;
                    return S_ = Z, F.dynamicTypingFunction && F.dynamicTyping[S_] === void 0 && (F.dynamicTyping[S_] = F.dynamicTypingFunction(S_)), (F.dynamicTyping[S_] || F.dynamicTyping) === !0 ? e_ === "true" || e_ === "TRUE" || e_ !== "false" && e_ !== "FALSE" && (function(h_) {
                        if (A.test(h_)) {
                            var G_ = parseFloat(h_);
                            if (C < G_ && G_ < T) return !0;
                        }
                        return !1;
                    }(e_) ? parseFloat(e_) : G.test(e_) ? new Date(e_) : e_ === "" ? null : e_) : e_;
                }
                function P_(Z, e_, S_, h_) {
                    var G_ = {
                        type: Z,
                        code: e_,
                        message: S_
                    };
                    h_ !== void 0 && (G_.row = h_), p_.errors.push(G_);
                }
                this.parse = function(Z, e_, S_) {
                    var h_ = F.quoteChar || '"';
                    if (F.newline || (F.newline = function(C_, L_) {
                        C_ = C_.substring(0, 1048576);
                        var We = new RegExp(z(L_) + "([^]*?)" + z(L_), "gm"), Ne = (C_ = C_.replace(We, "")).split("\r"), Xe = C_.split(`
`), lo = 1 < Xe.length && Xe[0].length < Ne[0].length;
                        if (Ne.length === 1 || lo) return `
`;
                        for(var ve = 0, b_ = 0; b_ < Ne.length; b_++)Ne[b_][0] === `
` && ve++;
                        return ve >= Ne.length / 2 ? `\r
` : "\r";
                    }(Z, h_)), x = !1, F.delimiter) Q(F.delimiter) && (F.delimiter = F.delimiter(Z), p_.meta.delimiter = F.delimiter);
                    else {
                        var G_ = function(C_, L_, We, Ne, Xe) {
                            var lo, ve, b_, D_;
                            Xe = Xe || [
                                ",",
                                "	",
                                "|",
                                ";",
                                c.RECORD_SEP,
                                c.UNIT_SEP
                            ];
                            for(var w_ = 0; w_ < Xe.length; w_++){
                                var l_ = Xe[w_], j_ = 0, q_ = 0, $e = 0;
                                b_ = void 0;
                                for(var ee = new L({
                                    comments: Ne,
                                    delimiter: l_,
                                    newline: L_,
                                    preview: 10
                                }).parse(C_), Ge = 0; Ge < ee.data.length; Ge++)if (We && Fe(ee.data[Ge])) $e++;
                                else {
                                    var _r = ee.data[Ge].length;
                                    q_ += _r, b_ !== void 0 ? 0 < _r && (j_ += Math.abs(_r - b_), b_ = _r) : b_ = _r;
                                }
                                0 < ee.data.length && (q_ /= ee.data.length - $e), (ve === void 0 || j_ <= ve) && (D_ === void 0 || D_ < q_) && 1.99 < q_ && (ve = j_, lo = l_, D_ = q_);
                            }
                            return {
                                successful: !!(F.delimiter = lo),
                                bestDelimiter: lo
                            };
                        }(Z, F.newline, F.skipEmptyLines, F.comments, F.delimitersToGuess);
                        G_.successful ? F.delimiter = G_.bestDelimiter : (x = !0, F.delimiter = c.DefaultDelimiter), p_.meta.delimiter = F.delimiter;
                    }
                    var de = W(F);
                    return F.preview && F.header && de.preview++, y = Z, w = new L(de), p_ = w.parse(y, e_, S_), n_(), g_ ? {
                        meta: {
                            paused: !0
                        }
                    } : p_ || {
                        meta: {
                            paused: !1
                        }
                    };
                }, this.paused = function() {
                    return g_;
                }, this.pause = function() {
                    g_ = !0, w.abort(), y = Q(F.chunk) ? "" : y.substring(w.getCharIndex());
                }, this.resume = function() {
                    $_.streamer._halted ? (g_ = !1, $_.streamer.parseChunk(y, !0)) : setTimeout($_.resume, 3);
                }, this.aborted = function() {
                    return U_;
                }, this.abort = function() {
                    U_ = !0, w.abort(), p_.meta.aborted = !0, Q(F.complete) && F.complete(p_), y = "";
                };
            }
            function z(F) {
                return F.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            }
            function L(F) {
                var y, w = (F = F || {}).delimiter, x = F.newline, T = F.comments, C = F.step, A = F.preview, G = F.fastMode, $_ = y = F.quoteChar === void 0 || F.quoteChar === null ? '"' : F.quoteChar;
                if (F.escapeChar !== void 0 && ($_ = F.escapeChar), (typeof w != "string" || -1 < c.BAD_DELIMITERS.indexOf(w)) && (w = ","), T === w) throw new Error("Comment character same as delimiter");
                T === !0 ? T = "#" : (typeof T != "string" || -1 < c.BAD_DELIMITERS.indexOf(T)) && (T = !1), x !== `
` && x !== "\r" && x !== `\r
` && (x = `
`);
                var i_ = 0, W_ = !1;
                this.parse = function(g_, U_, we) {
                    if (typeof g_ != "string") throw new Error("Input must be a string");
                    var p_ = g_.length, pe = w.length, Fe = x.length, n_ = T.length, N_ = Q(C), H_ = [], P_ = [], Z = [], e_ = i_ = 0;
                    if (!g_) return er();
                    if (F.header && !U_) {
                        var S_ = g_.split(x)[0].split(w), h_ = [], G_ = {}, de = !1;
                        for(var C_ in S_){
                            var L_ = S_[C_];
                            Q(F.transformHeader) && (L_ = F.transformHeader(L_, C_));
                            var We = L_, Ne = G_[L_] || 0;
                            for(0 < Ne && (de = !0, We = L_ + "_" + Ne), G_[L_] = Ne + 1; h_.includes(We);)We = We + "_" + Ne;
                            h_.push(We);
                        }
                        if (de) {
                            var Xe = g_.split(x);
                            Xe[0] = h_.join(w), g_ = Xe.join(x);
                        }
                    }
                    if (G || G !== !1 && g_.indexOf(y) === -1) {
                        for(var lo = g_.split(x), ve = 0; ve < lo.length; ve++){
                            if (Z = lo[ve], i_ += Z.length, ve !== lo.length - 1) i_ += x.length;
                            else if (we) return er();
                            if (!T || Z.substring(0, n_) !== T) {
                                if (N_) {
                                    if (H_ = [], $e(Z.split(w)), Ln(), W_) return er();
                                } else $e(Z.split(w));
                                if (A && A <= ve) return H_ = H_.slice(0, A), er(!0);
                            }
                        }
                        return er();
                    }
                    for(var b_ = g_.indexOf(w, i_), D_ = g_.indexOf(x, i_), w_ = new RegExp(z($_) + z(y), "g"), l_ = g_.indexOf(y, i_);;)if (g_[i_] !== y) {
                        if (T && Z.length === 0 && g_.substring(i_, i_ + n_) === T) {
                            if (D_ === -1) return er();
                            i_ = D_ + Fe, D_ = g_.indexOf(x, i_), b_ = g_.indexOf(w, i_);
                        } else if (b_ !== -1 && (b_ < D_ || D_ === -1)) Z.push(g_.substring(i_, b_)), i_ = b_ + pe, b_ = g_.indexOf(w, i_);
                        else {
                            if (D_ === -1) break;
                            if (Z.push(g_.substring(i_, D_)), _r(D_ + Fe), N_ && (Ln(), W_)) return er();
                            if (A && H_.length >= A) return er(!0);
                        }
                    } else for(l_ = i_, i_++;;){
                        if ((l_ = g_.indexOf(y, l_ + 1)) === -1) return we || P_.push({
                            type: "Quotes",
                            code: "MissingQuotes",
                            message: "Quoted field unterminated",
                            row: H_.length,
                            index: i_
                        }), Ge();
                        if (l_ === p_ - 1) return Ge(g_.substring(i_, l_).replace(w_, y));
                        if (y !== $_ || g_[l_ + 1] !== $_) {
                            if (y === $_ || l_ === 0 || g_[l_ - 1] !== $_) {
                                b_ !== -1 && b_ < l_ + 1 && (b_ = g_.indexOf(w, l_ + 1)), D_ !== -1 && D_ < l_ + 1 && (D_ = g_.indexOf(x, l_ + 1));
                                var j_ = ee(D_ === -1 ? b_ : Math.min(b_, D_));
                                if (g_.substr(l_ + 1 + j_, pe) === w) {
                                    Z.push(g_.substring(i_, l_).replace(w_, y)), g_[i_ = l_ + 1 + j_ + pe] !== y && (l_ = g_.indexOf(y, i_)), b_ = g_.indexOf(w, i_), D_ = g_.indexOf(x, i_);
                                    break;
                                }
                                var q_ = ee(D_);
                                if (g_.substring(l_ + 1 + q_, l_ + 1 + q_ + Fe) === x) {
                                    if (Z.push(g_.substring(i_, l_).replace(w_, y)), _r(l_ + 1 + q_ + Fe), b_ = g_.indexOf(w, i_), l_ = g_.indexOf(y, i_), N_ && (Ln(), W_)) return er();
                                    if (A && H_.length >= A) return er(!0);
                                    break;
                                }
                                P_.push({
                                    type: "Quotes",
                                    code: "InvalidQuotes",
                                    message: "Trailing quote on quoted field is malformed",
                                    row: H_.length,
                                    index: i_
                                }), l_++;
                            }
                        } else l_++;
                    }
                    return Ge();
                    function $e(dr) {
                        H_.push(dr), e_ = i_;
                    }
                    function ee(dr) {
                        var Xt = 0;
                        if (dr !== -1) {
                            var D0 = g_.substring(l_ + 1, dr);
                            D0 && D0.trim() === "" && (Xt = D0.length);
                        }
                        return Xt;
                    }
                    function Ge(dr) {
                        return we || (dr === void 0 && (dr = g_.substring(i_)), Z.push(dr), i_ = p_, $e(Z), N_ && Ln()), er();
                    }
                    function _r(dr) {
                        i_ = dr, $e(Z), Z = [], D_ = g_.indexOf(x, i_);
                    }
                    function er(dr) {
                        return {
                            data: H_,
                            errors: P_,
                            meta: {
                                delimiter: w,
                                linebreak: x,
                                aborted: W_,
                                truncated: !!dr,
                                cursor: e_ + (U_ || 0)
                            }
                        };
                    }
                    function Ln() {
                        C(er()), H_ = [], P_ = [];
                    }
                }, this.abort = function() {
                    W_ = !0;
                }, this.getCharIndex = function() {
                    return i_;
                };
            }
            function J(F) {
                var y = F.data, w = n[y.workerId], x = !1;
                if (y.error) w.userError(y.error, y.file);
                else if (y.results && y.results.data) {
                    var T = {
                        abort: function() {
                            x = !0, c_(y.workerId, {
                                data: [],
                                errors: [],
                                meta: {
                                    aborted: !0
                                }
                            });
                        },
                        pause: t_,
                        resume: t_
                    };
                    if (Q(w.userStep)) {
                        for(var C = 0; C < y.results.data.length && (w.userStep({
                            data: y.results.data[C],
                            errors: y.results.errors,
                            meta: y.results.meta
                        }, T), !x); C++);
                        delete y.results;
                    } else Q(w.userChunk) && (w.userChunk(y.results, T, y.file), delete y.results);
                }
                y.finished && !x && c_(y.workerId, y.results);
            }
            function c_(F, y) {
                var w = n[F];
                Q(w.userComplete) && w.userComplete(y), w.terminate(), delete n[F];
            }
            function t_() {
                throw new Error("Not implemented.");
            }
            function W(F) {
                if (typeof F != "object" || F === null) return F;
                var y = Array.isArray(F) ? [] : {};
                for(var w in F)y[w] = W(F[w]);
                return y;
            }
            function a_(F, y) {
                return function() {
                    F.apply(y, arguments);
                };
            }
            function Q(F) {
                return typeof F == "function";
            }
            return t && (_.onmessage = function(F) {
                var y = F.data;
                if (c.WORKER_ID === void 0 && y && (c.WORKER_ID = y.workerId), typeof y.input == "string") _.postMessage({
                    workerId: c.WORKER_ID,
                    results: c.parse(y.input, y.config),
                    finished: !0
                });
                else if (_.File && y.input instanceof File || y.input instanceof Object) {
                    var w = c.parse(y.input, y.config);
                    w && _.postMessage({
                        workerId: c.WORKER_ID,
                        results: w,
                        finished: !0
                    });
                }
            }), (v.prototype = Object.create(d.prototype)).constructor = v, (b.prototype = Object.create(d.prototype)).constructor = b, (p.prototype = Object.create(p.prototype)).constructor = p, (u.prototype = Object.create(d.prototype)).constructor = u, c;
        });
    });
    function Wi(e) {
        let _ = 0, r;
        return ()=>{
            if (_ === 2) return r;
            if (_ === 1) throw new Error("Binding demanded before initialized");
            return _ = 1, r = e(), _ = 2, r;
        };
    }
    function* v2(e, _) {
        for(let r = e; r < _; r++)yield r;
    }
    function l() {
        throw new Error("Failed pattern match");
    }
    var Hi = (e)=>{
        let _ = e.Apply0(), r = _.Functor0(), t = {
            map: (s)=>{
                let c = r.map(s);
                return (i)=>(d)=>c(i(d));
            }
        }, n = {
            apply: (s)=>(c)=>(i)=>_.apply(s(i))(c(i)),
            Functor0: ()=>t
        };
        return {
            bind: (s)=>(c)=>(i)=>e.bind(s(i))((d)=>c(d)(i)),
            Apply0: ()=>n
        };
    };
    var Jb = (e)=>{
        let _ = e.Applicative0(), r = _.Apply0(), t = r.Functor0(), n = {
            map: (d)=>{
                let v = t.map(d);
                return (b)=>(p)=>v(b(p));
            }
        }, s = {
            apply: (d)=>(v)=>(b)=>r.apply(d(b))(v(b)),
            Functor0: ()=>n
        }, c = {
            pure: (d)=>{
                let v = _.pure(d);
                return (b)=>v;
            },
            Apply0: ()=>s
        }, i = Hi(e.Bind1());
        return {
            Applicative0: ()=>c,
            Bind1: ()=>i
        };
    };
    var Hc = (e)=>(_)=>e;
    var g2 = (e)=>(_)=>_(e);
    var Vb = {
        compose: (e)=>(_)=>(r)=>e(_(r))
    };
    var zE = ()=>({
            tag: "Proxy"
        }), q = zE();
    var te = function(e) {
        return function(_) {
            for(var r = _.length, t = new Array(r), n = 0; n < r; n++)t[n] = e(_[n]);
            return t;
        };
    };
    var Nt = {
        map: te
    };
    var Ls = (e)=>e;
    var $ = function(e) {
        return function(_) {
            for(var r = [], t = 0, n = e.length; t < n; t++)Array.prototype.push.apply(r, _(e[t]));
            return r;
        };
    };
    var qb = (e)=>e;
    var Vo = function(e) {
        return function(_) {
            return _[e];
        };
    }, Ur = function(e) {
        return function(_) {
            return function(r) {
                var t = {};
                for(var n in r)({}).hasOwnProperty.call(r, n) && (t[n] = r[n]);
                return t[e] = _, t;
            };
        };
    };
    var __ = function(e) {
        return e.toString();
    }, jc = function(e) {
        var _ = e.toString();
        return isNaN(_ + ".0") ? _ : _ + ".0";
    }, Cv = function(e) {
        var _ = e.charCodeAt(0);
        if (_ < 32 || _ === 127) {
            switch(e){
                case "\x07":
                    return "'\\a'";
                case "\b":
                    return "'\\b'";
                case "\f":
                    return "'\\f'";
                case `
`:
                    return "'\\n'";
                case "\r":
                    return "'\\r'";
                case "	":
                    return "'\\t'";
                case "\v":
                    return "'\\v'";
            }
            return "'\\" + _.toString(10) + "'";
        }
        return e === "'" || e === "\\" ? "'\\" + e + "'" : "'" + e + "'";
    }, Se = function(e) {
        var _ = e.length;
        return '"' + e.replace(/[\0-\x1F\x7F"\\]/g, function(r, t) {
            switch(r){
                case '"':
                case "\\":
                    return "\\" + r;
                case "\x07":
                    return "\\a";
                case "\b":
                    return "\\b";
                case "\f":
                    return "\\f";
                case `
`:
                    return "\\n";
                case "\r":
                    return "\\r";
                case "	":
                    return "\\t";
                case "\v":
                    return "\\v";
            }
            var n = t + 1, s = n < _ && e[n] >= "0" && e[n] <= "9" ? "\\&" : "";
            return "\\" + r.charCodeAt(0).toString(10) + s;
        }) + '"';
    };
    var Hb = {
        show: (e)=>"unit"
    }, Qc = {
        show: Se
    };
    var qE = ()=>({
            tag: "NoArguments"
        });
    var o = (e, _)=>({
            tag: e,
            _1: _
        }), $2 = (e)=>o("Inl", e), h2 = (e)=>o("Inr", e);
    var P = qE(), y2 = (e)=>e, D2 = (e)=>e;
    var jb = (e)=>({
            tag: e
        }), E_ = jb("LT"), T_ = jb("GT"), X_ = jb("EQ");
    var R = (e, _)=>({
            tag: e,
            _1: _
        }), D = R("Nothing"), f_ = (e)=>R("Just", e);
    var w2 = (e)=>({
            append: (_)=>(r)=>{
                    if (_.tag === "Nothing") return r;
                    if (r.tag === "Nothing") return _;
                    if (_.tag === "Just") {
                        if (r.tag === "Just") return R("Just", e.append(_._1)(r._1));
                        l();
                    }
                    l();
                }
        });
    var Av = (e)=>{
        if (e.tag === "Nothing") return !0;
        if (e.tag === "Just") return !1;
        l();
    };
    var I0 = {
        map: (e)=>(_)=>_.tag === "Just" ? R("Just", e(_._1)) : D
    };
    var Yc = (e)=>{
        let _ = e.Eq0(), r = {
            eq: (t)=>(n)=>t.tag === "Nothing" ? n.tag === "Nothing" : t.tag === "Just" && n.tag === "Just" ? _.eq(t._1)(n._1) : !1
        };
        return {
            compare: (t)=>(n)=>{
                    if (t.tag === "Nothing") return n.tag === "Nothing" ? X_ : E_;
                    if (n.tag === "Nothing") return T_;
                    if (t.tag === "Just") {
                        if (n.tag === "Just") return e.compare(t._1)(n._1);
                        l();
                    }
                    l();
                },
            Eq0: ()=>r
        };
    };
    var wo = {
        apply: (e)=>(_)=>{
                if (e.tag === "Just") return _.tag === "Just" ? R("Just", e._1(_._1)) : D;
                if (e.tag === "Nothing") return D;
                l();
            },
        Functor0: ()=>I0
    };
    var Nv = {
        pure: f_,
        Apply0: ()=>wo
    };
    var S = (e, _)=>({
            tag: e,
            _1: _
        }), Ao = (e)=>S("Left", e), I_ = (e)=>S("Right", e);
    var x0 = {
        map: (e)=>(_)=>{
                if (_.tag === "Left") return S("Left", _._1);
                if (_.tag === "Right") return S("Right", e(_._1));
                l();
            }
    };
    var R2 = (e)=>{
        if (e.tag === "Left") return D;
        if (e.tag === "Right") return R("Just", e._1);
        l();
    };
    var ht = {
        apply: (e)=>(_)=>{
                if (e.tag === "Left") return S("Left", e._1);
                if (e.tag === "Right") {
                    if (_.tag === "Left") return S("Left", _._1);
                    if (_.tag === "Right") return S("Right", e._1(_._1));
                    l();
                }
                l();
            },
        Functor0: ()=>x0
    }, F_ = {
        bind: (e)=>{
            if (e.tag === "Left") {
                let _ = e._1;
                return (r)=>S("Left", _);
            }
            if (e.tag === "Right") {
                let _ = e._1;
                return (r)=>r(_);
            }
            l();
        },
        Apply0: ()=>ht
    };
    var _n = {
        pure: I_,
        Apply0: ()=>ht
    };
    var Fv = (e)=>e;
    var Kb = {
        map: (e)=>(_)=>e(_)
    };
    var k2 = {
        apply: (e)=>(_)=>e(_),
        Functor0: ()=>Kb
    }, WE = {
        bind: (e)=>(_)=>_(e),
        Apply0: ()=>k2
    }, Qb = {
        pure: Fv,
        Apply0: ()=>k2
    }, yt = {
        Applicative0: ()=>Qb,
        Bind1: ()=>WE
    };
    var S2 = function(e) {
        return function() {
            return e;
        };
    };
    var HE = {
        apply: (e)=>(_)=>()=>{
                    let r = e(), t = _();
                    return Mv.pure(r(t))();
                },
        Functor0: ()=>jE
    }, Mv = {
        pure: S2,
        Apply0: ()=>HE
    }, jE = {
        map: (e)=>(_)=>()=>{
                    let r = _();
                    return e(r);
                }
    };
    var nt = (e, _)=>({
            tag: e,
            _1: _
        }), Zb = (e)=>nt("Loop", e);
    var Pv = {
        tailRecM: (e)=>{
            let _ = (r)=>{
                let t = r, n = !0, s;
                for(; n;){
                    let c = t;
                    if (c.tag === "Loop") {
                        t = e(c._1);
                        continue;
                    }
                    if (c.tag === "Done") {
                        n = !1, s = c._1;
                        continue;
                    }
                    l();
                }
                return s;
            };
            return (r)=>_(e(r));
        },
        Monad0: ()=>yt
    };
    var E = (e, _)=>({
            tag: "Tuple",
            _1: e,
            _2: _
        }), qo = (e)=>(_)=>E(e, _);
    var Xc = (e)=>e._2;
    var Lv = {
        map: (e)=>(_)=>E(_._1, e(_._2))
    };
    var Bn = (e)=>e._1;
    var I2 = (e)=>{
        let _ = e.Bind1().bind, r = e.Applicative0().pure;
        return {
            bind: (t)=>(n)=>_(t)((s)=>{
                        if (s.tag === "Left") return r(S("Left", s._1));
                        if (s.tag === "Right") return n(s._1);
                        l();
                    }),
            Apply0: ()=>x2(e)
        };
    }, x2 = (e)=>{
        let _ = e.Bind1().Apply0().Functor0(), r = {
            map: (t)=>_.map(x0.map(t))
        };
        return {
            apply: (()=>{
                let t = I2(e).bind, n = zv(e).pure;
                return (s)=>(c)=>t(s)((i)=>t(c)((d)=>n(i(d))));
            })(),
            Functor0: ()=>r
        };
    }, zv = (e)=>({
            pure: (()=>{
                let _ = e.Applicative0().pure;
                return (r)=>_(S("Right", r));
            })(),
            Apply0: ()=>x2(e)
        });
    var E2 = (e)=>{
        let _ = {
            Applicative0: ()=>zv(e),
            Bind1: ()=>I2(e)
        };
        return {
            throwError: (()=>{
                let r = e.Applicative0().pure;
                return (t)=>r(S("Left", t));
            })(),
            Monad0: ()=>_
        };
    };
    var T2 = (e)=>(_)=>{
            let r = _.Bind1(), t = _.Applicative0().pure, n = r.Apply0().Functor0(), s = {
                map: (c)=>n.map(x0.map(c))
            };
            return {
                alt: (c)=>(i)=>r.bind(c)((d)=>{
                            if (d.tag === "Right") return t(S("Right", d._1));
                            if (d.tag === "Left") {
                                let v = d._1;
                                return r.bind(i)((b)=>{
                                    if (b.tag === "Right") return t(S("Right", b._1));
                                    if (b.tag === "Left") return t(S("Left", e.append(v)(b._1)));
                                    l();
                                });
                            }
                            l();
                        }),
                Functor0: ()=>s
            };
        };
    var Jn = (e, _)=>({
            tag: "NonEmpty",
            _1: e,
            _2: _
        });
    var Y = (e, _, r)=>({
            tag: e,
            _1: _,
            _2: r
        });
    var y_ = Y("Nil"), no = (e)=>(_)=>Y("Cons", e, _);
    var br = (e)=>((r)=>(t)=>{
                let n = r, s = t, c = !0, i;
                for(; c;){
                    let d = n, v = s, b = (p, u)=>((z)=>(L)=>{
                                let J = z, c_ = L, t_ = !0, W;
                                for(; t_;){
                                    let a_ = J, Q = c_;
                                    if (a_.tag === "Cons") {
                                        if (a_._1.tag === "Cons") {
                                            if (a_._1._2.tag === "Cons") {
                                                if (a_._1._2._2.tag === "Cons") {
                                                    J = a_._2, c_ = Y("Cons", e(a_._1._1), Y("Cons", e(a_._1._2._1), Y("Cons", e(a_._1._2._2._1), Q)));
                                                    continue;
                                                }
                                                t_ = !1, W = Q;
                                                continue;
                                            }
                                            t_ = !1, W = Q;
                                            continue;
                                        }
                                        t_ = !1, W = Q;
                                        continue;
                                    }
                                    t_ = !1, W = Q;
                                }
                                return W;
                            })(p)((()=>u.tag === "Cons" ? u._2.tag === "Cons" ? u._2._2.tag === "Nil" ? Y("Cons", e(u._1), Y("Cons", e(u._2._1), y_)) : y_ : u._2.tag === "Nil" ? Y("Cons", e(u._1), y_) : y_ : y_)());
                    if (v.tag === "Cons") {
                        if (v._2.tag === "Cons") {
                            if (v._2._2.tag === "Cons") {
                                n = Y("Cons", v, d), s = v._2._2._2;
                                continue;
                            }
                            c = !1, i = b(d, v);
                            continue;
                        }
                        c = !1, i = b(d, v);
                        continue;
                    }
                    c = !1, i = b(d, v);
                }
                return i;
            })(y_), rT = {
        map: br
    };
    var Ro = {
        foldr: (e)=>(_)=>{
                let r = Ro.foldl((n)=>(s)=>e(s)(n))(_), t = (()=>((s)=>(c)=>{
                            let i = s, d = c, v = !0, b;
                            for(; v;){
                                let p = i, u = d;
                                if (u.tag === "Nil") {
                                    v = !1, b = p;
                                    continue;
                                }
                                if (u.tag === "Cons") {
                                    i = Y("Cons", u._1, p), d = u._2;
                                    continue;
                                }
                                l();
                            }
                            return b;
                        })(y_))();
                return (n)=>r(t(n));
            },
        foldl: (e)=>(r)=>(t)=>{
                    let n = r, s = t, c = !0, i;
                    for(; c;){
                        let d = n, v = s;
                        if (v.tag === "Nil") {
                            c = !1, i = d;
                            continue;
                        }
                        if (v.tag === "Cons") {
                            n = e(d)(v._1), s = v._2;
                            continue;
                        }
                        l();
                    }
                    return i;
                },
        foldMap: (e)=>{
            let _ = e.Semigroup0().append, r = e.mempty;
            return (t)=>Ro.foldl((n)=>{
                    let s = _(n);
                    return (c)=>s(t(c));
                })(r);
        }
    };
    var A2 = {
        append: (e)=>(_)=>Jn(e._1, Ro.foldr(no)(Y("Cons", _._1, _._2))(e._2))
    };
    var tT = {
        unfoldr1: (e)=>(_)=>((t)=>(n)=>{
                        let s = t, c = n, i = !0, d;
                        for(; i;){
                            let v = s, b = c, p = e(v);
                            if (p._2.tag === "Just") {
                                s = p._2._1, c = Y("Cons", p._1, b);
                                continue;
                            }
                            if (p._2.tag === "Nothing") {
                                let u = (m)=>(z)=>{
                                        let L = m, J = z, c_ = !0, t_;
                                        for(; c_;){
                                            let W = L, a_ = J;
                                            if (a_.tag === "Nil") {
                                                c_ = !1, t_ = W;
                                                continue;
                                            }
                                            if (a_.tag === "Cons") {
                                                L = Y("Cons", a_._1, W), J = a_._2;
                                                continue;
                                            }
                                            l();
                                        }
                                        return t_;
                                    };
                                i = !1, d = u(y_)(Y("Cons", p._1, b));
                                continue;
                            }
                            l();
                        }
                        return d;
                    })(_)(y_)
    }, Ov = {
        unfoldr: (e)=>(_)=>((t)=>(n)=>{
                        let s = t, c = n, i = !0, d;
                        for(; i;){
                            let v = s, b = c, p = e(v);
                            if (p.tag === "Nothing") {
                                let u = (m)=>(z)=>{
                                        let L = m, J = z, c_ = !0, t_;
                                        for(; c_;){
                                            let W = L, a_ = J;
                                            if (a_.tag === "Nil") {
                                                c_ = !1, t_ = W;
                                                continue;
                                            }
                                            if (a_.tag === "Cons") {
                                                L = Y("Cons", a_._1, W), J = a_._2;
                                                continue;
                                            }
                                            l();
                                        }
                                        return t_;
                                    };
                                i = !1, d = u(y_)(b);
                                continue;
                            }
                            if (p.tag === "Just") {
                                s = p._1._2, c = Y("Cons", p._1._1, b);
                                continue;
                            }
                            l();
                        }
                        return d;
                    })(_)(y_),
        Unfoldable10: ()=>tT
    };
    var N2 = {
        apply: (e)=>(_)=>{
                if (e.tag === "Nil") return y_;
                if (e.tag === "Cons") return Ro.foldr(no)(N2.apply(e._2)(_))(br(e._1)(_));
                l();
            },
        Functor0: ()=>rT
    };
    var ji = {
        bind: (e)=>(_)=>{
                if (e.tag === "Nil") return y_;
                if (e.tag === "Cons") return Ro.foldr(no)(ji.bind(e._2)(_))(_(e._1));
                l();
            },
        Apply0: ()=>N2
    };
    function ep(e) {
        return e.stack || e.toString();
    }
    function T0(e) {
        return new Error(e);
    }
    function No(e) {
        return e.message;
    }
    function Ki(e) {
        return function() {
            throw e;
        };
    }
    var F2 = (e)=>{
        let _ = e.MonadThrow0().Monad0(), r = _.Bind1().Apply0().Functor0().map, t = _.Applicative0().pure;
        return (n)=>e.catchError(r(I_)(n))((s)=>t(S("Left", s)));
    };
    var uT = {
        append: (e)=>(_)=>e.tag === "Just" ? e : _
    };
    var je = {
        mempty: D,
        Semigroup0: ()=>uT
    };
    var Tr = function(e) {
        return function(_) {
            return function(r) {
                for(var t = _, n = r.length, s = n - 1; s >= 0; s--)t = e(r[s])(t);
                return t;
            };
        };
    }, Vn = function(e) {
        return function(_) {
            return function(r) {
                for(var t = _, n = r.length, s = 0; s < n; s++)t = e(t)(r[s]);
                return t;
            };
        };
    };
    var Qi = (e)=>{
        let _ = e.Apply0(), r = _.Functor0().map;
        return (t)=>(n)=>t.foldr((s)=>{
                    let c = n(s);
                    return (i)=>_.apply(r((d)=>Ls)(c))(i);
                })(e.pure());
    }, Yi = (e)=>{
        let _ = Qi(e);
        return (r)=>{
            let t = _(r);
            return (n)=>(s)=>t(s)(n);
        };
    };
    var eo = {
        foldr: Tr,
        foldl: Vn,
        foldMap: (e)=>{
            let _ = e.Semigroup0().append, r = e.mempty;
            return (t)=>eo.foldr((n)=>(s)=>_(t(n))(s))(r);
        }
    };
    var Uv = (e)=>(_)=>e.foldl((r)=>(t)=>r.tag === "Nothing" && _(t) ? R("Just", t) : r)(D);
    var Ie = function(e) {
        throw new Error(e);
    };
    var pr = function(e) {
        return e;
    };
    var Br = function() {
        var e = {}, _ = "Pure", r = "Throw", t = "Catch", n = "Sync", s = "Async", c = "Bind", i = "Bracket", d = "Fork", v = "Sequential", b = "Map", p = "Apply", u = "Alt", m = "Cons", z = "Resume", L = "Release", J = "Finalizer", c_ = "Finalized", t_ = "Forked", W = "Fiber", a_ = "Thunk";
        function Q(n_, N_, H_, P_) {
            this.tag = n_, this._1 = N_, this._2 = H_, this._3 = P_;
        }
        function F(n_) {
            var N_ = function(H_, P_, Z) {
                return new Q(n_, H_, P_, Z);
            };
            return N_.tag = n_, N_;
        }
        function y(n_) {
            return new Q(_, void 0);
        }
        function w(n_) {
            try {
                n_();
            } catch (N_) {
                setTimeout(function() {
                    throw N_;
                }, 0);
            }
        }
        function x(n_, N_, H_) {
            try {
                return N_(H_());
            } catch (P_) {
                return n_(P_);
            }
        }
        function T(n_, N_, H_) {
            try {
                return N_(H_)();
            } catch (P_) {
                return H_(n_(P_))(), y;
            }
        }
        var C = function() {
            var n_ = 1024, N_ = 0, H_ = 0, P_ = new Array(n_), Z = !1;
            function e_() {
                var S_;
                for(Z = !0; N_ !== 0;)N_--, S_ = P_[H_], P_[H_] = void 0, H_ = (H_ + 1) % n_, S_();
                Z = !1;
            }
            return {
                isDraining: function() {
                    return Z;
                },
                enqueue: function(S_) {
                    var h_, G_;
                    N_ === n_ && (G_ = Z, e_(), Z = G_), P_[(H_ + N_) % n_] = S_, N_++, Z || e_();
                }
            };
        }();
        function A(n_) {
            var N_ = {}, H_ = 0, P_ = 0;
            return {
                register: function(Z) {
                    var e_ = H_++;
                    Z.onComplete({
                        rethrow: !0,
                        handler: function(S_) {
                            return function() {
                                P_--, delete N_[e_];
                            };
                        }
                    })(), N_[e_] = Z, P_++;
                },
                isEmpty: function() {
                    return P_ === 0;
                },
                killAll: function(Z, e_) {
                    return function() {
                        if (P_ === 0) return e_();
                        var S_ = 0, h_ = {};
                        function G_(C_) {
                            h_[C_] = N_[C_].kill(Z, function(L_) {
                                return function() {
                                    delete h_[C_], S_--, n_.isLeft(L_) && n_.fromLeft(L_) && setTimeout(function() {
                                        throw n_.fromLeft(L_);
                                    }, 0), S_ === 0 && e_();
                                };
                            })();
                        }
                        for(var de in N_)N_.hasOwnProperty(de) && (S_++, G_(de));
                        return N_ = {}, H_ = 0, P_ = 0, function(C_) {
                            return new Q(n, function() {
                                for(var L_ in h_)h_.hasOwnProperty(L_) && h_[L_]();
                            });
                        };
                    };
                }
            };
        }
        var G = 0, $_ = 1, i_ = 2, W_ = 3, g_ = 4, U_ = 5, we = 6;
        function p_(n_, N_, H_) {
            var P_ = 0, Z = G, e_ = H_, S_ = null, h_ = null, G_ = null, de = null, C_ = null, L_ = 0, We = 0, Ne = null, Xe = !0;
            function lo(w_) {
                for(var l_, j_, q_;;)switch(l_ = null, j_ = null, q_ = null, Z){
                    case i_:
                        Z = $_;
                        try {
                            e_ = G_(e_), de === null ? G_ = null : (G_ = de._1, de = de._2);
                        } catch (ee) {
                            Z = U_, S_ = n_.left(ee), e_ = null;
                        }
                        break;
                    case W_:
                        n_.isLeft(e_) ? (Z = U_, S_ = e_, e_ = null) : G_ === null ? Z = U_ : (Z = i_, e_ = n_.fromRight(e_));
                        break;
                    case $_:
                        switch(e_.tag){
                            case c:
                                G_ && (de = new Q(m, G_, de)), G_ = e_._2, Z = $_, e_ = e_._1;
                                break;
                            case _:
                                G_ === null ? (Z = U_, e_ = n_.right(e_._1)) : (Z = i_, e_ = e_._1);
                                break;
                            case n:
                                Z = W_, e_ = x(n_.left, n_.right, e_._1);
                                break;
                            case s:
                                Z = g_, e_ = T(n_.left, e_._1, function(ee) {
                                    return function() {
                                        P_ === w_ && (P_++, C.enqueue(function() {
                                            P_ === w_ + 1 && (Z = W_, e_ = ee, lo(P_));
                                        }));
                                    };
                                });
                                return;
                            case r:
                                Z = U_, S_ = n_.left(e_._1), e_ = null;
                                break;
                            case t:
                                G_ === null ? C_ = new Q(m, e_, C_, h_) : C_ = new Q(m, e_, new Q(m, new Q(z, G_, de), C_, h_), h_), G_ = null, de = null, Z = $_, e_ = e_._1;
                                break;
                            case i:
                                L_++, G_ === null ? C_ = new Q(m, e_, C_, h_) : C_ = new Q(m, e_, new Q(m, new Q(z, G_, de), C_, h_), h_), G_ = null, de = null, Z = $_, e_ = e_._1;
                                break;
                            case d:
                                Z = W_, l_ = p_(n_, N_, e_._2), N_ && N_.register(l_), e_._1 && l_.run(), e_ = n_.right(l_);
                                break;
                            case v:
                                Z = $_, e_ = Fe(n_, N_, e_._1);
                                break;
                        }
                        break;
                    case U_:
                        if (G_ = null, de = null, C_ === null) Z = we, e_ = h_ || S_ || e_;
                        else switch(l_ = C_._3, q_ = C_._1, C_ = C_._2, q_.tag){
                            case t:
                                h_ && h_ !== l_ && L_ === 0 ? Z = U_ : S_ && (Z = $_, e_ = q_._2(n_.fromLeft(S_)), S_ = null);
                                break;
                            case z:
                                h_ && h_ !== l_ && L_ === 0 || S_ ? Z = U_ : (G_ = q_._1, de = q_._2, Z = i_, e_ = n_.fromRight(e_));
                                break;
                            case i:
                                L_--, S_ === null && (j_ = n_.fromRight(e_), C_ = new Q(m, new Q(L, q_._2, j_), C_, l_), (h_ === l_ || L_ > 0) && (Z = $_, e_ = q_._3(j_)));
                                break;
                            case L:
                                C_ = new Q(m, new Q(c_, e_, S_), C_, h_), Z = $_, h_ && h_ !== l_ && L_ === 0 ? e_ = q_._1.killed(n_.fromLeft(h_))(q_._2) : S_ ? e_ = q_._1.failed(n_.fromLeft(S_))(q_._2) : e_ = q_._1.completed(n_.fromRight(e_))(q_._2), S_ = null, L_++;
                                break;
                            case J:
                                L_++, C_ = new Q(m, new Q(c_, e_, S_), C_, h_), Z = $_, e_ = q_._1;
                                break;
                            case c_:
                                L_--, Z = U_, e_ = q_._1, S_ = q_._2;
                                break;
                        }
                        break;
                    case we:
                        for(var $e in Ne)Ne.hasOwnProperty($e) && (Xe = Xe && Ne[$e].rethrow, w(Ne[$e].handler(e_)));
                        Ne = null, h_ && S_ ? setTimeout(function() {
                            throw n_.fromLeft(S_);
                        }, 0) : n_.isLeft(e_) && Xe && setTimeout(function() {
                            if (Xe) throw n_.fromLeft(e_);
                        }, 0);
                        return;
                    case G:
                        Z = $_;
                        break;
                    case g_:
                        return;
                }
            }
            function ve(w_) {
                return function() {
                    if (Z === we) return Xe = Xe && w_.rethrow, w_.handler(e_)(), function() {};
                    var l_ = We++;
                    return Ne = Ne || {}, Ne[l_] = w_, function() {
                        Ne !== null && delete Ne[l_];
                    };
                };
            }
            function b_(w_, l_) {
                return function() {
                    if (Z === we) return l_(n_.right(void 0))(), function() {};
                    var j_ = ve({
                        rethrow: !1,
                        handler: function() {
                            return l_(n_.right(void 0));
                        }
                    })();
                    switch(Z){
                        case G:
                            h_ = n_.left(w_), Z = we, e_ = h_, lo(P_);
                            break;
                        case g_:
                            h_ === null && (h_ = n_.left(w_)), L_ === 0 && (Z === g_ && (C_ = new Q(m, new Q(J, e_(w_)), C_, h_)), Z = U_, e_ = null, S_ = null, lo(++P_));
                            break;
                        default:
                            h_ === null && (h_ = n_.left(w_)), L_ === 0 && (Z = U_, e_ = null, S_ = null);
                    }
                    return j_;
                };
            }
            function D_(w_) {
                return function() {
                    var l_ = ve({
                        rethrow: !1,
                        handler: w_
                    })();
                    return Z === G && lo(P_), l_;
                };
            }
            return {
                kill: b_,
                join: D_,
                onComplete: ve,
                isSuspended: function() {
                    return Z === G;
                },
                run: function() {
                    Z === G && (C.isDraining() ? lo(P_) : C.enqueue(function() {
                        lo(P_);
                    }));
                }
            };
        }
        function pe(n_, N_, H_, P_) {
            var Z = 0, e_ = {}, S_ = 0, h_ = {}, G_ = new Error("[ParAff] Early exit"), de = null, C_ = e;
            function L_(ve, b_, D_) {
                var w_ = b_, l_ = null, j_ = null, q_ = 0, $e = {}, ee, Ge;
                _: for(;;)switch(ee = null, w_.tag){
                    case t_:
                        if (w_._3 === e && (ee = e_[w_._1], $e[q_++] = ee.kill(ve, function(_r) {
                            return function() {
                                q_--, q_ === 0 && D_(_r)();
                            };
                        })), l_ === null) break _;
                        w_ = l_._2, j_ === null ? l_ = null : (l_ = j_._1, j_ = j_._2);
                        break;
                    case b:
                        w_ = w_._2;
                        break;
                    case p:
                    case u:
                        l_ && (j_ = new Q(m, l_, j_)), l_ = w_, w_ = w_._1;
                        break;
                }
                if (q_ === 0) D_(n_.right(void 0))();
                else for(Ge = 0, ee = q_; Ge < ee; Ge++)$e[Ge] = $e[Ge]();
                return $e;
            }
            function We(ve, b_, D_) {
                var w_, l_, j_, q_, $e, ee;
                n_.isLeft(ve) ? (w_ = ve, l_ = null) : (l_ = ve, w_ = null);
                _: for(;;){
                    if (j_ = null, q_ = null, $e = null, ee = null, de !== null) return;
                    if (b_ === null) {
                        P_(w_ || l_)();
                        return;
                    }
                    if (b_._3 !== e) return;
                    switch(b_.tag){
                        case b:
                            w_ === null ? (b_._3 = n_.right(b_._1(n_.fromRight(l_))), l_ = b_._3) : b_._3 = w_;
                            break;
                        case p:
                            if (j_ = b_._1._3, q_ = b_._2._3, w_) {
                                if (b_._3 = w_, $e = !0, ee = S_++, h_[ee] = L_(G_, w_ === j_ ? b_._2 : b_._1, function() {
                                    return function() {
                                        delete h_[ee], $e ? $e = !1 : D_ === null ? We(w_, null, null) : We(w_, D_._1, D_._2);
                                    };
                                }), $e) {
                                    $e = !1;
                                    return;
                                }
                            } else {
                                if (j_ === e || q_ === e) return;
                                l_ = n_.right(n_.fromRight(j_)(n_.fromRight(q_))), b_._3 = l_;
                            }
                            break;
                        case u:
                            if (j_ = b_._1._3, q_ = b_._2._3, j_ === e && n_.isLeft(q_) || q_ === e && n_.isLeft(j_)) return;
                            if (j_ !== e && n_.isLeft(j_) && q_ !== e && n_.isLeft(q_)) w_ = l_ === j_ ? q_ : j_, l_ = null, b_._3 = w_;
                            else if (b_._3 = l_, $e = !0, ee = S_++, h_[ee] = L_(G_, l_ === j_ ? b_._2 : b_._1, function() {
                                return function() {
                                    delete h_[ee], $e ? $e = !1 : D_ === null ? We(l_, null, null) : We(l_, D_._1, D_._2);
                                };
                            }), $e) {
                                $e = !1;
                                return;
                            }
                            break;
                    }
                    D_ === null ? b_ = null : (b_ = D_._1, D_ = D_._2);
                }
            }
            function Ne(ve) {
                return function(b_) {
                    return function() {
                        delete e_[ve._1], ve._3 = b_, We(b_, ve._2._1, ve._2._2);
                    };
                };
            }
            function Xe() {
                var ve = $_, b_ = H_, D_ = null, w_ = null, l_, j_;
                _: for(;;)switch(l_ = null, j_ = null, ve){
                    case $_:
                        switch(b_.tag){
                            case b:
                                D_ && (w_ = new Q(m, D_, w_)), D_ = new Q(b, b_._1, e, e), b_ = b_._2;
                                break;
                            case p:
                                D_ && (w_ = new Q(m, D_, w_)), D_ = new Q(p, e, b_._2, e), b_ = b_._1;
                                break;
                            case u:
                                D_ && (w_ = new Q(m, D_, w_)), D_ = new Q(u, e, b_._2, e), b_ = b_._1;
                                break;
                            default:
                                j_ = Z++, ve = U_, l_ = b_, b_ = new Q(t_, j_, new Q(m, D_, w_), e), l_ = p_(n_, N_, l_), l_.onComplete({
                                    rethrow: !1,
                                    handler: Ne(b_)
                                })(), e_[j_] = l_, N_ && N_.register(l_);
                        }
                        break;
                    case U_:
                        if (D_ === null) break _;
                        D_._1 === e ? (D_._1 = b_, ve = $_, b_ = D_._2, D_._2 = e) : (D_._2 = b_, b_ = D_, w_ === null ? D_ = null : (D_ = w_._1, w_ = w_._2));
                }
                for(C_ = b_, j_ = 0; j_ < Z; j_++)e_[j_].run();
            }
            function lo(ve, b_) {
                de = n_.left(ve);
                var D_;
                for(var w_ in h_)if (h_.hasOwnProperty(w_)) {
                    D_ = h_[w_];
                    for(w_ in D_)D_.hasOwnProperty(w_) && D_[w_]();
                }
                h_ = null;
                var l_ = L_(ve, C_, b_);
                return function(j_) {
                    return new Q(s, function(q_) {
                        return function() {
                            for(var $e in l_)l_.hasOwnProperty($e) && l_[$e]();
                            return y;
                        };
                    });
                };
            }
            return Xe(), function(ve) {
                return new Q(s, function(b_) {
                    return function() {
                        return lo(ve, b_);
                    };
                });
            };
        }
        function Fe(n_, N_, H_) {
            return new Q(s, function(P_) {
                return function() {
                    return pe(n_, N_, H_, P_);
                };
            });
        }
        return Q.EMPTY = e, Q.Pure = F(_), Q.Throw = F(r), Q.Catch = F(t), Q.Sync = F(n), Q.Async = F(s), Q.Bind = F(c), Q.Bracket = F(i), Q.Fork = F(d), Q.Seq = F(v), Q.ParMap = F(b), Q.ParApply = F(p), Q.ParAlt = F(u), Q.Fiber = p_, Q.Supervisor = A, Q.Scheduler = C, Q.nonCanceler = y, Q;
    }(), so = Br.Pure, M2 = Br.Throw;
    function P2(e) {
        return function(_) {
            return Br.Catch(e, _);
        };
    }
    function Os(e) {
        return function(_) {
            return _.tag === Br.Pure.tag ? Br.Pure(e(_._1)) : Br.Bind(_, function(r) {
                return Br.Pure(e(r));
            });
        };
    }
    function fr(e) {
        return function(_) {
            return Br.Bind(e, _);
        };
    }
    var he = Br.Sync;
    var op = Br.Async;
    function Bv(e, _) {
        return function() {
            return Br.Fiber(e, null, _);
        };
    }
    var bT = function() {
        function e(r, t) {
            return r === 0 && typeof setImmediate < "u" ? setImmediate(t) : setTimeout(t, r);
        }
        function _(r, t) {
            return r === 0 && typeof clearImmediate < "u" ? clearImmediate(t) : clearTimeout(t);
        }
        return function(r, t) {
            return Br.Async(function(n) {
                return function() {
                    var s = e(t, n(r()));
                    return function() {
                        return Br.Sync(function() {
                            return r(_(t, s));
                        });
                    };
                };
            });
        };
    }(), pT = Br.Seq;
    var fT = {
        map: Os
    };
    var rp = {
        isLeft: (e)=>{
            if (e.tag === "Left") return !0;
            if (e.tag === "Right") return !1;
            l();
        },
        fromLeft: (e)=>{
            if (e.tag === "Left") return e._1;
            if (e.tag === "Right") return Ie("unsafeFromLeft: Right");
            l();
        },
        fromRight: (e)=>{
            if (e.tag === "Right") return e._1;
            if (e.tag === "Left") return Ie("unsafeFromRight: Left");
            l();
        },
        left: Ao,
        right: I_
    };
    var mT = {
        Applicative0: ()=>z2,
        Bind1: ()=>$T
    }, $T = {
        bind: fr,
        Apply0: ()=>L2
    }, L2 = {
        apply: (e)=>(_)=>fr(e)((r)=>fr(_)((t)=>z2.pure(r(t)))),
        Functor0: ()=>fT
    }, z2 = {
        pure: so,
        Apply0: ()=>L2
    };
    var hT = {
        throwError: M2,
        Monad0: ()=>mT
    }, yT = {
        catchError: P2,
        MonadThrow0: ()=>hT
    }, Jv = F2(yT);
    var O2 = (e)=>(_)=>{
            let r = Bv(rp, fr(Jv(_))((t)=>he(e(t))));
            return ()=>{
                let t = r();
                return t.run(), t;
            };
        }, U2 = (e)=>(_)=>{
            let r = O2(e)(_);
            return ()=>{
                r();
            };
        };
    var B2 = (()=>{
        let e = so();
        return (_)=>e;
    })();
    var Us = isFinite;
    function Xi(e, _, r, t) {
        var n = parseFloat(e);
        return _(n) ? r(n) : t;
    }
    var Jr = Math.floor;
    var tp = function(e) {
        return function(_) {
            return e % _;
        };
    };
    var J2 = function(e) {
        return function(_) {
            return function(r) {
                return (r | 0) === r ? e(r) : _;
            };
        };
    }, Pe = function(e) {
        return e;
    }, V2 = function(e) {
        return function(_) {
            return function(r) {
                var t;
                r < 11 ? t = "[0-" + (r - 1).toString() + "]" : r === 11 ? t = "[0-9a]" : t = "[0-9a-" + String.fromCharCode(86 + r) + "]";
                var n = new RegExp("^[\\+\\-]?" + t + "+$", "i");
                return function(s) {
                    if (n.test(s)) {
                        var c = parseInt(s, r);
                        return (c | 0) === c ? e(c) : _;
                    } else return _;
                };
            };
        };
    };
    var DT = V2(f_)(D), ct = DT(10), Zc = J2(f_)(D), at = (e)=>{
        if (!Us(e)) return 0;
        if (e >= Pe(2147483647)) return 2147483647;
        if (e <= Pe(-2147483648)) return -2147483648;
        let _ = Zc(e);
        if (_.tag === "Nothing") return 0;
        if (_.tag === "Just") return _._1;
        l();
    };
    var q2 = function(e) {
        return function(_) {
            return e === _;
        };
    };
    var W2 = q2;
    var Vv = q2, Wn = function(e) {
        return function(_) {
            return function(r) {
                if (_.length !== r.length) return !1;
                for(var t = 0; t < _.length; t++)if (!e(_[t])(r[t])) return !1;
                return !0;
            };
        };
    };
    var Zi = {
        eq: Vv
    };
    var qv = {
        eq: W2
    };
    var H2 = function(e) {
        return function(_) {
            return function(r) {
                return function(t) {
                    return function(n) {
                        return t < n ? e : t === n ? _ : r;
                    };
                };
            };
        };
    };
    var j2 = H2;
    var K2 = H2;
    var Ko = {
        compare: K2(E_)(X_)(T_),
        Eq0: ()=>Zi
    };
    var co = {
        compare: j2(E_)(X_)(T_),
        Eq0: ()=>qv
    };
    var Wv = ()=>(e)=>{
            let _ = {
                eq: e.EqRecord0().eqRecord(q)
            };
            return {
                compare: e.compareRecord(q),
                Eq0: ()=>_
            };
        };
    var Bs = function(e) {
        return function(_) {
            if (e >= 0 && e < _.length) return _.charAt(e);
            throw new Error("Data.String.Unsafe.charAt: Invalid index.");
        };
    };
    var np = function(e) {
        return e;
    };
    var Vr = function(e) {
        return e.length;
    };
    var X2 = function(e) {
        return function(_) {
            return function(r) {
                return function(t) {
                    var n = t.indexOf(r);
                    return n === -1 ? _ : e(n);
                };
            };
        };
    };
    var Js = function(e) {
        return function(_) {
            return _.substr(0, e);
        };
    }, it = function(e) {
        return function(_) {
            return _.substring(e);
        };
    };
    var Z2 = function(e) {
        return function(_) {
            return {
                before: _.substring(0, e),
                after: _.substring(e)
            };
        };
    };
    var _7 = (e)=>(_)=>{
            let r = Z2(Vr(e))(_);
            return r.before === e ? R("Just", r.after) : D;
        };
    var _l = X2(f_)(D);
    function sp(e) {
        return Object.prototype.toString.call(e).slice(8, -1);
    }
    var ST = Array.isArray || function(e) {
        return Object.prototype.toString.call(e) === "[object Array]";
    };
    var IT = (e, _, r)=>({
            tag: e,
            _1: _,
            _2: r
        });
    var cp = (e)=>{
        let _ = zv(e).pure, r = E2(e).throwError;
        return (t)=>(n)=>sp(n) === t ? _(n) : r(Jn(IT("TypeMismatch", t, sp(n)), y_));
    };
    function e7(e) {
        return function(_) {
            return function(r) {
                return function() {
                    e.then(r, _);
                };
            };
        };
    }
    var ET = (()=>T2(A2)(yt).alt)(), TT = cp(yt), GT = cp(yt)("String"), el = (e)=>(_)=>op((r)=>{
                let t = e7(_)((n)=>r(S("Left", e(n)))())((n)=>r(S("Right", n))());
                return ()=>(t(), B2);
            });
    var ol = (e)=>{
        let _ = ET(TT("Error")(e))((()=>{
            let r = GT(e);
            if (r.tag === "Left") return S("Left", r._1);
            if (r.tag === "Right") return S("Right", T0(r._1));
            l();
        })());
        if (_.tag === "Left") return T0("Promise failed, couldn't extract JS Error or String");
        if (_.tag === "Right") return _._1;
        l();
    };
    var re = (e)=>e;
    var Hv = {
        bimap: (e)=>(_)=>(r)=>E(e(r._1), _(r._2))
    }, fe = {
        bimap: (e)=>(_)=>(r)=>{
                    if (r.tag === "Left") return S("Left", e(r._1));
                    if (r.tag === "Right") return S("Right", _(r._1));
                    l();
                }
    };
    function CT(e) {
        return function() {
            return e.slice();
        };
    }
    var lp = CT, AT = function() {
        function e(_, r, t, n, s, c) {
            var i, d, v, b, p, u, m;
            for(i = s + (c - s >> 1), i - s > 1 && e(_, r, n, t, s, i), c - i > 1 && e(_, r, n, t, i, c), d = s, v = i, b = s; d < i && v < c;)p = n[d], u = n[v], m = r(_(p)(u)), m > 0 ? (t[b++] = u, ++v) : (t[b++] = p, ++d);
            for(; d < i;)t[b++] = n[d++];
            for(; v < c;)t[b++] = n[v++];
        }
        return function(_) {
            return function(r) {
                return function(t) {
                    return function() {
                        return t.length < 2 || e(_, r, t, t.slice(0), 0, t.length), t;
                    };
                };
            };
        };
    }();
    var dp = {
        map: (e)=>(_)=>_
    };
    var o7 = (e)=>{
        let _ = e.mempty, r = e.Semigroup0(), t = {
            apply: (n)=>(s)=>r.append(n)(s),
            Functor0: ()=>dp
        };
        return {
            pure: (n)=>_,
            Apply0: ()=>t
        };
    };
    var Cr = function(e) {
        return function(_) {
            for(var r = _.length, t = Array(r), n = 0; n < r; n++)t[n] = e(n)(_[n]);
            return t;
        };
    };
    var pp = {
        mapWithIndex: Cr,
        Functor0: ()=>Nt
    };
    var c7 = function(e) {
        return function(_) {
            return e + _;
        };
    }, ne = function(e) {
        return function(_) {
            return e.length === 0 ? _ : _.length === 0 ? e : e.concat(_);
        };
    };
    var a7 = {
        append: (e)=>(_)=>{}
    }, Kv = {
        append: c7
    };
    var v7 = function() {
        function e(n) {
            return [
                n
            ];
        }
        function _(n) {
            return function(s) {
                return [
                    n,
                    s
                ];
            };
        }
        function r(n) {
            return function(s) {
                return function(c) {
                    return [
                        n,
                        s,
                        c
                    ];
                };
            };
        }
        function t(n) {
            return function(s) {
                return n.concat(s);
            };
        }
        return function(n) {
            return function(s) {
                return function(c) {
                    return function(i) {
                        return function(d) {
                            function v(b, p) {
                                switch(p - b){
                                    case 0:
                                        return c([]);
                                    case 1:
                                        return s(e)(i(d[b]));
                                    case 2:
                                        return n(s(_)(i(d[b])))(i(d[b + 1]));
                                    case 3:
                                        return n(n(s(r)(i(d[b])))(i(d[b + 1])))(i(d[b + 2]));
                                    default:
                                        var u = b + Math.floor((p - b) / 4) * 2;
                                        return n(s(t)(v(b, u)))(v(u, p));
                                }
                            }
                            return v(0, d.length);
                        };
                    };
                };
            };
        };
    }();
    var _a = (e)=>e;
    var lt = {
        traverse: (e)=>{
            let _ = e.Apply0();
            return v7(_.apply)(_.Functor0().map)(e.pure);
        },
        sequence: (e)=>lt.traverse(e)(_a),
        Functor0: ()=>Nt,
        Foldable1: ()=>eo
    };
    var f7 = function(e) {
        return function(_) {
            for(var r = e > _ ? -1 : 1, t = new Array(r * (_ - e) + 1), n = e, s = 0; n !== _;)t[s++] = n, n += r;
            return t[s] = n, t;
        };
    }, aG = function(e) {
        return function(_) {
            if (e < 1) return [];
            var r = new Array(e);
            return r.fill(_);
        };
    }, iG = function(e) {
        return function(_) {
            for(var r = [], t = 0, n = 0; n < e; n++)r[t++] = _;
            return r;
        };
    }, lG = typeof Array.prototype.fill == "function" ? aG : iG, Hn = function() {
        function e(n, s) {
            this.head = n, this.tail = s;
        }
        var _ = {};
        function r(n) {
            return function(s) {
                return new e(n, s);
            };
        }
        function t(n) {
            for(var s = [], c = 0, i = n; i !== _;)s[c++] = i.head, i = i.tail;
            return s;
        }
        return function(n) {
            return function(s) {
                return t(n(r)(_)(s));
            };
        };
    }();
    var fp = function(e) {
        return function(_) {
            return function(r) {
                return r.length === 0 ? e({}) : _(r[0])(r.slice(1));
            };
        };
    }, m7 = function(e) {
        return function(_) {
            return function(r) {
                return function(t) {
                    return t < 0 || t >= r.length ? _ : e(r[t]);
                };
            };
        };
    };
    var $7 = function(e) {
        return function(_) {
            return function(r) {
                return function(t) {
                    for(var n = t.length - 1; n >= 0; n--)if (r(t[n])) return e(n);
                    return _;
                };
            };
        };
    }, h7 = function(e) {
        return function(_) {
            return function(r) {
                return function(t) {
                    return function(n) {
                        if (r < 0 || r > n.length) return _;
                        var s = n.slice();
                        return s.splice(r, 0, t), e(s);
                    };
                };
            };
        };
    };
    var Qv = function(e) {
        if (e.length <= 1e4) return Array.prototype.concat.apply([], e);
        for(var _ = [], r = 0, t = e.length; r < t; r++)for(var n = e[r], s = 0, c = n.length; s < c; s++)_.push(n[s]);
        return _;
    }, mp = function(e) {
        return function(_) {
            return _.filter(e);
        };
    };
    var dG = function() {
        function e(_, r, t, n, s, c) {
            var i, d, v, b, p, u, m;
            for(i = s + (c - s >> 1), i - s > 1 && e(_, r, n, t, s, i), c - i > 1 && e(_, r, n, t, i, c), d = s, v = i, b = s; d < i && v < c;)p = n[d], u = n[v], m = r(_(p)(u)), m > 0 ? (t[b++] = u, ++v) : (t[b++] = p, ++d);
            for(; d < i;)t[b++] = n[d++];
            for(; v < c;)t[b++] = n[v++];
        }
        return function(_) {
            return function(r) {
                return function(t) {
                    var n;
                    return t.length < 2 ? t : (n = t.slice(0), e(_, r, n, t.slice(0), 0, t.length), n);
                };
            };
        };
    }(), ea = function(e) {
        return function(_) {
            return function(r) {
                return r.slice(e, _);
            };
        };
    };
    var qr = fp((e)=>D)((e)=>(_)=>R("Just", {
                head: e,
                tail: _
            }));
    var $p = fp((e)=>D)((e)=>(_)=>R("Just", _));
    var Ft = (e)=>(_)=>(()=>{
                let r = lp(e);
                return ()=>{
                    let t = r();
                    return t.push(_), t;
                };
            })()(), h = (e)=>[
            e
        ];
    var y7 = (e)=>(_)=>{
            let r = _.length;
            return r < 2 ? _ : (()=>{
                let t = [];
                t.push(_[0]);
                for (let n of v2(1, r))t.push(e), t.push(_[n]);
                return t;
            })();
        };
    var uG = h7(f_)(D), hp = (e)=>e.length === 0 ? D : R("Just", ea(0)(e.length - 1 | 0)(e)), Wr = m7(f_)(D);
    var gG = $7(f_)(D), bG = (e)=>(_)=>(r)=>{
                let t = uG((()=>{
                    let n = gG((s)=>e(_)(s).tag === "GT")(r);
                    if (n.tag === "Nothing") return 0;
                    if (n.tag === "Just") return n._1 + 1 | 0;
                    l();
                })())(_)(r);
                if (t.tag === "Just") return t._1;
                l();
            }, yp = (e)=>bG(e.compare);
    var D7 = (e)=>(_)=>ne([
                e
            ])(_);
    var w7 = (e)=>(_)=>$(_)(e), oa = (e)=>w7((_)=>{
            let r = e(_);
            if (r.tag === "Nothing") return [];
            if (r.tag === "Just") return [
                r._1
            ];
            l();
        });
    var ra = {
        foldrWithIndex: (e)=>(_)=>{
                let r = Tr((n)=>{
                    let s = n._1, c = n._2;
                    return (i)=>e(s)(c)(i);
                })(_), t = Cr(qo);
                return (n)=>r(t(n));
            },
        foldlWithIndex: (e)=>(_)=>{
                let r = Vn((n)=>(s)=>e(s._1)(n)(s._2))(_), t = Cr(qo);
                return (n)=>r(t(n));
            },
        foldMapWithIndex: (e)=>{
            let _ = e.Semigroup0().append, r = e.mempty;
            return (t)=>ra.foldrWithIndex((n)=>(s)=>(c)=>_(t(n)(s))(c))(r);
        },
        Foldable0: ()=>eo
    };
    var R7 = function(e) {
        return function(_) {
            return function(r) {
                return function(t) {
                    return function(n) {
                        return function(s) {
                            for(var c = [], i = s;;){
                                var d = n(i);
                                c.push(r(d));
                                var v = t(d);
                                if (e(v)) return c;
                                i = _(v);
                            }
                        };
                    };
                };
            };
        };
    };
    var pG = (e)=>{
        if (e.tag === "Just") return e._1;
        l();
    };
    var Dp = {
        unfoldr1: R7(Av)(pG)(Bn)(Xc)
    };
    var k7 = function(e) {
        return function(_) {
            return function(r) {
                return function(t) {
                    return function(n) {
                        return function(s) {
                            for(var c = [], i = s;;){
                                var d = n(i);
                                if (e(d)) return c;
                                var v = _(d);
                                c.push(r(v)), i = t(v);
                            }
                        };
                    };
                };
            };
        };
    };
    var fG = (e)=>{
        if (e.tag === "Just") return e._1;
        l();
    };
    var Vs = {
        unfoldr: k7(Av)(fG)(Bn)(Xc),
        Unfoldable10: ()=>Dp
    };
    var na = {};
    function S7(e) {
        return function(_) {
            return function(r) {
                return function(t) {
                    var n = r;
                    function s(i) {
                        return function(d) {
                            return _(d)(i)(t[i]);
                        };
                    }
                    for(var c in t)hasOwnProperty.call(t, c) && (n = e(n)(s(c)));
                    return n;
                };
            };
        };
    }
    function A0(e, _, r, t) {
        return r in t ? _(t[r]) : e;
    }
    function Rp(e) {
        return function(_) {
            var r = [];
            for(var t in _)hasOwnProperty.call(_, t) && r.push(e(t)(_[t]));
            return r;
        };
    }
    var sK = Object.keys || Rp(function(e) {
        return function() {
            return e;
        };
    });
    var qs = (e)=>(_)=>{
            let r = {
                ..._
            };
            return e(r)(), r;
        };
    var hG = S7(g2), E7 = (e)=>{
        let _ = e.Semigroup0().append, r = e.mempty;
        return (t)=>hG((n)=>(s)=>(c)=>_(n)(t(s)(c)))(r);
    };
    function ie(e) {
        return e;
    }
    var T7 = null;
    function dt(e) {
        return JSON.stringify(e);
    }
    function kp(e) {
        return Object.prototype.toString.call(e) === "[object Array]";
    }
    function Q_(e, _, r, t, n, s, c) {
        return c == null ? e() : typeof c == "boolean" ? _(c) : typeof c == "number" ? r(c) : typeof c == "string" ? t(c) : Object.prototype.toString.call(c) === "[object Array]" ? n(c) : s(c);
    }
    function tl(e, _, r, t, n) {
        if (t == null) return n == null ? e : r;
        if (typeof t == "boolean") return typeof n == "boolean" ? t === n ? e : t === !1 ? r : _ : n == null ? _ : r;
        if (typeof t == "number") return typeof n == "number" ? t === n ? e : t < n ? r : _ : n == null || typeof n == "boolean" ? _ : r;
        if (typeof t == "string") return typeof n == "string" ? t === n ? e : t < n ? r : _ : n == null || typeof n == "boolean" || typeof n == "number" ? _ : r;
        if (kp(t)) {
            if (kp(n)) {
                for(var s = 0; s < Math.min(t.length, n.length); s++){
                    var c = tl(e, _, r, t[s], n[s]);
                    if (c !== e) return c;
                }
                return t.length === n.length ? e : t.length < n.length ? r : _;
            } else return n == null || typeof n == "boolean" || typeof n == "number" || typeof n == "string" ? _ : r;
        } else {
            if (n == null) return _;
            if (typeof n == "boolean") return _;
            if (typeof n == "number") return _;
            if (typeof n == "string") return _;
            if (kp(n)) return _;
            var i = Object.keys(t), d = Object.keys(n);
            if (i.length < d.length) return r;
            if (i.length > d.length) return _;
            for(var v = i.concat(d).sort(), b = 0; b < v.length; b++){
                var p = v[b];
                if (t[p] === void 0) return r;
                if (n[p] === void 0) return _;
                var u = tl(e, _, r, t[p], n[p]);
                if (u !== e) return u;
            }
            return e;
        }
    }
    var G7 = {
        eq: (e)=>(_)=>tl(X_, T_, E_, e, _).tag === "EQ"
    };
    var H = (e, _, r)=>({
            tag: e,
            _1: _,
            _2: r
        });
    var C7 = (e)=>(_)=>H("AtIndex", e, _), Sp = (e)=>(_)=>H("AtKey", e, _), nl = (e)=>(_)=>H("Named", e, _), sa = H("MissingValue"), ge = {
        show: (e)=>{
            if (e.tag === "TypeMismatch") return "(TypeMismatch " + Se(e._1) + ")";
            if (e.tag === "UnexpectedValue") return "(UnexpectedValue " + dt(e._1) + ")";
            if (e.tag === "AtIndex") return "(AtIndex " + __(e._1) + " " + ge.show(e._2) + ")";
            if (e.tag === "AtKey") return "(AtKey " + Se(e._1) + " " + ge.show(e._2) + ")";
            if (e.tag === "Named") return "(Named " + Se(e._1) + " " + ge.show(e._2) + ")";
            if (e.tag === "MissingValue") return "MissingValue";
            l();
        }
    }, A7 = (e)=>{
        let _ = (r)=>{
            if (r.tag === "TypeMismatch") return "  Expected value of type '" + r._1 + "'.";
            if (r.tag === "UnexpectedValue") return "  Unexpected value " + dt(r._1) + ".";
            if (r.tag === "AtIndex") return "  At array index " + __(r._1) + `:
` + _(r._2);
            if (r.tag === "AtKey") return "  At object key '" + r._1 + `':
` + _(r._2);
            if (r.tag === "Named") return "  Under '" + r._1 + `':
` + _(r._2);
            if (r.tag === "MissingValue") return "  No value was found.";
            l();
        };
        return `An error occurred while decoding a JSON value:
` + _(e);
    };
    var Ip = (e)=>e;
    var F7 = (e)=>{
        let _ = (d)=>(v)=>{
                if (d.tag === "Cons") {
                    if (v.tag === "Cons") return e(d._1)(v._1).tag === "GT" ? Y("Cons", v._1, _(d)(v._2)) : Y("Cons", d._1, _(d._2)(v));
                    if (v.tag === "Nil") return d;
                    l();
                }
                if (d.tag === "Nil") return v;
                if (v.tag === "Nil") return d;
                l();
            }, r = (d)=>d.tag === "Cons" && d._2.tag === "Cons" ? Y("Cons", _(d._1)(d._2._1), r(d._2._2)) : d, t = (d)=>{
            let v = d, b = !0, p;
            for(; b;){
                let u = v;
                if (u.tag === "Cons") {
                    if (u._2.tag === "Nil") {
                        b = !1, p = u._1;
                        continue;
                    }
                    v = r(u);
                    continue;
                }
                v = r(u);
            }
            return p;
        }, n = (d, v, b, p)=>{
            let u = d, m = v, z = b, L = p, J = !0, c_;
            for(; J;){
                if (u === 0) {
                    let t_ = m;
                    if (t_.tag === "Cons") {
                        if (t_._2.tag === "Cons") {
                            if (e(t_._1)(t_._2._1).tag === "GT") {
                                u = 1, m = t_._2._1, z = Y("Cons", t_._1, y_), L = t_._2._2;
                                continue;
                            }
                            let W = t_._1;
                            u = 2, m = t_._2._1, z = (a_)=>Y("Cons", W, a_), L = t_._2._2;
                            continue;
                        }
                        J = !1, c_ = Y("Cons", t_, y_);
                        continue;
                    }
                    J = !1, c_ = Y("Cons", t_, y_);
                    continue;
                }
                if (u === 1) {
                    let t_ = m, W = z, a_ = L;
                    if (a_.tag === "Cons") {
                        if (e(t_)(a_._1).tag === "GT") {
                            u = 1, m = a_._1, z = Y("Cons", t_, W), L = a_._2;
                            continue;
                        }
                        J = !1, c_ = Y("Cons", Y("Cons", t_, W), s(a_));
                        continue;
                    }
                    J = !1, c_ = Y("Cons", Y("Cons", t_, W), s(a_));
                    continue;
                }
                if (u === 2) {
                    let t_ = m, W = z, a_ = L;
                    if (a_.tag === "Cons") {
                        if ((()=>{
                            let Q = e(t_)(a_._1);
                            return Q.tag === "LT" || Q.tag !== "GT";
                        })()) {
                            u = 2, m = a_._1, z = (Q)=>W(Y("Cons", t_, Q)), L = a_._2;
                            continue;
                        }
                        J = !1, c_ = Y("Cons", W(Y("Cons", t_, y_)), s(a_));
                        continue;
                    }
                    J = !1, c_ = Y("Cons", W(Y("Cons", t_, y_)), s(a_));
                }
            }
            return c_;
        }, s = (d)=>n(0, d), c = (d)=>(v)=>(b)=>n(1, d, v, b), i = (d)=>(v)=>(b)=>n(2, d, v, b);
        return (d)=>t(s(d));
    };
    var xp = (()=>((_)=>(r)=>{
                let t = _, n = r, s = !0, c;
                for(; s;){
                    let i = t, d = n;
                    if (d.tag === "Nil") {
                        s = !1, c = i;
                        continue;
                    }
                    if (d.tag === "Cons") {
                        t = Y("Cons", d._1, i), n = d._2;
                        continue;
                    }
                    l();
                }
                return c;
            })(y_))();
    var M7 = (e)=>((r)=>(t)=>{
                let n = r, s = t, c = !0, i;
                for(; c;){
                    let d = n, v = s;
                    if (v.tag === "Nil") {
                        c = !1, i = xp(d);
                        continue;
                    }
                    if (v.tag === "Cons") {
                        let b = e(v._1);
                        if (b.tag === "Nothing") {
                            n = d, s = v._2;
                            continue;
                        }
                        if (b.tag === "Just") {
                            n = Y("Cons", b._1, d), s = v._2;
                            continue;
                        }
                        l();
                    }
                    l();
                }
                return i;
            })(y_);
    var Ep = (e)=>{
        let _ = e.Applicative0().Apply0().apply, r = e.Plus1().Alt0().Functor0().map;
        return (t)=>(n)=>_(r(no)(n))(t.defer((s)=>SG(e)(t)(n)));
    }, SG = (e)=>{
        let _ = e.Plus1().Alt0().alt, r = e.Applicative0().pure;
        return (t)=>(n)=>_(Ep(e)(t)(n))(r(y_));
    };
    var Tp = (e)=>(_)=>(r)=>{
                if (r.tag === "Nil") return Y("Cons", _, y_);
                if (r.tag === "Cons") return e(_)(r._1).tag === "GT" ? Y("Cons", r._1, Tp(e)(_)(r._2)) : Y("Cons", _, r);
                l();
            };
    var P7 = (e)=>((r)=>(t)=>{
                let n = r, s = t, c = !0, i;
                for(; c;){
                    let d = n, v = s;
                    if (v.tag === "Nil") {
                        c = !1, i = xp(d);
                        continue;
                    }
                    if (v.tag === "Cons") {
                        if (e(v._1)) {
                            n = Y("Cons", v._1, d), s = v._2;
                            continue;
                        }
                        n = d, s = v._2;
                        continue;
                    }
                    l();
                }
                return i;
            })(y_);
    var ca = function(e) {
        var _ = null;
        return function() {
            return e === void 0 || (_ = e(), e = void 0), _;
        };
    }, aa = function(e) {
        return e();
    };
    var Zv = (e, _, r, t)=>({
            tag: "KickUp",
            _1: e,
            _2: _,
            _3: r,
            _4: t
        }), A_ = (e, _, r, t, n, s, c, i)=>({
            tag: e,
            _1: _,
            _2: r,
            _3: t,
            _4: n,
            _5: s,
            _6: c,
            _7: i
        }), Qe = (e, _, r, t, n, s, c)=>({
            tag: e,
            _1: _,
            _2: r,
            _3: t,
            _4: n,
            _5: s,
            _6: c
        });
    var be = A_("Leaf");
    var z7 = (e)=>(_)=>{
            let r = (t)=>{
                let n = t, s = !0, c;
                for(; s;){
                    let i = n;
                    if (i.tag === "Nil") {
                        s = !1, c = D;
                        continue;
                    }
                    if (i.tag === "Cons") {
                        if (i._1.tag === "Leaf") {
                            n = i._2;
                            continue;
                        }
                        if (i._1.tag === "Two") {
                            s = !1, c = R("Just", E(E(i._1._2, i._1._3), Y("Cons", i._1._1, Y("Cons", i._1._4, i._2))));
                            continue;
                        }
                        if (i._1.tag === "Three") {
                            s = !1, c = R("Just", E(E(i._1._2, i._1._3), Y("Cons", A_("Two", be, i._1._5, i._1._6, be), Y("Cons", i._1._1, Y("Cons", i._1._4, Y("Cons", i._1._7, i._2))))));
                            continue;
                        }
                        l();
                    }
                    l();
                }
                return c;
            };
            return e.unfoldr(r)(Y("Cons", _, y_));
        };
    var vt = (e)=>(_)=>(t)=>{
                let n = t, s = !0, c;
                for(; s;){
                    let i = n;
                    if (i.tag === "Leaf") {
                        s = !1, c = D;
                        continue;
                    }
                    if (i.tag === "Two") {
                        let d = e.compare(_)(i._2);
                        if (d.tag === "EQ") {
                            s = !1, c = R("Just", i._3);
                            continue;
                        }
                        if (d.tag === "LT") {
                            n = i._1;
                            continue;
                        }
                        n = i._4;
                        continue;
                    }
                    if (i.tag === "Three") {
                        let d = e.compare(_)(i._2);
                        if (d.tag === "EQ") {
                            s = !1, c = R("Just", i._3);
                            continue;
                        }
                        let v = e.compare(_)(i._5);
                        if (v.tag === "EQ") {
                            s = !1, c = R("Just", i._6);
                            continue;
                        }
                        if (d.tag === "LT") {
                            n = i._1;
                            continue;
                        }
                        if (v.tag === "GT") {
                            n = i._7;
                            continue;
                        }
                        n = i._4;
                        continue;
                    }
                    l();
                }
                return c;
            };
    var bo = (e)=>(_)=>(r)=>{
                let t = e, n = _, s = r, c = !0, i;
                for(; c;){
                    let d = t, v = n, b = s;
                    if (v.tag === "Nil") {
                        c = !1, i = b;
                        continue;
                    }
                    if (v.tag === "Cons") {
                        if (v._1.tag === "TwoLeft") {
                            t = d, n = v._2, s = A_("Two", b, v._1._1, v._1._2, v._1._3);
                            continue;
                        }
                        if (v._1.tag === "TwoRight") {
                            t = d, n = v._2, s = A_("Two", v._1._1, v._1._2, v._1._3, b);
                            continue;
                        }
                        if (v._1.tag === "ThreeLeft") {
                            t = d, n = v._2, s = A_("Three", b, v._1._1, v._1._2, v._1._3, v._1._4, v._1._5, v._1._6);
                            continue;
                        }
                        if (v._1.tag === "ThreeMiddle") {
                            t = d, n = v._2, s = A_("Three", v._1._1, v._1._2, v._1._3, b, v._1._4, v._1._5, v._1._6);
                            continue;
                        }
                        if (v._1.tag === "ThreeRight") {
                            t = d, n = v._2, s = A_("Three", v._1._1, v._1._2, v._1._3, v._1._4, v._1._5, v._1._6, b);
                            continue;
                        }
                        l();
                    }
                    l();
                }
                return i;
            }, N0 = (e)=>(_)=>(r)=>{
                let t = (s)=>(c)=>{
                        let i = s, d = c, v = !0, b;
                        for(; v;){
                            let p = i, u = d;
                            if (p.tag === "Nil") {
                                v = !1, b = A_("Two", u._1, u._2, u._3, u._4);
                                continue;
                            }
                            if (p.tag === "Cons") {
                                if (p._1.tag === "TwoLeft") {
                                    v = !1, b = bo(e)(p._2)(A_("Three", u._1, u._2, u._3, u._4, p._1._1, p._1._2, p._1._3));
                                    continue;
                                }
                                if (p._1.tag === "TwoRight") {
                                    v = !1, b = bo(e)(p._2)(A_("Three", p._1._1, p._1._2, p._1._3, u._1, u._2, u._3, u._4));
                                    continue;
                                }
                                if (p._1.tag === "ThreeLeft") {
                                    i = p._2, d = Zv(A_("Two", u._1, u._2, u._3, u._4), p._1._1, p._1._2, A_("Two", p._1._3, p._1._4, p._1._5, p._1._6));
                                    continue;
                                }
                                if (p._1.tag === "ThreeMiddle") {
                                    i = p._2, d = Zv(A_("Two", p._1._1, p._1._2, p._1._3, u._1), u._2, u._3, A_("Two", u._4, p._1._4, p._1._5, p._1._6));
                                    continue;
                                }
                                if (p._1.tag === "ThreeRight") {
                                    i = p._2, d = Zv(A_("Two", p._1._1, p._1._2, p._1._3, p._1._4), p._1._5, p._1._6, A_("Two", u._1, u._2, u._3, u._4));
                                    continue;
                                }
                                l();
                            }
                            l();
                        }
                        return b;
                    };
                return ((s)=>(c)=>{
                        let i = s, d = c, v = !0, b;
                        for(; v;){
                            let p = i, u = d;
                            if (u.tag === "Leaf") {
                                v = !1, b = t(p)(Zv(be, _, r, be));
                                continue;
                            }
                            if (u.tag === "Two") {
                                let m = e.compare(_)(u._2);
                                if (m.tag === "EQ") {
                                    v = !1, b = bo(e)(p)(A_("Two", u._1, _, r, u._4));
                                    continue;
                                }
                                if (m.tag === "LT") {
                                    i = Y("Cons", Qe("TwoLeft", u._2, u._3, u._4), p), d = u._1;
                                    continue;
                                }
                                i = Y("Cons", Qe("TwoRight", u._1, u._2, u._3), p), d = u._4;
                                continue;
                            }
                            if (u.tag === "Three") {
                                let m = e.compare(_)(u._2);
                                if (m.tag === "EQ") {
                                    v = !1, b = bo(e)(p)(A_("Three", u._1, _, r, u._4, u._5, u._6, u._7));
                                    continue;
                                }
                                let z = e.compare(_)(u._5);
                                if (z.tag === "EQ") {
                                    v = !1, b = bo(e)(p)(A_("Three", u._1, u._2, u._3, u._4, _, r, u._7));
                                    continue;
                                }
                                if (m.tag === "LT") {
                                    i = Y("Cons", Qe("ThreeLeft", u._2, u._3, u._4, u._5, u._6, u._7), p), d = u._1;
                                    continue;
                                }
                                if (m.tag === "GT") {
                                    if (z.tag === "LT") {
                                        i = Y("Cons", Qe("ThreeMiddle", u._1, u._2, u._3, u._5, u._6, u._7), p), d = u._4;
                                        continue;
                                    }
                                    i = Y("Cons", Qe("ThreeRight", u._1, u._2, u._3, u._4, u._5, u._6), p), d = u._7;
                                    continue;
                                }
                                i = Y("Cons", Qe("ThreeRight", u._1, u._2, u._3, u._4, u._5, u._6), p), d = u._7;
                                continue;
                            }
                            l();
                        }
                        return b;
                    })(y_);
            }, TG = (e)=>(_)=>{
            let r = (c)=>(i)=>{
                    let d = c, v = i, b = !0, p;
                    for(; b;){
                        let u = d, m = v;
                        if (u.tag === "Nil") {
                            b = !1, p = m;
                            continue;
                        }
                        if (u.tag === "Cons") {
                            let z = u._2, L = (x, T, C, A, G, $_, i_, W_, g_, U_)=>bo(e)(z)(A_("Two", A_("Two", x, G, W_, T), $_, g_, A_("Two", C, i_, U_, A))), J = (x, T, C, A, G, $_, i_, W_, g_, U_)=>bo(e)(z)(A_("Two", A_("Two", x, G, W_, T), $_, g_, A_("Two", C, i_, U_, A))), c_ = (x, T, C, A, G, $_, i_, W_, g_, U_)=>bo(e)(z)(A_("Two", A_("Three", x, G, W_, T, $_, g_, C), i_, U_, A)), t_ = (x, T, C, A, G, $_, i_, W_, g_, U_)=>bo(e)(z)(A_("Two", A_("Three", x, G, W_, T, $_, g_, C), i_, U_, A)), W = (x, T, C, A, G, $_, i_, W_, g_, U_)=>bo(e)(z)(A_("Two", x, G, W_, A_("Three", T, $_, g_, C, i_, U_, A))), a_ = (x, T, C, A, G, $_, i_, W_, g_, U_)=>bo(e)(z)(A_("Two", x, G, W_, A_("Three", T, $_, g_, C, i_, U_, A))), Q = (x, T, C, A, G, $_, i_, W_, g_, U_, we, p_, pe)=>bo(e)(z)(A_("Three", A_("Two", x, $_, U_, T), i_, we, A_("Two", C, W_, p_, A), g_, pe, G)), F = (x, T, C, A, G, $_, i_, W_, g_, U_, we, p_, pe)=>bo(e)(z)(A_("Three", A_("Two", x, $_, U_, T), i_, we, A_("Two", C, W_, p_, A), g_, pe, G)), y = (x, T, C, A, G, $_, i_, W_, g_, U_, we, p_, pe)=>bo(e)(z)(A_("Three", x, $_, U_, A_("Two", T, i_, we, C), W_, p_, A_("Two", A, g_, pe, G))), w = (x, T, C, A, G, $_, i_, W_, g_, U_, we, p_, pe)=>bo(e)(z)(A_("Three", x, $_, U_, A_("Two", T, i_, we, C), W_, p_, A_("Two", A, g_, pe, G)));
                            if (m.tag === "Leaf") {
                                if (u._1.tag === "TwoLeft") {
                                    if (u._1._3.tag === "Leaf") {
                                        b = !1, p = bo(e)(z)(A_("Two", be, u._1._1, u._1._2, be));
                                        continue;
                                    }
                                    if (u._1._3.tag === "Two") {
                                        d = z, v = A_("Three", m, u._1._1, u._1._2, u._1._3._1, u._1._3._2, u._1._3._3, u._1._3._4);
                                        continue;
                                    }
                                    if (u._1._3.tag === "Three") {
                                        b = !1, p = L(m, u._1._3._1, u._1._3._4, u._1._3._7, u._1._1, u._1._3._2, u._1._3._5, u._1._2, u._1._3._3, u._1._3._6);
                                        continue;
                                    }
                                    b = !1, p = Ie("The impossible happened in partial function `up`.");
                                    continue;
                                }
                                if (u._1.tag === "TwoRight") {
                                    if (u._1._1.tag === "Leaf") {
                                        b = !1, p = bo(e)(z)(A_("Two", be, u._1._2, u._1._3, be));
                                        continue;
                                    }
                                    if (u._1._1.tag === "Two") {
                                        d = z, v = A_("Three", u._1._1._1, u._1._1._2, u._1._1._3, u._1._1._4, u._1._2, u._1._3, m);
                                        continue;
                                    }
                                    if (u._1._1.tag === "Three") {
                                        b = !1, p = J(u._1._1._1, u._1._1._4, u._1._1._7, m, u._1._1._2, u._1._1._5, u._1._2, u._1._1._3, u._1._1._6, u._1._3);
                                        continue;
                                    }
                                    b = !1, p = Ie("The impossible happened in partial function `up`.");
                                    continue;
                                }
                                if (u._1.tag === "ThreeLeft") {
                                    if (u._1._6.tag === "Leaf") {
                                        if (u._1._3.tag === "Leaf") {
                                            b = !1, p = bo(e)(z)(A_("Three", be, u._1._1, u._1._2, be, u._1._4, u._1._5, be));
                                            continue;
                                        }
                                        if (u._1._3.tag === "Two") {
                                            b = !1, p = c_(m, u._1._3._1, u._1._3._4, u._1._6, u._1._1, u._1._3._2, u._1._4, u._1._2, u._1._3._3, u._1._5);
                                            continue;
                                        }
                                        if (u._1._3.tag === "Three") {
                                            b = !1, p = Q(m, u._1._3._1, u._1._3._4, u._1._3._7, u._1._6, u._1._1, u._1._3._2, u._1._3._5, u._1._4, u._1._2, u._1._3._3, u._1._3._6, u._1._5);
                                            continue;
                                        }
                                        b = !1, p = Ie("The impossible happened in partial function `up`.");
                                        continue;
                                    }
                                    if (u._1._3.tag === "Two") {
                                        b = !1, p = c_(m, u._1._3._1, u._1._3._4, u._1._6, u._1._1, u._1._3._2, u._1._4, u._1._2, u._1._3._3, u._1._5);
                                        continue;
                                    }
                                    if (u._1._3.tag === "Three") {
                                        b = !1, p = Q(m, u._1._3._1, u._1._3._4, u._1._3._7, u._1._6, u._1._1, u._1._3._2, u._1._3._5, u._1._4, u._1._2, u._1._3._3, u._1._3._6, u._1._5);
                                        continue;
                                    }
                                    b = !1, p = Ie("The impossible happened in partial function `up`.");
                                    continue;
                                }
                                if (u._1.tag === "ThreeMiddle") {
                                    if (u._1._1.tag === "Leaf") {
                                        if (u._1._6.tag === "Leaf") {
                                            b = !1, p = bo(e)(z)(A_("Three", be, u._1._2, u._1._3, be, u._1._4, u._1._5, be));
                                            continue;
                                        }
                                        if (u._1._6.tag === "Two") {
                                            b = !1, p = W(u._1._1, m, u._1._6._1, u._1._6._4, u._1._2, u._1._4, u._1._6._2, u._1._3, u._1._5, u._1._6._3);
                                            continue;
                                        }
                                        if (u._1._6.tag === "Three") {
                                            b = !1, p = y(u._1._1, m, u._1._6._1, u._1._6._4, u._1._6._7, u._1._2, u._1._4, u._1._6._2, u._1._6._5, u._1._3, u._1._5, u._1._6._3, u._1._6._6);
                                            continue;
                                        }
                                        b = !1, p = Ie("The impossible happened in partial function `up`.");
                                        continue;
                                    }
                                    if (u._1._1.tag === "Two") {
                                        b = !1, p = t_(u._1._1._1, u._1._1._4, m, u._1._6, u._1._1._2, u._1._2, u._1._4, u._1._1._3, u._1._3, u._1._5);
                                        continue;
                                    }
                                    if (u._1._6.tag === "Two") {
                                        b = !1, p = W(u._1._1, m, u._1._6._1, u._1._6._4, u._1._2, u._1._4, u._1._6._2, u._1._3, u._1._5, u._1._6._3);
                                        continue;
                                    }
                                    if (u._1._1.tag === "Three") {
                                        b = !1, p = F(u._1._1._1, u._1._1._4, u._1._1._7, m, u._1._6, u._1._1._2, u._1._1._5, u._1._2, u._1._4, u._1._1._3, u._1._1._6, u._1._3, u._1._5);
                                        continue;
                                    }
                                    if (u._1._6.tag === "Three") {
                                        b = !1, p = y(u._1._1, m, u._1._6._1, u._1._6._4, u._1._6._7, u._1._2, u._1._4, u._1._6._2, u._1._6._5, u._1._3, u._1._5, u._1._6._3, u._1._6._6);
                                        continue;
                                    }
                                    b = !1, p = Ie("The impossible happened in partial function `up`.");
                                    continue;
                                }
                                if (u._1.tag === "ThreeRight") {
                                    if (u._1._1.tag === "Leaf") {
                                        if (u._1._4.tag === "Leaf") {
                                            b = !1, p = bo(e)(z)(A_("Three", be, u._1._2, u._1._3, be, u._1._5, u._1._6, be));
                                            continue;
                                        }
                                        if (u._1._4.tag === "Two") {
                                            b = !1, p = a_(u._1._1, u._1._4._1, u._1._4._4, m, u._1._2, u._1._4._2, u._1._5, u._1._3, u._1._4._3, u._1._6);
                                            continue;
                                        }
                                        if (u._1._4.tag === "Three") {
                                            b = !1, p = w(u._1._1, u._1._4._1, u._1._4._4, u._1._4._7, m, u._1._2, u._1._4._2, u._1._4._5, u._1._5, u._1._3, u._1._4._3, u._1._4._6, u._1._6);
                                            continue;
                                        }
                                        b = !1, p = Ie("The impossible happened in partial function `up`.");
                                        continue;
                                    }
                                    if (u._1._4.tag === "Two") {
                                        b = !1, p = a_(u._1._1, u._1._4._1, u._1._4._4, m, u._1._2, u._1._4._2, u._1._5, u._1._3, u._1._4._3, u._1._6);
                                        continue;
                                    }
                                    if (u._1._4.tag === "Three") {
                                        b = !1, p = w(u._1._1, u._1._4._1, u._1._4._4, u._1._4._7, m, u._1._2, u._1._4._2, u._1._4._5, u._1._5, u._1._3, u._1._4._3, u._1._4._6, u._1._6);
                                        continue;
                                    }
                                    b = !1, p = Ie("The impossible happened in partial function `up`.");
                                    continue;
                                }
                                b = !1, p = Ie("The impossible happened in partial function `up`.");
                                continue;
                            }
                            if (u._1.tag === "TwoLeft") {
                                if (u._1._3.tag === "Two") {
                                    d = z, v = A_("Three", m, u._1._1, u._1._2, u._1._3._1, u._1._3._2, u._1._3._3, u._1._3._4);
                                    continue;
                                }
                                if (u._1._3.tag === "Three") {
                                    b = !1, p = L(m, u._1._3._1, u._1._3._4, u._1._3._7, u._1._1, u._1._3._2, u._1._3._5, u._1._2, u._1._3._3, u._1._3._6);
                                    continue;
                                }
                                b = !1, p = Ie("The impossible happened in partial function `up`.");
                                continue;
                            }
                            if (u._1.tag === "TwoRight") {
                                if (u._1._1.tag === "Two") {
                                    d = z, v = A_("Three", u._1._1._1, u._1._1._2, u._1._1._3, u._1._1._4, u._1._2, u._1._3, m);
                                    continue;
                                }
                                if (u._1._1.tag === "Three") {
                                    b = !1, p = J(u._1._1._1, u._1._1._4, u._1._1._7, m, u._1._1._2, u._1._1._5, u._1._2, u._1._1._3, u._1._1._6, u._1._3);
                                    continue;
                                }
                                b = !1, p = Ie("The impossible happened in partial function `up`.");
                                continue;
                            }
                            if (u._1.tag === "ThreeLeft") {
                                if (u._1._3.tag === "Two") {
                                    b = !1, p = c_(m, u._1._3._1, u._1._3._4, u._1._6, u._1._1, u._1._3._2, u._1._4, u._1._2, u._1._3._3, u._1._5);
                                    continue;
                                }
                                if (u._1._3.tag === "Three") {
                                    b = !1, p = Q(m, u._1._3._1, u._1._3._4, u._1._3._7, u._1._6, u._1._1, u._1._3._2, u._1._3._5, u._1._4, u._1._2, u._1._3._3, u._1._3._6, u._1._5);
                                    continue;
                                }
                                b = !1, p = Ie("The impossible happened in partial function `up`.");
                                continue;
                            }
                            if (u._1.tag === "ThreeMiddle") {
                                if (u._1._1.tag === "Two") {
                                    b = !1, p = t_(u._1._1._1, u._1._1._4, m, u._1._6, u._1._1._2, u._1._2, u._1._4, u._1._1._3, u._1._3, u._1._5);
                                    continue;
                                }
                                if (u._1._6.tag === "Two") {
                                    b = !1, p = W(u._1._1, m, u._1._6._1, u._1._6._4, u._1._2, u._1._4, u._1._6._2, u._1._3, u._1._5, u._1._6._3);
                                    continue;
                                }
                                if (u._1._1.tag === "Three") {
                                    b = !1, p = F(u._1._1._1, u._1._1._4, u._1._1._7, m, u._1._6, u._1._1._2, u._1._1._5, u._1._2, u._1._4, u._1._1._3, u._1._1._6, u._1._3, u._1._5);
                                    continue;
                                }
                                if (u._1._6.tag === "Three") {
                                    b = !1, p = y(u._1._1, m, u._1._6._1, u._1._6._4, u._1._6._7, u._1._2, u._1._4, u._1._6._2, u._1._6._5, u._1._3, u._1._5, u._1._6._3, u._1._6._6);
                                    continue;
                                }
                                b = !1, p = Ie("The impossible happened in partial function `up`.");
                                continue;
                            }
                            if (u._1.tag === "ThreeRight") {
                                if (u._1._4.tag === "Two") {
                                    b = !1, p = a_(u._1._1, u._1._4._1, u._1._4._4, m, u._1._2, u._1._4._2, u._1._5, u._1._3, u._1._4._3, u._1._6);
                                    continue;
                                }
                                if (u._1._4.tag === "Three") {
                                    b = !1, p = w(u._1._1, u._1._4._1, u._1._4._4, u._1._4._7, m, u._1._2, u._1._4._2, u._1._4._5, u._1._5, u._1._3, u._1._4._3, u._1._4._6, u._1._6);
                                    continue;
                                }
                                b = !1, p = Ie("The impossible happened in partial function `up`.");
                                continue;
                            }
                            b = !1, p = Ie("The impossible happened in partial function `up`.");
                            continue;
                        }
                        l();
                    }
                    return p;
                }, t = (c)=>(i)=>{
                    let d = c, v = i, b = !0, p;
                    for(; b;){
                        let u = d, m = v;
                        if (m.tag === "Two") {
                            if (m._1.tag === "Leaf") {
                                if (m._4.tag === "Leaf") {
                                    b = !1, p = r(u)(be);
                                    continue;
                                }
                                d = Y("Cons", Qe("TwoRight", m._1, m._2, m._3), u), v = m._4;
                                continue;
                            }
                            d = Y("Cons", Qe("TwoRight", m._1, m._2, m._3), u), v = m._4;
                            continue;
                        }
                        if (m.tag === "Three") {
                            if (m._1.tag === "Leaf") {
                                if (m._4.tag === "Leaf") {
                                    if (m._7.tag === "Leaf") {
                                        b = !1, p = r(Y("Cons", Qe("TwoRight", be, m._2, m._3), u))(be);
                                        continue;
                                    }
                                    d = Y("Cons", Qe("ThreeRight", m._1, m._2, m._3, m._4, m._5, m._6), u), v = m._7;
                                    continue;
                                }
                                d = Y("Cons", Qe("ThreeRight", m._1, m._2, m._3, m._4, m._5, m._6), u), v = m._7;
                                continue;
                            }
                            d = Y("Cons", Qe("ThreeRight", m._1, m._2, m._3, m._4, m._5, m._6), u), v = m._7;
                            continue;
                        }
                        b = !1, p = Ie("The impossible happened in partial function `removeMaxNode`.");
                    }
                    return p;
                }, n = (c)=>{
                let i = c, d = !0, v;
                for(; d;){
                    let b = i;
                    if (b.tag === "Two") {
                        if (b._4.tag === "Leaf") {
                            d = !1, v = {
                                key: b._2,
                                value: b._3
                            };
                            continue;
                        }
                        i = b._4;
                        continue;
                    }
                    if (b.tag === "Three") {
                        if (b._7.tag === "Leaf") {
                            d = !1, v = {
                                key: b._5,
                                value: b._6
                            };
                            continue;
                        }
                        i = b._7;
                        continue;
                    }
                    d = !1, v = Ie("The impossible happened in partial function `maxNode`.");
                }
                return v;
            };
            return ((c)=>(i)=>{
                    let d = c, v = i, b = !0, p;
                    for(; b;){
                        let u = d, m = v;
                        if (m.tag === "Leaf") {
                            b = !1, p = D;
                            continue;
                        }
                        if (m.tag === "Two") {
                            let z = e.compare(_)(m._2);
                            if (z.tag === "EQ") {
                                if (m._4.tag === "Leaf") {
                                    b = !1, p = R("Just", E(m._3, r(u)(be)));
                                    continue;
                                }
                                let L = n(m._1);
                                b = !1, p = R("Just", E(m._3, t(Y("Cons", Qe("TwoLeft", L.key, L.value, m._4), u))(m._1)));
                                continue;
                            }
                            if (z.tag === "LT") {
                                d = Y("Cons", Qe("TwoLeft", m._2, m._3, m._4), u), v = m._1;
                                continue;
                            }
                            d = Y("Cons", Qe("TwoRight", m._1, m._2, m._3), u), v = m._4;
                            continue;
                        }
                        if (m.tag === "Three") {
                            let z = e.compare(_)(m._5), L = e.compare(_)(m._2);
                            if ((()=>m._1.tag === "Leaf" && m._4.tag === "Leaf" ? m._7.tag === "Leaf" : !1)()) {
                                if (L.tag === "EQ") {
                                    b = !1, p = R("Just", E(m._3, bo(e)(u)(A_("Two", be, m._5, m._6, be))));
                                    continue;
                                }
                                if (z.tag === "EQ") {
                                    b = !1, p = R("Just", E(m._6, bo(e)(u)(A_("Two", be, m._2, m._3, be))));
                                    continue;
                                }
                                if (L.tag === "LT") {
                                    d = Y("Cons", Qe("ThreeLeft", m._2, m._3, m._4, m._5, m._6, m._7), u), v = m._1;
                                    continue;
                                }
                                if (L.tag === "GT") {
                                    if (z.tag === "LT") {
                                        d = Y("Cons", Qe("ThreeMiddle", m._1, m._2, m._3, m._5, m._6, m._7), u), v = m._4;
                                        continue;
                                    }
                                    d = Y("Cons", Qe("ThreeRight", m._1, m._2, m._3, m._4, m._5, m._6), u), v = m._7;
                                    continue;
                                }
                                d = Y("Cons", Qe("ThreeRight", m._1, m._2, m._3, m._4, m._5, m._6), u), v = m._7;
                                continue;
                            }
                            if (L.tag === "EQ") {
                                let J = n(m._1);
                                b = !1, p = R("Just", E(m._3, t(Y("Cons", Qe("ThreeLeft", J.key, J.value, m._4, m._5, m._6, m._7), u))(m._1)));
                                continue;
                            }
                            if (z.tag === "EQ") {
                                let J = n(m._4);
                                b = !1, p = R("Just", E(m._6, t(Y("Cons", Qe("ThreeMiddle", m._1, m._2, m._3, J.key, J.value, m._7), u))(m._4)));
                                continue;
                            }
                            if (L.tag === "LT") {
                                d = Y("Cons", Qe("ThreeLeft", m._2, m._3, m._4, m._5, m._6, m._7), u), v = m._1;
                                continue;
                            }
                            if (L.tag === "GT") {
                                if (z.tag === "LT") {
                                    d = Y("Cons", Qe("ThreeMiddle", m._1, m._2, m._3, m._5, m._6, m._7), u), v = m._4;
                                    continue;
                                }
                                d = Y("Cons", Qe("ThreeRight", m._1, m._2, m._3, m._4, m._5, m._6), u), v = m._7;
                                continue;
                            }
                            d = Y("Cons", Qe("ThreeRight", m._1, m._2, m._3, m._4, m._5, m._6), u), v = m._7;
                            continue;
                        }
                        l();
                    }
                    return p;
                })(y_);
        }, ko = {
        foldr: (e)=>(_)=>(r)=>{
                    if (r.tag === "Leaf") return _;
                    if (r.tag === "Two") return ko.foldr(e)(e(r._3)(ko.foldr(e)(_)(r._4)))(r._1);
                    if (r.tag === "Three") return ko.foldr(e)(e(r._3)(ko.foldr(e)(e(r._6)(ko.foldr(e)(_)(r._7)))(r._4)))(r._1);
                    l();
                },
        foldl: (e)=>(_)=>(r)=>{
                    if (r.tag === "Leaf") return _;
                    if (r.tag === "Two") return ko.foldl(e)(e(ko.foldl(e)(_)(r._1))(r._3))(r._4);
                    if (r.tag === "Three") return ko.foldl(e)(e(ko.foldl(e)(e(ko.foldl(e)(_)(r._1))(r._3))(r._4))(r._6))(r._7);
                    l();
                },
        foldMap: (e)=>{
            let _ = e.mempty, r = e.Semigroup0().append;
            return (t)=>(n)=>{
                    if (n.tag === "Leaf") return _;
                    if (n.tag === "Two") return r(ko.foldMap(e)(t)(n._1))(r(t(n._3))(ko.foldMap(e)(t)(n._4)));
                    if (n.tag === "Three") return r(ko.foldMap(e)(t)(n._1))(r(t(n._3))(r(ko.foldMap(e)(t)(n._4))(r(t(n._6))(ko.foldMap(e)(t)(n._7)))));
                    l();
                };
        }
    };
    var sl = (e)=>(_)=>_.foldl((r)=>(t)=>N0(e)(t._1)(t._2)(r))(be);
    var _u = (e)=>(_)=>(r)=>{
                let t = TG(e)(_)(r);
                if (t.tag === "Nothing") return r;
                if (t.tag === "Just") return t._1._2;
                l();
            };
    var O7 = (e)=>(_)=>(r)=>(t)=>{
                    let n = _(vt(e)(r)(t));
                    if (n.tag === "Nothing") return _u(e)(r)(t);
                    if (n.tag === "Just") return N0(e)(r)(n._1)(t);
                    l();
                };
    var U7 = (e)=>(_)=>(r)=>(t)=>O7(e)((n)=>{
                        if (n.tag === "Nothing") return D;
                        if (n.tag === "Just") return _(n._1);
                        l();
                    })(r)(t);
    var sQ = String.fromCharCode(65535), cQ = String.fromCharCode(0), AG = Number.POSITIVE_INFINITY, NG = Number.NEGATIVE_INFINITY;
    function F0(e) {
        return e.charCodeAt(0);
    }
    function cl(e) {
        return String.fromCharCode(e);
    }
    var M0 = function(e) {
        return function(_) {
            return _ === 0 ? 0 : _ > 0 ? Math.floor(e / _) : -Math.floor(e / -_);
        };
    }, wt = function(e) {
        return function(_) {
            if (_ === 0) return 0;
            var r = Math.abs(_);
            return (e % r + r) % r;
        };
    };
    var Pt = function(e) {
        return function(_) {
            return _.split(e);
        };
    }, P0 = function(e) {
        return e.toLowerCase();
    }, Cp = function(e) {
        return e.toUpperCase();
    };
    var Hr = function(e) {
        return function(_) {
            return _.join(e);
        };
    };
    var JG = typeof Array.from == "function", J7 = typeof Symbol < "u" && Symbol != null && typeof Symbol.iterator < "u" && typeof String.prototype[Symbol.iterator] == "function", VG = typeof String.prototype.fromCodePoint == "function", qG = typeof String.prototype.codePointAt == "function", V7 = function(e) {
        return qG ? function(_) {
            return _.codePointAt(0);
        } : e;
    }, q7 = function(e) {
        return function(_) {
            return function(r) {
                return function(t) {
                    return function(n) {
                        return function(s) {
                            var c = s.length;
                            if (n < 0 || n >= c) return r;
                            if (J7) for(var i = s[Symbol.iterator](), d = n;; --d){
                                var v = i.next();
                                if (v.done) return r;
                                if (d === 0) return _(t(v.value));
                            }
                            return e(n)(s);
                        };
                    };
                };
            };
        };
    };
    var W7 = function(e) {
        return VG ? String.fromCodePoint : e;
    }, H7 = function(e) {
        return function(_) {
            return J7 ? function(r) {
                for(var t = "", n = r[Symbol.iterator](), s = 0; s < _; ++s){
                    var c = n.next();
                    if (c.done) return t;
                    t += c.value;
                }
                return t;
            } : e(_);
        };
    }, j7 = function(e) {
        return function(_) {
            return JG ? function(r) {
                return Array.from(r, _);
            } : e;
        };
    };
    var L0 = (e)=>{
        let _ = Vr(e);
        if (_ === 0) return D;
        if (_ === 1) return R("Just", {
            head: F0(Bs(0)(e)),
            tail: ""
        });
        let r = F0(Bs(1)(e)), t = F0(Bs(0)(e));
        return 55296 <= t && t <= 56319 && 56320 <= r && r <= 57343 ? R("Just", {
            head: (((t - 55296 | 0) * 1024 | 0) + (r - 56320 | 0) | 0) + 65536 | 0,
            tail: it(2)(e)
        }) : R("Just", {
            head: t,
            tail: it(1)(e)
        });
    }, WG = (e)=>{
        let _ = L0(e);
        return _.tag === "Just" ? R("Just", E(_._1.head, _._1.tail)) : D;
    }, HG = (e)=>Vs.unfoldr(WG)(e), jG = (e)=>{
        let _ = F0(Bs(0)(e));
        if (55296 <= _ && _ <= 56319 && Vr(e) > 1) {
            let r = F0(Bs(1)(e));
            return 56320 <= r && r <= 57343 ? (((_ - 55296 | 0) * 1024 | 0) + (r - 56320 | 0) | 0) + 65536 | 0 : _;
        }
        return _;
    }, Np = V7(jG), il = j7(HG)(Np);
    var Ap = (e)=>np((()=>e >= 0 && e <= 65535 ? cl(e) : e < 0 ? "\x00" : "￿")()), KG = (e)=>e <= 65535 ? Ap(e) : Ap(M0(e - 65536 | 0)(1024) + 55296 | 0) + Ap(wt(e - 65536 | 0)(1024) + 56320 | 0);
    var ll = W7(KG), K7 = (e)=>(_)=>{
            if (e < 1) return "";
            let r = L0(_);
            return r.tag === "Just" ? ll(r._1.head) + K7(e - 1 | 0)(r._1.tail) : _;
        }, z0 = H7(K7);
    var Fp = (e)=>(_)=>{
            let r = z0(e)(_);
            return {
                before: r,
                after: it(Vr(r))(_)
            };
        };
    var QG = (e)=>(_)=>{
            let r = e, t = _, n = !0, s;
            for(; n;){
                let c = r, d = L0(t);
                if (d.tag === "Just") {
                    if (c === 0) {
                        n = !1, s = R("Just", d._1.head);
                        continue;
                    }
                    r = c - 1 | 0, t = d._1.tail;
                    continue;
                }
                n = !1, s = D;
            }
            return s;
        }, Mp = (e)=>(_)=>e < 0 ? D : e === 0 ? _ === "" ? D : R("Just", Np(_)) : q7(QG)(f_)(D)(Np)(e)(_);
    var Pp = (e)=>(_)=>{
            if (_.tag === "Nothing") return T7;
            if (_.tag === "Just") return e(_._1);
            l();
        };
    var Q7 = (e)=>Pe(e);
    var $r = {
        gEncodeJson: (e)=>(_)=>na
    };
    var oo = {
        encodeJson: ie
    };
    var Lp = {
        encodeJson: ie
    }, Ar = {
        encodeJson: Q7
    };
    var zp = (e)=>({
            encodeJson: (()=>{
                let _ = te(e.encodeJson);
                return (r)=>_(r);
            })()
        });
    var Op = (e)=>({
            encodeJson: (()=>{
                let _ = te(e.encodeJson);
                return (r)=>_(r);
            })()
        });
    var z_ = (e)=>(_)=>(r)=>()=>({
                        gEncodeJson: (t)=>(n)=>{
                                let s = r.reflectSymbol(q), c = e.encodeJson(Vo(r.reflectSymbol(q))(t));
                                return qs((i)=>()=>(i[s] = c, i))(_.gEncodeJson(t)(q));
                            }
                    });
    var vl = {
        traverseWithIndex: (e)=>{
            let _ = vl.FunctorWithIndex0().mapWithIndex, r = vl.Traversable2().sequence(e);
            return (t)=>{
                let n = _(t);
                return (s)=>r(n(s));
            };
        },
        FunctorWithIndex0: ()=>pp,
        FoldableWithIndex1: ()=>ra,
        Traversable2: ()=>lt
    };
    var nC = (()=>lt.traverse(_n))();
    var sC = (()=>vl.traverseWithIndex(_n))();
    var Z7 = (e)=>(_)=>{
            if (Q_((t)=>!0, (t)=>!1, (t)=>!1, (t)=>!1, (t)=>!1, (t)=>!1, _)) return S("Right", D);
            let r = e(_);
            if (r.tag === "Left") return S("Left", r._1);
            if (r.tag === "Right") return S("Right", R("Just", r._1));
            l();
        };
    var _9 = (e)=>{
        let _ = Q_((r)=>D, (r)=>D, (r)=>D, (r)=>D, f_, (r)=>D, e);
        if (_.tag === "Nothing") return S("Left", H("TypeMismatch", "Array"));
        if (_.tag === "Just") return S("Right", _._1);
        l();
    };
    var Up = (e)=>{
        let _ = fe.bimap(nl("NonEmptyArray"))(re), r = nC(e);
        return (t)=>F_.bind(F_.bind(_9(t))((n)=>{
                let s = qr(n);
                if (s.tag === "Nothing") return S("Left", H("TypeMismatch", "NonEmptyArray"));
                if (s.tag === "Just") return S("Right", ne([
                    s._1.head
                ])(s._1.tail));
                l();
            }))((n)=>_(r(n)));
    };
    var Qn = (e)=>F_.bind(Q_((_)=>S("Left", H("TypeMismatch", "Number")), (_)=>S("Left", H("TypeMismatch", "Number")), I_, (_)=>S("Left", H("TypeMismatch", "Number")), (_)=>S("Left", H("TypeMismatch", "Number")), (_)=>S("Left", H("TypeMismatch", "Number")), e))((_)=>{
            let r = Zc(_);
            if (r.tag === "Nothing") return S("Left", H("TypeMismatch", "Integer"));
            if (r.tag === "Just") return S("Right", r._1);
            l();
        });
    var eu = (e)=>{
        let _ = fe.bimap(nl("Array"))(re), r = sC((t)=>{
            let n = fe.bimap(C7(t))(re);
            return (s)=>n(e(s));
        });
        return (t)=>F_.bind(_9(t))((n)=>_(r(n)));
    };
    var tr = {
        gDecodeJson: (e)=>(_)=>S("Right", {})
    };
    var So = (e)=>()=>({
                decodeJson: (_)=>{
                    let r = Q_((t)=>D, (t)=>D, (t)=>D, (t)=>D, (t)=>D, f_, _);
                    if (r.tag === "Just") return e.gDecodeJson(r._1)(q);
                    if (r.tag === "Nothing") return S("Left", H("TypeMismatch", "Object"));
                    l();
                }
            });
    var Re = (e)=>(_)=>(r)=>()=>()=>({
                            gDecodeJson: (t)=>(n)=>{
                                    let s = r.reflectSymbol(q), c = e.decodeJsonField(A0(D, f_, s, t));
                                    if (c.tag === "Just") return F_.bind(fe.bimap(Sp(s))(re)(c._1))((i)=>F_.bind(_.gDecodeJson(t)(q))((d)=>S("Right", Ur(r.reflectSymbol(q))(i)(d))));
                                    if (c.tag === "Nothing") return S("Left", H("AtKey", s, sa));
                                    l();
                                }
                        });
    var e9 = (e)=>({
            decodeJsonField: (_)=>{
                if (_.tag === "Nothing") return R("Just", S("Right", D));
                if (_.tag === "Just") return R("Just", Z7(e.decodeJson)(_._1));
                l();
            }
        });
    var Lt = {
        tagKey: "tag",
        valuesKey: "values",
        unwrapSingleArguments: !1
    };
    var o9 = (e)=>(_)=>(r)=>{
                let t = nl(r);
                return F_.bind((()=>{
                    let n = t(H("TypeMismatch", "Object")), s = Q_((c)=>D, (c)=>D, (c)=>D, (c)=>D, (c)=>D, f_, _);
                    if (s.tag === "Nothing") return S("Left", n);
                    if (s.tag === "Just") return S("Right", s._1);
                    l();
                })())((n)=>F_.bind((()=>{
                        let s = t(H("AtKey", e.tagKey, sa)), c = A0(D, f_, e.tagKey, n);
                        if (c.tag === "Nothing") return S("Left", s);
                        if (c.tag === "Just") return S("Right", c._1);
                        l();
                    })())((s)=>F_.bind((()=>{
                            let c = t(H("AtKey", e.tagKey, H("TypeMismatch", "String"))), i = Q_((d)=>D, (d)=>D, (d)=>D, f_, (d)=>D, (d)=>D, s);
                            if (i.tag === "Nothing") return S("Left", c);
                            if (i.tag === "Just") return S("Right", i._1);
                            l();
                        })())((c)=>F_.bind((()=>{
                                let i = S("Left", t(H("AtKey", e.tagKey, H("UnexpectedValue", c))));
                                return c !== r ? i : S("Right", void 0);
                            })())(()=>S("Right", {
                                    tag: c,
                                    decodingErr: t
                                })))));
            }, cC = (e)=>(_)=>(r)=>F_.bind(o9(e)(_)(r))((t)=>{
                    let n = t.decodingErr, s = t.tag;
                    return F_.bind((()=>{
                        let c = n(H("TypeMismatch", "Object")), i = Q_((d)=>D, (d)=>D, (d)=>D, (d)=>D, (d)=>D, f_, _);
                        if (i.tag === "Nothing") return S("Left", c);
                        if (i.tag === "Just") return S("Right", i._1);
                        l();
                    })())((c)=>F_.bind((()=>{
                            let i = n(H("AtKey", e.valuesKey, sa)), d = A0(D, f_, e.valuesKey, c);
                            if (d.tag === "Nothing") return S("Left", i);
                            if (d.tag === "Just") return S("Right", d._1);
                            l();
                        })())((i)=>S("Right", {
                                tag: s,
                                values: i,
                                decodingErr: n
                            })));
                });
    var O0 = (e)=>(_)=>(r)=>{
                let t = _.decodeRepWith(r);
                return (n)=>{
                    let s = t(n);
                    if (s.tag === "Left") return S("Left", s._1);
                    if (s.tag === "Right") return S("Right", e.to(s._1));
                    l();
                };
            };
    var Po = (e)=>(_)=>({
                decodeRepWith: (r)=>(t)=>{
                        let n = e.decodeRepWith(r)(t), s = (()=>{
                            if (n.tag === "Left") return S("Left", n._1);
                            if (n.tag === "Right") return S("Right", o("Inl", n._1));
                            l();
                        })(), c = _.decodeRepWith(r)(t), i = (()=>{
                            if (c.tag === "Left") return S("Left", c._1);
                            if (c.tag === "Right") return S("Right", o("Inr", c._1));
                            l();
                        })();
                        return s.tag === "Left" ? i : s;
                    }
            });
    var aC = {
        decodeRepArgs: (e)=>S("Right", {
                init: P,
                rest: e
            })
    }, iC = (e)=>({
            decodeRepArgs: (_)=>F_.bind((()=>{
                    let r = qr(_);
                    if (r.tag === "Nothing") return S("Left", H("TypeMismatch", "NonEmptyArray"));
                    if (r.tag === "Just") return S("Right", r._1);
                    l();
                })())((r)=>{
                    let t = e.decodeJson(r.head);
                    if (t.tag === "Left") return S("Left", t._1);
                    if (t.tag === "Right") return S("Right", {
                        init: t._1,
                        rest: r.tail
                    });
                    l();
                })
        });
    var r9 = (e)=>(_)=>(r)=>(t)=>F_.bind(fe.bimap(t)(re)(e.decodeRepArgs(r)))((n)=>{
                        let s = n.init;
                        return F_.bind((()=>{
                            let c = S("Left", t(H("AtKey", _.valuesKey, H("UnexpectedValue", n.rest))));
                            return Wn(G7.eq)(n.rest)([]) ? S("Right", void 0) : c;
                        })())(()=>S("Right", s));
                    });
    var bl = (e)=>(_)=>{
            let r = r9(iC(_));
            return {
                decodeRepWith: (t)=>(n)=>F_.bind(cC(t)(n)(e.reflectSymbol(q)))((s)=>t.unwrapSingleArguments ? r(t)([
                                s.values
                            ])(s.decodingErr) : F_.bind((()=>{
                                let c = s.decodingErr(H("AtKey", t.valuesKey, H("TypeMismatch", "Array"))), i = Q_((d)=>D, (d)=>D, (d)=>D, (d)=>D, f_, (d)=>D, s.values);
                                if (i.tag === "Nothing") return S("Left", c);
                                if (i.tag === "Just") return S("Right", i._1);
                                l();
                            })())((c)=>r(t)(c)(s.decodingErr)))
            };
        }, po = (e)=>({
            decodeRepWith: (_)=>(r)=>F_.bind(o9(_)(r)(e.reflectSymbol(q)))((t)=>r9(aC)(_)([])(t.decodingErr))
        });
    var U0 = (e)=>(_)=>{
            let r = _.encodeRepWith(Lt);
            return (t)=>r(e.from(t));
        };
    var fo = {
        encodeRepArgs: (e)=>[]
    };
    var Je = (e)=>(_)=>({
                encodeRepWith: (r)=>(t)=>{
                        let n = _.encodeRepArgs(t), s = (()=>r.unwrapSingleArguments ? n.length === 1 ? n[0] : n : n)();
                        return (()=>{
                            let c = r.tagKey, i = e.reflectSymbol(q);
                            return qs((d)=>()=>(d[c] = i, d))((()=>{
                                let d = r.valuesKey;
                                return qs((v)=>()=>(v[d] = s, v))(na);
                            })());
                        })();
                    }
            });
    var Io = (e)=>({
            tag: "Taff",
            _1: e
        }), lC = (e)=>e;
    var la = {
        mapAffError: lC
    }, nn = {
        bimap: (e)=>(_)=>(r)=>Io(fr(r._1)((t)=>so(fe.bimap(e)(_)(t))))
    };
    var ou = {
        Applicative0: ()=>ru,
        Bind1: ()=>Qo
    }, Qo = {
        bind: (e)=>(_)=>Io(fr(e._1)((r)=>{
                    if (r.tag === "Left") return so(S("Left", r._1));
                    if (r.tag === "Right") return _(r._1)._1;
                    l();
                })),
        Apply0: ()=>sn
    }, sn = {
        apply: (e)=>(_)=>Qo.bind(e)((r)=>Qo.bind(_)((t)=>ru.pure(r(t)))),
        Functor0: ()=>dC
    }, ru = {
        pure: (e)=>Io(so(S("Right", e))),
        Apply0: ()=>sn
    }, dC = {
        map: (e)=>(_)=>sn.apply(Io(so(S("Right", e))))(_)
    };
    var pl = (e)=>{
        let _ = e.mapAffError;
        return {
            liftEffect: (r)=>Io(Os(fe.bimap(_)(re))(Jv(he(r)))),
            Monad0: ()=>ou
        };
    }, Vp = (e)=>{
        let _ = e.mapAffError, r = pl(e);
        return {
            liftAff: (t)=>Io(Os(fe.bimap(_)(re))(Jv(t))),
            MonadEffect0: ()=>r
        };
    };
    var Ws = (e)=>{
        if (e.tag === "Left") return Io(so(S("Left", e._1)));
        if (e.tag === "Right") return Io(so(S("Right", e._1)));
        l();
    }, jr = (e)=>{
        let _ = Vp(e).liftAff;
        return (r)=>_(fr(he(r))(el(ol)));
    };
    var t9 = function(e) {
        return function(_) {
            return _.join(e);
        };
    };
    var V = {
        genericShowArgs: (e)=>[]
    };
    var U = (e)=>(_)=>({
                "genericShow'": (r)=>{
                    let t = _.reflectSymbol(q), n = e.genericShowArgs(r);
                    return n.length === 0 ? t : "(" + t9(" ")(ne([
                        t
                    ])(n)) + ")";
                }
            });
    var xo = (e, _)=>({
            tag: e,
            _1: _
        }), n9 = xo("CANCELLED"), s9 = xo("UNKNOWN"), c9 = xo("INVALID_ARGUMENT"), a9 = xo("DEADLINE_EXCEEDED"), i9 = xo("NOT_FOUND"), l9 = xo("ALREADY_EXISTS"), d9 = xo("PERMISSION_DENIED"), v9 = xo("RESOURCE_EXHAUSTED"), u9 = xo("FAILED_PRECONDITION"), g9 = xo("ABORTED"), b9 = xo("OUT_OF_RANGE"), p9 = xo("UNIMPLEMENTED"), f9 = xo("INTERNAL"), m9 = xo("UNAVAILABLE"), $9 = xo("DATA_LOSS"), h9 = xo("UNAUTHENTICATED");
    var y9 = (e)=>xo("DecodeDocError", e), vC = {
        to: (e)=>{
            if (e.tag === "Inl") return n9;
            if (e.tag === "Inr") {
                if (e._1.tag === "Inl") return s9;
                if (e._1.tag === "Inr") {
                    if (e._1._1.tag === "Inl") return c9;
                    if (e._1._1.tag === "Inr") {
                        if (e._1._1._1.tag === "Inl") return a9;
                        if (e._1._1._1.tag === "Inr") {
                            if (e._1._1._1._1.tag === "Inl") return i9;
                            if (e._1._1._1._1.tag === "Inr") {
                                if (e._1._1._1._1._1.tag === "Inl") return l9;
                                if (e._1._1._1._1._1.tag === "Inr") {
                                    if (e._1._1._1._1._1._1.tag === "Inl") return d9;
                                    if (e._1._1._1._1._1._1.tag === "Inr") {
                                        if (e._1._1._1._1._1._1._1.tag === "Inl") return v9;
                                        if (e._1._1._1._1._1._1._1.tag === "Inr") {
                                            if (e._1._1._1._1._1._1._1._1.tag === "Inl") return u9;
                                            if (e._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                if (e._1._1._1._1._1._1._1._1._1.tag === "Inl") return g9;
                                                if (e._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                    if (e._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return b9;
                                                    if (e._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                        if (e._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return p9;
                                                        if (e._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return f9;
                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return m9;
                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return $9;
                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return h9;
                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return xo("DecodeError", e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") return xo("DecodeDocError", e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                            l();
                                                                        }
                                                                        l();
                                                                    }
                                                                    l();
                                                                }
                                                                l();
                                                            }
                                                            l();
                                                        }
                                                        l();
                                                    }
                                                    l();
                                                }
                                                l();
                                            }
                                            l();
                                        }
                                        l();
                                    }
                                    l();
                                }
                                l();
                            }
                            l();
                        }
                        l();
                    }
                    l();
                }
                l();
            }
            l();
        },
        from: (e)=>{
            if (e.tag === "CANCELLED") return o("Inl", P);
            if (e.tag === "UNKNOWN") return o("Inr", o("Inl", P));
            if (e.tag === "INVALID_ARGUMENT") return o("Inr", o("Inr", o("Inl", P)));
            if (e.tag === "DEADLINE_EXCEEDED") return o("Inr", o("Inr", o("Inr", o("Inl", P))));
            if (e.tag === "NOT_FOUND") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))));
            if (e.tag === "ALREADY_EXISTS") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))));
            if (e.tag === "PERMISSION_DENIED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))));
            if (e.tag === "RESOURCE_EXHAUSTED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))));
            if (e.tag === "FAILED_PRECONDITION") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))));
            if (e.tag === "ABORTED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))));
            if (e.tag === "OUT_OF_RANGE") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))));
            if (e.tag === "UNIMPLEMENTED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))));
            if (e.tag === "INTERNAL") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))));
            if (e.tag === "UNAVAILABLE") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))));
            if (e.tag === "DATA_LOSS") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))));
            if (e.tag === "UNAUTHENTICATED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))));
            if (e.tag === "DecodeError") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", e._1)))))))))))))))));
            if (e.tag === "DecodeDocError") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", e._1)))))))))))))))));
            l();
        }
    }, Hs = {
        show: (()=>{
            let e = U(V)({
                reflectSymbol: ()=>"CANCELLED"
            }), _ = U(V)({
                reflectSymbol: ()=>"UNKNOWN"
            }), r = U(V)({
                reflectSymbol: ()=>"INVALID_ARGUMENT"
            }), t = U(V)({
                reflectSymbol: ()=>"DEADLINE_EXCEEDED"
            }), n = U(V)({
                reflectSymbol: ()=>"NOT_FOUND"
            }), s = U(V)({
                reflectSymbol: ()=>"ALREADY_EXISTS"
            }), c = U(V)({
                reflectSymbol: ()=>"PERMISSION_DENIED"
            }), i = U(V)({
                reflectSymbol: ()=>"RESOURCE_EXHAUSTED"
            }), d = U(V)({
                reflectSymbol: ()=>"FAILED_PRECONDITION"
            }), v = U(V)({
                reflectSymbol: ()=>"ABORTED"
            }), b = U(V)({
                reflectSymbol: ()=>"OUT_OF_RANGE"
            }), p = U(V)({
                reflectSymbol: ()=>"UNIMPLEMENTED"
            }), u = U(V)({
                reflectSymbol: ()=>"INTERNAL"
            }), m = U(V)({
                reflectSymbol: ()=>"UNAVAILABLE"
            }), z = U(V)({
                reflectSymbol: ()=>"DATA_LOSS"
            }), L = U(V)({
                reflectSymbol: ()=>"UNAUTHENTICATED"
            }), J = U({
                genericShowArgs: (t_)=>[
                        ge.show(t_)
                    ]
            })({
                reflectSymbol: ()=>"DecodeError"
            }), c_ = U({
                genericShowArgs: (t_)=>[
                        ge.show(t_)
                    ]
            })({
                reflectSymbol: ()=>"DecodeDocError"
            });
            return (t_)=>{
                let W = vC.from(t_);
                if (W.tag === "Inl") return e["genericShow'"](W._1);
                if (W.tag === "Inr") {
                    if (W._1.tag === "Inl") return _["genericShow'"](W._1._1);
                    if (W._1.tag === "Inr") {
                        if (W._1._1.tag === "Inl") return r["genericShow'"](W._1._1._1);
                        if (W._1._1.tag === "Inr") {
                            if (W._1._1._1.tag === "Inl") return t["genericShow'"](W._1._1._1._1);
                            if (W._1._1._1.tag === "Inr") {
                                if (W._1._1._1._1.tag === "Inl") return n["genericShow'"](W._1._1._1._1._1);
                                if (W._1._1._1._1.tag === "Inr") {
                                    if (W._1._1._1._1._1.tag === "Inl") return s["genericShow'"](W._1._1._1._1._1._1);
                                    if (W._1._1._1._1._1.tag === "Inr") {
                                        if (W._1._1._1._1._1._1.tag === "Inl") return c["genericShow'"](W._1._1._1._1._1._1._1);
                                        if (W._1._1._1._1._1._1.tag === "Inr") {
                                            if (W._1._1._1._1._1._1._1.tag === "Inl") return i["genericShow'"](W._1._1._1._1._1._1._1._1);
                                            if (W._1._1._1._1._1._1._1.tag === "Inr") {
                                                if (W._1._1._1._1._1._1._1._1.tag === "Inl") return d["genericShow'"](W._1._1._1._1._1._1._1._1._1);
                                                if (W._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                    if (W._1._1._1._1._1._1._1._1._1.tag === "Inl") return v["genericShow'"](W._1._1._1._1._1._1._1._1._1._1);
                                                    if (W._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                        if (W._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return b["genericShow'"](W._1._1._1._1._1._1._1._1._1._1._1);
                                                        if (W._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                            if (W._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return p["genericShow'"](W._1._1._1._1._1._1._1._1._1._1._1._1);
                                                            if (W._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                if (W._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return u["genericShow'"](W._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                if (W._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                    if (W._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return m["genericShow'"](W._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                    if (W._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                        if (W._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return z["genericShow'"](W._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                        if (W._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                            if (W._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return L["genericShow'"](W._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                            if (W._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                if (W._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return J["genericShow'"](W._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                if (W._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") return c_["genericShow'"](W._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                l();
                                                                            }
                                                                            l();
                                                                        }
                                                                        l();
                                                                    }
                                                                    l();
                                                                }
                                                                l();
                                                            }
                                                            l();
                                                        }
                                                        l();
                                                    }
                                                    l();
                                                }
                                                l();
                                            }
                                            l();
                                        }
                                        l();
                                    }
                                    l();
                                }
                                l();
                            }
                            l();
                        }
                        l();
                    }
                    l();
                }
                l();
            };
        })()
    }, uC = {
        decodeJson: (e)=>F_.bind(Q_((_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), I_, (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), e))((_)=>S("Right", (()=>_ === "cancelled" ? n9 : _ === "unknown" ? s9 : _ === "invalid-argument" ? c9 : _ === "deadline-exceeded" ? a9 : _ === "not-found" ? i9 : _ === "already-exists" ? l9 : _ === "permission-denied" ? d9 : _ === "resource-exhausted" ? v9 : _ === "failed-precondition" ? u9 : _ === "aborted" ? g9 : _ === "out-of-range" ? b9 : _ === "unimplemented" ? p9 : _ === "internal" ? f9 : _ === "unavailable" ? m9 : _ === "data-loss" ? $9 : _ === "unauthenticated" ? h9 : xo("DecodeError", H("UnexpectedValue", e)))()))
    }, gC = (e)=>{
        let _ = uC.decodeJson(e);
        if (_.tag === "Left") return xo("DecodeError", _._1);
        if (_.tag === "Right") return _._1;
        l();
    }, qp = {
        mapAffError: (e)=>gC(No(e))
    };
    var w9 = function(e) {
        let _ = [], r = 0;
        for(let t = 0; t < e.length; t++){
            let n = e.charCodeAt(t);
            n < 128 ? _[r++] = n : n < 2048 ? (_[r++] = n >> 6 | 192, _[r++] = n & 63 | 128) : (n & 64512) === 55296 && t + 1 < e.length && (e.charCodeAt(t + 1) & 64512) === 56320 ? (n = 65536 + ((n & 1023) << 10) + (e.charCodeAt(++t) & 1023), _[r++] = n >> 18 | 240, _[r++] = n >> 12 & 63 | 128, _[r++] = n >> 6 & 63 | 128, _[r++] = n & 63 | 128) : (_[r++] = n >> 12 | 224, _[r++] = n >> 6 & 63 | 128, _[r++] = n & 63 | 128);
        }
        return _;
    }, bC = function(e) {
        let _ = [], r = 0, t = 0;
        for(; r < e.length;){
            let n = e[r++];
            if (n < 128) _[t++] = String.fromCharCode(n);
            else if (n > 191 && n < 224) {
                let s = e[r++];
                _[t++] = String.fromCharCode((n & 31) << 6 | s & 63);
            } else if (n > 239 && n < 365) {
                let s = e[r++], c = e[r++], i = e[r++], d = ((n & 7) << 18 | (s & 63) << 12 | (c & 63) << 6 | i & 63) - 65536;
                _[t++] = String.fromCharCode(55296 + (d >> 10)), _[t++] = String.fromCharCode(56320 + (d & 1023));
            } else {
                let s = e[r++], c = e[r++];
                _[t++] = String.fromCharCode((n & 15) << 12 | (s & 63) << 6 | c & 63);
            }
        }
        return _.join("");
    }, R9 = {
        byteToCharMap_: null,
        charToByteMap_: null,
        byteToCharMapWebSafe_: null,
        charToByteMapWebSafe_: null,
        ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
        get ENCODED_VALS () {
            return this.ENCODED_VALS_BASE + "+/=";
        },
        get ENCODED_VALS_WEBSAFE () {
            return this.ENCODED_VALS_BASE + "-_.";
        },
        HAS_NATIVE_SUPPORT: typeof atob == "function",
        encodeByteArray (e, _) {
            if (!Array.isArray(e)) throw Error("encodeByteArray takes an array as a parameter");
            this.init_();
            let r = _ ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, t = [];
            for(let n = 0; n < e.length; n += 3){
                let s = e[n], c = n + 1 < e.length, i = c ? e[n + 1] : 0, d = n + 2 < e.length, v = d ? e[n + 2] : 0, b = s >> 2, p = (s & 3) << 4 | i >> 4, u = (i & 15) << 2 | v >> 6, m = v & 63;
                d || (m = 64, c || (u = 64)), t.push(r[b], r[p], r[u], r[m]);
            }
            return t.join("");
        },
        encodeString (e, _) {
            return this.HAS_NATIVE_SUPPORT && !_ ? btoa(e) : this.encodeByteArray(w9(e), _);
        },
        decodeString (e, _) {
            return this.HAS_NATIVE_SUPPORT && !_ ? atob(e) : bC(this.decodeStringToByteArray(e, _));
        },
        decodeStringToByteArray (e, _) {
            this.init_();
            let r = _ ? this.charToByteMapWebSafe_ : this.charToByteMap_, t = [];
            for(let n = 0; n < e.length;){
                let s = r[e.charAt(n++)], i = n < e.length ? r[e.charAt(n)] : 0;
                ++n;
                let v = n < e.length ? r[e.charAt(n)] : 64;
                ++n;
                let p = n < e.length ? r[e.charAt(n)] : 64;
                if (++n, s == null || i == null || v == null || p == null) throw new jp;
                let u = s << 2 | i >> 4;
                if (t.push(u), v !== 64) {
                    let m = i << 4 & 240 | v >> 2;
                    if (t.push(m), p !== 64) {
                        let z = v << 6 & 192 | p;
                        t.push(z);
                    }
                }
            }
            return t;
        },
        init_ () {
            if (!this.byteToCharMap_) {
                this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
                for(let e = 0; e < this.ENCODED_VALS.length; e++)this.byteToCharMap_[e] = this.ENCODED_VALS.charAt(e), this.charToByteMap_[this.byteToCharMap_[e]] = e, this.byteToCharMapWebSafe_[e] = this.ENCODED_VALS_WEBSAFE.charAt(e), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[e]] = e, e >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(e)] = e, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(e)] = e);
            }
        }
    }, jp = class extends Error {
        constructor(){
            super(...arguments), this.name = "DecodeBase64StringError";
        }
    }, pC = function(e) {
        let _ = w9(e);
        return R9.encodeByteArray(_, !0);
    }, fl = function(e) {
        return pC(e).replace(/\./g, "");
    }, Qp = function(e) {
        try {
            return R9.decodeString(e, !0);
        } catch (_) {
            console.error("base64Decode failed: ", _);
        }
        return null;
    };
    function fC() {
        if (typeof self < "u") return self;
        if (typeof window < "u") return window;
        if (typeof $parcel$global < "u") return $parcel$global;
        throw new Error("Unable to locate global object.");
    }
    var mC = ()=>fC().__FIREBASE_DEFAULTS__, $C = ()=>{
        if (typeof $cfae44f0dfdf62c0$exports > "u" || typeof $cfae44f0dfdf62c0$exports.env > "u") return;
        let e = undefined;
        if (e) return JSON.parse(e);
    }, hC = ()=>{
        if (typeof document > "u") return;
        let e;
        try {
            e = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
        } catch  {
            return;
        }
        let _ = e && Qp(e[1]);
        return _ && JSON.parse(_);
    }, nu = ()=>{
        try {
            return mC() || $C() || hC();
        } catch (e) {
            console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
            return;
        }
    }, Yp = (e)=>{
        var _, r;
        return (r = (_ = nu()) === null || _ === void 0 ? void 0 : _.emulatorHosts) === null || r === void 0 ? void 0 : r[e];
    }, su = (e)=>{
        let _ = Yp(e);
        if (!_) return;
        let r = _.lastIndexOf(":");
        if (r <= 0 || r + 1 === _.length) throw new Error(`Invalid host ${_} with no separate hostname and port!`);
        let t = parseInt(_.substring(r + 1), 10);
        return _[0] === "[" ? [
            _.substring(1, r - 1),
            t
        ] : [
            _.substring(0, r),
            t
        ];
    }, Xp = ()=>{
        var e;
        return (e = nu()) === null || e === void 0 ? void 0 : e.config;
    }, Zp = (e)=>{
        var _;
        return (_ = nu()) === null || _ === void 0 ? void 0 : _[`_${e}`];
    };
    var tu = class {
        constructor(){
            this.reject = ()=>{}, this.resolve = ()=>{}, this.promise = new Promise((_, r)=>{
                this.resolve = _, this.reject = r;
            });
        }
        wrapCallback(_) {
            return (r, t)=>{
                r ? this.reject(r) : this.resolve(t), typeof _ == "function" && (this.promise.catch(()=>{}), _.length === 1 ? _(r) : _(r, t));
            };
        }
    };
    function k9(e, _) {
        if (e.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
        let r = {
            alg: "none",
            type: "JWT"
        }, t = _ || "demo-project", n = e.iat || 0, s = e.sub || e.user_id;
        if (!s) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
        let c = Object.assign({
            iss: `https://securetoken.google.com/${t}`,
            aud: t,
            iat: n,
            exp: n + 3600,
            auth_time: n,
            sub: s,
            user_id: s,
            firebase: {
                sign_in_provider: "custom",
                identities: {}
            }
        }, e), i = "";
        return [
            fl(JSON.stringify(r)),
            fl(JSON.stringify(c)),
            i
        ].join(".");
    }
    function Wo() {
        return typeof navigator < "u" && typeof navigator.userAgent == "string" ? navigator.userAgent : "";
    }
    function S9() {
        return typeof window < "u" && !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(Wo());
    }
    function yC() {
        var e;
        let _ = (e = nu()) === null || e === void 0 ? void 0 : e.forceEnvironment;
        if (_ === "node") return !0;
        if (_ === "browser") return !1;
        try {
            return Object.prototype.toString.call($parcel$global.process) === "[object process]";
        } catch  {
            return !1;
        }
    }
    function I9() {
        let e = typeof chrome == "object" ? chrome.runtime : typeof browser == "object" ? browser.runtime : void 0;
        return typeof e == "object" && e.id !== void 0;
    }
    function x9() {
        return typeof navigator == "object" && navigator.product === "ReactNative";
    }
    function E9() {
        let e = Wo();
        return e.indexOf("MSIE ") >= 0 || e.indexOf("Trident/") >= 0;
    }
    function T9() {
        return !yC() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
    }
    function _5() {
        try {
            return typeof indexedDB == "object";
        } catch  {
            return !1;
        }
    }
    function G9() {
        return new Promise((e, _)=>{
            try {
                let r = !0, t = "validate-browser-context-for-indexeddb-analytics-module", n = self.indexedDB.open(t);
                n.onsuccess = ()=>{
                    n.result.close(), r || self.indexedDB.deleteDatabase(t), e(!0);
                }, n.onupgradeneeded = ()=>{
                    r = !1;
                }, n.onerror = ()=>{
                    var s;
                    _(((s = n.error) === null || s === void 0 ? void 0 : s.message) || "");
                };
            } catch (r) {
                _(r);
            }
        });
    }
    var DC = "FirebaseError", Nr = class e extends Error {
        constructor(_, r, t){
            super(r), this.code = _, this.customData = t, this.name = DC, Object.setPrototypeOf(this, e.prototype), Error.captureStackTrace && Error.captureStackTrace(this, Yn.prototype.create);
        }
    }, Yn = class {
        constructor(_, r, t){
            this.service = _, this.serviceName = r, this.errors = t;
        }
        create(_, ...r) {
            let t = r[0] || {}, n = `${this.service}/${_}`, s = this.errors[_], c = s ? wC(s, t) : "Error", i = `${this.serviceName}: ${c} (${n}).`;
            return new Nr(n, i, t);
        }
    };
    function wC(e, _) {
        return e.replace(RC, (r, t)=>{
            let n = _[t];
            return n != null ? String(n) : `<${t}?>`;
        });
    }
    var RC = /\{\$([^}]+)}/g;
    function C9(e) {
        for(let _ in e)if (Object.prototype.hasOwnProperty.call(e, _)) return !1;
        return !0;
    }
    function js(e, _) {
        if (e === _) return !0;
        let r = Object.keys(e), t = Object.keys(_);
        for (let n of r){
            if (!t.includes(n)) return !1;
            let s = e[n], c = _[n];
            if (D9(s) && D9(c)) {
                if (!js(s, c)) return !1;
            } else if (s !== c) return !1;
        }
        for (let n of t)if (!r.includes(n)) return !1;
        return !0;
    }
    function D9(e) {
        return e !== null && typeof e == "object";
    }
    function da(e) {
        let _ = [];
        for (let [r, t] of Object.entries(e))Array.isArray(t) ? t.forEach((n)=>{
            _.push(encodeURIComponent(r) + "=" + encodeURIComponent(n));
        }) : _.push(encodeURIComponent(r) + "=" + encodeURIComponent(t));
        return _.length ? "&" + _.join("&") : "";
    }
    function va(e) {
        let _ = {};
        return e.replace(/^\?/, "").split("&").forEach((t)=>{
            if (t) {
                let [n, s] = t.split("=");
                _[decodeURIComponent(n)] = decodeURIComponent(s);
            }
        }), _;
    }
    function ua(e) {
        let _ = e.indexOf("?");
        if (!_) return "";
        let r = e.indexOf("#", _);
        return e.substring(_, r > 0 ? r : void 0);
    }
    function A9(e, _) {
        let r = new Kp(e, _);
        return r.subscribe.bind(r);
    }
    var Kp = class {
        constructor(_, r){
            this.observers = [], this.unsubscribes = [], this.observerCount = 0, this.task = Promise.resolve(), this.finalized = !1, this.onNoObservers = r, this.task.then(()=>{
                _(this);
            }).catch((t)=>{
                this.error(t);
            });
        }
        next(_) {
            this.forEachObserver((r)=>{
                r.next(_);
            });
        }
        error(_) {
            this.forEachObserver((r)=>{
                r.error(_);
            }), this.close(_);
        }
        complete() {
            this.forEachObserver((_)=>{
                _.complete();
            }), this.close();
        }
        subscribe(_, r, t) {
            let n;
            if (_ === void 0 && r === void 0 && t === void 0) throw new Error("Missing Observer.");
            kC(_, [
                "next",
                "error",
                "complete"
            ]) ? n = _ : n = {
                next: _,
                error: r,
                complete: t
            }, n.next === void 0 && (n.next = Hp), n.error === void 0 && (n.error = Hp), n.complete === void 0 && (n.complete = Hp);
            let s = this.unsubscribeOne.bind(this, this.observers.length);
            return this.finalized && this.task.then(()=>{
                try {
                    this.finalError ? n.error(this.finalError) : n.complete();
                } catch  {}
            }), this.observers.push(n), s;
        }
        unsubscribeOne(_) {
            this.observers === void 0 || this.observers[_] === void 0 || (delete this.observers[_], this.observerCount -= 1, this.observerCount === 0 && this.onNoObservers !== void 0 && this.onNoObservers(this));
        }
        forEachObserver(_) {
            if (!this.finalized) for(let r = 0; r < this.observers.length; r++)this.sendOne(r, _);
        }
        sendOne(_, r) {
            this.task.then(()=>{
                if (this.observers !== void 0 && this.observers[_] !== void 0) try {
                    r(this.observers[_]);
                } catch (t) {
                    typeof console < "u" && console.error && console.error(t);
                }
            });
        }
        close(_) {
            this.finalized || (this.finalized = !0, _ !== void 0 && (this.finalError = _), this.task.then(()=>{
                this.observers = void 0, this.onNoObservers = void 0;
            }));
        }
    };
    function kC(e, _) {
        if (typeof e != "object" || e === null) return !1;
        for (let r of _)if (r in e && typeof e[r] == "function") return !0;
        return !1;
    }
    function Hp() {}
    var KX = 14400000;
    function mo(e) {
        return e && e._delegate ? e._delegate : e;
    }
    var Kr = class {
        constructor(_, r, t){
            this.name = _, this.instanceFactory = r, this.type = t, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
        }
        setInstantiationMode(_) {
            return this.instantiationMode = _, this;
        }
        setMultipleInstances(_) {
            return this.multipleInstances = _, this;
        }
        setServiceProps(_) {
            return this.serviceProps = _, this;
        }
        setInstanceCreatedCallback(_) {
            return this.onInstanceCreated = _, this;
        }
    };
    var Ks = "[DEFAULT]";
    var e5 = class {
        constructor(_, r){
            this.name = _, this.container = r, this.component = null, this.instances = new Map, this.instancesDeferred = new Map, this.instancesOptions = new Map, this.onInitCallbacks = new Map;
        }
        get(_) {
            let r = this.normalizeInstanceIdentifier(_);
            if (!this.instancesDeferred.has(r)) {
                let t = new tu;
                if (this.instancesDeferred.set(r, t), this.isInitialized(r) || this.shouldAutoInitialize()) try {
                    let n = this.getOrInitializeService({
                        instanceIdentifier: r
                    });
                    n && t.resolve(n);
                } catch  {}
            }
            return this.instancesDeferred.get(r).promise;
        }
        getImmediate(_) {
            var r;
            let t = this.normalizeInstanceIdentifier(_?.identifier), n = (r = _?.optional) !== null && r !== void 0 ? r : !1;
            if (this.isInitialized(t) || this.shouldAutoInitialize()) try {
                return this.getOrInitializeService({
                    instanceIdentifier: t
                });
            } catch (s) {
                if (n) return null;
                throw s;
            }
            else {
                if (n) return null;
                throw Error(`Service ${this.name} is not available`);
            }
        }
        getComponent() {
            return this.component;
        }
        setComponent(_) {
            if (_.name !== this.name) throw Error(`Mismatching Component ${_.name} for Provider ${this.name}.`);
            if (this.component) throw Error(`Component for ${this.name} has already been provided`);
            if (this.component = _, !!this.shouldAutoInitialize()) {
                if (IC(_)) try {
                    this.getOrInitializeService({
                        instanceIdentifier: Ks
                    });
                } catch  {}
                for (let [r, t] of this.instancesDeferred.entries()){
                    let n = this.normalizeInstanceIdentifier(r);
                    try {
                        let s = this.getOrInitializeService({
                            instanceIdentifier: n
                        });
                        t.resolve(s);
                    } catch  {}
                }
            }
        }
        clearInstance(_ = Ks) {
            this.instancesDeferred.delete(_), this.instancesOptions.delete(_), this.instances.delete(_);
        }
        async delete() {
            let _ = Array.from(this.instances.values());
            await Promise.all([
                ..._.filter((r)=>"INTERNAL" in r).map((r)=>r.INTERNAL.delete()),
                ..._.filter((r)=>"_delete" in r).map((r)=>r._delete())
            ]);
        }
        isComponentSet() {
            return this.component != null;
        }
        isInitialized(_ = Ks) {
            return this.instances.has(_);
        }
        getOptions(_ = Ks) {
            return this.instancesOptions.get(_) || {};
        }
        initialize(_ = {}) {
            let { options: r = {}  } = _, t = this.normalizeInstanceIdentifier(_.instanceIdentifier);
            if (this.isInitialized(t)) throw Error(`${this.name}(${t}) has already been initialized`);
            if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
            let n = this.getOrInitializeService({
                instanceIdentifier: t,
                options: r
            });
            for (let [s, c] of this.instancesDeferred.entries()){
                let i = this.normalizeInstanceIdentifier(s);
                t === i && c.resolve(n);
            }
            return n;
        }
        onInit(_, r) {
            var t;
            let n = this.normalizeInstanceIdentifier(r), s = (t = this.onInitCallbacks.get(n)) !== null && t !== void 0 ? t : new Set;
            s.add(_), this.onInitCallbacks.set(n, s);
            let c = this.instances.get(n);
            return c && _(c, n), ()=>{
                s.delete(_);
            };
        }
        invokeOnInitCallbacks(_, r) {
            let t = this.onInitCallbacks.get(r);
            if (t) for (let n of t)try {
                n(_, r);
            } catch  {}
        }
        getOrInitializeService({ instanceIdentifier: _ , options: r = {}  }) {
            let t = this.instances.get(_);
            if (!t && this.component && (t = this.component.instanceFactory(this.container, {
                instanceIdentifier: SC(_),
                options: r
            }), this.instances.set(_, t), this.instancesOptions.set(_, r), this.invokeOnInitCallbacks(t, _), this.component.onInstanceCreated)) try {
                this.component.onInstanceCreated(this.container, _, t);
            } catch  {}
            return t || null;
        }
        normalizeInstanceIdentifier(_ = Ks) {
            return this.component ? this.component.multipleInstances ? _ : Ks : _;
        }
        shouldAutoInitialize() {
            return !!this.component && this.component.instantiationMode !== "EXPLICIT";
        }
    };
    function SC(e) {
        return e === Ks ? void 0 : e;
    }
    function IC(e) {
        return e.instantiationMode === "EAGER";
    }
    var cu = class {
        constructor(_){
            this.name = _, this.providers = new Map;
        }
        addComponent(_) {
            let r = this.getProvider(_.name);
            if (r.isComponentSet()) throw new Error(`Component ${_.name} has already been registered with ${this.name}`);
            r.setComponent(_);
        }
        addOrOverwriteComponent(_) {
            this.getProvider(_.name).isComponentSet() && this.providers.delete(_.name), this.addComponent(_);
        }
        getProvider(_) {
            if (this.providers.has(_)) return this.providers.get(_);
            let r = new e5(_, this);
            return this.providers.set(_, r), r;
        }
        getProviders() {
            return Array.from(this.providers.values());
        }
    };
    var xC = [], ye;
    (function(e) {
        e[e.DEBUG = 0] = "DEBUG", e[e.VERBOSE = 1] = "VERBOSE", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.ERROR = 4] = "ERROR", e[e.SILENT = 5] = "SILENT";
    })(ye || (ye = {}));
    var EC = {
        debug: ye.DEBUG,
        verbose: ye.VERBOSE,
        info: ye.INFO,
        warn: ye.WARN,
        error: ye.ERROR,
        silent: ye.SILENT
    }, TC = ye.INFO, GC = {
        [ye.DEBUG]: "log",
        [ye.VERBOSE]: "log",
        [ye.INFO]: "info",
        [ye.WARN]: "warn",
        [ye.ERROR]: "error"
    }, CC = (e, _, ...r)=>{
        if (_ < e.logLevel) return;
        let t = new Date().toISOString(), n = GC[_];
        if (n) console[n](`[${t}]  ${e.name}:`, ...r);
        else throw new Error(`Attempted to log a message with an invalid logType (value: ${_})`);
    }, J0 = class {
        constructor(_){
            this.name = _, this._logLevel = TC, this._logHandler = CC, this._userLogHandler = null, xC.push(this);
        }
        get logLevel() {
            return this._logLevel;
        }
        set logLevel(_) {
            if (!(_ in ye)) throw new TypeError(`Invalid value "${_}" assigned to \`logLevel\``);
            this._logLevel = _;
        }
        setLogLevel(_) {
            this._logLevel = typeof _ == "string" ? EC[_] : _;
        }
        get logHandler() {
            return this._logHandler;
        }
        set logHandler(_) {
            if (typeof _ != "function") throw new TypeError("Value assigned to `logHandler` must be a function");
            this._logHandler = _;
        }
        get userLogHandler() {
            return this._userLogHandler;
        }
        set userLogHandler(_) {
            this._userLogHandler = _;
        }
        debug(..._) {
            this._userLogHandler && this._userLogHandler(this, ye.DEBUG, ..._), this._logHandler(this, ye.DEBUG, ..._);
        }
        log(..._) {
            this._userLogHandler && this._userLogHandler(this, ye.VERBOSE, ..._), this._logHandler(this, ye.VERBOSE, ..._);
        }
        info(..._) {
            this._userLogHandler && this._userLogHandler(this, ye.INFO, ..._), this._logHandler(this, ye.INFO, ..._);
        }
        warn(..._) {
            this._userLogHandler && this._userLogHandler(this, ye.WARN, ..._), this._logHandler(this, ye.WARN, ..._);
        }
        error(..._) {
            this._userLogHandler && this._userLogHandler(this, ye.ERROR, ..._), this._logHandler(this, ye.ERROR, ..._);
        }
    };
    var AC = (e, _)=>_.some((r)=>e instanceof r), N9, F9;
    function NC() {
        return N9 || (N9 = [
            IDBDatabase,
            IDBObjectStore,
            IDBIndex,
            IDBCursor,
            IDBTransaction
        ]);
    }
    function FC() {
        return F9 || (F9 = [
            IDBCursor.prototype.advance,
            IDBCursor.prototype.continue,
            IDBCursor.prototype.continuePrimaryKey
        ]);
    }
    var M9 = new WeakMap, r5 = new WeakMap, P9 = new WeakMap, o5 = new WeakMap, n5 = new WeakMap;
    function MC(e) {
        let _ = new Promise((r, t)=>{
            let n = ()=>{
                e.removeEventListener("success", s), e.removeEventListener("error", c);
            }, s = ()=>{
                r(cn(e.result)), n();
            }, c = ()=>{
                t(e.error), n();
            };
            e.addEventListener("success", s), e.addEventListener("error", c);
        });
        return _.then((r)=>{
            r instanceof IDBCursor && M9.set(r, e);
        }).catch(()=>{}), n5.set(_, e), _;
    }
    function PC(e) {
        if (r5.has(e)) return;
        let _ = new Promise((r, t)=>{
            let n = ()=>{
                e.removeEventListener("complete", s), e.removeEventListener("error", c), e.removeEventListener("abort", c);
            }, s = ()=>{
                r(), n();
            }, c = ()=>{
                t(e.error || new DOMException("AbortError", "AbortError")), n();
            };
            e.addEventListener("complete", s), e.addEventListener("error", c), e.addEventListener("abort", c);
        });
        r5.set(e, _);
    }
    var t5 = {
        get (e, _, r) {
            if (e instanceof IDBTransaction) {
                if (_ === "done") return r5.get(e);
                if (_ === "objectStoreNames") return e.objectStoreNames || P9.get(e);
                if (_ === "store") return r.objectStoreNames[1] ? void 0 : r.objectStore(r.objectStoreNames[0]);
            }
            return cn(e[_]);
        },
        set (e, _, r) {
            return e[_] = r, !0;
        },
        has (e, _) {
            return e instanceof IDBTransaction && (_ === "done" || _ === "store") ? !0 : _ in e;
        }
    };
    function L9(e) {
        t5 = e(t5);
    }
    function LC(e) {
        return e === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(_, ...r) {
            let t = e.call(au(this), _, ...r);
            return P9.set(t, _.sort ? _.sort() : [
                _
            ]), cn(t);
        } : FC().includes(e) ? function(..._) {
            return e.apply(au(this), _), cn(M9.get(this));
        } : function(..._) {
            return cn(e.apply(au(this), _));
        };
    }
    function zC(e) {
        return typeof e == "function" ? LC(e) : (e instanceof IDBTransaction && PC(e), AC(e, NC()) ? new Proxy(e, t5) : e);
    }
    function cn(e) {
        if (e instanceof IDBRequest) return MC(e);
        if (o5.has(e)) return o5.get(e);
        let _ = zC(e);
        return _ !== e && (o5.set(e, _), n5.set(_, e)), _;
    }
    var au = (e)=>n5.get(e);
    function O9(e, _, { blocked: r , upgrade: t , blocking: n , terminated: s  } = {}) {
        let c = indexedDB.open(e, _), i = cn(c);
        return t && c.addEventListener("upgradeneeded", (d)=>{
            t(cn(c.result), d.oldVersion, d.newVersion, cn(c.transaction), d);
        }), r && c.addEventListener("blocked", (d)=>r(d.oldVersion, d.newVersion, d)), i.then((d)=>{
            s && d.addEventListener("close", ()=>s()), n && d.addEventListener("versionchange", (v)=>n(v.oldVersion, v.newVersion, v));
        }).catch(()=>{}), i;
    }
    var OC = [
        "get",
        "getKey",
        "getAll",
        "getAllKeys",
        "count"
    ], UC = [
        "put",
        "add",
        "delete",
        "clear"
    ], s5 = new Map;
    function z9(e, _) {
        if (!(e instanceof IDBDatabase && !(_ in e) && typeof _ == "string")) return;
        if (s5.get(_)) return s5.get(_);
        let r = _.replace(/FromIndex$/, ""), t = _ !== r, n = UC.includes(r);
        if (!(r in (t ? IDBIndex : IDBObjectStore).prototype) || !(n || OC.includes(r))) return;
        let s = async function(c, ...i) {
            let d = this.transaction(c, n ? "readwrite" : "readonly"), v = d.store;
            return t && (v = v.index(i.shift())), (await Promise.all([
                v[r](...i),
                n && d.done
            ]))[0];
        };
        return s5.set(_, s), s;
    }
    L9((e)=>({
            ...e,
            get: (_, r, t)=>z9(_, r) || e.get(_, r, t),
            has: (_, r)=>!!z9(_, r) || e.has(_, r)
        }));
    var a5 = class {
        constructor(_){
            this.container = _;
        }
        getPlatformInfoString() {
            return this.container.getProviders().map((r)=>{
                if (BC(r)) {
                    let t = r.getImmediate();
                    return `${t.library}/${t.version}`;
                } else return null;
            }).filter((r)=>r).join(" ");
        }
    };
    function BC(e) {
        let _ = e.getComponent();
        return _?.type === "VERSION";
    }
    var i5 = "@firebase/app", U9 = "0.10.6";
    var Qs = new J0("@firebase/app"), JC = "@firebase/app-compat", VC = "@firebase/analytics-compat", qC = "@firebase/analytics", WC = "@firebase/app-check-compat", HC = "@firebase/app-check", jC = "@firebase/auth", KC = "@firebase/auth-compat", QC = "@firebase/database", YC = "@firebase/database-compat", XC = "@firebase/functions", ZC = "@firebase/functions-compat", _A = "@firebase/installations", eA = "@firebase/installations-compat", oA = "@firebase/messaging", rA = "@firebase/messaging-compat", tA = "@firebase/performance", nA = "@firebase/performance-compat", sA = "@firebase/remote-config", cA = "@firebase/remote-config-compat", aA = "@firebase/storage", iA = "@firebase/storage-compat", lA = "@firebase/firestore", dA = "@firebase/vertexai-preview", vA = "@firebase/firestore-compat", uA = "firebase", gA = "10.12.3";
    var l5 = "[DEFAULT]", bA = {
        [i5]: "fire-core",
        [JC]: "fire-core-compat",
        [qC]: "fire-analytics",
        [VC]: "fire-analytics-compat",
        [HC]: "fire-app-check",
        [WC]: "fire-app-check-compat",
        [jC]: "fire-auth",
        [KC]: "fire-auth-compat",
        [QC]: "fire-rtdb",
        [YC]: "fire-rtdb-compat",
        [XC]: "fire-fn",
        [ZC]: "fire-fn-compat",
        [_A]: "fire-iid",
        [eA]: "fire-iid-compat",
        [oA]: "fire-fcm",
        [rA]: "fire-fcm-compat",
        [tA]: "fire-perf",
        [nA]: "fire-perf-compat",
        [sA]: "fire-rc",
        [cA]: "fire-rc-compat",
        [aA]: "fire-gcs",
        [iA]: "fire-gcs-compat",
        [lA]: "fire-fst",
        [vA]: "fire-fst-compat",
        [dA]: "fire-vertex",
        "fire-js": "fire-js",
        [uA]: "fire-js-all"
    };
    var iu = new Map, pA = new Map, d5 = new Map;
    function B9(e, _) {
        try {
            e.container.addComponent(_);
        } catch (r) {
            Qs.debug(`Component ${_.name} failed to register with FirebaseApp ${e.name}`, r);
        }
    }
    function an(e) {
        let _ = e.name;
        if (d5.has(_)) return Qs.debug(`There were multiple attempts to register component ${_}.`), !1;
        d5.set(_, e);
        for (let r of iu.values())B9(r, e);
        for (let r of pA.values())B9(r, e);
        return !0;
    }
    function Ys(e, _) {
        let r = e.container.getProvider("heartbeat").getImmediate({
            optional: !0
        });
        return r && r.triggerHeartbeat(), e.container.getProvider(_);
    }
    function ln(e) {
        return e.settings !== void 0;
    }
    var fA = {
        "no-app": "No Firebase App '{$appName}' has been created - call initializeApp() first",
        "bad-app-name": "Illegal App name: '{$appName}'",
        "duplicate-app": "Firebase App named '{$appName}' already exists with different options or config",
        "app-deleted": "Firebase App named '{$appName}' already deleted",
        "server-app-deleted": "Firebase Server App has been deleted",
        "no-options": "Need to provide options, when not being deployed to hosting via source.",
        "invalid-app-argument": "firebase.{$appName}() takes either no argument or a Firebase App instance.",
        "invalid-log-argument": "First argument to `onLog` must be null or a function.",
        "idb-open": "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
        "idb-get": "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
        "idb-set": "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
        "idb-delete": "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
        "finalization-registry-not-supported": "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
        "invalid-server-app-environment": "FirebaseServerApp is not for use in browser environments."
    }, V0 = new Yn("app", "Firebase", fA);
    var v5 = class {
        constructor(_, r, t){
            this._isDeleted = !1, this._options = Object.assign({}, _), this._config = Object.assign({}, r), this._name = r.name, this._automaticDataCollectionEnabled = r.automaticDataCollectionEnabled, this._container = t, this.container.addComponent(new Kr("app", ()=>this, "PUBLIC"));
        }
        get automaticDataCollectionEnabled() {
            return this.checkDestroyed(), this._automaticDataCollectionEnabled;
        }
        set automaticDataCollectionEnabled(_) {
            this.checkDestroyed(), this._automaticDataCollectionEnabled = _;
        }
        get name() {
            return this.checkDestroyed(), this._name;
        }
        get options() {
            return this.checkDestroyed(), this._options;
        }
        get config() {
            return this.checkDestroyed(), this._config;
        }
        get container() {
            return this._container;
        }
        get isDeleted() {
            return this._isDeleted;
        }
        set isDeleted(_) {
            this._isDeleted = _;
        }
        checkDestroyed() {
            if (this.isDeleted) throw V0.create("app-deleted", {
                appName: this._name
            });
        }
    };
    var q0 = gA;
    function b5(e, _ = {}) {
        let r = e;
        typeof _ != "object" && (_ = {
            name: _
        });
        let t = Object.assign({
            name: l5,
            automaticDataCollectionEnabled: !1
        }, _), n = t.name;
        if (typeof n != "string" || !n) throw V0.create("bad-app-name", {
            appName: String(n)
        });
        if (r || (r = Xp()), !r) throw V0.create("no-options");
        let s = iu.get(n);
        if (s) {
            if (js(r, s.options) && js(t, s.config)) return s;
            throw V0.create("duplicate-app", {
                appName: n
            });
        }
        let c = new cu(n);
        for (let d of d5.values())c.addComponent(d);
        let i = new v5(r, t, c);
        return iu.set(n, i), i;
    }
    function W0(e = l5) {
        let _ = iu.get(e);
        if (!_ && e === l5 && Xp()) return b5();
        if (!_) throw V0.create("no-app", {
            appName: e
        });
        return _;
    }
    function Qr(e, _, r) {
        var t;
        let n = (t = bA[e]) !== null && t !== void 0 ? t : e;
        r && (n += `-${r}`);
        let s = n.match(/\s|\//), c = _.match(/\s|\//);
        if (s || c) {
            let i = [
                `Unable to register library "${n}" with version "${_}":`
            ];
            s && i.push(`library name "${n}" contains illegal characters (whitespace or "/")`), s && c && i.push("and"), c && i.push(`version name "${_}" contains illegal characters (whitespace or "/")`), Qs.warn(i.join(" "));
            return;
        }
        an(new Kr(`${n}-version`, ()=>({
                library: n,
                version: _
            }), "VERSION"));
    }
    var mA = "firebase-heartbeat-database", $A = 1, ml = "firebase-heartbeat-store", c5 = null;
    function W9() {
        return c5 || (c5 = O9(mA, $A, {
            upgrade: (e, _)=>{
                switch(_){
                    case 0:
                        try {
                            e.createObjectStore(ml);
                        } catch (r) {
                            console.warn(r);
                        }
                }
            }
        }).catch((e)=>{
            throw V0.create("idb-open", {
                originalErrorMessage: e.message
            });
        })), c5;
    }
    async function hA(e) {
        try {
            let r = (await W9()).transaction(ml), t = await r.objectStore(ml).get(H9(e));
            return await r.done, t;
        } catch (_) {
            if (_ instanceof Nr) Qs.warn(_.message);
            else {
                let r = V0.create("idb-get", {
                    originalErrorMessage: _?.message
                });
                Qs.warn(r.message);
            }
        }
    }
    async function J9(e, _) {
        try {
            let t = (await W9()).transaction(ml, "readwrite");
            await t.objectStore(ml).put(_, H9(e)), await t.done;
        } catch (r) {
            if (r instanceof Nr) Qs.warn(r.message);
            else {
                let t = V0.create("idb-set", {
                    originalErrorMessage: r?.message
                });
                Qs.warn(t.message);
            }
        }
    }
    function H9(e) {
        return `${e.name}!${e.options.appId}`;
    }
    var yA = 1024, DA = 2592000000, u5 = class {
        constructor(_){
            this.container = _, this._heartbeatsCache = null;
            let r = this.container.getProvider("app").getImmediate();
            this._storage = new g5(r), this._heartbeatsCachePromise = this._storage.read().then((t)=>(this._heartbeatsCache = t, t));
        }
        async triggerHeartbeat() {
            var _, r;
            let n = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), s = V9();
            if (!(((_ = this._heartbeatsCache) === null || _ === void 0 ? void 0 : _.heartbeats) == null && (this._heartbeatsCache = await this._heartbeatsCachePromise, ((r = this._heartbeatsCache) === null || r === void 0 ? void 0 : r.heartbeats) == null)) && !(this._heartbeatsCache.lastSentHeartbeatDate === s || this._heartbeatsCache.heartbeats.some((c)=>c.date === s))) return this._heartbeatsCache.heartbeats.push({
                date: s,
                agent: n
            }), this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((c)=>{
                let i = new Date(c.date).valueOf();
                return Date.now() - i <= DA;
            }), this._storage.overwrite(this._heartbeatsCache);
        }
        async getHeartbeatsHeader() {
            var _;
            if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, ((_ = this._heartbeatsCache) === null || _ === void 0 ? void 0 : _.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return "";
            let r = V9(), { heartbeatsToSend: t , unsentEntries: n  } = wA(this._heartbeatsCache.heartbeats), s = fl(JSON.stringify({
                version: 2,
                heartbeats: t
            }));
            return this._heartbeatsCache.lastSentHeartbeatDate = r, n.length > 0 ? (this._heartbeatsCache.heartbeats = n, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), s;
        }
    };
    function V9() {
        return new Date().toISOString().substring(0, 10);
    }
    function wA(e, _ = yA) {
        let r = [], t = e.slice();
        for (let n of e){
            let s = r.find((c)=>c.agent === n.agent);
            if (s) {
                if (s.dates.push(n.date), q9(r) > _) {
                    s.dates.pop();
                    break;
                }
            } else if (r.push({
                agent: n.agent,
                dates: [
                    n.date
                ]
            }), q9(r) > _) {
                r.pop();
                break;
            }
            t = t.slice(1);
        }
        return {
            heartbeatsToSend: r,
            unsentEntries: t
        };
    }
    var g5 = class {
        constructor(_){
            this.app = _, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
        }
        async runIndexedDBEnvironmentCheck() {
            return _5() ? G9().then(()=>!0).catch(()=>!1) : !1;
        }
        async read() {
            if (await this._canUseIndexedDBPromise) {
                let r = await hA(this.app);
                return r?.heartbeats ? r : {
                    heartbeats: []
                };
            } else return {
                heartbeats: []
            };
        }
        async overwrite(_) {
            var r;
            if (await this._canUseIndexedDBPromise) {
                let n = await this.read();
                return J9(this.app, {
                    lastSentHeartbeatDate: (r = _.lastSentHeartbeatDate) !== null && r !== void 0 ? r : n.lastSentHeartbeatDate,
                    heartbeats: _.heartbeats
                });
            } else return;
        }
        async add(_) {
            var r;
            if (await this._canUseIndexedDBPromise) {
                let n = await this.read();
                return J9(this.app, {
                    lastSentHeartbeatDate: (r = _.lastSentHeartbeatDate) !== null && r !== void 0 ? r : n.lastSentHeartbeatDate,
                    heartbeats: [
                        ...n.heartbeats,
                        ..._.heartbeats
                    ]
                });
            } else return;
        }
    };
    function q9(e) {
        return fl(JSON.stringify({
            version: 2,
            heartbeats: e
        })).length;
    }
    function RA(e) {
        an(new Kr("platform-logger", (_)=>new a5(_), "PRIVATE")), an(new Kr("heartbeat", (_)=>new u5(_), "PRIVATE")), Qr(i5, U9, e), Qr(i5, U9, "esm2017"), Qr("fire-js", "");
    }
    RA("");
    var j9 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, K9 = {};
    var H0, p5;
    (function() {
        var e;
        function _(y, w) {
            function x() {}
            x.prototype = w.prototype, y.D = w.prototype, y.prototype = new x, y.prototype.constructor = y, y.C = function(T, C, A) {
                for(var G = Array(arguments.length - 2), $_ = 2; $_ < arguments.length; $_++)G[$_ - 2] = arguments[$_];
                return w.prototype[C].apply(T, G);
            };
        }
        function r() {
            this.blockSize = -1;
        }
        function t() {
            this.blockSize = -1, this.blockSize = 64, this.g = Array(4), this.B = Array(this.blockSize), this.o = this.h = 0, this.s();
        }
        _(t, r), t.prototype.s = function() {
            this.g[0] = 1732584193, this.g[1] = 4023233417, this.g[2] = 2562383102, this.g[3] = 271733878, this.o = this.h = 0;
        };
        function n(y, w, x) {
            x || (x = 0);
            var T = Array(16);
            if (typeof w == "string") for(var C = 0; 16 > C; ++C)T[C] = w.charCodeAt(x++) | w.charCodeAt(x++) << 8 | w.charCodeAt(x++) << 16 | w.charCodeAt(x++) << 24;
            else for(C = 0; 16 > C; ++C)T[C] = w[x++] | w[x++] << 8 | w[x++] << 16 | w[x++] << 24;
            w = y.g[0], x = y.g[1], C = y.g[2];
            var A = y.g[3], G = w + (A ^ x & (C ^ A)) + T[0] + 3614090360 & 4294967295;
            w = x + (G << 7 & 4294967295 | G >>> 25), G = A + (C ^ w & (x ^ C)) + T[1] + 3905402710 & 4294967295, A = w + (G << 12 & 4294967295 | G >>> 20), G = C + (x ^ A & (w ^ x)) + T[2] + 606105819 & 4294967295, C = A + (G << 17 & 4294967295 | G >>> 15), G = x + (w ^ C & (A ^ w)) + T[3] + 3250441966 & 4294967295, x = C + (G << 22 & 4294967295 | G >>> 10), G = w + (A ^ x & (C ^ A)) + T[4] + 4118548399 & 4294967295, w = x + (G << 7 & 4294967295 | G >>> 25), G = A + (C ^ w & (x ^ C)) + T[5] + 1200080426 & 4294967295, A = w + (G << 12 & 4294967295 | G >>> 20), G = C + (x ^ A & (w ^ x)) + T[6] + 2821735955 & 4294967295, C = A + (G << 17 & 4294967295 | G >>> 15), G = x + (w ^ C & (A ^ w)) + T[7] + 4249261313 & 4294967295, x = C + (G << 22 & 4294967295 | G >>> 10), G = w + (A ^ x & (C ^ A)) + T[8] + 1770035416 & 4294967295, w = x + (G << 7 & 4294967295 | G >>> 25), G = A + (C ^ w & (x ^ C)) + T[9] + 2336552879 & 4294967295, A = w + (G << 12 & 4294967295 | G >>> 20), G = C + (x ^ A & (w ^ x)) + T[10] + 4294925233 & 4294967295, C = A + (G << 17 & 4294967295 | G >>> 15), G = x + (w ^ C & (A ^ w)) + T[11] + 2304563134 & 4294967295, x = C + (G << 22 & 4294967295 | G >>> 10), G = w + (A ^ x & (C ^ A)) + T[12] + 1804603682 & 4294967295, w = x + (G << 7 & 4294967295 | G >>> 25), G = A + (C ^ w & (x ^ C)) + T[13] + 4254626195 & 4294967295, A = w + (G << 12 & 4294967295 | G >>> 20), G = C + (x ^ A & (w ^ x)) + T[14] + 2792965006 & 4294967295, C = A + (G << 17 & 4294967295 | G >>> 15), G = x + (w ^ C & (A ^ w)) + T[15] + 1236535329 & 4294967295, x = C + (G << 22 & 4294967295 | G >>> 10), G = w + (C ^ A & (x ^ C)) + T[1] + 4129170786 & 4294967295, w = x + (G << 5 & 4294967295 | G >>> 27), G = A + (x ^ C & (w ^ x)) + T[6] + 3225465664 & 4294967295, A = w + (G << 9 & 4294967295 | G >>> 23), G = C + (w ^ x & (A ^ w)) + T[11] + 643717713 & 4294967295, C = A + (G << 14 & 4294967295 | G >>> 18), G = x + (A ^ w & (C ^ A)) + T[0] + 3921069994 & 4294967295, x = C + (G << 20 & 4294967295 | G >>> 12), G = w + (C ^ A & (x ^ C)) + T[5] + 3593408605 & 4294967295, w = x + (G << 5 & 4294967295 | G >>> 27), G = A + (x ^ C & (w ^ x)) + T[10] + 38016083 & 4294967295, A = w + (G << 9 & 4294967295 | G >>> 23), G = C + (w ^ x & (A ^ w)) + T[15] + 3634488961 & 4294967295, C = A + (G << 14 & 4294967295 | G >>> 18), G = x + (A ^ w & (C ^ A)) + T[4] + 3889429448 & 4294967295, x = C + (G << 20 & 4294967295 | G >>> 12), G = w + (C ^ A & (x ^ C)) + T[9] + 568446438 & 4294967295, w = x + (G << 5 & 4294967295 | G >>> 27), G = A + (x ^ C & (w ^ x)) + T[14] + 3275163606 & 4294967295, A = w + (G << 9 & 4294967295 | G >>> 23), G = C + (w ^ x & (A ^ w)) + T[3] + 4107603335 & 4294967295, C = A + (G << 14 & 4294967295 | G >>> 18), G = x + (A ^ w & (C ^ A)) + T[8] + 1163531501 & 4294967295, x = C + (G << 20 & 4294967295 | G >>> 12), G = w + (C ^ A & (x ^ C)) + T[13] + 2850285829 & 4294967295, w = x + (G << 5 & 4294967295 | G >>> 27), G = A + (x ^ C & (w ^ x)) + T[2] + 4243563512 & 4294967295, A = w + (G << 9 & 4294967295 | G >>> 23), G = C + (w ^ x & (A ^ w)) + T[7] + 1735328473 & 4294967295, C = A + (G << 14 & 4294967295 | G >>> 18), G = x + (A ^ w & (C ^ A)) + T[12] + 2368359562 & 4294967295, x = C + (G << 20 & 4294967295 | G >>> 12), G = w + (x ^ C ^ A) + T[5] + 4294588738 & 4294967295, w = x + (G << 4 & 4294967295 | G >>> 28), G = A + (w ^ x ^ C) + T[8] + 2272392833 & 4294967295, A = w + (G << 11 & 4294967295 | G >>> 21), G = C + (A ^ w ^ x) + T[11] + 1839030562 & 4294967295, C = A + (G << 16 & 4294967295 | G >>> 16), G = x + (C ^ A ^ w) + T[14] + 4259657740 & 4294967295, x = C + (G << 23 & 4294967295 | G >>> 9), G = w + (x ^ C ^ A) + T[1] + 2763975236 & 4294967295, w = x + (G << 4 & 4294967295 | G >>> 28), G = A + (w ^ x ^ C) + T[4] + 1272893353 & 4294967295, A = w + (G << 11 & 4294967295 | G >>> 21), G = C + (A ^ w ^ x) + T[7] + 4139469664 & 4294967295, C = A + (G << 16 & 4294967295 | G >>> 16), G = x + (C ^ A ^ w) + T[10] + 3200236656 & 4294967295, x = C + (G << 23 & 4294967295 | G >>> 9), G = w + (x ^ C ^ A) + T[13] + 681279174 & 4294967295, w = x + (G << 4 & 4294967295 | G >>> 28), G = A + (w ^ x ^ C) + T[0] + 3936430074 & 4294967295, A = w + (G << 11 & 4294967295 | G >>> 21), G = C + (A ^ w ^ x) + T[3] + 3572445317 & 4294967295, C = A + (G << 16 & 4294967295 | G >>> 16), G = x + (C ^ A ^ w) + T[6] + 76029189 & 4294967295, x = C + (G << 23 & 4294967295 | G >>> 9), G = w + (x ^ C ^ A) + T[9] + 3654602809 & 4294967295, w = x + (G << 4 & 4294967295 | G >>> 28), G = A + (w ^ x ^ C) + T[12] + 3873151461 & 4294967295, A = w + (G << 11 & 4294967295 | G >>> 21), G = C + (A ^ w ^ x) + T[15] + 530742520 & 4294967295, C = A + (G << 16 & 4294967295 | G >>> 16), G = x + (C ^ A ^ w) + T[2] + 3299628645 & 4294967295, x = C + (G << 23 & 4294967295 | G >>> 9), G = w + (C ^ (x | ~A)) + T[0] + 4096336452 & 4294967295, w = x + (G << 6 & 4294967295 | G >>> 26), G = A + (x ^ (w | ~C)) + T[7] + 1126891415 & 4294967295, A = w + (G << 10 & 4294967295 | G >>> 22), G = C + (w ^ (A | ~x)) + T[14] + 2878612391 & 4294967295, C = A + (G << 15 & 4294967295 | G >>> 17), G = x + (A ^ (C | ~w)) + T[5] + 4237533241 & 4294967295, x = C + (G << 21 & 4294967295 | G >>> 11), G = w + (C ^ (x | ~A)) + T[12] + 1700485571 & 4294967295, w = x + (G << 6 & 4294967295 | G >>> 26), G = A + (x ^ (w | ~C)) + T[3] + 2399980690 & 4294967295, A = w + (G << 10 & 4294967295 | G >>> 22), G = C + (w ^ (A | ~x)) + T[10] + 4293915773 & 4294967295, C = A + (G << 15 & 4294967295 | G >>> 17), G = x + (A ^ (C | ~w)) + T[1] + 2240044497 & 4294967295, x = C + (G << 21 & 4294967295 | G >>> 11), G = w + (C ^ (x | ~A)) + T[8] + 1873313359 & 4294967295, w = x + (G << 6 & 4294967295 | G >>> 26), G = A + (x ^ (w | ~C)) + T[15] + 4264355552 & 4294967295, A = w + (G << 10 & 4294967295 | G >>> 22), G = C + (w ^ (A | ~x)) + T[6] + 2734768916 & 4294967295, C = A + (G << 15 & 4294967295 | G >>> 17), G = x + (A ^ (C | ~w)) + T[13] + 1309151649 & 4294967295, x = C + (G << 21 & 4294967295 | G >>> 11), G = w + (C ^ (x | ~A)) + T[4] + 4149444226 & 4294967295, w = x + (G << 6 & 4294967295 | G >>> 26), G = A + (x ^ (w | ~C)) + T[11] + 3174756917 & 4294967295, A = w + (G << 10 & 4294967295 | G >>> 22), G = C + (w ^ (A | ~x)) + T[2] + 718787259 & 4294967295, C = A + (G << 15 & 4294967295 | G >>> 17), G = x + (A ^ (C | ~w)) + T[9] + 3951481745 & 4294967295, y.g[0] = y.g[0] + w & 4294967295, y.g[1] = y.g[1] + (C + (G << 21 & 4294967295 | G >>> 11)) & 4294967295, y.g[2] = y.g[2] + C & 4294967295, y.g[3] = y.g[3] + A & 4294967295;
        }
        t.prototype.u = function(y, w) {
            w === void 0 && (w = y.length);
            for(var x = w - this.blockSize, T = this.B, C = this.h, A = 0; A < w;){
                if (C == 0) for(; A <= x;)n(this, y, A), A += this.blockSize;
                if (typeof y == "string") {
                    for(; A < w;)if (T[C++] = y.charCodeAt(A++), C == this.blockSize) {
                        n(this, T), C = 0;
                        break;
                    }
                } else for(; A < w;)if (T[C++] = y[A++], C == this.blockSize) {
                    n(this, T), C = 0;
                    break;
                }
            }
            this.h = C, this.o += w;
        }, t.prototype.v = function() {
            var y = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
            y[0] = 128;
            for(var w = 1; w < y.length - 8; ++w)y[w] = 0;
            var x = 8 * this.o;
            for(w = y.length - 8; w < y.length; ++w)y[w] = x & 255, x /= 256;
            for(this.u(y), y = Array(16), w = x = 0; 4 > w; ++w)for(var T = 0; 32 > T; T += 8)y[x++] = this.g[w] >>> T & 255;
            return y;
        };
        function s(y, w) {
            var x = i;
            return Object.prototype.hasOwnProperty.call(x, y) ? x[y] : x[y] = w(y);
        }
        function c(y, w) {
            this.h = w;
            for(var x = [], T = !0, C = y.length - 1; 0 <= C; C--){
                var A = y[C] | 0;
                T && A == w || (x[C] = A, T = !1);
            }
            this.g = x;
        }
        var i = {};
        function d(y) {
            return -128 <= y && 128 > y ? s(y, function(w) {
                return new c([
                    w | 0
                ], 0 > w ? -1 : 0);
            }) : new c([
                y | 0
            ], 0 > y ? -1 : 0);
        }
        function v(y) {
            if (isNaN(y) || !isFinite(y)) return p;
            if (0 > y) return J(v(-y));
            for(var w = [], x = 1, T = 0; y >= x; T++)w[T] = y / x | 0, x *= 4294967296;
            return new c(w, 0);
        }
        function b(y, w) {
            if (y.length == 0) throw Error("number format error: empty string");
            if (w = w || 10, 2 > w || 36 < w) throw Error("radix out of range: " + w);
            if (y.charAt(0) == "-") return J(b(y.substring(1), w));
            if (0 <= y.indexOf("-")) throw Error('number format error: interior "-" character');
            for(var x = v(Math.pow(w, 8)), T = p, C = 0; C < y.length; C += 8){
                var A = Math.min(8, y.length - C), G = parseInt(y.substring(C, C + A), w);
                8 > A ? (A = v(Math.pow(w, A)), T = T.j(A).add(v(G))) : (T = T.j(x), T = T.add(v(G)));
            }
            return T;
        }
        var p = d(0), u = d(1), m = d(16777216);
        e = c.prototype, e.m = function() {
            if (L(this)) return -J(this).m();
            for(var y = 0, w = 1, x = 0; x < this.g.length; x++){
                var T = this.i(x);
                y += (0 <= T ? T : 4294967296 + T) * w, w *= 4294967296;
            }
            return y;
        }, e.toString = function(y) {
            if (y = y || 10, 2 > y || 36 < y) throw Error("radix out of range: " + y);
            if (z(this)) return "0";
            if (L(this)) return "-" + J(this).toString(y);
            for(var w = v(Math.pow(y, 6)), x = this, T = "";;){
                var C = a_(x, w).g;
                x = c_(x, C.j(w));
                var A = ((0 < x.g.length ? x.g[0] : x.h) >>> 0).toString(y);
                if (x = C, z(x)) return A + T;
                for(; 6 > A.length;)A = "0" + A;
                T = A + T;
            }
        }, e.i = function(y) {
            return 0 > y ? 0 : y < this.g.length ? this.g[y] : this.h;
        };
        function z(y) {
            if (y.h != 0) return !1;
            for(var w = 0; w < y.g.length; w++)if (y.g[w] != 0) return !1;
            return !0;
        }
        function L(y) {
            return y.h == -1;
        }
        e.l = function(y) {
            return y = c_(this, y), L(y) ? -1 : z(y) ? 0 : 1;
        };
        function J(y) {
            for(var w = y.g.length, x = [], T = 0; T < w; T++)x[T] = ~y.g[T];
            return new c(x, ~y.h).add(u);
        }
        e.abs = function() {
            return L(this) ? J(this) : this;
        }, e.add = function(y) {
            for(var w = Math.max(this.g.length, y.g.length), x = [], T = 0, C = 0; C <= w; C++){
                var A = T + (this.i(C) & 65535) + (y.i(C) & 65535), G = (A >>> 16) + (this.i(C) >>> 16) + (y.i(C) >>> 16);
                T = G >>> 16, A &= 65535, G &= 65535, x[C] = G << 16 | A;
            }
            return new c(x, x[x.length - 1] & -2147483648 ? -1 : 0);
        };
        function c_(y, w) {
            return y.add(J(w));
        }
        e.j = function(y) {
            if (z(this) || z(y)) return p;
            if (L(this)) return L(y) ? J(this).j(J(y)) : J(J(this).j(y));
            if (L(y)) return J(this.j(J(y)));
            if (0 > this.l(m) && 0 > y.l(m)) return v(this.m() * y.m());
            for(var w = this.g.length + y.g.length, x = [], T = 0; T < 2 * w; T++)x[T] = 0;
            for(T = 0; T < this.g.length; T++)for(var C = 0; C < y.g.length; C++){
                var A = this.i(T) >>> 16, G = this.i(T) & 65535, $_ = y.i(C) >>> 16, i_ = y.i(C) & 65535;
                x[2 * T + 2 * C] += G * i_, t_(x, 2 * T + 2 * C), x[2 * T + 2 * C + 1] += A * i_, t_(x, 2 * T + 2 * C + 1), x[2 * T + 2 * C + 1] += G * $_, t_(x, 2 * T + 2 * C + 1), x[2 * T + 2 * C + 2] += A * $_, t_(x, 2 * T + 2 * C + 2);
            }
            for(T = 0; T < w; T++)x[T] = x[2 * T + 1] << 16 | x[2 * T];
            for(T = w; T < 2 * w; T++)x[T] = 0;
            return new c(x, 0);
        };
        function t_(y, w) {
            for(; (y[w] & 65535) != y[w];)y[w + 1] += y[w] >>> 16, y[w] &= 65535, w++;
        }
        function W(y, w) {
            this.g = y, this.h = w;
        }
        function a_(y, w) {
            if (z(w)) throw Error("division by zero");
            if (z(y)) return new W(p, p);
            if (L(y)) return w = a_(J(y), w), new W(J(w.g), J(w.h));
            if (L(w)) return w = a_(y, J(w)), new W(J(w.g), w.h);
            if (30 < y.g.length) {
                if (L(y) || L(w)) throw Error("slowDivide_ only works with positive integers.");
                for(var x = u, T = w; 0 >= T.l(y);)x = Q(x), T = Q(T);
                var C = F(x, 1), A = F(T, 1);
                for(T = F(T, 2), x = F(x, 2); !z(T);){
                    var G = A.add(T);
                    0 >= G.l(y) && (C = C.add(x), A = G), T = F(T, 1), x = F(x, 1);
                }
                return w = c_(y, C.j(w)), new W(C, w);
            }
            for(C = p; 0 <= y.l(w);){
                for(x = Math.max(1, Math.floor(y.m() / w.m())), T = Math.ceil(Math.log(x) / Math.LN2), T = 48 >= T ? 1 : Math.pow(2, T - 48), A = v(x), G = A.j(w); L(G) || 0 < G.l(y);)x -= T, A = v(x), G = A.j(w);
                z(A) && (A = u), C = C.add(A), y = c_(y, G);
            }
            return new W(C, y);
        }
        e.A = function(y) {
            return a_(this, y).h;
        }, e.and = function(y) {
            for(var w = Math.max(this.g.length, y.g.length), x = [], T = 0; T < w; T++)x[T] = this.i(T) & y.i(T);
            return new c(x, this.h & y.h);
        }, e.or = function(y) {
            for(var w = Math.max(this.g.length, y.g.length), x = [], T = 0; T < w; T++)x[T] = this.i(T) | y.i(T);
            return new c(x, this.h | y.h);
        }, e.xor = function(y) {
            for(var w = Math.max(this.g.length, y.g.length), x = [], T = 0; T < w; T++)x[T] = this.i(T) ^ y.i(T);
            return new c(x, this.h ^ y.h);
        };
        function Q(y) {
            for(var w = y.g.length + 1, x = [], T = 0; T < w; T++)x[T] = y.i(T) << 1 | y.i(T - 1) >>> 31;
            return new c(x, y.h);
        }
        function F(y, w) {
            var x = w >> 5;
            w %= 32;
            for(var T = y.g.length - x, C = [], A = 0; A < T; A++)C[A] = 0 < w ? y.i(A + x) >>> w | y.i(A + x + 1) << 32 - w : y.i(A + x);
            return new c(C, y.h);
        }
        t.prototype.digest = t.prototype.v, t.prototype.reset = t.prototype.s, t.prototype.update = t.prototype.u, p5 = K9.Md5 = t, c.prototype.add = c.prototype.add, c.prototype.multiply = c.prototype.j, c.prototype.modulo = c.prototype.A, c.prototype.compare = c.prototype.l, c.prototype.toNumber = c.prototype.m, c.prototype.toString = c.prototype.toString, c.prototype.getBits = c.prototype.i, c.fromNumber = v, c.fromString = b, H0 = K9.Integer = c;
    }).apply(typeof j9 < "u" ? j9 : typeof self < "u" ? self : typeof window < "u" ? window : {});
    var lu = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, Xn = {};
    var f5, m5, ga, $5, $l, du, h5, y5, D5;
    (function() {
        var e, _ = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, g, f) {
            return a == Array.prototype || a == Object.prototype || (a[g] = f.value), a;
        };
        function r(a) {
            a = [
                typeof globalThis == "object" && globalThis,
                a,
                typeof window == "object" && window,
                typeof self == "object" && self,
                typeof lu == "object" && lu
            ];
            for(var g = 0; g < a.length; ++g){
                var f = a[g];
                if (f && f.Math == Math) return f;
            }
            throw Error("Cannot find global object");
        }
        var t = r(this);
        function n(a, g) {
            if (g) _: {
                var f = t;
                a = a.split(".");
                for(var k = 0; k < a.length - 1; k++){
                    var B = a[k];
                    if (!(B in f)) break _;
                    f = f[B];
                }
                a = a[a.length - 1], k = f[a], g = g(k), g != k && g != null && _(f, a, {
                    configurable: !0,
                    writable: !0,
                    value: g
                });
            }
        }
        function s(a, g) {
            a instanceof String && (a += "");
            var f = 0, k = !1, B = {
                next: function() {
                    if (!k && f < a.length) {
                        var j = f++;
                        return {
                            value: g(j, a[j]),
                            done: !1
                        };
                    }
                    return k = !0, {
                        done: !0,
                        value: void 0
                    };
                }
            };
            return B[Symbol.iterator] = function() {
                return B;
            }, B;
        }
        n("Array.prototype.values", function(a) {
            return a || function() {
                return s(this, function(g, f) {
                    return f;
                });
            };
        });
        var c = c || {}, i = this || self;
        function d(a) {
            var g = typeof a;
            return g = g != "object" ? g : a ? Array.isArray(a) ? "array" : g : "null", g == "array" || g == "object" && typeof a.length == "number";
        }
        function v(a) {
            var g = typeof a;
            return g == "object" && a != null || g == "function";
        }
        function b(a, g, f) {
            return a.call.apply(a.bind, arguments);
        }
        function p(a, g, f) {
            if (!a) throw Error();
            if (2 < arguments.length) {
                var k = Array.prototype.slice.call(arguments, 2);
                return function() {
                    var B = Array.prototype.slice.call(arguments);
                    return Array.prototype.unshift.apply(B, k), a.apply(g, B);
                };
            }
            return function() {
                return a.apply(g, arguments);
            };
        }
        function u(a, g, f) {
            return u = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? b : p, u.apply(null, arguments);
        }
        function m(a, g) {
            var f = Array.prototype.slice.call(arguments, 1);
            return function() {
                var k = f.slice();
                return k.push.apply(k, arguments), a.apply(this, k);
            };
        }
        function z(a, g) {
            function f() {}
            f.prototype = g.prototype, a.aa = g.prototype, a.prototype = new f, a.prototype.constructor = a, a.Qb = function(k, B, j) {
                for(var u_ = Array(arguments.length - 2), Be = 2; Be < arguments.length; Be++)u_[Be - 2] = arguments[Be];
                return g.prototype[B].apply(k, u_);
            };
        }
        function L(a) {
            let g = a.length;
            if (0 < g) {
                let f = Array(g);
                for(let k = 0; k < g; k++)f[k] = a[k];
                return f;
            }
            return [];
        }
        function J(a, g) {
            for(let f = 1; f < arguments.length; f++){
                let k = arguments[f];
                if (d(k)) {
                    let B = a.length || 0, j = k.length || 0;
                    a.length = B + j;
                    for(let u_ = 0; u_ < j; u_++)a[B + u_] = k[u_];
                } else a.push(k);
            }
        }
        class c_ {
            constructor(g, f){
                this.i = g, this.j = f, this.h = 0, this.g = null;
            }
            get() {
                let g;
                return 0 < this.h ? (this.h--, g = this.g, this.g = g.next, g.next = null) : g = this.i(), g;
            }
        }
        function t_(a) {
            return /^[\s\xa0]*$/.test(a);
        }
        function W() {
            var a = i.navigator;
            return a && (a = a.userAgent) ? a : "";
        }
        function a_(a) {
            return a_[" "](a), a;
        }
        a_[" "] = function() {};
        var Q = W().indexOf("Gecko") != -1 && !(W().toLowerCase().indexOf("webkit") != -1 && W().indexOf("Edge") == -1) && !(W().indexOf("Trident") != -1 || W().indexOf("MSIE") != -1) && W().indexOf("Edge") == -1;
        function F(a, g, f) {
            for(let k in a)g.call(f, a[k], k, a);
        }
        function y(a, g) {
            for(let f in a)g.call(void 0, a[f], f, a);
        }
        function w(a) {
            let g = {};
            for(let f in a)g[f] = a[f];
            return g;
        }
        let x = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
        function T(a, g) {
            let f, k;
            for(let B = 1; B < arguments.length; B++){
                k = arguments[B];
                for(f in k)a[f] = k[f];
                for(let j = 0; j < x.length; j++)f = x[j], Object.prototype.hasOwnProperty.call(k, f) && (a[f] = k[f]);
            }
        }
        function C(a) {
            var g = 1;
            a = a.split(":");
            let f = [];
            for(; 0 < g && a.length;)f.push(a.shift()), g--;
            return a.length && f.push(a.join(":")), f;
        }
        function A(a) {
            i.setTimeout(()=>{
                throw a;
            }, 0);
        }
        function G() {
            var a = we;
            let g = null;
            return a.g && (g = a.g, a.g = a.g.next, a.g || (a.h = null), g.next = null), g;
        }
        class $_ {
            constructor(){
                this.h = this.g = null;
            }
            add(g, f) {
                let k = i_.get();
                k.set(g, f), this.h ? this.h.next = k : this.g = k, this.h = k;
            }
        }
        var i_ = new c_(()=>new W_, (a)=>a.reset());
        class W_ {
            constructor(){
                this.next = this.g = this.h = null;
            }
            set(g, f) {
                this.h = g, this.g = f, this.next = null;
            }
            reset() {
                this.next = this.g = this.h = null;
            }
        }
        let g_, U_ = !1, we = new $_, p_ = ()=>{
            let a = i.Promise.resolve(void 0);
            g_ = ()=>{
                a.then(pe);
            };
        };
        var pe = ()=>{
            for(var a; a = G();){
                try {
                    a.h.call(a.g);
                } catch (f) {
                    A(f);
                }
                var g = i_;
                g.j(a), 100 > g.h && (g.h++, a.next = g.g, g.g = a);
            }
            U_ = !1;
        };
        function Fe() {
            this.s = this.s, this.C = this.C;
        }
        Fe.prototype.s = !1, Fe.prototype.ma = function() {
            this.s || (this.s = !0, this.N());
        }, Fe.prototype.N = function() {
            if (this.C) for(; this.C.length;)this.C.shift()();
        };
        function n_(a, g) {
            this.type = a, this.g = this.target = g, this.defaultPrevented = !1;
        }
        n_.prototype.h = function() {
            this.defaultPrevented = !0;
        };
        var N_ = function() {
            if (!i.addEventListener || !Object.defineProperty) return !1;
            var a = !1, g = Object.defineProperty({}, "passive", {
                get: function() {
                    a = !0;
                }
            });
            try {
                let f = ()=>{};
                i.addEventListener("test", f, g), i.removeEventListener("test", f, g);
            } catch  {}
            return a;
        }();
        function H_(a, g) {
            if (n_.call(this, a ? a.type : ""), this.relatedTarget = this.g = this.target = null, this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0, this.key = "", this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1, this.state = null, this.pointerId = 0, this.pointerType = "", this.i = null, a) {
                var f = this.type = a.type, k = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
                if (this.target = a.target || a.srcElement, this.g = g, g = a.relatedTarget) {
                    if (Q) {
                        _: {
                            try {
                                a_(g.nodeName);
                                var B = !0;
                                break _;
                            } catch  {}
                            B = !1;
                        }
                        B || (g = null);
                    }
                } else f == "mouseover" ? g = a.fromElement : f == "mouseout" && (g = a.toElement);
                this.relatedTarget = g, k ? (this.clientX = k.clientX !== void 0 ? k.clientX : k.pageX, this.clientY = k.clientY !== void 0 ? k.clientY : k.pageY, this.screenX = k.screenX || 0, this.screenY = k.screenY || 0) : (this.clientX = a.clientX !== void 0 ? a.clientX : a.pageX, this.clientY = a.clientY !== void 0 ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0), this.button = a.button, this.key = a.key || "", this.ctrlKey = a.ctrlKey, this.altKey = a.altKey, this.shiftKey = a.shiftKey, this.metaKey = a.metaKey, this.pointerId = a.pointerId || 0, this.pointerType = typeof a.pointerType == "string" ? a.pointerType : P_[a.pointerType] || "", this.state = a.state, this.i = a, a.defaultPrevented && H_.aa.h.call(this);
            }
        }
        z(H_, n_);
        var P_ = {
            2: "touch",
            3: "pen",
            4: "mouse"
        };
        H_.prototype.h = function() {
            H_.aa.h.call(this);
            var a = this.i;
            a.preventDefault ? a.preventDefault() : a.returnValue = !1;
        };
        var Z = "closure_listenable_" + (1e6 * Math.random() | 0), e_ = 0;
        function S_(a, g, f, k, B) {
            this.listener = a, this.proxy = null, this.src = g, this.type = f, this.capture = !!k, this.ha = B, this.key = ++e_, this.da = this.fa = !1;
        }
        function h_(a) {
            a.da = !0, a.listener = null, a.proxy = null, a.src = null, a.ha = null;
        }
        function G_(a) {
            this.src = a, this.g = {}, this.h = 0;
        }
        G_.prototype.add = function(a, g, f, k, B) {
            var j = a.toString();
            a = this.g[j], a || (a = this.g[j] = [], this.h++);
            var u_ = C_(a, g, k, B);
            return -1 < u_ ? (g = a[u_], f || (g.fa = !1)) : (g = new S_(g, this.src, j, !!k, B), g.fa = f, a.push(g)), g;
        };
        function de(a, g) {
            var f = g.type;
            if (f in a.g) {
                var k = a.g[f], B = Array.prototype.indexOf.call(k, g, void 0), j;
                (j = 0 <= B) && Array.prototype.splice.call(k, B, 1), j && (h_(g), a.g[f].length == 0 && (delete a.g[f], a.h--));
            }
        }
        function C_(a, g, f, k) {
            for(var B = 0; B < a.length; ++B){
                var j = a[B];
                if (!j.da && j.listener == g && j.capture == !!f && j.ha == k) return B;
            }
            return -1;
        }
        var L_ = "closure_lm_" + (1e6 * Math.random() | 0), We = {};
        function Ne(a, g, f, k, B) {
            if (k && k.once) return ve(a, g, f, k, B);
            if (Array.isArray(g)) {
                for(var j = 0; j < g.length; j++)Ne(a, g[j], f, k, B);
                return null;
            }
            return f = $e(f), a && a[Z] ? a.K(g, f, v(k) ? !!k.capture : !!k, B) : Xe(a, g, f, !1, k, B);
        }
        function Xe(a, g, f, k, B, j) {
            if (!g) throw Error("Invalid event type");
            var u_ = v(B) ? !!B.capture : !!B, Be = j_(a);
            if (Be || (a[L_] = Be = new G_(a)), f = Be.add(g, f, k, u_, j), f.proxy) return f;
            if (k = lo(), f.proxy = k, k.src = a, k.listener = f, a.addEventListener) N_ || (B = u_), B === void 0 && (B = !1), a.addEventListener(g.toString(), k, B);
            else if (a.attachEvent) a.attachEvent(w_(g.toString()), k);
            else if (a.addListener && a.removeListener) a.addListener(k);
            else throw Error("addEventListener and attachEvent are unavailable.");
            return f;
        }
        function lo() {
            function a(f) {
                return g.call(a.src, a.listener, f);
            }
            let g = l_;
            return a;
        }
        function ve(a, g, f, k, B) {
            if (Array.isArray(g)) {
                for(var j = 0; j < g.length; j++)ve(a, g[j], f, k, B);
                return null;
            }
            return f = $e(f), a && a[Z] ? a.L(g, f, v(k) ? !!k.capture : !!k, B) : Xe(a, g, f, !0, k, B);
        }
        function b_(a, g, f, k, B) {
            if (Array.isArray(g)) for(var j = 0; j < g.length; j++)b_(a, g[j], f, k, B);
            else k = v(k) ? !!k.capture : !!k, f = $e(f), a && a[Z] ? (a = a.i, g = String(g).toString(), g in a.g && (j = a.g[g], f = C_(j, f, k, B), -1 < f && (h_(j[f]), Array.prototype.splice.call(j, f, 1), j.length == 0 && (delete a.g[g], a.h--)))) : a && (a = j_(a)) && (g = a.g[g.toString()], a = -1, g && (a = C_(g, f, k, B)), (f = -1 < a ? g[a] : null) && D_(f));
        }
        function D_(a) {
            if (typeof a != "number" && a && !a.da) {
                var g = a.src;
                if (g && g[Z]) de(g.i, a);
                else {
                    var f = a.type, k = a.proxy;
                    g.removeEventListener ? g.removeEventListener(f, k, a.capture) : g.detachEvent ? g.detachEvent(w_(f), k) : g.addListener && g.removeListener && g.removeListener(k), (f = j_(g)) ? (de(f, a), f.h == 0 && (f.src = null, g[L_] = null)) : h_(a);
                }
            }
        }
        function w_(a) {
            return a in We ? We[a] : We[a] = "on" + a;
        }
        function l_(a, g) {
            if (a.da) a = !0;
            else {
                g = new H_(g, this);
                var f = a.listener, k = a.ha || a.src;
                a.fa && D_(a), a = f.call(k, g);
            }
            return a;
        }
        function j_(a) {
            return a = a[L_], a instanceof G_ ? a : null;
        }
        var q_ = "__closure_events_fn_" + (1e9 * Math.random() >>> 0);
        function $e(a) {
            return typeof a == "function" ? a : (a[q_] || (a[q_] = function(g) {
                return a.handleEvent(g);
            }), a[q_]);
        }
        function ee() {
            Fe.call(this), this.i = new G_(this), this.M = this, this.F = null;
        }
        z(ee, Fe), ee.prototype[Z] = !0, ee.prototype.removeEventListener = function(a, g, f, k) {
            b_(this, a, g, f, k);
        };
        function Ge(a, g) {
            var f, k = a.F;
            if (k) for(f = []; k; k = k.F)f.push(k);
            if (a = a.M, k = g.type || g, typeof g == "string") g = new n_(g, a);
            else if (g instanceof n_) g.target = g.target || a;
            else {
                var B = g;
                g = new n_(k, a), T(g, B);
            }
            if (B = !0, f) for(var j = f.length - 1; 0 <= j; j--){
                var u_ = g.g = f[j];
                B = _r(u_, k, !0, g) && B;
            }
            if (u_ = g.g = a, B = _r(u_, k, !0, g) && B, B = _r(u_, k, !1, g) && B, f) for(j = 0; j < f.length; j++)u_ = g.g = f[j], B = _r(u_, k, !1, g) && B;
        }
        ee.prototype.N = function() {
            if (ee.aa.N.call(this), this.i) {
                var a = this.i, g;
                for(g in a.g){
                    for(var f = a.g[g], k = 0; k < f.length; k++)h_(f[k]);
                    delete a.g[g], a.h--;
                }
            }
            this.F = null;
        }, ee.prototype.K = function(a, g, f, k) {
            return this.i.add(String(a), g, !1, f, k);
        }, ee.prototype.L = function(a, g, f, k) {
            return this.i.add(String(a), g, !0, f, k);
        };
        function _r(a, g, f, k) {
            if (g = a.i.g[String(g)], !g) return !0;
            g = g.concat();
            for(var B = !0, j = 0; j < g.length; ++j){
                var u_ = g[j];
                if (u_ && !u_.da && u_.capture == f) {
                    var Be = u_.listener, rr = u_.ha || u_.src;
                    u_.fa && de(a.i, u_), B = Be.call(rr, k) !== !1 && B;
                }
            }
            return B && !k.defaultPrevented;
        }
        function er(a, g, f) {
            if (typeof a == "function") f && (a = u(a, f));
            else if (a && typeof a.handleEvent == "function") a = u(a.handleEvent, a);
            else throw Error("Invalid listener argument");
            return 2147483647 < Number(g) ? -1 : i.setTimeout(a, g || 0);
        }
        function Ln(a) {
            a.g = er(()=>{
                a.g = null, a.i && (a.i = !1, Ln(a));
            }, a.l);
            let g = a.h;
            a.h = null, a.m.apply(null, g);
        }
        class dr extends Fe {
            constructor(g, f){
                super(), this.m = g, this.l = f, this.h = null, this.i = !1, this.g = null;
            }
            j(g) {
                this.h = arguments, this.g ? this.i = !0 : Ln(this);
            }
            N() {
                super.N(), this.g && (i.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
            }
        }
        function Xt(a) {
            Fe.call(this), this.h = a, this.g = {};
        }
        z(Xt, Fe);
        var D0 = [];
        function lv(a) {
            F(a.g, function(g, f) {
                this.g.hasOwnProperty(f) && D_(g);
            }, a), a.g = {};
        }
        Xt.prototype.N = function() {
            Xt.aa.N.call(this), lv(this);
        }, Xt.prototype.handleEvent = function() {
            throw Error("EventHandler.handleEvent not implemented");
        };
        var Gi = i.JSON.stringify, xb = i.JSON.parse, Eb = class {
            stringify(a) {
                return i.JSON.stringify(a, void 0);
            }
            parse(a) {
                return i.JSON.parse(a, void 0);
            }
        };
        function Ci() {}
        Ci.prototype.h = null;
        function dv(a) {
            return a.h || (a.h = a.i());
        }
        function vv() {}
        var Es = {
            OPEN: "a",
            kb: "b",
            Ja: "c",
            wb: "d"
        };
        function Ai() {
            n_.call(this, "d");
        }
        z(Ai, n_);
        function Ni() {
            n_.call(this, "c");
        }
        z(Ni, n_);
        var zn = {}, uv = null;
        function Uc() {
            return uv = uv || new ee;
        }
        zn.La = "serverreachability";
        function gv(a) {
            n_.call(this, zn.La, a);
        }
        z(gv, n_);
        function Ts(a) {
            let g = Uc();
            Ge(g, new gv(g));
        }
        zn.STAT_EVENT = "statevent";
        function bv(a, g) {
            n_.call(this, zn.STAT_EVENT, a), this.stat = g;
        }
        z(bv, n_);
        function or(a) {
            let g = Uc();
            Ge(g, new bv(g, a));
        }
        zn.Ma = "timingevent";
        function pv(a, g) {
            n_.call(this, zn.Ma, a), this.size = g;
        }
        z(pv, n_);
        function Gs(a, g) {
            if (typeof a != "function") throw Error("Fn must not be null and must be a function");
            return i.setTimeout(function() {
                a();
            }, g);
        }
        function Cs() {
            this.g = !0;
        }
        Cs.prototype.xa = function() {
            this.g = !1;
        };
        function Tb(a, g, f, k, B, j) {
            a.info(function() {
                if (a.g) {
                    if (j) for(var u_ = "", Be = j.split("&"), rr = 0; rr < Be.length; rr++){
                        var Ce = Be[rr].split("=");
                        if (1 < Ce.length) {
                            var vr = Ce[0];
                            Ce = Ce[1];
                            var ur = vr.split("_");
                            u_ = 2 <= ur.length && ur[1] == "type" ? u_ + (vr + "=" + Ce + "&") : u_ + (vr + "=redacted&");
                        }
                    }
                    else u_ = null;
                } else u_ = j;
                return "XMLHTTP REQ (" + k + ") [attempt " + B + "]: " + g + `
` + f + `
` + u_;
            });
        }
        function Gb(a, g, f, k, B, j, u_) {
            a.info(function() {
                return "XMLHTTP RESP (" + k + ") [ attempt " + B + "]: " + g + `
` + f + `
` + j + " " + u_;
            });
        }
        function w0(a, g, f, k) {
            a.info(function() {
                return "XMLHTTP TEXT (" + g + "): " + Ab(a, f) + (k ? " " + k : "");
            });
        }
        function Cb(a, g) {
            a.info(function() {
                return "TIMEOUT: " + g;
            });
        }
        Cs.prototype.info = function() {};
        function Ab(a, g) {
            if (!a.g) return g;
            if (!g) return null;
            try {
                var f = JSON.parse(g);
                if (f) {
                    for(a = 0; a < f.length; a++)if (Array.isArray(f[a])) {
                        var k = f[a];
                        if (!(2 > k.length)) {
                            var B = k[1];
                            if (Array.isArray(B) && !(1 > B.length)) {
                                var j = B[0];
                                if (j != "noop" && j != "stop" && j != "close") for(var u_ = 1; u_ < B.length; u_++)B[u_] = "";
                            }
                        }
                    }
                }
                return Gi(f);
            } catch  {
                return g;
            }
        }
        var Bc = {
            NO_ERROR: 0,
            gb: 1,
            tb: 2,
            sb: 3,
            nb: 4,
            rb: 5,
            ub: 6,
            Ia: 7,
            TIMEOUT: 8,
            xb: 9
        }, fv = {
            lb: "complete",
            Hb: "success",
            Ja: "error",
            Ia: "abort",
            zb: "ready",
            Ab: "readystatechange",
            TIMEOUT: "timeout",
            vb: "incrementaldata",
            yb: "progress",
            ob: "downloadprogress",
            Pb: "uploadprogress"
        }, Fi;
        function Jc() {}
        z(Jc, Ci), Jc.prototype.g = function() {
            return new XMLHttpRequest;
        }, Jc.prototype.i = function() {
            return {};
        }, Fi = new Jc;
        function Zt(a, g, f, k) {
            this.j = a, this.i = g, this.l = f, this.R = k || 1, this.U = new Xt(this), this.I = 45e3, this.H = null, this.o = !1, this.m = this.A = this.v = this.L = this.F = this.S = this.B = null, this.D = [], this.g = null, this.C = 0, this.s = this.u = null, this.X = -1, this.J = !1, this.O = 0, this.M = null, this.W = this.K = this.T = this.P = !1, this.h = new mv;
        }
        function mv() {
            this.i = null, this.g = "", this.h = !1;
        }
        var $v = {}, Mi = {};
        function As(a, g, f) {
            a.L = 1, a.v = wv(On(g)), a.m = f, a.P = !0, I(a, null);
        }
        function I(a, g) {
            a.F = Date.now(), hv(a), a.A = On(a.v);
            var f = a.A, k = a.R;
            Array.isArray(k) || (k = [
                String(k)
            ]), Jy(f.i, "t", k), a.C = 0, f = a.j.J, a.h = new mv, a.g = c2(a.j, f ? g : null, !a.m), 0 < a.O && (a.M = new dr(u(a.Y, a, a.g), a.O)), g = a.U, f = a.g, k = a.ca;
            var B = "readystatechange";
            Array.isArray(B) || (B && (D0[0] = B.toString()), B = D0);
            for(var j = 0; j < B.length; j++){
                var u_ = Ne(f, B[j], k || g.handleEvent, !1, g.h || g);
                if (!u_) break;
                g.g[u_.key] = u_;
            }
            g = a.H ? w(a.H) : {}, a.m ? (a.u || (a.u = "POST"), g["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.A, a.u, a.m, g)) : (a.u = "GET", a.g.ea(a.A, a.u, null, g)), Ts(), Tb(a.i, a.u, a.A, a.l, a.R, a.m);
        }
        Zt.prototype.ca = function(a) {
            a = a.target;
            let g = this.M;
            g && Un(a) == 3 ? g.j() : this.Y(a);
        }, Zt.prototype.Y = function(a) {
            try {
                if (a == this.g) _: {
                    let ur = Un(this.g);
                    var g = this.g.Ba();
                    let Wc = this.g.Z();
                    if (!(3 > ur) && (ur != 3 || this.g && (this.h.h || this.g.oa() || Qy(this.g)))) {
                        this.J || ur != 4 || g == 7 || (g == 8 || 0 >= Wc ? Ts(3) : Ts(2)), Nb(this);
                        var f = this.g.Z();
                        this.X = f;
                        e: if (Ty(this)) {
                            var k = Qy(this.g);
                            a = "";
                            var B = k.length, j = Un(this.g) == 4;
                            if (!this.h.i) {
                                if (typeof TextDecoder > "u") {
                                    Ns(this), Pi(this);
                                    var u_ = "";
                                    break e;
                                }
                                this.h.i = new i.TextDecoder;
                            }
                            for(g = 0; g < B; g++)this.h.h = !0, a += this.h.i.decode(k[g], {
                                stream: !(j && g == B - 1)
                            });
                            k.length = 0, this.h.g += a, this.C = 0, u_ = this.h.g;
                        } else u_ = this.g.oa();
                        if (this.o = f == 200, Gb(this.i, this.u, this.A, this.l, this.R, ur, f), this.o) {
                            if (this.T && !this.K) {
                                e: {
                                    if (this.g) {
                                        var Be, rr = this.g;
                                        if ((Be = rr.g ? rr.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !t_(Be)) {
                                            var Ce = Be;
                                            break e;
                                        }
                                    }
                                    Ce = null;
                                }
                                if (f = Ce) w0(this.i, this.l, f, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, Fb(this, f);
                                else {
                                    this.o = !1, this.s = 3, or(12), Ns(this), Pi(this);
                                    break _;
                                }
                            }
                            if (this.P) {
                                f = !0;
                                let At;
                                for(; !this.J && this.C < u_.length;)if (At = vE(this, u_), At == Mi) {
                                    ur == 4 && (this.s = 4, or(14), f = !1), w0(this.i, this.l, null, "[Incomplete Response]");
                                    break;
                                } else if (At == $v) {
                                    this.s = 4, or(15), w0(this.i, this.l, u_, "[Invalid Chunk]"), f = !1;
                                    break;
                                } else w0(this.i, this.l, At, null), Fb(this, At);
                                if (Ty(this) && this.C != 0 && (this.h.g = this.h.g.slice(this.C), this.C = 0), ur != 4 || u_.length != 0 || this.h.h || (this.s = 1, or(16), f = !1), this.o = this.o && f, !f) w0(this.i, this.l, u_, "[Invalid Chunked Response]"), Ns(this), Pi(this);
                                else if (0 < u_.length && !this.W) {
                                    this.W = !0;
                                    var vr = this.j;
                                    vr.g == this && vr.ba && !vr.M && (vr.j.info("Great, no buffering proxy detected. Bytes received: " + u_.length), Ub(vr), vr.M = !0, or(11));
                                }
                            } else w0(this.i, this.l, u_, null), Fb(this, u_);
                            ur == 4 && Ns(this), this.o && !this.J && (ur == 4 ? r2(this.j, this) : (this.o = !1, hv(this)));
                        } else EE(this.g), f == 400 && 0 < u_.indexOf("Unknown SID") ? (this.s = 3, or(12)) : (this.s = 0, or(13)), Ns(this), Pi(this);
                    }
                }
            } catch  {} finally{}
        };
        function Ty(a) {
            return a.g ? a.u == "GET" && a.L != 2 && a.j.Ca : !1;
        }
        function vE(a, g) {
            var f = a.C, k = g.indexOf(`
`, f);
            return k == -1 ? Mi : (f = Number(g.substring(f, k)), isNaN(f) ? $v : (k += 1, k + f > g.length ? Mi : (g = g.slice(k, k + f), a.C = k + f, g)));
        }
        Zt.prototype.cancel = function() {
            this.J = !0, Ns(this);
        };
        function hv(a) {
            a.S = Date.now() + a.I, Gy(a, a.I);
        }
        function Gy(a, g) {
            if (a.B != null) throw Error("WatchDog timer not null");
            a.B = Gs(u(a.ba, a), g);
        }
        function Nb(a) {
            a.B && (i.clearTimeout(a.B), a.B = null);
        }
        Zt.prototype.ba = function() {
            this.B = null;
            let a = Date.now();
            0 <= a - this.S ? (Cb(this.i, this.A), this.L != 2 && (Ts(), or(17)), Ns(this), this.s = 2, Pi(this)) : Gy(this, this.S - a);
        };
        function Pi(a) {
            a.j.G == 0 || a.J || r2(a.j, a);
        }
        function Ns(a) {
            Nb(a);
            var g = a.M;
            g && typeof g.ma == "function" && g.ma(), a.M = null, lv(a.U), a.g && (g = a.g, a.g = null, g.abort(), g.ma());
        }
        function Fb(a, g) {
            try {
                var f = a.j;
                if (f.G != 0 && (f.g == a || Mb(f.h, a))) {
                    if (!a.K && Mb(f.h, a) && f.G == 3) {
                        try {
                            var k = f.Da.g.parse(g);
                        } catch  {
                            k = null;
                        }
                        if (Array.isArray(k) && k.length == 3) {
                            var B = k;
                            if (B[0] == 0) {
                                _: if (!f.u) {
                                    if (f.g) {
                                        if (f.g.F + 3e3 < a.F) xv(f), Sv(f);
                                        else break _;
                                    }
                                    Ob(f), or(18);
                                }
                            } else f.za = B[1], 0 < f.za - f.T && 37500 > B[2] && f.F && f.v == 0 && !f.C && (f.C = Gs(u(f.Za, f), 6e3));
                            if (1 >= Ny(f.h) && f.ca) {
                                try {
                                    f.ca();
                                } catch  {}
                                f.ca = void 0;
                            }
                        } else Ms(f, 11);
                    } else if ((a.K || f.g == a) && xv(f), !t_(g)) for(B = f.Da.g.parse(g), g = 0; g < B.length; g++){
                        let Ce = B[g];
                        if (f.T = Ce[0], Ce = Ce[1], f.G == 2) {
                            if (Ce[0] == "c") {
                                f.K = Ce[1], f.ia = Ce[2];
                                let vr = Ce[3];
                                vr != null && (f.la = vr, f.j.info("VER=" + f.la));
                                let ur = Ce[4];
                                ur != null && (f.Aa = ur, f.j.info("SVER=" + f.Aa));
                                let Wc = Ce[5];
                                Wc != null && typeof Wc == "number" && 0 < Wc && (k = 1.5 * Wc, f.L = k, f.j.info("backChannelRequestTimeoutMs_=" + k)), k = f;
                                let At = a.g;
                                if (At) {
                                    let Tv = At.g ? At.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                    if (Tv) {
                                        var j = k.h;
                                        j.g || Tv.indexOf("spdy") == -1 && Tv.indexOf("quic") == -1 && Tv.indexOf("h2") == -1 || (j.j = j.l, j.g = new Set, j.h && (Pb(j, j.h), j.h = null));
                                    }
                                    if (k.D) {
                                        let Bb = At.g ? At.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                        Bb && (k.ya = Bb, He(k.I, k.D, Bb));
                                    }
                                }
                                f.G = 3, f.l && f.l.ua(), f.ba && (f.R = Date.now() - a.F, f.j.info("Handshake RTT: " + f.R + "ms")), k = f;
                                var u_ = a;
                                if (k.qa = s2(k, k.J ? k.ia : null, k.W), u_.K) {
                                    Fy(k.h, u_);
                                    var Be = u_, rr = k.L;
                                    rr && (Be.I = rr), Be.B && (Nb(Be), hv(Be)), k.g = u_;
                                } else e2(k);
                                0 < f.i.length && Iv(f);
                            } else Ce[0] != "stop" && Ce[0] != "close" || Ms(f, 7);
                        } else f.G == 3 && (Ce[0] == "stop" || Ce[0] == "close" ? Ce[0] == "stop" ? Ms(f, 7) : zb(f) : Ce[0] != "noop" && f.l && f.l.ta(Ce), f.v = 0);
                    }
                }
                Ts(4);
            } catch  {}
        }
        var uE = class {
            constructor(a, g){
                this.g = a, this.map = g;
            }
        };
        function Cy(a) {
            this.l = a || 10, i.PerformanceNavigationTiming ? (a = i.performance.getEntriesByType("navigation"), a = 0 < a.length && (a[0].nextHopProtocol == "hq" || a[0].nextHopProtocol == "h2")) : a = !!(i.chrome && i.chrome.loadTimes && i.chrome.loadTimes() && i.chrome.loadTimes().wasFetchedViaSpdy), this.j = a ? this.l : 1, this.g = null, 1 < this.j && (this.g = new Set), this.h = null, this.i = [];
        }
        function Ay(a) {
            return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
        }
        function Ny(a) {
            return a.h ? 1 : a.g ? a.g.size : 0;
        }
        function Mb(a, g) {
            return a.h ? a.h == g : a.g ? a.g.has(g) : !1;
        }
        function Pb(a, g) {
            a.g ? a.g.add(g) : a.h = g;
        }
        function Fy(a, g) {
            a.h && a.h == g ? a.h = null : a.g && a.g.has(g) && a.g.delete(g);
        }
        Cy.prototype.cancel = function() {
            if (this.i = My(this), this.h) this.h.cancel(), this.h = null;
            else if (this.g && this.g.size !== 0) {
                for (let a of this.g.values())a.cancel();
                this.g.clear();
            }
        };
        function My(a) {
            if (a.h != null) return a.i.concat(a.h.D);
            if (a.g != null && a.g.size !== 0) {
                let g = a.i;
                for (let f of a.g.values())g = g.concat(f.D);
                return g;
            }
            return L(a.i);
        }
        function gE(a) {
            if (a.V && typeof a.V == "function") return a.V();
            if (typeof Map < "u" && a instanceof Map || typeof Set < "u" && a instanceof Set) return Array.from(a.values());
            if (typeof a == "string") return a.split("");
            if (d(a)) {
                for(var g = [], f = a.length, k = 0; k < f; k++)g.push(a[k]);
                return g;
            }
            g = [], f = 0;
            for(k in a)g[f++] = a[k];
            return g;
        }
        function bE(a) {
            if (a.na && typeof a.na == "function") return a.na();
            if (!a.V || typeof a.V != "function") {
                if (typeof Map < "u" && a instanceof Map) return Array.from(a.keys());
                if (!(typeof Set < "u" && a instanceof Set)) {
                    if (d(a) || typeof a == "string") {
                        var g = [];
                        a = a.length;
                        for(var f = 0; f < a; f++)g.push(f);
                        return g;
                    }
                    g = [], f = 0;
                    for(let k in a)g[f++] = k;
                    return g;
                }
            }
        }
        function Py(a, g) {
            if (a.forEach && typeof a.forEach == "function") a.forEach(g, void 0);
            else if (d(a) || typeof a == "string") Array.prototype.forEach.call(a, g, void 0);
            else for(var f = bE(a), k = gE(a), B = k.length, j = 0; j < B; j++)g.call(void 0, k[j], f && f[j], a);
        }
        var Ly = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
        function pE(a, g) {
            if (a) {
                a = a.split("&");
                for(var f = 0; f < a.length; f++){
                    var k = a[f].indexOf("="), B = null;
                    if (0 <= k) {
                        var j = a[f].substring(0, k);
                        B = a[f].substring(k + 1);
                    } else j = a[f];
                    g(j, B ? decodeURIComponent(B.replace(/\+/g, " ")) : "");
                }
            }
        }
        function Fs(a) {
            if (this.g = this.o = this.j = "", this.s = null, this.m = this.l = "", this.h = !1, a instanceof Fs) {
                this.h = a.h, yv(this, a.j), this.o = a.o, this.g = a.g, Dv(this, a.s), this.l = a.l;
                var g = a.i, f = new Oi;
                f.i = g.i, g.g && (f.g = new Map(g.g), f.h = g.h), zy(this, f), this.m = a.m;
            } else a && (g = String(a).match(Ly)) ? (this.h = !1, yv(this, g[1] || "", !0), this.o = Li(g[2] || ""), this.g = Li(g[3] || "", !0), Dv(this, g[4]), this.l = Li(g[5] || "", !0), zy(this, g[6] || "", !0), this.m = Li(g[7] || "")) : (this.h = !1, this.i = new Oi(null, this.h));
        }
        Fs.prototype.toString = function() {
            var a = [], g = this.j;
            g && a.push(zi(g, Oy, !0), ":");
            var f = this.g;
            return (f || g == "file") && (a.push("//"), (g = this.o) && a.push(zi(g, Oy, !0), "@"), a.push(encodeURIComponent(String(f)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), f = this.s, f != null && a.push(":", String(f))), (f = this.l) && (this.g && f.charAt(0) != "/" && a.push("/"), a.push(zi(f, f.charAt(0) == "/" ? $E : mE, !0))), (f = this.i.toString()) && a.push("?", f), (f = this.m) && a.push("#", zi(f, yE)), a.join("");
        };
        function On(a) {
            return new Fs(a);
        }
        function yv(a, g, f) {
            a.j = f ? Li(g, !0) : g, a.j && (a.j = a.j.replace(/:$/, ""));
        }
        function Dv(a, g) {
            if (g) {
                if (g = Number(g), isNaN(g) || 0 > g) throw Error("Bad port number " + g);
                a.s = g;
            } else a.s = null;
        }
        function zy(a, g, f) {
            g instanceof Oi ? (a.i = g, DE(a.i, a.h)) : (f || (g = zi(g, hE)), a.i = new Oi(g, a.h));
        }
        function He(a, g, f) {
            a.i.set(g, f);
        }
        function wv(a) {
            return He(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36)), a;
        }
        function Li(a, g) {
            return a ? g ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
        }
        function zi(a, g, f) {
            return typeof a == "string" ? (a = encodeURI(a).replace(g, fE), f && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
        }
        function fE(a) {
            return a = a.charCodeAt(0), "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
        }
        var Oy = /[#\/\?@]/g, mE = /[#\?:]/g, $E = /[#\?]/g, hE = /[#\?@]/g, yE = /#/g;
        function Oi(a, g) {
            this.h = this.g = null, this.i = a || null, this.j = !!g;
        }
        function R0(a) {
            a.g || (a.g = new Map, a.h = 0, a.i && pE(a.i, function(g, f) {
                a.add(decodeURIComponent(g.replace(/\+/g, " ")), f);
            }));
        }
        e = Oi.prototype, e.add = function(a, g) {
            R0(this), this.i = null, a = Vc(this, a);
            var f = this.g.get(a);
            return f || this.g.set(a, f = []), f.push(g), this.h += 1, this;
        };
        function Uy(a, g) {
            R0(a), g = Vc(a, g), a.g.has(g) && (a.i = null, a.h -= a.g.get(g).length, a.g.delete(g));
        }
        function By(a, g) {
            return R0(a), g = Vc(a, g), a.g.has(g);
        }
        e.forEach = function(a, g) {
            R0(this), this.g.forEach(function(f, k) {
                f.forEach(function(B) {
                    a.call(g, B, k, this);
                }, this);
            }, this);
        }, e.na = function() {
            R0(this);
            let a = Array.from(this.g.values()), g = Array.from(this.g.keys()), f = [];
            for(let k = 0; k < g.length; k++){
                let B = a[k];
                for(let j = 0; j < B.length; j++)f.push(g[k]);
            }
            return f;
        }, e.V = function(a) {
            R0(this);
            let g = [];
            if (typeof a == "string") By(this, a) && (g = g.concat(this.g.get(Vc(this, a))));
            else {
                a = Array.from(this.g.values());
                for(let f = 0; f < a.length; f++)g = g.concat(a[f]);
            }
            return g;
        }, e.set = function(a, g) {
            return R0(this), this.i = null, a = Vc(this, a), By(this, a) && (this.h -= this.g.get(a).length), this.g.set(a, [
                g
            ]), this.h += 1, this;
        }, e.get = function(a, g) {
            return a ? (a = this.V(a), 0 < a.length ? String(a[0]) : g) : g;
        };
        function Jy(a, g, f) {
            Uy(a, g), 0 < f.length && (a.i = null, a.g.set(Vc(a, g), L(f)), a.h += f.length);
        }
        e.toString = function() {
            if (this.i) return this.i;
            if (!this.g) return "";
            let a = [], g = Array.from(this.g.keys());
            for(var f = 0; f < g.length; f++){
                var k = g[f];
                let j = encodeURIComponent(String(k)), u_ = this.V(k);
                for(k = 0; k < u_.length; k++){
                    var B = j;
                    u_[k] !== "" && (B += "=" + encodeURIComponent(String(u_[k]))), a.push(B);
                }
            }
            return this.i = a.join("&");
        };
        function Vc(a, g) {
            return g = String(g), a.j && (g = g.toLowerCase()), g;
        }
        function DE(a, g) {
            g && !a.j && (R0(a), a.i = null, a.g.forEach(function(f, k) {
                var B = k.toLowerCase();
                k != B && (Uy(this, k), Jy(this, B, f));
            }, a)), a.j = g;
        }
        function wE(a, g) {
            let f = new Cs;
            if (i.Image) {
                let k = new Image;
                k.onload = m(k0, f, "TestLoadImage: loaded", !0, g, k), k.onerror = m(k0, f, "TestLoadImage: error", !1, g, k), k.onabort = m(k0, f, "TestLoadImage: abort", !1, g, k), k.ontimeout = m(k0, f, "TestLoadImage: timeout", !1, g, k), i.setTimeout(function() {
                    k.ontimeout && k.ontimeout();
                }, 1e4), k.src = a;
            } else g(!1);
        }
        function RE(a, g) {
            let f = new Cs, k = new AbortController, B = setTimeout(()=>{
                k.abort(), k0(f, "TestPingServer: timeout", !1, g);
            }, 1e4);
            fetch(a, {
                signal: k.signal
            }).then((j)=>{
                clearTimeout(B), j.ok ? k0(f, "TestPingServer: ok", !0, g) : k0(f, "TestPingServer: server error", !1, g);
            }).catch(()=>{
                clearTimeout(B), k0(f, "TestPingServer: error", !1, g);
            });
        }
        function k0(a, g, f, k, B) {
            try {
                B && (B.onload = null, B.onerror = null, B.onabort = null, B.ontimeout = null), k(f);
            } catch  {}
        }
        function kE() {
            this.g = new Eb;
        }
        function SE(a, g, f) {
            let k = f || "";
            try {
                Py(a, function(B, j) {
                    let u_ = B;
                    v(B) && (u_ = Gi(B)), g.push(k + j + "=" + encodeURIComponent(u_));
                });
            } catch (B) {
                throw g.push(k + "type=" + encodeURIComponent("_badmap")), B;
            }
        }
        function Ui(a) {
            this.l = a.Ub || null, this.j = a.eb || !1;
        }
        z(Ui, Ci), Ui.prototype.g = function() {
            return new Rv(this.l, this.j);
        }, Ui.prototype.i = function(a) {
            return function() {
                return a;
            };
        }({});
        function Rv(a, g) {
            ee.call(this), this.D = a, this.o = g, this.m = void 0, this.status = this.readyState = 0, this.responseType = this.responseText = this.response = this.statusText = "", this.onreadystatechange = null, this.u = new Headers, this.h = null, this.B = "GET", this.A = "", this.g = !1, this.v = this.j = this.l = null;
        }
        z(Rv, ee), e = Rv.prototype, e.open = function(a, g) {
            if (this.readyState != 0) throw this.abort(), Error("Error reopening a connection");
            this.B = a, this.A = g, this.readyState = 1, Ji(this);
        }, e.send = function(a) {
            if (this.readyState != 1) throw this.abort(), Error("need to call open() first. ");
            this.g = !0;
            let g = {
                headers: this.u,
                method: this.B,
                credentials: this.m,
                cache: void 0
            };
            a && (g.body = a), (this.D || i).fetch(new Request(this.A, g)).then(this.Sa.bind(this), this.ga.bind(this));
        }, e.abort = function() {
            this.response = this.responseText = "", this.u = new Headers, this.status = 0, this.j && this.j.cancel("Request was aborted.").catch(()=>{}), 1 <= this.readyState && this.g && this.readyState != 4 && (this.g = !1, Bi(this)), this.readyState = 0;
        }, e.Sa = function(a) {
            if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Ji(this)), this.g && (this.readyState = 3, Ji(this), this.g))) {
                if (this.responseType === "arraybuffer") a.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));
                else if (typeof i.ReadableStream < "u" && "body" in a) {
                    if (this.j = a.body.getReader(), this.o) {
                        if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                        this.response = [];
                    } else this.response = this.responseText = "", this.v = new TextDecoder;
                    Vy(this);
                } else a.text().then(this.Ra.bind(this), this.ga.bind(this));
            }
        };
        function Vy(a) {
            a.j.read().then(a.Pa.bind(a)).catch(a.ga.bind(a));
        }
        e.Pa = function(a) {
            if (this.g) {
                if (this.o && a.value) this.response.push(a.value);
                else if (!this.o) {
                    var g = a.value ? a.value : new Uint8Array(0);
                    (g = this.v.decode(g, {
                        stream: !a.done
                    })) && (this.response = this.responseText += g);
                }
                a.done ? Bi(this) : Ji(this), this.readyState == 3 && Vy(this);
            }
        }, e.Ra = function(a) {
            this.g && (this.response = this.responseText = a, Bi(this));
        }, e.Qa = function(a) {
            this.g && (this.response = a, Bi(this));
        }, e.ga = function() {
            this.g && Bi(this);
        };
        function Bi(a) {
            a.readyState = 4, a.l = null, a.j = null, a.v = null, Ji(a);
        }
        e.setRequestHeader = function(a, g) {
            this.u.append(a, g);
        }, e.getResponseHeader = function(a) {
            return this.h && this.h.get(a.toLowerCase()) || "";
        }, e.getAllResponseHeaders = function() {
            if (!this.h) return "";
            let a = [], g = this.h.entries();
            for(var f = g.next(); !f.done;)f = f.value, a.push(f[0] + ": " + f[1]), f = g.next();
            return a.join(`\r
`);
        };
        function Ji(a) {
            a.onreadystatechange && a.onreadystatechange.call(a);
        }
        Object.defineProperty(Rv.prototype, "withCredentials", {
            get: function() {
                return this.m === "include";
            },
            set: function(a) {
                this.m = a ? "include" : "same-origin";
            }
        });
        function qy(a) {
            let g = "";
            return F(a, function(f, k) {
                g += k, g += ":", g += f, g += `\r
`;
            }), g;
        }
        function Lb(a, g, f) {
            _: {
                for(k in f){
                    var k = !1;
                    break _;
                }
                k = !0;
            }
            k || (f = qy(f), typeof a == "string" ? f != null && encodeURIComponent(String(f)) : He(a, g, f));
        }
        function vo(a) {
            ee.call(this), this.headers = new Map, this.o = a || null, this.h = !1, this.v = this.g = null, this.D = "", this.m = 0, this.l = "", this.j = this.B = this.u = this.A = !1, this.I = null, this.H = "", this.J = !1;
        }
        z(vo, ee);
        var IE = /^https?$/i, xE = [
            "POST",
            "PUT"
        ];
        e = vo.prototype, e.Ha = function(a) {
            this.J = a;
        }, e.ea = function(a, g, f, k) {
            if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
            g = g ? g.toUpperCase() : "GET", this.D = a, this.l = "", this.m = 0, this.A = !1, this.h = !0, this.g = this.o ? this.o.g() : Fi.g(), this.v = this.o ? dv(this.o) : dv(Fi), this.g.onreadystatechange = u(this.Ea, this);
            try {
                this.B = !0, this.g.open(g, String(a), !0), this.B = !1;
            } catch (j) {
                Wy(this, j);
                return;
            }
            if (a = f || "", f = new Map(this.headers), k) {
                if (Object.getPrototypeOf(k) === Object.prototype) for(var B in k)f.set(B, k[B]);
                else if (typeof k.keys == "function" && typeof k.get == "function") for (let j of k.keys())f.set(j, k.get(j));
                else throw Error("Unknown input type for opt_headers: " + String(k));
            }
            k = Array.from(f.keys()).find((j)=>j.toLowerCase() == "content-type"), B = i.FormData && a instanceof i.FormData, !(0 <= Array.prototype.indexOf.call(xE, g, void 0)) || k || B || f.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
            for (let [j, u_] of f)this.g.setRequestHeader(j, u_);
            this.H && (this.g.responseType = this.H), "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);
            try {
                Ky(this), this.u = !0, this.g.send(a), this.u = !1;
            } catch (j) {
                Wy(this, j);
            }
        };
        function Wy(a, g) {
            a.h = !1, a.g && (a.j = !0, a.g.abort(), a.j = !1), a.l = g, a.m = 5, Hy(a), kv(a);
        }
        function Hy(a) {
            a.A || (a.A = !0, Ge(a, "complete"), Ge(a, "error"));
        }
        e.abort = function(a) {
            this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.m = a || 7, Ge(this, "complete"), Ge(this, "abort"), kv(this));
        }, e.N = function() {
            this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), kv(this, !0)), vo.aa.N.call(this);
        }, e.Ea = function() {
            this.s || (this.B || this.u || this.j ? jy(this) : this.bb());
        }, e.bb = function() {
            jy(this);
        };
        function jy(a) {
            if (a.h && typeof c < "u" && (!a.v[1] || Un(a) != 4 || a.Z() != 2)) {
                if (a.u && Un(a) == 4) er(a.Ea, 0, a);
                else if (Ge(a, "readystatechange"), Un(a) == 4) {
                    a.h = !1;
                    try {
                        let u_ = a.Z();
                        _: switch(u_){
                            case 200:
                            case 201:
                            case 202:
                            case 204:
                            case 206:
                            case 304:
                            case 1223:
                                var g = !0;
                                break _;
                            default:
                                g = !1;
                        }
                        var f;
                        if (!(f = g)) {
                            var k;
                            if (k = u_ === 0) {
                                var B = String(a.D).match(Ly)[1] || null;
                                !B && i.self && i.self.location && (B = i.self.location.protocol.slice(0, -1)), k = !IE.test(B ? B.toLowerCase() : "");
                            }
                            f = k;
                        }
                        if (f) Ge(a, "complete"), Ge(a, "success");
                        else {
                            a.m = 6;
                            try {
                                var j = 2 < Un(a) ? a.g.statusText : "";
                            } catch  {
                                j = "";
                            }
                            a.l = j + " [" + a.Z() + "]", Hy(a);
                        }
                    } finally{
                        kv(a);
                    }
                }
            }
        }
        function kv(a, g) {
            if (a.g) {
                Ky(a);
                let f = a.g, k = a.v[0] ? ()=>{} : null;
                a.g = null, a.v = null, g || Ge(a, "ready");
                try {
                    f.onreadystatechange = k;
                } catch  {}
            }
        }
        function Ky(a) {
            a.I && (i.clearTimeout(a.I), a.I = null);
        }
        e.isActive = function() {
            return !!this.g;
        };
        function Un(a) {
            return a.g ? a.g.readyState : 0;
        }
        e.Z = function() {
            try {
                return 2 < Un(this) ? this.g.status : -1;
            } catch  {
                return -1;
            }
        }, e.oa = function() {
            try {
                return this.g ? this.g.responseText : "";
            } catch  {
                return "";
            }
        }, e.Oa = function(a) {
            if (this.g) {
                var g = this.g.responseText;
                return a && g.indexOf(a) == 0 && (g = g.substring(a.length)), xb(g);
            }
        };
        function Qy(a) {
            try {
                if (!a.g) return null;
                if ("response" in a.g) return a.g.response;
                switch(a.H){
                    case "":
                    case "text":
                        return a.g.responseText;
                    case "arraybuffer":
                        if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
                }
                return null;
            } catch  {
                return null;
            }
        }
        function EE(a) {
            let g = {};
            a = (a.g && 2 <= Un(a) && a.g.getAllResponseHeaders() || "").split(`\r
`);
            for(let k = 0; k < a.length; k++){
                if (t_(a[k])) continue;
                var f = C(a[k]);
                let B = f[0];
                if (f = f[1], typeof f != "string") continue;
                f = f.trim();
                let j = g[B] || [];
                g[B] = j, j.push(f);
            }
            y(g, function(k) {
                return k.join(", ");
            });
        }
        e.Ba = function() {
            return this.m;
        }, e.Ka = function() {
            return typeof this.l == "string" ? this.l : String(this.l);
        };
        function Vi(a, g, f) {
            return f && f.internalChannelParams && f.internalChannelParams[a] || g;
        }
        function Yy(a) {
            this.Aa = 0, this.i = [], this.j = new Cs, this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null, this.Ya = this.U = 0, this.Va = Vi("failFast", !1, a), this.F = this.C = this.u = this.s = this.l = null, this.X = !0, this.za = this.T = -1, this.Y = this.v = this.B = 0, this.Ta = Vi("baseRetryDelayMs", 5e3, a), this.cb = Vi("retryDelaySeedMs", 1e4, a), this.Wa = Vi("forwardChannelMaxRetries", 2, a), this.wa = Vi("forwardChannelRequestTimeoutMs", 2e4, a), this.pa = a && a.xmlHttpFactory || void 0, this.Xa = a && a.Tb || void 0, this.Ca = a && a.useFetchStreams || !1, this.L = void 0, this.J = a && a.supportsCrossDomainXhr || !1, this.K = "", this.h = new Cy(a && a.concurrentRequestLimit), this.Da = new kE, this.P = a && a.fastHandshake || !1, this.O = a && a.encodeInitMessageHeaders || !1, this.P && this.O && (this.O = !1), this.Ua = a && a.Rb || !1, a && a.xa && this.j.xa(), a && a.forceLongPolling && (this.X = !1), this.ba = !this.P && this.X && a && a.detectBufferingProxy || !1, this.ja = void 0, a && a.longPollingTimeout && 0 < a.longPollingTimeout && (this.ja = a.longPollingTimeout), this.ca = void 0, this.R = 0, this.M = !1, this.ka = this.A = null;
        }
        e = Yy.prototype, e.la = 8, e.G = 1, e.connect = function(a, g, f, k) {
            or(0), this.W = a, this.H = g || {}, f && k !== void 0 && (this.H.OSID = f, this.H.OAID = k), this.F = this.X, this.I = s2(this, null, this.W), Iv(this);
        };
        function zb(a) {
            if (Xy(a), a.G == 3) {
                var g = a.U++, f = On(a.I);
                if (He(f, "SID", a.K), He(f, "RID", g), He(f, "TYPE", "terminate"), qi(a, f), g = new Zt(a, a.j, g), g.L = 2, g.v = wv(On(f)), f = !1, i.navigator && i.navigator.sendBeacon) try {
                    f = i.navigator.sendBeacon(g.v.toString(), "");
                } catch  {}
                !f && i.Image && (new Image().src = g.v, f = !0), f || (g.g = c2(g.j, null), g.g.ea(g.v)), g.F = Date.now(), hv(g);
            }
            n2(a);
        }
        function Sv(a) {
            a.g && (Ub(a), a.g.cancel(), a.g = null);
        }
        function Xy(a) {
            Sv(a), a.u && (i.clearTimeout(a.u), a.u = null), xv(a), a.h.cancel(), a.s && (typeof a.s == "number" && i.clearTimeout(a.s), a.s = null);
        }
        function Iv(a) {
            if (!Ay(a.h) && !a.s) {
                a.s = !0;
                var g = a.Ga;
                g_ || p_(), U_ || (g_(), U_ = !0), we.add(g, a), a.B = 0;
            }
        }
        function TE(a, g) {
            return Ny(a.h) >= a.h.j - (a.s ? 1 : 0) ? !1 : a.s ? (a.i = g.D.concat(a.i), !0) : a.G == 1 || a.G == 2 || a.B >= (a.Va ? 0 : a.Wa) ? !1 : (a.s = Gs(u(a.Ga, a, g), t2(a, a.B)), a.B++, !0);
        }
        e.Ga = function(a) {
            if (this.s) {
                if (this.s = null, this.G == 1) {
                    if (!a) {
                        this.U = Math.floor(1e5 * Math.random()), a = this.U++;
                        let B = new Zt(this, this.j, a), j = this.o;
                        if (this.S && (j ? (j = w(j), T(j, this.S)) : j = this.S), this.m !== null || this.O || (B.H = j, j = null), this.P) _: {
                            for(var g = 0, f = 0; f < this.i.length; f++){
                                e: {
                                    var k = this.i[f];
                                    if ("__data__" in k.map && (k = k.map.__data__, typeof k == "string")) {
                                        k = k.length;
                                        break e;
                                    }
                                    k = void 0;
                                }
                                if (k === void 0) break;
                                if (g += k, 4096 < g) {
                                    g = f;
                                    break _;
                                }
                                if (g === 4096 || f === this.i.length - 1) {
                                    g = f + 1;
                                    break _;
                                }
                            }
                            g = 1e3;
                        }
                        else g = 1e3;
                        g = _2(this, B, g), f = On(this.I), He(f, "RID", a), He(f, "CVER", 22), this.D && He(f, "X-HTTP-Session-Id", this.D), qi(this, f), j && (this.O ? g = "headers=" + encodeURIComponent(String(qy(j))) + "&" + g : this.m && Lb(f, this.m, j)), Pb(this.h, B), this.Ua && He(f, "TYPE", "init"), this.P ? (He(f, "$req", g), He(f, "SID", "null"), B.T = !0, As(B, f, null)) : As(B, f, g), this.G = 2;
                    }
                } else this.G == 3 && (a ? Zy(this, a) : this.i.length == 0 || Ay(this.h) || Zy(this));
            }
        };
        function Zy(a, g) {
            var f;
            g ? f = g.l : f = a.U++;
            let k = On(a.I);
            He(k, "SID", a.K), He(k, "RID", f), He(k, "AID", a.T), qi(a, k), a.m && a.o && Lb(k, a.m, a.o), f = new Zt(a, a.j, f, a.B + 1), a.m === null && (f.H = a.o), g && (a.i = g.D.concat(a.i)), g = _2(a, f, 1e3), f.I = Math.round(.5 * a.wa) + Math.round(.5 * a.wa * Math.random()), Pb(a.h, f), As(f, k, g);
        }
        function qi(a, g) {
            a.H && F(a.H, function(f, k) {
                He(g, k, f);
            }), a.l && Py({}, function(f, k) {
                He(g, k, f);
            });
        }
        function _2(a, g, f) {
            f = Math.min(a.i.length, f);
            var k = a.l ? u(a.l.Na, a.l, a) : null;
            _: {
                var B = a.i;
                let j = -1;
                for(;;){
                    let u_ = [
                        "count=" + f
                    ];
                    j == -1 ? 0 < f ? (j = B[0].g, u_.push("ofs=" + j)) : j = 0 : u_.push("ofs=" + j);
                    let Be = !0;
                    for(let rr = 0; rr < f; rr++){
                        let Ce = B[rr].g, vr = B[rr].map;
                        if (Ce -= j, 0 > Ce) j = Math.max(0, B[rr].g - 100), Be = !1;
                        else try {
                            SE(vr, u_, "req" + Ce + "_");
                        } catch  {
                            k && k(vr);
                        }
                    }
                    if (Be) {
                        k = u_.join("&");
                        break _;
                    }
                }
            }
            return a = a.i.splice(0, f), g.D = a, k;
        }
        function e2(a) {
            if (!a.g && !a.u) {
                a.Y = 1;
                var g = a.Fa;
                g_ || p_(), U_ || (g_(), U_ = !0), we.add(g, a), a.v = 0;
            }
        }
        function Ob(a) {
            return a.g || a.u || 3 <= a.v ? !1 : (a.Y++, a.u = Gs(u(a.Fa, a), t2(a, a.v)), a.v++, !0);
        }
        e.Fa = function() {
            if (this.u = null, o2(this), this.ba && !(this.M || this.g == null || 0 >= this.R)) {
                var a = 2 * this.R;
                this.j.info("BP detection timer enabled: " + a), this.A = Gs(u(this.ab, this), a);
            }
        }, e.ab = function() {
            this.A && (this.A = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.M = !0, or(10), Sv(this), o2(this));
        };
        function Ub(a) {
            a.A != null && (i.clearTimeout(a.A), a.A = null);
        }
        function o2(a) {
            a.g = new Zt(a, a.j, "rpc", a.Y), a.m === null && (a.g.H = a.o), a.g.O = 0;
            var g = On(a.qa);
            He(g, "RID", "rpc"), He(g, "SID", a.K), He(g, "AID", a.T), He(g, "CI", a.F ? "0" : "1"), !a.F && a.ja && He(g, "TO", a.ja), He(g, "TYPE", "xmlhttp"), qi(a, g), a.m && a.o && Lb(g, a.m, a.o), a.L && (a.g.I = a.L);
            var f = a.g;
            a = a.ia, f.L = 1, f.v = wv(On(g)), f.m = null, f.P = !0, I(f, a);
        }
        e.Za = function() {
            this.C != null && (this.C = null, Sv(this), Ob(this), or(19));
        };
        function xv(a) {
            a.C != null && (i.clearTimeout(a.C), a.C = null);
        }
        function r2(a, g) {
            var f = null;
            if (a.g == g) {
                xv(a), Ub(a), a.g = null;
                var k = 2;
            } else if (Mb(a.h, g)) f = g.D, Fy(a.h, g), k = 1;
            else return;
            if (a.G != 0) {
                if (g.o) {
                    if (k == 1) {
                        f = g.m ? g.m.length : 0, g = Date.now() - g.F;
                        var B = a.B;
                        k = Uc(), Ge(k, new pv(k, f)), Iv(a);
                    } else e2(a);
                } else if (B = g.s, B == 3 || B == 0 && 0 < g.X || !(k == 1 && TE(a, g) || k == 2 && Ob(a))) switch(f && 0 < f.length && (g = a.h, g.i = g.i.concat(f)), B){
                    case 1:
                        Ms(a, 5);
                        break;
                    case 4:
                        Ms(a, 10);
                        break;
                    case 3:
                        Ms(a, 6);
                        break;
                    default:
                        Ms(a, 2);
                }
            }
        }
        function t2(a, g) {
            let f = a.Ta + Math.floor(Math.random() * a.cb);
            return a.isActive() || (f *= 2), f * g;
        }
        function Ms(a, g) {
            if (a.j.info("Error code " + g), g == 2) {
                var f = u(a.fb, a), k = a.Xa;
                let B = !k;
                k = new Fs(k || "//www.google.com/images/cleardot.gif"), i.location && i.location.protocol == "http" || yv(k, "https"), wv(k), B ? wE(k.toString(), f) : RE(k.toString(), f);
            } else or(2);
            a.G = 0, a.l && a.l.sa(g), n2(a), Xy(a);
        }
        e.fb = function(a) {
            a ? (this.j.info("Successfully pinged google.com"), or(2)) : (this.j.info("Failed to ping google.com"), or(1));
        };
        function n2(a) {
            if (a.G = 0, a.ka = [], a.l) {
                let g = My(a.h);
                (g.length != 0 || a.i.length != 0) && (J(a.ka, g), J(a.ka, a.i), a.h.i.length = 0, L(a.i), a.i.length = 0), a.l.ra();
            }
        }
        function s2(a, g, f) {
            var k = f instanceof Fs ? On(f) : new Fs(f);
            if (k.g != "") g && (k.g = g + "." + k.g), Dv(k, k.s);
            else {
                var B = i.location;
                k = B.protocol, g = g ? g + "." + B.hostname : B.hostname, B = +B.port;
                var j = new Fs(null);
                k && yv(j, k), g && (j.g = g), B && Dv(j, B), f && (j.l = f), k = j;
            }
            return f = a.D, g = a.ya, f && g && He(k, f, g), He(k, "VER", a.la), qi(a, k), k;
        }
        function c2(a, g, f) {
            if (g && !a.J) throw Error("Can't create secondary domain capable XhrIo object.");
            return g = a.Ca && !a.pa ? new vo(new Ui({
                eb: f
            })) : new vo(a.pa), g.Ha(a.J), g;
        }
        e.isActive = function() {
            return !!this.l && this.l.isActive(this);
        };
        function a2() {}
        e = a2.prototype, e.ua = function() {}, e.ta = function() {}, e.sa = function() {}, e.ra = function() {}, e.isActive = function() {
            return !0;
        }, e.Na = function() {};
        function Ev() {}
        Ev.prototype.g = function(a, g) {
            return new tt(a, g);
        };
        function tt(a, g) {
            ee.call(this), this.g = new Yy(g), this.l = a, this.h = g && g.messageUrlParams || null, a = g && g.messageHeaders || null, g && g.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
                "X-Client-Protocol": "webchannel"
            }), this.g.o = a, a = g && g.initMessageHeaders || null, g && g.messageContentType && (a ? a["X-WebChannel-Content-Type"] = g.messageContentType : a = {
                "X-WebChannel-Content-Type": g.messageContentType
            }), g && g.va && (a ? a["X-WebChannel-Client-Profile"] = g.va : a = {
                "X-WebChannel-Client-Profile": g.va
            }), this.g.S = a, (a = g && g.Sb) && !t_(a) && (this.g.m = a), this.v = g && g.supportsCrossDomainXhr || !1, this.u = g && g.sendRawJson || !1, (g = g && g.httpSessionIdParam) && !t_(g) && (this.g.D = g, a = this.h, a !== null && g in a && (a = this.h, g in a && delete a[g])), this.j = new qc(this);
        }
        z(tt, ee), tt.prototype.m = function() {
            this.g.l = this.j, this.v && (this.g.J = !0), this.g.connect(this.l, this.h || void 0);
        }, tt.prototype.close = function() {
            zb(this.g);
        }, tt.prototype.o = function(a) {
            var g = this.g;
            if (typeof a == "string") {
                var f = {};
                f.__data__ = a, a = f;
            } else this.u && (f = {}, f.__data__ = Gi(a), a = f);
            g.i.push(new uE(g.Ya++, a)), g.G == 3 && Iv(g);
        }, tt.prototype.N = function() {
            this.g.l = null, delete this.j, zb(this.g), delete this.g, tt.aa.N.call(this);
        };
        function i2(a) {
            Ai.call(this), a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
            var g = a.__sm__;
            if (g) {
                _: {
                    for(let f in g){
                        a = f;
                        break _;
                    }
                    a = void 0;
                }
                (this.i = a) && (a = this.i, g = g !== null && a in g ? g[a] : void 0), this.data = g;
            } else this.data = a;
        }
        z(i2, Ai);
        function l2() {
            Ni.call(this), this.status = 1;
        }
        z(l2, Ni);
        function qc(a) {
            this.g = a;
        }
        z(qc, a2), qc.prototype.ua = function() {
            Ge(this.g, "a");
        }, qc.prototype.ta = function(a) {
            Ge(this.g, new i2(a));
        }, qc.prototype.sa = function(a) {
            Ge(this.g, new l2);
        }, qc.prototype.ra = function() {
            Ge(this.g, "b");
        }, Ev.prototype.createWebChannel = Ev.prototype.g, tt.prototype.send = tt.prototype.o, tt.prototype.open = tt.prototype.m, tt.prototype.close = tt.prototype.close, D5 = Xn.createWebChannelTransport = function() {
            return new Ev;
        }, y5 = Xn.getStatEventTarget = function() {
            return Uc();
        }, h5 = Xn.Event = zn, du = Xn.Stat = {
            mb: 0,
            pb: 1,
            qb: 2,
            Jb: 3,
            Ob: 4,
            Lb: 5,
            Mb: 6,
            Kb: 7,
            Ib: 8,
            Nb: 9,
            PROXY: 10,
            NOPROXY: 11,
            Gb: 12,
            Cb: 13,
            Db: 14,
            Bb: 15,
            Eb: 16,
            Fb: 17,
            ib: 18,
            hb: 19,
            jb: 20
        }, Bc.NO_ERROR = 0, Bc.TIMEOUT = 8, Bc.HTTP_ERROR = 6, $l = Xn.ErrorCode = Bc, fv.COMPLETE = "complete", $5 = Xn.EventType = fv, vv.EventType = Es, Es.OPEN = "a", Es.CLOSE = "b", Es.ERROR = "c", Es.MESSAGE = "d", ee.prototype.listen = ee.prototype.K, ga = Xn.WebChannel = vv, m5 = Xn.FetchXmlHttpFactory = Ui, vo.prototype.listenOnce = vo.prototype.L, vo.prototype.getLastError = vo.prototype.Ka, vo.prototype.getLastErrorCode = vo.prototype.Ba, vo.prototype.getStatus = vo.prototype.Z, vo.prototype.getResponseJson = vo.prototype.Oa, vo.prototype.getResponseText = vo.prototype.oa, vo.prototype.send = vo.prototype.ea, vo.prototype.setWithCredentials = vo.prototype.Ha, f5 = Xn.XhrIo = vo;
    }).apply(typeof lu < "u" ? lu : typeof self < "u" ? self : typeof window < "u" ? window : {});
    var Q9 = "@firebase/firestore";
    var Yo = class {
        constructor(_){
            this.uid = _;
        }
        isAuthenticated() {
            return this.uid != null;
        }
        toKey() {
            return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
        }
        isEqual(_) {
            return _.uid === this.uid;
        }
    };
    Yo.UNAUTHENTICATED = new Yo(null), Yo.GOOGLE_CREDENTIALS = new Yo("google-credentials-uid"), Yo.FIRST_PARTY = new Yo("first-party-uid"), Yo.MOCK_USER = new Yo("mock-user");
    var Na = "10.12.3";
    var ec = new J0("@firebase/firestore");
    function hl() {
        return ec.logLevel;
    }
    function k_(e, ..._) {
        if (ec.logLevel <= ye.DEBUG) {
            let r = _.map(am);
            ec.debug(`Firestore (${Na}): ${e}`, ...r);
        }
    }
    function _0(e, ..._) {
        if (ec.logLevel <= ye.ERROR) {
            let r = _.map(am);
            ec.error(`Firestore (${Na}): ${e}`, ...r);
        }
    }
    function ya(e, ..._) {
        if (ec.logLevel <= ye.WARN) {
            let r = _.map(am);
            ec.warn(`Firestore (${Na}): ${e}`, ...r);
        }
    }
    function am(e) {
        if (typeof e == "string") return e;
        try {
            return function(r) {
                return JSON.stringify(r);
            }(e);
        } catch  {
            return e;
        }
    }
    function Z_(e = "Unexpected state") {
        let _ = `FIRESTORE (${Na}) INTERNAL ASSERTION FAILED: ` + e;
        throw _0(_), new Error(_);
    }
    function Ve(e, _) {
        e || Z_();
    }
    function ce(e, _) {
        return e;
    }
    var o_ = {
        OK: "ok",
        CANCELLED: "cancelled",
        UNKNOWN: "unknown",
        INVALID_ARGUMENT: "invalid-argument",
        DEADLINE_EXCEEDED: "deadline-exceeded",
        NOT_FOUND: "not-found",
        ALREADY_EXISTS: "already-exists",
        PERMISSION_DENIED: "permission-denied",
        UNAUTHENTICATED: "unauthenticated",
        RESOURCE_EXHAUSTED: "resource-exhausted",
        FAILED_PRECONDITION: "failed-precondition",
        ABORTED: "aborted",
        OUT_OF_RANGE: "out-of-range",
        UNIMPLEMENTED: "unimplemented",
        INTERNAL: "internal",
        UNAVAILABLE: "unavailable",
        DATA_LOSS: "data-loss"
    }, R_ = class extends Nr {
        constructor(_, r){
            super(_, r), this.code = _, this.message = r, this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
        }
    };
    var un = class {
        constructor(){
            this.promise = new Promise((_, r)=>{
                this.resolve = _, this.reject = r;
            });
        }
    };
    var pu = class {
        constructor(_, r){
            this.user = r, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${_}`);
        }
    }, I5 = class {
        getToken() {
            return Promise.resolve(null);
        }
        invalidateToken() {}
        start(_, r) {
            _.enqueueRetryable(()=>r(Yo.UNAUTHENTICATED));
        }
        shutdown() {}
    }, x5 = class {
        constructor(_){
            this.token = _, this.changeListener = null;
        }
        getToken() {
            return Promise.resolve(this.token);
        }
        invalidateToken() {}
        start(_, r) {
            this.changeListener = r, _.enqueueRetryable(()=>r(this.token.user));
        }
        shutdown() {
            this.changeListener = null;
        }
    }, E5 = class {
        constructor(_){
            this.t = _, this.currentUser = Yo.UNAUTHENTICATED, this.i = 0, this.forceRefresh = !1, this.auth = null;
        }
        start(_, r) {
            let t = this.i, n = (d)=>this.i !== t ? (t = this.i, r(d)) : Promise.resolve(), s = new un;
            this.o = ()=>{
                this.i++, this.currentUser = this.u(), s.resolve(), s = new un, _.enqueueRetryable(()=>n(this.currentUser));
            };
            let c = ()=>{
                let d = s;
                _.enqueueRetryable(async ()=>{
                    await d.promise, await n(this.currentUser);
                });
            }, i = (d)=>{
                k_("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = d, this.auth.addAuthTokenListener(this.o), c();
            };
            this.t.onInit((d)=>i(d)), setTimeout(()=>{
                if (!this.auth) {
                    let d = this.t.getImmediate({
                        optional: !0
                    });
                    d ? i(d) : (k_("FirebaseAuthCredentialsProvider", "Auth not yet detected"), s.resolve(), s = new un);
                }
            }, 0), c();
        }
        getToken() {
            let _ = this.i, r = this.forceRefresh;
            return this.forceRefresh = !1, this.auth ? this.auth.getToken(r).then((t)=>this.i !== _ ? (k_("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? (Ve(typeof t.accessToken == "string"), new pu(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
        }
        invalidateToken() {
            this.forceRefresh = !0;
        }
        shutdown() {
            this.auth && this.auth.removeAuthTokenListener(this.o);
        }
        u() {
            let _ = this.auth && this.auth.getUid();
            return Ve(_ === null || typeof _ == "string"), new Yo(_);
        }
    }, T5 = class {
        constructor(_, r, t){
            this.l = _, this.h = r, this.P = t, this.type = "FirstParty", this.user = Yo.FIRST_PARTY, this.I = new Map;
        }
        T() {
            return this.P ? this.P() : null;
        }
        get headers() {
            this.I.set("X-Goog-AuthUser", this.l);
            let _ = this.T();
            return _ && this.I.set("Authorization", _), this.h && this.I.set("X-Goog-Iam-Authorization-Token", this.h), this.I;
        }
    }, G5 = class {
        constructor(_, r, t){
            this.l = _, this.h = r, this.P = t;
        }
        getToken() {
            return Promise.resolve(new T5(this.l, this.h, this.P));
        }
        start(_, r) {
            _.enqueueRetryable(()=>r(Yo.FIRST_PARTY));
        }
        shutdown() {}
        invalidateToken() {}
    }, C5 = class {
        constructor(_){
            this.value = _, this.type = "AppCheck", this.headers = new Map, _ && _.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
        }
    }, A5 = class {
        constructor(_){
            this.A = _, this.forceRefresh = !1, this.appCheck = null, this.R = null;
        }
        start(_, r) {
            let t = (s)=>{
                s.error != null && k_("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${s.error.message}`);
                let c = s.token !== this.R;
                return this.R = s.token, k_("FirebaseAppCheckTokenProvider", `Received ${c ? "new" : "existing"} token.`), c ? r(s.token) : Promise.resolve();
            };
            this.o = (s)=>{
                _.enqueueRetryable(()=>t(s));
            };
            let n = (s)=>{
                k_("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = s, this.appCheck.addTokenListener(this.o);
            };
            this.A.onInit((s)=>n(s)), setTimeout(()=>{
                if (!this.appCheck) {
                    let s = this.A.getImmediate({
                        optional: !0
                    });
                    s ? n(s) : k_("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
                }
            }, 0);
        }
        getToken() {
            let _ = this.forceRefresh;
            return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(_).then((r)=>r ? (Ve(typeof r.token == "string"), this.R = r.token, new C5(r.token)) : null) : Promise.resolve(null);
        }
        invalidateToken() {
            this.forceRefresh = !0;
        }
        shutdown() {
            this.appCheck && this.appCheck.removeTokenListener(this.o);
        }
    };
    function kA(e) {
        let _ = typeof self < "u" && (self.crypto || self.msCrypto), r = new Uint8Array(e);
        if (_ && typeof _.getRandomValues == "function") _.getRandomValues(r);
        else for(let t = 0; t < e; t++)r[t] = Math.floor(256 * Math.random());
        return r;
    }
    var fu = class {
        static newId() {
            let _ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", r = Math.floor(256 / _.length) * _.length, t = "";
            for(; t.length < 20;){
                let n = kA(40);
                for(let s = 0; s < n.length; ++s)t.length < 20 && n[s] < r && (t += _.charAt(n[s] % _.length));
            }
            return t;
        }
    };
    function Ae(e, _) {
        return e < _ ? -1 : e > _ ? 1 : 0;
    }
    function Da(e, _, r) {
        return e.length === _.length && e.every((t, n)=>r(t, _[n]));
    }
    var sr = class e {
        constructor(_, r){
            if (this.seconds = _, this.nanoseconds = r, r < 0) throw new R_(o_.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + r);
            if (r >= 1e9) throw new R_(o_.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + r);
            if (_ < -62135596800) throw new R_(o_.INVALID_ARGUMENT, "Timestamp seconds out of range: " + _);
            if (_ >= 253402300800) throw new R_(o_.INVALID_ARGUMENT, "Timestamp seconds out of range: " + _);
        }
        static now() {
            return e.fromMillis(Date.now());
        }
        static fromDate(_) {
            return e.fromMillis(_.getTime());
        }
        static fromMillis(_) {
            let r = Math.floor(_ / 1e3), t = Math.floor(1e6 * (_ - 1e3 * r));
            return new e(r, t);
        }
        toDate() {
            return new Date(this.toMillis());
        }
        toMillis() {
            return 1e3 * this.seconds + this.nanoseconds / 1e6;
        }
        _compareTo(_) {
            return this.seconds === _.seconds ? Ae(this.nanoseconds, _.nanoseconds) : Ae(this.seconds, _.seconds);
        }
        isEqual(_) {
            return _.seconds === this.seconds && _.nanoseconds === this.nanoseconds;
        }
        toString() {
            return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
        }
        toJSON() {
            return {
                seconds: this.seconds,
                nanoseconds: this.nanoseconds
            };
        }
        valueOf() {
            let _ = this.seconds - -62135596800;
            return String(_).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
        }
    };
    var le = class e {
        constructor(_){
            this.timestamp = _;
        }
        static fromTimestamp(_) {
            return new e(_);
        }
        static min() {
            return new e(new sr(0, 0));
        }
        static max() {
            return new e(new sr(253402300799, 999999999));
        }
        compareTo(_) {
            return this.timestamp._compareTo(_.timestamp);
        }
        isEqual(_) {
            return this.timestamp.isEqual(_.timestamp);
        }
        toMicroseconds() {
            return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
        }
        toString() {
            return "SnapshotVersion(" + this.timestamp.toString() + ")";
        }
        toTimestamp() {
            return this.timestamp;
        }
    };
    var mu = class e {
        constructor(_, r, t){
            r === void 0 ? r = 0 : r > _.length && Z_(), t === void 0 ? t = _.length - r : t > _.length - r && Z_(), this.segments = _, this.offset = r, this.len = t;
        }
        get length() {
            return this.len;
        }
        isEqual(_) {
            return e.comparator(this, _) === 0;
        }
        child(_) {
            let r = this.segments.slice(this.offset, this.limit());
            return _ instanceof e ? _.forEach((t)=>{
                r.push(t);
            }) : r.push(_), this.construct(r);
        }
        limit() {
            return this.offset + this.length;
        }
        popFirst(_) {
            return _ = _ === void 0 ? 1 : _, this.construct(this.segments, this.offset + _, this.length - _);
        }
        popLast() {
            return this.construct(this.segments, this.offset, this.length - 1);
        }
        firstSegment() {
            return this.segments[this.offset];
        }
        lastSegment() {
            return this.get(this.length - 1);
        }
        get(_) {
            return this.segments[this.offset + _];
        }
        isEmpty() {
            return this.length === 0;
        }
        isPrefixOf(_) {
            if (_.length < this.length) return !1;
            for(let r = 0; r < this.length; r++)if (this.get(r) !== _.get(r)) return !1;
            return !0;
        }
        isImmediateParentOf(_) {
            if (this.length + 1 !== _.length) return !1;
            for(let r = 0; r < this.length; r++)if (this.get(r) !== _.get(r)) return !1;
            return !0;
        }
        forEach(_) {
            for(let r = this.offset, t = this.limit(); r < t; r++)_(this.segments[r]);
        }
        toArray() {
            return this.segments.slice(this.offset, this.limit());
        }
        static comparator(_, r) {
            let t = Math.min(_.length, r.length);
            for(let n = 0; n < t; n++){
                let s = _.get(n), c = r.get(n);
                if (s < c) return -1;
                if (s > c) return 1;
            }
            return _.length < r.length ? -1 : _.length > r.length ? 1 : 0;
        }
    }, ao = class e extends mu {
        construct(_, r, t) {
            return new e(_, r, t);
        }
        canonicalString() {
            return this.toArray().join("/");
        }
        toString() {
            return this.canonicalString();
        }
        toUriEncodedString() {
            return this.toArray().map(encodeURIComponent).join("/");
        }
        static fromString(..._) {
            let r = [];
            for (let t of _){
                if (t.indexOf("//") >= 0) throw new R_(o_.INVALID_ARGUMENT, `Invalid segment (${t}). Paths must not contain // in them.`);
                r.push(...t.split("/").filter((n)=>n.length > 0));
            }
            return new e(r);
        }
        static emptyPath() {
            return new e([]);
        }
    }, SA = /^[_a-zA-Z][_a-zA-Z0-9]*$/, gt = class e extends mu {
        construct(_, r, t) {
            return new e(_, r, t);
        }
        static isValidIdentifier(_) {
            return SA.test(_);
        }
        canonicalString() {
            return this.toArray().map((_)=>(_ = _.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), e.isValidIdentifier(_) || (_ = "`" + _ + "`"), _)).join(".");
        }
        toString() {
            return this.canonicalString();
        }
        isKeyField() {
            return this.length === 1 && this.get(0) === "__name__";
        }
        static keyField() {
            return new e([
                "__name__"
            ]);
        }
        static fromServerFormat(_) {
            let r = [], t = "", n = 0, s = ()=>{
                if (t.length === 0) throw new R_(o_.INVALID_ARGUMENT, `Invalid field path (${_}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
                r.push(t), t = "";
            }, c = !1;
            for(; n < _.length;){
                let i = _[n];
                if (i === "\\") {
                    if (n + 1 === _.length) throw new R_(o_.INVALID_ARGUMENT, "Path has trailing escape character: " + _);
                    let d = _[n + 1];
                    if (d !== "\\" && d !== "." && d !== "`") throw new R_(o_.INVALID_ARGUMENT, "Path has invalid escape sequence: " + _);
                    t += d, n += 2;
                } else i === "`" ? (c = !c, n++) : i !== "." || c ? (t += i, n++) : (s(), n++);
            }
            if (s(), c) throw new R_(o_.INVALID_ARGUMENT, "Unterminated ` in path: " + _);
            return new e(r);
        }
        static emptyPath() {
            return new e([]);
        }
    };
    var V_ = class e {
        constructor(_){
            this.path = _;
        }
        static fromPath(_) {
            return new e(ao.fromString(_));
        }
        static fromName(_) {
            return new e(ao.fromString(_).popFirst(5));
        }
        static empty() {
            return new e(ao.emptyPath());
        }
        get collectionGroup() {
            return this.path.popLast().lastSegment();
        }
        hasCollectionId(_) {
            return this.path.length >= 2 && this.path.get(this.path.length - 2) === _;
        }
        getCollectionGroup() {
            return this.path.get(this.path.length - 2);
        }
        getCollectionPath() {
            return this.path.popLast();
        }
        isEqual(_) {
            return _ !== null && ao.comparator(this.path, _.path) === 0;
        }
        toString() {
            return this.path.toString();
        }
        static comparator(_, r) {
            return ao.comparator(_.path, r.path);
        }
        static isDocumentKey(_) {
            return _.length % 2 == 0;
        }
        static fromSegments(_) {
            return new e(new ao(_.slice()));
        }
    };
    var N5 = class {
        constructor(_, r, t, n){
            this.indexId = _, this.collectionGroup = r, this.fields = t, this.indexState = n;
        }
    };
    N5.UNKNOWN_ID = -1;
    function IA(e, _) {
        let r = e.toTimestamp().seconds, t = e.toTimestamp().nanoseconds + 1, n = le.fromTimestamp(t === 1e9 ? new sr(r + 1, 0) : new sr(r, t));
        return new oc(n, V_.empty(), _);
    }
    function xA(e) {
        return new oc(e.readTime, e.key, -1);
    }
    var oc = class e {
        constructor(_, r, t){
            this.readTime = _, this.documentKey = r, this.largestBatchId = t;
        }
        static min() {
            return new e(le.min(), V_.empty(), -1);
        }
        static max() {
            return new e(le.max(), V_.empty(), -1);
        }
    };
    function EA(e, _) {
        let r = e.readTime.compareTo(_.readTime);
        return r !== 0 ? r : (r = V_.comparator(e.documentKey, _.documentKey), r !== 0 ? r : Ae(e.largestBatchId, _.largestBatchId));
    }
    var TA = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.", F5 = class {
        constructor(){
            this.onCommittedListeners = [];
        }
        addOnCommittedListener(_) {
            this.onCommittedListeners.push(_);
        }
        raiseOnCommittedEvent() {
            this.onCommittedListeners.forEach((_)=>_());
        }
    };
    async function zl(e) {
        if (e.code !== o_.FAILED_PRECONDITION || e.message !== TA) throw e;
        k_("LocalStore", "Unexpectedly lost primary lease");
    }
    var d_ = class e {
        constructor(_){
            this.nextCallback = null, this.catchCallback = null, this.result = void 0, this.error = void 0, this.isDone = !1, this.callbackAttached = !1, _((r)=>{
                this.isDone = !0, this.result = r, this.nextCallback && this.nextCallback(r);
            }, (r)=>{
                this.isDone = !0, this.error = r, this.catchCallback && this.catchCallback(r);
            });
        }
        catch(_) {
            return this.next(void 0, _);
        }
        next(_, r) {
            return this.callbackAttached && Z_(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(r, this.error) : this.wrapSuccess(_, this.result) : new e((t, n)=>{
                this.nextCallback = (s)=>{
                    this.wrapSuccess(_, s).next(t, n);
                }, this.catchCallback = (s)=>{
                    this.wrapFailure(r, s).next(t, n);
                };
            });
        }
        toPromise() {
            return new Promise((_, r)=>{
                this.next(_, r);
            });
        }
        wrapUserFunction(_) {
            try {
                let r = _();
                return r instanceof e ? r : e.resolve(r);
            } catch (r) {
                return e.reject(r);
            }
        }
        wrapSuccess(_, r) {
            return _ ? this.wrapUserFunction(()=>_(r)) : e.resolve(r);
        }
        wrapFailure(_, r) {
            return _ ? this.wrapUserFunction(()=>_(r)) : e.reject(r);
        }
        static resolve(_) {
            return new e((r, t)=>{
                r(_);
            });
        }
        static reject(_) {
            return new e((r, t)=>{
                t(_);
            });
        }
        static waitFor(_) {
            return new e((r, t)=>{
                let n = 0, s = 0, c = !1;
                _.forEach((i)=>{
                    ++n, i.next(()=>{
                        ++s, c && s === n && r();
                    }, (d)=>t(d));
                }), c = !0, s === n && r();
            });
        }
        static or(_) {
            let r = e.resolve(!1);
            for (let t of _)r = r.next((n)=>n ? e.resolve(n) : t());
            return r;
        }
        static forEach(_, r) {
            let t = [];
            return _.forEach((n, s)=>{
                t.push(r.call(this, n, s));
            }), this.waitFor(t);
        }
        static mapArray(_, r) {
            return new e((t, n)=>{
                let s = _.length, c = new Array(s), i = 0;
                for(let d = 0; d < s; d++){
                    let v = d;
                    r(_[v]).next((b)=>{
                        c[v] = b, ++i, i === s && t(c);
                    }, (b)=>n(b));
                }
            });
        }
        static doWhile(_, r) {
            return new e((t, n)=>{
                let s = ()=>{
                    _() === !0 ? r().next(()=>{
                        s();
                    }, n) : t();
                };
                s();
            });
        }
    };
    function GA(e) {
        let _ = e.match(/Android ([\d.]+)/i), r = _ ? _[1].split(".").slice(0, 2).join(".") : "-1";
        return Number(r);
    }
    function Ol(e) {
        return e.name === "IndexedDbTransactionError";
    }
    var Sl = class {
        constructor(_, r){
            this.previousValue = _, r && (r.sequenceNumberHandler = (t)=>this.ie(t), this.se = (t)=>r.writeSequenceNumber(t));
        }
        ie(_) {
            return this.previousValue = Math.max(_, this.previousValue), this.previousValue;
        }
        next() {
            let _ = ++this.previousValue;
            return this.se && this.se(_), _;
        }
    };
    Sl.oe = -1;
    function Hu(e) {
        return e == null;
    }
    function Il(e) {
        return e === 0 && 1 / e == -1 / 0;
    }
    function CA(e) {
        return typeof e == "number" && Number.isInteger(e) && !Il(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
    }
    var AA = [
        "mutationQueues",
        "mutations",
        "documentMutations",
        "remoteDocuments",
        "targets",
        "owner",
        "targetGlobal",
        "targetDocuments",
        "clientMetadata",
        "remoteDocumentGlobal",
        "collectionParents",
        "bundles",
        "namedQueries"
    ], kZ = [
        ...AA,
        "documentOverlays"
    ], NA = [
        "mutationQueues",
        "mutations",
        "documentMutations",
        "remoteDocumentsV14",
        "targets",
        "owner",
        "targetGlobal",
        "targetDocuments",
        "clientMetadata",
        "remoteDocumentGlobal",
        "collectionParents",
        "bundles",
        "namedQueries",
        "documentOverlays"
    ], FA = NA, SZ = [
        ...FA,
        "indexConfiguration",
        "indexState",
        "indexEntries"
    ];
    function Y9(e) {
        let _ = 0;
        for(let r in e)Object.prototype.hasOwnProperty.call(e, r) && _++;
        return _;
    }
    function Fa(e, _) {
        for(let r in e)Object.prototype.hasOwnProperty.call(e, r) && _(r, e[r]);
    }
    function x4(e) {
        for(let _ in e)if (Object.prototype.hasOwnProperty.call(e, _)) return !1;
        return !0;
    }
    var ho = class e {
        constructor(_, r){
            this.comparator = _, this.root = r || gn.EMPTY;
        }
        insert(_, r) {
            return new e(this.comparator, this.root.insert(_, r, this.comparator).copy(null, null, gn.BLACK, null, null));
        }
        remove(_) {
            return new e(this.comparator, this.root.remove(_, this.comparator).copy(null, null, gn.BLACK, null, null));
        }
        get(_) {
            let r = this.root;
            for(; !r.isEmpty();){
                let t = this.comparator(_, r.key);
                if (t === 0) return r.value;
                t < 0 ? r = r.left : t > 0 && (r = r.right);
            }
            return null;
        }
        indexOf(_) {
            let r = 0, t = this.root;
            for(; !t.isEmpty();){
                let n = this.comparator(_, t.key);
                if (n === 0) return r + t.left.size;
                n < 0 ? t = t.left : (r += t.left.size + 1, t = t.right);
            }
            return -1;
        }
        isEmpty() {
            return this.root.isEmpty();
        }
        get size() {
            return this.root.size;
        }
        minKey() {
            return this.root.minKey();
        }
        maxKey() {
            return this.root.maxKey();
        }
        inorderTraversal(_) {
            return this.root.inorderTraversal(_);
        }
        forEach(_) {
            this.inorderTraversal((r, t)=>(_(r, t), !1));
        }
        toString() {
            let _ = [];
            return this.inorderTraversal((r, t)=>(_.push(`${r}:${t}`), !1)), `{${_.join(", ")}}`;
        }
        reverseTraversal(_) {
            return this.root.reverseTraversal(_);
        }
        getIterator() {
            return new ma(this.root, null, this.comparator, !1);
        }
        getIteratorFrom(_) {
            return new ma(this.root, _, this.comparator, !1);
        }
        getReverseIterator() {
            return new ma(this.root, null, this.comparator, !0);
        }
        getReverseIteratorFrom(_) {
            return new ma(this.root, _, this.comparator, !0);
        }
    }, ma = class {
        constructor(_, r, t, n){
            this.isReverse = n, this.nodeStack = [];
            let s = 1;
            for(; !_.isEmpty();)if (s = r ? t(_.key, r) : 1, r && n && (s *= -1), s < 0) _ = this.isReverse ? _.left : _.right;
            else {
                if (s === 0) {
                    this.nodeStack.push(_);
                    break;
                }
                this.nodeStack.push(_), _ = this.isReverse ? _.right : _.left;
            }
        }
        getNext() {
            let _ = this.nodeStack.pop(), r = {
                key: _.key,
                value: _.value
            };
            if (this.isReverse) for(_ = _.left; !_.isEmpty();)this.nodeStack.push(_), _ = _.right;
            else for(_ = _.right; !_.isEmpty();)this.nodeStack.push(_), _ = _.left;
            return r;
        }
        hasNext() {
            return this.nodeStack.length > 0;
        }
        peek() {
            if (this.nodeStack.length === 0) return null;
            let _ = this.nodeStack[this.nodeStack.length - 1];
            return {
                key: _.key,
                value: _.value
            };
        }
    }, gn = class e {
        constructor(_, r, t, n, s){
            this.key = _, this.value = r, this.color = t ?? e.RED, this.left = n ?? e.EMPTY, this.right = s ?? e.EMPTY, this.size = this.left.size + 1 + this.right.size;
        }
        copy(_, r, t, n, s) {
            return new e(_ ?? this.key, r ?? this.value, t ?? this.color, n ?? this.left, s ?? this.right);
        }
        isEmpty() {
            return !1;
        }
        inorderTraversal(_) {
            return this.left.inorderTraversal(_) || _(this.key, this.value) || this.right.inorderTraversal(_);
        }
        reverseTraversal(_) {
            return this.right.reverseTraversal(_) || _(this.key, this.value) || this.left.reverseTraversal(_);
        }
        min() {
            return this.left.isEmpty() ? this : this.left.min();
        }
        minKey() {
            return this.min().key;
        }
        maxKey() {
            return this.right.isEmpty() ? this.key : this.right.maxKey();
        }
        insert(_, r, t) {
            let n = this, s = t(_, n.key);
            return n = s < 0 ? n.copy(null, null, null, n.left.insert(_, r, t), null) : s === 0 ? n.copy(null, r, null, null, null) : n.copy(null, null, null, null, n.right.insert(_, r, t)), n.fixUp();
        }
        removeMin() {
            if (this.left.isEmpty()) return e.EMPTY;
            let _ = this;
            return _.left.isRed() || _.left.left.isRed() || (_ = _.moveRedLeft()), _ = _.copy(null, null, null, _.left.removeMin(), null), _.fixUp();
        }
        remove(_, r) {
            let t, n = this;
            if (r(_, n.key) < 0) n.left.isEmpty() || n.left.isRed() || n.left.left.isRed() || (n = n.moveRedLeft()), n = n.copy(null, null, null, n.left.remove(_, r), null);
            else {
                if (n.left.isRed() && (n = n.rotateRight()), n.right.isEmpty() || n.right.isRed() || n.right.left.isRed() || (n = n.moveRedRight()), r(_, n.key) === 0) {
                    if (n.right.isEmpty()) return e.EMPTY;
                    t = n.right.min(), n = n.copy(t.key, t.value, null, null, n.right.removeMin());
                }
                n = n.copy(null, null, null, null, n.right.remove(_, r));
            }
            return n.fixUp();
        }
        isRed() {
            return this.color;
        }
        fixUp() {
            let _ = this;
            return _.right.isRed() && !_.left.isRed() && (_ = _.rotateLeft()), _.left.isRed() && _.left.left.isRed() && (_ = _.rotateRight()), _.left.isRed() && _.right.isRed() && (_ = _.colorFlip()), _;
        }
        moveRedLeft() {
            let _ = this.colorFlip();
            return _.right.left.isRed() && (_ = _.copy(null, null, null, null, _.right.rotateRight()), _ = _.rotateLeft(), _ = _.colorFlip()), _;
        }
        moveRedRight() {
            let _ = this.colorFlip();
            return _.left.left.isRed() && (_ = _.rotateRight(), _ = _.colorFlip()), _;
        }
        rotateLeft() {
            let _ = this.copy(null, null, e.RED, null, this.right.left);
            return this.right.copy(null, null, this.color, _, null);
        }
        rotateRight() {
            let _ = this.copy(null, null, e.RED, this.left.right, null);
            return this.left.copy(null, null, this.color, null, _);
        }
        colorFlip() {
            let _ = this.left.copy(null, null, !this.left.color, null, null), r = this.right.copy(null, null, !this.right.color, null, null);
            return this.copy(null, null, !this.color, _, r);
        }
        checkMaxDepth() {
            let _ = this.check();
            return Math.pow(2, _) <= this.size + 1;
        }
        check() {
            if (this.isRed() && this.left.isRed() || this.right.isRed()) throw Z_();
            let _ = this.left.check();
            if (_ !== this.right.check()) throw Z_();
            return _ + (this.isRed() ? 0 : 1);
        }
    };
    gn.EMPTY = null, gn.RED = !0, gn.BLACK = !1;
    gn.EMPTY = new class {
        constructor(){
            this.size = 0;
        }
        get key() {
            throw Z_();
        }
        get value() {
            throw Z_();
        }
        get color() {
            throw Z_();
        }
        get left() {
            throw Z_();
        }
        get right() {
            throw Z_();
        }
        copy(_, r, t, n, s) {
            return this;
        }
        insert(_, r, t) {
            return new gn(_, r);
        }
        remove(_, r) {
            return this;
        }
        isEmpty() {
            return !0;
        }
        inorderTraversal(_) {
            return !1;
        }
        reverseTraversal(_) {
            return !1;
        }
        minKey() {
            return null;
        }
        maxKey() {
            return null;
        }
        isRed() {
            return !1;
        }
        checkMaxDepth() {
            return !0;
        }
        check() {
            return 0;
        }
    };
    var yr = class e {
        constructor(_){
            this.comparator = _, this.data = new ho(this.comparator);
        }
        has(_) {
            return this.data.get(_) !== null;
        }
        first() {
            return this.data.minKey();
        }
        last() {
            return this.data.maxKey();
        }
        get size() {
            return this.data.size;
        }
        indexOf(_) {
            return this.data.indexOf(_);
        }
        forEach(_) {
            this.data.inorderTraversal((r, t)=>(_(r), !1));
        }
        forEachInRange(_, r) {
            let t = this.data.getIteratorFrom(_[0]);
            for(; t.hasNext();){
                let n = t.getNext();
                if (this.comparator(n.key, _[1]) >= 0) return;
                r(n.key);
            }
        }
        forEachWhile(_, r) {
            let t;
            for(t = r !== void 0 ? this.data.getIteratorFrom(r) : this.data.getIterator(); t.hasNext();)if (!_(t.getNext().key)) return;
        }
        firstAfterOrEqual(_) {
            let r = this.data.getIteratorFrom(_);
            return r.hasNext() ? r.getNext().key : null;
        }
        getIterator() {
            return new $u(this.data.getIterator());
        }
        getIteratorFrom(_) {
            return new $u(this.data.getIteratorFrom(_));
        }
        add(_) {
            return this.copy(this.data.remove(_).insert(_, !0));
        }
        delete(_) {
            return this.has(_) ? this.copy(this.data.remove(_)) : this;
        }
        isEmpty() {
            return this.data.isEmpty();
        }
        unionWith(_) {
            let r = this;
            return r.size < _.size && (r = _, _ = this), _.forEach((t)=>{
                r = r.add(t);
            }), r;
        }
        isEqual(_) {
            if (!(_ instanceof e) || this.size !== _.size) return !1;
            let r = this.data.getIterator(), t = _.data.getIterator();
            for(; r.hasNext();){
                let n = r.getNext().key, s = t.getNext().key;
                if (this.comparator(n, s) !== 0) return !1;
            }
            return !0;
        }
        toArray() {
            let _ = [];
            return this.forEach((r)=>{
                _.push(r);
            }), _;
        }
        toString() {
            let _ = [];
            return this.forEach((r)=>_.push(r)), "SortedSet(" + _.toString() + ")";
        }
        copy(_) {
            let r = new e(this.comparator);
            return r.data = _, r;
        }
    }, $u = class {
        constructor(_){
            this.iter = _;
        }
        getNext() {
            return this.iter.getNext().key;
        }
        hasNext() {
            return this.iter.hasNext();
        }
    };
    var vn = class e {
        constructor(_){
            this.fields = _, _.sort(gt.comparator);
        }
        static empty() {
            return new e([]);
        }
        unionWith(_) {
            let r = new yr(gt.comparator);
            for (let t of this.fields)r = r.add(t);
            for (let t of _)r = r.add(t);
            return new e(r.toArray());
        }
        covers(_) {
            for (let r of this.fields)if (r.isPrefixOf(_)) return !0;
            return !1;
        }
        isEqual(_) {
            return Da(this.fields, _.fields, (r, t)=>r.isEqual(t));
        }
    };
    var hu = class extends Error {
        constructor(){
            super(...arguments), this.name = "Base64DecodeError";
        }
    };
    var Mr = class e {
        constructor(_){
            this.binaryString = _;
        }
        static fromBase64String(_) {
            let r = function(n) {
                try {
                    return atob(n);
                } catch (s) {
                    throw typeof DOMException < "u" && s instanceof DOMException ? new hu("Invalid base64 string: " + s) : s;
                }
            }(_);
            return new e(r);
        }
        static fromUint8Array(_) {
            let r = function(n) {
                let s = "";
                for(let c = 0; c < n.length; ++c)s += String.fromCharCode(n[c]);
                return s;
            }(_);
            return new e(r);
        }
        [Symbol.iterator]() {
            let _ = 0;
            return {
                next: ()=>_ < this.binaryString.length ? {
                        value: this.binaryString.charCodeAt(_++),
                        done: !1
                    } : {
                        value: void 0,
                        done: !0
                    }
            };
        }
        toBase64() {
            return function(r) {
                return btoa(r);
            }(this.binaryString);
        }
        toUint8Array() {
            return function(r) {
                let t = new Uint8Array(r.length);
                for(let n = 0; n < r.length; n++)t[n] = r.charCodeAt(n);
                return t;
            }(this.binaryString);
        }
        approximateByteSize() {
            return 2 * this.binaryString.length;
        }
        compareTo(_) {
            return Ae(this.binaryString, _.binaryString);
        }
        isEqual(_) {
            return this.binaryString === _.binaryString;
        }
    };
    Mr.EMPTY_BYTE_STRING = new Mr("");
    var MA = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
    function e0(e) {
        if (Ve(!!e), typeof e == "string") {
            let _ = 0, r = MA.exec(e);
            if (Ve(!!r), r[1]) {
                let n = r[1];
                n = (n + "000000000").substr(0, 9), _ = Number(n);
            }
            let t = new Date(e);
            return {
                seconds: Math.floor(t.getTime() / 1e3),
                nanos: _
            };
        }
        return {
            seconds: $o(e.seconds),
            nanos: $o(e.nanos)
        };
    }
    function $o(e) {
        return typeof e == "number" ? e : typeof e == "string" ? Number(e) : 0;
    }
    function Q0(e) {
        return typeof e == "string" ? Mr.fromBase64String(e) : Mr.fromUint8Array(e);
    }
    function im(e) {
        var _, r;
        return ((r = (((_ = e?.mapValue) === null || _ === void 0 ? void 0 : _.fields) || {}).__type__) === null || r === void 0 ? void 0 : r.stringValue) === "server_timestamp";
    }
    function lm(e) {
        let _ = e.mapValue.fields.__previous_value__;
        return im(_) ? lm(_) : _;
    }
    function xl(e) {
        let _ = e0(e.mapValue.fields.__local_write_time__.timestampValue);
        return new sr(_.seconds, _.nanos);
    }
    var M5 = class {
        constructor(_, r, t, n, s, c, i, d, v){
            this.databaseId = _, this.appId = r, this.persistenceKey = t, this.host = n, this.ssl = s, this.forceLongPolling = c, this.autoDetectLongPolling = i, this.longPollingOptions = d, this.useFetchStreams = v;
        }
    }, yu = class e {
        constructor(_, r){
            this.projectId = _, this.database = r || "(default)";
        }
        static empty() {
            return new e("", "");
        }
        get isDefaultDatabase() {
            return this.database === "(default)";
        }
        isEqual(_) {
            return _ instanceof e && _.projectId === this.projectId && _.database === this.database;
        }
    };
    var vu = {
        mapValue: {
            fields: {
                __type__: {
                    stringValue: "__max__"
                }
            }
        }
    };
    function rc(e) {
        return "nullValue" in e ? 0 : "booleanValue" in e ? 1 : "integerValue" in e || "doubleValue" in e ? 2 : "timestampValue" in e ? 3 : "stringValue" in e ? 5 : "bytesValue" in e ? 6 : "referenceValue" in e ? 7 : "geoPointValue" in e ? 8 : "arrayValue" in e ? 9 : "mapValue" in e ? im(e) ? 4 : E4(e) ? 9007199254740991 : 10 : Z_();
    }
    function fn(e, _) {
        if (e === _) return !0;
        let r = rc(e);
        if (r !== rc(_)) return !1;
        switch(r){
            case 0:
            case 9007199254740991:
                return !0;
            case 1:
                return e.booleanValue === _.booleanValue;
            case 4:
                return xl(e).isEqual(xl(_));
            case 3:
                return function(n, s) {
                    if (typeof n.timestampValue == "string" && typeof s.timestampValue == "string" && n.timestampValue.length === s.timestampValue.length) return n.timestampValue === s.timestampValue;
                    let c = e0(n.timestampValue), i = e0(s.timestampValue);
                    return c.seconds === i.seconds && c.nanos === i.nanos;
                }(e, _);
            case 5:
                return e.stringValue === _.stringValue;
            case 6:
                return function(n, s) {
                    return Q0(n.bytesValue).isEqual(Q0(s.bytesValue));
                }(e, _);
            case 7:
                return e.referenceValue === _.referenceValue;
            case 8:
                return function(n, s) {
                    return $o(n.geoPointValue.latitude) === $o(s.geoPointValue.latitude) && $o(n.geoPointValue.longitude) === $o(s.geoPointValue.longitude);
                }(e, _);
            case 2:
                return function(n, s) {
                    if ("integerValue" in n && "integerValue" in s) return $o(n.integerValue) === $o(s.integerValue);
                    if ("doubleValue" in n && "doubleValue" in s) {
                        let c = $o(n.doubleValue), i = $o(s.doubleValue);
                        return c === i ? Il(c) === Il(i) : isNaN(c) && isNaN(i);
                    }
                    return !1;
                }(e, _);
            case 9:
                return Da(e.arrayValue.values || [], _.arrayValue.values || [], fn);
            case 10:
                return function(n, s) {
                    let c = n.mapValue.fields || {}, i = s.mapValue.fields || {};
                    if (Y9(c) !== Y9(i)) return !1;
                    for(let d in c)if (c.hasOwnProperty(d) && (i[d] === void 0 || !fn(c[d], i[d]))) return !1;
                    return !0;
                }(e, _);
            default:
                return Z_();
        }
    }
    function El(e, _) {
        return (e.values || []).find((r)=>fn(r, _)) !== void 0;
    }
    function wa(e, _) {
        if (e === _) return 0;
        let r = rc(e), t = rc(_);
        if (r !== t) return Ae(r, t);
        switch(r){
            case 0:
            case 9007199254740991:
                return 0;
            case 1:
                return Ae(e.booleanValue, _.booleanValue);
            case 2:
                return function(s, c) {
                    let i = $o(s.integerValue || s.doubleValue), d = $o(c.integerValue || c.doubleValue);
                    return i < d ? -1 : i > d ? 1 : i === d ? 0 : isNaN(i) ? isNaN(d) ? 0 : -1 : 1;
                }(e, _);
            case 3:
                return X9(e.timestampValue, _.timestampValue);
            case 4:
                return X9(xl(e), xl(_));
            case 5:
                return Ae(e.stringValue, _.stringValue);
            case 6:
                return function(s, c) {
                    let i = Q0(s), d = Q0(c);
                    return i.compareTo(d);
                }(e.bytesValue, _.bytesValue);
            case 7:
                return function(s, c) {
                    let i = s.split("/"), d = c.split("/");
                    for(let v = 0; v < i.length && v < d.length; v++){
                        let b = Ae(i[v], d[v]);
                        if (b !== 0) return b;
                    }
                    return Ae(i.length, d.length);
                }(e.referenceValue, _.referenceValue);
            case 8:
                return function(s, c) {
                    let i = Ae($o(s.latitude), $o(c.latitude));
                    return i !== 0 ? i : Ae($o(s.longitude), $o(c.longitude));
                }(e.geoPointValue, _.geoPointValue);
            case 9:
                return function(s, c) {
                    let i = s.values || [], d = c.values || [];
                    for(let v = 0; v < i.length && v < d.length; ++v){
                        let b = wa(i[v], d[v]);
                        if (b) return b;
                    }
                    return Ae(i.length, d.length);
                }(e.arrayValue, _.arrayValue);
            case 10:
                return function(s, c) {
                    if (s === vu.mapValue && c === vu.mapValue) return 0;
                    if (s === vu.mapValue) return 1;
                    if (c === vu.mapValue) return -1;
                    let i = s.fields || {}, d = Object.keys(i), v = c.fields || {}, b = Object.keys(v);
                    d.sort(), b.sort();
                    for(let p = 0; p < d.length && p < b.length; ++p){
                        let u = Ae(d[p], b[p]);
                        if (u !== 0) return u;
                        let m = wa(i[d[p]], v[b[p]]);
                        if (m !== 0) return m;
                    }
                    return Ae(d.length, b.length);
                }(e.mapValue, _.mapValue);
            default:
                throw Z_();
        }
    }
    function X9(e, _) {
        if (typeof e == "string" && typeof _ == "string" && e.length === _.length) return Ae(e, _);
        let r = e0(e), t = e0(_), n = Ae(r.seconds, t.seconds);
        return n !== 0 ? n : Ae(r.nanos, t.nanos);
    }
    function Ra(e) {
        return P5(e);
    }
    function P5(e) {
        return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function(r) {
            let t = e0(r);
            return `time(${t.seconds},${t.nanos})`;
        }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function(r) {
            return Q0(r).toBase64();
        }(e.bytesValue) : "referenceValue" in e ? function(r) {
            return V_.fromName(r).toString();
        }(e.referenceValue) : "geoPointValue" in e ? function(r) {
            return `geo(${r.latitude},${r.longitude})`;
        }(e.geoPointValue) : "arrayValue" in e ? function(r) {
            let t = "[", n = !0;
            for (let s of r.values || [])n ? n = !1 : t += ",", t += P5(s);
            return t + "]";
        }(e.arrayValue) : "mapValue" in e ? function(r) {
            let t = Object.keys(r.fields || {}).sort(), n = "{", s = !0;
            for (let c of t)s ? s = !1 : n += ",", n += `${c}:${P5(r.fields[c])}`;
            return n + "}";
        }(e.mapValue) : Z_();
    }
    function Z9(e, _) {
        return {
            referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${_.path.canonicalString()}`
        };
    }
    function L5(e) {
        return !!e && "integerValue" in e;
    }
    function dm(e) {
        return !!e && "arrayValue" in e;
    }
    function _4(e) {
        return !!e && "nullValue" in e;
    }
    function e4(e) {
        return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
    }
    function gu(e) {
        return !!e && "mapValue" in e;
    }
    function Dl(e) {
        if (e.geoPointValue) return {
            geoPointValue: Object.assign({}, e.geoPointValue)
        };
        if (e.timestampValue && typeof e.timestampValue == "object") return {
            timestampValue: Object.assign({}, e.timestampValue)
        };
        if (e.mapValue) {
            let _ = {
                mapValue: {
                    fields: {}
                }
            };
            return Fa(e.mapValue.fields, (r, t)=>_.mapValue.fields[r] = Dl(t)), _;
        }
        if (e.arrayValue) {
            let _ = {
                arrayValue: {
                    values: []
                }
            };
            for(let r = 0; r < (e.arrayValue.values || []).length; ++r)_.arrayValue.values[r] = Dl(e.arrayValue.values[r]);
            return _;
        }
        return Object.assign({}, e);
    }
    function E4(e) {
        return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === "__max__";
    }
    var zt = class e {
        constructor(_){
            this.value = _;
        }
        static empty() {
            return new e({
                mapValue: {}
            });
        }
        field(_) {
            if (_.isEmpty()) return this.value;
            {
                let r = this.value;
                for(let t = 0; t < _.length - 1; ++t)if (r = (r.mapValue.fields || {})[_.get(t)], !gu(r)) return null;
                return r = (r.mapValue.fields || {})[_.lastSegment()], r || null;
            }
        }
        set(_, r) {
            this.getFieldsMap(_.popLast())[_.lastSegment()] = Dl(r);
        }
        setAll(_) {
            let r = gt.emptyPath(), t = {}, n = [];
            _.forEach((c, i)=>{
                if (!r.isImmediateParentOf(i)) {
                    let d = this.getFieldsMap(r);
                    this.applyChanges(d, t, n), t = {}, n = [], r = i.popLast();
                }
                c ? t[i.lastSegment()] = Dl(c) : n.push(i.lastSegment());
            });
            let s = this.getFieldsMap(r);
            this.applyChanges(s, t, n);
        }
        delete(_) {
            let r = this.field(_.popLast());
            gu(r) && r.mapValue.fields && delete r.mapValue.fields[_.lastSegment()];
        }
        isEqual(_) {
            return fn(this.value, _.value);
        }
        getFieldsMap(_) {
            let r = this.value;
            r.mapValue.fields || (r.mapValue = {
                fields: {}
            });
            for(let t = 0; t < _.length; ++t){
                let n = r.mapValue.fields[_.get(t)];
                gu(n) && n.mapValue.fields || (n = {
                    mapValue: {
                        fields: {}
                    }
                }, r.mapValue.fields[_.get(t)] = n), r = n;
            }
            return r.mapValue.fields;
        }
        applyChanges(_, r, t) {
            Fa(r, (n, s)=>_[n] = s);
            for (let n of t)delete _[n];
        }
        clone() {
            return new e(Dl(this.value));
        }
    };
    function T4(e) {
        let _ = [];
        return Fa(e.fields, (r, t)=>{
            let n = new gt([
                r
            ]);
            if (gu(t)) {
                let s = T4(t.mapValue).fields;
                if (s.length === 0) _.push(n);
                else for (let c of s)_.push(n.child(c));
            } else _.push(n);
        }), new vn(_);
    }
    var Ot = class e {
        constructor(_, r, t, n, s, c, i){
            this.key = _, this.documentType = r, this.version = t, this.readTime = n, this.createTime = s, this.data = c, this.documentState = i;
        }
        static newInvalidDocument(_) {
            return new e(_, 0, le.min(), le.min(), le.min(), zt.empty(), 0);
        }
        static newFoundDocument(_, r, t, n) {
            return new e(_, 1, r, le.min(), t, n, 0);
        }
        static newNoDocument(_, r) {
            return new e(_, 2, r, le.min(), le.min(), zt.empty(), 0);
        }
        static newUnknownDocument(_, r) {
            return new e(_, 3, r, le.min(), le.min(), zt.empty(), 2);
        }
        convertToFoundDocument(_, r) {
            return !this.createTime.isEqual(le.min()) || this.documentType !== 2 && this.documentType !== 0 || (this.createTime = _), this.version = _, this.documentType = 1, this.data = r, this.documentState = 0, this;
        }
        convertToNoDocument(_) {
            return this.version = _, this.documentType = 2, this.data = zt.empty(), this.documentState = 0, this;
        }
        convertToUnknownDocument(_) {
            return this.version = _, this.documentType = 3, this.data = zt.empty(), this.documentState = 2, this;
        }
        setHasCommittedMutations() {
            return this.documentState = 2, this;
        }
        setHasLocalMutations() {
            return this.documentState = 1, this.version = le.min(), this;
        }
        setReadTime(_) {
            return this.readTime = _, this;
        }
        get hasLocalMutations() {
            return this.documentState === 1;
        }
        get hasCommittedMutations() {
            return this.documentState === 2;
        }
        get hasPendingWrites() {
            return this.hasLocalMutations || this.hasCommittedMutations;
        }
        isValidDocument() {
            return this.documentType !== 0;
        }
        isFoundDocument() {
            return this.documentType === 1;
        }
        isNoDocument() {
            return this.documentType === 2;
        }
        isUnknownDocument() {
            return this.documentType === 3;
        }
        isEqual(_) {
            return _ instanceof e && this.key.isEqual(_.key) && this.version.isEqual(_.version) && this.documentType === _.documentType && this.documentState === _.documentState && this.data.isEqual(_.data);
        }
        mutableCopy() {
            return new e(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
        }
        toString() {
            return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
        }
    };
    var ka = class {
        constructor(_, r){
            this.position = _, this.inclusive = r;
        }
    };
    function o4(e, _, r) {
        let t = 0;
        for(let n = 0; n < e.position.length; n++){
            let s = _[n], c = e.position[n];
            if (s.field.isKeyField() ? t = V_.comparator(V_.fromName(c.referenceValue), r.key) : t = wa(c, r.data.field(s.field)), s.dir === "desc" && (t *= -1), t !== 0) break;
        }
        return t;
    }
    function r4(e, _) {
        if (e === null) return _ === null;
        if (_ === null || e.inclusive !== _.inclusive || e.position.length !== _.position.length) return !1;
        for(let r = 0; r < e.position.length; r++)if (!fn(e.position[r], _.position[r])) return !1;
        return !0;
    }
    var Sa = class {
        constructor(_, r = "asc"){
            this.field = _, this.dir = r;
        }
    };
    function PA(e, _) {
        return e.dir === _.dir && e.field.isEqual(_.field);
    }
    var Du = class {
    }, Oo = class e extends Du {
        constructor(_, r, t){
            super(), this.field = _, this.op = r, this.value = t;
        }
        static create(_, r, t) {
            return _.isKeyField() ? r === "in" || r === "not-in" ? this.createKeyFieldInFilter(_, r, t) : new O5(_, r, t) : r === "array-contains" ? new J5(_, t) : r === "in" ? new V5(_, t) : r === "not-in" ? new q5(_, t) : r === "array-contains-any" ? new W5(_, t) : new e(_, r, t);
        }
        static createKeyFieldInFilter(_, r, t) {
            return r === "in" ? new U5(_, t) : new B5(_, t);
        }
        matches(_) {
            let r = _.data.field(this.field);
            return this.op === "!=" ? r !== null && this.matchesComparison(wa(r, this.value)) : r !== null && rc(this.value) === rc(r) && this.matchesComparison(wa(r, this.value));
        }
        matchesComparison(_) {
            switch(this.op){
                case "<":
                    return _ < 0;
                case "<=":
                    return _ <= 0;
                case "==":
                    return _ === 0;
                case "!=":
                    return _ !== 0;
                case ">":
                    return _ > 0;
                case ">=":
                    return _ >= 0;
                default:
                    return Z_();
            }
        }
        isInequality() {
            return [
                "<",
                "<=",
                ">",
                ">=",
                "!=",
                "not-in"
            ].indexOf(this.op) >= 0;
        }
        getFlattenedFilters() {
            return [
                this
            ];
        }
        getFilters() {
            return [
                this
            ];
        }
    }, Ut = class e extends Du {
        constructor(_, r){
            super(), this.filters = _, this.op = r, this.ae = null;
        }
        static create(_, r) {
            return new e(_, r);
        }
        matches(_) {
            return G4(this) ? this.filters.find((r)=>!r.matches(_)) === void 0 : this.filters.find((r)=>r.matches(_)) !== void 0;
        }
        getFlattenedFilters() {
            return this.ae !== null || (this.ae = this.filters.reduce((_, r)=>_.concat(r.getFlattenedFilters()), [])), this.ae;
        }
        getFilters() {
            return Object.assign([], this.filters);
        }
    };
    function G4(e) {
        return e.op === "and";
    }
    function C4(e) {
        return LA(e) && G4(e);
    }
    function LA(e) {
        for (let _ of e.filters)if (_ instanceof Ut) return !1;
        return !0;
    }
    function z5(e) {
        if (e instanceof Oo) return e.field.canonicalString() + e.op.toString() + Ra(e.value);
        if (C4(e)) return e.filters.map((_)=>z5(_)).join(",");
        {
            let _ = e.filters.map((r)=>z5(r)).join(",");
            return `${e.op}(${_})`;
        }
    }
    function A4(e, _) {
        return e instanceof Oo ? function(t, n) {
            return n instanceof Oo && t.op === n.op && t.field.isEqual(n.field) && fn(t.value, n.value);
        }(e, _) : e instanceof Ut ? function(t, n) {
            return n instanceof Ut && t.op === n.op && t.filters.length === n.filters.length ? t.filters.reduce((s, c, i)=>s && A4(c, n.filters[i]), !0) : !1;
        }(e, _) : void Z_();
    }
    function N4(e) {
        return e instanceof Oo ? function(r) {
            return `${r.field.canonicalString()} ${r.op} ${Ra(r.value)}`;
        }(e) : e instanceof Ut ? function(r) {
            return r.op.toString() + " {" + r.getFilters().map(N4).join(" ,") + "}";
        }(e) : "Filter";
    }
    var O5 = class extends Oo {
        constructor(_, r, t){
            super(_, r, t), this.key = V_.fromName(t.referenceValue);
        }
        matches(_) {
            let r = V_.comparator(_.key, this.key);
            return this.matchesComparison(r);
        }
    }, U5 = class extends Oo {
        constructor(_, r){
            super(_, "in", r), this.keys = F4("in", r);
        }
        matches(_) {
            return this.keys.some((r)=>r.isEqual(_.key));
        }
    }, B5 = class extends Oo {
        constructor(_, r){
            super(_, "not-in", r), this.keys = F4("not-in", r);
        }
        matches(_) {
            return !this.keys.some((r)=>r.isEqual(_.key));
        }
    };
    function F4(e, _) {
        var r;
        return (((r = _.arrayValue) === null || r === void 0 ? void 0 : r.values) || []).map((t)=>V_.fromName(t.referenceValue));
    }
    var J5 = class extends Oo {
        constructor(_, r){
            super(_, "array-contains", r);
        }
        matches(_) {
            let r = _.data.field(this.field);
            return dm(r) && El(r.arrayValue, this.value);
        }
    }, V5 = class extends Oo {
        constructor(_, r){
            super(_, "in", r);
        }
        matches(_) {
            let r = _.data.field(this.field);
            return r !== null && El(this.value.arrayValue, r);
        }
    }, q5 = class extends Oo {
        constructor(_, r){
            super(_, "not-in", r);
        }
        matches(_) {
            if (El(this.value.arrayValue, {
                nullValue: "NULL_VALUE"
            })) return !1;
            let r = _.data.field(this.field);
            return r !== null && !El(this.value.arrayValue, r);
        }
    }, W5 = class extends Oo {
        constructor(_, r){
            super(_, "array-contains-any", r);
        }
        matches(_) {
            let r = _.data.field(this.field);
            return !(!dm(r) || !r.arrayValue.values) && r.arrayValue.values.some((t)=>El(this.value.arrayValue, t));
        }
    };
    var H5 = class {
        constructor(_, r = null, t = [], n = [], s = null, c = null, i = null){
            this.path = _, this.collectionGroup = r, this.orderBy = t, this.filters = n, this.limit = s, this.startAt = c, this.endAt = i, this.ue = null;
        }
    };
    function t4(e, _ = null, r = [], t = [], n = null, s = null, c = null) {
        return new H5(e, _, r, t, n, s, c);
    }
    function vm(e) {
        let _ = ce(e);
        if (_.ue === null) {
            let r = _.path.canonicalString();
            _.collectionGroup !== null && (r += "|cg:" + _.collectionGroup), r += "|f:", r += _.filters.map((t)=>z5(t)).join(","), r += "|ob:", r += _.orderBy.map((t)=>(function(s) {
                    return s.field.canonicalString() + s.dir;
                })(t)).join(","), Hu(_.limit) || (r += "|l:", r += _.limit), _.startAt && (r += "|lb:", r += _.startAt.inclusive ? "b:" : "a:", r += _.startAt.position.map((t)=>Ra(t)).join(",")), _.endAt && (r += "|ub:", r += _.endAt.inclusive ? "a:" : "b:", r += _.endAt.position.map((t)=>Ra(t)).join(",")), _.ue = r;
        }
        return _.ue;
    }
    function um(e, _) {
        if (e.limit !== _.limit || e.orderBy.length !== _.orderBy.length) return !1;
        for(let r = 0; r < e.orderBy.length; r++)if (!PA(e.orderBy[r], _.orderBy[r])) return !1;
        if (e.filters.length !== _.filters.length) return !1;
        for(let r = 0; r < e.filters.length; r++)if (!A4(e.filters[r], _.filters[r])) return !1;
        return e.collectionGroup === _.collectionGroup && !!e.path.isEqual(_.path) && !!r4(e.startAt, _.startAt) && r4(e.endAt, _.endAt);
    }
    function j5(e) {
        return V_.isDocumentKey(e.path) && e.collectionGroup === null && e.filters.length === 0;
    }
    var tc = class {
        constructor(_, r = null, t = [], n = [], s = null, c = "F", i = null, d = null){
            this.path = _, this.collectionGroup = r, this.explicitOrderBy = t, this.filters = n, this.limit = s, this.limitType = c, this.startAt = i, this.endAt = d, this.ce = null, this.le = null, this.he = null, this.startAt, this.endAt;
        }
    };
    function zA(e, _, r, t, n, s, c, i) {
        return new tc(e, _, r, t, n, s, c, i);
    }
    function ju(e) {
        return new tc(e);
    }
    function n4(e) {
        return e.filters.length === 0 && e.limit === null && e.startAt == null && e.endAt == null && (e.explicitOrderBy.length === 0 || e.explicitOrderBy.length === 1 && e.explicitOrderBy[0].field.isKeyField());
    }
    function M4(e) {
        return e.collectionGroup !== null;
    }
    function wl(e) {
        let _ = ce(e);
        if (_.ce === null) {
            _.ce = [];
            let r = new Set;
            for (let s of _.explicitOrderBy)_.ce.push(s), r.add(s.field.canonicalString());
            let t = _.explicitOrderBy.length > 0 ? _.explicitOrderBy[_.explicitOrderBy.length - 1].dir : "asc";
            (function(c) {
                let i = new yr(gt.comparator);
                return c.filters.forEach((d)=>{
                    d.getFlattenedFilters().forEach((v)=>{
                        v.isInequality() && (i = i.add(v.field));
                    });
                }), i;
            })(_).forEach((s)=>{
                r.has(s.canonicalString()) || s.isKeyField() || _.ce.push(new Sa(s, t));
            }), r.has(gt.keyField().canonicalString()) || _.ce.push(new Sa(gt.keyField(), t));
        }
        return _.ce;
    }
    function bn(e) {
        let _ = ce(e);
        return _.le || (_.le = OA(_, wl(e))), _.le;
    }
    function OA(e, _) {
        if (e.limitType === "F") return t4(e.path, e.collectionGroup, _, e.filters, e.limit, e.startAt, e.endAt);
        {
            _ = _.map((n)=>{
                let s = n.dir === "desc" ? "asc" : "desc";
                return new Sa(n.field, s);
            });
            let r = e.endAt ? new ka(e.endAt.position, e.endAt.inclusive) : null, t = e.startAt ? new ka(e.startAt.position, e.startAt.inclusive) : null;
            return t4(e.path, e.collectionGroup, _, e.filters, e.limit, r, t);
        }
    }
    function K5(e, _) {
        let r = e.filters.concat([
            _
        ]);
        return new tc(e.path, e.collectionGroup, e.explicitOrderBy.slice(), r, e.limit, e.limitType, e.startAt, e.endAt);
    }
    function Q5(e, _, r) {
        return new tc(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), _, r, e.startAt, e.endAt);
    }
    function Ku(e, _) {
        return um(bn(e), bn(_)) && e.limitType === _.limitType;
    }
    function P4(e) {
        return `${vm(bn(e))}|lt:${e.limitType}`;
    }
    function ba(e) {
        return `Query(target=${function(r) {
            let t = r.path.canonicalString();
            return r.collectionGroup !== null && (t += " collectionGroup=" + r.collectionGroup), r.filters.length > 0 && (t += `, filters: [${r.filters.map((n)=>N4(n)).join(", ")}]`), Hu(r.limit) || (t += ", limit: " + r.limit), r.orderBy.length > 0 && (t += `, orderBy: [${r.orderBy.map((n)=>(function(c) {
                    return `${c.field.canonicalString()} (${c.dir})`;
                })(n)).join(", ")}]`), r.startAt && (t += ", startAt: ", t += r.startAt.inclusive ? "b:" : "a:", t += r.startAt.position.map((n)=>Ra(n)).join(",")), r.endAt && (t += ", endAt: ", t += r.endAt.inclusive ? "a:" : "b:", t += r.endAt.position.map((n)=>Ra(n)).join(",")), `Target(${t})`;
        }(bn(e))}; limitType=${e.limitType})`;
    }
    function Qu(e, _) {
        return _.isFoundDocument() && function(t, n) {
            let s = n.key.path;
            return t.collectionGroup !== null ? n.key.hasCollectionId(t.collectionGroup) && t.path.isPrefixOf(s) : V_.isDocumentKey(t.path) ? t.path.isEqual(s) : t.path.isImmediateParentOf(s);
        }(e, _) && function(t, n) {
            for (let s of wl(t))if (!s.field.isKeyField() && n.data.field(s.field) === null) return !1;
            return !0;
        }(e, _) && function(t, n) {
            for (let s of t.filters)if (!s.matches(n)) return !1;
            return !0;
        }(e, _) && function(t, n) {
            return !(t.startAt && !function(c, i, d) {
                let v = o4(c, i, d);
                return c.inclusive ? v <= 0 : v < 0;
            }(t.startAt, wl(t), n) || t.endAt && !function(c, i, d) {
                let v = o4(c, i, d);
                return c.inclusive ? v >= 0 : v > 0;
            }(t.endAt, wl(t), n));
        }(e, _);
    }
    function UA(e) {
        return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
    }
    function L4(e) {
        return (_, r)=>{
            let t = !1;
            for (let n of wl(e)){
                let s = BA(n, _, r);
                if (s !== 0) return s;
                t = t || n.field.isKeyField();
            }
            return 0;
        };
    }
    function BA(e, _, r) {
        let t = e.field.isKeyField() ? V_.comparator(_.key, r.key) : function(s, c, i) {
            let d = c.data.field(s), v = i.data.field(s);
            return d !== null && v !== null ? wa(d, v) : Z_();
        }(e.field, _, r);
        switch(e.dir){
            case "asc":
                return t;
            case "desc":
                return -1 * t;
            default:
                return Z_();
        }
    }
    var Y0 = class {
        constructor(_, r){
            this.mapKeyFn = _, this.equalsFn = r, this.inner = {}, this.innerSize = 0;
        }
        get(_) {
            let r = this.mapKeyFn(_), t = this.inner[r];
            if (t !== void 0) {
                for (let [n, s] of t)if (this.equalsFn(n, _)) return s;
            }
        }
        has(_) {
            return this.get(_) !== void 0;
        }
        set(_, r) {
            let t = this.mapKeyFn(_), n = this.inner[t];
            if (n === void 0) return this.inner[t] = [
                [
                    _,
                    r
                ]
            ], void this.innerSize++;
            for(let s = 0; s < n.length; s++)if (this.equalsFn(n[s][0], _)) return void (n[s] = [
                _,
                r
            ]);
            n.push([
                _,
                r
            ]), this.innerSize++;
        }
        delete(_) {
            let r = this.mapKeyFn(_), t = this.inner[r];
            if (t === void 0) return !1;
            for(let n = 0; n < t.length; n++)if (this.equalsFn(t[n][0], _)) return t.length === 1 ? delete this.inner[r] : t.splice(n, 1), this.innerSize--, !0;
            return !1;
        }
        forEach(_) {
            Fa(this.inner, (r, t)=>{
                for (let [n, s] of t)_(n, s);
            });
        }
        isEmpty() {
            return x4(this.inner);
        }
        size() {
            return this.innerSize;
        }
    };
    var JA = new ho(V_.comparator);
    function o0() {
        return JA;
    }
    var z4 = new ho(V_.comparator);
    function yl(...e) {
        let _ = z4;
        for (let r of e)_ = _.insert(r.key, r);
        return _;
    }
    function O4(e) {
        let _ = z4;
        return e.forEach((r, t)=>_ = _.insert(r, t.overlayedDocument)), _;
    }
    function Xs() {
        return Rl();
    }
    function U4() {
        return Rl();
    }
    function Rl() {
        return new Y0((e)=>e.toString(), (e, _)=>e.isEqual(_));
    }
    var VA = new ho(V_.comparator), qA = new yr(V_.comparator);
    function ke(...e) {
        let _ = qA;
        for (let r of e)_ = _.add(r);
        return _;
    }
    var WA = new yr(Ae);
    function HA() {
        return WA;
    }
    function B4(e, _) {
        if (e.useProto3Json) {
            if (isNaN(_)) return {
                doubleValue: "NaN"
            };
            if (_ === 1 / 0) return {
                doubleValue: "Infinity"
            };
            if (_ === -1 / 0) return {
                doubleValue: "-Infinity"
            };
        }
        return {
            doubleValue: Il(_) ? "-0" : _
        };
    }
    function J4(e) {
        return {
            integerValue: "" + e
        };
    }
    function jA(e, _) {
        return CA(_) ? J4(_) : B4(e, _);
    }
    var Ia = class {
        constructor(){
            this._ = void 0;
        }
    };
    function KA(e, _, r) {
        return e instanceof xa ? function(n, s) {
            let c = {
                fields: {
                    __type__: {
                        stringValue: "server_timestamp"
                    },
                    __local_write_time__: {
                        timestampValue: {
                            seconds: n.seconds,
                            nanos: n.nanoseconds
                        }
                    }
                }
            };
            return s && im(s) && (s = lm(s)), s && (c.fields.__previous_value__ = s), {
                mapValue: c
            };
        }(r, _) : e instanceof nc ? q4(e, _) : e instanceof sc ? W4(e, _) : function(n, s) {
            let c = V4(n, s), i = s4(c) + s4(n.Pe);
            return L5(c) && L5(n.Pe) ? J4(i) : B4(n.serializer, i);
        }(e, _);
    }
    function QA(e, _, r) {
        return e instanceof nc ? q4(e, _) : e instanceof sc ? W4(e, _) : r;
    }
    function V4(e, _) {
        return e instanceof Ea ? function(t) {
            return L5(t) || function(s) {
                return !!s && "doubleValue" in s;
            }(t);
        }(_) ? _ : {
            integerValue: 0
        } : null;
    }
    var xa = class extends Ia {
    }, nc = class extends Ia {
        constructor(_){
            super(), this.elements = _;
        }
    };
    function q4(e, _) {
        let r = H4(_);
        for (let t of e.elements)r.some((n)=>fn(n, t)) || r.push(t);
        return {
            arrayValue: {
                values: r
            }
        };
    }
    var sc = class extends Ia {
        constructor(_){
            super(), this.elements = _;
        }
    };
    function W4(e, _) {
        let r = H4(_);
        for (let t of e.elements)r = r.filter((n)=>!fn(n, t));
        return {
            arrayValue: {
                values: r
            }
        };
    }
    var Ea = class extends Ia {
        constructor(_, r){
            super(), this.serializer = _, this.Pe = r;
        }
    };
    function s4(e) {
        return $o(e.integerValue || e.doubleValue);
    }
    function H4(e) {
        return dm(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
    }
    function YA(e, _) {
        return e.field.isEqual(_.field) && function(t, n) {
            return t instanceof nc && n instanceof nc || t instanceof sc && n instanceof sc ? Da(t.elements, n.elements, fn) : t instanceof Ea && n instanceof Ea ? fn(t.Pe, n.Pe) : t instanceof xa && n instanceof xa;
        }(e.transform, _.transform);
    }
    var Y5 = class {
        constructor(_, r){
            this.version = _, this.transformResults = r;
        }
    }, j0 = class e {
        constructor(_, r){
            this.updateTime = _, this.exists = r;
        }
        static none() {
            return new e;
        }
        static exists(_) {
            return new e(void 0, _);
        }
        static updateTime(_) {
            return new e(_);
        }
        get isNone() {
            return this.updateTime === void 0 && this.exists === void 0;
        }
        isEqual(_) {
            return this.exists === _.exists && (this.updateTime ? !!_.updateTime && this.updateTime.isEqual(_.updateTime) : !_.updateTime);
        }
    };
    function bu(e, _) {
        return e.updateTime !== void 0 ? _.isFoundDocument() && _.version.isEqual(e.updateTime) : e.exists === void 0 || e.exists === _.isFoundDocument();
    }
    var Ta = class {
    };
    function j4(e, _) {
        if (!e.hasLocalMutations || _ && _.fields.length === 0) return null;
        if (_ === null) return e.isNoDocument() ? new Tl(e.key, j0.none()) : new cc(e.key, e.data, j0.none());
        {
            let r = e.data, t = zt.empty(), n = new yr(gt.comparator);
            for (let s of _.fields)if (!n.has(s)) {
                let c = r.field(s);
                c === null && s.length > 1 && (s = s.popLast(), c = r.field(s)), c === null ? t.delete(s) : t.set(s, c), n = n.add(s);
            }
            return new r0(e.key, t, new vn(n.toArray()), j0.none());
        }
    }
    function XA(e, _, r) {
        e instanceof cc ? function(n, s, c) {
            let i = n.value.clone(), d = a4(n.fieldTransforms, s, c.transformResults);
            i.setAll(d), s.convertToFoundDocument(c.version, i).setHasCommittedMutations();
        }(e, _, r) : e instanceof r0 ? function(n, s, c) {
            if (!bu(n.precondition, s)) return void s.convertToUnknownDocument(c.version);
            let i = a4(n.fieldTransforms, s, c.transformResults), d = s.data;
            d.setAll(K4(n)), d.setAll(i), s.convertToFoundDocument(c.version, d).setHasCommittedMutations();
        }(e, _, r) : function(n, s, c) {
            s.convertToNoDocument(c.version).setHasCommittedMutations();
        }(0, _, r);
    }
    function kl(e, _, r, t) {
        return e instanceof cc ? function(s, c, i, d) {
            if (!bu(s.precondition, c)) return i;
            let v = s.value.clone(), b = i4(s.fieldTransforms, d, c);
            return v.setAll(b), c.convertToFoundDocument(c.version, v).setHasLocalMutations(), null;
        }(e, _, r, t) : e instanceof r0 ? function(s, c, i, d) {
            if (!bu(s.precondition, c)) return i;
            let v = i4(s.fieldTransforms, d, c), b = c.data;
            return b.setAll(K4(s)), b.setAll(v), c.convertToFoundDocument(c.version, b).setHasLocalMutations(), i === null ? null : i.unionWith(s.fieldMask.fields).unionWith(s.fieldTransforms.map((p)=>p.field));
        }(e, _, r, t) : function(s, c, i) {
            return bu(s.precondition, c) ? (c.convertToNoDocument(c.version).setHasLocalMutations(), null) : i;
        }(e, _, r);
    }
    function ZA(e, _) {
        let r = null;
        for (let t of e.fieldTransforms){
            let n = _.data.field(t.field), s = V4(t.transform, n || null);
            s != null && (r === null && (r = zt.empty()), r.set(t.field, s));
        }
        return r || null;
    }
    function c4(e, _) {
        return e.type === _.type && !!e.key.isEqual(_.key) && !!e.precondition.isEqual(_.precondition) && !!function(t, n) {
            return t === void 0 && n === void 0 || !(!t || !n) && Da(t, n, (s, c)=>YA(s, c));
        }(e.fieldTransforms, _.fieldTransforms) && (e.type === 0 ? e.value.isEqual(_.value) : e.type !== 1 || e.data.isEqual(_.data) && e.fieldMask.isEqual(_.fieldMask));
    }
    var cc = class extends Ta {
        constructor(_, r, t, n = []){
            super(), this.key = _, this.value = r, this.precondition = t, this.fieldTransforms = n, this.type = 0;
        }
        getFieldMask() {
            return null;
        }
    }, r0 = class extends Ta {
        constructor(_, r, t, n, s = []){
            super(), this.key = _, this.data = r, this.fieldMask = t, this.precondition = n, this.fieldTransforms = s, this.type = 1;
        }
        getFieldMask() {
            return this.fieldMask;
        }
    };
    function K4(e) {
        let _ = new Map;
        return e.fieldMask.fields.forEach((r)=>{
            if (!r.isEmpty()) {
                let t = e.data.field(r);
                _.set(r, t);
            }
        }), _;
    }
    function a4(e, _, r) {
        let t = new Map;
        Ve(e.length === r.length);
        for(let n = 0; n < r.length; n++){
            let s = e[n], c = s.transform, i = _.data.field(s.field);
            t.set(s.field, QA(c, i, r[n]));
        }
        return t;
    }
    function i4(e, _, r) {
        let t = new Map;
        for (let n of e){
            let s = n.transform, c = r.data.field(n.field);
            t.set(n.field, KA(s, c, _));
        }
        return t;
    }
    var Tl = class extends Ta {
        constructor(_, r){
            super(), this.key = _, this.precondition = r, this.type = 2, this.fieldTransforms = [];
        }
        getFieldMask() {
            return null;
        }
    }, X5 = class extends Ta {
        constructor(_, r){
            super(), this.key = _, this.precondition = r, this.type = 3, this.fieldTransforms = [];
        }
        getFieldMask() {
            return null;
        }
    };
    var Z5 = class {
        constructor(_, r, t, n){
            this.batchId = _, this.localWriteTime = r, this.baseMutations = t, this.mutations = n;
        }
        applyToRemoteDocument(_, r) {
            let t = r.mutationResults;
            for(let n = 0; n < this.mutations.length; n++){
                let s = this.mutations[n];
                s.key.isEqual(_.key) && XA(s, _, t[n]);
            }
        }
        applyToLocalView(_, r) {
            for (let t of this.baseMutations)t.key.isEqual(_.key) && (r = kl(t, _, r, this.localWriteTime));
            for (let t of this.mutations)t.key.isEqual(_.key) && (r = kl(t, _, r, this.localWriteTime));
            return r;
        }
        applyToLocalDocumentSet(_, r) {
            let t = U4();
            return this.mutations.forEach((n)=>{
                let s = _.get(n.key), c = s.overlayedDocument, i = this.applyToLocalView(c, s.mutatedFields);
                i = r.has(n.key) ? null : i;
                let d = j4(c, i);
                d !== null && t.set(n.key, d), c.isValidDocument() || c.convertToNoDocument(le.min());
            }), t;
        }
        keys() {
            return this.mutations.reduce((_, r)=>_.add(r.key), ke());
        }
        isEqual(_) {
            return this.batchId === _.batchId && Da(this.mutations, _.mutations, (r, t)=>c4(r, t)) && Da(this.baseMutations, _.baseMutations, (r, t)=>c4(r, t));
        }
    }, _f = class e {
        constructor(_, r, t, n){
            this.batch = _, this.commitVersion = r, this.mutationResults = t, this.docVersions = n;
        }
        static from(_, r, t) {
            Ve(_.mutations.length === t.length);
            let n = function() {
                return VA;
            }(), s = _.mutations;
            for(let c = 0; c < s.length; c++)n = n.insert(s[c].key, t[c].version);
            return new e(_, r, t, n);
        }
    };
    var ef = class {
        constructor(_, r){
            this.largestBatchId = _, this.mutation = r;
        }
        getKey() {
            return this.mutation.key;
        }
        isEqual(_) {
            return _ !== null && this.mutation === _.mutation;
        }
        toString() {
            return `Overlay{
      largestBatchId: ${this.largestBatchId},
      mutation: ${this.mutation.toString()}
    }`;
        }
    };
    var of = class {
        constructor(_, r){
            this.count = _, this.unchangedNames = r;
        }
    };
    var Lo, xe;
    function _N(e) {
        switch(e){
            default:
                return Z_();
            case o_.CANCELLED:
            case o_.UNKNOWN:
            case o_.DEADLINE_EXCEEDED:
            case o_.RESOURCE_EXHAUSTED:
            case o_.INTERNAL:
            case o_.UNAVAILABLE:
            case o_.UNAUTHENTICATED:
                return !1;
            case o_.INVALID_ARGUMENT:
            case o_.NOT_FOUND:
            case o_.ALREADY_EXISTS:
            case o_.PERMISSION_DENIED:
            case o_.FAILED_PRECONDITION:
            case o_.ABORTED:
            case o_.OUT_OF_RANGE:
            case o_.UNIMPLEMENTED:
            case o_.DATA_LOSS:
                return !0;
        }
    }
    function Q4(e) {
        if (e === void 0) return _0("GRPC error has no .code"), o_.UNKNOWN;
        switch(e){
            case Lo.OK:
                return o_.OK;
            case Lo.CANCELLED:
                return o_.CANCELLED;
            case Lo.UNKNOWN:
                return o_.UNKNOWN;
            case Lo.DEADLINE_EXCEEDED:
                return o_.DEADLINE_EXCEEDED;
            case Lo.RESOURCE_EXHAUSTED:
                return o_.RESOURCE_EXHAUSTED;
            case Lo.INTERNAL:
                return o_.INTERNAL;
            case Lo.UNAVAILABLE:
                return o_.UNAVAILABLE;
            case Lo.UNAUTHENTICATED:
                return o_.UNAUTHENTICATED;
            case Lo.INVALID_ARGUMENT:
                return o_.INVALID_ARGUMENT;
            case Lo.NOT_FOUND:
                return o_.NOT_FOUND;
            case Lo.ALREADY_EXISTS:
                return o_.ALREADY_EXISTS;
            case Lo.PERMISSION_DENIED:
                return o_.PERMISSION_DENIED;
            case Lo.FAILED_PRECONDITION:
                return o_.FAILED_PRECONDITION;
            case Lo.ABORTED:
                return o_.ABORTED;
            case Lo.OUT_OF_RANGE:
                return o_.OUT_OF_RANGE;
            case Lo.UNIMPLEMENTED:
                return o_.UNIMPLEMENTED;
            case Lo.DATA_LOSS:
                return o_.DATA_LOSS;
            default:
                return Z_();
        }
    }
    (xe = Lo || (Lo = {}))[xe.OK = 0] = "OK", xe[xe.CANCELLED = 1] = "CANCELLED", xe[xe.UNKNOWN = 2] = "UNKNOWN", xe[xe.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", xe[xe.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", xe[xe.NOT_FOUND = 5] = "NOT_FOUND", xe[xe.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", xe[xe.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", xe[xe.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", xe[xe.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", xe[xe.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", xe[xe.ABORTED = 10] = "ABORTED", xe[xe.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", xe[xe.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", xe[xe.INTERNAL = 13] = "INTERNAL", xe[xe.UNAVAILABLE = 14] = "UNAVAILABLE", xe[xe.DATA_LOSS = 15] = "DATA_LOSS";
    var l4 = null;
    function eN() {
        return new TextEncoder;
    }
    var oN = new H0([
        4294967295,
        4294967295
    ], 0);
    function d4(e) {
        let _ = eN().encode(e), r = new p5;
        return r.update(_), new Uint8Array(r.digest());
    }
    function v4(e) {
        let _ = new DataView(e.buffer), r = _.getUint32(0, !0), t = _.getUint32(4, !0), n = _.getUint32(8, !0), s = _.getUint32(12, !0);
        return [
            new H0([
                r,
                t
            ], 0),
            new H0([
                n,
                s
            ], 0)
        ];
    }
    var rf = class e {
        constructor(_, r, t){
            if (this.bitmap = _, this.padding = r, this.hashCount = t, r < 0 || r >= 8) throw new Zs(`Invalid padding: ${r}`);
            if (t < 0) throw new Zs(`Invalid hash count: ${t}`);
            if (_.length > 0 && this.hashCount === 0) throw new Zs(`Invalid hash count: ${t}`);
            if (_.length === 0 && r !== 0) throw new Zs(`Invalid padding when bitmap length is 0: ${r}`);
            this.Ie = 8 * _.length - r, this.Te = H0.fromNumber(this.Ie);
        }
        Ee(_, r, t) {
            let n = _.add(r.multiply(H0.fromNumber(t)));
            return n.compare(oN) === 1 && (n = new H0([
                n.getBits(0),
                n.getBits(1)
            ], 0)), n.modulo(this.Te).toNumber();
        }
        de(_) {
            return (this.bitmap[Math.floor(_ / 8)] & 1 << _ % 8) != 0;
        }
        mightContain(_) {
            if (this.Ie === 0) return !1;
            let r = d4(_), [t, n] = v4(r);
            for(let s = 0; s < this.hashCount; s++){
                let c = this.Ee(t, n, s);
                if (!this.de(c)) return !1;
            }
            return !0;
        }
        static create(_, r, t) {
            let n = _ % 8 == 0 ? 0 : 8 - _ % 8, s = new Uint8Array(Math.ceil(_ / 8)), c = new e(s, n, r);
            return t.forEach((i)=>c.insert(i)), c;
        }
        insert(_) {
            if (this.Ie === 0) return;
            let r = d4(_), [t, n] = v4(r);
            for(let s = 0; s < this.hashCount; s++){
                let c = this.Ee(t, n, s);
                this.Ae(c);
            }
        }
        Ae(_) {
            let r = Math.floor(_ / 8), t = _ % 8;
            this.bitmap[r] |= 1 << t;
        }
    }, Zs = class extends Error {
        constructor(){
            super(...arguments), this.name = "BloomFilterError";
        }
    };
    var wu = class e {
        constructor(_, r, t, n, s){
            this.snapshotVersion = _, this.targetChanges = r, this.targetMismatches = t, this.documentUpdates = n, this.resolvedLimboDocuments = s;
        }
        static createSynthesizedRemoteEventForCurrentChange(_, r, t) {
            let n = new Map;
            return n.set(_, Gl.createSynthesizedTargetChangeForCurrentChange(_, r, t)), new e(le.min(), n, new ho(Ae), o0(), ke());
        }
    }, Gl = class e {
        constructor(_, r, t, n, s){
            this.resumeToken = _, this.current = r, this.addedDocuments = t, this.modifiedDocuments = n, this.removedDocuments = s;
        }
        static createSynthesizedTargetChangeForCurrentChange(_, r, t) {
            return new e(t, r, ke(), ke(), ke());
        }
    };
    var $a = class {
        constructor(_, r, t, n){
            this.Re = _, this.removedTargetIds = r, this.key = t, this.Ve = n;
        }
    }, Ru = class {
        constructor(_, r){
            this.targetId = _, this.me = r;
        }
    }, ku = class {
        constructor(_, r, t = Mr.EMPTY_BYTE_STRING, n = null){
            this.state = _, this.targetIds = r, this.resumeToken = t, this.cause = n;
        }
    }, Su = class {
        constructor(){
            this.fe = 0, this.ge = g4(), this.pe = Mr.EMPTY_BYTE_STRING, this.ye = !1, this.we = !0;
        }
        get current() {
            return this.ye;
        }
        get resumeToken() {
            return this.pe;
        }
        get Se() {
            return this.fe !== 0;
        }
        get be() {
            return this.we;
        }
        De(_) {
            _.approximateByteSize() > 0 && (this.we = !0, this.pe = _);
        }
        Ce() {
            let _ = ke(), r = ke(), t = ke();
            return this.ge.forEach((n, s)=>{
                switch(s){
                    case 0:
                        _ = _.add(n);
                        break;
                    case 2:
                        r = r.add(n);
                        break;
                    case 1:
                        t = t.add(n);
                        break;
                    default:
                        Z_();
                }
            }), new Gl(this.pe, this.ye, _, r, t);
        }
        ve() {
            this.we = !1, this.ge = g4();
        }
        Fe(_, r) {
            this.we = !0, this.ge = this.ge.insert(_, r);
        }
        Me(_) {
            this.we = !0, this.ge = this.ge.remove(_);
        }
        xe() {
            this.fe += 1;
        }
        Oe() {
            this.fe -= 1, Ve(this.fe >= 0);
        }
        Ne() {
            this.we = !0, this.ye = !0;
        }
    }, tf = class {
        constructor(_){
            this.Le = _, this.Be = new Map, this.ke = o0(), this.qe = u4(), this.Qe = new ho(Ae);
        }
        Ke(_) {
            for (let r of _.Re)_.Ve && _.Ve.isFoundDocument() ? this.$e(r, _.Ve) : this.Ue(r, _.key, _.Ve);
            for (let r of _.removedTargetIds)this.Ue(r, _.key, _.Ve);
        }
        We(_) {
            this.forEachTarget(_, (r)=>{
                let t = this.Ge(r);
                switch(_.state){
                    case 0:
                        this.ze(r) && t.De(_.resumeToken);
                        break;
                    case 1:
                        t.Oe(), t.Se || t.ve(), t.De(_.resumeToken);
                        break;
                    case 2:
                        t.Oe(), t.Se || this.removeTarget(r);
                        break;
                    case 3:
                        this.ze(r) && (t.Ne(), t.De(_.resumeToken));
                        break;
                    case 4:
                        this.ze(r) && (this.je(r), t.De(_.resumeToken));
                        break;
                    default:
                        Z_();
                }
            });
        }
        forEachTarget(_, r) {
            _.targetIds.length > 0 ? _.targetIds.forEach(r) : this.Be.forEach((t, n)=>{
                this.ze(n) && r(n);
            });
        }
        He(_) {
            let r = _.targetId, t = _.me.count, n = this.Je(r);
            if (n) {
                let s = n.target;
                if (j5(s)) {
                    if (t === 0) {
                        let c = new V_(s.path);
                        this.Ue(r, c, Ot.newNoDocument(c, le.min()));
                    } else Ve(t === 1);
                } else {
                    let c = this.Ye(r);
                    if (c !== t) {
                        let i = this.Ze(_), d = i ? this.Xe(i, _, c) : 1;
                        if (d !== 0) {
                            this.je(r);
                            let v = d === 2 ? "TargetPurposeExistenceFilterMismatchBloom" : "TargetPurposeExistenceFilterMismatch";
                            this.Qe = this.Qe.insert(r, v);
                        }
                        l4?.et(function(b, p, u, m, z) {
                            var L, J, c_, t_, W, a_;
                            let Q = {
                                localCacheCount: b,
                                existenceFilterCount: p.count,
                                databaseId: u.database,
                                projectId: u.projectId
                            }, F = p.unchangedNames;
                            return F && (Q.bloomFilter = {
                                applied: z === 0,
                                hashCount: (L = F?.hashCount) !== null && L !== void 0 ? L : 0,
                                bitmapLength: (t_ = (c_ = (J = F?.bits) === null || J === void 0 ? void 0 : J.bitmap) === null || c_ === void 0 ? void 0 : c_.length) !== null && t_ !== void 0 ? t_ : 0,
                                padding: (a_ = (W = F?.bits) === null || W === void 0 ? void 0 : W.padding) !== null && a_ !== void 0 ? a_ : 0,
                                mightContain: (y)=>{
                                    var w;
                                    return (w = m?.mightContain(y)) !== null && w !== void 0 && w;
                                }
                            }), Q;
                        }(c, _.me, this.Le.tt(), i, d));
                    }
                }
            }
        }
        Ze(_) {
            let r = _.me.unchangedNames;
            if (!r || !r.bits) return null;
            let { bits: { bitmap: t = "" , padding: n = 0  } , hashCount: s = 0  } = r, c, i;
            try {
                c = Q0(t).toUint8Array();
            } catch (d) {
                if (d instanceof hu) return ya("Decoding the base64 bloom filter in existence filter failed (" + d.message + "); ignoring the bloom filter and falling back to full re-query."), null;
                throw d;
            }
            try {
                i = new rf(c, n, s);
            } catch (d) {
                return ya(d instanceof Zs ? "BloomFilter error: " : "Applying bloom filter failed: ", d), null;
            }
            return i.Ie === 0 ? null : i;
        }
        Xe(_, r, t) {
            return r.me.count === t - this.nt(_, r.targetId) ? 0 : 2;
        }
        nt(_, r) {
            let t = this.Le.getRemoteKeysForTarget(r), n = 0;
            return t.forEach((s)=>{
                let c = this.Le.tt(), i = `projects/${c.projectId}/databases/${c.database}/documents/${s.path.canonicalString()}`;
                _.mightContain(i) || (this.Ue(r, s, null), n++);
            }), n;
        }
        rt(_) {
            let r = new Map;
            this.Be.forEach((s, c)=>{
                let i = this.Je(c);
                if (i) {
                    if (s.current && j5(i.target)) {
                        let d = new V_(i.target.path);
                        this.ke.get(d) !== null || this.it(c, d) || this.Ue(c, d, Ot.newNoDocument(d, _));
                    }
                    s.be && (r.set(c, s.Ce()), s.ve());
                }
            });
            let t = ke();
            this.qe.forEach((s, c)=>{
                let i = !0;
                c.forEachWhile((d)=>{
                    let v = this.Je(d);
                    return !v || v.purpose === "TargetPurposeLimboResolution" || (i = !1, !1);
                }), i && (t = t.add(s));
            }), this.ke.forEach((s, c)=>c.setReadTime(_));
            let n = new wu(_, r, this.Qe, this.ke, t);
            return this.ke = o0(), this.qe = u4(), this.Qe = new ho(Ae), n;
        }
        $e(_, r) {
            if (!this.ze(_)) return;
            let t = this.it(_, r.key) ? 2 : 0;
            this.Ge(_).Fe(r.key, t), this.ke = this.ke.insert(r.key, r), this.qe = this.qe.insert(r.key, this.st(r.key).add(_));
        }
        Ue(_, r, t) {
            if (!this.ze(_)) return;
            let n = this.Ge(_);
            this.it(_, r) ? n.Fe(r, 1) : n.Me(r), this.qe = this.qe.insert(r, this.st(r).delete(_)), t && (this.ke = this.ke.insert(r, t));
        }
        removeTarget(_) {
            this.Be.delete(_);
        }
        Ye(_) {
            let r = this.Ge(_).Ce();
            return this.Le.getRemoteKeysForTarget(_).size + r.addedDocuments.size - r.removedDocuments.size;
        }
        xe(_) {
            this.Ge(_).xe();
        }
        Ge(_) {
            let r = this.Be.get(_);
            return r || (r = new Su, this.Be.set(_, r)), r;
        }
        st(_) {
            let r = this.qe.get(_);
            return r || (r = new yr(Ae), this.qe = this.qe.insert(_, r)), r;
        }
        ze(_) {
            let r = this.Je(_) !== null;
            return r || k_("WatchChangeAggregator", "Detected inactive target", _), r;
        }
        Je(_) {
            let r = this.Be.get(_);
            return r && r.Se ? null : this.Le.ot(_);
        }
        je(_) {
            this.Be.set(_, new Su), this.Le.getRemoteKeysForTarget(_).forEach((r)=>{
                this.Ue(_, r, null);
            });
        }
        it(_, r) {
            return this.Le.getRemoteKeysForTarget(_).has(r);
        }
    };
    function u4() {
        return new ho(V_.comparator);
    }
    function g4() {
        return new ho(V_.comparator);
    }
    var rN = (()=>({
            asc: "ASCENDING",
            desc: "DESCENDING"
        }))(), tN = (()=>({
            "<": "LESS_THAN",
            "<=": "LESS_THAN_OR_EQUAL",
            ">": "GREATER_THAN",
            ">=": "GREATER_THAN_OR_EQUAL",
            "==": "EQUAL",
            "!=": "NOT_EQUAL",
            "array-contains": "ARRAY_CONTAINS",
            in: "IN",
            "not-in": "NOT_IN",
            "array-contains-any": "ARRAY_CONTAINS_ANY"
        }))(), nN = (()=>({
            and: "AND",
            or: "OR"
        }))(), nf = class {
        constructor(_, r){
            this.databaseId = _, this.useProto3Json = r;
        }
    };
    function sf(e, _) {
        return e.useProto3Json || Hu(_) ? _ : {
            value: _
        };
    }
    function Iu(e, _) {
        return e.useProto3Json ? `${new Date(1e3 * _.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + _.nanoseconds).slice(-9)}Z` : {
            seconds: "" + _.seconds,
            nanos: _.nanoseconds
        };
    }
    function Y4(e, _) {
        return e.useProto3Json ? _.toBase64() : _.toUint8Array();
    }
    function sN(e, _) {
        return Iu(e, _.toTimestamp());
    }
    function pn(e) {
        return Ve(!!e), le.fromTimestamp(function(r) {
            let t = e0(r);
            return new sr(t.seconds, t.nanos);
        }(e));
    }
    function gm(e, _) {
        return cf(e, _).canonicalString();
    }
    function cf(e, _) {
        let r = (function(n) {
            return new ao([
                "projects",
                n.projectId,
                "databases",
                n.database
            ]);
        })(e).child("documents");
        return _ === void 0 ? r : r.child(_);
    }
    function X4(e) {
        let _ = ao.fromString(e);
        return Ve(rD(_)), _;
    }
    function af(e, _) {
        return gm(e.databaseId, _.path);
    }
    function w5(e, _) {
        let r = X4(_);
        if (r.get(1) !== e.databaseId.projectId) throw new R_(o_.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + r.get(1) + " vs " + e.databaseId.projectId);
        if (r.get(3) !== e.databaseId.database) throw new R_(o_.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + r.get(3) + " vs " + e.databaseId.database);
        return new V_(_D(r));
    }
    function Z4(e, _) {
        return gm(e.databaseId, _);
    }
    function cN(e) {
        let _ = X4(e);
        return _.length === 4 ? ao.emptyPath() : _D(_);
    }
    function lf(e) {
        return new ao([
            "projects",
            e.databaseId.projectId,
            "databases",
            e.databaseId.database
        ]).canonicalString();
    }
    function _D(e) {
        return Ve(e.length > 4 && e.get(4) === "documents"), e.popFirst(5);
    }
    function b4(e, _, r) {
        return {
            name: af(e, _),
            fields: r.value.mapValue.fields
        };
    }
    function aN(e, _) {
        let r;
        if ("targetChange" in _) {
            _.targetChange;
            let t = function(v) {
                return v === "NO_CHANGE" ? 0 : v === "ADD" ? 1 : v === "REMOVE" ? 2 : v === "CURRENT" ? 3 : v === "RESET" ? 4 : Z_();
            }(_.targetChange.targetChangeType || "NO_CHANGE"), n = _.targetChange.targetIds || [], s = function(v, b) {
                return v.useProto3Json ? (Ve(b === void 0 || typeof b == "string"), Mr.fromBase64String(b || "")) : (Ve(b === void 0 || b instanceof $7610d1aa0befc885$require$Buffer || b instanceof Uint8Array), Mr.fromUint8Array(b || new Uint8Array));
            }(e, _.targetChange.resumeToken), c = _.targetChange.cause, i = c && function(v) {
                let b = v.code === void 0 ? o_.UNKNOWN : Q4(v.code);
                return new R_(b, v.message || "");
            }(c);
            r = new ku(t, n, s, i || null);
        } else if ("documentChange" in _) {
            _.documentChange;
            let t = _.documentChange;
            t.document, t.document.name, t.document.updateTime;
            let n = w5(e, t.document.name), s = pn(t.document.updateTime), c = t.document.createTime ? pn(t.document.createTime) : le.min(), i = new zt({
                mapValue: {
                    fields: t.document.fields
                }
            }), d = Ot.newFoundDocument(n, s, c, i), v = t.targetIds || [], b = t.removedTargetIds || [];
            r = new $a(v, b, d.key, d);
        } else if ("documentDelete" in _) {
            _.documentDelete;
            let t = _.documentDelete;
            t.document;
            let n = w5(e, t.document), s = t.readTime ? pn(t.readTime) : le.min(), c = Ot.newNoDocument(n, s), i = t.removedTargetIds || [];
            r = new $a([], i, c.key, c);
        } else if ("documentRemove" in _) {
            _.documentRemove;
            let t = _.documentRemove;
            t.document;
            let n = w5(e, t.document), s = t.removedTargetIds || [];
            r = new $a([], s, n, null);
        } else {
            if (!("filter" in _)) return Z_();
            {
                _.filter;
                let t = _.filter;
                t.targetId;
                let { count: n = 0 , unchangedNames: s  } = t, c = new of(n, s), i = t.targetId;
                r = new Ru(i, c);
            }
        }
        return r;
    }
    function iN(e, _) {
        let r;
        if (_ instanceof cc) r = {
            update: b4(e, _.key, _.value)
        };
        else if (_ instanceof Tl) r = {
            delete: af(e, _.key)
        };
        else if (_ instanceof r0) r = {
            update: b4(e, _.key, _.data),
            updateMask: mN(_.fieldMask)
        };
        else {
            if (!(_ instanceof X5)) return Z_();
            r = {
                verify: af(e, _.key)
            };
        }
        return _.fieldTransforms.length > 0 && (r.updateTransforms = _.fieldTransforms.map((t)=>(function(s, c) {
                let i = c.transform;
                if (i instanceof xa) return {
                    fieldPath: c.field.canonicalString(),
                    setToServerValue: "REQUEST_TIME"
                };
                if (i instanceof nc) return {
                    fieldPath: c.field.canonicalString(),
                    appendMissingElements: {
                        values: i.elements
                    }
                };
                if (i instanceof sc) return {
                    fieldPath: c.field.canonicalString(),
                    removeAllFromArray: {
                        values: i.elements
                    }
                };
                if (i instanceof Ea) return {
                    fieldPath: c.field.canonicalString(),
                    increment: i.Pe
                };
                throw Z_();
            })(0, t))), _.precondition.isNone || (r.currentDocument = function(n, s) {
            return s.updateTime !== void 0 ? {
                updateTime: sN(n, s.updateTime)
            } : s.exists !== void 0 ? {
                exists: s.exists
            } : Z_();
        }(e, _.precondition)), r;
    }
    function lN(e, _) {
        return e && e.length > 0 ? (Ve(_ !== void 0), e.map((r)=>(function(n, s) {
                let c = n.updateTime ? pn(n.updateTime) : pn(s);
                return c.isEqual(le.min()) && (c = pn(s)), new Y5(c, n.transformResults || []);
            })(r, _))) : [];
    }
    function dN(e, _) {
        return {
            documents: [
                Z4(e, _.path)
            ]
        };
    }
    function vN(e, _) {
        let r = {
            structuredQuery: {}
        }, t = _.path, n;
        _.collectionGroup !== null ? (n = t, r.structuredQuery.from = [
            {
                collectionId: _.collectionGroup,
                allDescendants: !0
            }
        ]) : (n = t.popLast(), r.structuredQuery.from = [
            {
                collectionId: t.lastSegment()
            }
        ]), r.parent = Z4(e, n);
        let s = function(v) {
            if (v.length !== 0) return oD(Ut.create(v, "and"));
        }(_.filters);
        s && (r.structuredQuery.where = s);
        let c = function(v) {
            if (v.length !== 0) return v.map((b)=>(function(u) {
                    return {
                        field: pa(u.field),
                        direction: bN(u.dir)
                    };
                })(b));
        }(_.orderBy);
        c && (r.structuredQuery.orderBy = c);
        let i = sf(e, _.limit);
        return i !== null && (r.structuredQuery.limit = i), _.startAt && (r.structuredQuery.startAt = function(v) {
            return {
                before: v.inclusive,
                values: v.position
            };
        }(_.startAt)), _.endAt && (r.structuredQuery.endAt = function(v) {
            return {
                before: !v.inclusive,
                values: v.position
            };
        }(_.endAt)), {
            _t: r,
            parent: n
        };
    }
    function uN(e) {
        let _ = cN(e.parent), r = e.structuredQuery, t = r.from ? r.from.length : 0, n = null;
        if (t > 0) {
            Ve(t === 1);
            let b = r.from[0];
            b.allDescendants ? n = b.collectionId : _ = _.child(b.collectionId);
        }
        let s = [];
        r.where && (s = function(p) {
            let u = eD(p);
            return u instanceof Ut && C4(u) ? u.getFilters() : [
                u
            ];
        }(r.where));
        let c = [];
        r.orderBy && (c = function(p) {
            return p.map((u)=>(function(z) {
                    return new Sa(fa(z.field), function(J) {
                        switch(J){
                            case "ASCENDING":
                                return "asc";
                            case "DESCENDING":
                                return "desc";
                            default:
                                return;
                        }
                    }(z.direction));
                })(u));
        }(r.orderBy));
        let i = null;
        r.limit && (i = function(p) {
            let u;
            return u = typeof p == "object" ? p.value : p, Hu(u) ? null : u;
        }(r.limit));
        let d = null;
        r.startAt && (d = function(p) {
            let u = !!p.before, m = p.values || [];
            return new ka(m, u);
        }(r.startAt));
        let v = null;
        return r.endAt && (v = function(p) {
            let u = !p.before, m = p.values || [];
            return new ka(m, u);
        }(r.endAt)), zA(_, n, c, s, i, "F", d, v);
    }
    function gN(e, _) {
        let r = function(n) {
            switch(n){
                case "TargetPurposeListen":
                    return null;
                case "TargetPurposeExistenceFilterMismatch":
                    return "existence-filter-mismatch";
                case "TargetPurposeExistenceFilterMismatchBloom":
                    return "existence-filter-mismatch-bloom";
                case "TargetPurposeLimboResolution":
                    return "limbo-document";
                default:
                    return Z_();
            }
        }(_.purpose);
        return r == null ? null : {
            "goog-listen-tags": r
        };
    }
    function eD(e) {
        return e.unaryFilter !== void 0 ? function(r) {
            switch(r.unaryFilter.op){
                case "IS_NAN":
                    let t = fa(r.unaryFilter.field);
                    return Oo.create(t, "==", {
                        doubleValue: NaN
                    });
                case "IS_NULL":
                    let n = fa(r.unaryFilter.field);
                    return Oo.create(n, "==", {
                        nullValue: "NULL_VALUE"
                    });
                case "IS_NOT_NAN":
                    let s = fa(r.unaryFilter.field);
                    return Oo.create(s, "!=", {
                        doubleValue: NaN
                    });
                case "IS_NOT_NULL":
                    let c = fa(r.unaryFilter.field);
                    return Oo.create(c, "!=", {
                        nullValue: "NULL_VALUE"
                    });
                default:
                    return Z_();
            }
        }(e) : e.fieldFilter !== void 0 ? function(r) {
            return Oo.create(fa(r.fieldFilter.field), function(n) {
                switch(n){
                    case "EQUAL":
                        return "==";
                    case "NOT_EQUAL":
                        return "!=";
                    case "GREATER_THAN":
                        return ">";
                    case "GREATER_THAN_OR_EQUAL":
                        return ">=";
                    case "LESS_THAN":
                        return "<";
                    case "LESS_THAN_OR_EQUAL":
                        return "<=";
                    case "ARRAY_CONTAINS":
                        return "array-contains";
                    case "IN":
                        return "in";
                    case "NOT_IN":
                        return "not-in";
                    case "ARRAY_CONTAINS_ANY":
                        return "array-contains-any";
                    default:
                        return Z_();
                }
            }(r.fieldFilter.op), r.fieldFilter.value);
        }(e) : e.compositeFilter !== void 0 ? function(r) {
            return Ut.create(r.compositeFilter.filters.map((t)=>eD(t)), function(n) {
                switch(n){
                    case "AND":
                        return "and";
                    case "OR":
                        return "or";
                    default:
                        return Z_();
                }
            }(r.compositeFilter.op));
        }(e) : Z_();
    }
    function bN(e) {
        return rN[e];
    }
    function pN(e) {
        return tN[e];
    }
    function fN(e) {
        return nN[e];
    }
    function pa(e) {
        return {
            fieldPath: e.canonicalString()
        };
    }
    function fa(e) {
        return gt.fromServerFormat(e.fieldPath);
    }
    function oD(e) {
        return e instanceof Oo ? function(r) {
            if (r.op === "==") {
                if (e4(r.value)) return {
                    unaryFilter: {
                        field: pa(r.field),
                        op: "IS_NAN"
                    }
                };
                if (_4(r.value)) return {
                    unaryFilter: {
                        field: pa(r.field),
                        op: "IS_NULL"
                    }
                };
            } else if (r.op === "!=") {
                if (e4(r.value)) return {
                    unaryFilter: {
                        field: pa(r.field),
                        op: "IS_NOT_NAN"
                    }
                };
                if (_4(r.value)) return {
                    unaryFilter: {
                        field: pa(r.field),
                        op: "IS_NOT_NULL"
                    }
                };
            }
            return {
                fieldFilter: {
                    field: pa(r.field),
                    op: pN(r.op),
                    value: r.value
                }
            };
        }(e) : e instanceof Ut ? function(r) {
            let t = r.getFilters().map((n)=>oD(n));
            return t.length === 1 ? t[0] : {
                compositeFilter: {
                    op: fN(r.op),
                    filters: t
                }
            };
        }(e) : Z_();
    }
    function mN(e) {
        let _ = [];
        return e.fields.forEach((r)=>_.push(r.canonicalString())), {
            fieldPaths: _
        };
    }
    function rD(e) {
        return e.length >= 4 && e.get(0) === "projects" && e.get(2) === "databases";
    }
    var Cl = class e {
        constructor(_, r, t, n, s = le.min(), c = le.min(), i = Mr.EMPTY_BYTE_STRING, d = null){
            this.target = _, this.targetId = r, this.purpose = t, this.sequenceNumber = n, this.snapshotVersion = s, this.lastLimboFreeSnapshotVersion = c, this.resumeToken = i, this.expectedCount = d;
        }
        withSequenceNumber(_) {
            return new e(this.target, this.targetId, this.purpose, _, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
        }
        withResumeToken(_, r) {
            return new e(this.target, this.targetId, this.purpose, this.sequenceNumber, r, this.lastLimboFreeSnapshotVersion, _, null);
        }
        withExpectedCount(_) {
            return new e(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, _);
        }
        withLastLimboFreeSnapshotVersion(_) {
            return new e(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, _, this.resumeToken, this.expectedCount);
        }
    };
    var df = class {
        constructor(_){
            this.ct = _;
        }
    };
    function $N(e) {
        let _ = uN({
            parent: e.parent,
            structuredQuery: e.structuredQuery
        });
        return e.limitType === "LAST" ? Q5(_, _.limit, "L") : _;
    }
    var xu = class {
        constructor(){}
        Pt(_, r) {
            this.It(_, r), r.Tt();
        }
        It(_, r) {
            if ("nullValue" in _) this.Et(r, 5);
            else if ("booleanValue" in _) this.Et(r, 10), r.dt(_.booleanValue ? 1 : 0);
            else if ("integerValue" in _) this.Et(r, 15), r.dt($o(_.integerValue));
            else if ("doubleValue" in _) {
                let t = $o(_.doubleValue);
                isNaN(t) ? this.Et(r, 13) : (this.Et(r, 15), Il(t) ? r.dt(0) : r.dt(t));
            } else if ("timestampValue" in _) {
                let t = _.timestampValue;
                this.Et(r, 20), typeof t == "string" && (t = e0(t)), r.At(`${t.seconds || ""}`), r.dt(t.nanos || 0);
            } else if ("stringValue" in _) this.Rt(_.stringValue, r), this.Vt(r);
            else if ("bytesValue" in _) this.Et(r, 30), r.ft(Q0(_.bytesValue)), this.Vt(r);
            else if ("referenceValue" in _) this.gt(_.referenceValue, r);
            else if ("geoPointValue" in _) {
                let t = _.geoPointValue;
                this.Et(r, 45), r.dt(t.latitude || 0), r.dt(t.longitude || 0);
            } else "mapValue" in _ ? E4(_) ? this.Et(r, Number.MAX_SAFE_INTEGER) : (this.yt(_.mapValue, r), this.Vt(r)) : "arrayValue" in _ ? (this.wt(_.arrayValue, r), this.Vt(r)) : Z_();
        }
        Rt(_, r) {
            this.Et(r, 25), this.St(_, r);
        }
        St(_, r) {
            r.At(_);
        }
        yt(_, r) {
            let t = _.fields || {};
            this.Et(r, 55);
            for (let n of Object.keys(t))this.Rt(n, r), this.It(t[n], r);
        }
        wt(_, r) {
            let t = _.values || [];
            this.Et(r, 50);
            for (let n of t)this.It(n, r);
        }
        gt(_, r) {
            this.Et(r, 37), V_.fromName(_).path.forEach((t)=>{
                this.Et(r, 60), this.St(t, r);
            });
        }
        Et(_, r) {
            _.dt(r);
        }
        Vt(_) {
            _.dt(2);
        }
    };
    xu.bt = new xu;
    var vf = class {
        constructor(){
            this._n = new uf;
        }
        addToCollectionParentIndex(_, r) {
            return this._n.add(r), d_.resolve();
        }
        getCollectionParents(_, r) {
            return d_.resolve(this._n.getEntries(r));
        }
        addFieldIndex(_, r) {
            return d_.resolve();
        }
        deleteFieldIndex(_, r) {
            return d_.resolve();
        }
        deleteAllFieldIndexes(_) {
            return d_.resolve();
        }
        createTargetIndexes(_, r) {
            return d_.resolve();
        }
        getDocumentsMatchingTarget(_, r) {
            return d_.resolve(null);
        }
        getIndexType(_, r) {
            return d_.resolve(0);
        }
        getFieldIndexes(_, r) {
            return d_.resolve([]);
        }
        getNextCollectionGroupToUpdate(_) {
            return d_.resolve(null);
        }
        getMinOffset(_, r) {
            return d_.resolve(oc.min());
        }
        getMinOffsetFromCollectionGroup(_, r) {
            return d_.resolve(oc.min());
        }
        updateCollectionGroup(_, r, t) {
            return d_.resolve();
        }
        updateIndexEntries(_, r) {
            return d_.resolve();
        }
    }, uf = class {
        constructor(){
            this.index = {};
        }
        add(_) {
            let r = _.lastSegment(), t = _.popLast(), n = this.index[r] || new yr(ao.comparator), s = !n.has(t);
            return this.index[r] = n.add(t), s;
        }
        has(_) {
            let r = _.lastSegment(), t = _.popLast(), n = this.index[r];
            return n && n.has(t);
        }
        getEntries(_) {
            return (this.index[_] || new yr(ao.comparator)).toArray();
        }
    };
    var xZ = new Uint8Array(0);
    var dn = class e {
        constructor(_, r, t){
            this.cacheSizeCollectionThreshold = _, this.percentileToCollect = r, this.maximumSequenceNumbersToCollect = t;
        }
        static withCacheSize(_) {
            return new e(_, e.DEFAULT_COLLECTION_PERCENTILE, e.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
        }
    };
    dn.DEFAULT_COLLECTION_PERCENTILE = 10, dn.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, dn.DEFAULT = new dn(41943040, dn.DEFAULT_COLLECTION_PERCENTILE, dn.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), dn.DISABLED = new dn(-1, 0, 0);
    var Al = class e {
        constructor(_){
            this.On = _;
        }
        next() {
            return this.On += 2, this.On;
        }
        static Nn() {
            return new e(0);
        }
        static Ln() {
            return new e(-1);
        }
    };
    var gf = class {
        constructor(){
            this.changes = new Y0((_)=>_.toString(), (_, r)=>_.isEqual(r)), this.changesApplied = !1;
        }
        addEntry(_) {
            this.assertNotApplied(), this.changes.set(_.key, _);
        }
        removeEntry(_, r) {
            this.assertNotApplied(), this.changes.set(_, Ot.newInvalidDocument(_).setReadTime(r));
        }
        getEntry(_, r) {
            this.assertNotApplied();
            let t = this.changes.get(r);
            return t !== void 0 ? d_.resolve(t) : this.getFromCache(_, r);
        }
        getEntries(_, r) {
            return this.getAllFromCache(_, r);
        }
        apply(_) {
            return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(_);
        }
        assertNotApplied() {}
    };
    var bf = class {
        constructor(_, r){
            this.overlayedDocument = _, this.mutatedFields = r;
        }
    };
    var pf = class {
        constructor(_, r, t, n){
            this.remoteDocumentCache = _, this.mutationQueue = r, this.documentOverlayCache = t, this.indexManager = n;
        }
        getDocument(_, r) {
            let t = null;
            return this.documentOverlayCache.getOverlay(_, r).next((n)=>(t = n, this.remoteDocumentCache.getEntry(_, r))).next((n)=>(t !== null && kl(t.mutation, n, vn.empty(), sr.now()), n));
        }
        getDocuments(_, r) {
            return this.remoteDocumentCache.getEntries(_, r).next((t)=>this.getLocalViewOfDocuments(_, t, ke()).next(()=>t));
        }
        getLocalViewOfDocuments(_, r, t = ke()) {
            let n = Xs();
            return this.populateOverlays(_, n, r).next(()=>this.computeViews(_, r, n, t).next((s)=>{
                    let c = yl();
                    return s.forEach((i, d)=>{
                        c = c.insert(i, d.overlayedDocument);
                    }), c;
                }));
        }
        getOverlayedDocuments(_, r) {
            let t = Xs();
            return this.populateOverlays(_, t, r).next(()=>this.computeViews(_, r, t, ke()));
        }
        populateOverlays(_, r, t) {
            let n = [];
            return t.forEach((s)=>{
                r.has(s) || n.push(s);
            }), this.documentOverlayCache.getOverlays(_, n).next((s)=>{
                s.forEach((c, i)=>{
                    r.set(c, i);
                });
            });
        }
        computeViews(_, r, t, n) {
            let s = o0(), c = Rl(), i = function() {
                return Rl();
            }();
            return r.forEach((d, v)=>{
                let b = t.get(v.key);
                n.has(v.key) && (b === void 0 || b.mutation instanceof r0) ? s = s.insert(v.key, v) : b !== void 0 ? (c.set(v.key, b.mutation.getFieldMask()), kl(b.mutation, v, b.mutation.getFieldMask(), sr.now())) : c.set(v.key, vn.empty());
            }), this.recalculateAndSaveOverlays(_, s).next((d)=>(d.forEach((v, b)=>c.set(v, b)), r.forEach((v, b)=>{
                    var p;
                    return i.set(v, new bf(b, (p = c.get(v)) !== null && p !== void 0 ? p : null));
                }), i));
        }
        recalculateAndSaveOverlays(_, r) {
            let t = Rl(), n = new ho((c, i)=>c - i), s = ke();
            return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(_, r).next((c)=>{
                for (let i of c)i.keys().forEach((d)=>{
                    let v = r.get(d);
                    if (v === null) return;
                    let b = t.get(d) || vn.empty();
                    b = i.applyToLocalView(v, b), t.set(d, b);
                    let p = (n.get(i.batchId) || ke()).add(d);
                    n = n.insert(i.batchId, p);
                });
            }).next(()=>{
                let c = [], i = n.getReverseIterator();
                for(; i.hasNext();){
                    let d = i.getNext(), v = d.key, b = d.value, p = U4();
                    b.forEach((u)=>{
                        if (!s.has(u)) {
                            let m = j4(r.get(u), t.get(u));
                            m !== null && p.set(u, m), s = s.add(u);
                        }
                    }), c.push(this.documentOverlayCache.saveOverlays(_, v, p));
                }
                return d_.waitFor(c);
            }).next(()=>t);
        }
        recalculateAndSaveOverlaysForDocumentKeys(_, r) {
            return this.remoteDocumentCache.getEntries(_, r).next((t)=>this.recalculateAndSaveOverlays(_, t));
        }
        getDocumentsMatchingQuery(_, r, t, n) {
            return function(c) {
                return V_.isDocumentKey(c.path) && c.collectionGroup === null && c.filters.length === 0;
            }(r) ? this.getDocumentsMatchingDocumentQuery(_, r.path) : M4(r) ? this.getDocumentsMatchingCollectionGroupQuery(_, r, t, n) : this.getDocumentsMatchingCollectionQuery(_, r, t, n);
        }
        getNextDocuments(_, r, t, n) {
            return this.remoteDocumentCache.getAllFromCollectionGroup(_, r, t, n).next((s)=>{
                let c = n - s.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(_, r, t.largestBatchId, n - s.size) : d_.resolve(Xs()), i = -1, d = s;
                return c.next((v)=>d_.forEach(v, (b, p)=>(i < p.largestBatchId && (i = p.largestBatchId), s.get(b) ? d_.resolve() : this.remoteDocumentCache.getEntry(_, b).next((u)=>{
                            d = d.insert(b, u);
                        }))).next(()=>this.populateOverlays(_, v, s)).next(()=>this.computeViews(_, d, v, ke())).next((b)=>({
                            batchId: i,
                            changes: O4(b)
                        })));
            });
        }
        getDocumentsMatchingDocumentQuery(_, r) {
            return this.getDocument(_, new V_(r)).next((t)=>{
                let n = yl();
                return t.isFoundDocument() && (n = n.insert(t.key, t)), n;
            });
        }
        getDocumentsMatchingCollectionGroupQuery(_, r, t, n) {
            let s = r.collectionGroup, c = yl();
            return this.indexManager.getCollectionParents(_, s).next((i)=>d_.forEach(i, (d)=>{
                    let v = function(p, u) {
                        return new tc(u, null, p.explicitOrderBy.slice(), p.filters.slice(), p.limit, p.limitType, p.startAt, p.endAt);
                    }(r, d.child(s));
                    return this.getDocumentsMatchingCollectionQuery(_, v, t, n).next((b)=>{
                        b.forEach((p, u)=>{
                            c = c.insert(p, u);
                        });
                    });
                }).next(()=>c));
        }
        getDocumentsMatchingCollectionQuery(_, r, t, n) {
            let s;
            return this.documentOverlayCache.getOverlaysForCollection(_, r.path, t.largestBatchId).next((c)=>(s = c, this.remoteDocumentCache.getDocumentsMatchingQuery(_, r, t, s, n))).next((c)=>{
                s.forEach((d, v)=>{
                    let b = v.getKey();
                    c.get(b) === null && (c = c.insert(b, Ot.newInvalidDocument(b)));
                });
                let i = yl();
                return c.forEach((d, v)=>{
                    let b = s.get(d);
                    b !== void 0 && kl(b.mutation, v, vn.empty(), sr.now()), Qu(r, v) && (i = i.insert(d, v));
                }), i;
            });
        }
    };
    var ff = class {
        constructor(_){
            this.serializer = _, this.cr = new Map, this.lr = new Map;
        }
        getBundleMetadata(_, r) {
            return d_.resolve(this.cr.get(r));
        }
        saveBundleMetadata(_, r) {
            return this.cr.set(r.id, function(n) {
                return {
                    id: n.id,
                    version: n.version,
                    createTime: pn(n.createTime)
                };
            }(r)), d_.resolve();
        }
        getNamedQuery(_, r) {
            return d_.resolve(this.lr.get(r));
        }
        saveNamedQuery(_, r) {
            return this.lr.set(r.name, function(n) {
                return {
                    name: n.name,
                    query: $N(n.bundledQuery),
                    readTime: pn(n.readTime)
                };
            }(r)), d_.resolve();
        }
    };
    var mf = class {
        constructor(){
            this.overlays = new ho(V_.comparator), this.hr = new Map;
        }
        getOverlay(_, r) {
            return d_.resolve(this.overlays.get(r));
        }
        getOverlays(_, r) {
            let t = Xs();
            return d_.forEach(r, (n)=>this.getOverlay(_, n).next((s)=>{
                    s !== null && t.set(n, s);
                })).next(()=>t);
        }
        saveOverlays(_, r, t) {
            return t.forEach((n, s)=>{
                this.ht(_, r, s);
            }), d_.resolve();
        }
        removeOverlaysForBatchId(_, r, t) {
            let n = this.hr.get(t);
            return n !== void 0 && (n.forEach((s)=>this.overlays = this.overlays.remove(s)), this.hr.delete(t)), d_.resolve();
        }
        getOverlaysForCollection(_, r, t) {
            let n = Xs(), s = r.length + 1, c = new V_(r.child("")), i = this.overlays.getIteratorFrom(c);
            for(; i.hasNext();){
                let d = i.getNext().value, v = d.getKey();
                if (!r.isPrefixOf(v.path)) break;
                v.path.length === s && d.largestBatchId > t && n.set(d.getKey(), d);
            }
            return d_.resolve(n);
        }
        getOverlaysForCollectionGroup(_, r, t, n) {
            let s = new ho((v, b)=>v - b), c = this.overlays.getIterator();
            for(; c.hasNext();){
                let v = c.getNext().value;
                if (v.getKey().getCollectionGroup() === r && v.largestBatchId > t) {
                    let b = s.get(v.largestBatchId);
                    b === null && (b = Xs(), s = s.insert(v.largestBatchId, b)), b.set(v.getKey(), v);
                }
            }
            let i = Xs(), d = s.getIterator();
            for(; d.hasNext() && (d.getNext().value.forEach((v, b)=>i.set(v, b)), !(i.size() >= n)););
            return d_.resolve(i);
        }
        ht(_, r, t) {
            let n = this.overlays.get(t.key);
            if (n !== null) {
                let c = this.hr.get(n.largestBatchId).delete(t.key);
                this.hr.set(n.largestBatchId, c);
            }
            this.overlays = this.overlays.insert(t.key, new ef(r, t));
            let s = this.hr.get(r);
            s === void 0 && (s = ke(), this.hr.set(r, s)), this.hr.set(r, s.add(t.key));
        }
    };
    var Nl = class {
        constructor(){
            this.Pr = new yr(zo.Ir), this.Tr = new yr(zo.Er);
        }
        isEmpty() {
            return this.Pr.isEmpty();
        }
        addReference(_, r) {
            let t = new zo(_, r);
            this.Pr = this.Pr.add(t), this.Tr = this.Tr.add(t);
        }
        dr(_, r) {
            _.forEach((t)=>this.addReference(t, r));
        }
        removeReference(_, r) {
            this.Ar(new zo(_, r));
        }
        Rr(_, r) {
            _.forEach((t)=>this.removeReference(t, r));
        }
        Vr(_) {
            let r = new V_(new ao([])), t = new zo(r, _), n = new zo(r, _ + 1), s = [];
            return this.Tr.forEachInRange([
                t,
                n
            ], (c)=>{
                this.Ar(c), s.push(c.key);
            }), s;
        }
        mr() {
            this.Pr.forEach((_)=>this.Ar(_));
        }
        Ar(_) {
            this.Pr = this.Pr.delete(_), this.Tr = this.Tr.delete(_);
        }
        gr(_) {
            let r = new V_(new ao([])), t = new zo(r, _), n = new zo(r, _ + 1), s = ke();
            return this.Tr.forEachInRange([
                t,
                n
            ], (c)=>{
                s = s.add(c.key);
            }), s;
        }
        containsKey(_) {
            let r = new zo(_, 0), t = this.Pr.firstAfterOrEqual(r);
            return t !== null && _.isEqual(t.key);
        }
    }, zo = class {
        constructor(_, r){
            this.key = _, this.pr = r;
        }
        static Ir(_, r) {
            return V_.comparator(_.key, r.key) || Ae(_.pr, r.pr);
        }
        static Er(_, r) {
            return Ae(_.pr, r.pr) || V_.comparator(_.key, r.key);
        }
    };
    var $f = class {
        constructor(_, r){
            this.indexManager = _, this.referenceDelegate = r, this.mutationQueue = [], this.yr = 1, this.wr = new yr(zo.Ir);
        }
        checkEmpty(_) {
            return d_.resolve(this.mutationQueue.length === 0);
        }
        addMutationBatch(_, r, t, n) {
            let s = this.yr;
            this.yr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
            let c = new Z5(s, r, t, n);
            this.mutationQueue.push(c);
            for (let i of n)this.wr = this.wr.add(new zo(i.key, s)), this.indexManager.addToCollectionParentIndex(_, i.key.path.popLast());
            return d_.resolve(c);
        }
        lookupMutationBatch(_, r) {
            return d_.resolve(this.Sr(r));
        }
        getNextMutationBatchAfterBatchId(_, r) {
            let t = r + 1, n = this.br(t), s = n < 0 ? 0 : n;
            return d_.resolve(this.mutationQueue.length > s ? this.mutationQueue[s] : null);
        }
        getHighestUnacknowledgedBatchId() {
            return d_.resolve(this.mutationQueue.length === 0 ? -1 : this.yr - 1);
        }
        getAllMutationBatches(_) {
            return d_.resolve(this.mutationQueue.slice());
        }
        getAllMutationBatchesAffectingDocumentKey(_, r) {
            let t = new zo(r, 0), n = new zo(r, Number.POSITIVE_INFINITY), s = [];
            return this.wr.forEachInRange([
                t,
                n
            ], (c)=>{
                let i = this.Sr(c.pr);
                s.push(i);
            }), d_.resolve(s);
        }
        getAllMutationBatchesAffectingDocumentKeys(_, r) {
            let t = new yr(Ae);
            return r.forEach((n)=>{
                let s = new zo(n, 0), c = new zo(n, Number.POSITIVE_INFINITY);
                this.wr.forEachInRange([
                    s,
                    c
                ], (i)=>{
                    t = t.add(i.pr);
                });
            }), d_.resolve(this.Dr(t));
        }
        getAllMutationBatchesAffectingQuery(_, r) {
            let t = r.path, n = t.length + 1, s = t;
            V_.isDocumentKey(s) || (s = s.child(""));
            let c = new zo(new V_(s), 0), i = new yr(Ae);
            return this.wr.forEachWhile((d)=>{
                let v = d.key.path;
                return !!t.isPrefixOf(v) && (v.length === n && (i = i.add(d.pr)), !0);
            }, c), d_.resolve(this.Dr(i));
        }
        Dr(_) {
            let r = [];
            return _.forEach((t)=>{
                let n = this.Sr(t);
                n !== null && r.push(n);
            }), r;
        }
        removeMutationBatch(_, r) {
            Ve(this.Cr(r.batchId, "removed") === 0), this.mutationQueue.shift();
            let t = this.wr;
            return d_.forEach(r.mutations, (n)=>{
                let s = new zo(n.key, r.batchId);
                return t = t.delete(s), this.referenceDelegate.markPotentiallyOrphaned(_, n.key);
            }).next(()=>{
                this.wr = t;
            });
        }
        Mn(_) {}
        containsKey(_, r) {
            let t = new zo(r, 0), n = this.wr.firstAfterOrEqual(t);
            return d_.resolve(r.isEqual(n && n.key));
        }
        performConsistencyCheck(_) {
            return this.mutationQueue.length, d_.resolve();
        }
        Cr(_, r) {
            return this.br(_);
        }
        br(_) {
            return this.mutationQueue.length === 0 ? 0 : _ - this.mutationQueue[0].batchId;
        }
        Sr(_) {
            let r = this.br(_);
            return r < 0 || r >= this.mutationQueue.length ? null : this.mutationQueue[r];
        }
    };
    var hf = class {
        constructor(_){
            this.vr = _, this.docs = function() {
                return new ho(V_.comparator);
            }(), this.size = 0;
        }
        setIndexManager(_) {
            this.indexManager = _;
        }
        addEntry(_, r) {
            let t = r.key, n = this.docs.get(t), s = n ? n.size : 0, c = this.vr(r);
            return this.docs = this.docs.insert(t, {
                document: r.mutableCopy(),
                size: c
            }), this.size += c - s, this.indexManager.addToCollectionParentIndex(_, t.path.popLast());
        }
        removeEntry(_) {
            let r = this.docs.get(_);
            r && (this.docs = this.docs.remove(_), this.size -= r.size);
        }
        getEntry(_, r) {
            let t = this.docs.get(r);
            return d_.resolve(t ? t.document.mutableCopy() : Ot.newInvalidDocument(r));
        }
        getEntries(_, r) {
            let t = o0();
            return r.forEach((n)=>{
                let s = this.docs.get(n);
                t = t.insert(n, s ? s.document.mutableCopy() : Ot.newInvalidDocument(n));
            }), d_.resolve(t);
        }
        getDocumentsMatchingQuery(_, r, t, n) {
            let s = o0(), c = r.path, i = new V_(c.child("")), d = this.docs.getIteratorFrom(i);
            for(; d.hasNext();){
                let { key: v , value: { document: b  }  } = d.getNext();
                if (!c.isPrefixOf(v.path)) break;
                v.path.length > c.length + 1 || EA(xA(b), t) <= 0 || (n.has(b.key) || Qu(r, b)) && (s = s.insert(b.key, b.mutableCopy()));
            }
            return d_.resolve(s);
        }
        getAllFromCollectionGroup(_, r, t, n) {
            Z_();
        }
        Fr(_, r) {
            return d_.forEach(this.docs, (t)=>r(t));
        }
        newChangeBuffer(_) {
            return new yf(this);
        }
        getSize(_) {
            return d_.resolve(this.size);
        }
    }, yf = class extends gf {
        constructor(_){
            super(), this.ar = _;
        }
        applyChanges(_) {
            let r = [];
            return this.changes.forEach((t, n)=>{
                n.isValidDocument() ? r.push(this.ar.addEntry(_, n)) : this.ar.removeEntry(t);
            }), d_.waitFor(r);
        }
        getFromCache(_, r) {
            return this.ar.getEntry(_, r);
        }
        getAllFromCache(_, r) {
            return this.ar.getEntries(_, r);
        }
    };
    var Df = class {
        constructor(_){
            this.persistence = _, this.Mr = new Y0((r)=>vm(r), um), this.lastRemoteSnapshotVersion = le.min(), this.highestTargetId = 0, this.Or = 0, this.Nr = new Nl, this.targetCount = 0, this.Lr = Al.Nn();
        }
        forEachTarget(_, r) {
            return this.Mr.forEach((t, n)=>r(n)), d_.resolve();
        }
        getLastRemoteSnapshotVersion(_) {
            return d_.resolve(this.lastRemoteSnapshotVersion);
        }
        getHighestSequenceNumber(_) {
            return d_.resolve(this.Or);
        }
        allocateTargetId(_) {
            return this.highestTargetId = this.Lr.next(), d_.resolve(this.highestTargetId);
        }
        setTargetsMetadata(_, r, t) {
            return t && (this.lastRemoteSnapshotVersion = t), r > this.Or && (this.Or = r), d_.resolve();
        }
        qn(_) {
            this.Mr.set(_.target, _);
            let r = _.targetId;
            r > this.highestTargetId && (this.Lr = new Al(r), this.highestTargetId = r), _.sequenceNumber > this.Or && (this.Or = _.sequenceNumber);
        }
        addTargetData(_, r) {
            return this.qn(r), this.targetCount += 1, d_.resolve();
        }
        updateTargetData(_, r) {
            return this.qn(r), d_.resolve();
        }
        removeTargetData(_, r) {
            return this.Mr.delete(r.target), this.Nr.Vr(r.targetId), this.targetCount -= 1, d_.resolve();
        }
        removeTargets(_, r, t) {
            let n = 0, s = [];
            return this.Mr.forEach((c, i)=>{
                i.sequenceNumber <= r && t.get(i.targetId) === null && (this.Mr.delete(c), s.push(this.removeMatchingKeysForTargetId(_, i.targetId)), n++);
            }), d_.waitFor(s).next(()=>n);
        }
        getTargetCount(_) {
            return d_.resolve(this.targetCount);
        }
        getTargetData(_, r) {
            let t = this.Mr.get(r) || null;
            return d_.resolve(t);
        }
        addMatchingKeys(_, r, t) {
            return this.Nr.dr(r, t), d_.resolve();
        }
        removeMatchingKeys(_, r, t) {
            this.Nr.Rr(r, t);
            let n = this.persistence.referenceDelegate, s = [];
            return n && r.forEach((c)=>{
                s.push(n.markPotentiallyOrphaned(_, c));
            }), d_.waitFor(s);
        }
        removeMatchingKeysForTargetId(_, r) {
            return this.Nr.Vr(r), d_.resolve();
        }
        getMatchingKeysForTargetId(_, r) {
            let t = this.Nr.gr(r);
            return d_.resolve(t);
        }
        containsKey(_, r) {
            return d_.resolve(this.Nr.containsKey(r));
        }
    };
    var wf = class {
        constructor(_, r){
            this.Br = {}, this.overlays = {}, this.kr = new Sl(0), this.qr = !1, this.qr = !0, this.referenceDelegate = _(this), this.Qr = new Df(this), this.indexManager = new vf, this.remoteDocumentCache = function(n) {
                return new hf(n);
            }((t)=>this.referenceDelegate.Kr(t)), this.serializer = new df(r), this.$r = new ff(this.serializer);
        }
        start() {
            return Promise.resolve();
        }
        shutdown() {
            return this.qr = !1, Promise.resolve();
        }
        get started() {
            return this.qr;
        }
        setDatabaseDeletedListener() {}
        setNetworkEnabled() {}
        getIndexManager(_) {
            return this.indexManager;
        }
        getDocumentOverlayCache(_) {
            let r = this.overlays[_.toKey()];
            return r || (r = new mf, this.overlays[_.toKey()] = r), r;
        }
        getMutationQueue(_, r) {
            let t = this.Br[_.toKey()];
            return t || (t = new $f(r, this.referenceDelegate), this.Br[_.toKey()] = t), t;
        }
        getTargetCache() {
            return this.Qr;
        }
        getRemoteDocumentCache() {
            return this.remoteDocumentCache;
        }
        getBundleCache() {
            return this.$r;
        }
        runTransaction(_, r, t) {
            k_("MemoryPersistence", "Starting transaction:", _);
            let n = new Rf(this.kr.next());
            return this.referenceDelegate.Ur(), t(n).next((s)=>this.referenceDelegate.Wr(n).next(()=>s)).toPromise().then((s)=>(n.raiseOnCommittedEvent(), s));
        }
        Gr(_, r) {
            return d_.or(Object.values(this.Br).map((t)=>()=>t.containsKey(_, r)));
        }
    }, Rf = class extends F5 {
        constructor(_){
            super(), this.currentSequenceNumber = _;
        }
    }, kf = class e {
        constructor(_){
            this.persistence = _, this.zr = new Nl, this.jr = null;
        }
        static Hr(_) {
            return new e(_);
        }
        get Jr() {
            if (this.jr) return this.jr;
            throw Z_();
        }
        addReference(_, r, t) {
            return this.zr.addReference(t, r), this.Jr.delete(t.toString()), d_.resolve();
        }
        removeReference(_, r, t) {
            return this.zr.removeReference(t, r), this.Jr.add(t.toString()), d_.resolve();
        }
        markPotentiallyOrphaned(_, r) {
            return this.Jr.add(r.toString()), d_.resolve();
        }
        removeTarget(_, r) {
            this.zr.Vr(r.targetId).forEach((n)=>this.Jr.add(n.toString()));
            let t = this.persistence.getTargetCache();
            return t.getMatchingKeysForTargetId(_, r.targetId).next((n)=>{
                n.forEach((s)=>this.Jr.add(s.toString()));
            }).next(()=>t.removeTargetData(_, r));
        }
        Ur() {
            this.jr = new Set;
        }
        Wr(_) {
            let r = this.persistence.getRemoteDocumentCache().newChangeBuffer();
            return d_.forEach(this.Jr, (t)=>{
                let n = V_.fromPath(t);
                return this.Yr(_, n).next((s)=>{
                    s || r.removeEntry(n, le.min());
                });
            }).next(()=>(this.jr = null, r.apply(_)));
        }
        updateLimboDocument(_, r) {
            return this.Yr(_, r).next((t)=>{
                t ? this.Jr.delete(r.toString()) : this.Jr.add(r.toString());
            });
        }
        Kr(_) {
            return 0;
        }
        Yr(_, r) {
            return d_.or([
                ()=>d_.resolve(this.zr.containsKey(r)),
                ()=>this.persistence.getTargetCache().containsKey(_, r),
                ()=>this.persistence.Gr(_, r)
            ]);
        }
    };
    var Sf = class e {
        constructor(_, r, t, n){
            this.targetId = _, this.fromCache = r, this.qi = t, this.Qi = n;
        }
        static Ki(_, r) {
            let t = ke(), n = ke();
            for (let s of r.docChanges)switch(s.type){
                case 0:
                    t = t.add(s.doc.key);
                    break;
                case 1:
                    n = n.add(s.doc.key);
            }
            return new e(_, r.fromCache, t, n);
        }
    };
    var If = class {
        constructor(){
            this._documentReadCount = 0;
        }
        get documentReadCount() {
            return this._documentReadCount;
        }
        incrementDocumentReadCount(_) {
            this._documentReadCount += _;
        }
    };
    var xf = class {
        constructor(){
            this.$i = !1, this.Ui = !1, this.Wi = 100, this.Gi = function() {
                return T9() ? 8 : GA(Wo()) > 0 ? 6 : 4;
            }();
        }
        initialize(_, r) {
            this.zi = _, this.indexManager = r, this.$i = !0;
        }
        getDocumentsMatchingQuery(_, r, t, n) {
            let s = {
                result: null
            };
            return this.ji(_, r).next((c)=>{
                s.result = c;
            }).next(()=>{
                if (!s.result) return this.Hi(_, r, n, t).next((c)=>{
                    s.result = c;
                });
            }).next(()=>{
                if (s.result) return;
                let c = new If;
                return this.Ji(_, r, c).next((i)=>{
                    if (s.result = i, this.Ui) return this.Yi(_, r, c, i.size);
                });
            }).next(()=>s.result);
        }
        Yi(_, r, t, n) {
            return t.documentReadCount < this.Wi ? (hl() <= ye.DEBUG && k_("QueryEngine", "SDK will not create cache indexes for query:", ba(r), "since it only creates cache indexes for collection contains", "more than or equal to", this.Wi, "documents"), d_.resolve()) : (hl() <= ye.DEBUG && k_("QueryEngine", "Query:", ba(r), "scans", t.documentReadCount, "local documents and returns", n, "documents as results."), t.documentReadCount > this.Gi * n ? (hl() <= ye.DEBUG && k_("QueryEngine", "The SDK decides to create cache indexes for query:", ba(r), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(_, bn(r))) : d_.resolve());
        }
        ji(_, r) {
            if (n4(r)) return d_.resolve(null);
            let t = bn(r);
            return this.indexManager.getIndexType(_, t).next((n)=>n === 0 ? null : (r.limit !== null && n === 1 && (r = Q5(r, null, "F"), t = bn(r)), this.indexManager.getDocumentsMatchingTarget(_, t).next((s)=>{
                    let c = ke(...s);
                    return this.zi.getDocuments(_, c).next((i)=>this.indexManager.getMinOffset(_, t).next((d)=>{
                            let v = this.Zi(r, i);
                            return this.Xi(r, v, c, d.readTime) ? this.ji(_, Q5(r, null, "F")) : this.es(_, v, r, d);
                        }));
                })));
        }
        Hi(_, r, t, n) {
            return n4(r) || n.isEqual(le.min()) ? d_.resolve(null) : this.zi.getDocuments(_, t).next((s)=>{
                let c = this.Zi(r, s);
                return this.Xi(r, c, t, n) ? d_.resolve(null) : (hl() <= ye.DEBUG && k_("QueryEngine", "Re-using previous result from %s to execute query: %s", n.toString(), ba(r)), this.es(_, c, r, IA(n, -1)).next((i)=>i));
            });
        }
        Zi(_, r) {
            let t = new yr(L4(_));
            return r.forEach((n, s)=>{
                Qu(_, s) && (t = t.add(s));
            }), t;
        }
        Xi(_, r, t, n) {
            if (_.limit === null) return !1;
            if (t.size !== r.size) return !0;
            let s = _.limitType === "F" ? r.last() : r.first();
            return !!s && (s.hasPendingWrites || s.version.compareTo(n) > 0);
        }
        Ji(_, r, t) {
            return hl() <= ye.DEBUG && k_("QueryEngine", "Using full collection scan to execute query:", ba(r)), this.zi.getDocumentsMatchingQuery(_, r, oc.min(), t);
        }
        es(_, r, t, n) {
            return this.zi.getDocumentsMatchingQuery(_, t, n).next((s)=>(r.forEach((c)=>{
                    s = s.insert(c.key, c);
                }), s));
        }
    };
    var Ef = class {
        constructor(_, r, t, n){
            this.persistence = _, this.ts = r, this.serializer = n, this.ns = new ho(Ae), this.rs = new Y0((s)=>vm(s), um), this.ss = new Map, this.os = _.getRemoteDocumentCache(), this.Qr = _.getTargetCache(), this.$r = _.getBundleCache(), this._s(t);
        }
        _s(_) {
            this.documentOverlayCache = this.persistence.getDocumentOverlayCache(_), this.indexManager = this.persistence.getIndexManager(_), this.mutationQueue = this.persistence.getMutationQueue(_, this.indexManager), this.localDocuments = new pf(this.os, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.os.setIndexManager(this.indexManager), this.ts.initialize(this.localDocuments, this.indexManager);
        }
        collectGarbage(_) {
            return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (r)=>_.collect(r, this.ns));
        }
    };
    function hN(e, _, r, t) {
        return new Ef(e, _, r, t);
    }
    async function tD(e, _) {
        let r = ce(e);
        return await r.persistence.runTransaction("Handle user change", "readonly", (t)=>{
            let n;
            return r.mutationQueue.getAllMutationBatches(t).next((s)=>(n = s, r._s(_), r.mutationQueue.getAllMutationBatches(t))).next((s)=>{
                let c = [], i = [], d = ke();
                for (let v of n){
                    c.push(v.batchId);
                    for (let b of v.mutations)d = d.add(b.key);
                }
                for (let v of s){
                    i.push(v.batchId);
                    for (let b of v.mutations)d = d.add(b.key);
                }
                return r.localDocuments.getDocuments(t, d).next((v)=>({
                        us: v,
                        removedBatchIds: c,
                        addedBatchIds: i
                    }));
            });
        });
    }
    function yN(e, _) {
        let r = ce(e);
        return r.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (t)=>{
            let n = _.batch.keys(), s = r.os.newChangeBuffer({
                trackRemovals: !0
            });
            return (function(i, d, v, b) {
                let p = v.batch, u = p.keys(), m = d_.resolve();
                return u.forEach((z)=>{
                    m = m.next(()=>b.getEntry(d, z)).next((L)=>{
                        let J = v.docVersions.get(z);
                        Ve(J !== null), L.version.compareTo(J) < 0 && (p.applyToRemoteDocument(L, v), L.isValidDocument() && (L.setReadTime(v.commitVersion), b.addEntry(L)));
                    });
                }), m.next(()=>i.mutationQueue.removeMutationBatch(d, p));
            })(r, t, _, s).next(()=>s.apply(t)).next(()=>r.mutationQueue.performConsistencyCheck(t)).next(()=>r.documentOverlayCache.removeOverlaysForBatchId(t, n, _.batch.batchId)).next(()=>r.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(t, function(i) {
                    let d = ke();
                    for(let v = 0; v < i.mutationResults.length; ++v)i.mutationResults[v].transformResults.length > 0 && (d = d.add(i.batch.mutations[v].key));
                    return d;
                }(_))).next(()=>r.localDocuments.getDocuments(t, n));
        });
    }
    function nD(e) {
        let _ = ce(e);
        return _.persistence.runTransaction("Get last remote snapshot version", "readonly", (r)=>_.Qr.getLastRemoteSnapshotVersion(r));
    }
    function DN(e, _) {
        let r = ce(e), t = _.snapshotVersion, n = r.ns;
        return r.persistence.runTransaction("Apply remote event", "readwrite-primary", (s)=>{
            let c = r.os.newChangeBuffer({
                trackRemovals: !0
            });
            n = r.ns;
            let i = [];
            _.targetChanges.forEach((b, p)=>{
                let u = n.get(p);
                if (!u) return;
                i.push(r.Qr.removeMatchingKeys(s, b.removedDocuments, p).next(()=>r.Qr.addMatchingKeys(s, b.addedDocuments, p)));
                let m = u.withSequenceNumber(s.currentSequenceNumber);
                _.targetMismatches.get(p) !== null ? m = m.withResumeToken(Mr.EMPTY_BYTE_STRING, le.min()).withLastLimboFreeSnapshotVersion(le.min()) : b.resumeToken.approximateByteSize() > 0 && (m = m.withResumeToken(b.resumeToken, t)), n = n.insert(p, m), function(L, J, c_) {
                    return L.resumeToken.approximateByteSize() === 0 || J.snapshotVersion.toMicroseconds() - L.snapshotVersion.toMicroseconds() >= 3e8 ? !0 : c_.addedDocuments.size + c_.modifiedDocuments.size + c_.removedDocuments.size > 0;
                }(u, m, b) && i.push(r.Qr.updateTargetData(s, m));
            });
            let d = o0(), v = ke();
            if (_.documentUpdates.forEach((b)=>{
                _.resolvedLimboDocuments.has(b) && i.push(r.persistence.referenceDelegate.updateLimboDocument(s, b));
            }), i.push(wN(s, c, _.documentUpdates).next((b)=>{
                d = b.cs, v = b.ls;
            })), !t.isEqual(le.min())) {
                let b = r.Qr.getLastRemoteSnapshotVersion(s).next((p)=>r.Qr.setTargetsMetadata(s, s.currentSequenceNumber, t));
                i.push(b);
            }
            return d_.waitFor(i).next(()=>c.apply(s)).next(()=>r.localDocuments.getLocalViewOfDocuments(s, d, v)).next(()=>d);
        }).then((s)=>(r.ns = n, s));
    }
    function wN(e, _, r) {
        let t = ke(), n = ke();
        return r.forEach((s)=>t = t.add(s)), _.getEntries(e, t).next((s)=>{
            let c = o0();
            return r.forEach((i, d)=>{
                let v = s.get(i);
                d.isFoundDocument() !== v.isFoundDocument() && (n = n.add(i)), d.isNoDocument() && d.version.isEqual(le.min()) ? (_.removeEntry(i, d.readTime), c = c.insert(i, d)) : !v.isValidDocument() || d.version.compareTo(v.version) > 0 || d.version.compareTo(v.version) === 0 && v.hasPendingWrites ? (_.addEntry(d), c = c.insert(i, d)) : k_("LocalStore", "Ignoring outdated watch update for ", i, ". Current version:", v.version, " Watch version:", d.version);
            }), {
                cs: c,
                ls: n
            };
        });
    }
    function RN(e, _) {
        let r = ce(e);
        return r.persistence.runTransaction("Get next mutation batch", "readonly", (t)=>(_ === void 0 && (_ = -1), r.mutationQueue.getNextMutationBatchAfterBatchId(t, _)));
    }
    function kN(e, _) {
        let r = ce(e);
        return r.persistence.runTransaction("Allocate target", "readwrite", (t)=>{
            let n;
            return r.Qr.getTargetData(t, _).next((s)=>s ? (n = s, d_.resolve(n)) : r.Qr.allocateTargetId(t).next((c)=>(n = new Cl(_, c, "TargetPurposeListen", t.currentSequenceNumber), r.Qr.addTargetData(t, n).next(()=>n))));
        }).then((t)=>{
            let n = r.ns.get(t.targetId);
            return (n === null || t.snapshotVersion.compareTo(n.snapshotVersion) > 0) && (r.ns = r.ns.insert(t.targetId, t), r.rs.set(_, t.targetId)), t;
        });
    }
    async function Tf(e, _, r) {
        let t = ce(e), n = t.ns.get(_), s = r ? "readwrite" : "readwrite-primary";
        try {
            r || await t.persistence.runTransaction("Release target", s, (c)=>t.persistence.referenceDelegate.removeTarget(c, n));
        } catch (c) {
            if (!Ol(c)) throw c;
            k_("LocalStore", `Failed to update sequence numbers for target ${_}: ${c}`);
        }
        t.ns = t.ns.remove(_), t.rs.delete(n.target);
    }
    function p4(e, _, r) {
        let t = ce(e), n = le.min(), s = ke();
        return t.persistence.runTransaction("Execute query", "readwrite", (c)=>(function(d, v, b) {
                let p = ce(d), u = p.rs.get(b);
                return u !== void 0 ? d_.resolve(p.ns.get(u)) : p.Qr.getTargetData(v, b);
            })(t, c, bn(_)).next((i)=>{
                if (i) return n = i.lastLimboFreeSnapshotVersion, t.Qr.getMatchingKeysForTargetId(c, i.targetId).next((d)=>{
                    s = d;
                });
            }).next(()=>t.ts.getDocumentsMatchingQuery(c, _, r ? n : le.min(), r ? s : ke())).next((i)=>(SN(t, UA(_), i), {
                    documents: i,
                    hs: s
                })));
    }
    function SN(e, _, r) {
        let t = e.ss.get(_) || le.min();
        r.forEach((n, s)=>{
            s.readTime.compareTo(t) > 0 && (t = s.readTime);
        }), e.ss.set(_, t);
    }
    var Eu = class {
        constructor(){
            this.activeTargetIds = HA();
        }
        As(_) {
            this.activeTargetIds = this.activeTargetIds.add(_);
        }
        Rs(_) {
            this.activeTargetIds = this.activeTargetIds.delete(_);
        }
        ds() {
            let _ = {
                activeTargetIds: this.activeTargetIds.toArray(),
                updateTimeMs: Date.now()
            };
            return JSON.stringify(_);
        }
    };
    var Gf = class {
        constructor(){
            this.no = new Eu, this.ro = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
        }
        addPendingMutation(_) {}
        updateMutationState(_, r, t) {}
        addLocalQueryTarget(_) {
            return this.no.As(_), this.ro[_] || "not-current";
        }
        updateQueryState(_, r, t) {
            this.ro[_] = r;
        }
        removeLocalQueryTarget(_) {
            this.no.Rs(_);
        }
        isLocalQueryTarget(_) {
            return this.no.activeTargetIds.has(_);
        }
        clearQueryState(_) {
            delete this.ro[_];
        }
        getAllActiveQueryTargets() {
            return this.no.activeTargetIds;
        }
        isActiveQueryTarget(_) {
            return this.no.activeTargetIds.has(_);
        }
        start() {
            return this.no = new Eu, Promise.resolve();
        }
        handleUserChange(_, r, t) {}
        setOnlineState(_) {}
        shutdown() {}
        writeSequenceNumber(_) {}
        notifyBundleLoaded(_) {}
    };
    var Cf = class {
        io(_) {}
        shutdown() {}
    };
    var Tu = class {
        constructor(){
            this.so = ()=>this.oo(), this._o = ()=>this.ao(), this.uo = [], this.co();
        }
        io(_) {
            this.uo.push(_);
        }
        shutdown() {
            window.removeEventListener("online", this.so), window.removeEventListener("offline", this._o);
        }
        co() {
            window.addEventListener("online", this.so), window.addEventListener("offline", this._o);
        }
        oo() {
            k_("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
            for (let _ of this.uo)_(0);
        }
        ao() {
            k_("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
            for (let _ of this.uo)_(1);
        }
        static D() {
            return typeof window < "u" && window.addEventListener !== void 0 && window.removeEventListener !== void 0;
        }
    };
    var uu = null;
    function R5() {
        return uu === null ? uu = function() {
            return 268435456 + Math.round(2147483648 * Math.random());
        }() : uu++, "0x" + uu.toString(16);
    }
    var IN = {
        BatchGetDocuments: "batchGet",
        Commit: "commit",
        RunQuery: "runQuery",
        RunAggregationQuery: "runAggregationQuery"
    };
    var Af = class {
        constructor(_){
            this.lo = _.lo, this.ho = _.ho;
        }
        Po(_) {
            this.Io = _;
        }
        To(_) {
            this.Eo = _;
        }
        Ao(_) {
            this.Ro = _;
        }
        onMessage(_) {
            this.Vo = _;
        }
        close() {
            this.ho();
        }
        send(_) {
            this.lo(_);
        }
        mo() {
            this.Io();
        }
        fo() {
            this.Eo();
        }
        po(_) {
            this.Ro(_);
        }
        yo(_) {
            this.Vo(_);
        }
    };
    var hr = "WebChannelConnection", Nf = class extends class {
        constructor(r){
            this.databaseInfo = r, this.databaseId = r.databaseId;
            let t = r.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), s = encodeURIComponent(this.databaseId.database);
            this.wo = t + "://" + r.host, this.So = `projects/${n}/databases/${s}`, this.bo = this.databaseId.database === "(default)" ? `project_id=${n}` : `project_id=${n}&database_id=${s}`;
        }
        get Do() {
            return !1;
        }
        Co(r, t, n, s, c) {
            let i = R5(), d = this.vo(r, t.toUriEncodedString());
            k_("RestConnection", `Sending RPC '${r}' ${i}:`, d, n);
            let v = {
                "google-cloud-resource-prefix": this.So,
                "x-goog-request-params": this.bo
            };
            return this.Fo(v, s, c), this.Mo(r, d, v, n).then((b)=>(k_("RestConnection", `Received RPC '${r}' ${i}: `, b), b), (b)=>{
                throw ya("RestConnection", `RPC '${r}' ${i} failed with error: `, b, "url: ", d, "request:", n), b;
            });
        }
        xo(r, t, n, s, c, i) {
            return this.Co(r, t, n, s, c);
        }
        Fo(r, t, n) {
            r["X-Goog-Api-Client"] = function() {
                return "gl-js/ fire/" + Na;
            }(), r["Content-Type"] = "text/plain", this.databaseInfo.appId && (r["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((s, c)=>r[c] = s), n && n.headers.forEach((s, c)=>r[c] = s);
        }
        vo(r, t) {
            let n = IN[r];
            return `${this.wo}/v1/${t}:${n}`;
        }
        terminate() {}
    } {
        constructor(_){
            super(_), this.forceLongPolling = _.forceLongPolling, this.autoDetectLongPolling = _.autoDetectLongPolling, this.useFetchStreams = _.useFetchStreams, this.longPollingOptions = _.longPollingOptions;
        }
        Mo(_, r, t, n) {
            let s = R5();
            return new Promise((c, i)=>{
                let d = new f5;
                d.setWithCredentials(!0), d.listenOnce($5.COMPLETE, ()=>{
                    try {
                        switch(d.getLastErrorCode()){
                            case $l.NO_ERROR:
                                let b = d.getResponseJson();
                                k_(hr, `XHR for RPC '${_}' ${s} received:`, JSON.stringify(b)), c(b);
                                break;
                            case $l.TIMEOUT:
                                k_(hr, `RPC '${_}' ${s} timed out`), i(new R_(o_.DEADLINE_EXCEEDED, "Request time out"));
                                break;
                            case $l.HTTP_ERROR:
                                let p = d.getStatus();
                                if (k_(hr, `RPC '${_}' ${s} failed with status:`, p, "response text:", d.getResponseText()), p > 0) {
                                    let u = d.getResponseJson();
                                    Array.isArray(u) && (u = u[0]);
                                    let m = u?.error;
                                    if (m && m.status && m.message) {
                                        let z = function(J) {
                                            let c_ = J.toLowerCase().replace(/_/g, "-");
                                            return Object.values(o_).indexOf(c_) >= 0 ? c_ : o_.UNKNOWN;
                                        }(m.status);
                                        i(new R_(z, m.message));
                                    } else i(new R_(o_.UNKNOWN, "Server responded with status " + d.getStatus()));
                                } else i(new R_(o_.UNAVAILABLE, "Connection failed."));
                                break;
                            default:
                                Z_();
                        }
                    } finally{
                        k_(hr, `RPC '${_}' ${s} completed.`);
                    }
                });
                let v = JSON.stringify(n);
                k_(hr, `RPC '${_}' ${s} sending request:`, n), d.send(r, "POST", v, t, 15);
            });
        }
        Oo(_, r, t) {
            let n = R5(), s = [
                this.wo,
                "/",
                "google.firestore.v1.Firestore",
                "/",
                _,
                "/channel"
            ], c = D5(), i = y5(), d = {
                httpSessionIdParam: "gsessionid",
                initMessageHeaders: {},
                messageUrlParams: {
                    database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
                },
                sendRawJson: !0,
                supportsCrossDomainXhr: !0,
                internalChannelParams: {
                    forwardChannelRequestTimeoutMs: 6e5
                },
                forceLongPolling: this.forceLongPolling,
                detectBufferingProxy: this.autoDetectLongPolling
            }, v = this.longPollingOptions.timeoutSeconds;
            v !== void 0 && (d.longPollingTimeout = Math.round(1e3 * v)), this.useFetchStreams && (d.xmlHttpFactory = new m5({})), this.Fo(d.initMessageHeaders, r, t), d.encodeInitMessageHeaders = !0;
            let b = s.join("");
            k_(hr, `Creating RPC '${_}' stream ${n}: ${b}`, d);
            let p = c.createWebChannel(b, d), u = !1, m = !1, z = new Af({
                lo: (J)=>{
                    m ? k_(hr, `Not sending because RPC '${_}' stream ${n} is closed:`, J) : (u || (k_(hr, `Opening RPC '${_}' stream ${n} transport.`), p.open(), u = !0), k_(hr, `RPC '${_}' stream ${n} sending:`, J), p.send(J));
                },
                ho: ()=>p.close()
            }), L = (J, c_, t_)=>{
                J.listen(c_, (W)=>{
                    try {
                        t_(W);
                    } catch (a_) {
                        setTimeout(()=>{
                            throw a_;
                        }, 0);
                    }
                });
            };
            return L(p, ga.EventType.OPEN, ()=>{
                m || (k_(hr, `RPC '${_}' stream ${n} transport opened.`), z.mo());
            }), L(p, ga.EventType.CLOSE, ()=>{
                m || (m = !0, k_(hr, `RPC '${_}' stream ${n} transport closed`), z.po());
            }), L(p, ga.EventType.ERROR, (J)=>{
                m || (m = !0, ya(hr, `RPC '${_}' stream ${n} transport errored:`, J), z.po(new R_(o_.UNAVAILABLE, "The operation could not be completed")));
            }), L(p, ga.EventType.MESSAGE, (J)=>{
                var c_;
                if (!m) {
                    let t_ = J.data[0];
                    Ve(!!t_);
                    let W = t_, a_ = W.error || ((c_ = W[0]) === null || c_ === void 0 ? void 0 : c_.error);
                    if (a_) {
                        k_(hr, `RPC '${_}' stream ${n} received error:`, a_);
                        let Q = a_.status, F = function(x) {
                            let T = Lo[x];
                            if (T !== void 0) return Q4(T);
                        }(Q), y = a_.message;
                        F === void 0 && (F = o_.INTERNAL, y = "Unknown error status: " + Q + " with message " + a_.message), m = !0, z.po(new R_(F, y)), p.close();
                    } else k_(hr, `RPC '${_}' stream ${n} received:`, t_), z.yo(t_);
                }
            }), L(i, h5.STAT_EVENT, (J)=>{
                J.stat === du.PROXY ? k_(hr, `RPC '${_}' stream ${n} detected buffering proxy`) : J.stat === du.NOPROXY && k_(hr, `RPC '${_}' stream ${n} detected no buffering proxy`);
            }), setTimeout(()=>{
                z.fo();
            }, 0), z;
        }
    };
    function k5() {
        return typeof document < "u" ? document : null;
    }
    function Yu(e) {
        return new nf(e, !0);
    }
    var Gu = class {
        constructor(_, r, t = 1e3, n = 1.5, s = 6e4){
            this.oi = _, this.timerId = r, this.No = t, this.Lo = n, this.Bo = s, this.ko = 0, this.qo = null, this.Qo = Date.now(), this.reset();
        }
        reset() {
            this.ko = 0;
        }
        Ko() {
            this.ko = this.Bo;
        }
        $o(_) {
            this.cancel();
            let r = Math.floor(this.ko + this.Uo()), t = Math.max(0, Date.now() - this.Qo), n = Math.max(0, r - t);
            n > 0 && k_("ExponentialBackoff", `Backing off for ${n} ms (base delay: ${this.ko} ms, delay with jitter: ${r} ms, last attempt: ${t} ms ago)`), this.qo = this.oi.enqueueAfterDelay(this.timerId, n, ()=>(this.Qo = Date.now(), _())), this.ko *= this.Lo, this.ko < this.No && (this.ko = this.No), this.ko > this.Bo && (this.ko = this.Bo);
        }
        Wo() {
            this.qo !== null && (this.qo.skipDelay(), this.qo = null);
        }
        cancel() {
            this.qo !== null && (this.qo.cancel(), this.qo = null);
        }
        Uo() {
            return (Math.random() - .5) * this.ko;
        }
    };
    var Cu = class {
        constructor(_, r, t, n, s, c, i, d){
            this.oi = _, this.Go = t, this.zo = n, this.connection = s, this.authCredentialsProvider = c, this.appCheckCredentialsProvider = i, this.listener = d, this.state = 0, this.jo = 0, this.Ho = null, this.Jo = null, this.stream = null, this.Yo = new Gu(_, r);
        }
        Zo() {
            return this.state === 1 || this.state === 5 || this.Xo();
        }
        Xo() {
            return this.state === 2 || this.state === 3;
        }
        start() {
            this.state !== 4 ? this.auth() : this.e_();
        }
        async stop() {
            this.Zo() && await this.close(0);
        }
        t_() {
            this.state = 0, this.Yo.reset();
        }
        n_() {
            this.Xo() && this.Ho === null && (this.Ho = this.oi.enqueueAfterDelay(this.Go, 6e4, ()=>this.r_()));
        }
        i_(_) {
            this.s_(), this.stream.send(_);
        }
        async r_() {
            if (this.Xo()) return this.close(0);
        }
        s_() {
            this.Ho && (this.Ho.cancel(), this.Ho = null);
        }
        o_() {
            this.Jo && (this.Jo.cancel(), this.Jo = null);
        }
        async close(_, r) {
            this.s_(), this.o_(), this.Yo.cancel(), this.jo++, _ !== 4 ? this.Yo.reset() : r && r.code === o_.RESOURCE_EXHAUSTED ? (_0(r.toString()), _0("Using maximum backoff delay to prevent overloading the backend."), this.Yo.Ko()) : r && r.code === o_.UNAUTHENTICATED && this.state !== 3 && (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), this.stream !== null && (this.__(), this.stream.close(), this.stream = null), this.state = _, await this.listener.Ao(r);
        }
        __() {}
        auth() {
            this.state = 1;
            let _ = this.a_(this.jo), r = this.jo;
            Promise.all([
                this.authCredentialsProvider.getToken(),
                this.appCheckCredentialsProvider.getToken()
            ]).then(([t, n])=>{
                this.jo === r && this.u_(t, n);
            }, (t)=>{
                _(()=>{
                    let n = new R_(o_.UNKNOWN, "Fetching auth token failed: " + t.message);
                    return this.c_(n);
                });
            });
        }
        u_(_, r) {
            let t = this.a_(this.jo);
            this.stream = this.l_(_, r), this.stream.Po(()=>{
                t(()=>this.listener.Po());
            }), this.stream.To(()=>{
                t(()=>(this.state = 2, this.Jo = this.oi.enqueueAfterDelay(this.zo, 1e4, ()=>(this.Xo() && (this.state = 3), Promise.resolve())), this.listener.To()));
            }), this.stream.Ao((n)=>{
                t(()=>this.c_(n));
            }), this.stream.onMessage((n)=>{
                t(()=>this.onMessage(n));
            });
        }
        e_() {
            this.state = 5, this.Yo.$o(async ()=>{
                this.state = 0, this.start();
            });
        }
        c_(_) {
            return k_("PersistentStream", `close with error: ${_}`), this.stream = null, this.close(4, _);
        }
        a_(_) {
            return (r)=>{
                this.oi.enqueueAndForget(()=>this.jo === _ ? r() : (k_("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
            };
        }
    }, Ff = class extends Cu {
        constructor(_, r, t, n, s, c){
            super(_, "listen_stream_connection_backoff", "listen_stream_idle", "health_check_timeout", r, t, n, c), this.serializer = s;
        }
        l_(_, r) {
            return this.connection.Oo("Listen", _, r);
        }
        onMessage(_) {
            this.Yo.reset();
            let r = aN(this.serializer, _), t = function(s) {
                if (!("targetChange" in s)) return le.min();
                let c = s.targetChange;
                return c.targetIds && c.targetIds.length ? le.min() : c.readTime ? pn(c.readTime) : le.min();
            }(_);
            return this.listener.h_(r, t);
        }
        P_(_) {
            let r = {};
            r.database = lf(this.serializer), r.addTarget = function(s, c) {
                let i, d = c.target;
                if (i = j5(d) ? {
                    documents: dN(s, d)
                } : {
                    query: vN(s, d)._t
                }, i.targetId = c.targetId, c.resumeToken.approximateByteSize() > 0) {
                    i.resumeToken = Y4(s, c.resumeToken);
                    let v = sf(s, c.expectedCount);
                    v !== null && (i.expectedCount = v);
                } else if (c.snapshotVersion.compareTo(le.min()) > 0) {
                    i.readTime = Iu(s, c.snapshotVersion.toTimestamp());
                    let v = sf(s, c.expectedCount);
                    v !== null && (i.expectedCount = v);
                }
                return i;
            }(this.serializer, _);
            let t = gN(this.serializer, _);
            t && (r.labels = t), this.i_(r);
        }
        I_(_) {
            let r = {};
            r.database = lf(this.serializer), r.removeTarget = _, this.i_(r);
        }
    }, Mf = class extends Cu {
        constructor(_, r, t, n, s, c){
            super(_, "write_stream_connection_backoff", "write_stream_idle", "health_check_timeout", r, t, n, c), this.serializer = s, this.T_ = !1;
        }
        get E_() {
            return this.T_;
        }
        start() {
            this.T_ = !1, this.lastStreamToken = void 0, super.start();
        }
        __() {
            this.T_ && this.d_([]);
        }
        l_(_, r) {
            return this.connection.Oo("Write", _, r);
        }
        onMessage(_) {
            if (Ve(!!_.streamToken), this.lastStreamToken = _.streamToken, this.T_) {
                this.Yo.reset();
                let r = lN(_.writeResults, _.commitTime), t = pn(_.commitTime);
                return this.listener.A_(t, r);
            }
            return Ve(!_.writeResults || _.writeResults.length === 0), this.T_ = !0, this.listener.R_();
        }
        V_() {
            let _ = {};
            _.database = lf(this.serializer), this.i_(_);
        }
        d_(_) {
            let r = {
                streamToken: this.lastStreamToken,
                writes: _.map((t)=>iN(this.serializer, t))
            };
            this.i_(r);
        }
    };
    var Pf = class extends class {
    } {
        constructor(_, r, t, n){
            super(), this.authCredentials = _, this.appCheckCredentials = r, this.connection = t, this.serializer = n, this.m_ = !1;
        }
        f_() {
            if (this.m_) throw new R_(o_.FAILED_PRECONDITION, "The client has already been terminated.");
        }
        Co(_, r, t, n) {
            return this.f_(), Promise.all([
                this.authCredentials.getToken(),
                this.appCheckCredentials.getToken()
            ]).then(([s, c])=>this.connection.Co(_, cf(r, t), n, s, c)).catch((s)=>{
                throw s.name === "FirebaseError" ? (s.code === o_.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), s) : new R_(o_.UNKNOWN, s.toString());
            });
        }
        xo(_, r, t, n, s) {
            return this.f_(), Promise.all([
                this.authCredentials.getToken(),
                this.appCheckCredentials.getToken()
            ]).then(([c, i])=>this.connection.xo(_, cf(r, t), n, c, i, s)).catch((c)=>{
                throw c.name === "FirebaseError" ? (c.code === o_.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), c) : new R_(o_.UNKNOWN, c.toString());
            });
        }
        terminate() {
            this.m_ = !0, this.connection.terminate();
        }
    }, Lf = class {
        constructor(_, r){
            this.asyncQueue = _, this.onlineStateHandler = r, this.state = "Unknown", this.g_ = 0, this.p_ = null, this.y_ = !0;
        }
        w_() {
            this.g_ === 0 && (this.S_("Unknown"), this.p_ = this.asyncQueue.enqueueAfterDelay("online_state_timeout", 1e4, ()=>(this.p_ = null, this.b_("Backend didn't respond within 10 seconds."), this.S_("Offline"), Promise.resolve())));
        }
        D_(_) {
            this.state === "Online" ? this.S_("Unknown") : (this.g_++, this.g_ >= 1 && (this.C_(), this.b_(`Connection failed 1 times. Most recent error: ${_.toString()}`), this.S_("Offline")));
        }
        set(_) {
            this.C_(), this.g_ = 0, _ === "Online" && (this.y_ = !1), this.S_(_);
        }
        S_(_) {
            _ !== this.state && (this.state = _, this.onlineStateHandler(_));
        }
        b_(_) {
            let r = `Could not reach Cloud Firestore backend. ${_}
This typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
            this.y_ ? (_0(r), this.y_ = !1) : k_("OnlineStateTracker", r);
        }
        C_() {
            this.p_ !== null && (this.p_.cancel(), this.p_ = null);
        }
    };
    var zf = class {
        constructor(_, r, t, n, s){
            this.localStore = _, this.datastore = r, this.asyncQueue = t, this.remoteSyncer = {}, this.v_ = [], this.F_ = new Map, this.M_ = new Set, this.x_ = [], this.O_ = s, this.O_.io((c)=>{
                t.enqueueAndForget(async ()=>{
                    ac(this) && (k_("RemoteStore", "Restarting streams for network reachability change."), await async function(d) {
                        let v = ce(d);
                        v.M_.add(4), await Ul(v), v.N_.set("Unknown"), v.M_.delete(4), await Xu(v);
                    }(this));
                });
            }), this.N_ = new Lf(t, n);
        }
    };
    async function Xu(e) {
        if (ac(e)) for (let _ of e.x_)await _(!0);
    }
    async function Ul(e) {
        for (let _ of e.x_)await _(!1);
    }
    function sD(e, _) {
        let r = ce(e);
        r.F_.has(_.targetId) || (r.F_.set(_.targetId, _), mm(r) ? fm(r) : Ma(r).Xo() && pm(r, _));
    }
    function bm(e, _) {
        let r = ce(e), t = Ma(r);
        r.F_.delete(_), t.Xo() && cD(r, _), r.F_.size === 0 && (t.Xo() ? t.n_() : ac(r) && r.N_.set("Unknown"));
    }
    function pm(e, _) {
        if (e.L_.xe(_.targetId), _.resumeToken.approximateByteSize() > 0 || _.snapshotVersion.compareTo(le.min()) > 0) {
            let r = e.remoteSyncer.getRemoteKeysForTarget(_.targetId).size;
            _ = _.withExpectedCount(r);
        }
        Ma(e).P_(_);
    }
    function cD(e, _) {
        e.L_.xe(_), Ma(e).I_(_);
    }
    function fm(e) {
        e.L_ = new tf({
            getRemoteKeysForTarget: (_)=>e.remoteSyncer.getRemoteKeysForTarget(_),
            ot: (_)=>e.F_.get(_) || null,
            tt: ()=>e.datastore.serializer.databaseId
        }), Ma(e).start(), e.N_.w_();
    }
    function mm(e) {
        return ac(e) && !Ma(e).Zo() && e.F_.size > 0;
    }
    function ac(e) {
        return ce(e).M_.size === 0;
    }
    function aD(e) {
        e.L_ = void 0;
    }
    async function xN(e) {
        e.N_.set("Online");
    }
    async function EN(e) {
        e.F_.forEach((_, r)=>{
            pm(e, _);
        });
    }
    async function TN(e, _) {
        aD(e), mm(e) ? (e.N_.D_(_), fm(e)) : e.N_.set("Unknown");
    }
    async function GN(e, _, r) {
        if (e.N_.set("Online"), _ instanceof ku && _.state === 2 && _.cause) try {
            await async function(n, s) {
                let c = s.cause;
                for (let i of s.targetIds)n.F_.has(i) && (await n.remoteSyncer.rejectListen(i, c), n.F_.delete(i), n.L_.removeTarget(i));
            }(e, _);
        } catch (t) {
            k_("RemoteStore", "Failed to remove targets %s: %s ", _.targetIds.join(","), t), await Au(e, t);
        }
        else if (_ instanceof $a ? e.L_.Ke(_) : _ instanceof Ru ? e.L_.He(_) : e.L_.We(_), !r.isEqual(le.min())) try {
            let t = await nD(e.localStore);
            r.compareTo(t) >= 0 && await function(s, c) {
                let i = s.L_.rt(c);
                return i.targetChanges.forEach((d, v)=>{
                    if (d.resumeToken.approximateByteSize() > 0) {
                        let b = s.F_.get(v);
                        b && s.F_.set(v, b.withResumeToken(d.resumeToken, c));
                    }
                }), i.targetMismatches.forEach((d, v)=>{
                    let b = s.F_.get(d);
                    if (!b) return;
                    s.F_.set(d, b.withResumeToken(Mr.EMPTY_BYTE_STRING, b.snapshotVersion)), cD(s, d);
                    let p = new Cl(b.target, d, v, b.sequenceNumber);
                    pm(s, p);
                }), s.remoteSyncer.applyRemoteEvent(i);
            }(e, r);
        } catch (t) {
            k_("RemoteStore", "Failed to raise snapshot:", t), await Au(e, t);
        }
    }
    async function Au(e, _, r) {
        if (!Ol(_)) throw _;
        e.M_.add(1), await Ul(e), e.N_.set("Offline"), r || (r = ()=>nD(e.localStore)), e.asyncQueue.enqueueRetryable(async ()=>{
            k_("RemoteStore", "Retrying IndexedDB access"), await r(), e.M_.delete(1), await Xu(e);
        });
    }
    function iD(e, _) {
        return _().catch((r)=>Au(e, r, _));
    }
    async function Zu(e) {
        let _ = ce(e), r = X0(_), t = _.v_.length > 0 ? _.v_[_.v_.length - 1].batchId : -1;
        for(; CN(_);)try {
            let n = await RN(_.localStore, t);
            if (n === null) {
                _.v_.length === 0 && r.n_();
                break;
            }
            t = n.batchId, AN(_, n);
        } catch (n) {
            await Au(_, n);
        }
        lD(_) && dD(_);
    }
    function CN(e) {
        return ac(e) && e.v_.length < 10;
    }
    function AN(e, _) {
        e.v_.push(_);
        let r = X0(e);
        r.Xo() && r.E_ && r.d_(_.mutations);
    }
    function lD(e) {
        return ac(e) && !X0(e).Zo() && e.v_.length > 0;
    }
    function dD(e) {
        X0(e).start();
    }
    async function NN(e) {
        X0(e).V_();
    }
    async function FN(e) {
        let _ = X0(e);
        for (let r of e.v_)_.d_(r.mutations);
    }
    async function MN(e, _, r) {
        let t = e.v_.shift(), n = _f.from(t, _, r);
        await iD(e, ()=>e.remoteSyncer.applySuccessfulWrite(n)), await Zu(e);
    }
    async function PN(e, _) {
        _ && X0(e).E_ && await async function(t, n) {
            if (function(c) {
                return _N(c) && c !== o_.ABORTED;
            }(n.code)) {
                let s = t.v_.shift();
                X0(t).t_(), await iD(t, ()=>t.remoteSyncer.rejectFailedWrite(s.batchId, n)), await Zu(t);
            }
        }(e, _), lD(e) && dD(e);
    }
    async function f4(e, _) {
        let r = ce(e);
        r.asyncQueue.verifyOperationInProgress(), k_("RemoteStore", "RemoteStore received new credentials");
        let t = ac(r);
        r.M_.add(3), await Ul(r), t && r.N_.set("Unknown"), await r.remoteSyncer.handleCredentialChange(_), r.M_.delete(3), await Xu(r);
    }
    async function LN(e, _) {
        let r = ce(e);
        _ ? (r.M_.delete(2), await Xu(r)) : _ || (r.M_.add(2), await Ul(r), r.N_.set("Unknown"));
    }
    function Ma(e) {
        return e.B_ || (e.B_ = function(r, t, n) {
            let s = ce(r);
            return s.f_(), new Ff(t, s.connection, s.authCredentials, s.appCheckCredentials, s.serializer, n);
        }(e.datastore, e.asyncQueue, {
            Po: xN.bind(null, e),
            To: EN.bind(null, e),
            Ao: TN.bind(null, e),
            h_: GN.bind(null, e)
        }), e.x_.push(async (_)=>{
            _ ? (e.B_.t_(), mm(e) ? fm(e) : e.N_.set("Unknown")) : (await e.B_.stop(), aD(e));
        })), e.B_;
    }
    function X0(e) {
        return e.k_ || (e.k_ = function(r, t, n) {
            let s = ce(r);
            return s.f_(), new Mf(t, s.connection, s.authCredentials, s.appCheckCredentials, s.serializer, n);
        }(e.datastore, e.asyncQueue, {
            Po: ()=>Promise.resolve(),
            To: NN.bind(null, e),
            Ao: PN.bind(null, e),
            R_: FN.bind(null, e),
            A_: MN.bind(null, e)
        }), e.x_.push(async (_)=>{
            _ ? (e.k_.t_(), await Zu(e)) : (await e.k_.stop(), e.v_.length > 0 && (k_("RemoteStore", `Stopping write stream with ${e.v_.length} pending writes`), e.v_ = []));
        })), e.k_;
    }
    var Of = class e {
        constructor(_, r, t, n, s){
            this.asyncQueue = _, this.timerId = r, this.targetTimeMs = t, this.op = n, this.removalCallback = s, this.deferred = new un, this.then = this.deferred.promise.then.bind(this.deferred.promise), this.deferred.promise.catch((c)=>{});
        }
        get promise() {
            return this.deferred.promise;
        }
        static createAndSchedule(_, r, t, n, s) {
            let c = Date.now() + t, i = new e(_, r, c, n, s);
            return i.start(t), i;
        }
        start(_) {
            this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), _);
        }
        skipDelay() {
            return this.handleDelayElapsed();
        }
        cancel(_) {
            this.timerHandle !== null && (this.clearTimeout(), this.deferred.reject(new R_(o_.CANCELLED, "Operation cancelled" + (_ ? ": " + _ : ""))));
        }
        handleDelayElapsed() {
            this.asyncQueue.enqueueAndForget(()=>this.timerHandle !== null ? (this.clearTimeout(), this.op().then((_)=>this.deferred.resolve(_))) : Promise.resolve());
        }
        clearTimeout() {
            this.timerHandle !== null && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
        }
    };
    function $m(e, _) {
        if (_0("AsyncQueue", `${_}: ${e}`), Ol(e)) return new R_(o_.UNAVAILABLE, `${_}: ${e}`);
        throw e;
    }
    var Nu = class e {
        constructor(_){
            this.comparator = _ ? (r, t)=>_(r, t) || V_.comparator(r.key, t.key) : (r, t)=>V_.comparator(r.key, t.key), this.keyedMap = yl(), this.sortedSet = new ho(this.comparator);
        }
        static emptySet(_) {
            return new e(_.comparator);
        }
        has(_) {
            return this.keyedMap.get(_) != null;
        }
        get(_) {
            return this.keyedMap.get(_);
        }
        first() {
            return this.sortedSet.minKey();
        }
        last() {
            return this.sortedSet.maxKey();
        }
        isEmpty() {
            return this.sortedSet.isEmpty();
        }
        indexOf(_) {
            let r = this.keyedMap.get(_);
            return r ? this.sortedSet.indexOf(r) : -1;
        }
        get size() {
            return this.sortedSet.size;
        }
        forEach(_) {
            this.sortedSet.inorderTraversal((r, t)=>(_(r), !1));
        }
        add(_) {
            let r = this.delete(_.key);
            return r.copy(r.keyedMap.insert(_.key, _), r.sortedSet.insert(_, null));
        }
        delete(_) {
            let r = this.get(_);
            return r ? this.copy(this.keyedMap.remove(_), this.sortedSet.remove(r)) : this;
        }
        isEqual(_) {
            if (!(_ instanceof e) || this.size !== _.size) return !1;
            let r = this.sortedSet.getIterator(), t = _.sortedSet.getIterator();
            for(; r.hasNext();){
                let n = r.getNext().key, s = t.getNext().key;
                if (!n.isEqual(s)) return !1;
            }
            return !0;
        }
        toString() {
            let _ = [];
            return this.forEach((r)=>{
                _.push(r.toString());
            }), _.length === 0 ? "DocumentSet ()" : `DocumentSet (
  ` + _.join(`  
`) + `
)`;
        }
        copy(_, r) {
            let t = new e;
            return t.comparator = this.comparator, t.keyedMap = _, t.sortedSet = r, t;
        }
    };
    var Fu = class {
        constructor(){
            this.q_ = new ho(V_.comparator);
        }
        track(_) {
            let r = _.doc.key, t = this.q_.get(r);
            t ? _.type !== 0 && t.type === 3 ? this.q_ = this.q_.insert(r, _) : _.type === 3 && t.type !== 1 ? this.q_ = this.q_.insert(r, {
                type: t.type,
                doc: _.doc
            }) : _.type === 2 && t.type === 2 ? this.q_ = this.q_.insert(r, {
                type: 2,
                doc: _.doc
            }) : _.type === 2 && t.type === 0 ? this.q_ = this.q_.insert(r, {
                type: 0,
                doc: _.doc
            }) : _.type === 1 && t.type === 0 ? this.q_ = this.q_.remove(r) : _.type === 1 && t.type === 2 ? this.q_ = this.q_.insert(r, {
                type: 1,
                doc: t.doc
            }) : _.type === 0 && t.type === 1 ? this.q_ = this.q_.insert(r, {
                type: 2,
                doc: _.doc
            }) : Z_() : this.q_ = this.q_.insert(r, _);
        }
        Q_() {
            let _ = [];
            return this.q_.inorderTraversal((r, t)=>{
                _.push(t);
            }), _;
        }
    }, Ga = class e {
        constructor(_, r, t, n, s, c, i, d, v){
            this.query = _, this.docs = r, this.oldDocs = t, this.docChanges = n, this.mutatedKeys = s, this.fromCache = c, this.syncStateChanged = i, this.excludesMetadataChanges = d, this.hasCachedResults = v;
        }
        static fromInitialDocuments(_, r, t, n, s) {
            let c = [];
            return r.forEach((i)=>{
                c.push({
                    type: 0,
                    doc: i
                });
            }), new e(_, r, Nu.emptySet(r), c, t, n, !0, !1, s);
        }
        get hasPendingWrites() {
            return !this.mutatedKeys.isEmpty();
        }
        isEqual(_) {
            if (!(this.fromCache === _.fromCache && this.hasCachedResults === _.hasCachedResults && this.syncStateChanged === _.syncStateChanged && this.mutatedKeys.isEqual(_.mutatedKeys) && Ku(this.query, _.query) && this.docs.isEqual(_.docs) && this.oldDocs.isEqual(_.oldDocs))) return !1;
            let r = this.docChanges, t = _.docChanges;
            if (r.length !== t.length) return !1;
            for(let n = 0; n < r.length; n++)if (r[n].type !== t[n].type || !r[n].doc.isEqual(t[n].doc)) return !1;
            return !0;
        }
    };
    var Uf = class {
        constructor(){
            this.K_ = void 0, this.U_ = [];
        }
        W_() {
            return this.U_.some((_)=>_.G_());
        }
    }, Bf = class {
        constructor(){
            this.queries = new Y0((_)=>P4(_), Ku), this.onlineState = "Unknown", this.z_ = new Set;
        }
    };
    async function vD(e, _) {
        let r = ce(e), t = 3, n = _.query, s = r.queries.get(n);
        s ? !s.W_() && _.G_() && (t = 2) : (s = new Uf, t = _.G_() ? 0 : 1);
        try {
            switch(t){
                case 0:
                    s.K_ = await r.onListen(n, !0);
                    break;
                case 1:
                    s.K_ = await r.onListen(n, !1);
                    break;
                case 2:
                    await r.onFirstRemoteStoreListen(n);
            }
        } catch (c) {
            let i = $m(c, `Initialization of query '${ba(_.query)}' failed`);
            return void _.onError(i);
        }
        r.queries.set(n, s), s.U_.push(_), _.j_(r.onlineState), s.K_ && _.H_(s.K_) && hm(r);
    }
    async function uD(e, _) {
        let r = ce(e), t = _.query, n = 3, s = r.queries.get(t);
        if (s) {
            let c = s.U_.indexOf(_);
            c >= 0 && (s.U_.splice(c, 1), s.U_.length === 0 ? n = _.G_() ? 0 : 1 : !s.W_() && _.G_() && (n = 2));
        }
        switch(n){
            case 0:
                return r.queries.delete(t), r.onUnlisten(t, !0);
            case 1:
                return r.queries.delete(t), r.onUnlisten(t, !1);
            case 2:
                return r.onLastRemoteStoreUnlisten(t);
            default:
                return;
        }
    }
    function zN(e, _) {
        let r = ce(e), t = !1;
        for (let n of _){
            let s = n.query, c = r.queries.get(s);
            if (c) {
                for (let i of c.U_)i.H_(n) && (t = !0);
                c.K_ = n;
            }
        }
        t && hm(r);
    }
    function ON(e, _, r) {
        let t = ce(e), n = t.queries.get(_);
        if (n) for (let s of n.U_)s.onError(r);
        t.queries.delete(_);
    }
    function hm(e) {
        e.z_.forEach((_)=>{
            _.next();
        });
    }
    var Jf, m4;
    (m4 = Jf || (Jf = {})).J_ = "default", m4.Cache = "cache";
    var Mu = class {
        constructor(_, r, t){
            this.query = _, this.Y_ = r, this.Z_ = !1, this.X_ = null, this.onlineState = "Unknown", this.options = t || {};
        }
        H_(_) {
            if (!this.options.includeMetadataChanges) {
                let t = [];
                for (let n of _.docChanges)n.type !== 3 && t.push(n);
                _ = new Ga(_.query, _.docs, _.oldDocs, t, _.mutatedKeys, _.fromCache, _.syncStateChanged, !0, _.hasCachedResults);
            }
            let r = !1;
            return this.Z_ ? this.ea(_) && (this.Y_.next(_), r = !0) : this.ta(_, this.onlineState) && (this.na(_), r = !0), this.X_ = _, r;
        }
        onError(_) {
            this.Y_.error(_);
        }
        j_(_) {
            this.onlineState = _;
            let r = !1;
            return this.X_ && !this.Z_ && this.ta(this.X_, _) && (this.na(this.X_), r = !0), r;
        }
        ta(_, r) {
            if (!_.fromCache || !this.G_()) return !0;
            let t = r !== "Offline";
            return (!this.options.ra || !t) && (!_.docs.isEmpty() || _.hasCachedResults || r === "Offline");
        }
        ea(_) {
            if (_.docChanges.length > 0) return !0;
            let r = this.X_ && this.X_.hasPendingWrites !== _.hasPendingWrites;
            return !(!_.syncStateChanged && !r) && this.options.includeMetadataChanges === !0;
        }
        na(_) {
            _ = Ga.fromInitialDocuments(_.query, _.docs, _.mutatedKeys, _.fromCache, _.hasCachedResults), this.Z_ = !0, this.Y_.next(_);
        }
        G_() {
            return this.options.source !== Jf.Cache;
        }
    };
    var Pu = class {
        constructor(_){
            this.key = _;
        }
    }, Lu = class {
        constructor(_){
            this.key = _;
        }
    }, Vf = class {
        constructor(_, r){
            this.query = _, this.la = r, this.ha = null, this.hasCachedResults = !1, this.current = !1, this.Pa = ke(), this.mutatedKeys = ke(), this.Ia = L4(_), this.Ta = new Nu(this.Ia);
        }
        get Ea() {
            return this.la;
        }
        da(_, r) {
            let t = r ? r.Aa : new Fu, n = r ? r.Ta : this.Ta, s = r ? r.mutatedKeys : this.mutatedKeys, c = n, i = !1, d = this.query.limitType === "F" && n.size === this.query.limit ? n.last() : null, v = this.query.limitType === "L" && n.size === this.query.limit ? n.first() : null;
            if (_.inorderTraversal((b, p)=>{
                let u = n.get(b), m = Qu(this.query, p) ? p : null, z = !!u && this.mutatedKeys.has(u.key), L = !!m && (m.hasLocalMutations || this.mutatedKeys.has(m.key) && m.hasCommittedMutations), J = !1;
                u && m ? u.data.isEqual(m.data) ? z !== L && (t.track({
                    type: 3,
                    doc: m
                }), J = !0) : this.Ra(u, m) || (t.track({
                    type: 2,
                    doc: m
                }), J = !0, (d && this.Ia(m, d) > 0 || v && this.Ia(m, v) < 0) && (i = !0)) : !u && m ? (t.track({
                    type: 0,
                    doc: m
                }), J = !0) : u && !m && (t.track({
                    type: 1,
                    doc: u
                }), J = !0, (d || v) && (i = !0)), J && (m ? (c = c.add(m), s = L ? s.add(b) : s.delete(b)) : (c = c.delete(b), s = s.delete(b)));
            }), this.query.limit !== null) for(; c.size > this.query.limit;){
                let b = this.query.limitType === "F" ? c.last() : c.first();
                c = c.delete(b.key), s = s.delete(b.key), t.track({
                    type: 1,
                    doc: b
                });
            }
            return {
                Ta: c,
                Aa: t,
                Xi: i,
                mutatedKeys: s
            };
        }
        Ra(_, r) {
            return _.hasLocalMutations && r.hasCommittedMutations && !r.hasLocalMutations;
        }
        applyChanges(_, r, t, n) {
            let s = this.Ta;
            this.Ta = _.Ta, this.mutatedKeys = _.mutatedKeys;
            let c = _.Aa.Q_();
            c.sort((b, p)=>(function(m, z) {
                    let L = (J)=>{
                        switch(J){
                            case 0:
                                return 1;
                            case 2:
                            case 3:
                                return 2;
                            case 1:
                                return 0;
                            default:
                                return Z_();
                        }
                    };
                    return L(m) - L(z);
                })(b.type, p.type) || this.Ia(b.doc, p.doc)), this.Va(t), n = n != null && n;
            let i = r && !n ? this.ma() : [], d = this.Pa.size === 0 && this.current && !n ? 1 : 0, v = d !== this.ha;
            return this.ha = d, c.length !== 0 || v ? {
                snapshot: new Ga(this.query, _.Ta, s, c, _.mutatedKeys, d === 0, v, !1, !!t && t.resumeToken.approximateByteSize() > 0),
                fa: i
            } : {
                fa: i
            };
        }
        j_(_) {
            return this.current && _ === "Offline" ? (this.current = !1, this.applyChanges({
                Ta: this.Ta,
                Aa: new Fu,
                mutatedKeys: this.mutatedKeys,
                Xi: !1
            }, !1)) : {
                fa: []
            };
        }
        ga(_) {
            return !this.la.has(_) && !!this.Ta.has(_) && !this.Ta.get(_).hasLocalMutations;
        }
        Va(_) {
            _ && (_.addedDocuments.forEach((r)=>this.la = this.la.add(r)), _.modifiedDocuments.forEach((r)=>{}), _.removedDocuments.forEach((r)=>this.la = this.la.delete(r)), this.current = _.current);
        }
        ma() {
            if (!this.current) return [];
            let _ = this.Pa;
            this.Pa = ke(), this.Ta.forEach((t)=>{
                this.ga(t.key) && (this.Pa = this.Pa.add(t.key));
            });
            let r = [];
            return _.forEach((t)=>{
                this.Pa.has(t) || r.push(new Lu(t));
            }), this.Pa.forEach((t)=>{
                _.has(t) || r.push(new Pu(t));
            }), r;
        }
        pa(_) {
            this.la = _.hs, this.Pa = ke();
            let r = this.da(_.documents);
            return this.applyChanges(r, !0);
        }
        ya() {
            return Ga.fromInitialDocuments(this.query, this.Ta, this.mutatedKeys, this.ha === 0, this.hasCachedResults);
        }
    }, qf = class {
        constructor(_, r, t){
            this.query = _, this.targetId = r, this.view = t;
        }
    }, Wf = class {
        constructor(_){
            this.key = _, this.wa = !1;
        }
    }, Hf = class {
        constructor(_, r, t, n, s, c){
            this.localStore = _, this.remoteStore = r, this.eventManager = t, this.sharedClientState = n, this.currentUser = s, this.maxConcurrentLimboResolutions = c, this.Sa = {}, this.ba = new Y0((i)=>P4(i), Ku), this.Da = new Map, this.Ca = new Set, this.va = new ho(V_.comparator), this.Fa = new Map, this.Ma = new Nl, this.xa = {}, this.Oa = new Map, this.Na = Al.Ln(), this.onlineState = "Unknown", this.La = void 0;
        }
        get isPrimaryClient() {
            return this.La === !0;
        }
    };
    async function UN(e, _, r = !0) {
        let t = $D(e), n, s = t.ba.get(_);
        return s ? (t.sharedClientState.addLocalQueryTarget(s.targetId), n = s.view.ya()) : n = await gD(t, _, r, !0), n;
    }
    async function BN(e, _) {
        let r = $D(e);
        await gD(r, _, !0, !1);
    }
    async function gD(e, _, r, t) {
        let n = await kN(e.localStore, bn(_)), s = n.targetId, c = r ? e.sharedClientState.addLocalQueryTarget(s) : "not-current", i;
        return t && (i = await JN(e, _, s, c === "current", n.resumeToken)), e.isPrimaryClient && r && sD(e.remoteStore, n), i;
    }
    async function JN(e, _, r, t, n) {
        e.Ba = (p, u, m)=>(async function(L, J, c_, t_) {
                let W = J.view.da(c_);
                W.Xi && (W = await p4(L.localStore, J.query, !1).then(({ documents: y  })=>J.view.da(y, W)));
                let a_ = t_ && t_.targetChanges.get(J.targetId), Q = t_ && t_.targetMismatches.get(J.targetId) != null, F = J.view.applyChanges(W, L.isPrimaryClient, a_, Q);
                return h4(L, J.targetId, F.fa), F.snapshot;
            })(e, p, u, m);
        let s = await p4(e.localStore, _, !0), c = new Vf(_, s.hs), i = c.da(s.documents), d = Gl.createSynthesizedTargetChangeForCurrentChange(r, t && e.onlineState !== "Offline", n), v = c.applyChanges(i, e.isPrimaryClient, d);
        h4(e, r, v.fa);
        let b = new qf(_, r, c);
        return e.ba.set(_, b), e.Da.has(r) ? e.Da.get(r).push(_) : e.Da.set(r, [
            _
        ]), v.snapshot;
    }
    async function VN(e, _, r) {
        let t = ce(e), n = t.ba.get(_), s = t.Da.get(n.targetId);
        if (s.length > 1) return t.Da.set(n.targetId, s.filter((c)=>!Ku(c, _))), void t.ba.delete(_);
        t.isPrimaryClient ? (t.sharedClientState.removeLocalQueryTarget(n.targetId), t.sharedClientState.isActiveQueryTarget(n.targetId) || await Tf(t.localStore, n.targetId, !1).then(()=>{
            t.sharedClientState.clearQueryState(n.targetId), r && bm(t.remoteStore, n.targetId), jf(t, n.targetId);
        }).catch(zl)) : (jf(t, n.targetId), await Tf(t.localStore, n.targetId, !0));
    }
    async function qN(e, _) {
        let r = ce(e), t = r.ba.get(_), n = r.Da.get(t.targetId);
        r.isPrimaryClient && n.length === 1 && (r.sharedClientState.removeLocalQueryTarget(t.targetId), bm(r.remoteStore, t.targetId));
    }
    async function WN(e, _, r) {
        let t = ZN(e);
        try {
            let n = await function(c, i) {
                let d = ce(c), v = sr.now(), b = i.reduce((m, z)=>m.add(z.key), ke()), p, u;
                return d.persistence.runTransaction("Locally write mutations", "readwrite", (m)=>{
                    let z = o0(), L = ke();
                    return d.os.getEntries(m, b).next((J)=>{
                        z = J, z.forEach((c_, t_)=>{
                            t_.isValidDocument() || (L = L.add(c_));
                        });
                    }).next(()=>d.localDocuments.getOverlayedDocuments(m, z)).next((J)=>{
                        p = J;
                        let c_ = [];
                        for (let t_ of i){
                            let W = ZA(t_, p.get(t_.key).overlayedDocument);
                            W != null && c_.push(new r0(t_.key, W, T4(W.value.mapValue), j0.exists(!0)));
                        }
                        return d.mutationQueue.addMutationBatch(m, v, c_, i);
                    }).next((J)=>{
                        u = J;
                        let c_ = J.applyToLocalDocumentSet(p, L);
                        return d.documentOverlayCache.saveOverlays(m, J.batchId, c_);
                    });
                }).then(()=>({
                        batchId: u.batchId,
                        changes: O4(p)
                    }));
            }(t.localStore, _);
            t.sharedClientState.addPendingMutation(n.batchId), function(c, i, d) {
                let v = c.xa[c.currentUser.toKey()];
                v || (v = new ho(Ae)), v = v.insert(i, d), c.xa[c.currentUser.toKey()] = v;
            }(t, n.batchId, r), await Bl(t, n.changes), await Zu(t.remoteStore);
        } catch (n) {
            let s = $m(n, "Failed to persist write");
            r.reject(s);
        }
    }
    async function bD(e, _) {
        let r = ce(e);
        try {
            let t = await DN(r.localStore, _);
            _.targetChanges.forEach((n, s)=>{
                let c = r.Fa.get(s);
                c && (Ve(n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size <= 1), n.addedDocuments.size > 0 ? c.wa = !0 : n.modifiedDocuments.size > 0 ? Ve(c.wa) : n.removedDocuments.size > 0 && (Ve(c.wa), c.wa = !1));
            }), await Bl(r, t, _);
        } catch (t) {
            await zl(t);
        }
    }
    function $4(e, _, r) {
        let t = ce(e);
        if (t.isPrimaryClient && r === 0 || !t.isPrimaryClient && r === 1) {
            let n = [];
            t.ba.forEach((s, c)=>{
                let i = c.view.j_(_);
                i.snapshot && n.push(i.snapshot);
            }), function(c, i) {
                let d = ce(c);
                d.onlineState = i;
                let v = !1;
                d.queries.forEach((b, p)=>{
                    for (let u of p.U_)u.j_(i) && (v = !0);
                }), v && hm(d);
            }(t.eventManager, _), n.length && t.Sa.h_(n), t.onlineState = _, t.isPrimaryClient && t.sharedClientState.setOnlineState(_);
        }
    }
    async function HN(e, _, r) {
        let t = ce(e);
        t.sharedClientState.updateQueryState(_, "rejected", r);
        let n = t.Fa.get(_), s = n && n.key;
        if (s) {
            let c = new ho(V_.comparator);
            c = c.insert(s, Ot.newNoDocument(s, le.min()));
            let i = ke().add(s), d = new wu(le.min(), new Map, new ho(Ae), c, i);
            await bD(t, d), t.va = t.va.remove(s), t.Fa.delete(_), ym(t);
        } else await Tf(t.localStore, _, !1).then(()=>jf(t, _, r)).catch(zl);
    }
    async function jN(e, _) {
        let r = ce(e), t = _.batch.batchId;
        try {
            let n = await yN(r.localStore, _);
            fD(r, t, null), pD(r, t), r.sharedClientState.updateMutationState(t, "acknowledged"), await Bl(r, n);
        } catch (n) {
            await zl(n);
        }
    }
    async function KN(e, _, r) {
        let t = ce(e);
        try {
            let n = await function(c, i) {
                let d = ce(c);
                return d.persistence.runTransaction("Reject batch", "readwrite-primary", (v)=>{
                    let b;
                    return d.mutationQueue.lookupMutationBatch(v, i).next((p)=>(Ve(p !== null), b = p.keys(), d.mutationQueue.removeMutationBatch(v, p))).next(()=>d.mutationQueue.performConsistencyCheck(v)).next(()=>d.documentOverlayCache.removeOverlaysForBatchId(v, b, i)).next(()=>d.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(v, b)).next(()=>d.localDocuments.getDocuments(v, b));
                });
            }(t.localStore, _);
            fD(t, _, r), pD(t, _), t.sharedClientState.updateMutationState(_, "rejected", r), await Bl(t, n);
        } catch (n) {
            await zl(n);
        }
    }
    function pD(e, _) {
        (e.Oa.get(_) || []).forEach((r)=>{
            r.resolve();
        }), e.Oa.delete(_);
    }
    function fD(e, _, r) {
        let t = ce(e), n = t.xa[t.currentUser.toKey()];
        if (n) {
            let s = n.get(_);
            s && (r ? s.reject(r) : s.resolve(), n = n.remove(_)), t.xa[t.currentUser.toKey()] = n;
        }
    }
    function jf(e, _, r = null) {
        e.sharedClientState.removeLocalQueryTarget(_);
        for (let t of e.Da.get(_))e.ba.delete(t), r && e.Sa.ka(t, r);
        e.Da.delete(_), e.isPrimaryClient && e.Ma.Vr(_).forEach((t)=>{
            e.Ma.containsKey(t) || mD(e, t);
        });
    }
    function mD(e, _) {
        e.Ca.delete(_.path.canonicalString());
        let r = e.va.get(_);
        r !== null && (bm(e.remoteStore, r), e.va = e.va.remove(_), e.Fa.delete(r), ym(e));
    }
    function h4(e, _, r) {
        for (let t of r)t instanceof Pu ? (e.Ma.addReference(t.key, _), QN(e, t)) : t instanceof Lu ? (k_("SyncEngine", "Document no longer in limbo: " + t.key), e.Ma.removeReference(t.key, _), e.Ma.containsKey(t.key) || mD(e, t.key)) : Z_();
    }
    function QN(e, _) {
        let r = _.key, t = r.path.canonicalString();
        e.va.get(r) || e.Ca.has(t) || (k_("SyncEngine", "New document in limbo: " + r), e.Ca.add(t), ym(e));
    }
    function ym(e) {
        for(; e.Ca.size > 0 && e.va.size < e.maxConcurrentLimboResolutions;){
            let _ = e.Ca.values().next().value;
            e.Ca.delete(_);
            let r = new V_(ao.fromString(_)), t = e.Na.next();
            e.Fa.set(t, new Wf(r)), e.va = e.va.insert(r, t), sD(e.remoteStore, new Cl(bn(ju(r.path)), t, "TargetPurposeLimboResolution", Sl.oe));
        }
    }
    async function Bl(e, _, r) {
        let t = ce(e), n = [], s = [], c = [];
        t.ba.isEmpty() || (t.ba.forEach((i, d)=>{
            c.push(t.Ba(d, _, r).then((v)=>{
                var b;
                if ((v || r) && t.isPrimaryClient) {
                    let p = v ? !v.fromCache : (b = r?.targetChanges.get(d.targetId)) === null || b === void 0 ? void 0 : b.current;
                    t.sharedClientState.updateQueryState(d.targetId, p ? "current" : "not-current");
                }
                if (v) {
                    n.push(v);
                    let p = Sf.Ki(d.targetId, v);
                    s.push(p);
                }
            }));
        }), await Promise.all(c), t.Sa.h_(n), await async function(d, v) {
            let b = ce(d);
            try {
                await b.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (p)=>d_.forEach(v, (u)=>d_.forEach(u.qi, (m)=>b.persistence.referenceDelegate.addReference(p, u.targetId, m)).next(()=>d_.forEach(u.Qi, (m)=>b.persistence.referenceDelegate.removeReference(p, u.targetId, m)))));
            } catch (p) {
                if (!Ol(p)) throw p;
                k_("LocalStore", "Failed to update sequence numbers: " + p);
            }
            for (let p of v){
                let u = p.targetId;
                if (!p.fromCache) {
                    let m = b.ns.get(u), z = m.snapshotVersion, L = m.withLastLimboFreeSnapshotVersion(z);
                    b.ns = b.ns.insert(u, L);
                }
            }
        }(t.localStore, s));
    }
    async function YN(e, _) {
        let r = ce(e);
        if (!r.currentUser.isEqual(_)) {
            k_("SyncEngine", "User change. New user:", _.toKey());
            let t = await tD(r.localStore, _);
            r.currentUser = _, function(s, c) {
                s.Oa.forEach((i)=>{
                    i.forEach((d)=>{
                        d.reject(new R_(o_.CANCELLED, c));
                    });
                }), s.Oa.clear();
            }(r, "'waitForPendingWrites' promise is rejected due to a user change."), r.sharedClientState.handleUserChange(_, t.removedBatchIds, t.addedBatchIds), await Bl(r, t.us);
        }
    }
    function XN(e, _) {
        let r = ce(e), t = r.Fa.get(_);
        if (t && t.wa) return ke().add(t.key);
        {
            let n = ke(), s = r.Da.get(_);
            if (!s) return n;
            for (let c of s){
                let i = r.ba.get(c);
                n = n.unionWith(i.view.Ea);
            }
            return n;
        }
    }
    function $D(e) {
        let _ = ce(e);
        return _.remoteStore.remoteSyncer.applyRemoteEvent = bD.bind(null, _), _.remoteStore.remoteSyncer.getRemoteKeysForTarget = XN.bind(null, _), _.remoteStore.remoteSyncer.rejectListen = HN.bind(null, _), _.Sa.h_ = zN.bind(null, _.eventManager), _.Sa.ka = ON.bind(null, _.eventManager), _;
    }
    function ZN(e) {
        let _ = ce(e);
        return _.remoteStore.remoteSyncer.applySuccessfulWrite = jN.bind(null, _), _.remoteStore.remoteSyncer.rejectFailedWrite = KN.bind(null, _), _;
    }
    var zu = class {
        constructor(){
            this.synchronizeTabs = !1;
        }
        async initialize(_) {
            this.serializer = Yu(_.databaseInfo.databaseId), this.sharedClientState = this.createSharedClientState(_), this.persistence = this.createPersistence(_), await this.persistence.start(), this.localStore = this.createLocalStore(_), this.gcScheduler = this.createGarbageCollectionScheduler(_, this.localStore), this.indexBackfillerScheduler = this.createIndexBackfillerScheduler(_, this.localStore);
        }
        createGarbageCollectionScheduler(_, r) {
            return null;
        }
        createIndexBackfillerScheduler(_, r) {
            return null;
        }
        createLocalStore(_) {
            return hN(this.persistence, new xf, _.initialUser, this.serializer);
        }
        createPersistence(_) {
            return new wf(kf.Hr, this.serializer);
        }
        createSharedClientState(_) {
            return new Gf;
        }
        async terminate() {
            var _, r;
            (_ = this.gcScheduler) === null || _ === void 0 || _.stop(), (r = this.indexBackfillerScheduler) === null || r === void 0 || r.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
        }
    };
    var Kf = class {
        async initialize(_, r) {
            this.localStore || (this.localStore = _.localStore, this.sharedClientState = _.sharedClientState, this.datastore = this.createDatastore(r), this.remoteStore = this.createRemoteStore(r), this.eventManager = this.createEventManager(r), this.syncEngine = this.createSyncEngine(r, !_.synchronizeTabs), this.sharedClientState.onlineStateHandler = (t)=>$4(this.syncEngine, t, 1), this.remoteStore.remoteSyncer.handleCredentialChange = YN.bind(null, this.syncEngine), await LN(this.remoteStore, this.syncEngine.isPrimaryClient));
        }
        createEventManager(_) {
            return function() {
                return new Bf;
            }();
        }
        createDatastore(_) {
            let r = Yu(_.databaseInfo.databaseId), t = function(s) {
                return new Nf(s);
            }(_.databaseInfo);
            return function(s, c, i, d) {
                return new Pf(s, c, i, d);
            }(_.authCredentials, _.appCheckCredentials, t, r);
        }
        createRemoteStore(_) {
            return function(t, n, s, c, i) {
                return new zf(t, n, s, c, i);
            }(this.localStore, this.datastore, _.asyncQueue, (r)=>$4(this.syncEngine, r, 0), function() {
                return Tu.D() ? new Tu : new Cf;
            }());
        }
        createSyncEngine(_, r) {
            return function(n, s, c, i, d, v, b) {
                let p = new Hf(n, s, c, i, d, v);
                return b && (p.La = !0), p;
            }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, _.initialUser, _.maxConcurrentLimboResolutions, r);
        }
        async terminate() {
            var _;
            await async function(t) {
                let n = ce(t);
                k_("RemoteStore", "RemoteStore shutting down."), n.M_.add(5), await Ul(n), n.O_.shutdown(), n.N_.set("Unknown");
            }(this.remoteStore), (_ = this.datastore) === null || _ === void 0 || _.terminate();
        }
    };
    var Ou = class {
        constructor(_){
            this.observer = _, this.muted = !1;
        }
        next(_) {
            this.observer.next && this.Ka(this.observer.next, _);
        }
        error(_) {
            this.observer.error ? this.Ka(this.observer.error, _) : _0("Uncaught Error in snapshot listener:", _.toString());
        }
        $a() {
            this.muted = !0;
        }
        Ka(_, r) {
            this.muted || setTimeout(()=>{
                this.muted || _(r);
            }, 0);
        }
    };
    var Qf = class {
        constructor(_, r, t, n){
            this.authCredentials = _, this.appCheckCredentials = r, this.asyncQueue = t, this.databaseInfo = n, this.user = Yo.UNAUTHENTICATED, this.clientId = fu.newId(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this.authCredentials.start(t, async (s)=>{
                k_("FirestoreClient", "Received user=", s.uid), await this.authCredentialListener(s), this.user = s;
            }), this.appCheckCredentials.start(t, (s)=>(k_("FirestoreClient", "Received new app check token=", s), this.appCheckCredentialListener(s, this.user)));
        }
        get configuration() {
            return {
                asyncQueue: this.asyncQueue,
                databaseInfo: this.databaseInfo,
                clientId: this.clientId,
                authCredentials: this.authCredentials,
                appCheckCredentials: this.appCheckCredentials,
                initialUser: this.user,
                maxConcurrentLimboResolutions: 100
            };
        }
        setCredentialChangeListener(_) {
            this.authCredentialListener = _;
        }
        setAppCheckTokenChangeListener(_) {
            this.appCheckCredentialListener = _;
        }
        verifyNotTerminated() {
            if (this.asyncQueue.isShuttingDown) throw new R_(o_.FAILED_PRECONDITION, "The client has already been terminated.");
        }
        terminate() {
            this.asyncQueue.enterRestrictedMode();
            let _ = new un;
            return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
                try {
                    this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), _.resolve();
                } catch (r) {
                    let t = $m(r, "Failed to shutdown persistence");
                    _.reject(t);
                }
            }), _.promise;
        }
    };
    async function S5(e, _) {
        e.asyncQueue.verifyOperationInProgress(), k_("FirestoreClient", "Initializing OfflineComponentProvider");
        let r = e.configuration;
        await _.initialize(r);
        let t = r.initialUser;
        e.setCredentialChangeListener(async (n)=>{
            t.isEqual(n) || (await tD(_.localStore, n), t = n);
        }), _.persistence.setDatabaseDeletedListener(()=>e.terminate()), e._offlineComponents = _;
    }
    async function y4(e, _) {
        e.asyncQueue.verifyOperationInProgress();
        let r = await eF(e);
        k_("FirestoreClient", "Initializing OnlineComponentProvider"), await _.initialize(r, e.configuration), e.setCredentialChangeListener((t)=>f4(_.remoteStore, t)), e.setAppCheckTokenChangeListener((t, n)=>f4(_.remoteStore, n)), e._onlineComponents = _;
    }
    function _F(e) {
        return e.name === "FirebaseError" ? e.code === o_.FAILED_PRECONDITION || e.code === o_.UNIMPLEMENTED : !(typeof DOMException < "u" && e instanceof DOMException) || e.code === 22 || e.code === 20 || e.code === 11;
    }
    async function eF(e) {
        if (!e._offlineComponents) {
            if (e._uninitializedComponentsProvider) {
                k_("FirestoreClient", "Using user provided OfflineComponentProvider");
                try {
                    await S5(e, e._uninitializedComponentsProvider._offline);
                } catch (_) {
                    let r = _;
                    if (!_F(r)) throw r;
                    ya("Error using user provided cache. Falling back to memory cache: " + r), await S5(e, new zu);
                }
            } else k_("FirestoreClient", "Using default OfflineComponentProvider"), await S5(e, new zu);
        }
        return e._offlineComponents;
    }
    async function hD(e) {
        return e._onlineComponents || (e._uninitializedComponentsProvider ? (k_("FirestoreClient", "Using user provided OnlineComponentProvider"), await y4(e, e._uninitializedComponentsProvider._online)) : (k_("FirestoreClient", "Using default OnlineComponentProvider"), await y4(e, new Kf))), e._onlineComponents;
    }
    function oF(e) {
        return hD(e).then((_)=>_.syncEngine);
    }
    async function Yf(e) {
        let _ = await hD(e), r = _.eventManager;
        return r.onListen = UN.bind(null, _.syncEngine), r.onUnlisten = VN.bind(null, _.syncEngine), r.onFirstRemoteStoreListen = BN.bind(null, _.syncEngine), r.onLastRemoteStoreUnlisten = qN.bind(null, _.syncEngine), r;
    }
    function rF(e, _, r = {}) {
        let t = new un;
        return e.asyncQueue.enqueueAndForget(async ()=>(function(s, c, i, d, v) {
                let b = new Ou({
                    next: (u)=>{
                        c.enqueueAndForget(()=>uD(s, p));
                        let m = u.docs.has(i);
                        !m && u.fromCache ? v.reject(new R_(o_.UNAVAILABLE, "Failed to get document because the client is offline.")) : m && u.fromCache && d && d.source === "server" ? v.reject(new R_(o_.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : v.resolve(u);
                    },
                    error: (u)=>v.reject(u)
                }), p = new Mu(ju(i.path), b, {
                    includeMetadataChanges: !0,
                    ra: !0
                });
                return vD(s, p);
            })(await Yf(e), e.asyncQueue, _, r, t)), t.promise;
    }
    function yD(e) {
        let _ = {};
        return e.timeoutSeconds !== void 0 && (_.timeoutSeconds = e.timeoutSeconds), _;
    }
    var D4 = new Map;
    function DD(e, _, r) {
        if (!r) throw new R_(o_.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${_}.`);
    }
    function tF(e, _, r, t) {
        if (_ === !0 && t === !0) throw new R_(o_.INVALID_ARGUMENT, `${e} and ${r} cannot be used together.`);
    }
    function w4(e) {
        if (!V_.isDocumentKey(e)) throw new R_(o_.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
    }
    function R4(e) {
        if (V_.isDocumentKey(e)) throw new R_(o_.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
    }
    function _1(e) {
        if (e === void 0) return "undefined";
        if (e === null) return "null";
        if (typeof e == "string") return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
        if (typeof e == "number" || typeof e == "boolean") return "" + e;
        if (typeof e == "object") {
            if (e instanceof Array) return "an array";
            {
                let _ = function(t) {
                    return t.constructor ? t.constructor.name : null;
                }(e);
                return _ ? `a custom ${_} object` : "an object";
            }
        }
        return typeof e == "function" ? "a function" : Z_();
    }
    function Zn(e, _) {
        if ("_delegate" in e && (e = e._delegate), !(e instanceof _)) {
            if (_.name === e.constructor.name) throw new R_(o_.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
            {
                let r = _1(e);
                throw new R_(o_.INVALID_ARGUMENT, `Expected type '${_.name}', but it was: ${r}`);
            }
        }
        return e;
    }
    var Uu = class {
        constructor(_){
            var r, t;
            if (_.host === void 0) {
                if (_.ssl !== void 0) throw new R_(o_.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
                this.host = "firestore.googleapis.com", this.ssl = !0;
            } else this.host = _.host, this.ssl = (r = _.ssl) === null || r === void 0 || r;
            if (this.credentials = _.credentials, this.ignoreUndefinedProperties = !!_.ignoreUndefinedProperties, this.localCache = _.localCache, _.cacheSizeBytes === void 0) this.cacheSizeBytes = 41943040;
            else {
                if (_.cacheSizeBytes !== -1 && _.cacheSizeBytes < 1048576) throw new R_(o_.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
                this.cacheSizeBytes = _.cacheSizeBytes;
            }
            tF("experimentalForceLongPolling", _.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", _.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!_.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : _.experimentalAutoDetectLongPolling === void 0 ? this.experimentalAutoDetectLongPolling = !0 : this.experimentalAutoDetectLongPolling = !!_.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = yD((t = _.experimentalLongPollingOptions) !== null && t !== void 0 ? t : {}), function(s) {
                if (s.timeoutSeconds !== void 0) {
                    if (isNaN(s.timeoutSeconds)) throw new R_(o_.INVALID_ARGUMENT, `invalid long polling timeout: ${s.timeoutSeconds} (must not be NaN)`);
                    if (s.timeoutSeconds < 5) throw new R_(o_.INVALID_ARGUMENT, `invalid long polling timeout: ${s.timeoutSeconds} (minimum allowed value is 5)`);
                    if (s.timeoutSeconds > 30) throw new R_(o_.INVALID_ARGUMENT, `invalid long polling timeout: ${s.timeoutSeconds} (maximum allowed value is 30)`);
                }
            }(this.experimentalLongPollingOptions), this.useFetchStreams = !!_.useFetchStreams;
        }
        isEqual(_) {
            return this.host === _.host && this.ssl === _.ssl && this.credentials === _.credentials && this.cacheSizeBytes === _.cacheSizeBytes && this.experimentalForceLongPolling === _.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === _.experimentalAutoDetectLongPolling && function(t, n) {
                return t.timeoutSeconds === n.timeoutSeconds;
            }(this.experimentalLongPollingOptions, _.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === _.ignoreUndefinedProperties && this.useFetchStreams === _.useFetchStreams;
        }
    }, Ca = class {
        constructor(_, r, t, n){
            this._authCredentials = _, this._appCheckCredentials = r, this._databaseId = t, this._app = n, this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new Uu({}), this._settingsFrozen = !1;
        }
        get app() {
            if (!this._app) throw new R_(o_.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
            return this._app;
        }
        get _initialized() {
            return this._settingsFrozen;
        }
        get _terminated() {
            return this._terminateTask !== void 0;
        }
        _setSettings(_) {
            if (this._settingsFrozen) throw new R_(o_.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
            this._settings = new Uu(_), _.credentials !== void 0 && (this._authCredentials = function(t) {
                if (!t) return new I5;
                switch(t.type){
                    case "firstParty":
                        return new G5(t.sessionIndex || "0", t.iamToken || null, t.authTokenFactory || null);
                    case "provider":
                        return t.client;
                    default:
                        throw new R_(o_.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
                }
            }(_.credentials));
        }
        _getSettings() {
            return this._settings;
        }
        _freezeSettings() {
            return this._settingsFrozen = !0, this._settings;
        }
        _delete() {
            return this._terminateTask || (this._terminateTask = this._terminate()), this._terminateTask;
        }
        toJSON() {
            return {
                app: this._app,
                databaseId: this._databaseId,
                settings: this._settings
            };
        }
        _terminate() {
            return function(r) {
                let t = D4.get(r);
                t && (k_("ComponentProvider", "Removing Datastore"), D4.delete(r), t.terminate());
            }(this), Promise.resolve();
        }
    };
    function Dm(e, _, r, t = {}) {
        var n;
        let s = (e = Zn(e, Ca))._getSettings(), c = `${_}:${r}`;
        if (s.host !== "firestore.googleapis.com" && s.host !== c && ya("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."), e._setSettings(Object.assign(Object.assign({}, s), {
            host: c,
            ssl: !1
        })), t.mockUserToken) {
            let i, d;
            if (typeof t.mockUserToken == "string") i = t.mockUserToken, d = Yo.MOCK_USER;
            else {
                i = k9(t.mockUserToken, (n = e._app) === null || n === void 0 ? void 0 : n.options.projectId);
                let v = t.mockUserToken.sub || t.mockUserToken.user_id;
                if (!v) throw new R_(o_.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
                d = new Yo(v);
            }
            e._authCredentials = new x5(new pu(i, d));
        }
    }
    var Aa = class e {
        constructor(_, r, t){
            this.converter = r, this._query = t, this.type = "query", this.firestore = _;
        }
        withConverter(_) {
            return new e(this.firestore, _, this._query);
        }
    }, Fr = class e {
        constructor(_, r, t){
            this.converter = r, this._key = t, this.type = "document", this.firestore = _;
        }
        get _path() {
            return this._key.path;
        }
        get id() {
            return this._key.path.lastSegment();
        }
        get path() {
            return this._key.path.canonicalString();
        }
        get parent() {
            return new K0(this.firestore, this.converter, this._key.path.popLast());
        }
        withConverter(_) {
            return new e(this.firestore, _, this._key);
        }
    }, K0 = class e extends Aa {
        constructor(_, r, t){
            super(_, r, ju(t)), this._path = t, this.type = "collection";
        }
        get id() {
            return this._query.path.lastSegment();
        }
        get path() {
            return this._query.path.canonicalString();
        }
        get parent() {
            let _ = this._path.popLast();
            return _.isEmpty() ? null : new Fr(this.firestore, null, new V_(_));
        }
        withConverter(_) {
            return new e(this.firestore, _, this._path);
        }
    };
    function wm(e, _, ...r) {
        if (e = mo(e), DD("collection", "path", _), e instanceof Ca) {
            let t = ao.fromString(_, ...r);
            return R4(t), new K0(e, null, t);
        }
        {
            if (!(e instanceof Fr || e instanceof K0)) throw new R_(o_.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
            let t = e._path.child(ao.fromString(_, ...r));
            return R4(t), new K0(e.firestore, null, t);
        }
    }
    function ic(e, _, ...r) {
        if (e = mo(e), arguments.length === 1 && (_ = fu.newId()), DD("doc", "path", _), e instanceof Ca) {
            let t = ao.fromString(_, ...r);
            return w4(t), new Fr(e, null, new V_(t));
        }
        {
            if (!(e instanceof Fr || e instanceof K0)) throw new R_(o_.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
            let t = e._path.child(ao.fromString(_, ...r));
            return w4(t), new Fr(e.firestore, e instanceof K0 ? e.converter : null, new V_(t));
        }
    }
    var Xf = class {
        constructor(){
            this.iu = Promise.resolve(), this.su = [], this.ou = !1, this._u = [], this.au = null, this.uu = !1, this.cu = !1, this.lu = [], this.Yo = new Gu(this, "async_queue_retry"), this.hu = ()=>{
                let r = k5();
                r && k_("AsyncQueue", "Visibility state changed to " + r.visibilityState), this.Yo.Wo();
            };
            let _ = k5();
            _ && typeof _.addEventListener == "function" && _.addEventListener("visibilitychange", this.hu);
        }
        get isShuttingDown() {
            return this.ou;
        }
        enqueueAndForget(_) {
            this.enqueue(_);
        }
        enqueueAndForgetEvenWhileRestricted(_) {
            this.Pu(), this.Iu(_);
        }
        enterRestrictedMode(_) {
            if (!this.ou) {
                this.ou = !0, this.cu = _ || !1;
                let r = k5();
                r && typeof r.removeEventListener == "function" && r.removeEventListener("visibilitychange", this.hu);
            }
        }
        enqueue(_) {
            if (this.Pu(), this.ou) return new Promise(()=>{});
            let r = new un;
            return this.Iu(()=>this.ou && this.cu ? Promise.resolve() : (_().then(r.resolve, r.reject), r.promise)).then(()=>r.promise);
        }
        enqueueRetryable(_) {
            this.enqueueAndForget(()=>(this.su.push(_), this.Tu()));
        }
        async Tu() {
            if (this.su.length !== 0) {
                try {
                    await this.su[0](), this.su.shift(), this.Yo.reset();
                } catch (_) {
                    if (!Ol(_)) throw _;
                    k_("AsyncQueue", "Operation failed with retryable error: " + _);
                }
                this.su.length > 0 && this.Yo.$o(()=>this.Tu());
            }
        }
        Iu(_) {
            let r = this.iu.then(()=>(this.uu = !0, _().catch((t)=>{
                    this.au = t, this.uu = !1;
                    let n = function(c) {
                        let i = c.message || "";
                        return c.stack && (i = c.stack.includes(c.message) ? c.stack : c.message + `
` + c.stack), i;
                    }(t);
                    throw _0("INTERNAL UNHANDLED ERROR: ", n), t;
                }).then((t)=>(this.uu = !1, t))));
            return this.iu = r, r;
        }
        enqueueAfterDelay(_, r, t) {
            this.Pu(), this.lu.indexOf(_) > -1 && (r = 0);
            let n = Of.createAndSchedule(this, _, r, t, (s)=>this.Eu(s));
            return this._u.push(n), n;
        }
        Pu() {
            this.au && Z_();
        }
        verifyOperationInProgress() {}
        async du() {
            let _;
            do _ = this.iu, await _;
            while (_ !== this.iu);
        }
        Au(_) {
            for (let r of this._u)if (r.timerId === _) return !0;
            return !1;
        }
        Ru(_) {
            return this.du().then(()=>{
                this._u.sort((r, t)=>r.targetTimeMs - t.targetTimeMs);
                for (let r of this._u)if (r.skipDelay(), _ !== "all" && r.timerId === _) break;
                return this.du();
            });
        }
        Vu(_) {
            this.lu.push(_);
        }
        Eu(_) {
            let r = this._u.indexOf(_);
            this._u.splice(r, 1);
        }
    };
    function k4(e) {
        return function(r, t) {
            if (typeof r != "object" || r === null) return !1;
            let n = r;
            for (let s of t)if (s in n && typeof n[s] == "function") return !0;
            return !1;
        }(e, [
            "next",
            "error",
            "complete"
        ]);
    }
    var Z0 = class extends Ca {
        constructor(_, r, t, n){
            super(_, r, t, n), this.type = "firestore", this._queue = function() {
                return new Xf;
            }(), this._persistenceKey = n?.name || "[DEFAULT]";
        }
        _terminate() {
            return this._firestoreClient || wD(this), this._firestoreClient.terminate();
        }
    };
    function e1(e, _) {
        let r = typeof e == "object" ? e : W0(), t = typeof e == "string" ? e : _ || "(default)", n = Ys(r, "firestore").getImmediate({
            identifier: t
        });
        if (!n._initialized) {
            let s = su("firestore");
            s && Dm(n, ...s);
        }
        return n;
    }
    function Rm(e) {
        return e._firestoreClient || wD(e), e._firestoreClient.verifyNotTerminated(), e._firestoreClient;
    }
    function wD(e) {
        var _, r, t;
        let n = e._freezeSettings(), s = function(i, d, v, b) {
            return new M5(i, d, v, b.host, b.ssl, b.experimentalForceLongPolling, b.experimentalAutoDetectLongPolling, yD(b.experimentalLongPollingOptions), b.useFetchStreams);
        }(e._databaseId, ((_ = e._app) === null || _ === void 0 ? void 0 : _.options.appId) || "", e._persistenceKey, n);
        e._firestoreClient = new Qf(e._authCredentials, e._appCheckCredentials, e._queue, s), !((r = n.localCache) === null || r === void 0) && r._offlineComponentProvider && !((t = n.localCache) === null || t === void 0) && t._onlineComponentProvider && (e._firestoreClient._uninitializedComponentsProvider = {
            _offlineKind: n.localCache.kind,
            _offline: n.localCache._offlineComponentProvider,
            _online: n.localCache._onlineComponentProvider
        });
    }
    var Fl = class e {
        constructor(_){
            this._byteString = _;
        }
        static fromBase64String(_) {
            try {
                return new e(Mr.fromBase64String(_));
            } catch (r) {
                throw new R_(o_.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + r);
            }
        }
        static fromUint8Array(_) {
            return new e(Mr.fromUint8Array(_));
        }
        toBase64() {
            return this._byteString.toBase64();
        }
        toUint8Array() {
            return this._byteString.toUint8Array();
        }
        toString() {
            return "Bytes(base64: " + this.toBase64() + ")";
        }
        isEqual(_) {
            return this._byteString.isEqual(_._byteString);
        }
    };
    var Ml = class {
        constructor(..._){
            for(let r = 0; r < _.length; ++r)if (_[r].length === 0) throw new R_(o_.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
            this._internalPath = new gt(_);
        }
        isEqual(_) {
            return this._internalPath.isEqual(_._internalPath);
        }
    };
    var Bu = class {
        constructor(_){
            this._methodName = _;
        }
    };
    var Pl = class {
        constructor(_, r){
            if (!isFinite(_) || _ < -90 || _ > 90) throw new R_(o_.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + _);
            if (!isFinite(r) || r < -180 || r > 180) throw new R_(o_.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + r);
            this._lat = _, this._long = r;
        }
        get latitude() {
            return this._lat;
        }
        get longitude() {
            return this._long;
        }
        isEqual(_) {
            return this._lat === _._lat && this._long === _._long;
        }
        toJSON() {
            return {
                latitude: this._lat,
                longitude: this._long
            };
        }
        _compareTo(_) {
            return Ae(this._lat, _._lat) || Ae(this._long, _._long);
        }
    };
    var nF = /^__.*__$/, Zf = class {
        constructor(_, r, t){
            this.data = _, this.fieldMask = r, this.fieldTransforms = t;
        }
        toMutation(_, r) {
            return this.fieldMask !== null ? new r0(_, this.data, this.fieldMask, r, this.fieldTransforms) : new cc(_, this.data, r, this.fieldTransforms);
        }
    };
    function RD(e) {
        switch(e){
            case 0:
            case 2:
            case 1:
                return !0;
            case 3:
            case 4:
                return !1;
            default:
                throw Z_();
        }
    }
    var _m = class e {
        constructor(_, r, t, n, s, c){
            this.settings = _, this.databaseId = r, this.serializer = t, this.ignoreUndefinedProperties = n, s === void 0 && this.mu(), this.fieldTransforms = s || [], this.fieldMask = c || [];
        }
        get path() {
            return this.settings.path;
        }
        get fu() {
            return this.settings.fu;
        }
        gu(_) {
            return new e(Object.assign(Object.assign({}, this.settings), _), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
        }
        pu(_) {
            var r;
            let t = (r = this.path) === null || r === void 0 ? void 0 : r.child(_), n = this.gu({
                path: t,
                yu: !1
            });
            return n.wu(_), n;
        }
        Su(_) {
            var r;
            let t = (r = this.path) === null || r === void 0 ? void 0 : r.child(_), n = this.gu({
                path: t,
                yu: !1
            });
            return n.mu(), n;
        }
        bu(_) {
            return this.gu({
                path: void 0,
                yu: !0
            });
        }
        Du(_) {
            return Ju(_, this.settings.methodName, this.settings.Cu || !1, this.path, this.settings.vu);
        }
        contains(_) {
            return this.fieldMask.find((r)=>_.isPrefixOf(r)) !== void 0 || this.fieldTransforms.find((r)=>_.isPrefixOf(r.field)) !== void 0;
        }
        mu() {
            if (this.path) for(let _ = 0; _ < this.path.length; _++)this.wu(this.path.get(_));
        }
        wu(_) {
            if (_.length === 0) throw this.Du("Document fields must not be empty");
            if (RD(this.fu) && nF.test(_)) throw this.Du('Document fields cannot begin and end with "__"');
        }
    }, em = class {
        constructor(_, r, t){
            this.databaseId = _, this.ignoreUndefinedProperties = r, this.serializer = t || Yu(_);
        }
        Fu(_, r, t, n = !1) {
            return new _m({
                fu: _,
                methodName: r,
                vu: t,
                path: gt.emptyPath(),
                yu: !1,
                Cu: n
            }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
        }
    };
    function kD(e) {
        let _ = e._freezeSettings(), r = Yu(e._databaseId);
        return new em(e._databaseId, !!_.ignoreUndefinedProperties, r);
    }
    function sF(e, _, r, t, n, s = {}) {
        let c = e.Fu(s.merge || s.mergeFields ? 2 : 0, _, r, n);
        xD("Data must be an object, but it was:", c, t);
        let i = SD(t, c), d, v;
        if (s.merge) d = new vn(c.fieldMask), v = c.fieldTransforms;
        else if (s.mergeFields) {
            let b = [];
            for (let p of s.mergeFields){
                let u = aF(_, p, r);
                if (!c.contains(u)) throw new R_(o_.INVALID_ARGUMENT, `Field '${u}' is specified in your field mask but missing from your input data.`);
                lF(b, u) || b.push(u);
            }
            d = new vn(b), v = c.fieldTransforms.filter((p)=>d.covers(p.field));
        } else d = null, v = c.fieldTransforms;
        return new Zf(new zt(i), d, v);
    }
    function cF(e, _, r, t = !1) {
        return km(r, e.Fu(t ? 4 : 3, _));
    }
    function km(e, _) {
        if (ID(e = mo(e))) return xD("Unsupported field value:", _, e), SD(e, _);
        if (e instanceof Bu) return function(t, n) {
            if (!RD(n.fu)) throw n.Du(`${t._methodName}() can only be used with update() and set()`);
            if (!n.path) throw n.Du(`${t._methodName}() is not currently supported inside arrays`);
            let s = t._toFieldTransform(n);
            s && n.fieldTransforms.push(s);
        }(e, _), null;
        if (e === void 0 && _.ignoreUndefinedProperties) return null;
        if (_.path && _.fieldMask.push(_.path), e instanceof Array) {
            if (_.settings.yu && _.fu !== 4) throw _.Du("Nested arrays are not supported");
            return function(t, n) {
                let s = [], c = 0;
                for (let i of t){
                    let d = km(i, n.bu(c));
                    d == null && (d = {
                        nullValue: "NULL_VALUE"
                    }), s.push(d), c++;
                }
                return {
                    arrayValue: {
                        values: s
                    }
                };
            }(e, _);
        }
        return function(t, n) {
            if ((t = mo(t)) === null) return {
                nullValue: "NULL_VALUE"
            };
            if (typeof t == "number") return jA(n.serializer, t);
            if (typeof t == "boolean") return {
                booleanValue: t
            };
            if (typeof t == "string") return {
                stringValue: t
            };
            if (t instanceof Date) {
                let s = sr.fromDate(t);
                return {
                    timestampValue: Iu(n.serializer, s)
                };
            }
            if (t instanceof sr) {
                let s = new sr(t.seconds, 1e3 * Math.floor(t.nanoseconds / 1e3));
                return {
                    timestampValue: Iu(n.serializer, s)
                };
            }
            if (t instanceof Pl) return {
                geoPointValue: {
                    latitude: t.latitude,
                    longitude: t.longitude
                }
            };
            if (t instanceof Fl) return {
                bytesValue: Y4(n.serializer, t._byteString)
            };
            if (t instanceof Fr) {
                let s = n.databaseId, c = t.firestore._databaseId;
                if (!c.isEqual(s)) throw n.Du(`Document reference is for database ${c.projectId}/${c.database} but should be for database ${s.projectId}/${s.database}`);
                return {
                    referenceValue: gm(t.firestore._databaseId || n.databaseId, t._key.path)
                };
            }
            throw n.Du(`Unsupported field value: ${_1(t)}`);
        }(e, _);
    }
    function SD(e, _) {
        let r = {};
        return x4(e) ? _.path && _.path.length > 0 && _.fieldMask.push(_.path) : Fa(e, (t, n)=>{
            let s = km(n, _.pu(t));
            s != null && (r[t] = s);
        }), {
            mapValue: {
                fields: r
            }
        };
    }
    function ID(e) {
        return !(typeof e != "object" || e === null || e instanceof Array || e instanceof Date || e instanceof sr || e instanceof Pl || e instanceof Fl || e instanceof Fr || e instanceof Bu);
    }
    function xD(e, _, r) {
        if (!ID(r) || !function(n) {
            return typeof n == "object" && n !== null && (Object.getPrototypeOf(n) === Object.prototype || Object.getPrototypeOf(n) === null);
        }(r)) {
            let t = _1(r);
            throw t === "an object" ? _.Du(e + " a custom object") : _.Du(e + " " + t);
        }
    }
    function aF(e, _, r) {
        if ((_ = mo(_)) instanceof Ml) return _._internalPath;
        if (typeof _ == "string") return ED(e, _);
        throw Ju("Field path arguments must be of type string or ", e, !1, void 0, r);
    }
    var iF = new RegExp("[~\\*/\\[\\]]");
    function ED(e, _, r) {
        if (_.search(iF) >= 0) throw Ju(`Invalid field path (${_}). Paths must not contain '~', '*', '/', '[', or ']'`, e, !1, void 0, r);
        try {
            return new Ml(..._.split("."))._internalPath;
        } catch  {
            throw Ju(`Invalid field path (${_}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, !1, void 0, r);
        }
    }
    function Ju(e, _, r, t, n) {
        let s = t && !t.isEmpty(), c = n !== void 0, i = `Function ${_}() called with invalid data`;
        r && (i += " (via `toFirestore()`)"), i += ". ";
        let d = "";
        return (s || c) && (d += " (found", s && (d += ` in field ${t}`), c && (d += ` in document ${n}`), d += ")"), new R_(o_.INVALID_ARGUMENT, i + e + d);
    }
    function lF(e, _) {
        return e.some((r)=>r.isEqual(_));
    }
    var Vu = class {
        constructor(_, r, t, n, s){
            this._firestore = _, this._userDataWriter = r, this._key = t, this._document = n, this._converter = s;
        }
        get id() {
            return this._key.path.lastSegment();
        }
        get ref() {
            return new Fr(this._firestore, this._converter, this._key);
        }
        exists() {
            return this._document !== null;
        }
        data() {
            if (this._document) {
                if (this._converter) {
                    let _ = new om(this._firestore, this._userDataWriter, this._key, this._document, null);
                    return this._converter.fromFirestore(_);
                }
                return this._userDataWriter.convertValue(this._document.data.value);
            }
        }
        get(_) {
            if (this._document) {
                let r = this._document.data.field(TD("DocumentSnapshot.get", _));
                if (r !== null) return this._userDataWriter.convertValue(r);
            }
        }
    }, om = class extends Vu {
        data() {
            return super.data();
        }
    };
    function TD(e, _) {
        return typeof _ == "string" ? ED(e, _) : _ instanceof Ml ? _._internalPath : _._delegate._internalPath;
    }
    function dF(e) {
        if (e.limitType === "L" && e.explicitOrderBy.length === 0) throw new R_(o_.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
    }
    var Ll = class {
    }, rm = class extends Ll {
    };
    function GD(e, _, ...r) {
        let t = [];
        _ instanceof Ll && t.push(_), t = t.concat(r), function(s) {
            let c = s.filter((d)=>d instanceof nm).length, i = s.filter((d)=>d instanceof tm).length;
            if (c > 1 || c > 0 && i > 0) throw new R_(o_.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
        }(t);
        for (let n of t)e = n._apply(e);
        return e;
    }
    var tm = class e extends rm {
        constructor(_, r, t){
            super(), this._field = _, this._op = r, this._value = t, this.type = "where";
        }
        static _create(_, r, t) {
            return new e(_, r, t);
        }
        _apply(_) {
            let r = this._parse(_);
            return CD(_._query, r), new Aa(_.firestore, _.converter, K5(_._query, r));
        }
        _parse(_) {
            let r = kD(_.firestore);
            return function(s, c, i, d, v, b, p) {
                let u;
                if (v.isKeyField()) {
                    if (b === "array-contains" || b === "array-contains-any") throw new R_(o_.INVALID_ARGUMENT, `Invalid Query. You can't perform '${b}' queries on documentId().`);
                    if (b === "in" || b === "not-in") {
                        I4(p, b);
                        let m = [];
                        for (let z of p)m.push(S4(d, s, z));
                        u = {
                            arrayValue: {
                                values: m
                            }
                        };
                    } else u = S4(d, s, p);
                } else b !== "in" && b !== "not-in" && b !== "array-contains-any" || I4(p, b), u = cF(i, c, p, b === "in" || b === "not-in");
                return Oo.create(v, b, u);
            }(_._query, "where", r, _.firestore._databaseId, this._field, this._op, this._value);
        }
    };
    var nm = class e extends Ll {
        constructor(_, r){
            super(), this.type = _, this._queryConstraints = r;
        }
        static _create(_, r) {
            return new e(_, r);
        }
        _parse(_) {
            let r = this._queryConstraints.map((t)=>t._parse(_)).filter((t)=>t.getFilters().length > 0);
            return r.length === 1 ? r[0] : Ut.create(r, this._getOperator());
        }
        _apply(_) {
            let r = this._parse(_);
            return r.getFilters().length === 0 ? _ : (function(n, s) {
                let c = n, i = s.getFlattenedFilters();
                for (let d of i)CD(c, d), c = K5(c, d);
            }(_._query, r), new Aa(_.firestore, _.converter, K5(_._query, r)));
        }
        _getQueryConstraints() {
            return this._queryConstraints;
        }
        _getOperator() {
            return this.type === "and" ? "and" : "or";
        }
    };
    function S4(e, _, r) {
        if (typeof (r = mo(r)) == "string") {
            if (r === "") throw new R_(o_.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
            if (!M4(_) && r.indexOf("/") !== -1) throw new R_(o_.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${r}' contains a '/' character.`);
            let t = _.path.child(ao.fromString(r));
            if (!V_.isDocumentKey(t)) throw new R_(o_.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${t}' is not because it has an odd number of segments (${t.length}).`);
            return Z9(e, new V_(t));
        }
        if (r instanceof Fr) return Z9(e, r._key);
        throw new R_(o_.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${_1(r)}.`);
    }
    function I4(e, _) {
        if (!Array.isArray(e) || e.length === 0) throw new R_(o_.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${_.toString()}' filters.`);
    }
    function CD(e, _) {
        let r = function(n, s) {
            for (let c of n)for (let i of c.getFlattenedFilters())if (s.indexOf(i.op) >= 0) return i.op;
            return null;
        }(e.filters, function(n) {
            switch(n){
                case "!=":
                    return [
                        "!=",
                        "not-in"
                    ];
                case "array-contains-any":
                case "in":
                    return [
                        "not-in"
                    ];
                case "not-in":
                    return [
                        "array-contains-any",
                        "in",
                        "not-in",
                        "!="
                    ];
                default:
                    return [];
            }
        }(_.op));
        if (r !== null) throw r === _.op ? new R_(o_.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${_.op.toString()}' filter.`) : new R_(o_.INVALID_ARGUMENT, `Invalid query. You cannot use '${_.op.toString()}' filters with '${r.toString()}' filters.`);
    }
    var sm = class {
        convertValue(_, r = "none") {
            switch(rc(_)){
                case 0:
                    return null;
                case 1:
                    return _.booleanValue;
                case 2:
                    return $o(_.integerValue || _.doubleValue);
                case 3:
                    return this.convertTimestamp(_.timestampValue);
                case 4:
                    return this.convertServerTimestamp(_, r);
                case 5:
                    return _.stringValue;
                case 6:
                    return this.convertBytes(Q0(_.bytesValue));
                case 7:
                    return this.convertReference(_.referenceValue);
                case 8:
                    return this.convertGeoPoint(_.geoPointValue);
                case 9:
                    return this.convertArray(_.arrayValue, r);
                case 10:
                    return this.convertObject(_.mapValue, r);
                default:
                    throw Z_();
            }
        }
        convertObject(_, r) {
            return this.convertObjectMap(_.fields, r);
        }
        convertObjectMap(_, r = "none") {
            let t = {};
            return Fa(_, (n, s)=>{
                t[n] = this.convertValue(s, r);
            }), t;
        }
        convertGeoPoint(_) {
            return new Pl($o(_.latitude), $o(_.longitude));
        }
        convertArray(_, r) {
            return (_.values || []).map((t)=>this.convertValue(t, r));
        }
        convertServerTimestamp(_, r) {
            switch(r){
                case "previous":
                    let t = lm(_);
                    return t == null ? null : this.convertValue(t, r);
                case "estimate":
                    return this.convertTimestamp(xl(_));
                default:
                    return null;
            }
        }
        convertTimestamp(_) {
            let r = e0(_);
            return new sr(r.seconds, r.nanos);
        }
        convertDocumentKey(_, r) {
            let t = ao.fromString(_);
            Ve(rD(t));
            let n = new yu(t.get(1), t.get(3)), s = new V_(t.popFirst(5));
            return n.isEqual(r) || _0(`Document ${s} contains a document reference within a different database (${n.projectId}/${n.database}) which is not supported. It will be treated as a reference in the current database (${r.projectId}/${r.database}) instead.`), s;
        }
    };
    function vF(e, _, r) {
        let t;
        return t = e ? r && (r.merge || r.mergeFields) ? e.toFirestore(_, r) : e.toFirestore(_) : _, t;
    }
    var _c = class {
        constructor(_, r){
            this.hasPendingWrites = _, this.fromCache = r;
        }
        isEqual(_) {
            return this.hasPendingWrites === _.hasPendingWrites && this.fromCache === _.fromCache;
        }
    }, qu = class extends Vu {
        constructor(_, r, t, n, s, c){
            super(_, r, t, n, c), this._firestore = _, this._firestoreImpl = _, this.metadata = s;
        }
        exists() {
            return super.exists();
        }
        data(_ = {}) {
            if (this._document) {
                if (this._converter) {
                    let r = new ha(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, null);
                    return this._converter.fromFirestore(r, _);
                }
                return this._userDataWriter.convertValue(this._document.data.value, _.serverTimestamps);
            }
        }
        get(_, r = {}) {
            if (this._document) {
                let t = this._document.data.field(TD("DocumentSnapshot.get", _));
                if (t !== null) return this._userDataWriter.convertValue(t, r.serverTimestamps);
            }
        }
    }, ha = class extends qu {
        data(_ = {}) {
            return super.data(_);
        }
    }, cm = class {
        constructor(_, r, t, n){
            this._firestore = _, this._userDataWriter = r, this._snapshot = n, this.metadata = new _c(n.hasPendingWrites, n.fromCache), this.query = t;
        }
        get docs() {
            let _ = [];
            return this.forEach((r)=>_.push(r)), _;
        }
        get size() {
            return this._snapshot.docs.size;
        }
        get empty() {
            return this.size === 0;
        }
        forEach(_, r) {
            this._snapshot.docs.forEach((t)=>{
                _.call(r, new ha(this._firestore, this._userDataWriter, t.key, t, new _c(this._snapshot.mutatedKeys.has(t.key), this._snapshot.fromCache), this.query.converter));
            });
        }
        docChanges(_ = {}) {
            let r = !!_.includeMetadataChanges;
            if (r && this._snapshot.excludesMetadataChanges) throw new R_(o_.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
            return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === r || (this._cachedChanges = function(n, s) {
                if (n._snapshot.oldDocs.isEmpty()) {
                    let c = 0;
                    return n._snapshot.docChanges.map((i)=>{
                        let d = new ha(n._firestore, n._userDataWriter, i.doc.key, i.doc, new _c(n._snapshot.mutatedKeys.has(i.doc.key), n._snapshot.fromCache), n.query.converter);
                        return i.doc, {
                            type: "added",
                            doc: d,
                            oldIndex: -1,
                            newIndex: c++
                        };
                    });
                }
                {
                    let c = n._snapshot.oldDocs;
                    return n._snapshot.docChanges.filter((i)=>s || i.type !== 3).map((i)=>{
                        let d = new ha(n._firestore, n._userDataWriter, i.doc.key, i.doc, new _c(n._snapshot.mutatedKeys.has(i.doc.key), n._snapshot.fromCache), n.query.converter), v = -1, b = -1;
                        return i.type !== 0 && (v = c.indexOf(i.doc.key), c = c.delete(i.doc.key)), i.type !== 1 && (c = c.add(i.doc), b = c.indexOf(i.doc.key)), {
                            type: uF(i.type),
                            doc: d,
                            oldIndex: v,
                            newIndex: b
                        };
                    });
                }
            }(this, r), this._cachedChangesIncludeMetadataChanges = r), this._cachedChanges;
        }
    };
    function uF(e) {
        switch(e){
            case 0:
                return "added";
            case 2:
            case 3:
                return "modified";
            case 1:
                return "removed";
            default:
                return Z_();
        }
    }
    function AD(e) {
        e = Zn(e, Fr);
        let _ = Zn(e.firestore, Z0);
        return rF(Rm(_), e._key).then((r)=>MD(_, e, r));
    }
    var Wu = class extends sm {
        constructor(_){
            super(), this.firestore = _;
        }
        convertBytes(_) {
            return new Fl(_);
        }
        convertReference(_) {
            let r = this.convertDocumentKey(_, this.firestore._databaseId);
            return new Fr(this.firestore, null, r);
        }
    };
    function Sm(e, _, r) {
        e = Zn(e, Fr);
        let t = Zn(e.firestore, Z0), n = vF(e.converter, _, r);
        return FD(t, [
            sF(kD(t), "setDoc", e._key, n, e.converter !== null, r).toMutation(e._key, j0.none())
        ]);
    }
    function ND(e) {
        return FD(Zn(e.firestore, Z0), [
            new Tl(e._key, j0.none())
        ]);
    }
    function Im(e, ..._) {
        var r, t, n;
        e = mo(e);
        let s = {
            includeMetadataChanges: !1,
            source: "default"
        }, c = 0;
        typeof _[c] != "object" || k4(_[c]) || (s = _[c], c++);
        let i = {
            includeMetadataChanges: s.includeMetadataChanges,
            source: s.source
        };
        if (k4(_[c])) {
            let p = _[c];
            _[c] = (r = p.next) === null || r === void 0 ? void 0 : r.bind(p), _[c + 1] = (t = p.error) === null || t === void 0 ? void 0 : t.bind(p), _[c + 2] = (n = p.complete) === null || n === void 0 ? void 0 : n.bind(p);
        }
        let d, v, b;
        if (e instanceof Fr) v = Zn(e.firestore, Z0), b = ju(e._key.path), d = {
            next: (p)=>{
                _[c] && _[c](MD(v, e, p));
            },
            error: _[c + 1],
            complete: _[c + 2]
        };
        else {
            let p = Zn(e, Aa);
            v = Zn(p.firestore, Z0), b = p._query;
            let u = new Wu(v);
            d = {
                next: (m)=>{
                    _[c] && _[c](new cm(v, u, p, m));
                },
                error: _[c + 1],
                complete: _[c + 2]
            }, dF(e._query);
        }
        return function(u, m, z, L) {
            let J = new Ou(L), c_ = new Mu(m, J, z);
            return u.asyncQueue.enqueueAndForget(async ()=>vD(await Yf(u), c_)), ()=>{
                J.$a(), u.asyncQueue.enqueueAndForget(async ()=>uD(await Yf(u), c_));
            };
        }(Rm(v), b, i, d);
    }
    function FD(e, _) {
        return function(t, n) {
            let s = new un;
            return t.asyncQueue.enqueueAndForget(async ()=>WN(await oF(t), n, s)), s.promise;
        }(Rm(e), _);
    }
    function MD(e, _, r) {
        let t = r.docs.get(_._key), n = new Wu(e);
        return new qu(e, n, _._key, t, new _c(r.hasPendingWrites, r.fromCache), _.converter);
    }
    (function(_, r = !0) {
        (function(n) {
            Na = n;
        })(q0), an(new Kr("firestore", (t, { instanceIdentifier: n , options: s  })=>{
            let c = t.getProvider("app").getImmediate(), i = new Z0(new E5(t.getProvider("auth-internal")), new A5(t.getProvider("app-check-internal")), function(v, b) {
                if (!Object.prototype.hasOwnProperty.apply(v.options, [
                    "projectId"
                ])) throw new R_(o_.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
                return new yu(v.options.projectId, b);
            }(c, n), c);
            return s = Object.assign({
                useFetchStreams: r
            }, s), i._setSettings(s), i;
        }, "PUBLIC").setMultipleInstances(!0)), Qr(Q9, "4.6.4", _), Qr(Q9, "4.6.4", "esm2017");
    })();
    var PD = (e)=>(_)=>function() {
                return ic(wm(e, _)).id;
            }, LD = (e)=>(_)=>function() {
                return ND(ic(e, _)).catch((r)=>{
                    throw new Error(r.code);
                });
            };
    var zD = (e)=>(_)=>(r)=>function() {
                    let t = ic(e, _);
                    return Sm(t, r).then(()=>t).catch((n)=>{
                        throw new Error(n.code);
                    });
                }, OD = (e)=>(_)=>(r)=>function() {
                    let t = ic(e, _);
                    return Sm(t, r, {
                        merge: !0
                    }).then(()=>{}).catch((n)=>{
                        throw new Error(n.code);
                    });
                }, UD = (e)=>(_)=>function() {
                let r = ic(e, _);
                return AD(r).then((t)=>{
                    if (t.exists()) return {
                        id: t.id,
                        docData: t.data()
                    };
                    throw new Error("doc-not-found");
                }).catch((t)=>{
                    throw new Error(t.code);
                });
            }, _s = (e)=>(_)=>(r)=>function() {
                    if (window.firebaseSubscriptionState[r] != null) return window.firebaseSubscriptionState[r];
                    let t = Im(GD(wm(e, r)), (n)=>{
                        n.docChanges().forEach((s)=>{
                            let c = {
                                id: s.doc.id,
                                changeType: s.type,
                                docData: s.doc.data()
                            }, i = JSON.stringify({
                                docSnapshot: c
                            });
                            document.dispatchEvent(new CustomEvent(_, {
                                detail: i
                            }));
                        });
                    });
                    return window.firebaseSubscriptionState[r] = t, r;
                }, BD = (e)=>(_)=>(r)=>function() {
                    if (window.firebaseSubscriptionState[r] != null) return window.firebaseSubscriptionState[r];
                    let t = Im(ic(e, r), (n)=>{
                        let s = {
                            id: n.id,
                            changeType: "modified",
                            docData: n.data()
                        }, c = JSON.stringify({
                            docSnapshot: s
                        });
                        document.dispatchEvent(new CustomEvent(_, {
                            detail: c
                        }));
                    });
                    return window.firebaseSubscriptionState[r] = t, r;
                }, xm = function() {
        return e1();
    };
    var Dr = (e, _)=>({
            tag: "Doc",
            _1: e,
            _2: _
        });
    var gF = (()=>pl(qp).liftEffect)(), o1 = jr(qp), bF = (e)=>{
        if (e.tag === "Left") return Io(so(S("Left", e._1)));
        if (e.tag === "Right") return Io(so(S("Right", e._1)));
        l();
    }, pF = (e)=>e, Em = (e)=>(_)=>Dr(e, _);
    var Tm = (e)=>(_)=>sn.apply(Io(so(S("Right", pF))))(gF(PD(e)(_))), Jl = (e)=>(_)=>(r)=>o1(LD(e)(_ === "/" ? _ + r : _ + "/" + r)), Gm = (e)=>(_)=>(r)=>(t)=>Qo.bind(o1(UD(_)(r === "/" ? r + t : r + "/" + t)))((n)=>Qo.bind(bF(fe.bimap(y9)(re)(e.decodeJson(n.docData))))((s)=>Io(so(S("Right", Dr(t, s)))))), Vl = (e)=>(_)=>(r)=>(t)=>BD(e)(_)(r === "/" ? r + t : r + "/" + t), JD = (e)=>(_)=>(r)=>(t)=>(n)=>o1(OD(_)(r === "/" ? r + t : r + "/" + t)(e.encodeJson(n))), fF = (e)=>(_)=>Dr(_.id, e);
    var r1 = (e)=>(_)=>(r)=>(t)=>(n)=>sn.apply(Io(so(S("Right", fF(n)))))(o1(zD(_)(r === "/" ? r + t : r + "/" + t)(e.encodeJson(n))));
    var ql = (e)=>({
            tag: e
        }), Cm = ql("ClosedPhase"), Pa = ql("Phase1"), Am = ql("Phase2"), Nm = ql("Phase3"), Fm = ql("OpenPhase");
    var La = {
        encodeJson: (e)=>{
            if (e.tag === "ClosedPhase") return "ClosedPhase";
            if (e.tag === "Phase1") return "Phase1";
            if (e.tag === "Phase2") return "Phase2";
            if (e.tag === "Phase3") return "Phase3";
            if (e.tag === "OpenPhase") return "OpenPhase";
            l();
        }
    }, VD = JD((()=>{
        let e = z_(La)($r)({
            reflectSymbol: ()=>"bookingPhase"
        })();
        return {
            encodeJson: (_)=>e.gEncodeJson(_)(q)
        };
    })()), mF = (e)=>e === "ClosedPhase" ? R("Just", Cm) : e === "PreOpenPhase" ? R("Just", Pa) : e === "Phase1" ? R("Just", Pa) : e === "Phase2" ? R("Just", Am) : e === "Phase3" ? R("Just", Nm) : e === "OpenPhase" ? R("Just", Fm) : D, za = {
        decodeJson: (e)=>{
            let _ = Q_((t)=>D, (t)=>D, (t)=>D, f_, (t)=>D, (t)=>D, e), r = (()=>{
                if (_.tag === "Just") return mF(_._1);
                if (_.tag === "Nothing") return D;
                l();
            })();
            if (r.tag === "Nothing") return S("Left", H("TypeMismatch", "Invalid Booking Phase"));
            if (r.tag === "Just") return S("Right", r._1);
            l();
        }
    };
    var Rt = (e)=>({
            tag: e
        }), lc = (e)=>({
            tag: e
        }), jl = lc("Monday"), t1 = lc("Tuesday"), n1 = lc("Wednesday"), s1 = lc("Thursday"), c1 = lc("Friday"), a1 = lc("Saturday"), Kl = lc("Sunday"), es = Rt("January"), i1 = Rt("February"), l1 = Rt("March"), d1 = Rt("April"), v1 = Rt("May"), u1 = Rt("June"), g1 = Rt("July"), b1 = Rt("August"), p1 = Rt("September"), f1 = Rt("October"), m1 = Rt("November"), n0 = Rt("December");
    var $F = {
        eq: (e)=>(_)=>e.tag === "Monday" ? _.tag === "Monday" : e.tag === "Tuesday" ? _.tag === "Tuesday" : e.tag === "Wednesday" ? _.tag === "Wednesday" : e.tag === "Thursday" ? _.tag === "Thursday" : e.tag === "Friday" ? _.tag === "Friday" : e.tag === "Saturday" ? _.tag === "Saturday" : e.tag === "Sunday" ? _.tag === "Sunday" : !1
    }, qD = {
        compare: (e)=>(_)=>{
                if (e.tag === "Monday") return _.tag === "Monday" ? X_ : E_;
                if (_.tag === "Monday") return T_;
                if (e.tag === "Tuesday") return _.tag === "Tuesday" ? X_ : E_;
                if (_.tag === "Tuesday") return T_;
                if (e.tag === "Wednesday") return _.tag === "Wednesday" ? X_ : E_;
                if (_.tag === "Wednesday") return T_;
                if (e.tag === "Thursday") return _.tag === "Thursday" ? X_ : E_;
                if (_.tag === "Thursday") return T_;
                if (e.tag === "Friday") return _.tag === "Friday" ? X_ : E_;
                if (_.tag === "Friday") return T_;
                if (e.tag === "Saturday") return _.tag === "Saturday" ? X_ : E_;
                if (_.tag === "Saturday") return T_;
                if (e.tag === "Sunday") {
                    if (_.tag === "Sunday") return X_;
                    l();
                }
                l();
            },
        Eq0: ()=>$F
    }, hF = {
        eq: (e)=>(_)=>e.tag === "January" ? _.tag === "January" : e.tag === "February" ? _.tag === "February" : e.tag === "March" ? _.tag === "March" : e.tag === "April" ? _.tag === "April" : e.tag === "May" ? _.tag === "May" : e.tag === "June" ? _.tag === "June" : e.tag === "July" ? _.tag === "July" : e.tag === "August" ? _.tag === "August" : e.tag === "September" ? _.tag === "September" : e.tag === "October" ? _.tag === "October" : e.tag === "November" ? _.tag === "November" : e.tag === "December" ? _.tag === "December" : !1
    }, $1 = {
        compare: (e)=>(_)=>{
                if (e.tag === "January") return _.tag === "January" ? X_ : E_;
                if (_.tag === "January") return T_;
                if (e.tag === "February") return _.tag === "February" ? X_ : E_;
                if (_.tag === "February") return T_;
                if (e.tag === "March") return _.tag === "March" ? X_ : E_;
                if (_.tag === "March") return T_;
                if (e.tag === "April") return _.tag === "April" ? X_ : E_;
                if (_.tag === "April") return T_;
                if (e.tag === "May") return _.tag === "May" ? X_ : E_;
                if (_.tag === "May") return T_;
                if (e.tag === "June") return _.tag === "June" ? X_ : E_;
                if (_.tag === "June") return T_;
                if (e.tag === "July") return _.tag === "July" ? X_ : E_;
                if (_.tag === "July") return T_;
                if (e.tag === "August") return _.tag === "August" ? X_ : E_;
                if (_.tag === "August") return T_;
                if (e.tag === "September") return _.tag === "September" ? X_ : E_;
                if (_.tag === "September") return T_;
                if (e.tag === "October") return _.tag === "October" ? X_ : E_;
                if (_.tag === "October") return T_;
                if (e.tag === "November") return _.tag === "November" ? X_ : E_;
                if (_.tag === "November") return T_;
                if (e.tag === "December") {
                    if (_.tag === "December") return X_;
                    l();
                }
                l();
            },
        Eq0: ()=>hF
    };
    var yF = {
        bottom: jl,
        top: Kl,
        Ord0: ()=>qD
    }, DF = {
        bottom: es,
        top: n0,
        Ord0: ()=>$1
    };
    var Hl = {
        cardinality: 7,
        toEnum: (e)=>e === 1 ? R("Just", jl) : e === 2 ? R("Just", t1) : e === 3 ? R("Just", n1) : e === 4 ? R("Just", s1) : e === 5 ? R("Just", c1) : e === 6 ? R("Just", a1) : e === 7 ? R("Just", Kl) : D,
        fromEnum: (e)=>{
            if (e.tag === "Monday") return 1;
            if (e.tag === "Tuesday") return 2;
            if (e.tag === "Wednesday") return 3;
            if (e.tag === "Thursday") return 4;
            if (e.tag === "Friday") return 5;
            if (e.tag === "Saturday") return 6;
            if (e.tag === "Sunday") return 7;
            l();
        },
        Bounded0: ()=>yF,
        Enum1: ()=>wF
    }, wF = {
        succ: (e)=>Hl.toEnum((()=>{
                if (e.tag === "Monday") return 2;
                if (e.tag === "Tuesday") return 3;
                if (e.tag === "Wednesday") return 4;
                if (e.tag === "Thursday") return 5;
                if (e.tag === "Friday") return 6;
                if (e.tag === "Saturday") return 7;
                if (e.tag === "Sunday") return 8;
                l();
            })()),
        pred: (e)=>Hl.toEnum((()=>{
                if (e.tag === "Monday") return 0;
                if (e.tag === "Tuesday") return 1;
                if (e.tag === "Wednesday") return 2;
                if (e.tag === "Thursday") return 3;
                if (e.tag === "Friday") return 4;
                if (e.tag === "Saturday") return 5;
                if (e.tag === "Sunday") return 6;
                l();
            })()),
        Ord0: ()=>qD
    }, Yr = {
        cardinality: 12,
        toEnum: (e)=>e === 1 ? R("Just", es) : e === 2 ? R("Just", i1) : e === 3 ? R("Just", l1) : e === 4 ? R("Just", d1) : e === 5 ? R("Just", v1) : e === 6 ? R("Just", u1) : e === 7 ? R("Just", g1) : e === 8 ? R("Just", b1) : e === 9 ? R("Just", p1) : e === 10 ? R("Just", f1) : e === 11 ? R("Just", m1) : e === 12 ? R("Just", n0) : D,
        fromEnum: (e)=>{
            if (e.tag === "January") return 1;
            if (e.tag === "February") return 2;
            if (e.tag === "March") return 3;
            if (e.tag === "April") return 4;
            if (e.tag === "May") return 5;
            if (e.tag === "June") return 6;
            if (e.tag === "July") return 7;
            if (e.tag === "August") return 8;
            if (e.tag === "September") return 9;
            if (e.tag === "October") return 10;
            if (e.tag === "November") return 11;
            if (e.tag === "December") return 12;
            l();
        },
        Bounded0: ()=>DF,
        Enum1: ()=>Ql
    }, Ql = {
        succ: (e)=>Yr.toEnum((()=>{
                if (e.tag === "January") return 2;
                if (e.tag === "February") return 3;
                if (e.tag === "March") return 4;
                if (e.tag === "April") return 5;
                if (e.tag === "May") return 6;
                if (e.tag === "June") return 7;
                if (e.tag === "July") return 8;
                if (e.tag === "August") return 9;
                if (e.tag === "September") return 10;
                if (e.tag === "October") return 11;
                if (e.tag === "November") return 12;
                if (e.tag === "December") return 13;
                l();
            })()),
        pred: (e)=>Yr.toEnum((()=>{
                if (e.tag === "January") return 0;
                if (e.tag === "February") return 1;
                if (e.tag === "March") return 2;
                if (e.tag === "April") return 3;
                if (e.tag === "May") return 4;
                if (e.tag === "June") return 5;
                if (e.tag === "July") return 6;
                if (e.tag === "August") return 7;
                if (e.tag === "September") return 8;
                if (e.tag === "October") return 9;
                if (e.tag === "November") return 10;
                if (e.tag === "December") return 11;
                l();
            })()),
        Ord0: ()=>$1
    };
    var WD = function(e, _, r) {
        var t = new Date(Date.UTC(e, _, r));
        return e >= 0 && e < 100 && t.setUTCFullYear(e), t;
    };
    function HD(e, _, r, t) {
        var n = WD(_, r - 1, t);
        return e(n.getUTCFullYear())(n.getUTCMonth() + 1)(n.getUTCDate());
    }
    function jD(e, _, r) {
        return WD(e, _ - 1, r).getUTCDay();
    }
    var dc = (e, _, r)=>({
            tag: "Date",
            _1: e,
            _2: _,
            _3: r
        }), RF = (()=>{
        let e = Yc(co);
        return (_)=>(r)=>e.compare(_)(r).tag === "GT";
    })(), Yl = (e)=>(_)=>(r)=>dc(e, _, r);
    var Ua = (e)=>{
        let _ = jD(e._1, (()=>{
            if (e._2.tag === "January") return 1;
            if (e._2.tag === "February") return 2;
            if (e._2.tag === "March") return 3;
            if (e._2.tag === "April") return 4;
            if (e._2.tag === "May") return 5;
            if (e._2.tag === "June") return 6;
            if (e._2.tag === "July") return 7;
            if (e._2.tag === "August") return 8;
            if (e._2.tag === "September") return 9;
            if (e._2.tag === "October") return 10;
            if (e._2.tag === "November") return 11;
            if (e._2.tag === "December") return 12;
            l();
        })(), e._3);
        if (_ === 0) {
            let t = Hl.toEnum(7);
            if (t.tag === "Just") return t._1;
            l();
        }
        let r = Hl.toEnum(_);
        if (r.tag === "Just") return r._1;
        l();
    };
    var kF = (e)=>wt(e)(4) === 0 && (wt(e)(400) === 0 || wt(e)(100) !== 0), vc = (e)=>(_)=>{
            if (_.tag === "January") return 31;
            if (_.tag === "February") return kF(e) ? 29 : 28;
            if (_.tag === "March") return 31;
            if (_.tag === "April") return 30;
            if (_.tag === "May") return 31;
            if (_.tag === "June") return 30;
            if (_.tag === "July" || _.tag === "August") return 31;
            if (_.tag === "September") return 30;
            if (_.tag === "October") return 31;
            if (_.tag === "November") return 30;
            if (_.tag === "December") return 31;
            l();
        }, wr = {
        eq: (e)=>(_)=>e._1 === _._1 && (()=>e._2.tag === "January" ? _._2.tag === "January" : e._2.tag === "February" ? _._2.tag === "February" : e._2.tag === "March" ? _._2.tag === "March" : e._2.tag === "April" ? _._2.tag === "April" : e._2.tag === "May" ? _._2.tag === "May" : e._2.tag === "June" ? _._2.tag === "June" : e._2.tag === "July" ? _._2.tag === "July" : e._2.tag === "August" ? _._2.tag === "August" : e._2.tag === "September" ? _._2.tag === "September" : e._2.tag === "October" ? _._2.tag === "October" : e._2.tag === "November" ? _._2.tag === "November" : e._2.tag === "December" ? _._2.tag === "December" : !1)() && e._3 === _._3
    }, Eo = {
        compare: (e)=>(_)=>{
                let r = co.compare(e._1)(_._1);
                if (r.tag === "LT") return E_;
                if (r.tag === "GT") return T_;
                let t = $1.compare(e._2)(_._2);
                return t.tag === "LT" ? E_ : t.tag === "GT" ? T_ : co.compare(e._3)(_._3);
            },
        Eq0: ()=>wr
    }, KD = {
        succ: (e)=>{
            let _ = Ql.succ(e._2), r = e._3 + 1 | 0, t = r >= 1 && r <= 31 ? R("Just", r) : D, n = RF(t)(R("Just", vc(e._1)(e._2))) ? D : t;
            return wo.apply(wo.apply((()=>{
                if ((()=>{
                    if (n.tag === "Nothing") return !0;
                    if (n.tag === "Just") return !1;
                    l();
                })() && (()=>{
                    if (_.tag === "Nothing") return !0;
                    if (_.tag === "Just") return !1;
                    l();
                })()) {
                    let s = e._1 + 1 | 0;
                    return s >= -271820 && s <= 275759 ? R("Just", Yl(s)) : D;
                }
                return R("Just", Yl(e._1));
            })())(R("Just", (()=>{
                if ((()=>{
                    if (n.tag === "Nothing") return !0;
                    if (n.tag === "Just") return !1;
                    l();
                })()) {
                    if (_.tag === "Nothing") return es;
                    if (_.tag === "Just") return _._1;
                    l();
                }
                return e._2;
            })())))((()=>{
                if (n.tag === "Nothing") return !0;
                if (n.tag === "Just") return !1;
                l();
            })() ? R("Just", 1) : n);
        },
        pred: (e)=>{
            let _ = Ql.pred(e._2), r = e._3 - 1 | 0, t = r >= 1 && r <= 31 ? R("Just", r) : D, n = (()=>{
                if ((()=>{
                    if (t.tag === "Nothing") return !0;
                    if (t.tag === "Just") return !1;
                    l();
                })()) {
                    if (_.tag === "Nothing") return n0;
                    if (_.tag === "Just") return _._1;
                    l();
                }
                return e._2;
            })(), s = vc(e._1)(n);
            return wo.apply(wo.apply((()=>{
                if ((()=>{
                    if (t.tag === "Nothing") return !0;
                    if (t.tag === "Just") return !1;
                    l();
                })() && (()=>{
                    if (_.tag === "Nothing") return !0;
                    if (_.tag === "Just") return !1;
                    l();
                })()) {
                    let c = e._1 - 1 | 0;
                    return c >= -271820 && c <= 275759 ? R("Just", Yl(c)) : D;
                }
                return R("Just", Yl(e._1));
            })())(R("Just", n)))((()=>{
                if (t.tag === "Nothing") return !0;
                if (t.tag === "Just") return !1;
                l();
            })() ? R("Just", s) : t);
        },
        Ord0: ()=>Eo
    };
    var Xl = (e)=>(_)=>(r)=>HD((t)=>(n)=>(s)=>dc(t, (()=>{
                                let c = Yr.toEnum(n);
                                if (c.tag === "Just") return c._1;
                                l();
                            })(), s), e, (()=>{
                    if (_.tag === "January") return 1;
                    if (_.tag === "February") return 2;
                    if (_.tag === "March") return 3;
                    if (_.tag === "April") return 4;
                    if (_.tag === "May") return 5;
                    if (_.tag === "June") return 6;
                    if (_.tag === "July") return 7;
                    if (_.tag === "August") return 8;
                    if (_.tag === "September") return 9;
                    if (_.tag === "October") return 10;
                    if (_.tag === "November") return 11;
                    if (_.tag === "December") return 12;
                    l();
                })(), r), Ba = (e)=>(_)=>(r)=>wr.eq(Xl(e)(_)(r))(dc(e, _, r)) ? R("Just", dc(e, _, r)) : D;
    var Xo = (e)=>(_)=>{
            let r = (n)=>(s)=>{
                    if (n === 0) return R("Just", s);
                    let c = n + s._3 | 0, i = c < 1, d = vc(s._1)((()=>{
                        if (i) {
                            let u = Ql.pred(s._2);
                            if (u.tag === "Nothing") return n0;
                            if (u.tag === "Just") return u._1;
                            l();
                        }
                        return s._2;
                    })()), v = c > d, b = r((()=>i ? c : v ? (c - d | 0) - 1 | 0 : 0)()), p = (()=>{
                        if (i) return KD.pred(dc(s._1, s._2, 1));
                        if (v) return KD.succ(dc(s._1, s._2, d));
                        let u = Yl(s._1)(s._2);
                        return c >= 1 && c <= 31 ? R("Just", u(c)) : D;
                    })();
                    if (p.tag === "Just") return b(p._1);
                    if (p.tag === "Nothing") return D;
                    l();
                }, t = Zc(e);
            if (t.tag === "Just") return r(t._1)(_);
            if (t.tag === "Nothing") return D;
            l();
        };
    var h1 = (e, _, r, t)=>({
            tag: "Time",
            _1: e,
            _2: _,
            _3: r,
            _4: t
        }), Zl = (e)=>(_)=>(r)=>(t)=>h1(e, _, r, t);
    var SF = {
        eq: (e)=>(_)=>e._1 === _._1 && e._2 === _._2 && e._3 === _._3 && e._4 === _._4
    }, QD = {
        compare: (e)=>(_)=>{
                let r = co.compare(e._1)(_._1);
                if (r.tag === "LT") return E_;
                if (r.tag === "GT") return T_;
                let t = co.compare(e._2)(_._2);
                if (t.tag === "LT") return E_;
                if (t.tag === "GT") return T_;
                let n = co.compare(e._3)(_._3);
                return n.tag === "LT" ? E_ : n.tag === "GT" ? T_ : co.compare(e._4)(_._4);
            },
        Eq0: ()=>SF
    };
    var Pm = function(e, _, r, t, n, s, c) {
        var i = new Date(Date.UTC(e, _, r, t, n, s, c));
        return e >= 0 && e < 100 && i.setUTCFullYear(e), i.getTime();
    };
    function Lm(e, _) {
        var r = Pm(e.year, e.month - 1, e.day, e.hour, e.minute, e.second, e.millisecond), t = Pm(_.year, _.month - 1, _.day, _.hour, _.minute, _.second, _.millisecond);
        return r - t;
    }
    function YD(e) {
        return function(_) {
            return function(r) {
                return function(t) {
                    var n = Pm(t.year, t.month - 1, t.day, t.hour, t.minute, t.second, t.millisecond), s = new Date(n + r);
                    return isNaN(s.getTime()) ? _ : e({
                        year: s.getUTCFullYear(),
                        month: s.getUTCMonth() + 1,
                        day: s.getUTCDate(),
                        hour: s.getUTCHours(),
                        minute: s.getUTCMinutes(),
                        second: s.getUTCSeconds(),
                        millisecond: s.getUTCMilliseconds()
                    });
                };
            };
        };
    }
    var zm = (e, _)=>({
            tag: "DateTime",
            _1: e,
            _2: _
        }), Om = (e)=>(_)=>zm(e, _), y1 = (e)=>({
            year: e._1._1,
            month: (()=>{
                if (e._1._2.tag === "January") return 1;
                if (e._1._2.tag === "February") return 2;
                if (e._1._2.tag === "March") return 3;
                if (e._1._2.tag === "April") return 4;
                if (e._1._2.tag === "May") return 5;
                if (e._1._2.tag === "June") return 6;
                if (e._1._2.tag === "July") return 7;
                if (e._1._2.tag === "August") return 8;
                if (e._1._2.tag === "September") return 9;
                if (e._1._2.tag === "October") return 10;
                if (e._1._2.tag === "November") return 11;
                if (e._1._2.tag === "December") return 12;
                l();
            })(),
            day: e._1._3,
            hour: e._2._1,
            minute: e._2._2,
            second: e._2._3,
            millisecond: e._2._4
        });
    var IF = {
        eq: (e)=>(_)=>wr.eq(e._1)(_._1) && e._2._1 === _._2._1 && e._2._2 === _._2._2 && e._2._3 === _._2._3 && e._2._4 === _._2._4
    }, D1 = {
        compare: (e)=>(_)=>{
                let r = Eo.compare(e._1)(_._1);
                return r.tag === "LT" ? E_ : r.tag === "GT" ? T_ : QD.compare(e._2)(_._2);
            },
        Eq0: ()=>IF
    };
    var Ja = (e)=>(_)=>(r)=>{
                let t = YD(f_)(D)(e.fromDuration(_))(y1(r));
                if (t.tag === "Just") return wo.apply((()=>{
                    let n = wo.apply(wo.apply(t._1.year >= -271820 && t._1.year <= 275759 ? R("Just", Ba(t._1.year)) : D)(Yr.toEnum(t._1.month)))(t._1.day >= 1 && t._1.day <= 31 ? R("Just", t._1.day) : D), s = (()=>{
                        if (n.tag === "Just") return n._1;
                        if (n.tag === "Nothing") return D;
                        l();
                    })();
                    return s.tag === "Just" ? R("Just", Om(s._1)) : D;
                })())(wo.apply(wo.apply(wo.apply(t._1.hour >= 0 && t._1.hour <= 23 ? R("Just", Zl(t._1.hour)) : D)(t._1.minute >= 0 && t._1.minute <= 59 ? R("Just", t._1.minute) : D))(t._1.second >= 0 && t._1.second <= 59 ? R("Just", t._1.second) : D))(t._1.millisecond >= 0 && t._1.millisecond <= 999 ? R("Just", t._1.millisecond) : D));
                if (t.tag === "Nothing") return D;
                l();
            };
    var xF = function(e, _, r, t, n, s, c) {
        var i = new Date(Date.UTC(e, _, r, t, n, s, c));
        return e >= 0 && e < 100 && i.setUTCFullYear(e), i;
    };
    function Um(e, _, r, t, n, s, c) {
        return xF(e, _ - 1, r, t, n, s, c).getTime();
    }
    function XD(e) {
        return function(_) {
            var r = new Date(_);
            return e(r.getUTCFullYear())(r.getUTCMonth() + 1)(r.getUTCDate())(r.getUTCHours())(r.getUTCMinutes())(r.getUTCSeconds())(r.getUTCMilliseconds());
        };
    }
    var qe = XD((e)=>(_)=>(r)=>(t)=>(n)=>(s)=>(c)=>zm(Xl(e)((()=>{
                                    let i = Yr.toEnum(_);
                                    if (i.tag === "Just") return i._1;
                                    l();
                                })())(r), h1(t, n, s, c)));
    var w1 = (e)=>Um(e._1._1, (()=>{
            if (e._1._2.tag === "January") return 1;
            if (e._1._2.tag === "February") return 2;
            if (e._1._2.tag === "March") return 3;
            if (e._1._2.tag === "April") return 4;
            if (e._1._2.tag === "May") return 5;
            if (e._1._2.tag === "June") return 6;
            if (e._1._2.tag === "July") return 7;
            if (e._1._2.tag === "August") return 8;
            if (e._1._2.tag === "September") return 9;
            if (e._1._2.tag === "October") return 10;
            if (e._1._2.tag === "November") return 11;
            if (e._1._2.tag === "December") return 12;
            l();
        })(), e._1._3, e._2._1, e._2._2, e._2._3, e._2._4), Va = (e)=>Um(e._1, (()=>{
            if (e._2.tag === "January") return 1;
            if (e._2.tag === "February") return 2;
            if (e._2.tag === "March") return 3;
            if (e._2.tag === "April") return 4;
            if (e._2.tag === "May") return 5;
            if (e._2.tag === "June") return 6;
            if (e._2.tag === "July") return 7;
            if (e._2.tag === "August") return 8;
            if (e._2.tag === "September") return 9;
            if (e._2.tag === "October") return 10;
            if (e._2.tag === "November") return 11;
            if (e._2.tag === "December") return 12;
            l();
        })(), e._3, 0, 0, 0, 0);
    var EF = (e)=>({
            map: (_)=>(r)=>(t)=>e.map((n)=>E(_(n._1), n._2))(r(t))
        });
    var qa = (e)=>{
        let _ = e.Bind1().bind;
        return {
            bind: (r)=>(t)=>(n)=>_(r(n))((s)=>t(s._1)(s._2)),
            Apply0: ()=>ZD(e)
        };
    }, ZD = (e)=>{
        let _ = EF(e.Bind1().Apply0().Functor0());
        return {
            apply: (()=>{
                let r = qa(e).bind, t = _d(e).pure;
                return (n)=>(s)=>r(n)((c)=>r(s)((i)=>t(c(i))));
            })(),
            Functor0: ()=>_
        };
    }, _d = (e)=>{
        let _ = e.Applicative0().pure;
        return {
            pure: (r)=>(t)=>_(E(r, t)),
            Apply0: ()=>ZD(e)
        };
    };
    var _3 = (e)=>{
        let _ = e.Monad0(), r = _.Bind1().bind, t = _.Applicative0().pure, n = {
            Applicative0: ()=>_d(_),
            Bind1: ()=>qa(_)
        };
        return {
            tailRecM: (s)=>(c)=>(i)=>e.tailRecM((d)=>r(s(d._1)(d._2))((v)=>t((()=>{
                                    if (v._1.tag === "Loop") return nt("Loop", E(v._1._1, v._2));
                                    if (v._1.tag === "Done") return nt("Done", E(v._1._1, v._2));
                                    l();
                                })())))(E(c, i)),
            Monad0: ()=>n
        };
    }, e3 = (e)=>{
        let _ = e.Applicative0().pure, r = {
            Applicative0: ()=>_d(e),
            Bind1: ()=>qa(e)
        };
        return {
            state: (t)=>(n)=>_(t(n)),
            Monad0: ()=>r
        };
    };
    var os = (e, _)=>({
            tag: "ParseError",
            _1: e,
            _2: _
        }), rs = (e, _, r)=>({
            tag: "ParseState",
            _1: e,
            _2: _,
            _3: r
        }), R1 = (e, _, r)=>({
            tag: e,
            _1: _,
            _2: r
        });
    var GF = (e)=>R1("More", e), CF = (e)=>R1("Lift", e);
    var ed = {
        defer: (e)=>{
            let _ = ca(e);
            return (r, t, n, s, c)=>aa(_)(r, t, n, s, c);
        }
    };
    var o3 = {
        map: (e)=>(_)=>(r, t, n, s, c)=>t((i)=>_(r, t, n, s, (d, v)=>t((b)=>c(d, e(v)))))
    };
    var AF = {
        apply: (e)=>(_)=>(r, t, n, s, c)=>t((i)=>e(r, t, n, s, (d, v)=>t((b)=>_(d, t, n, s, (p, u)=>t((m)=>c(p, v(u))))))),
        Functor0: ()=>o3
    };
    var NF = {
        pure: (e)=>(_, r, t, n, s)=>s(_, e),
        Apply0: ()=>AF
    };
    var r3 = (e)=>{
        let _ = e.Semigroup0(), r = {
            append: (t)=>(n)=>(s, c, i, d, v)=>c((b)=>c((p)=>t(s, c, i, d, (u, m)=>c((z)=>{
                                        let L = _.append(m);
                                        return c((J)=>n(u, c, i, d, (c_, t_)=>c((W)=>v(c_, L(t_)))));
                                    }))))
        };
        return {
            mempty: (()=>{
                let t = e.mempty;
                return (n, s, c, i, d)=>d(n, t);
            })(),
            Semigroup0: ()=>r
        };
    }, ts = {
        alt: (e)=>(_)=>(r, t, n, s, c)=>{
                    let i = r._1, d = r._2;
                    return t((v)=>e(rs(i, d, !1), t, n, (b, p)=>{
                            let u = b._3;
                            return t((m)=>u ? s(b, p) : _(r, t, n, s, c));
                        }, c));
                },
        Functor0: ()=>o3
    };
    var t3 = (e)=>{
        let _ = e.Monad0(), r = _.Bind1().Apply0().Functor0().map, t = _.Applicative0().pure;
        return (n)=>(s)=>{
                let c = (i)=>{
                    let d = i, v = !0, b;
                    for(; v;){
                        let u = d();
                        if (u.tag === "More") {
                            d = u._1;
                            continue;
                        }
                        if (u.tag === "Lift") {
                            v = !1, b = r(Zb)(u._1);
                            continue;
                        }
                        if (u.tag === "Stop") {
                            v = !1, b = t(nt("Done", E(u._2, u._1)));
                            continue;
                        }
                        l();
                    }
                    return b;
                };
                return e.tailRecM(c)((i)=>s(n, GF, CF, (d, v)=>R1("Stop", d, S("Left", v)), (d, v)=>R1("Stop", d, S("Right", v))));
            };
    };
    var n3 = (e, _, r, t, n)=>n(e, e._2);
    var s3 = (e)=>{
        let _ = t3(e);
        return (r)=>(t)=>(n)=>(s, c, i, d, v)=>i(r.map((b)=>{
                            let p = b._1, u = b._2;
                            return (m)=>{
                                if (p.tag === "Left") return d(u, p._1);
                                if (p.tag === "Right") return v(u, p._1);
                                l();
                            };
                        })(t(_(s)(n))));
    }, FF = {
        index: 0,
        line: 1,
        column: 1
    }, MF = (e)=>{
        let _ = e.Monad0().Bind1().Apply0().Functor0().map, r = t3(e);
        return (t)=>(n)=>_(Bn)(r(rs(t, FF, !1))(n));
    }, c3 = MF(Pv);
    var PF = (e)=>(_)=>(r, t, n, s, c)=>s(r, os(e, _)), mn = (e)=>(_, r, t, n, s)=>r((c)=>n3(_, r, t, n, (i, d)=>r((v)=>PF(e)(d)(i, r, t, n, s))));
    var LF = {
        empty: mn("No alternative"),
        Alt0: ()=>ts
    }, od = {
        Applicative0: ()=>NF,
        Plus1: ()=>LF
    };
    var Jm = (e)=>(_)=>ts.alt(e)(mn("Expected " + _));
    var $n = (e)=>(_, r, t, n, s)=>{
            let c = _._3;
            return e(_, r, t, (i, d)=>n(rs(i._1, i._2, c), d), s);
        };
    var k1 = (e)=>(_)=>ts.alt(_)((r, t, n, s, c)=>c(r, e)), Vm = (e)=>k1(D)((_, r, t, n, s)=>r((c)=>e(_, r, t, n, (i, d)=>r((v)=>s(i, R("Just", d))))));
    var qm = (e)=>{
        let _ = e.foldr((r)=>(t)=>{
                if (t.tag === "Nothing") return R("Just", r);
                if (t.tag === "Just") return R("Just", ts.alt(r)(t._1));
                l();
            })(D);
        return (r)=>{
            let t = _(r);
            if (t.tag === "Nothing") return mn("No alternative");
            if (t.tag === "Just") return t._1;
            l();
        };
    };
    var a3 = function(e) {
        return function(_) {
            return function(r) {
                return function(t) {
                    try {
                        return _(new RegExp(r, t));
                    } catch (n) {
                        return e(n.message);
                    }
                };
            };
        };
    };
    var i3 = function(e) {
        return function(_) {
            var r = e.lastIndex, t = e.test(_);
            return e.lastIndex = r, t;
        };
    };
    var l3 = function(e) {
        return function(_) {
            return function(r) {
                return function(t) {
                    return function(n) {
                        return n.replace(r, function(s) {
                            for(var c = [], i, d = 1; typeof (i = arguments[d++]) != "number";)c.push(i == null ? _ : e(i));
                            return t(s)(c);
                        });
                    };
                };
            };
        };
    };
    var d3 = l3(f_)(D);
    var Ha = (e)=>(_)=>a3(Ao)(I_)(e)((_.global ? "g" : "") + (_.ignoreCase ? "i" : "") + (_.multiline ? "m" : "") + (_.dotAll ? "s" : "") + (_.sticky ? "y" : "") + (_.unicode ? "u" : ""));
    var Wm = (e)=>(_)=>(r)=>{
                if (_ === 10) return {
                    index: e.index + 1 | 0,
                    line: e.line + 1 | 0,
                    column: 1
                };
                if (_ === 13) {
                    let t = Mp(0)(r);
                    return t.tag === "Just" ? t._1 === 10 ? {
                        index: e.index + 1 | 0,
                        line: e.line,
                        column: e.column
                    } : {
                        index: e.index + 1 | 0,
                        line: e.line + 1 | 0,
                        column: 1
                    } : {
                        index: e.index + 1 | 0,
                        line: e.line + 1 | 0,
                        column: 1
                    };
                }
                return _ === 9 ? {
                    index: e.index + 1 | 0,
                    line: e.line,
                    column: (e.column + 8 | 0) - wt(e.column - 1 | 0)(8) | 0
                } : {
                    index: e.index + 1 | 0,
                    line: e.line,
                    column: e.column + 1 | 0
                };
            }, zF = (e)=>(_)=>(r)=>{
                let t = e, n = _, s = r, c = !0, i;
                for(; c;){
                    let d = t, v = n, b = s, p = L0(v);
                    if (p.tag === "Nothing") {
                        c = !1, i = d;
                        continue;
                    }
                    if (p.tag === "Just") {
                        t = p._1.tail === "" ? Wm(d)(p._1.head)(b) : Wm(d)(p._1.head)(p._1.tail), n = p._1.tail, s = b;
                        continue;
                    }
                    l();
                }
                return i;
            };
    var v3 = (e)=>(_, r, t, n, s)=>{
            let c = L0(_._1);
            if (c.tag === "Nothing") return n(_, os("Unexpected EOF", _._2));
            if (c.tag === "Just") {
                if (c._1.head < 0 || c._1.head > 65535) return n(_, os("Expected Char", _._2));
                let i = (()=>{
                    if (c._1.head >= 0 && c._1.head <= 65535) return cl(c._1.head);
                    l();
                })();
                return e(i) ? s(rs(c._1.tail, Wm(_._2)(c._1.head)(c._1.tail), !0), i) : n(_, os("Predicate unsatisfied", _._2));
            }
            l();
        };
    var u3 = (e, _, r, t, n)=>e._1 === "" ? n(rs(e._1, e._2, !0), void 0) : t(e, os("Expected EOF", e._2)), g3 = (e)=>(_, r, t, n, s)=>{
            let c = e(_._1);
            if (c.tag === "Left") return n(_, os(c._1, _._2));
            if (c.tag === "Right") return s(rs(c._1.remainder, zF(_._2)(c._1.consumed)(c._1.remainder), c._1.consumed !== ""), c._1.value);
            l();
        };
    var s0 = (e)=>g3((_)=>{
            let r = _7(e)(_);
            return r.tag === "Just" ? S("Right", {
                value: e,
                consumed: e,
                remainder: r._1
            }) : S("Left", "Expected " + Se(e));
        });
    var S1 = (e)=>Jm(v3((_)=>_ === e))(Cv(e));
    var OF = (e)=>"(line " + __(e.line) + ", col " + __(e.column) + ")", UF = (e)=>e._1 + " " + OF(e._2), b3 = (e)=>(_)=>fe.bimap(UF)(re)(c3(_)((r, t, n, s, c)=>t((i)=>t((d)=>e(r, t, n, s, (v, b)=>t((p)=>t((u)=>u3(v, t, n, s, (m, z)=>t((L)=>c(m, b)))))))))), x1 = (e)=>(_)=>{
            let r = qm(_);
            return (t)=>(n)=>(s)=>r(e.map((c)=>{
                            let i = c._2, d = n(c._1);
                            return (v, b, p, u, m)=>b((z)=>d(v, b, p, u, (L, J)=>b((c_)=>m(L, i))));
                        })(s));
        };
    var f3 = {
        mempty: void 0,
        Semigroup0: ()=>a7
    }, Hm = {
        mempty: "",
        Semigroup0: ()=>Kv
    };
    var jm = {
        global: !1,
        ignoreCase: !1,
        multiline: !1,
        dotAll: !1,
        sticky: !1,
        unicode: !1
    };
    var Km = {
        global: !0,
        ignoreCase: !1,
        multiline: !1,
        dotAll: !1,
        sticky: !1,
        unicode: !1
    };
    var WF = x1(Nt)(eo);
    var T1 = (e)=>$n(WF(e)(S1)([
            E("0", 0),
            E("1", 1),
            E("2", 2),
            E("3", 3),
            E("4", 4),
            E("5", 5),
            E("6", 6),
            E("7", 7),
            E("8", 8),
            E("9", 9)
        ]));
    var Co = (e, _)=>({
            tag: e,
            _1: _
        }), k3 = (e)=>({
            tag: e
        }), S3 = (()=>Hi(F_).bind)(), jF = Yi(_n)(eo), yn = (()=>Ro.foldMap(Hm))(), nd = x1(Nt)(eo), KF = (e)=>-e, QF = (e)=>e, y3 = Ep(od)(ed), yo = {
        Applicative0: ()=>_d(yt),
        Bind1: ()=>qa(yt)
    }, To = (()=>{
        let e = qa(yt).Apply0().Functor0().map;
        return (_)=>(r, t, n, s, c)=>n(e((i)=>(d)=>c(r, i))(_));
    })(), Go = e3(yt), ja = (e)=>(_)=>(r)=>ht.apply((()=>{
                    let t = e(r);
                    if (t.tag === "Left") return S("Left", t._1);
                    if (t.tag === "Right") return S("Right", (n)=>{});
                    l();
                })())(_(r)), YF = s3(_3(Pv)), XF = (()=>Ro.foldMap(r3(f3)))(), D3 = k3("AM"), w3 = k3("PM"), Ka = Co("YearFull");
    var I3 = Co("MonthShort"), ss = Co("MonthTwoDigits"), cs = Co("DayOfMonthTwoDigits");
    var x3 = Co("DayOfWeekNameShort"), G1 = Co("Hours24");
    var C1 = Co("MinutesTwoDigits");
    var hn = (e)=>(_)=>S3(I_)((r)=>{
                let t = r.num < e || r.num > _ ? S("Left", "Number is out of range [ " + __(e) + ", " + __(_) + " ]") : S("Right", void 0);
                return (n)=>t;
            }), ZF = (e)=>e.hour.tag === "Just" ? e.hour._1 === 24 ? jF([
            e.minute,
            e.second,
            e.millisecond
        ])((_)=>(()=>{
                if (_.tag === "Nothing") return !1;
                if (_.tag === "Just") return _._1 > 0;
                l();
            })() ? S("Left", "When hour is 24, other time components must be 0") : S("Right", void 0)) : S("Right", void 0) : S("Right", void 0), E3 = (e)=>{
        let _ = e.Applicative0(), r = _.Apply0().apply, t = e.Plus1().Alt0().Functor0().map;
        return (n)=>(s)=>(c)=>s === 0 ? _.pure(y_) : r(t(no)(c))(n.defer((i)=>_M(e)(n)(s - 1 | 0)(c)));
    }, _M = (e)=>{
        let _ = e.Applicative0().pure, r = e.Plus1().Alt0().alt;
        return (t)=>(n)=>(s)=>n === 0 ? _(y_) : r(E3(e)(t)(n)(s))(_(y_));
    }, eM = E3(od)(ed);
    var oM = (e)=>nd(e)((_)=>$n(s0(_)))([
            E("Jan", es),
            E("Feb", i1),
            E("Mar", l1),
            E("Apr", d1),
            E("May", v1),
            E("Jun", u1),
            E("Jul", g1),
            E("Aug", b1),
            E("Sep", p1),
            E("Oct", f1),
            E("Nov", m1),
            E("Dec", n0)
        ]), rM = oM(yo), tM = (e)=>nd(e)((_)=>$n(s0(_)))([
            E("January", es),
            E("February", i1),
            E("March", l1),
            E("April", d1),
            E("May", v1),
            E("June", u1),
            E("July", g1),
            E("August", b1),
            E("September", p1),
            E("October", f1),
            E("November", m1),
            E("December", n0)
        ]), nM = tM(yo), sM = (e)=>nd(e)((_)=>$n(s0(_)))([
            E("am", D3),
            E("AM", D3),
            E("pm", w3),
            E("PM", w3)
        ]), cM = sM(yo), Zr = (e)=>(_)=>(r)=>(t)=>{
                    let n = eM(_)(T1(e));
                    return (s, c, i, d, v)=>c((b)=>n(s, c, i, d, (p, u)=>c((m)=>{
                                    let z = (()=>((c_)=>(t_)=>{
                                                let W = c_, a_ = t_, Q = !0, F;
                                                for(; Q;){
                                                    let y = W, w = a_;
                                                    if (w.tag === "Nil") {
                                                        Q = !1, F = y;
                                                        continue;
                                                    }
                                                    if (w.tag === "Cons") {
                                                        W = (y * 10 | 0) + w._1 | 0, a_ = w._2;
                                                        continue;
                                                    }
                                                    l();
                                                }
                                                return F;
                                            })(0)(u))(), L = r({
                                        length: (()=>((c_)=>(t_)=>{
                                                    let W = c_, a_ = t_, Q = !0, F;
                                                    for(; Q;){
                                                        let y = W, w = a_;
                                                        if (w.tag === "Nil") {
                                                            Q = !1, F = y;
                                                            continue;
                                                        }
                                                        if (w.tag === "Cons") {
                                                            W = y + 1 | 0, a_ = w._2;
                                                            continue;
                                                        }
                                                        l();
                                                    }
                                                    return F;
                                                })(0)(u))(),
                                        num: z,
                                        maxLength: _
                                    });
                                    if (L.tag === "Left") return mn(t + "(" + L._1 + ")")(p, c, i, d, v);
                                    if (L.tag === "Right") return v(p, z);
                                    l();
                                })));
                }, R3 = (e)=>(_)=>(r)=>(t)=>(n, s, c, i, d)=>s((v)=>s((b)=>Vm(S1("-"))(n, s, c, i, (p, u)=>s((m)=>{
                                        let z = (()=>{
                                            if (u.tag === "Nothing") return !1;
                                            if (u.tag === "Just") return !0;
                                            l();
                                        })();
                                        return s((L)=>{
                                            let J = z ? KF : QF, c_ = Zr(e)(_)(r)(t);
                                            return s((t_)=>c_(p, s, c, i, (W, a_)=>s((Q)=>d(W, J(a_)))));
                                        });
                                    })))), aM = (e)=>nd(e)((_)=>$n(s0(_)))([
            E("Mon", jl),
            E("Tue", t1),
            E("Wed", n1),
            E("Thu", s1),
            E("Fri", c1),
            E("Sat", a1),
            E("Sun", Kl)
        ]), iM = aM(yo), lM = (e)=>nd(e)((_)=>$n(s0(_)))([
            E("Monday", jl),
            E("Tuesday", t1),
            E("Wednesday", n1),
            E("Thursday", s1),
            E("Friday", c1),
            E("Saturday", a1),
            E("Sunday", Kl)
        ]), dM = lM(yo), ns = (e)=>e < 0 ? "-" + ns(-e) : e < 10 ? "0" + __(e) : __(e), T3 = (e)=>e < 0 ? "-" + T3(-e) : e < 10 ? "000" + __(e) : e < 100 ? "00" + __(e) : e < 1e3 ? "0" + __(e) : __(e), G3 = (e)=>e < 0 ? "-" + G3(-e) : e < 10 ? "00" + __(e) : e < 100 ? "0" + __(e) : __(e), vM = {
        year: D,
        month: D,
        day: D,
        hour: D,
        minute: D,
        second: D,
        millisecond: D,
        meridiem: D
    };
    var uM = (e)=>{
        let _ = __(e >= 0 ? e : -e), r = il(_).length;
        return r === 1 ? "0" + _ : r === 2 ? _ : it(Vr(z0(r - 2 | 0)(_)))(_);
    };
    var Dn = (e)=>{
        let _ = e._1, r = e._2;
        return (t)=>{
            if (t.tag === "YearFull") return T3(_._1);
            if (t.tag === "YearTwoDigits") return uM(_._1);
            if (t.tag === "YearAbsolute") return __(_._1);
            if (t.tag === "MonthFull") {
                if (_._2.tag === "January") return "January";
                if (_._2.tag === "February") return "February";
                if (_._2.tag === "March") return "March";
                if (_._2.tag === "April") return "April";
                if (_._2.tag === "May") return "May";
                if (_._2.tag === "June") return "June";
                if (_._2.tag === "July") return "July";
                if (_._2.tag === "August") return "August";
                if (_._2.tag === "September") return "September";
                if (_._2.tag === "October") return "October";
                if (_._2.tag === "November") return "November";
                if (_._2.tag === "December") return "December";
                l();
            }
            if (t.tag === "MonthShort") {
                if (_._2.tag === "January") return "Jan";
                if (_._2.tag === "February") return "Feb";
                if (_._2.tag === "March") return "Mar";
                if (_._2.tag === "April") return "Apr";
                if (_._2.tag === "May") return "May";
                if (_._2.tag === "June") return "Jun";
                if (_._2.tag === "July") return "Jul";
                if (_._2.tag === "August") return "Aug";
                if (_._2.tag === "September") return "Sep";
                if (_._2.tag === "October") return "Oct";
                if (_._2.tag === "November") return "Nov";
                if (_._2.tag === "December") return "Dec";
                l();
            }
            if (t.tag === "MonthTwoDigits") return ns((()=>{
                if (_._2.tag === "January") return 1;
                if (_._2.tag === "February") return 2;
                if (_._2.tag === "March") return 3;
                if (_._2.tag === "April") return 4;
                if (_._2.tag === "May") return 5;
                if (_._2.tag === "June") return 6;
                if (_._2.tag === "July") return 7;
                if (_._2.tag === "August") return 8;
                if (_._2.tag === "September") return 9;
                if (_._2.tag === "October") return 10;
                if (_._2.tag === "November") return 11;
                if (_._2.tag === "December") return 12;
                l();
            })());
            if (t.tag === "DayOfMonthTwoDigits") return ns(_._3);
            if (t.tag === "DayOfMonth") return __(_._3);
            if (t.tag === "UnixTimestamp") return __(at(Jr(w1(e) / 1e3)));
            if (t.tag === "DayOfWeek") return __((()=>{
                let n = Ua(_);
                if (n.tag === "Monday") return 1;
                if (n.tag === "Tuesday") return 2;
                if (n.tag === "Wednesday") return 3;
                if (n.tag === "Thursday") return 4;
                if (n.tag === "Friday") return 5;
                if (n.tag === "Saturday") return 6;
                if (n.tag === "Sunday") return 7;
                l();
            })());
            if (t.tag === "DayOfWeekName") {
                let n = Ua(_);
                if (n.tag === "Monday") return "Monday";
                if (n.tag === "Tuesday") return "Tuesday";
                if (n.tag === "Wednesday") return "Wednesday";
                if (n.tag === "Thursday") return "Thursday";
                if (n.tag === "Friday") return "Friday";
                if (n.tag === "Saturday") return "Saturday";
                if (n.tag === "Sunday") return "Sunday";
                l();
            }
            if (t.tag === "DayOfWeekNameShort") return z0(3)((()=>{
                let n = Ua(_);
                if (n.tag === "Monday") return "Monday";
                if (n.tag === "Tuesday") return "Tuesday";
                if (n.tag === "Wednesday") return "Wednesday";
                if (n.tag === "Thursday") return "Thursday";
                if (n.tag === "Friday") return "Friday";
                if (n.tag === "Saturday") return "Saturday";
                if (n.tag === "Sunday") return "Sunday";
                l();
            })());
            if (t.tag === "Hours24") return ns(r._1);
            if (t.tag === "Hours12") return ns((()=>{
                let n = wt(r._1)(12);
                return n === 0 ? 12 : n;
            })());
            if (t.tag === "Meridiem") return r._1 >= 12 ? "PM" : "AM";
            if (t.tag === "Minutes") return __(r._2);
            if (t.tag === "MinutesTwoDigits") return ns(r._2);
            if (t.tag === "Seconds") return __(r._3);
            if (t.tag === "SecondsTwoDigits") return ns(r._3);
            if (t.tag === "Milliseconds") return G3(r._4);
            if (t.tag === "MillisecondsShort") return __(M0(r._4)(100));
            if (t.tag === "MillisecondsTwoDigits") return ns(M0(r._4)(10));
            if (t.tag === "Placeholder") return t._1;
            l();
        };
    };
    var Bt = S3(I_)((e)=>{
        let _ = e.maxLength !== e.length ? S("Left", "Expected " + __(e.maxLength) + " digits but got " + __(e.length)) : S("Right", void 0);
        return (r)=>_;
    }), gM = (e)=>{
        if (e.tag === "YearFull") return (_, r, t, n, s)=>r((c)=>R3(yo)(4)(Bt)("Incorrect full year")(_, r, t, n, (i, d)=>r((v)=>To(Go.state((b)=>E(void 0, {
                                year: R("Just", d),
                                day: b.day,
                                hour: b.hour,
                                meridiem: b.meridiem,
                                millisecond: b.millisecond,
                                minute: b.minute,
                                month: b.month,
                                second: b.second
                            })))(i, r, t, n, s))));
        if (e.tag === "YearTwoDigits") return (_, r, t, n, s)=>r((c)=>R3(yo)(2)(Bt)("Incorrect 2-digit year")(_, r, t, n, (i, d)=>r((v)=>To(Go.state((b)=>E(void 0, {
                                year: R("Just", d),
                                day: b.day,
                                hour: b.hour,
                                meridiem: b.meridiem,
                                millisecond: b.millisecond,
                                minute: b.minute,
                                month: b.month,
                                second: b.second
                            })))(i, r, t, n, s))));
        if (e.tag === "YearAbsolute") {
            let _ = k1(1)($n((t, n, s, c, i)=>n((d)=>s0("-")(t, n, s, c, (v, b)=>n((p)=>i(v, -1)))))), r = y3(T1(yo));
            return (t, n, s, c, i)=>n((d)=>n((v)=>n((b)=>_(t, n, s, c, (p, u)=>n((m)=>n((z)=>n((L)=>r(p, n, s, c, (J, c_)=>n((t_)=>{
                                                    let W = (()=>((Q)=>(F)=>{
                                                                let y = Q, w = F, x = !0, T;
                                                                for(; x;){
                                                                    let C = y, A = w;
                                                                    if (A.tag === "Nil") {
                                                                        x = !1, T = C;
                                                                        continue;
                                                                    }
                                                                    if (A.tag === "Cons") {
                                                                        y = (C * 10 | 0) + A._1 | 0, w = A._2;
                                                                        continue;
                                                                    }
                                                                    l();
                                                                }
                                                                return T;
                                                            })(0)(c_))();
                                                    return n((a_)=>{
                                                        let Q = u * W | 0;
                                                        return n((F)=>To(Go.state((y)=>E(void 0, {
                                                                    year: R("Just", Q),
                                                                    day: y.day,
                                                                    hour: y.hour,
                                                                    meridiem: y.meridiem,
                                                                    millisecond: y.millisecond,
                                                                    minute: y.minute,
                                                                    month: y.month,
                                                                    second: y.second
                                                                })))(J, n, s, c, i));
                                                    });
                                                })))))))));
        }
        if (e.tag === "MonthFull") return (_, r, t, n, s)=>r((c)=>r((i)=>nM(_, r, t, n, (d, v)=>r((b)=>{
                            let p = (()=>{
                                if (v.tag === "January") return 1;
                                if (v.tag === "February") return 2;
                                if (v.tag === "March") return 3;
                                if (v.tag === "April") return 4;
                                if (v.tag === "May") return 5;
                                if (v.tag === "June") return 6;
                                if (v.tag === "July") return 7;
                                if (v.tag === "August") return 8;
                                if (v.tag === "September") return 9;
                                if (v.tag === "October") return 10;
                                if (v.tag === "November") return 11;
                                if (v.tag === "December") return 12;
                                l();
                            })();
                            return r((u)=>To(Go.state((m)=>E(void 0, {
                                        month: R("Just", p),
                                        day: m.day,
                                        hour: m.hour,
                                        meridiem: m.meridiem,
                                        millisecond: m.millisecond,
                                        minute: m.minute,
                                        second: m.second,
                                        year: m.year
                                    })))(d, r, t, n, s));
                        }))));
        if (e.tag === "MonthShort") return (_, r, t, n, s)=>r((c)=>r((i)=>rM(_, r, t, n, (d, v)=>r((b)=>{
                            let p = (()=>{
                                if (v.tag === "January") return 1;
                                if (v.tag === "February") return 2;
                                if (v.tag === "March") return 3;
                                if (v.tag === "April") return 4;
                                if (v.tag === "May") return 5;
                                if (v.tag === "June") return 6;
                                if (v.tag === "July") return 7;
                                if (v.tag === "August") return 8;
                                if (v.tag === "September") return 9;
                                if (v.tag === "October") return 10;
                                if (v.tag === "November") return 11;
                                if (v.tag === "December") return 12;
                                l();
                            })();
                            return r((u)=>To(Go.state((m)=>E(void 0, {
                                        month: R("Just", p),
                                        day: m.day,
                                        hour: m.hour,
                                        meridiem: m.meridiem,
                                        millisecond: m.millisecond,
                                        minute: m.minute,
                                        second: m.second,
                                        year: m.year
                                    })))(d, r, t, n, s));
                        }))));
        if (e.tag === "MonthTwoDigits") {
            let _ = Zr(yo)(2)(ja(hn(1)(12))(Bt))("Incorrect 2-digit month");
            return (r, t, n, s, c)=>t((i)=>_(r, t, n, s, (d, v)=>t((b)=>To(Go.state((p)=>E(void 0, {
                                    month: R("Just", v),
                                    day: p.day,
                                    hour: p.hour,
                                    meridiem: p.meridiem,
                                    millisecond: p.millisecond,
                                    minute: p.minute,
                                    second: p.second,
                                    year: p.year
                                })))(d, t, n, s, c))));
        }
        if (e.tag === "DayOfMonthTwoDigits") {
            let _ = Zr(yo)(2)(ja(hn(1)(31))(Bt))("Incorrect day of month");
            return (r, t, n, s, c)=>t((i)=>_(r, t, n, s, (d, v)=>t((b)=>To(Go.state((p)=>E(void 0, {
                                    day: R("Just", v),
                                    hour: p.hour,
                                    meridiem: p.meridiem,
                                    millisecond: p.millisecond,
                                    minute: p.minute,
                                    month: p.month,
                                    second: p.second,
                                    year: p.year
                                })))(d, t, n, s, c))));
        }
        if (e.tag === "DayOfMonth") {
            let _ = Zr(yo)(2)(hn(1)(31))("Incorrect day of month");
            return (r, t, n, s, c)=>t((i)=>_(r, t, n, s, (d, v)=>t((b)=>To(Go.state((p)=>E(void 0, {
                                    day: R("Just", v),
                                    hour: p.hour,
                                    meridiem: p.meridiem,
                                    millisecond: p.millisecond,
                                    minute: p.minute,
                                    month: p.month,
                                    second: p.second,
                                    year: p.year
                                })))(d, t, n, s, c))));
        }
        if (e.tag === "UnixTimestamp") {
            let _ = y3(T1(yo));
            return (r, t, n, s, c)=>t((i)=>t((d)=>_(r, t, n, s, (v, b)=>t((p)=>{
                                let u = (()=>((z)=>(L)=>{
                                            let J = z, c_ = L, t_ = !0, W;
                                            for(; t_;){
                                                let a_ = J, Q = c_;
                                                if (Q.tag === "Nil") {
                                                    t_ = !1, W = a_;
                                                    continue;
                                                }
                                                if (Q.tag === "Cons") {
                                                    J = (a_ * 10 | 0) + Q._1 | 0, c_ = Q._2;
                                                    continue;
                                                }
                                                l();
                                            }
                                            return W;
                                        })(0)(b))();
                                return t((m)=>{
                                    let z = 1e3 * Pe(u), L = z >= -8639977881600000 && z <= 8639977881599999 ? R("Just", z) : D;
                                    return L.tag === "Just" ? To((()=>{
                                        let J = {
                                            year: R("Just", qe(L._1)._1._1),
                                            month: R("Just", (()=>{
                                                if (qe(L._1)._1._2.tag === "January") return 1;
                                                if (qe(L._1)._1._2.tag === "February") return 2;
                                                if (qe(L._1)._1._2.tag === "March") return 3;
                                                if (qe(L._1)._1._2.tag === "April") return 4;
                                                if (qe(L._1)._1._2.tag === "May") return 5;
                                                if (qe(L._1)._1._2.tag === "June") return 6;
                                                if (qe(L._1)._1._2.tag === "July") return 7;
                                                if (qe(L._1)._1._2.tag === "August") return 8;
                                                if (qe(L._1)._1._2.tag === "September") return 9;
                                                if (qe(L._1)._1._2.tag === "October") return 10;
                                                if (qe(L._1)._1._2.tag === "November") return 11;
                                                if (qe(L._1)._1._2.tag === "December") return 12;
                                                l();
                                            })()),
                                            day: R("Just", qe(L._1)._1._3),
                                            hour: R("Just", qe(L._1)._2._1),
                                            minute: R("Just", qe(L._1)._2._2),
                                            second: R("Just", qe(L._1)._2._3),
                                            millisecond: R("Just", qe(L._1)._2._4),
                                            meridiem: D
                                        };
                                        return Go.state((c_)=>E(void 0, J));
                                    })())(v, t, n, s, c) : mn("Incorrect timestamp")(v, t, n, s, c);
                                });
                            }))));
        }
        if (e.tag === "DayOfWeek") {
            let _ = Zr(yo)(1)(hn(1)(7))("Incorrect day of week");
            return (r, t, n, s, c)=>t((i)=>_(r, t, n, s, (d, v)=>t((b)=>c(d, void 0))));
        }
        if (e.tag === "DayOfWeekName") return (_, r, t, n, s)=>r((c)=>r((i)=>dM(_, r, t, n, (d, v)=>r((b)=>{
                            let p = (()=>{
                                if (v.tag === "Monday") return 1;
                                if (v.tag === "Tuesday") return 2;
                                if (v.tag === "Wednesday") return 3;
                                if (v.tag === "Thursday") return 4;
                                if (v.tag === "Friday") return 5;
                                if (v.tag === "Saturday") return 6;
                                if (v.tag === "Sunday") return 7;
                                l();
                            })();
                            return r((u)=>To(Go.state((m)=>E(void 0, {
                                        day: R("Just", p),
                                        hour: m.hour,
                                        meridiem: m.meridiem,
                                        millisecond: m.millisecond,
                                        minute: m.minute,
                                        month: m.month,
                                        second: m.second,
                                        year: m.year
                                    })))(d, r, t, n, s));
                        }))));
        if (e.tag === "DayOfWeekNameShort") return (_, r, t, n, s)=>r((c)=>r((i)=>iM(_, r, t, n, (d, v)=>r((b)=>{
                            let p = (()=>{
                                if (v.tag === "Monday") return 1;
                                if (v.tag === "Tuesday") return 2;
                                if (v.tag === "Wednesday") return 3;
                                if (v.tag === "Thursday") return 4;
                                if (v.tag === "Friday") return 5;
                                if (v.tag === "Saturday") return 6;
                                if (v.tag === "Sunday") return 7;
                                l();
                            })();
                            return r((u)=>To(Go.state((m)=>E(void 0, {
                                        day: R("Just", p),
                                        hour: m.hour,
                                        meridiem: m.meridiem,
                                        millisecond: m.millisecond,
                                        minute: m.minute,
                                        month: m.month,
                                        second: m.second,
                                        year: m.year
                                    })))(d, r, t, n, s));
                        }))));
        if (e.tag === "Hours24") {
            let _ = Zr(yo)(2)(ja(hn(0)(24))(Bt))("Incorrect 24 hour");
            return (r, t, n, s, c)=>t((i)=>_(r, t, n, s, (d, v)=>t((b)=>To(Go.state((p)=>E(void 0, {
                                    hour: R("Just", v),
                                    day: p.day,
                                    meridiem: p.meridiem,
                                    millisecond: p.millisecond,
                                    minute: p.minute,
                                    month: p.month,
                                    second: p.second,
                                    year: p.year
                                })))(d, t, n, s, c))));
        }
        if (e.tag === "Hours12") {
            let _ = Zr(yo)(2)(ja(hn(0)(12))(Bt))("Incorrect 12 hour");
            return (r, t, n, s, c)=>t((i)=>_(r, t, n, s, (d, v)=>t((b)=>To(Go.state((p)=>E(void 0, {
                                    hour: R("Just", v),
                                    day: p.day,
                                    meridiem: p.meridiem,
                                    millisecond: p.millisecond,
                                    minute: p.minute,
                                    month: p.month,
                                    second: p.second,
                                    year: p.year
                                })))(d, t, n, s, c))));
        }
        if (e.tag === "Meridiem") return (_, r, t, n, s)=>r((c)=>cM(_, r, t, n, (i, d)=>r((v)=>To(Go.state((b)=>E(void 0, {
                                meridiem: R("Just", d),
                                day: b.day,
                                hour: b.hour,
                                millisecond: b.millisecond,
                                minute: b.minute,
                                month: b.month,
                                second: b.second,
                                year: b.year
                            })))(i, r, t, n, s))));
        if (e.tag === "MinutesTwoDigits") {
            let _ = Zr(yo)(2)(ja(hn(0)(59))(Bt))("Incorrect 2-digit minute");
            return (r, t, n, s, c)=>t((i)=>_(r, t, n, s, (d, v)=>t((b)=>To(Go.state((p)=>E(void 0, {
                                    minute: R("Just", v),
                                    day: p.day,
                                    hour: p.hour,
                                    meridiem: p.meridiem,
                                    millisecond: p.millisecond,
                                    month: p.month,
                                    second: p.second,
                                    year: p.year
                                })))(d, t, n, s, c))));
        }
        if (e.tag === "Minutes") {
            let _ = Zr(yo)(2)(hn(0)(59))("Incorrect minute");
            return (r, t, n, s, c)=>t((i)=>_(r, t, n, s, (d, v)=>t((b)=>To(Go.state((p)=>E(void 0, {
                                    minute: R("Just", v),
                                    day: p.day,
                                    hour: p.hour,
                                    meridiem: p.meridiem,
                                    millisecond: p.millisecond,
                                    month: p.month,
                                    second: p.second,
                                    year: p.year
                                })))(d, t, n, s, c))));
        }
        if (e.tag === "SecondsTwoDigits") {
            let _ = Zr(yo)(2)(ja(hn(0)(59))(Bt))("Incorrect 2-digit second");
            return (r, t, n, s, c)=>t((i)=>_(r, t, n, s, (d, v)=>t((b)=>To(Go.state((p)=>E(void 0, {
                                    second: R("Just", v),
                                    day: p.day,
                                    hour: p.hour,
                                    meridiem: p.meridiem,
                                    millisecond: p.millisecond,
                                    minute: p.minute,
                                    month: p.month,
                                    year: p.year
                                })))(d, t, n, s, c))));
        }
        if (e.tag === "Seconds") {
            let _ = Zr(yo)(2)(hn(0)(59))("Incorrect second");
            return (r, t, n, s, c)=>t((i)=>_(r, t, n, s, (d, v)=>t((b)=>To(Go.state((p)=>E(void 0, {
                                    second: R("Just", v),
                                    day: p.day,
                                    hour: p.hour,
                                    meridiem: p.meridiem,
                                    millisecond: p.millisecond,
                                    minute: p.minute,
                                    month: p.month,
                                    year: p.year
                                })))(d, t, n, s, c))));
        }
        if (e.tag === "Milliseconds") {
            let _ = Zr(yo)(3)(Bt)("Incorrect millisecond");
            return (r, t, n, s, c)=>t((i)=>_(r, t, n, s, (d, v)=>t((b)=>To(Go.state((p)=>E(void 0, {
                                    millisecond: R("Just", v),
                                    day: p.day,
                                    hour: p.hour,
                                    meridiem: p.meridiem,
                                    minute: p.minute,
                                    month: p.month,
                                    second: p.second,
                                    year: p.year
                                })))(d, t, n, s, c))));
        }
        if (e.tag === "Placeholder") return (_, r, t, n, s)=>r((c)=>s0(e._1)(_, r, t, n, (i, d)=>r((v)=>s(i, void 0))));
        if (e.tag === "MillisecondsShort") {
            let _ = Zr(yo)(1)(Bt)("Incorrect 1-digit millisecond");
            return (r, t, n, s, c)=>t((i)=>t((d)=>_(r, t, n, s, (v, b)=>t((p)=>{
                                let u = b * 100 | 0;
                                return t((m)=>To(Go.state((z)=>E(void 0, {
                                            millisecond: R("Just", u),
                                            day: z.day,
                                            hour: z.hour,
                                            meridiem: z.meridiem,
                                            minute: z.minute,
                                            month: z.month,
                                            second: z.second,
                                            year: z.year
                                        })))(v, t, n, s, c));
                            }))));
        }
        if (e.tag === "MillisecondsTwoDigits") {
            let _ = Zr(yo)(2)(Bt)("Incorrect 2-digit millisecond");
            return (r, t, n, s, c)=>t((i)=>t((d)=>_(r, t, n, s, (v, b)=>t((p)=>{
                                let u = b * 10 | 0;
                                return t((m)=>To(Go.state((z)=>E(void 0, {
                                            millisecond: R("Just", u),
                                            day: z.day,
                                            hour: z.hour,
                                            meridiem: z.meridiem,
                                            minute: z.minute,
                                            month: z.month,
                                            second: z.second,
                                            year: z.year
                                        })))(v, t, n, s, c));
                            }))));
        }
        l();
    };
    var bM = (e)=>{
        let _ = ZF(e);
        return ht.apply((()=>{
            if (_.tag === "Left") return S("Left", _._1);
            if (_.tag === "Right") return S("Right", Ls);
            l();
        })())(ht.apply((()=>{
            let r = ht.apply(ht.apply((()=>{
                let t = (()=>{
                    if (e.year.tag === "Nothing") return 0;
                    if (e.year.tag === "Just") return e.year._1;
                    l();
                })();
                return t >= -271820 && t <= 275759 ? S("Right", Xl(t)) : S("Left", "Incorrect year");
            })())((()=>{
                let t = Yr.toEnum((()=>{
                    if (e.month.tag === "Nothing") return 1;
                    if (e.month.tag === "Just") return e.month._1;
                    l();
                })());
                if (t.tag === "Nothing") return S("Left", "Incorrect month");
                if (t.tag === "Just") return S("Right", t._1);
                l();
            })()))((()=>{
                let t = (()=>{
                    if (e.day.tag === "Nothing") return 1;
                    if (e.day.tag === "Just") return e.day._1;
                    l();
                })(), n = (()=>e.hour.tag === "Just" && e.hour._1 === 24 ? t + 1 | 0 : t)();
                return n >= 1 && n <= 31 ? S("Right", n) : S("Left", "Incorrect day");
            })());
            if (r.tag === "Left") return S("Left", r._1);
            if (r.tag === "Right") return S("Right", Om(r._1));
            l();
        })())(ht.apply(ht.apply(ht.apply((()=>{
            if (e.hour.tag === "Just") {
                let r = (()=>{
                    if (e.meridiem.tag === "Just") {
                        if (e.hour._1 === 12) {
                            if (e.meridiem._1.tag === "AM") return 0;
                            if (e.meridiem._1.tag === "PM") return 12;
                            l();
                        }
                        if (e.meridiem._1.tag === "PM") return e.hour._1 + 12 | 0;
                        if (e.meridiem._1.tag === "AM") return e.hour._1;
                        l();
                    }
                    if (e.meridiem.tag === "Nothing") return e.hour._1 === 24 ? 0 : e.hour._1;
                    l();
                })();
                return r >= 0 && r <= 23 ? S("Right", Zl(r)) : S("Left", "Incorrect hour");
            }
            return S("Right", Zl(0));
        })())((()=>{
            let r = (()=>{
                if (e.minute.tag === "Nothing") return 0;
                if (e.minute.tag === "Just") return e.minute._1;
                l();
            })();
            return r >= 0 && r <= 59 ? S("Right", r) : S("Left", "Incorrect minute");
        })()))((()=>{
            let r = (()=>{
                if (e.second.tag === "Nothing") return 0;
                if (e.second.tag === "Just") return e.second._1;
                l();
            })();
            return r >= 0 && r <= 59 ? S("Right", r) : S("Left", "Incorrect second");
        })()))((()=>{
            let r = (()=>{
                if (e.millisecond.tag === "Nothing") return 0;
                if (e.millisecond.tag === "Just") return e.millisecond._1;
                l();
            })();
            return r >= 0 && r <= 999 ? S("Right", r) : S("Left", "Incorrect millisecond");
        })())));
    }, pM = (e)=>{
        let _ = YF(e.Bind1().Apply0().Functor0());
        return (r)=>{
            let t = _((()=>{
                let n = e.Applicative0().pure;
                return (s)=>{
                    let c = s(vM);
                    return n(E((()=>{
                        if (c._1._1.tag === "Left") return S("Left", c._1._1._1);
                        if (c._1._1.tag === "Right") return S("Right", c._2);
                        l();
                    })(), c._1._2));
                };
            })())(XF(gM)(r));
            return (n, s, c, i, d)=>s((v)=>t(n, s, c, i, (b, p)=>s((u)=>{
                            let m = bM(p);
                            if (m.tag === "Left") return mn(m._1)(b, s, c, i, d);
                            if (m.tag === "Right") return d(b, m._1);
                            l();
                        })));
        };
    }, C3 = (()=>{
        let e = pM(yt);
        return (_)=>b3(e(_));
    })();
    var sd = Tr(no)(y_);
    var A3 = (e)=>(_)=>{
            let r = at(Jr(e.fromDuration(_) / 6e4)), t = at(Jr(e.fromDuration(_) / 36e5)), n = at(Jr(e.fromDuration(_) / 864e5));
            return {
                days: n,
                hours: t - (n * 24 | 0) | 0,
                minutes: r - (t * 60 | 0) | 0,
                seconds: at(Jr(e.fromDuration(_) / 1e3)) - (r * 60 | 0) | 0
            };
        }, wn = (e)=>{
        let _ = Xi(e, Us, f_, D);
        if (_.tag === "Just") return _._1 >= -8639977881600000 && _._1 <= 8639977881599999 ? R("Just", qe(_._1)) : D;
        if (_.tag === "Nothing") return D;
        l();
    };
    var Qm = (e)=>(_)=>yn(Dn(qe(Va(_))))(sd([
                Ka,
                Co("Placeholder", e),
                ss,
                Co("Placeholder", e),
                cs
            ]));
    var cd = (e)=>yn(Dn(qe(Va(e))))(sd([
            I3
        ]));
    var ad = (e)=>yn(Dn(qe(Va(e))))(sd([
            ss,
            cs
        ]));
    var N1 = (e)=>yn(Dn(qe(Va(e))))(sd([
            x3
        ]));
    var Qa = (e)=>yn(Dn(qe(Va(e))))(sd([
            cs,
            Co("Placeholder", "/"),
            ss
        ]));
    var fM = r1((()=>{
        let e = z_(oo)($r)({
            reflectSymbol: ()=>"title"
        })();
        return {
            encodeJson: (_)=>e.gEncodeJson(_)(q)
        };
    })()), N3 = (e)=>(_)=>(r)=>(t)=>fM(e)("/workYears/" + __(_) + "/remarks")(ad(r))(t);
    var F3 = (e)=>(_)=>(r)=>Jl(e)("/workYears/" + __(_) + "/remarks")(ad(r));
    var F1 = function(e) {
        return function(_) {
            for(var r = _[0], t = _.length, n = 1; n < t; n++)r = e(r)(_[n]);
            return r;
        };
    }, DM = function() {
        function e(c) {
            this.fn = c;
        }
        var _ = {}, r = function(c, i) {
            this.head = c, this.tail = i;
        };
        function t(c) {
            return new r(c, _);
        }
        function n(c) {
            return function(i) {
                return new r(c, i);
            };
        }
        function s(c) {
            for(var i = [], d = c; d !== _;)i.push(d.head), d = d.tail;
            return i;
        }
        return function(c) {
            return function(i) {
                return function(d) {
                    var v = function(p, u) {
                        return c(i(n)(d(p)))(u);
                    }, b = function(p, u, m) {
                        if (u === 0) return p;
                        var z = m[u - 1];
                        return new e(function() {
                            var L = b(v(z, p), u - 1, m);
                            return L;
                        });
                    };
                    return function(p) {
                        for(var u = i(t)(d(p[p.length - 1])), m = b(u, p.length - 1, p); m instanceof e;)m = m.fn();
                        return i(s)(m);
                    };
                };
            };
        };
    }();
    var as = (e)=>e;
    var Ym = {
        encodeJson: (e)=>ad(e)
    };
    var M3 = (e)=>{
        let _ = Wr(e)(e.length - 1 | 0), r = (()=>{
            if (_.tag === "Just") return _._1;
            l();
        })(), t = Wr(e)(0), n = (()=>{
            if (t.tag === "Just") return t._1;
            l();
        })(), s = Xo(Pe(e.length - 1 | 0))(n);
        if (s.tag === "Nothing") return !1;
        if (s.tag === "Just") return (()=>n._2.tag === "January" || n._2.tag === "February" || n._2.tag === "March" || n._2.tag === "April" || n._2.tag === "May" || n._2.tag === "June" || n._2.tag === "July" || n._2.tag === "August" || n._2.tag === "September" || n._2.tag === "October" || n._2.tag === "November" ? !1 : n._2.tag === "December")() && r._2.tag === "January" ? !1 : wr.eq(s._1)(r);
        l();
    }, Xm = (e)=>{
        let _ = Fp(2)(e), r = ct(_.before), t = (()=>{
            if (r.tag === "Just") return Yr.toEnum(r._1);
            if (r.tag === "Nothing") return D;
            l();
        })();
        if (t.tag === "Just") {
            let n = ct(_.after);
            if (n.tag === "Just") {
                if (n._1 >= 1 && n._1 <= 31) {
                    let s = Ba(2025)(t._1)(n._1);
                    if (s.tag === "Just") return R("Just", s._1);
                    if (s.tag === "Nothing") return D;
                    l();
                }
                return D;
            }
            if (n.tag === "Nothing") return D;
            l();
        }
        if (t.tag === "Nothing") return D;
        l();
    };
    var P3 = {
        decodeJson: (e)=>{
            let _ = Q_((t)=>D, (t)=>D, (t)=>D, f_, (t)=>D, (t)=>D, e), r = (()=>{
                if (_.tag === "Just") return Xm(_._1);
                if (_.tag === "Nothing") return D;
                l();
            })();
            if (r.tag === "Nothing") return S("Left", H("TypeMismatch", "Invalid ShortDate"));
            if (r.tag === "Just") return S("Right", r._1);
            l();
        }
    };
    var M1 = (e)=>e, P1 = {
        dimap: (e)=>(_)=>(r)=>(t)=>_(r(e(t)))
    };
    var Zm = (e)=>(_)=>(r)=>{
                let t = r.Profunctor0();
                return (n)=>t.dimap(_)((s)=>{
                        if (s.tag === "Left" || s.tag === "Right") return s._1;
                        l();
                    })(r.right(t.dimap(M1)(e)(n)));
            }, is = (e)=>(_)=>(r)=>Zm(e)((t)=>{
                    let n = _(t);
                    if (n.tag === "Nothing") return S("Left", t);
                    if (n.tag === "Just") return S("Right", n._1);
                    l();
                })(r);
    var dd = (e)=>(_)=>(r)=>{
                let t = r.Profunctor0().dimap;
                return (n)=>t((s)=>E(e(s), (c)=>_(s)(c)))((s)=>s._2(s._1))(r.first(n));
            };
    var z3 = (e)=>()=>(_)=>(r)=>Vo(e.reflectSymbol(_))(r);
    var m_ = (e)=>()=>()=>(_)=>(r)=>dd(z3(e)()(_))((t)=>(n)=>Ur(e.reflectSymbol(_))(n)(t))(r);
    var EM = (e)=>e, O_ = (()=>({
            first: (e)=>(_)=>E(e(_._1), _._2),
            second: Lv.map,
            Profunctor0: ()=>P1
        }))();
    var O3 = (e)=>{
        let _ = e.identity, r = e.Semigroupoid0(), t = e.Semigroupoid0();
        return (n)=>{
            let s = n.Profunctor0().dimap;
            return (c)=>(i)=>r.compose(t.compose(n.second(i))(n.first(c)))(s(EM)((d)=>E(d, d))(_));
        };
    };
    var TM = "firebase", GM = "10.12.3";
    Qr(TM, GM, "app");
    var CM = "type.googleapis.com/google.protobuf.Int64Value", AM = "type.googleapis.com/google.protobuf.UInt64Value";
    function V3(e, _) {
        let r = {};
        for(let t in e)e.hasOwnProperty(t) && (r[t] = _(e[t]));
        return r;
    }
    function e$(e) {
        if (e == null) return null;
        if (e instanceof Number && (e = e.valueOf()), typeof e == "number" && isFinite(e) || e === !0 || e === !1 || Object.prototype.toString.call(e) === "[object String]") return e;
        if (e instanceof Date) return e.toISOString();
        if (Array.isArray(e)) return e.map((_)=>e$(_));
        if (typeof e == "function" || typeof e == "object") return V3(e, (_)=>e$(_));
        throw new Error("Data cannot be encoded in JSON: " + e);
    }
    function L1(e) {
        if (e == null) return e;
        if (e["@type"]) switch(e["@type"]){
            case CM:
            case AM:
                {
                    let _ = Number(e.value);
                    if (isNaN(_)) throw new Error("Data cannot be decoded from JSON: " + e);
                    return _;
                }
            default:
                throw new Error("Data cannot be decoded from JSON: " + e);
        }
        return Array.isArray(e) ? e.map((_)=>L1(_)) : typeof e == "function" || typeof e == "object" ? V3(e, (_)=>L1(_)) : e;
    }
    var n$ = "functions";
    var U3 = {
        OK: "ok",
        CANCELLED: "cancelled",
        UNKNOWN: "unknown",
        INVALID_ARGUMENT: "invalid-argument",
        DEADLINE_EXCEEDED: "deadline-exceeded",
        NOT_FOUND: "not-found",
        ALREADY_EXISTS: "already-exists",
        PERMISSION_DENIED: "permission-denied",
        UNAUTHENTICATED: "unauthenticated",
        RESOURCE_EXHAUSTED: "resource-exhausted",
        FAILED_PRECONDITION: "failed-precondition",
        ABORTED: "aborted",
        OUT_OF_RANGE: "out-of-range",
        UNIMPLEMENTED: "unimplemented",
        INTERNAL: "internal",
        UNAVAILABLE: "unavailable",
        DATA_LOSS: "data-loss"
    }, ls = class extends Nr {
        constructor(_, r, t){
            super(`${n$}/${_}`, r || ""), this.details = t;
        }
    };
    function NM(e) {
        if (e >= 200 && e < 300) return "ok";
        switch(e){
            case 0:
                return "internal";
            case 400:
                return "invalid-argument";
            case 401:
                return "unauthenticated";
            case 403:
                return "permission-denied";
            case 404:
                return "not-found";
            case 409:
                return "aborted";
            case 429:
                return "resource-exhausted";
            case 499:
                return "cancelled";
            case 500:
                return "internal";
            case 501:
                return "unimplemented";
            case 503:
                return "unavailable";
            case 504:
                return "deadline-exceeded";
        }
        return "unknown";
    }
    function FM(e, _) {
        let r = NM(e), t = r, n;
        try {
            let s = _ && _.error;
            if (s) {
                let c = s.status;
                if (typeof c == "string") {
                    if (!U3[c]) return new ls("internal", "internal");
                    r = U3[c], t = c;
                }
                let i = s.message;
                typeof i == "string" && (t = i), n = s.details, n !== void 0 && (n = L1(n));
            }
        } catch  {}
        return r === "ok" ? null : new ls(r, t, n);
    }
    var o$ = class {
        constructor(_, r, t){
            this.auth = null, this.messaging = null, this.appCheck = null, this.auth = _.getImmediate({
                optional: !0
            }), this.messaging = r.getImmediate({
                optional: !0
            }), this.auth || _.get().then((n)=>this.auth = n, ()=>{}), this.messaging || r.get().then((n)=>this.messaging = n, ()=>{}), this.appCheck || t.get().then((n)=>this.appCheck = n, ()=>{});
        }
        async getAuthToken() {
            if (this.auth) try {
                let _ = await this.auth.getToken();
                return _?.accessToken;
            } catch  {
                return;
            }
        }
        async getMessagingToken() {
            if (!(!this.messaging || !("Notification" in self) || Notification.permission !== "granted")) try {
                return await this.messaging.getToken();
            } catch  {
                return;
            }
        }
        async getAppCheckToken(_) {
            if (this.appCheck) {
                let r = _ ? await this.appCheck.getLimitedUseToken() : await this.appCheck.getToken();
                return r.error ? null : r.token;
            }
            return null;
        }
        async getContext(_) {
            let r = await this.getAuthToken(), t = await this.getMessagingToken(), n = await this.getAppCheckToken(_);
            return {
                authToken: r,
                messagingToken: t,
                appCheckToken: n
            };
        }
    };
    var r$ = "us-central1";
    function MM(e) {
        let _ = null;
        return {
            promise: new Promise((r, t)=>{
                _ = setTimeout(()=>{
                    t(new ls("deadline-exceeded", "deadline-exceeded"));
                }, e);
            }),
            cancel: ()=>{
                _ && clearTimeout(_);
            }
        };
    }
    var t$ = class {
        constructor(_, r, t, n, s = r$, c){
            this.app = _, this.fetchImpl = c, this.emulatorOrigin = null, this.contextProvider = new o$(r, t, n), this.cancelAllRequests = new Promise((i)=>{
                this.deleteService = ()=>Promise.resolve(i());
            });
            try {
                let i = new URL(s);
                this.customDomain = i.origin, this.region = r$;
            } catch  {
                this.customDomain = null, this.region = s;
            }
        }
        _delete() {
            return this.deleteService();
        }
        _url(_) {
            let r = this.app.options.projectId;
            return this.emulatorOrigin !== null ? `${this.emulatorOrigin}/${r}/${this.region}/${_}` : this.customDomain !== null ? `${this.customDomain}/${_}` : `https://${this.region}-${r}.cloudfunctions.net/${_}`;
        }
    };
    function PM(e, _, r) {
        e.emulatorOrigin = `http://${_}:${r}`;
    }
    function LM(e, _, r) {
        return (t)=>OM(e, _, t, r || {});
    }
    async function zM(e, _, r, t) {
        r["Content-Type"] = "application/json";
        let n;
        try {
            n = await t(e, {
                method: "POST",
                body: JSON.stringify(_),
                headers: r
            });
        } catch  {
            return {
                status: 0,
                json: null
            };
        }
        let s = null;
        try {
            s = await n.json();
        } catch  {}
        return {
            status: n.status,
            json: s
        };
    }
    function OM(e, _, r, t) {
        let n = e._url(_);
        return UM(e, n, r, t);
    }
    async function UM(e, _, r, t) {
        r = e$(r);
        let n = {
            data: r
        }, s = {}, c = await e.contextProvider.getContext(t.limitedUseAppCheckTokens);
        c.authToken && (s.Authorization = "Bearer " + c.authToken), c.messagingToken && (s["Firebase-Instance-ID-Token"] = c.messagingToken), c.appCheckToken !== null && (s["X-Firebase-AppCheck"] = c.appCheckToken);
        let i = t.timeout || 7e4, d = MM(i), v = await Promise.race([
            zM(_, n, s, e.fetchImpl),
            d.promise,
            e.cancelAllRequests
        ]);
        if (d.cancel(), !v) throw new ls("cancelled", "Firebase Functions instance was deleted.");
        let b = FM(v.status, v.json);
        if (b) throw b;
        if (!v.json) throw new ls("internal", "Response is not valid JSON object.");
        let p = v.json.data;
        if (typeof p > "u" && (p = v.json.result), typeof p > "u") throw new ls("internal", "Response is missing data field.");
        return {
            data: L1(p)
        };
    }
    var B3 = "@firebase/functions", J3 = "0.11.6";
    var BM = "auth-internal", JM = "app-check-internal", VM = "messaging-internal";
    function qM(e, _) {
        let r = (t, { instanceIdentifier: n  })=>{
            let s = t.getProvider("app").getImmediate(), c = t.getProvider(BM), i = t.getProvider(VM), d = t.getProvider(JM);
            return new t$(s, c, i, d, n, e);
        };
        an(new Kr(n$, r, "PUBLIC").setMultipleInstances(!0)), Qr(B3, J3, _), Qr(B3, J3, "esm2017");
    }
    function z1(e = W0(), _ = r$) {
        let t = Ys(mo(e), n$).getImmediate({
            identifier: _
        }), n = su("functions");
        return n && s$(t, ...n), t;
    }
    function s$(e, _, r) {
        PM(mo(e), _, r);
    }
    function q3(e, _, r) {
        return LM(mo(e), _, r);
    }
    qM(fetch.bind(self));
    var W3 = (e)=>function() {
            return gc("createUser")(e).then((r)=>r.data).catch((r)=>{
                throw new Error(r.message);
            });
        }, H3 = (e)=>function() {
            return gc("editUser")(e).then((r)=>r.data).catch((r)=>{
                throw new Error(r.message);
            });
        }, j3 = (e)=>function() {
            return gc("deleteUser")(e).then((r)=>r.data).catch((r)=>{
                throw new Error(r.message);
            });
        }, vd = (e)=>function() {
            return gc("forgotPassword")({
                email: e
            }).then((r)=>r.data).catch((r)=>{
                throw new Error(r.message);
            });
        }, ud = (e)=>(_)=>function() {
                return gc("resetPassword")({
                    token: e,
                    password: _
                }).then((t)=>t.data).catch((t)=>{
                    throw new Error(t.message);
                });
            }, K3 = (e)=>function() {
            return gc("bookSlot")(e).then((r)=>r.data).catch((r)=>{
                throw new Error(r.message);
            });
        }, Q3 = (e)=>function() {
            return gc("cancelSlot")(e).then((r)=>r.data).catch((r)=>{
                throw new Error(r.message);
            });
        };
    function gc(e) {
        let _ = z1(W0(), window.firebaseFunctionsRegion);
        return q3(_, e);
    }
    var Jt = (e, _)=>({
            tag: e,
            _1: _
        }), Y3 = Jt("UNAUTHORIZED"), X3 = Jt("INVALID_PARAMS"), Z3 = Jt("USER_NOT_FOUND"), _6 = Jt("SLOT_NOT_FOUND"), e6 = Jt("SLOT_NOT_AVAILABLE"), o6 = Jt("INVALID_BOOKING");
    var r6 = (e)=>Jt("DecodeDocError", e), WM = {
        to: (e)=>{
            if (e.tag === "Inl") return Y3;
            if (e.tag === "Inr") {
                if (e._1.tag === "Inl") return X3;
                if (e._1.tag === "Inr") {
                    if (e._1._1.tag === "Inl") return Z3;
                    if (e._1._1.tag === "Inr") {
                        if (e._1._1._1.tag === "Inl") return _6;
                        if (e._1._1._1.tag === "Inr") {
                            if (e._1._1._1._1.tag === "Inl") return e6;
                            if (e._1._1._1._1.tag === "Inr") {
                                if (e._1._1._1._1._1.tag === "Inl") return o6;
                                if (e._1._1._1._1._1.tag === "Inr") {
                                    if (e._1._1._1._1._1._1.tag === "Inl") return Jt("DecodeError", e._1._1._1._1._1._1._1);
                                    if (e._1._1._1._1._1._1.tag === "Inr") return Jt("DecodeDocError", e._1._1._1._1._1._1._1);
                                    l();
                                }
                                l();
                            }
                            l();
                        }
                        l();
                    }
                    l();
                }
                l();
            }
            l();
        },
        from: (e)=>{
            if (e.tag === "UNAUTHORIZED") return o("Inl", P);
            if (e.tag === "INVALID_PARAMS") return o("Inr", o("Inl", P));
            if (e.tag === "USER_NOT_FOUND") return o("Inr", o("Inr", o("Inl", P)));
            if (e.tag === "SLOT_NOT_FOUND") return o("Inr", o("Inr", o("Inr", o("Inl", P))));
            if (e.tag === "SLOT_NOT_AVAILABLE") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))));
            if (e.tag === "INVALID_BOOKING") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))));
            if (e.tag === "DecodeError") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", e._1)))))));
            if (e.tag === "DecodeDocError") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", e._1)))))));
            l();
        }
    }, c$ = {
        show: (()=>{
            let e = U(V)({
                reflectSymbol: ()=>"UNAUTHORIZED"
            }), _ = U(V)({
                reflectSymbol: ()=>"INVALID_PARAMS"
            }), r = U(V)({
                reflectSymbol: ()=>"USER_NOT_FOUND"
            }), t = U(V)({
                reflectSymbol: ()=>"SLOT_NOT_FOUND"
            }), n = U(V)({
                reflectSymbol: ()=>"SLOT_NOT_AVAILABLE"
            }), s = U(V)({
                reflectSymbol: ()=>"INVALID_BOOKING"
            }), c = U({
                genericShowArgs: (d)=>[
                        ge.show(d)
                    ]
            })({
                reflectSymbol: ()=>"DecodeError"
            }), i = U({
                genericShowArgs: (d)=>[
                        ge.show(d)
                    ]
            })({
                reflectSymbol: ()=>"DecodeDocError"
            });
            return (d)=>{
                let v = WM.from(d);
                if (v.tag === "Inl") return e["genericShow'"](v._1);
                if (v.tag === "Inr") {
                    if (v._1.tag === "Inl") return _["genericShow'"](v._1._1);
                    if (v._1.tag === "Inr") {
                        if (v._1._1.tag === "Inl") return r["genericShow'"](v._1._1._1);
                        if (v._1._1.tag === "Inr") {
                            if (v._1._1._1.tag === "Inl") return t["genericShow'"](v._1._1._1._1);
                            if (v._1._1._1.tag === "Inr") {
                                if (v._1._1._1._1.tag === "Inl") return n["genericShow'"](v._1._1._1._1._1);
                                if (v._1._1._1._1.tag === "Inr") {
                                    if (v._1._1._1._1._1.tag === "Inl") return s["genericShow'"](v._1._1._1._1._1._1);
                                    if (v._1._1._1._1._1.tag === "Inr") {
                                        if (v._1._1._1._1._1._1.tag === "Inl") return c["genericShow'"](v._1._1._1._1._1._1._1);
                                        if (v._1._1._1._1._1._1.tag === "Inr") return i["genericShow'"](v._1._1._1._1._1._1._1);
                                        l();
                                    }
                                    l();
                                }
                                l();
                            }
                            l();
                        }
                        l();
                    }
                    l();
                }
                l();
            };
        })()
    }, HM = {
        decodeJson: (e)=>F_.bind(Q_((_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), I_, (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), e))((_)=>S("Right", (()=>_ === "UNAUTHORIZED" ? Y3 : _ === "INVALID_PARAMS" ? X3 : _ === "USER_NOT_FOUND" ? Z3 : _ === "SLOT_NOT_FOUND" ? _6 : _ === "SLOT_NOT_AVAILABLE" ? e6 : _ === "INVALID_BOOKING" ? o6 : Jt("DecodeError", H("UnexpectedValue", e)))()))
    }, jM = (e)=>{
        let _ = HM.decodeJson(e);
        if (_.tag === "Left") return Jt("DecodeError", _._1);
        if (_.tag === "Right") return _._1;
        l();
    }, t6 = {
        mapAffError: (e)=>jM(No(e))
    };
    var i0 = (e, _)=>({
            tag: e,
            _1: _
        }), s6 = i0("UNAUTHORIZED"), c6 = i0("INVALID_PARAMS"), a6 = i0("USER_NOT_FOUND"), i6 = i0("SLOT_NOT_FOUND");
    var l6 = (e)=>i0("DecodeDocError", e), KM = {
        to: (e)=>{
            if (e.tag === "Inl") return s6;
            if (e.tag === "Inr") {
                if (e._1.tag === "Inl") return c6;
                if (e._1.tag === "Inr") {
                    if (e._1._1.tag === "Inl") return a6;
                    if (e._1._1.tag === "Inr") {
                        if (e._1._1._1.tag === "Inl") return i6;
                        if (e._1._1._1.tag === "Inr") {
                            if (e._1._1._1._1.tag === "Inl") return i0("DecodeError", e._1._1._1._1._1);
                            if (e._1._1._1._1.tag === "Inr") return i0("DecodeDocError", e._1._1._1._1._1);
                            l();
                        }
                        l();
                    }
                    l();
                }
                l();
            }
            l();
        },
        from: (e)=>{
            if (e.tag === "UNAUTHORIZED") return o("Inl", P);
            if (e.tag === "INVALID_PARAMS") return o("Inr", o("Inl", P));
            if (e.tag === "USER_NOT_FOUND") return o("Inr", o("Inr", o("Inl", P)));
            if (e.tag === "SLOT_NOT_FOUND") return o("Inr", o("Inr", o("Inr", o("Inl", P))));
            if (e.tag === "DecodeError") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", e._1)))));
            if (e.tag === "DecodeDocError") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", e._1)))));
            l();
        }
    }, d6 = {
        show: (()=>{
            let e = U(V)({
                reflectSymbol: ()=>"UNAUTHORIZED"
            }), _ = U(V)({
                reflectSymbol: ()=>"INVALID_PARAMS"
            }), r = U(V)({
                reflectSymbol: ()=>"USER_NOT_FOUND"
            }), t = U(V)({
                reflectSymbol: ()=>"SLOT_NOT_FOUND"
            }), n = U({
                genericShowArgs: (c)=>[
                        ge.show(c)
                    ]
            })({
                reflectSymbol: ()=>"DecodeError"
            }), s = U({
                genericShowArgs: (c)=>[
                        ge.show(c)
                    ]
            })({
                reflectSymbol: ()=>"DecodeDocError"
            });
            return (c)=>{
                let i = KM.from(c);
                if (i.tag === "Inl") return e["genericShow'"](i._1);
                if (i.tag === "Inr") {
                    if (i._1.tag === "Inl") return _["genericShow'"](i._1._1);
                    if (i._1.tag === "Inr") {
                        if (i._1._1.tag === "Inl") return r["genericShow'"](i._1._1._1);
                        if (i._1._1.tag === "Inr") {
                            if (i._1._1._1.tag === "Inl") return t["genericShow'"](i._1._1._1._1);
                            if (i._1._1._1.tag === "Inr") {
                                if (i._1._1._1._1.tag === "Inl") return n["genericShow'"](i._1._1._1._1._1);
                                if (i._1._1._1._1.tag === "Inr") return s["genericShow'"](i._1._1._1._1._1);
                                l();
                            }
                            l();
                        }
                        l();
                    }
                    l();
                }
                l();
            };
        })()
    }, QM = {
        decodeJson: (e)=>F_.bind(Q_((_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), I_, (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), e))((_)=>S("Right", (()=>_ === "UNAUTHORIZED" ? s6 : _ === "INVALID_PARAMS" ? c6 : _ === "USER_NOT_FOUND" ? a6 : _ === "SLOT_NOT_FOUND" ? i6 : i0("DecodeError", H("UnexpectedValue", e)))()))
    }, YM = (e)=>{
        let _ = QM.decodeJson(e);
        if (_.tag === "Left") return i0("DecodeError", _._1);
        if (_.tag === "Right") return _._1;
        l();
    }, v6 = {
        mapAffError: (e)=>YM(No(e))
    };
    var Ya = (e, _)=>({
            tag: e,
            _1: _
        }), B1 = (e)=>({
            tag: e
        }), Xa = (e)=>({
            tag: e
        }), De = (e, _)=>({
            tag: e,
            _1: _
        }), vs = (e)=>({
            tag: e
        }), $6 = {
        reflectSymbol: ()=>"CCOALC"
    }, h6 = {
        reflectSymbol: ()=>"DFOALC"
    }, y6 = {
        reflectSymbol: ()=>"JBOALC"
    }, D6 = {
        reflectSymbol: ()=>"LOALC"
    }, w6 = {
        reflectSymbol: ()=>"CCOALC2"
    }, R6 = {
        reflectSymbol: ()=>"DFOALC2"
    }, us = {
        reflectSymbol: ()=>"camp"
    }, k6 = {
        reflectSymbol: ()=>"phase"
    }, S6 = {
        reflectSymbol: ()=>"username"
    }, I6 = {
        reflectSymbol: ()=>"Booked"
    }, x6 = {
        reflectSymbol: ()=>"PD"
    }, E6 = {
        reflectSymbol: ()=>"HQ"
    }, T6 = {
        reflectSymbol: ()=>"Available"
    }, U1 = {
        reflectSymbol: ()=>"days"
    }, G6 = {
        reflectSymbol: ()=>"title"
    };
    var C6 = {
        reflectSymbol: ()=>"Holiday"
    }, pd = {
        reflectSymbol: ()=>"booking"
    }, A6 = {
        reflectSymbol: ()=>"location"
    }, N6 = {
        reflectSymbol: ()=>"Resource"
    };
    var F6 = {
        reflectSymbol: ()=>"Camp4D3N"
    }, M6 = {
        reflectSymbol: ()=>"Camp3D2N"
    }, P6 = {
        reflectSymbol: ()=>"Camp1D"
    }, L6 = {
        reflectSymbol: ()=>"InSource4D3N"
    }, z6 = {
        reflectSymbol: ()=>"InSource3D2N"
    }, O6 = {
        reflectSymbol: ()=>"AsHoliday"
    }, U6 = {
        reflectSymbol: ()=>"AsPD"
    }, B6 = {
        reflectSymbol: ()=>"AsHQ"
    }, J6 = {
        reflectSymbol: ()=>"InSourceCamp"
    }, V6 = {
        reflectSymbol: ()=>"AwaitUserCamp"
    }, q6 = {
        reflectSymbol: ()=>"VendorRunCamp"
    }, W6 = {
        reflectSymbol: ()=>"SelfRunCamp"
    }, g6 = z_(oo)($r)(G6)(), H6 = Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", Q_((_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), I_, (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), e._1)) : D
    })(tr), b6 = Re((()=>{
        let e = Up(P3.decodeJson);
        return {
            decodeJsonField: (_)=>_.tag === "Just" ? R("Just", e(_._1)) : D
        };
    })()), p6 = H6(G6)()(), XM = (e)=>(_)=>{
            let r = Eo.compare(e)(_);
            if (r.tag === "LT") return _;
            if (r.tag === "EQ" || r.tag === "GT") return e;
            l();
        }, ZM = (e)=>(_)=>{
            let r = Eo.compare(e)(_);
            if (r.tag === "LT" || r.tag === "EQ") return e;
            if (r.tag === "GT") return _;
            l();
        }, _P = Tr(no)(y_), eP = (()=>lt.traverse(Nv)(_a))(), oP = jr(v6), j6 = {
        reflectSymbol: ()=>"slotID"
    }, rP = (()=>{
        let e = z_(oo)(z_(Ar)($r)({
            reflectSymbol: ()=>"workYear"
        })())(j6)();
        return (_)=>e.gEncodeJson(_)(q);
    })(), tP = jr(t6), a$ = vs("Camp4D3N"), i$ = vs("Camp3D2N"), l$ = vs("Camp1D"), d$ = vs("InSource4D3N"), v$ = vs("InSource3D2N"), u$ = vs("AsHoliday"), g$ = vs("AsPD"), b$ = vs("AsHQ"), bc = Xa("CCOALC"), pc = Xa("DFOALC"), fc = Xa("JBOALC"), mc = Xa("LOALC"), $c = Xa("CCOALC2"), hc = Xa("DFOALC2"), bd = B1("InSourceCamp"), ds = B1("AwaitUserCamp"), fd = B1("VendorRunCamp"), md = B1("SelfRunCamp");
    var J1 = Ya("PD"), V1 = Ya("HQ"), St = Ya("Available"), K6 = (e)=>De("Holiday", e), Q6 = (e)=>De("Resource", e);
    var Y6 = {
        to: (e)=>{
            if (e.tag === "Inl") return De("Holiday", e._1);
            if (e.tag === "Inr") return De("Resource", e._1);
            l();
        },
        from: (e)=>{
            if (e.tag === "Holiday") return o("Inl", e._1);
            if (e.tag === "Resource") return o("Inr", e._1);
            l();
        }
    }, X6 = {
        to: (e)=>{
            if (e.tag === "Inl") return a$;
            if (e.tag === "Inr") {
                if (e._1.tag === "Inl") return i$;
                if (e._1.tag === "Inr") {
                    if (e._1._1.tag === "Inl") return l$;
                    if (e._1._1.tag === "Inr") {
                        if (e._1._1._1.tag === "Inl") return d$;
                        if (e._1._1._1.tag === "Inr") {
                            if (e._1._1._1._1.tag === "Inl") return v$;
                            if (e._1._1._1._1.tag === "Inr") {
                                if (e._1._1._1._1._1.tag === "Inl") return u$;
                                if (e._1._1._1._1._1.tag === "Inr") {
                                    if (e._1._1._1._1._1._1.tag === "Inl") return g$;
                                    if (e._1._1._1._1._1._1.tag === "Inr") return b$;
                                    l();
                                }
                                l();
                            }
                            l();
                        }
                        l();
                    }
                    l();
                }
                l();
            }
            l();
        },
        from: (e)=>{
            if (e.tag === "Camp4D3N") return o("Inl", P);
            if (e.tag === "Camp3D2N") return o("Inr", o("Inl", P));
            if (e.tag === "Camp1D") return o("Inr", o("Inr", o("Inl", P)));
            if (e.tag === "InSource4D3N") return o("Inr", o("Inr", o("Inr", o("Inl", P))));
            if (e.tag === "InSource3D2N") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))));
            if (e.tag === "AsHoliday") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))));
            if (e.tag === "AsPD") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))));
            if (e.tag === "AsHQ") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", P)))))));
            l();
        }
    }, Z6 = U0(X6)((()=>{
        let e = Je(F6)(fo), _ = Je(M6)(fo), r = Je(P6)(fo), t = Je(L6)(fo), n = Je(z6)(fo), s = Je(O6)(fo), c = Je(U6)(fo), i = Je(B6)(fo);
        return {
            encodeRepWith: (d)=>(v)=>{
                    if (v.tag === "Inl") return e.encodeRepWith(d)(v._1);
                    if (v.tag === "Inr") {
                        if (v._1.tag === "Inl") return _.encodeRepWith(d)(v._1._1);
                        if (v._1.tag === "Inr") {
                            if (v._1._1.tag === "Inl") return r.encodeRepWith(d)(v._1._1._1);
                            if (v._1._1.tag === "Inr") {
                                if (v._1._1._1.tag === "Inl") return t.encodeRepWith(d)(v._1._1._1._1);
                                if (v._1._1._1.tag === "Inr") {
                                    if (v._1._1._1._1.tag === "Inl") return n.encodeRepWith(d)(v._1._1._1._1._1);
                                    if (v._1._1._1._1.tag === "Inr") {
                                        if (v._1._1._1._1._1.tag === "Inl") return s.encodeRepWith(d)(v._1._1._1._1._1._1);
                                        if (v._1._1._1._1._1.tag === "Inr") {
                                            if (v._1._1._1._1._1._1.tag === "Inl") return c.encodeRepWith(d)(v._1._1._1._1._1._1._1);
                                            if (v._1._1._1._1._1._1.tag === "Inr") return i.encodeRepWith(d)(v._1._1._1._1._1._1._1);
                                            l();
                                        }
                                        l();
                                    }
                                    l();
                                }
                                l();
                            }
                            l();
                        }
                        l();
                    }
                    l();
                }
        };
    })()), _8 = O0(X6)(Po(po(F6))(Po(po(M6))(Po(po(P6))(Po(po(L6))(Po(po(z6))(Po(po(O6))(Po(po(U6))(po(B6)))))))))(Lt), e8 = {
        to: (e)=>{
            if (e.tag === "Inl") return bc;
            if (e.tag === "Inr") {
                if (e._1.tag === "Inl") return pc;
                if (e._1.tag === "Inr") {
                    if (e._1._1.tag === "Inl") return fc;
                    if (e._1._1.tag === "Inr") {
                        if (e._1._1._1.tag === "Inl") return mc;
                        if (e._1._1._1.tag === "Inr") {
                            if (e._1._1._1._1.tag === "Inl") return $c;
                            if (e._1._1._1._1.tag === "Inr") return hc;
                            l();
                        }
                        l();
                    }
                    l();
                }
                l();
            }
            l();
        },
        from: (e)=>{
            if (e.tag === "CCOALC") return o("Inl", P);
            if (e.tag === "DFOALC") return o("Inr", o("Inl", P));
            if (e.tag === "JBOALC") return o("Inr", o("Inr", o("Inl", P)));
            if (e.tag === "LOALC") return o("Inr", o("Inr", o("Inr", o("Inl", P))));
            if (e.tag === "CCOALC2") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))));
            if (e.tag === "DFOALC2") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", P)))));
            l();
        }
    }, nP = U0(e8)((()=>{
        let e = Je($6)(fo), _ = Je(h6)(fo), r = Je(y6)(fo), t = Je(D6)(fo), n = Je(w6)(fo), s = Je(R6)(fo);
        return {
            encodeRepWith: (c)=>(i)=>{
                    if (i.tag === "Inl") return e.encodeRepWith(c)(i._1);
                    if (i.tag === "Inr") {
                        if (i._1.tag === "Inl") return _.encodeRepWith(c)(i._1._1);
                        if (i._1.tag === "Inr") {
                            if (i._1._1.tag === "Inl") return r.encodeRepWith(c)(i._1._1._1);
                            if (i._1._1.tag === "Inr") {
                                if (i._1._1._1.tag === "Inl") return t.encodeRepWith(c)(i._1._1._1._1);
                                if (i._1._1._1.tag === "Inr") {
                                    if (i._1._1._1._1.tag === "Inl") return n.encodeRepWith(c)(i._1._1._1._1._1);
                                    if (i._1._1._1._1.tag === "Inr") return s.encodeRepWith(c)(i._1._1._1._1._1);
                                    l();
                                }
                                l();
                            }
                            l();
                        }
                        l();
                    }
                    l();
                }
        };
    })()), sP = O0(e8)(Po(po($6))(Po(po(h6))(Po(po(y6))(Po(po(D6))(Po(po(w6))(po(R6)))))))(Lt);
    var o8 = {
        to: (e)=>{
            if (e.tag === "Inl") return bd;
            if (e.tag === "Inr") {
                if (e._1.tag === "Inl") return ds;
                if (e._1.tag === "Inr") {
                    if (e._1._1.tag === "Inl") return fd;
                    if (e._1._1.tag === "Inr") return md;
                    l();
                }
                l();
            }
            l();
        },
        from: (e)=>{
            if (e.tag === "InSourceCamp") return o("Inl", P);
            if (e.tag === "AwaitUserCamp") return o("Inr", o("Inl", P));
            if (e.tag === "VendorRunCamp") return o("Inr", o("Inr", o("Inl", P)));
            if (e.tag === "SelfRunCamp") return o("Inr", o("Inr", o("Inr", P)));
            l();
        }
    }, yc = U0(o8)((()=>{
        let e = Je(J6)(fo), _ = Je(V6)(fo), r = Je(q6)(fo), t = Je(W6)(fo);
        return {
            encodeRepWith: (n)=>(s)=>{
                    if (s.tag === "Inl") return e.encodeRepWith(n)(s._1);
                    if (s.tag === "Inr") {
                        if (s._1.tag === "Inl") return _.encodeRepWith(n)(s._1._1);
                        if (s._1.tag === "Inr") {
                            if (s._1._1.tag === "Inl") return r.encodeRepWith(n)(s._1._1._1);
                            if (s._1._1.tag === "Inr") return t.encodeRepWith(n)(s._1._1._1);
                            l();
                        }
                        l();
                    }
                    l();
                }
        };
    })()), Za = O0(o8)(Po(po(J6))(Po(po(V6))(Po(po(q6))(po(W6)))))(Lt), r8 = {
        to: (e)=>{
            if (e.tag === "Inl") return Ya("Booked", e._1);
            if (e.tag === "Inr") {
                if (e._1.tag === "Inl") return J1;
                if (e._1.tag === "Inr") {
                    if (e._1._1.tag === "Inl") return V1;
                    if (e._1._1.tag === "Inr") return St;
                    l();
                }
                l();
            }
            l();
        },
        from: (e)=>{
            if (e.tag === "Booked") return o("Inl", e._1);
            if (e.tag === "PD") return o("Inr", o("Inl", P));
            if (e.tag === "HQ") return o("Inr", o("Inr", o("Inl", P)));
            if (e.tag === "Available") return o("Inr", o("Inr", o("Inr", P)));
            l();
        }
    };
    var cP = {
        eq: (e)=>(_)=>e.tag === "CCOALC" ? _.tag === "CCOALC" : e.tag === "DFOALC" ? _.tag === "DFOALC" : e.tag === "JBOALC" ? _.tag === "JBOALC" : e.tag === "LOALC" ? _.tag === "LOALC" : e.tag === "CCOALC2" ? _.tag === "CCOALC2" : e.tag === "DFOALC2" ? _.tag === "DFOALC2" : !1
    }, p$ = {
        compare: (e)=>(_)=>{
                if (e.tag === "CCOALC") return _.tag === "CCOALC" ? X_ : E_;
                if (_.tag === "CCOALC") return T_;
                if (e.tag === "DFOALC") return _.tag === "DFOALC" ? X_ : E_;
                if (_.tag === "DFOALC") return T_;
                if (e.tag === "JBOALC") return _.tag === "JBOALC" ? X_ : E_;
                if (_.tag === "JBOALC") return T_;
                if (e.tag === "LOALC") return _.tag === "LOALC" ? X_ : E_;
                if (_.tag === "LOALC") return T_;
                if (e.tag === "CCOALC2") return _.tag === "CCOALC2" ? X_ : E_;
                if (_.tag === "CCOALC2") return T_;
                if (e.tag === "DFOALC2") {
                    if (_.tag === "DFOALC2") return X_;
                    l();
                }
                l();
            },
        Eq0: ()=>cP
    };
    var q1 = {
        eq: (e)=>(_)=>e.tag === "Booked" ? _.tag === "Booked" ? (()=>e._1.camp.tag === "InSourceCamp" ? _._1.camp.tag === "InSourceCamp" : e._1.camp.tag === "AwaitUserCamp" ? _._1.camp.tag === "AwaitUserCamp" : e._1.camp.tag === "VendorRunCamp" ? _._1.camp.tag === "VendorRunCamp" : e._1.camp.tag === "SelfRunCamp" ? _._1.camp.tag === "SelfRunCamp" : !1)() && (()=>e._1.phase.tag === "ClosedPhase" ? _._1.phase.tag === "ClosedPhase" : e._1.phase.tag === "Phase1" ? _._1.phase.tag === "Phase1" : e._1.phase.tag === "Phase2" ? _._1.phase.tag === "Phase2" : e._1.phase.tag === "Phase3" ? _._1.phase.tag === "Phase3" : e._1.phase.tag === "OpenPhase" ? _._1.phase.tag === "OpenPhase" : !1)() && e._1.username === _._1.username : !1 : e.tag === "PD" ? _.tag === "PD" : e.tag === "HQ" ? _.tag === "HQ" : e.tag === "Available" ? _.tag === "Available" : !1
    };
    var aP = {
        encodeJson: (e)=>nP(e)
    }, f$ = {
        encodeJson: (e)=>yc(e)
    }, iP = U0(r8)((()=>{
        let e = Je(I6)((()=>{
            let n = z_(f$)(z_(La)(z_(oo)($r)(S6)())(k6)())(us)();
            return {
                encodeRepArgs: (s)=>[
                        n.gEncodeJson(s)(q)
                    ]
            };
        })()), _ = Je(x6)(fo), r = Je(E6)(fo), t = Je(T6)(fo);
        return {
            encodeRepWith: (n)=>(s)=>{
                    if (s.tag === "Inl") return e.encodeRepWith(n)(s._1);
                    if (s.tag === "Inr") {
                        if (s._1.tag === "Inl") return _.encodeRepWith(n)(s._1._1);
                        if (s._1.tag === "Inr") {
                            if (s._1._1.tag === "Inl") return r.encodeRepWith(n)(s._1._1._1);
                            if (s._1._1.tag === "Inr") return t.encodeRepWith(n)(s._1._1._1);
                            l();
                        }
                        l();
                    }
                    l();
                }
        };
    })()), lP = (()=>{
        let e = z_(La)(z_(f$)(z_(oo)(z_(oo)(z_(Ar)($r)({
            reflectSymbol: ()=>"workYear"
        })())({
            reflectSymbol: ()=>"uid"
        })())(j6)())(us)())({
            reflectSymbol: ()=>"bookingPhase"
        })();
        return (_)=>e.gEncodeJson(_)(q);
    })(), dP = {
        encodeJson: (e)=>iP(e)
    }, vP = U0(Y6)((()=>{
        let e = Je(C6)((()=>{
            let r = z_(Op(Ym))(g6)(U1)();
            return {
                encodeRepArgs: (t)=>[
                        r.gEncodeJson(t)(q)
                    ]
            };
        })()), _ = Je(N6)((()=>{
            let r = z_(dP)(z_(f$)(z_(Op(Ym))(z_(aP)(g6)(A6)())(U1)())(us)())(pd)();
            return {
                encodeRepArgs: (t)=>[
                        r.gEncodeJson(t)(q)
                    ]
            };
        })());
        return {
            encodeRepWith: (r)=>(t)=>{
                    if (t.tag === "Inl") return e.encodeRepWith(r)(t._1);
                    if (t.tag === "Inr") return _.encodeRepWith(r)(t._1);
                    l();
                }
        };
    })()), uP = {
        encodeJson: (e)=>vP(e)
    };
    var gP = O0(r8)(Po(bl(I6)(So(Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", Za(e._1)) : D
    })(Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", za.decodeJson(e._1)) : D
    })(H6(S6)()())(k6)()())(us)()())()))(Po(po(x6))(Po(po(E6))(po(T6)))))(Lt);
    var t8 = O0(Y6)(Po(bl(C6)(So(b6(p6)(U1)()())()))(bl(N6)(So(Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", gP(e._1)) : D
    })(Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", Za(e._1)) : D
    })(b6(Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", sP(e._1)) : D
    })(p6)(A6)()())(U1)()())(us)()())(pd)()())())))(Lt);
    var n8 = (e)=>(_)=>(r)=>(t)=>r1(uP)(e)("/workYears/" + __(_) + "/slots")(r)(t);
    var s8 = (e)=>F1(XM)((()=>{
            if (e.tag === "Holiday" || e.tag === "Resource") return e._1.days;
            l();
        })()), It = (e)=>F1(ZM)((()=>{
            if (e.tag === "Holiday" || e.tag === "Resource") return e._1.days;
            l();
        })()), $d = (e)=>_P(te(pr)((()=>{
            if (e.tag === "Holiday" || e.tag === "Resource") return e._1.days;
            l();
        })()));
    var c8 = (e)=>((r)=>(t)=>{
                let n = r, s = t, c = !0, i;
                for(; c;){
                    let d = n, v = s;
                    if (d.tag === "Nil") {
                        c = !1, i = v;
                        continue;
                    }
                    if (d.tag === "Cons") {
                        if (d._1.tag === "Holiday") {
                            n = d._2, s = v;
                            continue;
                        }
                        if (d._1.tag === "Resource") {
                            n = d._2, s = Y("Cons", d._1._1, v);
                            continue;
                        }
                        l();
                    }
                    l();
                }
                return i;
            })(e)(y_);
    var O1 = (e)=>(_)=>{
            if (e <= 1) return [
                _
            ];
            let r = te((n)=>Xo(Pe(n))(_))(f7(0)(e - 1 | 0)), t = r.length > 0 ? eP(r) : D;
            if (t.tag === "Nothing") return [
                _
            ];
            if (t.tag === "Just") return t._1;
            l();
        }, a8 = (e)=>(_)=>Qo.bind(oP(Q3(rP({
                slotID: _,
                workYear: e
            }))))((r)=>Ws(fe.bimap(l6)(re)(Q_((t)=>S("Right", void 0), (t)=>S("Left", H("TypeMismatch", "null")), (t)=>S("Left", H("TypeMismatch", "null")), (t)=>S("Left", H("TypeMismatch", "null")), (t)=>S("Left", H("TypeMismatch", "null")), (t)=>S("Left", H("TypeMismatch", "null")), r)))), i8 = (e)=>(_)=>(r)=>(t)=>(n)=>Qo.bind(tP(K3(lP({
                            uid: r.uid,
                            slotID: n,
                            workYear: e,
                            camp: t,
                            bookingPhase: _
                        }))))((s)=>Ws(fe.bimap(r6)(re)(Q_((c)=>S("Right", void 0), (c)=>S("Left", H("TypeMismatch", "null")), (c)=>S("Left", H("TypeMismatch", "null")), (c)=>S("Left", H("TypeMismatch", "null")), (c)=>S("Left", H("TypeMismatch", "null")), (c)=>S("Left", H("TypeMismatch", "null")), s))));
    var f6 = m_(us)()()(q)(O_);
    var m6 = m_(pd)()()(q)(O_), l8 = (e)=>(_)=>(r)=>{
                if (r.tag === "Camp4D3N") return De("Resource", {
                    location: e,
                    camp: ds,
                    booking: St,
                    title: "4D3N",
                    days: te(as)(O1(4)(_))
                });
                if (r.tag === "Camp3D2N") return De("Resource", {
                    location: e,
                    camp: ds,
                    booking: St,
                    title: "3D2N",
                    days: te(as)(O1(3)(_))
                });
                if (r.tag === "Camp1D") return De("Resource", {
                    location: e,
                    camp: ds,
                    booking: St,
                    title: "1D",
                    days: te(as)([
                        _
                    ])
                });
                if (r.tag === "InSource4D3N") return De("Resource", f6((t)=>bd)({
                    location: e,
                    camp: ds,
                    booking: St,
                    title: "4D3N",
                    days: te(as)(O1(4)(_))
                }));
                if (r.tag === "InSource3D2N") return De("Resource", f6((t)=>bd)({
                    location: e,
                    camp: ds,
                    booking: St,
                    title: "3D2N",
                    days: te(as)(O1(3)(_))
                }));
                if (r.tag === "AsHoliday") return De("Holiday", {
                    title: "Public Holiday",
                    days: [
                        _
                    ]
                });
                if (r.tag === "AsPD") return De("Resource", m6((t)=>J1)({
                    location: e,
                    camp: ds,
                    booking: St,
                    title: "PD",
                    days: te(as)([
                        _
                    ])
                }));
                if (r.tag === "AsHQ") return De("Resource", m6((t)=>V1)({
                    location: e,
                    camp: ds,
                    booking: St,
                    title: "HQ",
                    days: te(as)([
                        _
                    ])
                }));
                l();
            };
    var d8 = {
        fromDuration: (e)=>e * 1e3,
        toDuration: (e)=>e / 1e3
    };
    var _i = {
        fromDuration: (e)=>e * 36e5,
        toDuration: (e)=>e / 36e5
    };
    var r_ = (e, _)=>({
            tag: e,
            _1: _
        }), v8 = r_("ADMIN_ONLY_OPERATION"), u8 = r_("ARGUMENT_ERROR"), g8 = r_("APP_NOT_AUTHORIZED"), b8 = r_("APP_NOT_INSTALLED"), p8 = r_("CAPTCHA_CHECK_FAILED"), f8 = r_("CODE_EXPIRED"), m8 = r_("CORDOVA_NOT_READY"), $8 = r_("CORS_UNSUPPORTED"), h8 = r_("CREDENTIAL_ALREADY_IN_USE"), y8 = r_("CREDENTIAL_MISMATCH"), D8 = r_("CREDENTIAL_TOO_OLD_LOGIN_AGAIN"), w8 = r_("DEPENDENT_SDK_INIT_BEFORE_AUTH"), R8 = r_("DYNAMIC_LINK_NOT_ACTIVATED"), k8 = r_("EMAIL_CHANGE_NEEDS_VERIFICATION"), S8 = r_("EMAIL_EXISTS"), I8 = r_("EMULATOR_CONFIG_FAILED"), x8 = r_("EXPIRED_OOB_CODE"), E8 = r_("EXPIRED_POPUP_REQUEST"), T8 = r_("INTERNAL_ERROR"), G8 = r_("INVALID_API_KEY"), C8 = r_("INVALID_APP_CREDENTIAL"), A8 = r_("INVALID_APP_ID"), N8 = r_("INVALID_AUTH"), F8 = r_("INVALID_AUTH_EVENT"), M8 = r_("INVALID_CERT_HASH"), P8 = r_("INVALID_CODE"), L8 = r_("INVALID_CONTINUE_URI"), z8 = r_("INVALID_CORDOVA_CONFIGURATION"), O8 = r_("INVALID_CUSTOM_TOKEN"), U8 = r_("INVALID_DYNAMIC_LINK_DOMAIN"), B8 = r_("INVALID_EMAIL"), J8 = r_("INVALID_EMULATOR_SCHEME"), V8 = r_("INVALID_IDP_RESPONSE"), q8 = r_("INVALID_MESSAGE_PAYLOAD"), W8 = r_("INVALID_MFA_SESSION"), H8 = r_("INVALID_OAUTH_CLIENT_ID"), j8 = r_("INVALID_OAUTH_PROVIDER"), K8 = r_("INVALID_OOB_CODE"), Q8 = r_("INVALID_ORIGIN"), Y8 = r_("INVALID_PASSWORD"), X8 = r_("INVALID_PERSISTENCE"), Z8 = r_("INVALID_PHONE_NUMBER"), _w = r_("INVALID_PROVIDER_ID"), ew = r_("INVALID_RECIPIENT_EMAIL"), ow = r_("INVALID_SENDER"), rw = r_("INVALID_SESSION_INFO"), tw = r_("INVALID_TENANT_ID"), nw = r_("MFA_INFO_NOT_FOUND"), sw = r_("MFA_REQUIRED"), cw = r_("MISSING_ANDROID_PACKAGE_NAME"), aw = r_("MISSING_APP_CREDENTIAL"), iw = r_("MISSING_AUTH_DOMAIN"), lw = r_("MISSING_CODE"), dw = r_("MISSING_CONTINUE_URI"), vw = r_("MISSING_IFRAME_START"), uw = r_("MISSING_IOS_BUNDLE_ID"), gw = r_("MISSING_OR_INVALID_NONCE"), bw = r_("MISSING_MFA_INFO"), pw = r_("MISSING_MFA_SESSION"), fw = r_("MISSING_PHONE_NUMBER"), mw = r_("MISSING_SESSION_INFO"), $w = r_("MODULE_DESTROYED"), hw = r_("NEED_CONFIRMATION"), yw = r_("NETWORK_REQUEST_FAILED"), Dw = r_("NULL_USER"), ww = r_("NO_AUTH_EVENT"), Rw = r_("NO_SUCH_PROVIDER"), kw = r_("OPERATION_NOT_ALLOWED"), Sw = r_("OPERATION_NOT_SUPPORTED"), Iw = r_("POPUP_BLOCKED"), xw = r_("POPUP_CLOSED_BY_USER"), Ew = r_("PROVIDER_ALREADY_LINKED"), Tw = r_("QUOTA_EXCEEDED"), Gw = r_("REDIRECT_CANCELLED_BY_USER"), Cw = r_("REDIRECT_OPERATION_PENDING"), Aw = r_("REJECTED_CREDENTIAL"), Nw = r_("SECOND_FACTOR_ALREADY_ENROLLED"), Fw = r_("SECOND_FACTOR_LIMIT_EXCEEDED"), Mw = r_("TENANT_ID_MISMATCH"), Pw = r_("TIMEOUT"), Lw = r_("TOKEN_EXPIRED"), zw = r_("TOO_MANY_ATTEMPTS_TRY_LATER"), Ow = r_("UNAUTHORIZED_DOMAIN"), Uw = r_("UNSUPPORTED_FIRST_FACTOR"), Bw = r_("UNSUPPORTED_PERSISTENCE"), Jw = r_("UNSUPPORTED_TENANT_OPERATION"), Vw = r_("UNVERIFIED_EMAIL"), qw = r_("USER_CANCELLED"), Ww = r_("USER_DELETED"), Hw = r_("USER_DISABLED"), jw = r_("USER_MISMATCH"), Kw = r_("USER_SIGNED_OUT"), Qw = r_("WEAK_PASSWORD"), Yw = r_("WEB_STORAGE_UNSUPPORTED"), Xw = r_("ALREADY_INITIALIZED"), Zw = r_("RECAPTCHA_NOT_ENABLED"), _R = r_("MISSING_RECAPTCHA_TOKEN"), eR = r_("INVALID_RECAPTCHA_TOKEN"), oR = r_("INVALID_RECAPTCHA_ACTION"), rR = r_("MISSING_CLIENT_TYPE"), tR = r_("MISSING_RECAPTCHA_VERSION"), nR = r_("INVALID_RECAPTCHA_VERSION"), sR = r_("INVALID_REQ_TYPE");
    var bP = {
        to: (e)=>{
            if (e.tag === "Inl") return v8;
            if (e.tag === "Inr") {
                if (e._1.tag === "Inl") return u8;
                if (e._1.tag === "Inr") {
                    if (e._1._1.tag === "Inl") return g8;
                    if (e._1._1.tag === "Inr") {
                        if (e._1._1._1.tag === "Inl") return b8;
                        if (e._1._1._1.tag === "Inr") {
                            if (e._1._1._1._1.tag === "Inl") return p8;
                            if (e._1._1._1._1.tag === "Inr") {
                                if (e._1._1._1._1._1.tag === "Inl") return f8;
                                if (e._1._1._1._1._1.tag === "Inr") {
                                    if (e._1._1._1._1._1._1.tag === "Inl") return m8;
                                    if (e._1._1._1._1._1._1.tag === "Inr") {
                                        if (e._1._1._1._1._1._1._1.tag === "Inl") return $8;
                                        if (e._1._1._1._1._1._1._1.tag === "Inr") {
                                            if (e._1._1._1._1._1._1._1._1.tag === "Inl") return h8;
                                            if (e._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                if (e._1._1._1._1._1._1._1._1._1.tag === "Inl") return y8;
                                                if (e._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                    if (e._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return D8;
                                                    if (e._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                        if (e._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return w8;
                                                        if (e._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return R8;
                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return k8;
                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return S8;
                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return I8;
                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return x8;
                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return E8;
                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return T8;
                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return G8;
                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return C8;
                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return A8;
                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return N8;
                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return F8;
                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return M8;
                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return P8;
                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return L8;
                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return z8;
                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return O8;
                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return U8;
                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return B8;
                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return J8;
                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return V8;
                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return q8;
                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return W8;
                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return H8;
                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return j8;
                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return K8;
                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Q8;
                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Y8;
                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return X8;
                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Z8;
                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return _w;
                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return ew;
                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return ow;
                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return rw;
                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return tw;
                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return nw;
                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return sw;
                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return cw;
                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return aw;
                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return iw;
                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return lw;
                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return dw;
                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return vw;
                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return uw;
                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return gw;
                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return bw;
                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return pw;
                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return fw;
                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return mw;
                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return $w;
                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return hw;
                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return yw;
                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Dw;
                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return ww;
                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Rw;
                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return kw;
                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Sw;
                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Iw;
                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return xw;
                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Ew;
                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Tw;
                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Gw;
                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Cw;
                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Aw;
                                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Nw;
                                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Fw;
                                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Mw;
                                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Pw;
                                                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Lw;
                                                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return zw;
                                                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Ow;
                                                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Uw;
                                                                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Bw;
                                                                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Jw;
                                                                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Vw;
                                                                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return qw;
                                                                                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Ww;
                                                                                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Hw;
                                                                                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return jw;
                                                                                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Kw;
                                                                                                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Qw;
                                                                                                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Yw;
                                                                                                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Xw;
                                                                                                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Zw;
                                                                                                                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return _R;
                                                                                                                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return eR;
                                                                                                                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return oR;
                                                                                                                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return rR;
                                                                                                                                                                                                                                                                                                                                                                                                                        if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return tR;
                                                                                                                                                                                                                                                                                                                                                                                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return nR;
                                                                                                                                                                                                                                                                                                                                                                                                                                if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return sR;
                                                                                                                                                                                                                                                                                                                                                                                                                                    if (e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") return r_("DecodeError", e._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                            }
                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                        }
                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                }
                                                                                                                                                                                                                l();
                                                                                                                                                                                                            }
                                                                                                                                                                                                            l();
                                                                                                                                                                                                        }
                                                                                                                                                                                                        l();
                                                                                                                                                                                                    }
                                                                                                                                                                                                    l();
                                                                                                                                                                                                }
                                                                                                                                                                                                l();
                                                                                                                                                                                            }
                                                                                                                                                                                            l();
                                                                                                                                                                                        }
                                                                                                                                                                                        l();
                                                                                                                                                                                    }
                                                                                                                                                                                    l();
                                                                                                                                                                                }
                                                                                                                                                                                l();
                                                                                                                                                                            }
                                                                                                                                                                            l();
                                                                                                                                                                        }
                                                                                                                                                                        l();
                                                                                                                                                                    }
                                                                                                                                                                    l();
                                                                                                                                                                }
                                                                                                                                                                l();
                                                                                                                                                            }
                                                                                                                                                            l();
                                                                                                                                                        }
                                                                                                                                                        l();
                                                                                                                                                    }
                                                                                                                                                    l();
                                                                                                                                                }
                                                                                                                                                l();
                                                                                                                                            }
                                                                                                                                            l();
                                                                                                                                        }
                                                                                                                                        l();
                                                                                                                                    }
                                                                                                                                    l();
                                                                                                                                }
                                                                                                                                l();
                                                                                                                            }
                                                                                                                            l();
                                                                                                                        }
                                                                                                                        l();
                                                                                                                    }
                                                                                                                    l();
                                                                                                                }
                                                                                                                l();
                                                                                                            }
                                                                                                            l();
                                                                                                        }
                                                                                                        l();
                                                                                                    }
                                                                                                    l();
                                                                                                }
                                                                                                l();
                                                                                            }
                                                                                            l();
                                                                                        }
                                                                                        l();
                                                                                    }
                                                                                    l();
                                                                                }
                                                                                l();
                                                                            }
                                                                            l();
                                                                        }
                                                                        l();
                                                                    }
                                                                    l();
                                                                }
                                                                l();
                                                            }
                                                            l();
                                                        }
                                                        l();
                                                    }
                                                    l();
                                                }
                                                l();
                                            }
                                            l();
                                        }
                                        l();
                                    }
                                    l();
                                }
                                l();
                            }
                            l();
                        }
                        l();
                    }
                    l();
                }
                l();
            }
            l();
        },
        from: (e)=>{
            if (e.tag === "ADMIN_ONLY_OPERATION") return o("Inl", P);
            if (e.tag === "ARGUMENT_ERROR") return o("Inr", o("Inl", P));
            if (e.tag === "APP_NOT_AUTHORIZED") return o("Inr", o("Inr", o("Inl", P)));
            if (e.tag === "APP_NOT_INSTALLED") return o("Inr", o("Inr", o("Inr", o("Inl", P))));
            if (e.tag === "CAPTCHA_CHECK_FAILED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))));
            if (e.tag === "CODE_EXPIRED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))));
            if (e.tag === "CORDOVA_NOT_READY") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))));
            if (e.tag === "CORS_UNSUPPORTED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))));
            if (e.tag === "CREDENTIAL_ALREADY_IN_USE") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))));
            if (e.tag === "CREDENTIAL_MISMATCH") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))));
            if (e.tag === "CREDENTIAL_TOO_OLD_LOGIN_AGAIN") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))));
            if (e.tag === "DEPENDENT_SDK_INIT_BEFORE_AUTH") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))));
            if (e.tag === "DYNAMIC_LINK_NOT_ACTIVATED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))));
            if (e.tag === "EMAIL_CHANGE_NEEDS_VERIFICATION") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))));
            if (e.tag === "EMAIL_EXISTS") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))));
            if (e.tag === "EMULATOR_CONFIG_FAILED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))));
            if (e.tag === "EXPIRED_OOB_CODE") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))));
            if (e.tag === "EXPIRED_POPUP_REQUEST") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))));
            if (e.tag === "INTERNAL_ERROR") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))));
            if (e.tag === "INVALID_API_KEY") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))));
            if (e.tag === "INVALID_APP_CREDENTIAL") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))));
            if (e.tag === "INVALID_APP_ID") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))));
            if (e.tag === "INVALID_AUTH") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))));
            if (e.tag === "INVALID_AUTH_EVENT") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))));
            if (e.tag === "INVALID_CERT_HASH") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))));
            if (e.tag === "INVALID_CODE") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))));
            if (e.tag === "INVALID_CONTINUE_URI") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))));
            if (e.tag === "INVALID_CORDOVA_CONFIGURATION") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))));
            if (e.tag === "INVALID_CUSTOM_TOKEN") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))));
            if (e.tag === "INVALID_DYNAMIC_LINK_DOMAIN") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_EMAIL") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_EMULATOR_SCHEME") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_IDP_RESPONSE") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_MESSAGE_PAYLOAD") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_MFA_SESSION") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_OAUTH_CLIENT_ID") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_OAUTH_PROVIDER") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_OOB_CODE") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_ORIGIN") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_PASSWORD") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_PERSISTENCE") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_PHONE_NUMBER") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_PROVIDER_ID") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_RECIPIENT_EMAIL") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_SENDER") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_SESSION_INFO") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_TENANT_ID") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MFA_INFO_NOT_FOUND") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MFA_REQUIRED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_ANDROID_PACKAGE_NAME") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_APP_CREDENTIAL") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_AUTH_DOMAIN") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_CODE") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_CONTINUE_URI") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_IFRAME_START") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_IOS_BUNDLE_ID") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_OR_INVALID_NONCE") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_MFA_INFO") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_MFA_SESSION") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_PHONE_NUMBER") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_SESSION_INFO") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MODULE_DESTROYED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "NEED_CONFIRMATION") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "NETWORK_REQUEST_FAILED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "NULL_USER") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "NO_AUTH_EVENT") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "NO_SUCH_PROVIDER") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "OPERATION_NOT_ALLOWED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "OPERATION_NOT_SUPPORTED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "POPUP_BLOCKED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "POPUP_CLOSED_BY_USER") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "PROVIDER_ALREADY_LINKED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "QUOTA_EXCEEDED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "REDIRECT_CANCELLED_BY_USER") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "REDIRECT_OPERATION_PENDING") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "REJECTED_CREDENTIAL") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "SECOND_FACTOR_ALREADY_ENROLLED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "SECOND_FACTOR_LIMIT_EXCEEDED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "TENANT_ID_MISMATCH") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "TIMEOUT") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "TOKEN_EXPIRED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "TOO_MANY_ATTEMPTS_TRY_LATER") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "UNAUTHORIZED_DOMAIN") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "UNSUPPORTED_FIRST_FACTOR") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "UNSUPPORTED_PERSISTENCE") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "UNSUPPORTED_TENANT_OPERATION") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "UNVERIFIED_EMAIL") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "USER_CANCELLED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "USER_DELETED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "USER_DISABLED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "USER_MISMATCH") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "USER_SIGNED_OUT") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "WEAK_PASSWORD") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "WEB_STORAGE_UNSUPPORTED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "ALREADY_INITIALIZED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "RECAPTCHA_NOT_ENABLED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_RECAPTCHA_TOKEN") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_RECAPTCHA_TOKEN") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_RECAPTCHA_ACTION") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_CLIENT_TYPE") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "MISSING_RECAPTCHA_VERSION") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_RECAPTCHA_VERSION") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "INVALID_REQ_TYPE") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            if (e.tag === "DecodeError") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", e._1)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
            l();
        }
    }, cR = {
        show: (()=>{
            let e = U(V)({
                reflectSymbol: ()=>"ADMIN_ONLY_OPERATION"
            }), _ = U(V)({
                reflectSymbol: ()=>"ARGUMENT_ERROR"
            }), r = U(V)({
                reflectSymbol: ()=>"APP_NOT_AUTHORIZED"
            }), t = U(V)({
                reflectSymbol: ()=>"APP_NOT_INSTALLED"
            }), n = U(V)({
                reflectSymbol: ()=>"CAPTCHA_CHECK_FAILED"
            }), s = U(V)({
                reflectSymbol: ()=>"CODE_EXPIRED"
            }), c = U(V)({
                reflectSymbol: ()=>"CORDOVA_NOT_READY"
            }), i = U(V)({
                reflectSymbol: ()=>"CORS_UNSUPPORTED"
            }), d = U(V)({
                reflectSymbol: ()=>"CREDENTIAL_ALREADY_IN_USE"
            }), v = U(V)({
                reflectSymbol: ()=>"CREDENTIAL_MISMATCH"
            }), b = U(V)({
                reflectSymbol: ()=>"CREDENTIAL_TOO_OLD_LOGIN_AGAIN"
            }), p = U(V)({
                reflectSymbol: ()=>"DEPENDENT_SDK_INIT_BEFORE_AUTH"
            }), u = U(V)({
                reflectSymbol: ()=>"DYNAMIC_LINK_NOT_ACTIVATED"
            }), m = U(V)({
                reflectSymbol: ()=>"EMAIL_CHANGE_NEEDS_VERIFICATION"
            }), z = U(V)({
                reflectSymbol: ()=>"EMAIL_EXISTS"
            }), L = U(V)({
                reflectSymbol: ()=>"EMULATOR_CONFIG_FAILED"
            }), J = U(V)({
                reflectSymbol: ()=>"EXPIRED_OOB_CODE"
            }), c_ = U(V)({
                reflectSymbol: ()=>"EXPIRED_POPUP_REQUEST"
            }), t_ = U(V)({
                reflectSymbol: ()=>"INTERNAL_ERROR"
            }), W = U(V)({
                reflectSymbol: ()=>"INVALID_API_KEY"
            }), a_ = U(V)({
                reflectSymbol: ()=>"INVALID_APP_CREDENTIAL"
            }), Q = U(V)({
                reflectSymbol: ()=>"INVALID_APP_ID"
            }), F = U(V)({
                reflectSymbol: ()=>"INVALID_AUTH"
            }), y = U(V)({
                reflectSymbol: ()=>"INVALID_AUTH_EVENT"
            }), w = U(V)({
                reflectSymbol: ()=>"INVALID_CERT_HASH"
            }), x = U(V)({
                reflectSymbol: ()=>"INVALID_CODE"
            }), T = U(V)({
                reflectSymbol: ()=>"INVALID_CONTINUE_URI"
            }), C = U(V)({
                reflectSymbol: ()=>"INVALID_CORDOVA_CONFIGURATION"
            }), A = U(V)({
                reflectSymbol: ()=>"INVALID_CUSTOM_TOKEN"
            }), G = U(V)({
                reflectSymbol: ()=>"INVALID_DYNAMIC_LINK_DOMAIN"
            }), $_ = U(V)({
                reflectSymbol: ()=>"INVALID_EMAIL"
            }), i_ = U(V)({
                reflectSymbol: ()=>"INVALID_EMULATOR_SCHEME"
            }), W_ = U(V)({
                reflectSymbol: ()=>"INVALID_IDP_RESPONSE"
            }), g_ = U(V)({
                reflectSymbol: ()=>"INVALID_MESSAGE_PAYLOAD"
            }), U_ = U(V)({
                reflectSymbol: ()=>"INVALID_MFA_SESSION"
            }), we = U(V)({
                reflectSymbol: ()=>"INVALID_OAUTH_CLIENT_ID"
            }), p_ = U(V)({
                reflectSymbol: ()=>"INVALID_OAUTH_PROVIDER"
            }), pe = U(V)({
                reflectSymbol: ()=>"INVALID_OOB_CODE"
            }), Fe = U(V)({
                reflectSymbol: ()=>"INVALID_ORIGIN"
            }), n_ = U(V)({
                reflectSymbol: ()=>"INVALID_PASSWORD"
            }), N_ = U(V)({
                reflectSymbol: ()=>"INVALID_PERSISTENCE"
            }), H_ = U(V)({
                reflectSymbol: ()=>"INVALID_PHONE_NUMBER"
            }), P_ = U(V)({
                reflectSymbol: ()=>"INVALID_PROVIDER_ID"
            }), Z = U(V)({
                reflectSymbol: ()=>"INVALID_RECIPIENT_EMAIL"
            }), e_ = U(V)({
                reflectSymbol: ()=>"INVALID_SENDER"
            }), S_ = U(V)({
                reflectSymbol: ()=>"INVALID_SESSION_INFO"
            }), h_ = U(V)({
                reflectSymbol: ()=>"INVALID_TENANT_ID"
            }), G_ = U(V)({
                reflectSymbol: ()=>"MFA_INFO_NOT_FOUND"
            }), de = U(V)({
                reflectSymbol: ()=>"MFA_REQUIRED"
            }), C_ = U(V)({
                reflectSymbol: ()=>"MISSING_ANDROID_PACKAGE_NAME"
            }), L_ = U(V)({
                reflectSymbol: ()=>"MISSING_APP_CREDENTIAL"
            }), We = U(V)({
                reflectSymbol: ()=>"MISSING_AUTH_DOMAIN"
            }), Ne = U(V)({
                reflectSymbol: ()=>"MISSING_CODE"
            }), Xe = U(V)({
                reflectSymbol: ()=>"MISSING_CONTINUE_URI"
            }), lo = U(V)({
                reflectSymbol: ()=>"MISSING_IFRAME_START"
            }), ve = U(V)({
                reflectSymbol: ()=>"MISSING_IOS_BUNDLE_ID"
            }), b_ = U(V)({
                reflectSymbol: ()=>"MISSING_OR_INVALID_NONCE"
            }), D_ = U(V)({
                reflectSymbol: ()=>"MISSING_MFA_INFO"
            }), w_ = U(V)({
                reflectSymbol: ()=>"MISSING_MFA_SESSION"
            }), l_ = U(V)({
                reflectSymbol: ()=>"MISSING_PHONE_NUMBER"
            }), j_ = U(V)({
                reflectSymbol: ()=>"MISSING_SESSION_INFO"
            }), q_ = U(V)({
                reflectSymbol: ()=>"MODULE_DESTROYED"
            }), $e = U(V)({
                reflectSymbol: ()=>"NEED_CONFIRMATION"
            }), ee = U(V)({
                reflectSymbol: ()=>"NETWORK_REQUEST_FAILED"
            }), Ge = U(V)({
                reflectSymbol: ()=>"NULL_USER"
            }), _r = U(V)({
                reflectSymbol: ()=>"NO_AUTH_EVENT"
            }), er = U(V)({
                reflectSymbol: ()=>"NO_SUCH_PROVIDER"
            }), Ln = U(V)({
                reflectSymbol: ()=>"OPERATION_NOT_ALLOWED"
            }), dr = U(V)({
                reflectSymbol: ()=>"OPERATION_NOT_SUPPORTED"
            }), Xt = U(V)({
                reflectSymbol: ()=>"POPUP_BLOCKED"
            }), D0 = U(V)({
                reflectSymbol: ()=>"POPUP_CLOSED_BY_USER"
            }), lv = U(V)({
                reflectSymbol: ()=>"PROVIDER_ALREADY_LINKED"
            }), Gi = U(V)({
                reflectSymbol: ()=>"QUOTA_EXCEEDED"
            }), xb = U(V)({
                reflectSymbol: ()=>"REDIRECT_CANCELLED_BY_USER"
            }), Eb = U(V)({
                reflectSymbol: ()=>"REDIRECT_OPERATION_PENDING"
            }), Ci = U(V)({
                reflectSymbol: ()=>"REJECTED_CREDENTIAL"
            }), dv = U(V)({
                reflectSymbol: ()=>"SECOND_FACTOR_ALREADY_ENROLLED"
            }), vv = U(V)({
                reflectSymbol: ()=>"SECOND_FACTOR_LIMIT_EXCEEDED"
            }), Es = U(V)({
                reflectSymbol: ()=>"TENANT_ID_MISMATCH"
            }), Ai = U(V)({
                reflectSymbol: ()=>"TIMEOUT"
            }), Ni = U(V)({
                reflectSymbol: ()=>"TOKEN_EXPIRED"
            }), zn = U(V)({
                reflectSymbol: ()=>"TOO_MANY_ATTEMPTS_TRY_LATER"
            }), uv = U(V)({
                reflectSymbol: ()=>"UNAUTHORIZED_DOMAIN"
            }), Uc = U(V)({
                reflectSymbol: ()=>"UNSUPPORTED_FIRST_FACTOR"
            }), gv = U(V)({
                reflectSymbol: ()=>"UNSUPPORTED_PERSISTENCE"
            }), Ts = U(V)({
                reflectSymbol: ()=>"UNSUPPORTED_TENANT_OPERATION"
            }), bv = U(V)({
                reflectSymbol: ()=>"UNVERIFIED_EMAIL"
            }), or = U(V)({
                reflectSymbol: ()=>"USER_CANCELLED"
            }), pv = U(V)({
                reflectSymbol: ()=>"USER_DELETED"
            }), Gs = U(V)({
                reflectSymbol: ()=>"USER_DISABLED"
            }), Cs = U(V)({
                reflectSymbol: ()=>"USER_MISMATCH"
            }), Tb = U(V)({
                reflectSymbol: ()=>"USER_SIGNED_OUT"
            }), Gb = U(V)({
                reflectSymbol: ()=>"WEAK_PASSWORD"
            }), w0 = U(V)({
                reflectSymbol: ()=>"WEB_STORAGE_UNSUPPORTED"
            }), Cb = U(V)({
                reflectSymbol: ()=>"ALREADY_INITIALIZED"
            }), Ab = U(V)({
                reflectSymbol: ()=>"RECAPTCHA_NOT_ENABLED"
            }), Bc = U(V)({
                reflectSymbol: ()=>"MISSING_RECAPTCHA_TOKEN"
            }), fv = U(V)({
                reflectSymbol: ()=>"INVALID_RECAPTCHA_TOKEN"
            }), Fi = U(V)({
                reflectSymbol: ()=>"INVALID_RECAPTCHA_ACTION"
            }), Jc = U(V)({
                reflectSymbol: ()=>"MISSING_CLIENT_TYPE"
            }), Zt = U(V)({
                reflectSymbol: ()=>"MISSING_RECAPTCHA_VERSION"
            }), mv = U(V)({
                reflectSymbol: ()=>"INVALID_RECAPTCHA_VERSION"
            }), $v = U(V)({
                reflectSymbol: ()=>"INVALID_REQ_TYPE"
            }), Mi = U({
                genericShowArgs: (As)=>[
                        ge.show(As)
                    ]
            })({
                reflectSymbol: ()=>"DecodeError"
            });
            return (As)=>{
                let I = bP.from(As);
                if (I.tag === "Inl") return e["genericShow'"](I._1);
                if (I.tag === "Inr") {
                    if (I._1.tag === "Inl") return _["genericShow'"](I._1._1);
                    if (I._1.tag === "Inr") {
                        if (I._1._1.tag === "Inl") return r["genericShow'"](I._1._1._1);
                        if (I._1._1.tag === "Inr") {
                            if (I._1._1._1.tag === "Inl") return t["genericShow'"](I._1._1._1._1);
                            if (I._1._1._1.tag === "Inr") {
                                if (I._1._1._1._1.tag === "Inl") return n["genericShow'"](I._1._1._1._1._1);
                                if (I._1._1._1._1.tag === "Inr") {
                                    if (I._1._1._1._1._1.tag === "Inl") return s["genericShow'"](I._1._1._1._1._1._1);
                                    if (I._1._1._1._1._1.tag === "Inr") {
                                        if (I._1._1._1._1._1._1.tag === "Inl") return c["genericShow'"](I._1._1._1._1._1._1._1);
                                        if (I._1._1._1._1._1._1.tag === "Inr") {
                                            if (I._1._1._1._1._1._1._1.tag === "Inl") return i["genericShow'"](I._1._1._1._1._1._1._1._1);
                                            if (I._1._1._1._1._1._1._1.tag === "Inr") {
                                                if (I._1._1._1._1._1._1._1._1.tag === "Inl") return d["genericShow'"](I._1._1._1._1._1._1._1._1._1);
                                                if (I._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                    if (I._1._1._1._1._1._1._1._1._1.tag === "Inl") return v["genericShow'"](I._1._1._1._1._1._1._1._1._1._1);
                                                    if (I._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                        if (I._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return b["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1);
                                                        if (I._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                            if (I._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return p["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1);
                                                            if (I._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return u["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return m["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return z["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return L["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return J["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return c_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return t_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return W["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return a_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Q["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return F["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return y["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return w["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return x["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return T["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return C["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return A["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return G["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return $_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return i_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return W_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return g_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return U_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return we["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return p_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return pe["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Fe["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return n_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return N_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return H_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return P_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Z["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return e_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return S_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return h_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return G_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return de["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return C_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return L_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return We["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Ne["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Xe["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return lo["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return ve["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return b_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return D_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return w_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return l_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return j_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return q_["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return $e["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return ee["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Ge["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return _r["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return er["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Ln["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return dr["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Xt["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return D0["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return lv["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Gi["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return xb["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Eb["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Ci["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return dv["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return vv["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Es["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Ai["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Ni["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return zn["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return uv["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Uc["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return gv["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Ts["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return bv["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return or["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return pv["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Gs["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Cs["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Tb["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Gb["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return w0["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Cb["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Ab["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Bc["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return fv["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Fi["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Jc["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                                                            if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return Zt["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                                                                if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return mv["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                                                                    if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                                                                                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return $v["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                                                                        if (I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") return Mi["genericShow'"](I._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                                                                                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                l();
                                                                                                                                                                                                                            }
                                                                                                                                                                                                                            l();
                                                                                                                                                                                                                        }
                                                                                                                                                                                                                        l();
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    l();
                                                                                                                                                                                                                }
                                                                                                                                                                                                                l();
                                                                                                                                                                                                            }
                                                                                                                                                                                                            l();
                                                                                                                                                                                                        }
                                                                                                                                                                                                        l();
                                                                                                                                                                                                    }
                                                                                                                                                                                                    l();
                                                                                                                                                                                                }
                                                                                                                                                                                                l();
                                                                                                                                                                                            }
                                                                                                                                                                                            l();
                                                                                                                                                                                        }
                                                                                                                                                                                        l();
                                                                                                                                                                                    }
                                                                                                                                                                                    l();
                                                                                                                                                                                }
                                                                                                                                                                                l();
                                                                                                                                                                            }
                                                                                                                                                                            l();
                                                                                                                                                                        }
                                                                                                                                                                        l();
                                                                                                                                                                    }
                                                                                                                                                                    l();
                                                                                                                                                                }
                                                                                                                                                                l();
                                                                                                                                                            }
                                                                                                                                                            l();
                                                                                                                                                        }
                                                                                                                                                        l();
                                                                                                                                                    }
                                                                                                                                                    l();
                                                                                                                                                }
                                                                                                                                                l();
                                                                                                                                            }
                                                                                                                                            l();
                                                                                                                                        }
                                                                                                                                        l();
                                                                                                                                    }
                                                                                                                                    l();
                                                                                                                                }
                                                                                                                                l();
                                                                                                                            }
                                                                                                                            l();
                                                                                                                        }
                                                                                                                        l();
                                                                                                                    }
                                                                                                                    l();
                                                                                                                }
                                                                                                                l();
                                                                                                            }
                                                                                                            l();
                                                                                                        }
                                                                                                        l();
                                                                                                    }
                                                                                                    l();
                                                                                                }
                                                                                                l();
                                                                                            }
                                                                                            l();
                                                                                        }
                                                                                        l();
                                                                                    }
                                                                                    l();
                                                                                }
                                                                                l();
                                                                            }
                                                                            l();
                                                                        }
                                                                        l();
                                                                    }
                                                                    l();
                                                                }
                                                                l();
                                                            }
                                                            l();
                                                        }
                                                        l();
                                                    }
                                                    l();
                                                }
                                                l();
                                            }
                                            l();
                                        }
                                        l();
                                    }
                                    l();
                                }
                                l();
                            }
                            l();
                        }
                        l();
                    }
                    l();
                }
                l();
            };
        })()
    }, pP = {
        decodeJson: (e)=>F_.bind(Q_((_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), I_, (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), e))((_)=>S("Right", (()=>_ === "auth/admin-restricted-operation" ? v8 : _ === "auth/argument-error" ? u8 : _ === "auth/app-not-authorized" ? g8 : _ === "auth/app-not-installed" ? b8 : _ === "auth/captcha-check-failed" ? p8 : _ === "auth/code-expired" ? f8 : _ === "auth/cordova-not-ready" ? m8 : _ === "auth/cors-unsupported" ? $8 : _ === "auth/credential-already-in-use" ? h8 : _ === "auth/custom-token-mismatch" ? y8 : _ === "auth/requires-recent-login" ? D8 : _ === "auth/dependent-sdk-initialized-before-auth" ? w8 : _ === "auth/dynamic-link-not-activated" ? R8 : _ === "auth/email-change-needs-verification" ? k8 : _ === "auth/email-already-in-use" ? S8 : _ === "auth/emulator-config-failed" ? I8 : _ === "auth/expired-action-code" ? x8 : _ === "auth/cancelled-popup-request" ? E8 : _ === "auth/internal-error" ? T8 : _ === "auth/invalid-api-key" ? G8 : _ === "auth/invalid-app-credential" ? C8 : _ === "auth/invalid-app-id" ? A8 : _ === "auth/invalid-user-token" ? N8 : _ === "auth/invalid-auth-event" ? F8 : _ === "auth/invalid-cert-hash" ? M8 : _ === "auth/invalid-verification-code" ? P8 : _ === "auth/invalid-continue-uri" ? L8 : _ === "auth/invalid-cordova-configuration" ? z8 : _ === "auth/invalid-custom-token" ? O8 : _ === "auth/invalid-dynamic-link-domain" ? U8 : _ === "auth/invalid-email" ? B8 : _ === "auth/invalid-emulator-scheme" ? J8 : _ === "auth/invalid-credential" ? V8 : _ === "auth/invalid-message-payload" ? q8 : _ === "auth/invalid-multi-factor-session" ? W8 : _ === "auth/invalid-oauth-client-id" ? H8 : _ === "auth/invalid-oauth-provider" ? j8 : _ === "auth/invalid-action-code" ? K8 : _ === "auth/unauthorized-domain" ? Q8 : _ === "auth/wrong-password" ? Y8 : _ === "auth/invalid-persistence-type" ? X8 : _ === "auth/invalid-phone-number" ? Z8 : _ === "auth/invalid-provider-id" ? _w : _ === "auth/invalid-recipient-email" ? ew : _ === "auth/invalid-sender" ? ow : _ === "auth/invalid-verification-id" ? rw : _ === "auth/invalid-tenant-id" ? tw : _ === "auth/multi-factor-info-not-found" ? nw : _ === "auth/multi-factor-auth-required" ? sw : _ === "auth/missing-android-pkg-name" ? cw : _ === "auth/missing-app-credential" ? aw : _ === "auth/auth-domain-config-required" ? iw : _ === "auth/missing-verification-code" ? lw : _ === "auth/missing-continue-uri" ? dw : _ === "auth/missing-iframe-start" ? vw : _ === "auth/missing-ios-bundle-id" ? uw : _ === "auth/missing-or-invalid-nonce" ? gw : _ === "auth/missing-multi-factor-info" ? bw : _ === "auth/missing-multi-factor-session" ? pw : _ === "auth/missing-phone-number" ? fw : _ === "auth/missing-verification-id" ? mw : _ === "auth/app-deleted" ? $w : _ === "auth/account-exists-with-different-credential" ? hw : _ === "auth/network-request-failed" ? yw : _ === "auth/null-user" ? Dw : _ === "auth/no-auth-event" ? ww : _ === "auth/no-such-provider" ? Rw : _ === "auth/operation-not-allowed" ? kw : _ === "auth/operation-not-supported-in-this-environment" ? Sw : _ === "auth/popup-blocked" ? Iw : _ === "auth/popup-closed-by-user" ? xw : _ === "auth/provider-already-linked" ? Ew : _ === "auth/quota-exceeded" ? Tw : _ === "auth/redirect-cancelled-by-user" ? Gw : _ === "auth/redirect-operation-pending" ? Cw : _ === "auth/rejected-credential" ? Aw : _ === "auth/second-factor-already-in-use" ? Nw : _ === "auth/maximum-second-factor-count-exceeded" ? Fw : _ === "auth/tenant-id-mismatch" ? Mw : _ === "auth/timeout" ? Pw : _ === "auth/user-token-expired" ? Lw : _ === "auth/too-many-requests" ? zw : _ === "auth/unauthorized-continue-uri" ? Ow : _ === "auth/unsupported-first-factor" ? Uw : _ === "auth/unsupported-persistence-type" ? Bw : _ === "auth/unsupported-tenant-operation" ? Jw : _ === "auth/unverified-email" ? Vw : _ === "auth/user-cancelled" ? qw : _ === "auth/user-not-found" ? Ww : _ === "auth/user-disabled" ? Hw : _ === "auth/user-mismatch" ? jw : _ === "auth/user-signed-out" ? Kw : _ === "auth/weak-password" ? Qw : _ === "auth/web-storage-unsupported" ? Yw : _ === "auth/already-initialized" ? Xw : _ === "auth/recaptcha-not-enabled" ? Zw : _ === "auth/missing-recaptcha-token" ? _R : _ === "auth/invalid-recaptcha-token" ? eR : _ === "auth/invalid-recaptcha-action" ? oR : _ === "auth/missing-client-type" ? rR : _ === "auth/missing-recaptcha-version" ? tR : _ === "auth/invalid-recaptcha-version" ? nR : _ === "auth/invalid-req-type" ? sR : r_("DecodeError", H("UnexpectedValue", e)))()))
    }, fP = (e)=>{
        let _ = pP.decodeJson(e);
        if (_.tag === "Left") return r_("DecodeError", _._1);
        if (_.tag === "Right") return _._1;
        l();
    }, aR = {
        mapAffError: (e)=>fP(No(e))
    };
    function H1(e, _) {
        var r = {};
        for(var t in e)Object.prototype.hasOwnProperty.call(e, t) && _.indexOf(t) < 0 && (r[t] = e[t]);
        if (e != null && typeof Object.getOwnPropertySymbols == "function") for(var n = 0, t = Object.getOwnPropertySymbols(e); n < t.length; n++)_.indexOf(t[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[n]) && (r[t[n]] = e[t[n]]);
        return r;
    }
    function IR() {
        return {
            "dependent-sdk-initialized-before-auth": "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
        };
    }
    var xR = IR, ER = new Yn("auth", "Firebase", IR());
    var Z1 = new J0("@firebase/auth");
    function mP(e, ..._) {
        Z1.logLevel <= ye.WARN && Z1.warn(`Auth (${q0}): ${e}`, ..._);
    }
    function K1(e, ..._) {
        Z1.logLevel <= ye.ERROR && Z1.error(`Auth (${q0}): ${e}`, ..._);
    }
    function Vt(e, ..._) {
        throw L$(e, ..._);
    }
    function Sn(e, ..._) {
        return L$(e, ..._);
    }
    function TR(e, _, r) {
        let t = Object.assign(Object.assign({}, xR()), {
            [_]: r
        });
        return new Yn("auth", "Firebase", t).create(_, {
            appName: e.name
        });
    }
    function bs(e) {
        return TR(e, "operation-not-supported-in-this-environment", "Operations that alter the current user are not supported in conjunction with FirebaseServerApp");
    }
    function L$(e, ..._) {
        if (typeof e != "string") {
            let r = _[0], t = [
                ..._.slice(1)
            ];
            return t[0] && (t[0].appName = e.name), e._errorFactory.create(r, ...t);
        }
        return ER.create(e, ..._);
    }
    function M_(e, _, ...r) {
        if (!e) throw L$(_, ...r);
    }
    function kn(e) {
        let _ = "INTERNAL ASSERTION FAILED: " + e;
        throw K1(_), new Error(_);
    }
    function d0(e, _) {
        e || kn(_);
    }
    function h$() {
        var e;
        return typeof self < "u" && ((e = self.location) === null || e === void 0 ? void 0 : e.href) || "";
    }
    function $P() {
        return lR() === "http:" || lR() === "https:";
    }
    function lR() {
        var e;
        return typeof self < "u" && ((e = self.location) === null || e === void 0 ? void 0 : e.protocol) || null;
    }
    function hP() {
        return typeof navigator < "u" && navigator && "onLine" in navigator && typeof navigator.onLine == "boolean" && ($P() || I9() || "connection" in navigator) ? navigator.onLine : !0;
    }
    function yP() {
        if (typeof navigator > "u") return null;
        let e = navigator;
        return e.languages && e.languages[0] || e.language || null;
    }
    var Dc = class {
        constructor(_, r){
            this.shortDelay = _, this.longDelay = r, d0(r > _, "Short delay should be less than long delay!"), this.isMobile = S9() || x9();
        }
        get() {
            return hP() ? this.isMobile ? this.longDelay : this.shortDelay : Math.min(5e3, this.shortDelay);
        }
    };
    function z$(e, _) {
        d0(e.emulator, "Emulator should always be set here");
        let { url: r  } = e.emulator;
        return _ ? `${r}${_.startsWith("/") ? _.slice(1) : _}` : r;
    }
    var _g = class {
        static initialize(_, r, t) {
            this.fetchImpl = _, r && (this.headersImpl = r), t && (this.responseImpl = t);
        }
        static fetch() {
            if (this.fetchImpl) return this.fetchImpl;
            if (typeof self < "u" && "fetch" in self) return self.fetch;
            if (typeof globalThis < "u" && globalThis.fetch) return globalThis.fetch;
            if (typeof fetch < "u") return fetch;
            kn("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
        }
        static headers() {
            if (this.headersImpl) return this.headersImpl;
            if (typeof self < "u" && "Headers" in self) return self.Headers;
            if (typeof globalThis < "u" && globalThis.Headers) return globalThis.Headers;
            if (typeof Headers < "u") return Headers;
            kn("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
        }
        static response() {
            if (this.responseImpl) return this.responseImpl;
            if (typeof self < "u" && "Response" in self) return self.Response;
            if (typeof globalThis < "u" && globalThis.Response) return globalThis.Response;
            if (typeof Response < "u") return Response;
            kn("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
        }
    };
    var DP = {
        CREDENTIAL_MISMATCH: "custom-token-mismatch",
        MISSING_CUSTOM_TOKEN: "internal-error",
        INVALID_IDENTIFIER: "invalid-email",
        MISSING_CONTINUE_URI: "internal-error",
        INVALID_PASSWORD: "wrong-password",
        MISSING_PASSWORD: "missing-password",
        INVALID_LOGIN_CREDENTIALS: "invalid-credential",
        EMAIL_EXISTS: "email-already-in-use",
        PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
        INVALID_IDP_RESPONSE: "invalid-credential",
        INVALID_PENDING_TOKEN: "invalid-credential",
        FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
        MISSING_REQ_TYPE: "internal-error",
        EMAIL_NOT_FOUND: "user-not-found",
        RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
        EXPIRED_OOB_CODE: "expired-action-code",
        INVALID_OOB_CODE: "invalid-action-code",
        MISSING_OOB_CODE: "internal-error",
        CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
        INVALID_ID_TOKEN: "invalid-user-token",
        TOKEN_EXPIRED: "user-token-expired",
        USER_NOT_FOUND: "user-token-expired",
        TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
        PASSWORD_DOES_NOT_MEET_REQUIREMENTS: "password-does-not-meet-requirements",
        INVALID_CODE: "invalid-verification-code",
        INVALID_SESSION_INFO: "invalid-verification-id",
        INVALID_TEMPORARY_PROOF: "invalid-credential",
        MISSING_SESSION_INFO: "missing-verification-id",
        SESSION_EXPIRED: "code-expired",
        MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
        UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
        INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
        ADMIN_ONLY_OPERATION: "admin-restricted-operation",
        INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
        MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
        MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
        MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
        SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
        SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
        BLOCKING_FUNCTION_ERROR_RESPONSE: "internal-error",
        RECAPTCHA_NOT_ENABLED: "recaptcha-not-enabled",
        MISSING_RECAPTCHA_TOKEN: "missing-recaptcha-token",
        INVALID_RECAPTCHA_TOKEN: "invalid-recaptcha-token",
        INVALID_RECAPTCHA_ACTION: "invalid-recaptcha-action",
        MISSING_CLIENT_TYPE: "missing-client-type",
        MISSING_RECAPTCHA_VERSION: "missing-recaptcha-version",
        INVALID_RECAPTCHA_VERSION: "invalid-recaptcha-version",
        INVALID_REQ_TYPE: "invalid-req-type"
    };
    var wP = new Dc(3e4, 6e4);
    function Zo(e, _) {
        return e.tenantId && !_.tenantId ? Object.assign(Object.assign({}, _), {
            tenantId: e.tenantId
        }) : _;
    }
    async function Rr(e, _, r, t, n = {}) {
        return GR(e, n, async ()=>{
            let s = {}, c = {};
            t && (_ === "GET" ? c = t : s = {
                body: JSON.stringify(t)
            });
            let i = da(Object.assign({
                key: e.config.apiKey
            }, c)).slice(1), d = await e._getAdditionalHeaders();
            return d["Content-Type"] = "application/json", e.languageCode && (d["X-Firebase-Locale"] = e.languageCode), _g.fetch()(CR(e, e.config.apiHost, r, i), Object.assign({
                method: _,
                headers: d,
                referrerPolicy: "no-referrer"
            }, s));
        });
    }
    async function GR(e, _, r) {
        e._canInitEmulator = !1;
        let t = Object.assign(Object.assign({}, DP), _);
        try {
            let n = new y$(e), s = await Promise.race([
                r(),
                n.promise
            ]);
            n.clearNetworkTimeout();
            let c = await s.json();
            if ("needConfirmation" in c) throw hd(e, "account-exists-with-different-credential", c);
            if (s.ok && !("errorMessage" in c)) return c;
            {
                let i = s.ok ? c.errorMessage : c.error.message, [d, v] = i.split(" : ");
                if (d === "FEDERATED_USER_ID_ALREADY_LINKED") throw hd(e, "credential-already-in-use", c);
                if (d === "EMAIL_EXISTS") throw hd(e, "email-already-in-use", c);
                if (d === "USER_DISABLED") throw hd(e, "user-disabled", c);
                let b = t[d] || d.toLowerCase().replace(/[_\s]+/g, "-");
                if (v) throw TR(e, b, v);
                Vt(e, b);
            }
        } catch (n) {
            if (n instanceof Nr) throw n;
            Vt(e, "network-request-failed", {
                message: String(n)
            });
        }
    }
    async function xc(e, _, r, t, n = {}) {
        let s = await Rr(e, _, r, t, n);
        return "mfaPendingCredential" in s && Vt(e, "multi-factor-auth-required", {
            _serverResponse: s
        }), s;
    }
    function CR(e, _, r, t) {
        let n = `${_}${r}?${t}`;
        return e.config.emulator ? z$(e.config, n) : `${e.config.apiScheme}://${n}`;
    }
    function RP(e) {
        switch(e){
            case "ENFORCE":
                return "ENFORCE";
            case "AUDIT":
                return "AUDIT";
            case "OFF":
                return "OFF";
            default:
                return "ENFORCEMENT_STATE_UNSPECIFIED";
        }
    }
    var y$ = class {
        constructor(_){
            this.auth = _, this.timer = null, this.promise = new Promise((r, t)=>{
                this.timer = setTimeout(()=>t(Sn(this.auth, "network-request-failed")), wP.get());
            });
        }
        clearNetworkTimeout() {
            clearTimeout(this.timer);
        }
    };
    function hd(e, _, r) {
        let t = {
            appName: e.name
        };
        r.email && (t.email = r.email), r.phoneNumber && (t.phoneNumber = r.phoneNumber);
        let n = Sn(e, _, t);
        return n.customData._tokenResponse = r, n;
    }
    function dR(e) {
        return e !== void 0 && e.enterprise !== void 0;
    }
    var D$ = class {
        constructor(_){
            if (this.siteKey = "", this.recaptchaEnforcementState = [], _.recaptchaKey === void 0) throw new Error("recaptchaKey undefined");
            this.siteKey = _.recaptchaKey.split("/")[3], this.recaptchaEnforcementState = _.recaptchaEnforcementState;
        }
        getProviderEnforcementState(_) {
            if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
            for (let r of this.recaptchaEnforcementState)if (r.provider && r.provider === _) return RP(r.enforcementState);
            return null;
        }
        isProviderEnabled(_) {
            return this.getProviderEnforcementState(_) === "ENFORCE" || this.getProviderEnforcementState(_) === "AUDIT";
        }
    };
    async function kP(e, _) {
        return Rr(e, "GET", "/v2/recaptchaConfig", Zo(e, _));
    }
    async function SP(e, _) {
        return Rr(e, "POST", "/v1/accounts:delete", _);
    }
    async function AR(e, _) {
        return Rr(e, "POST", "/v1/accounts:lookup", _);
    }
    function yd(e) {
        if (e) try {
            let _ = new Date(Number(e));
            if (!isNaN(_.getTime())) return _.toUTCString();
        } catch  {}
    }
    async function NR(e, _ = !1) {
        let r = mo(e), t = await r.getIdToken(_), n = O$(t);
        M_(n && n.exp && n.auth_time && n.iat, r.auth, "internal-error");
        let s = typeof n.firebase == "object" ? n.firebase : void 0, c = s?.sign_in_provider;
        return {
            claims: n,
            token: t,
            authTime: yd(m$(n.auth_time)),
            issuedAtTime: yd(m$(n.iat)),
            expirationTime: yd(m$(n.exp)),
            signInProvider: c || null,
            signInSecondFactor: s?.sign_in_second_factor || null
        };
    }
    function m$(e) {
        return Number(e) * 1e3;
    }
    function O$(e) {
        let [_, r, t] = e.split(".");
        if (_ === void 0 || r === void 0 || t === void 0) return K1("JWT malformed, contained fewer than 3 sections"), null;
        try {
            let n = Qp(r);
            return n ? JSON.parse(n) : (K1("Failed to decode base64 JWT payload"), null);
        } catch (n) {
            return K1("Caught error parsing JWT payload as JSON", n?.toString()), null;
        }
    }
    function vR(e) {
        let _ = O$(e);
        return M_(_, "internal-error"), M_(typeof _.exp < "u", "internal-error"), M_(typeof _.iat < "u", "internal-error"), Number(_.exp) - Number(_.iat);
    }
    async function wd(e, _, r = !1) {
        if (r) return _;
        try {
            return await _;
        } catch (t) {
            throw t instanceof Nr && IP(t) && e.auth.currentUser === e && await e.auth.signOut(), t;
        }
    }
    function IP({ code: e  }) {
        return e === "auth/user-disabled" || e === "auth/user-token-expired";
    }
    var w$ = class {
        constructor(_){
            this.user = _, this.isRunning = !1, this.timerId = null, this.errorBackoff = 3e4;
        }
        _start() {
            this.isRunning || (this.isRunning = !0, this.schedule());
        }
        _stop() {
            this.isRunning && (this.isRunning = !1, this.timerId !== null && clearTimeout(this.timerId));
        }
        getInterval(_) {
            var r;
            if (_) {
                let t = this.errorBackoff;
                return this.errorBackoff = Math.min(this.errorBackoff * 2, 96e4), t;
            } else {
                this.errorBackoff = 3e4;
                let n = ((r = this.user.stsTokenManager.expirationTime) !== null && r !== void 0 ? r : 0) - Date.now() - 3e5;
                return Math.max(0, n);
            }
        }
        schedule(_ = !1) {
            if (!this.isRunning) return;
            let r = this.getInterval(_);
            this.timerId = setTimeout(async ()=>{
                await this.iteration();
            }, r);
        }
        async iteration() {
            try {
                await this.user.getIdToken(!0);
            } catch (_) {
                _?.code === "auth/network-request-failed" && this.schedule(!0);
                return;
            }
            this.schedule();
        }
    };
    var Rd = class {
        constructor(_, r){
            this.createdAt = _, this.lastLoginAt = r, this._initializeTime();
        }
        _initializeTime() {
            this.lastSignInTime = yd(this.lastLoginAt), this.creationTime = yd(this.createdAt);
        }
        _copy(_) {
            this.createdAt = _.createdAt, this.lastLoginAt = _.lastLoginAt, this._initializeTime();
        }
        toJSON() {
            return {
                createdAt: this.createdAt,
                lastLoginAt: this.lastLoginAt
            };
        }
    };
    async function eg(e) {
        var _;
        let r = e.auth, t = await e.getIdToken(), n = await wd(e, AR(r, {
            idToken: t
        }));
        M_(n?.users.length, r, "internal-error");
        let s = n.users[0];
        e._notifyReloadListener(s);
        let c = !((_ = s.providerUserInfo) === null || _ === void 0) && _.length ? MR(s.providerUserInfo) : [], i = xP(e.providerData, c), d = e.isAnonymous, v = !(e.email && s.passwordHash) && !i?.length, b = d ? v : !1, p = {
            uid: s.localId,
            displayName: s.displayName || null,
            photoURL: s.photoUrl || null,
            email: s.email || null,
            emailVerified: s.emailVerified || !1,
            phoneNumber: s.phoneNumber || null,
            tenantId: s.tenantId || null,
            providerData: i,
            metadata: new Rd(s.createdAt, s.lastLoginAt),
            isAnonymous: b
        };
        Object.assign(e, p);
    }
    async function FR(e) {
        let _ = mo(e);
        await eg(_), await _.auth._persistUserIfCurrent(_), _.auth._notifyListenersIfCurrent(_);
    }
    function xP(e, _) {
        return [
            ...e.filter((t)=>!_.some((n)=>n.providerId === t.providerId)),
            ..._
        ];
    }
    function MR(e) {
        return e.map((_)=>{
            var { providerId: r  } = _, t = H1(_, [
                "providerId"
            ]);
            return {
                providerId: r,
                uid: t.rawId || "",
                displayName: t.displayName || null,
                email: t.email || null,
                phoneNumber: t.phoneNumber || null,
                photoURL: t.photoUrl || null
            };
        });
    }
    async function EP(e, _) {
        let r = await GR(e, {}, async ()=>{
            let t = da({
                grant_type: "refresh_token",
                refresh_token: _
            }).slice(1), { tokenApiHost: n , apiKey: s  } = e.config, c = CR(e, n, "/v1/token", `key=${s}`), i = await e._getAdditionalHeaders();
            return i["Content-Type"] = "application/x-www-form-urlencoded", _g.fetch()(c, {
                method: "POST",
                headers: i,
                body: t
            });
        });
        return {
            accessToken: r.access_token,
            expiresIn: r.expires_in,
            refreshToken: r.refresh_token
        };
    }
    async function TP(e, _) {
        return Rr(e, "POST", "/v2/accounts:revokeToken", Zo(e, _));
    }
    var Dd = class e {
        constructor(){
            this.refreshToken = null, this.accessToken = null, this.expirationTime = null;
        }
        get isExpired() {
            return !this.expirationTime || Date.now() > this.expirationTime - 3e4;
        }
        updateFromServerResponse(_) {
            M_(_.idToken, "internal-error"), M_(typeof _.idToken < "u", "internal-error"), M_(typeof _.refreshToken < "u", "internal-error");
            let r = "expiresIn" in _ && typeof _.expiresIn < "u" ? Number(_.expiresIn) : vR(_.idToken);
            this.updateTokensAndExpiration(_.idToken, _.refreshToken, r);
        }
        updateFromIdToken(_) {
            M_(_.length !== 0, "internal-error");
            let r = vR(_);
            this.updateTokensAndExpiration(_, null, r);
        }
        async getToken(_, r = !1) {
            return !r && this.accessToken && !this.isExpired ? this.accessToken : (M_(this.refreshToken, _, "user-token-expired"), this.refreshToken ? (await this.refresh(_, this.refreshToken), this.accessToken) : null);
        }
        clearRefreshToken() {
            this.refreshToken = null;
        }
        async refresh(_, r) {
            let { accessToken: t , refreshToken: n , expiresIn: s  } = await EP(_, r);
            this.updateTokensAndExpiration(t, n, Number(s));
        }
        updateTokensAndExpiration(_, r, t) {
            this.refreshToken = r || null, this.accessToken = _ || null, this.expirationTime = Date.now() + t * 1e3;
        }
        static fromJSON(_, r) {
            let { refreshToken: t , accessToken: n , expirationTime: s  } = r, c = new e;
            return t && (M_(typeof t == "string", "internal-error", {
                appName: _
            }), c.refreshToken = t), n && (M_(typeof n == "string", "internal-error", {
                appName: _
            }), c.accessToken = n), s && (M_(typeof s == "number", "internal-error", {
                appName: _
            }), c.expirationTime = s), c;
        }
        toJSON() {
            return {
                refreshToken: this.refreshToken,
                accessToken: this.accessToken,
                expirationTime: this.expirationTime
            };
        }
        _assign(_) {
            this.accessToken = _.accessToken, this.refreshToken = _.refreshToken, this.expirationTime = _.expirationTime;
        }
        _clone() {
            return Object.assign(new e, this.toJSON());
        }
        _performRefresh() {
            return kn("not implemented");
        }
    };
    function gs(e, _) {
        M_(typeof e == "string" || typeof e > "u", "internal-error", {
            appName: _
        });
    }
    var oi = class e {
        constructor(_){
            var { uid: r , auth: t , stsTokenManager: n  } = _, s = H1(_, [
                "uid",
                "auth",
                "stsTokenManager"
            ]);
            this.providerId = "firebase", this.proactiveRefresh = new w$(this), this.reloadUserInfo = null, this.reloadListener = null, this.uid = r, this.auth = t, this.stsTokenManager = n, this.accessToken = n.accessToken, this.displayName = s.displayName || null, this.email = s.email || null, this.emailVerified = s.emailVerified || !1, this.phoneNumber = s.phoneNumber || null, this.photoURL = s.photoURL || null, this.isAnonymous = s.isAnonymous || !1, this.tenantId = s.tenantId || null, this.providerData = s.providerData ? [
                ...s.providerData
            ] : [], this.metadata = new Rd(s.createdAt || void 0, s.lastLoginAt || void 0);
        }
        async getIdToken(_) {
            let r = await wd(this, this.stsTokenManager.getToken(this.auth, _));
            return M_(r, this.auth, "internal-error"), this.accessToken !== r && (this.accessToken = r, await this.auth._persistUserIfCurrent(this), this.auth._notifyListenersIfCurrent(this)), r;
        }
        getIdTokenResult(_) {
            return NR(this, _);
        }
        reload() {
            return FR(this);
        }
        _assign(_) {
            this !== _ && (M_(this.uid === _.uid, this.auth, "internal-error"), this.displayName = _.displayName, this.photoURL = _.photoURL, this.email = _.email, this.emailVerified = _.emailVerified, this.phoneNumber = _.phoneNumber, this.isAnonymous = _.isAnonymous, this.tenantId = _.tenantId, this.providerData = _.providerData.map((r)=>Object.assign({}, r)), this.metadata._copy(_.metadata), this.stsTokenManager._assign(_.stsTokenManager));
        }
        _clone(_) {
            let r = new e(Object.assign(Object.assign({}, this), {
                auth: _,
                stsTokenManager: this.stsTokenManager._clone()
            }));
            return r.metadata._copy(this.metadata), r;
        }
        _onReload(_) {
            M_(!this.reloadListener, this.auth, "internal-error"), this.reloadListener = _, this.reloadUserInfo && (this._notifyReloadListener(this.reloadUserInfo), this.reloadUserInfo = null);
        }
        _notifyReloadListener(_) {
            this.reloadListener ? this.reloadListener(_) : this.reloadUserInfo = _;
        }
        _startProactiveRefresh() {
            this.proactiveRefresh._start();
        }
        _stopProactiveRefresh() {
            this.proactiveRefresh._stop();
        }
        async _updateTokensIfNecessary(_, r = !1) {
            let t = !1;
            _.idToken && _.idToken !== this.stsTokenManager.accessToken && (this.stsTokenManager.updateFromServerResponse(_), t = !0), r && await eg(this), await this.auth._persistUserIfCurrent(this), t && this.auth._notifyListenersIfCurrent(this);
        }
        async delete() {
            if (ln(this.auth.app)) return Promise.reject(bs(this.auth));
            let _ = await this.getIdToken();
            return await wd(this, SP(this.auth, {
                idToken: _
            })), this.stsTokenManager.clearRefreshToken(), this.auth.signOut();
        }
        toJSON() {
            return Object.assign(Object.assign({
                uid: this.uid,
                email: this.email || void 0,
                emailVerified: this.emailVerified,
                displayName: this.displayName || void 0,
                isAnonymous: this.isAnonymous,
                photoURL: this.photoURL || void 0,
                phoneNumber: this.phoneNumber || void 0,
                tenantId: this.tenantId || void 0,
                providerData: this.providerData.map((_)=>Object.assign({}, _)),
                stsTokenManager: this.stsTokenManager.toJSON(),
                _redirectEventId: this._redirectEventId
            }, this.metadata.toJSON()), {
                apiKey: this.auth.config.apiKey,
                appName: this.auth.name
            });
        }
        get refreshToken() {
            return this.stsTokenManager.refreshToken || "";
        }
        static _fromJSON(_, r) {
            var t, n, s, c, i, d, v, b;
            let p = (t = r.displayName) !== null && t !== void 0 ? t : void 0, u = (n = r.email) !== null && n !== void 0 ? n : void 0, m = (s = r.phoneNumber) !== null && s !== void 0 ? s : void 0, z = (c = r.photoURL) !== null && c !== void 0 ? c : void 0, L = (i = r.tenantId) !== null && i !== void 0 ? i : void 0, J = (d = r._redirectEventId) !== null && d !== void 0 ? d : void 0, c_ = (v = r.createdAt) !== null && v !== void 0 ? v : void 0, t_ = (b = r.lastLoginAt) !== null && b !== void 0 ? b : void 0, { uid: W , emailVerified: a_ , isAnonymous: Q , providerData: F , stsTokenManager: y  } = r;
            M_(W && y, _, "internal-error");
            let w = Dd.fromJSON(this.name, y);
            M_(typeof W == "string", _, "internal-error"), gs(p, _.name), gs(u, _.name), M_(typeof a_ == "boolean", _, "internal-error"), M_(typeof Q == "boolean", _, "internal-error"), gs(m, _.name), gs(z, _.name), gs(L, _.name), gs(J, _.name), gs(c_, _.name), gs(t_, _.name);
            let x = new e({
                uid: W,
                auth: _,
                email: u,
                emailVerified: a_,
                displayName: p,
                isAnonymous: Q,
                photoURL: z,
                phoneNumber: m,
                tenantId: L,
                stsTokenManager: w,
                createdAt: c_,
                lastLoginAt: t_
            });
            return F && Array.isArray(F) && (x.providerData = F.map((T)=>Object.assign({}, T))), J && (x._redirectEventId = J), x;
        }
        static async _fromIdTokenResponse(_, r, t = !1) {
            let n = new Dd;
            n.updateFromServerResponse(r);
            let s = new e({
                uid: r.localId,
                auth: _,
                stsTokenManager: n,
                isAnonymous: t
            });
            return await eg(s), s;
        }
        static async _fromGetAccountInfoResponse(_, r, t) {
            let n = r.users[0];
            M_(n.localId !== void 0, "internal-error");
            let s = n.providerUserInfo !== void 0 ? MR(n.providerUserInfo) : [], c = !(n.email && n.passwordHash) && !s?.length, i = new Dd;
            i.updateFromIdToken(t);
            let d = new e({
                uid: n.localId,
                auth: _,
                stsTokenManager: i,
                isAnonymous: c
            }), v = {
                uid: n.localId,
                displayName: n.displayName || null,
                photoURL: n.photoUrl || null,
                email: n.email || null,
                emailVerified: n.emailVerified || !1,
                phoneNumber: n.phoneNumber || null,
                tenantId: n.tenantId || null,
                providerData: s,
                metadata: new Rd(n.createdAt, n.lastLoginAt),
                isAnonymous: !(n.email && n.passwordHash) && !s?.length
            };
            return Object.assign(d, v), d;
        }
    };
    var uR = new Map;
    function l0(e) {
        d0(e instanceof Function, "Expected a class definition");
        let _ = uR.get(e);
        return _ ? (d0(_ instanceof e, "Instance stored in cache mismatched with class"), _) : (_ = new e, uR.set(e, _), _);
    }
    var og = class {
        constructor(){
            this.type = "NONE", this.storage = {};
        }
        async _isAvailable() {
            return !0;
        }
        async _set(_, r) {
            this.storage[_] = r;
        }
        async _get(_) {
            let r = this.storage[_];
            return r === void 0 ? null : r;
        }
        async _remove(_) {
            delete this.storage[_];
        }
        _addListener(_, r) {}
        _removeListener(_, r) {}
    };
    og.type = "NONE";
    var R$ = og;
    function Q1(e, _, r) {
        return `firebase:${e}:${_}:${r}`;
    }
    var rg = class e {
        constructor(_, r, t){
            this.persistence = _, this.auth = r, this.userKey = t;
            let { config: n , name: s  } = this.auth;
            this.fullUserKey = Q1(this.userKey, n.apiKey, s), this.fullPersistenceKey = Q1("persistence", n.apiKey, s), this.boundEventHandler = r._onStorageEvent.bind(r), this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
        }
        setCurrentUser(_) {
            return this.persistence._set(this.fullUserKey, _.toJSON());
        }
        async getCurrentUser() {
            let _ = await this.persistence._get(this.fullUserKey);
            return _ ? oi._fromJSON(this.auth, _) : null;
        }
        removeCurrentUser() {
            return this.persistence._remove(this.fullUserKey);
        }
        savePersistenceForRedirect() {
            return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
        }
        async setPersistence(_) {
            if (this.persistence === _) return;
            let r = await this.getCurrentUser();
            if (await this.removeCurrentUser(), this.persistence = _, r) return this.setCurrentUser(r);
        }
        delete() {
            this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
        }
        static async create(_, r, t = "authUser") {
            if (!r.length) return new e(l0(R$), _, t);
            let n = (await Promise.all(r.map(async (v)=>{
                if (await v._isAvailable()) return v;
            }))).filter((v)=>v), s = n[0] || l0(R$), c = Q1(t, _.config.apiKey, _.name), i = null;
            for (let v of r)try {
                let b = await v._get(c);
                if (b) {
                    let p = oi._fromJSON(_, b);
                    v !== s && (i = p), s = v;
                    break;
                }
            } catch  {}
            let d = n.filter((v)=>v._shouldAllowMigration);
            return !s._shouldAllowMigration || !d.length ? new e(s, _, t) : (s = d[0], i && await s._set(c, i.toJSON()), await Promise.all(r.map(async (v)=>{
                if (v !== s) try {
                    await v._remove(c);
                } catch  {}
            })), new e(s, _, t));
        }
    };
    function gR(e) {
        let _ = e.toLowerCase();
        if (_.includes("opera/") || _.includes("opr/") || _.includes("opios/")) return "Opera";
        if (zR(_)) return "IEMobile";
        if (_.includes("msie") || _.includes("trident/")) return "IE";
        if (_.includes("edge/")) return "Edge";
        if (PR(_)) return "Firefox";
        if (_.includes("silk/")) return "Silk";
        if (UR(_)) return "Blackberry";
        if (BR(_)) return "Webos";
        if (U$(_)) return "Safari";
        if ((_.includes("chrome/") || LR(_)) && !_.includes("edge/")) return "Chrome";
        if (OR(_)) return "Android";
        {
            let r = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/, t = e.match(r);
            if (t?.length === 2) return t[1];
        }
        return "Other";
    }
    function PR(e = Wo()) {
        return /firefox\//i.test(e);
    }
    function U$(e = Wo()) {
        let _ = e.toLowerCase();
        return _.includes("safari/") && !_.includes("chrome/") && !_.includes("crios/") && !_.includes("android");
    }
    function LR(e = Wo()) {
        return /crios\//i.test(e);
    }
    function zR(e = Wo()) {
        return /iemobile/i.test(e);
    }
    function OR(e = Wo()) {
        return /android/i.test(e);
    }
    function UR(e = Wo()) {
        return /blackberry/i.test(e);
    }
    function BR(e = Wo()) {
        return /webos/i.test(e);
    }
    function yg(e = Wo()) {
        return /iphone|ipad|ipod/i.test(e) || /macintosh/i.test(e) && /mobile/i.test(e);
    }
    function GP(e = Wo()) {
        var _;
        return yg(e) && !!(!((_ = window.navigator) === null || _ === void 0) && _.standalone);
    }
    function CP() {
        return E9() && document.documentMode === 10;
    }
    function JR(e = Wo()) {
        return yg(e) || OR(e) || BR(e) || UR(e) || /windows phone/i.test(e) || zR(e);
    }
    function AP() {
        try {
            return !!(window && window !== window.top);
        } catch  {
            return !1;
        }
    }
    function VR(e, _ = []) {
        let r;
        switch(e){
            case "Browser":
                r = gR(Wo());
                break;
            case "Worker":
                r = `${gR(Wo())}-${e}`;
                break;
            default:
                r = e;
        }
        let t = _.length ? _.join(",") : "FirebaseCore-web";
        return `${r}/JsCore/${q0}/${t}`;
    }
    var k$ = class {
        constructor(_){
            this.auth = _, this.queue = [];
        }
        pushCallback(_, r) {
            let t = (s)=>new Promise((c, i)=>{
                    try {
                        let d = _(s);
                        c(d);
                    } catch (d) {
                        i(d);
                    }
                });
            t.onAbort = r, this.queue.push(t);
            let n = this.queue.length - 1;
            return ()=>{
                this.queue[n] = ()=>Promise.resolve();
            };
        }
        async runMiddleware(_) {
            if (this.auth.currentUser === _) return;
            let r = [];
            try {
                for (let t of this.queue)await t(_), t.onAbort && r.push(t.onAbort);
            } catch (t) {
                r.reverse();
                for (let n of r)try {
                    n();
                } catch  {}
                throw this.auth._errorFactory.create("login-blocked", {
                    originalMessage: t?.message
                });
            }
        }
    };
    async function NP(e, _ = {}) {
        return Rr(e, "GET", "/v2/passwordPolicy", Zo(e, _));
    }
    var FP = 6, S$ = class {
        constructor(_){
            var r, t, n, s;
            let c = _.customStrengthOptions;
            this.customStrengthOptions = {}, this.customStrengthOptions.minPasswordLength = (r = c.minPasswordLength) !== null && r !== void 0 ? r : FP, c.maxPasswordLength && (this.customStrengthOptions.maxPasswordLength = c.maxPasswordLength), c.containsLowercaseCharacter !== void 0 && (this.customStrengthOptions.containsLowercaseLetter = c.containsLowercaseCharacter), c.containsUppercaseCharacter !== void 0 && (this.customStrengthOptions.containsUppercaseLetter = c.containsUppercaseCharacter), c.containsNumericCharacter !== void 0 && (this.customStrengthOptions.containsNumericCharacter = c.containsNumericCharacter), c.containsNonAlphanumericCharacter !== void 0 && (this.customStrengthOptions.containsNonAlphanumericCharacter = c.containsNonAlphanumericCharacter), this.enforcementState = _.enforcementState, this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED" && (this.enforcementState = "OFF"), this.allowedNonAlphanumericCharacters = (n = (t = _.allowedNonAlphanumericCharacters) === null || t === void 0 ? void 0 : t.join("")) !== null && n !== void 0 ? n : "", this.forceUpgradeOnSignin = (s = _.forceUpgradeOnSignin) !== null && s !== void 0 ? s : !1, this.schemaVersion = _.schemaVersion;
        }
        validatePassword(_) {
            var r, t, n, s, c, i;
            let d = {
                isValid: !0,
                passwordPolicy: this
            };
            return this.validatePasswordLengthOptions(_, d), this.validatePasswordCharacterOptions(_, d), d.isValid && (d.isValid = (r = d.meetsMinPasswordLength) !== null && r !== void 0 ? r : !0), d.isValid && (d.isValid = (t = d.meetsMaxPasswordLength) !== null && t !== void 0 ? t : !0), d.isValid && (d.isValid = (n = d.containsLowercaseLetter) !== null && n !== void 0 ? n : !0), d.isValid && (d.isValid = (s = d.containsUppercaseLetter) !== null && s !== void 0 ? s : !0), d.isValid && (d.isValid = (c = d.containsNumericCharacter) !== null && c !== void 0 ? c : !0), d.isValid && (d.isValid = (i = d.containsNonAlphanumericCharacter) !== null && i !== void 0 ? i : !0), d;
        }
        validatePasswordLengthOptions(_, r) {
            let t = this.customStrengthOptions.minPasswordLength, n = this.customStrengthOptions.maxPasswordLength;
            t && (r.meetsMinPasswordLength = _.length >= t), n && (r.meetsMaxPasswordLength = _.length <= n);
        }
        validatePasswordCharacterOptions(_, r) {
            this.updatePasswordCharacterOptionsStatuses(r, !1, !1, !1, !1);
            let t;
            for(let n = 0; n < _.length; n++)t = _.charAt(n), this.updatePasswordCharacterOptionsStatuses(r, t >= "a" && t <= "z", t >= "A" && t <= "Z", t >= "0" && t <= "9", this.allowedNonAlphanumericCharacters.includes(t));
        }
        updatePasswordCharacterOptionsStatuses(_, r, t, n, s) {
            this.customStrengthOptions.containsLowercaseLetter && (_.containsLowercaseLetter || (_.containsLowercaseLetter = r)), this.customStrengthOptions.containsUppercaseLetter && (_.containsUppercaseLetter || (_.containsUppercaseLetter = t)), this.customStrengthOptions.containsNumericCharacter && (_.containsNumericCharacter || (_.containsNumericCharacter = n)), this.customStrengthOptions.containsNonAlphanumericCharacter && (_.containsNonAlphanumericCharacter || (_.containsNonAlphanumericCharacter = s));
        }
    };
    var I$ = class {
        constructor(_, r, t, n){
            this.app = _, this.heartbeatServiceProvider = r, this.appCheckServiceProvider = t, this.config = n, this.currentUser = null, this.emulatorConfig = null, this.operations = Promise.resolve(), this.authStateSubscription = new tg(this), this.idTokenSubscription = new tg(this), this.beforeStateQueue = new k$(this), this.redirectUser = null, this.isProactiveRefreshEnabled = !1, this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1, this._canInitEmulator = !0, this._isInitialized = !1, this._deleted = !1, this._initializationPromise = null, this._popupRedirectResolver = null, this._errorFactory = ER, this._agentRecaptchaConfig = null, this._tenantRecaptchaConfigs = {}, this._projectPasswordPolicy = null, this._tenantPasswordPolicies = {}, this.lastNotifiedUid = void 0, this.languageCode = null, this.tenantId = null, this.settings = {
                appVerificationDisabledForTesting: !1
            }, this.frameworks = [], this.name = _.name, this.clientVersion = n.sdkClientVersion;
        }
        _initializeWithPersistence(_, r) {
            return r && (this._popupRedirectResolver = l0(r)), this._initializationPromise = this.queue(async ()=>{
                var t, n;
                if (!this._deleted && (this.persistenceManager = await rg.create(this, _), !this._deleted)) {
                    if (!((t = this._popupRedirectResolver) === null || t === void 0) && t._shouldInitProactively) try {
                        await this._popupRedirectResolver._initialize(this);
                    } catch  {}
                    await this.initializeCurrentUser(r), this.lastNotifiedUid = ((n = this.currentUser) === null || n === void 0 ? void 0 : n.uid) || null, !this._deleted && (this._isInitialized = !0);
                }
            }), this._initializationPromise;
        }
        async _onStorageEvent() {
            if (this._deleted) return;
            let _ = await this.assertedPersistence.getCurrentUser();
            if (!(!this.currentUser && !_)) {
                if (this.currentUser && _ && this.currentUser.uid === _.uid) {
                    this._currentUser._assign(_), await this.currentUser.getIdToken();
                    return;
                }
                await this._updateCurrentUser(_, !0);
            }
        }
        async initializeCurrentUserFromIdToken(_) {
            try {
                let r = await AR(this, {
                    idToken: _
                }), t = await oi._fromGetAccountInfoResponse(this, r, _);
                await this.directlySetCurrentUser(t);
            } catch (r) {
                console.warn("FirebaseServerApp could not login user with provided authIdToken: ", r), await this.directlySetCurrentUser(null);
            }
        }
        async initializeCurrentUser(_) {
            var r;
            if (ln(this.app)) {
                let c = this.app.settings.authIdToken;
                return c ? new Promise((i)=>{
                    setTimeout(()=>this.initializeCurrentUserFromIdToken(c).then(i, i));
                }) : this.directlySetCurrentUser(null);
            }
            let t = await this.assertedPersistence.getCurrentUser(), n = t, s = !1;
            if (_ && this.config.authDomain) {
                await this.getOrInitRedirectPersistenceManager();
                let c = (r = this.redirectUser) === null || r === void 0 ? void 0 : r._redirectEventId, i = n?._redirectEventId, d = await this.tryRedirectSignIn(_);
                (!c || c === i) && d?.user && (n = d.user, s = !0);
            }
            if (!n) return this.directlySetCurrentUser(null);
            if (!n._redirectEventId) {
                if (s) try {
                    await this.beforeStateQueue.runMiddleware(n);
                } catch (c) {
                    n = t, this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(c));
                }
                return n ? this.reloadAndSetCurrentUserOrClear(n) : this.directlySetCurrentUser(null);
            }
            return M_(this._popupRedirectResolver, this, "argument-error"), await this.getOrInitRedirectPersistenceManager(), this.redirectUser && this.redirectUser._redirectEventId === n._redirectEventId ? this.directlySetCurrentUser(n) : this.reloadAndSetCurrentUserOrClear(n);
        }
        async tryRedirectSignIn(_) {
            let r = null;
            try {
                r = await this._popupRedirectResolver._completeRedirectFn(this, _, !0);
            } catch  {
                await this._setRedirectUser(null);
            }
            return r;
        }
        async reloadAndSetCurrentUserOrClear(_) {
            try {
                await eg(_);
            } catch (r) {
                if (r?.code !== "auth/network-request-failed") return this.directlySetCurrentUser(null);
            }
            return this.directlySetCurrentUser(_);
        }
        useDeviceLanguage() {
            this.languageCode = yP();
        }
        async _delete() {
            this._deleted = !0;
        }
        async updateCurrentUser(_) {
            if (ln(this.app)) return Promise.reject(bs(this));
            let r = _ ? mo(_) : null;
            return r && M_(r.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token"), this._updateCurrentUser(r && r._clone(this));
        }
        async _updateCurrentUser(_, r = !1) {
            if (!this._deleted) return _ && M_(this.tenantId === _.tenantId, this, "tenant-id-mismatch"), r || await this.beforeStateQueue.runMiddleware(_), this.queue(async ()=>{
                await this.directlySetCurrentUser(_), this.notifyAuthListeners();
            });
        }
        async signOut() {
            return ln(this.app) ? Promise.reject(bs(this)) : (await this.beforeStateQueue.runMiddleware(null), (this.redirectPersistenceManager || this._popupRedirectResolver) && await this._setRedirectUser(null), this._updateCurrentUser(null, !0));
        }
        setPersistence(_) {
            return ln(this.app) ? Promise.reject(bs(this)) : this.queue(async ()=>{
                await this.assertedPersistence.setPersistence(l0(_));
            });
        }
        _getRecaptchaConfig() {
            return this.tenantId == null ? this._agentRecaptchaConfig : this._tenantRecaptchaConfigs[this.tenantId];
        }
        async validatePassword(_) {
            this._getPasswordPolicyInternal() || await this._updatePasswordPolicy();
            let r = this._getPasswordPolicyInternal();
            return r.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION ? Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version", {})) : r.validatePassword(_);
        }
        _getPasswordPolicyInternal() {
            return this.tenantId === null ? this._projectPasswordPolicy : this._tenantPasswordPolicies[this.tenantId];
        }
        async _updatePasswordPolicy() {
            let _ = await NP(this), r = new S$(_);
            this.tenantId === null ? this._projectPasswordPolicy = r : this._tenantPasswordPolicies[this.tenantId] = r;
        }
        _getPersistence() {
            return this.assertedPersistence.persistence.type;
        }
        _updateErrorMap(_) {
            this._errorFactory = new Yn("auth", "Firebase", _());
        }
        onAuthStateChanged(_, r, t) {
            return this.registerStateListener(this.authStateSubscription, _, r, t);
        }
        beforeAuthStateChanged(_, r) {
            return this.beforeStateQueue.pushCallback(_, r);
        }
        onIdTokenChanged(_, r, t) {
            return this.registerStateListener(this.idTokenSubscription, _, r, t);
        }
        authStateReady() {
            return new Promise((_, r)=>{
                if (this.currentUser) _();
                else {
                    let t = this.onAuthStateChanged(()=>{
                        t(), _();
                    }, r);
                }
            });
        }
        async revokeAccessToken(_) {
            if (this.currentUser) {
                let r = await this.currentUser.getIdToken(), t = {
                    providerId: "apple.com",
                    tokenType: "ACCESS_TOKEN",
                    token: _,
                    idToken: r
                };
                this.tenantId != null && (t.tenantId = this.tenantId), await TP(this, t);
            }
        }
        toJSON() {
            var _;
            return {
                apiKey: this.config.apiKey,
                authDomain: this.config.authDomain,
                appName: this.name,
                currentUser: (_ = this._currentUser) === null || _ === void 0 ? void 0 : _.toJSON()
            };
        }
        async _setRedirectUser(_, r) {
            let t = await this.getOrInitRedirectPersistenceManager(r);
            return _ === null ? t.removeCurrentUser() : t.setCurrentUser(_);
        }
        async getOrInitRedirectPersistenceManager(_) {
            if (!this.redirectPersistenceManager) {
                let r = _ && l0(_) || this._popupRedirectResolver;
                M_(r, this, "argument-error"), this.redirectPersistenceManager = await rg.create(this, [
                    l0(r._redirectPersistence)
                ], "redirectUser"), this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
            }
            return this.redirectPersistenceManager;
        }
        async _redirectUserForId(_) {
            var r, t;
            return this._isInitialized && await this.queue(async ()=>{}), ((r = this._currentUser) === null || r === void 0 ? void 0 : r._redirectEventId) === _ ? this._currentUser : ((t = this.redirectUser) === null || t === void 0 ? void 0 : t._redirectEventId) === _ ? this.redirectUser : null;
        }
        async _persistUserIfCurrent(_) {
            if (_ === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(_));
        }
        _notifyListenersIfCurrent(_) {
            _ === this.currentUser && this.notifyAuthListeners();
        }
        _key() {
            return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
        }
        _startProactiveRefresh() {
            this.isProactiveRefreshEnabled = !0, this.currentUser && this._currentUser._startProactiveRefresh();
        }
        _stopProactiveRefresh() {
            this.isProactiveRefreshEnabled = !1, this.currentUser && this._currentUser._stopProactiveRefresh();
        }
        get _currentUser() {
            return this.currentUser;
        }
        notifyAuthListeners() {
            var _, r;
            if (!this._isInitialized) return;
            this.idTokenSubscription.next(this.currentUser);
            let t = (r = (_ = this.currentUser) === null || _ === void 0 ? void 0 : _.uid) !== null && r !== void 0 ? r : null;
            this.lastNotifiedUid !== t && (this.lastNotifiedUid = t, this.authStateSubscription.next(this.currentUser));
        }
        registerStateListener(_, r, t, n) {
            if (this._deleted) return ()=>{};
            let s = typeof r == "function" ? r : r.next.bind(r), c = !1, i = this._isInitialized ? Promise.resolve() : this._initializationPromise;
            if (M_(i, this, "internal-error"), i.then(()=>{
                c || s(this.currentUser);
            }), typeof r == "function") {
                let d = _.addObserver(r, t, n);
                return ()=>{
                    c = !0, d();
                };
            } else {
                let d = _.addObserver(r);
                return ()=>{
                    c = !0, d();
                };
            }
        }
        async directlySetCurrentUser(_) {
            this.currentUser && this.currentUser !== _ && this._currentUser._stopProactiveRefresh(), _ && this.isProactiveRefreshEnabled && _._startProactiveRefresh(), this.currentUser = _, _ ? await this.assertedPersistence.setCurrentUser(_) : await this.assertedPersistence.removeCurrentUser();
        }
        queue(_) {
            return this.operations = this.operations.then(_, _), this.operations;
        }
        get assertedPersistence() {
            return M_(this.persistenceManager, this, "internal-error"), this.persistenceManager;
        }
        _logFramework(_) {
            !_ || this.frameworks.includes(_) || (this.frameworks.push(_), this.frameworks.sort(), this.clientVersion = VR(this.config.clientPlatform, this._getFrameworks()));
        }
        _getFrameworks() {
            return this.frameworks;
        }
        async _getAdditionalHeaders() {
            var _;
            let r = {
                "X-Client-Version": this.clientVersion
            };
            this.app.options.appId && (r["X-Firebase-gmpid"] = this.app.options.appId);
            let t = await ((_ = this.heartbeatServiceProvider.getImmediate({
                optional: !0
            })) === null || _ === void 0 ? void 0 : _.getHeartbeatsHeader());
            t && (r["X-Firebase-Client"] = t);
            let n = await this._getAppCheckToken();
            return n && (r["X-Firebase-AppCheck"] = n), r;
        }
        async _getAppCheckToken() {
            var _;
            let r = await ((_ = this.appCheckServiceProvider.getImmediate({
                optional: !0
            })) === null || _ === void 0 ? void 0 : _.getToken());
            return r?.error && mP(`Error while retrieving App Check token: ${r.error}`), r?.token;
        }
    };
    function Ec(e) {
        return mo(e);
    }
    var tg = class {
        constructor(_){
            this.auth = _, this.observer = null, this.addObserver = A9((r)=>this.observer = r);
        }
        get next() {
            return M_(this.observer, this.auth, "internal-error"), this.observer.next.bind(this.observer);
        }
    };
    var Dg = {
        async loadJS () {
            throw new Error("Unable to load external scripts");
        },
        recaptchaV2Script: "",
        recaptchaEnterpriseScript: "",
        gapiScript: ""
    };
    function MP(e) {
        Dg = e;
    }
    function qR(e) {
        return Dg.loadJS(e);
    }
    function PP() {
        return Dg.recaptchaEnterpriseScript;
    }
    function LP() {
        return Dg.gapiScript;
    }
    function WR(e) {
        return `__${e}${Math.floor(Math.random() * 1e6)}`;
    }
    var zP = "recaptcha-enterprise", OP = "NO_RECAPTCHA", x$ = class {
        constructor(_){
            this.type = zP, this.auth = Ec(_);
        }
        async verify(_ = "verify", r = !1) {
            async function t(s) {
                if (!r) {
                    if (s.tenantId == null && s._agentRecaptchaConfig != null) return s._agentRecaptchaConfig.siteKey;
                    if (s.tenantId != null && s._tenantRecaptchaConfigs[s.tenantId] !== void 0) return s._tenantRecaptchaConfigs[s.tenantId].siteKey;
                }
                return new Promise(async (c, i)=>{
                    kP(s, {
                        clientType: "CLIENT_TYPE_WEB",
                        version: "RECAPTCHA_ENTERPRISE"
                    }).then((d)=>{
                        if (d.recaptchaKey === void 0) i(new Error("recaptcha Enterprise site key undefined"));
                        else {
                            let v = new D$(d);
                            return s.tenantId == null ? s._agentRecaptchaConfig = v : s._tenantRecaptchaConfigs[s.tenantId] = v, c(v.siteKey);
                        }
                    }).catch((d)=>{
                        i(d);
                    });
                });
            }
            function n(s, c, i) {
                let d = window.grecaptcha;
                dR(d) ? d.enterprise.ready(()=>{
                    d.enterprise.execute(s, {
                        action: _
                    }).then((v)=>{
                        c(v);
                    }).catch(()=>{
                        c(OP);
                    });
                }) : i(Error("No reCAPTCHA enterprise script loaded."));
            }
            return new Promise((s, c)=>{
                t(this.auth).then((i)=>{
                    if (!r && dR(window.grecaptcha)) n(i, s, c);
                    else {
                        if (typeof window > "u") {
                            c(new Error("RecaptchaVerifier is only supported in browser"));
                            return;
                        }
                        let d = PP();
                        d.length !== 0 && (d += i), qR(d).then(()=>{
                            n(i, s, c);
                        }).catch((v)=>{
                            c(v);
                        });
                    }
                }).catch((i)=>{
                    c(i);
                });
            });
        }
    };
    async function bR(e, _, r, t = !1) {
        let n = new x$(e), s;
        try {
            s = await n.verify(r);
        } catch  {
            s = await n.verify(r, !0);
        }
        let c = Object.assign({}, _);
        return t ? Object.assign(c, {
            captchaResp: s
        }) : Object.assign(c, {
            captchaResponse: s
        }), Object.assign(c, {
            clientType: "CLIENT_TYPE_WEB"
        }), Object.assign(c, {
            recaptchaVersion: "RECAPTCHA_ENTERPRISE"
        }), c;
    }
    async function pR(e, _, r, t) {
        var n;
        if (!((n = e._getRecaptchaConfig()) === null || n === void 0) && n.isProviderEnabled("EMAIL_PASSWORD_PROVIDER")) {
            let s = await bR(e, _, r, r === "getOobCode");
            return t(e, s);
        } else return t(e, _).catch(async (s)=>{
            if (s.code === "auth/missing-recaptcha-token") {
                console.log(`${r} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                let c = await bR(e, _, r, r === "getOobCode");
                return t(e, c);
            } else return Promise.reject(s);
        });
    }
    function HR(e, _) {
        let r = Ys(e, "auth");
        if (r.isInitialized()) {
            let n = r.getImmediate(), s = r.getOptions();
            if (js(s, _ ?? {})) return n;
            Vt(n, "already-initialized");
        }
        return r.initialize({
            options: _
        });
    }
    function UP(e, _) {
        let r = _?.persistence || [], t = (Array.isArray(r) ? r : [
            r
        ]).map(l0);
        _?.errorMap && e._updateErrorMap(_.errorMap), e._initializeWithPersistence(t, _?.popupRedirectResolver);
    }
    function wg(e, _, r) {
        let t = Ec(e);
        M_(t._canInitEmulator, t, "emulator-config-failed"), M_(/^https?:\/\//.test(_), t, "invalid-emulator-scheme");
        let n = !!r?.disableWarnings, s = jR(_), { host: c , port: i  } = BP(_), d = i === null ? "" : `:${i}`;
        t.config.emulator = {
            url: `${s}//${c}${d}/`
        }, t.settings.appVerificationDisabledForTesting = !0, t.emulatorConfig = Object.freeze({
            host: c,
            port: i,
            protocol: s.replace(":", ""),
            options: Object.freeze({
                disableWarnings: n
            })
        }), n || JP();
    }
    function jR(e) {
        let _ = e.indexOf(":");
        return _ < 0 ? "" : e.substr(0, _ + 1);
    }
    function BP(e) {
        let _ = jR(e), r = /(\/\/)?([^?#/]+)/.exec(e.substr(_.length));
        if (!r) return {
            host: "",
            port: null
        };
        let t = r[2].split("@").pop() || "", n = /^(\[[^\]]+\])(:|$)/.exec(t);
        if (n) {
            let s = n[1];
            return {
                host: s,
                port: fR(t.substr(s.length + 1))
            };
        } else {
            let [s, c] = t.split(":");
            return {
                host: s,
                port: fR(c)
            };
        }
    }
    function fR(e) {
        if (!e) return null;
        let _ = Number(e);
        return isNaN(_) ? null : _;
    }
    function JP() {
        function e() {
            let _ = document.createElement("p"), r = _.style;
            _.innerText = "Running in emulator mode. Do not use with production credentials.", r.position = "fixed", r.width = "100%", r.backgroundColor = "#ffffff", r.border = ".1em solid #000000", r.color = "#b50000", r.bottom = "0px", r.left = "0px", r.margin = "0px", r.zIndex = "10000", r.textAlign = "center", _.classList.add("firebase-emulator-warning"), document.body.appendChild(_);
        }
        typeof console < "u" && typeof console.info == "function" && console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials."), typeof window < "u" && typeof document < "u" && (document.readyState === "loading" ? window.addEventListener("DOMContentLoaded", e) : e());
    }
    var wc = class {
        constructor(_, r){
            this.providerId = _, this.signInMethod = r;
        }
        toJSON() {
            return kn("not implemented");
        }
        _getIdTokenResponse(_) {
            return kn("not implemented");
        }
        _linkToIdToken(_, r) {
            return kn("not implemented");
        }
        _getReauthenticationResolver(_) {
            return kn("not implemented");
        }
    };
    async function VP(e, _) {
        return Rr(e, "POST", "/v1/accounts:signUp", _);
    }
    async function qP(e, _) {
        return xc(e, "POST", "/v1/accounts:signInWithPassword", Zo(e, _));
    }
    async function WP(e, _) {
        return xc(e, "POST", "/v1/accounts:signInWithEmailLink", Zo(e, _));
    }
    async function HP(e, _) {
        return xc(e, "POST", "/v1/accounts:signInWithEmailLink", Zo(e, _));
    }
    var kd = class e extends wc {
        constructor(_, r, t, n = null){
            super("password", t), this._email = _, this._password = r, this._tenantId = n;
        }
        static _fromEmailAndPassword(_, r) {
            return new e(_, r, "password");
        }
        static _fromEmailAndCode(_, r, t = null) {
            return new e(_, r, "emailLink", t);
        }
        toJSON() {
            return {
                email: this._email,
                password: this._password,
                signInMethod: this.signInMethod,
                tenantId: this._tenantId
            };
        }
        static fromJSON(_) {
            let r = typeof _ == "string" ? JSON.parse(_) : _;
            if (r?.email && r?.password) {
                if (r.signInMethod === "password") return this._fromEmailAndPassword(r.email, r.password);
                if (r.signInMethod === "emailLink") return this._fromEmailAndCode(r.email, r.password, r.tenantId);
            }
            return null;
        }
        async _getIdTokenResponse(_) {
            switch(this.signInMethod){
                case "password":
                    let r = {
                        returnSecureToken: !0,
                        email: this._email,
                        password: this._password,
                        clientType: "CLIENT_TYPE_WEB"
                    };
                    return pR(_, r, "signInWithPassword", qP);
                case "emailLink":
                    return WP(_, {
                        email: this._email,
                        oobCode: this._password
                    });
                default:
                    Vt(_, "internal-error");
            }
        }
        async _linkToIdToken(_, r) {
            switch(this.signInMethod){
                case "password":
                    let t = {
                        idToken: r,
                        returnSecureToken: !0,
                        email: this._email,
                        password: this._password,
                        clientType: "CLIENT_TYPE_WEB"
                    };
                    return pR(_, t, "signUpPassword", VP);
                case "emailLink":
                    return HP(_, {
                        idToken: r,
                        email: this._email,
                        oobCode: this._password
                    });
                default:
                    Vt(_, "internal-error");
            }
        }
        _getReauthenticationResolver(_) {
            return this._getIdTokenResponse(_);
        }
    };
    async function ei(e, _) {
        return xc(e, "POST", "/v1/accounts:signInWithIdp", Zo(e, _));
    }
    var jP = "http://localhost", Rc = class e extends wc {
        constructor(){
            super(...arguments), this.pendingToken = null;
        }
        static _fromParams(_) {
            let r = new e(_.providerId, _.signInMethod);
            return _.idToken || _.accessToken ? (_.idToken && (r.idToken = _.idToken), _.accessToken && (r.accessToken = _.accessToken), _.nonce && !_.pendingToken && (r.nonce = _.nonce), _.pendingToken && (r.pendingToken = _.pendingToken)) : _.oauthToken && _.oauthTokenSecret ? (r.accessToken = _.oauthToken, r.secret = _.oauthTokenSecret) : Vt("argument-error"), r;
        }
        toJSON() {
            return {
                idToken: this.idToken,
                accessToken: this.accessToken,
                secret: this.secret,
                nonce: this.nonce,
                pendingToken: this.pendingToken,
                providerId: this.providerId,
                signInMethod: this.signInMethod
            };
        }
        static fromJSON(_) {
            let r = typeof _ == "string" ? JSON.parse(_) : _, { providerId: t , signInMethod: n  } = r, s = H1(r, [
                "providerId",
                "signInMethod"
            ]);
            if (!t || !n) return null;
            let c = new e(t, n);
            return c.idToken = s.idToken || void 0, c.accessToken = s.accessToken || void 0, c.secret = s.secret, c.nonce = s.nonce, c.pendingToken = s.pendingToken || null, c;
        }
        _getIdTokenResponse(_) {
            let r = this.buildRequest();
            return ei(_, r);
        }
        _linkToIdToken(_, r) {
            let t = this.buildRequest();
            return t.idToken = r, ei(_, t);
        }
        _getReauthenticationResolver(_) {
            let r = this.buildRequest();
            return r.autoCreate = !1, ei(_, r);
        }
        buildRequest() {
            let _ = {
                requestUri: jP,
                returnSecureToken: !0
            };
            if (this.pendingToken) _.pendingToken = this.pendingToken;
            else {
                let r = {};
                this.idToken && (r.id_token = this.idToken), this.accessToken && (r.access_token = this.accessToken), this.secret && (r.oauth_token_secret = this.secret), r.providerId = this.providerId, this.nonce && !this.pendingToken && (r.nonce = this.nonce), _.postBody = da(r);
            }
            return _;
        }
    };
    async function KP(e, _) {
        return Rr(e, "POST", "/v1/accounts:sendVerificationCode", Zo(e, _));
    }
    async function QP(e, _) {
        return xc(e, "POST", "/v1/accounts:signInWithPhoneNumber", Zo(e, _));
    }
    async function YP(e, _) {
        let r = await xc(e, "POST", "/v1/accounts:signInWithPhoneNumber", Zo(e, _));
        if (r.temporaryProof) throw hd(e, "account-exists-with-different-credential", r);
        return r;
    }
    var XP = {
        USER_NOT_FOUND: "user-not-found"
    };
    async function ZP(e, _) {
        let r = Object.assign(Object.assign({}, _), {
            operation: "REAUTH"
        });
        return xc(e, "POST", "/v1/accounts:signInWithPhoneNumber", Zo(e, r), XP);
    }
    var Sd = class e extends wc {
        constructor(_){
            super("phone", "phone"), this.params = _;
        }
        static _fromVerification(_, r) {
            return new e({
                verificationId: _,
                verificationCode: r
            });
        }
        static _fromTokenResponse(_, r) {
            return new e({
                phoneNumber: _,
                temporaryProof: r
            });
        }
        _getIdTokenResponse(_) {
            return QP(_, this._makeVerificationRequest());
        }
        _linkToIdToken(_, r) {
            return YP(_, Object.assign({
                idToken: r
            }, this._makeVerificationRequest()));
        }
        _getReauthenticationResolver(_) {
            return ZP(_, this._makeVerificationRequest());
        }
        _makeVerificationRequest() {
            let { temporaryProof: _ , phoneNumber: r , verificationId: t , verificationCode: n  } = this.params;
            return _ && r ? {
                temporaryProof: _,
                phoneNumber: r
            } : {
                sessionInfo: t,
                code: n
            };
        }
        toJSON() {
            let _ = {
                providerId: this.providerId
            };
            return this.params.phoneNumber && (_.phoneNumber = this.params.phoneNumber), this.params.temporaryProof && (_.temporaryProof = this.params.temporaryProof), this.params.verificationCode && (_.verificationCode = this.params.verificationCode), this.params.verificationId && (_.verificationId = this.params.verificationId), _;
        }
        static fromJSON(_) {
            typeof _ == "string" && (_ = JSON.parse(_));
            let { verificationId: r , verificationCode: t , phoneNumber: n , temporaryProof: s  } = _;
            return !t && !r && !n && !s ? null : new e({
                verificationId: r,
                verificationCode: t,
                phoneNumber: n,
                temporaryProof: s
            });
        }
    };
    function _L(e) {
        switch(e){
            case "recoverEmail":
                return "RECOVER_EMAIL";
            case "resetPassword":
                return "PASSWORD_RESET";
            case "signIn":
                return "EMAIL_SIGNIN";
            case "verifyEmail":
                return "VERIFY_EMAIL";
            case "verifyAndChangeEmail":
                return "VERIFY_AND_CHANGE_EMAIL";
            case "revertSecondFactorAddition":
                return "REVERT_SECOND_FACTOR_ADDITION";
            default:
                return null;
        }
    }
    function eL(e) {
        let _ = va(ua(e)).link, r = _ ? va(ua(_)).deep_link_id : null, t = va(ua(e)).deep_link_id;
        return (t ? va(ua(t)).link : null) || t || r || _ || e;
    }
    var ng = class e {
        constructor(_){
            var r, t, n, s, c, i;
            let d = va(ua(_)), v = (r = d.apiKey) !== null && r !== void 0 ? r : null, b = (t = d.oobCode) !== null && t !== void 0 ? t : null, p = _L((n = d.mode) !== null && n !== void 0 ? n : null);
            M_(v && b && p, "argument-error"), this.apiKey = v, this.operation = p, this.code = b, this.continueUrl = (s = d.continueUrl) !== null && s !== void 0 ? s : null, this.languageCode = (c = d.languageCode) !== null && c !== void 0 ? c : null, this.tenantId = (i = d.tenantId) !== null && i !== void 0 ? i : null;
        }
        static parseLink(_) {
            let r = eL(_);
            try {
                return new e(r);
            } catch  {
                return null;
            }
        }
    };
    var kc = class e {
        constructor(){
            this.providerId = e.PROVIDER_ID;
        }
        static credential(_, r) {
            return kd._fromEmailAndPassword(_, r);
        }
        static credentialWithLink(_, r) {
            let t = ng.parseLink(r);
            return M_(t, "argument-error"), kd._fromEmailAndCode(_, t.code, t.tenantId);
        }
    };
    kc.PROVIDER_ID = "password";
    kc.EMAIL_PASSWORD_SIGN_IN_METHOD = "password";
    kc.EMAIL_LINK_SIGN_IN_METHOD = "emailLink";
    var sg = class {
        constructor(_){
            this.providerId = _, this.defaultLanguageCode = null, this.customParameters = {};
        }
        setDefaultLanguage(_) {
            this.defaultLanguageCode = _;
        }
        setCustomParameters(_) {
            return this.customParameters = _, this;
        }
        getCustomParameters() {
            return this.customParameters;
        }
    };
    var Sc = class extends sg {
        constructor(){
            super(...arguments), this.scopes = [];
        }
        addScope(_) {
            return this.scopes.includes(_) || this.scopes.push(_), this;
        }
        getScopes() {
            return [
                ...this.scopes
            ];
        }
    };
    var Id = class e extends Sc {
        constructor(){
            super("facebook.com");
        }
        static credential(_) {
            return Rc._fromParams({
                providerId: e.PROVIDER_ID,
                signInMethod: e.FACEBOOK_SIGN_IN_METHOD,
                accessToken: _
            });
        }
        static credentialFromResult(_) {
            return e.credentialFromTaggedObject(_);
        }
        static credentialFromError(_) {
            return e.credentialFromTaggedObject(_.customData || {});
        }
        static credentialFromTaggedObject({ _tokenResponse: _  }) {
            if (!_ || !("oauthAccessToken" in _) || !_.oauthAccessToken) return null;
            try {
                return e.credential(_.oauthAccessToken);
            } catch  {
                return null;
            }
        }
    };
    Id.FACEBOOK_SIGN_IN_METHOD = "facebook.com";
    Id.PROVIDER_ID = "facebook.com";
    var xd = class e extends Sc {
        constructor(){
            super("google.com"), this.addScope("profile");
        }
        static credential(_, r) {
            return Rc._fromParams({
                providerId: e.PROVIDER_ID,
                signInMethod: e.GOOGLE_SIGN_IN_METHOD,
                idToken: _,
                accessToken: r
            });
        }
        static credentialFromResult(_) {
            return e.credentialFromTaggedObject(_);
        }
        static credentialFromError(_) {
            return e.credentialFromTaggedObject(_.customData || {});
        }
        static credentialFromTaggedObject({ _tokenResponse: _  }) {
            if (!_) return null;
            let { oauthIdToken: r , oauthAccessToken: t  } = _;
            if (!r && !t) return null;
            try {
                return e.credential(r, t);
            } catch  {
                return null;
            }
        }
    };
    xd.GOOGLE_SIGN_IN_METHOD = "google.com";
    xd.PROVIDER_ID = "google.com";
    var Ed = class e extends Sc {
        constructor(){
            super("github.com");
        }
        static credential(_) {
            return Rc._fromParams({
                providerId: e.PROVIDER_ID,
                signInMethod: e.GITHUB_SIGN_IN_METHOD,
                accessToken: _
            });
        }
        static credentialFromResult(_) {
            return e.credentialFromTaggedObject(_);
        }
        static credentialFromError(_) {
            return e.credentialFromTaggedObject(_.customData || {});
        }
        static credentialFromTaggedObject({ _tokenResponse: _  }) {
            if (!_ || !("oauthAccessToken" in _) || !_.oauthAccessToken) return null;
            try {
                return e.credential(_.oauthAccessToken);
            } catch  {
                return null;
            }
        }
    };
    Ed.GITHUB_SIGN_IN_METHOD = "github.com";
    Ed.PROVIDER_ID = "github.com";
    var Td = class e extends Sc {
        constructor(){
            super("twitter.com");
        }
        static credential(_, r) {
            return Rc._fromParams({
                providerId: e.PROVIDER_ID,
                signInMethod: e.TWITTER_SIGN_IN_METHOD,
                oauthToken: _,
                oauthTokenSecret: r
            });
        }
        static credentialFromResult(_) {
            return e.credentialFromTaggedObject(_);
        }
        static credentialFromError(_) {
            return e.credentialFromTaggedObject(_.customData || {});
        }
        static credentialFromTaggedObject({ _tokenResponse: _  }) {
            if (!_) return null;
            let { oauthAccessToken: r , oauthTokenSecret: t  } = _;
            if (!r || !t) return null;
            try {
                return e.credential(r, t);
            } catch  {
                return null;
            }
        }
    };
    Td.TWITTER_SIGN_IN_METHOD = "twitter.com";
    Td.PROVIDER_ID = "twitter.com";
    var Gd = class e {
        constructor(_){
            this.user = _.user, this.providerId = _.providerId, this._tokenResponse = _._tokenResponse, this.operationType = _.operationType;
        }
        static async _fromIdTokenResponse(_, r, t, n = !1) {
            let s = await oi._fromIdTokenResponse(_, t, n), c = mR(t);
            return new e({
                user: s,
                providerId: c,
                _tokenResponse: t,
                operationType: r
            });
        }
        static async _forOperation(_, r, t) {
            await _._updateTokensIfNecessary(t, !0);
            let n = mR(t);
            return new e({
                user: _,
                providerId: n,
                _tokenResponse: t,
                operationType: r
            });
        }
    };
    function mR(e) {
        return e.providerId ? e.providerId : "phoneNumber" in e ? "phone" : null;
    }
    var E$ = class e extends Nr {
        constructor(_, r, t, n){
            var s;
            super(r.code, r.message), this.operationType = t, this.user = n, Object.setPrototypeOf(this, e.prototype), this.customData = {
                appName: _.name,
                tenantId: (s = _.tenantId) !== null && s !== void 0 ? s : void 0,
                _serverResponse: r.customData._serverResponse,
                operationType: t
            };
        }
        static _fromErrorAndOperation(_, r, t, n) {
            return new e(_, r, t, n);
        }
    };
    function KR(e, _, r, t) {
        return (_ === "reauthenticate" ? r._getReauthenticationResolver(e) : r._getIdTokenResponse(e)).catch((s)=>{
            throw s.code === "auth/multi-factor-auth-required" ? E$._fromErrorAndOperation(e, s, _, t) : s;
        });
    }
    async function oL(e, _, r = !1) {
        let t = await wd(e, _._linkToIdToken(e.auth, await e.getIdToken()), r);
        return Gd._forOperation(e, "link", t);
    }
    async function rL(e, _, r = !1) {
        let { auth: t  } = e;
        if (ln(t.app)) return Promise.reject(bs(t));
        let n = "reauthenticate";
        try {
            let s = await wd(e, KR(t, n, _, e), r);
            M_(s.idToken, t, "internal-error");
            let c = O$(s.idToken);
            M_(c, t, "internal-error");
            let { sub: i  } = c;
            return M_(e.uid === i, t, "user-mismatch"), Gd._forOperation(e, n, s);
        } catch (s) {
            throw s?.code === "auth/user-not-found" && Vt(t, "user-mismatch"), s;
        }
    }
    async function QR(e, _, r = !1) {
        if (ln(e.app)) return Promise.reject(bs(e));
        let t = "signIn", n = await KR(e, t, _), s = await Gd._fromIdTokenResponse(e, t, n);
        return r || await e._updateCurrentUser(s.user), s;
    }
    async function YR(e, _) {
        return QR(Ec(e), _);
    }
    async function tL(e) {
        let _ = Ec(e);
        _._getPasswordPolicyInternal() && await _._updatePasswordPolicy();
    }
    function B$(e, _, r) {
        return ln(e.app) ? Promise.reject(bs(e)) : YR(mo(e), kc.credential(_, r)).catch(async (t)=>{
            throw t.code === "auth/password-does-not-meet-requirements" && tL(e), t;
        });
    }
    function XR(e, _, r, t) {
        return mo(e).onIdTokenChanged(_, r, t);
    }
    function ZR(e, _, r) {
        return mo(e).beforeAuthStateChanged(_, r);
    }
    function Rg(e, _, r, t) {
        return mo(e).onAuthStateChanged(_, r, t);
    }
    function nL(e, _) {
        return Rr(e, "POST", "/v2/accounts/mfaEnrollment:start", Zo(e, _));
    }
    function sL(e, _) {
        return Rr(e, "POST", "/v2/accounts/mfaEnrollment:finalize", Zo(e, _));
    }
    function cL(e, _) {
        return Rr(e, "POST", "/v2/accounts/mfaEnrollment:start", Zo(e, _));
    }
    function aL(e, _) {
        return Rr(e, "POST", "/v2/accounts/mfaEnrollment:finalize", Zo(e, _));
    }
    var cg = "__sak";
    var ag = class {
        constructor(_, r){
            this.storageRetriever = _, this.type = r;
        }
        _isAvailable() {
            try {
                return this.storage ? (this.storage.setItem(cg, "1"), this.storage.removeItem(cg), Promise.resolve(!0)) : Promise.resolve(!1);
            } catch  {
                return Promise.resolve(!1);
            }
        }
        _set(_, r) {
            return this.storage.setItem(_, JSON.stringify(r)), Promise.resolve();
        }
        _get(_) {
            let r = this.storage.getItem(_);
            return Promise.resolve(r ? JSON.parse(r) : null);
        }
        _remove(_) {
            return this.storage.removeItem(_), Promise.resolve();
        }
        get storage() {
            return this.storageRetriever();
        }
    };
    function iL() {
        let e = Wo();
        return U$(e) || yg(e);
    }
    var lL = 1e3, dL = 10, ig = class extends ag {
        constructor(){
            super(()=>window.localStorage, "LOCAL"), this.boundEventHandler = (_, r)=>this.onStorageEvent(_, r), this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.safariLocalStorageNotSynced = iL() && AP(), this.fallbackToPolling = JR(), this._shouldAllowMigration = !0;
        }
        forAllChangedKeys(_) {
            for (let r of Object.keys(this.listeners)){
                let t = this.storage.getItem(r), n = this.localCache[r];
                t !== n && _(r, n, t);
            }
        }
        onStorageEvent(_, r = !1) {
            if (!_.key) {
                this.forAllChangedKeys((c, i, d)=>{
                    this.notifyListeners(c, d);
                });
                return;
            }
            let t = _.key;
            if (r ? this.detachListener() : this.stopPolling(), this.safariLocalStorageNotSynced) {
                let c = this.storage.getItem(t);
                if (_.newValue !== c) _.newValue !== null ? this.storage.setItem(t, _.newValue) : this.storage.removeItem(t);
                else if (this.localCache[t] === _.newValue && !r) return;
            }
            let n = ()=>{
                let c = this.storage.getItem(t);
                !r && this.localCache[t] === c || this.notifyListeners(t, c);
            }, s = this.storage.getItem(t);
            CP() && s !== _.newValue && _.newValue !== _.oldValue ? setTimeout(n, dL) : n();
        }
        notifyListeners(_, r) {
            this.localCache[_] = r;
            let t = this.listeners[_];
            if (t) for (let n of Array.from(t))n(r && JSON.parse(r));
        }
        startPolling() {
            this.stopPolling(), this.pollTimer = setInterval(()=>{
                this.forAllChangedKeys((_, r, t)=>{
                    this.onStorageEvent(new StorageEvent("storage", {
                        key: _,
                        oldValue: r,
                        newValue: t
                    }), !0);
                });
            }, lL);
        }
        stopPolling() {
            this.pollTimer && (clearInterval(this.pollTimer), this.pollTimer = null);
        }
        attachListener() {
            window.addEventListener("storage", this.boundEventHandler);
        }
        detachListener() {
            window.removeEventListener("storage", this.boundEventHandler);
        }
        _addListener(_, r) {
            Object.keys(this.listeners).length === 0 && (this.fallbackToPolling ? this.startPolling() : this.attachListener()), this.listeners[_] || (this.listeners[_] = new Set, this.localCache[_] = this.storage.getItem(_)), this.listeners[_].add(r);
        }
        _removeListener(_, r) {
            this.listeners[_] && (this.listeners[_].delete(r), this.listeners[_].size === 0 && delete this.listeners[_]), Object.keys(this.listeners).length === 0 && (this.detachListener(), this.stopPolling());
        }
        async _set(_, r) {
            await super._set(_, r), this.localCache[_] = JSON.stringify(r);
        }
        async _get(_) {
            let r = await super._get(_);
            return this.localCache[_] = JSON.stringify(r), r;
        }
        async _remove(_) {
            await super._remove(_), delete this.localCache[_];
        }
    };
    ig.type = "LOCAL";
    var _k = ig;
    var lg = class extends ag {
        constructor(){
            super(()=>window.sessionStorage, "SESSION");
        }
        _addListener(_, r) {}
        _removeListener(_, r) {}
    };
    lg.type = "SESSION";
    var J$ = lg;
    function vL(e) {
        return Promise.all(e.map(async (_)=>{
            try {
                return {
                    fulfilled: !0,
                    value: await _
                };
            } catch (r) {
                return {
                    fulfilled: !1,
                    reason: r
                };
            }
        }));
    }
    var dg = class e {
        constructor(_){
            this.eventTarget = _, this.handlersMap = {}, this.boundEventHandler = this.handleEvent.bind(this);
        }
        static _getInstance(_) {
            let r = this.receivers.find((n)=>n.isListeningto(_));
            if (r) return r;
            let t = new e(_);
            return this.receivers.push(t), t;
        }
        isListeningto(_) {
            return this.eventTarget === _;
        }
        async handleEvent(_) {
            let r = _, { eventId: t , eventType: n , data: s  } = r.data, c = this.handlersMap[n];
            if (!c?.size) return;
            r.ports[0].postMessage({
                status: "ack",
                eventId: t,
                eventType: n
            });
            let i = Array.from(c).map(async (v)=>v(r.origin, s)), d = await vL(i);
            r.ports[0].postMessage({
                status: "done",
                eventId: t,
                eventType: n,
                response: d
            });
        }
        _subscribe(_, r) {
            Object.keys(this.handlersMap).length === 0 && this.eventTarget.addEventListener("message", this.boundEventHandler), this.handlersMap[_] || (this.handlersMap[_] = new Set), this.handlersMap[_].add(r);
        }
        _unsubscribe(_, r) {
            this.handlersMap[_] && r && this.handlersMap[_].delete(r), (!r || this.handlersMap[_].size === 0) && delete this.handlersMap[_], Object.keys(this.handlersMap).length === 0 && this.eventTarget.removeEventListener("message", this.boundEventHandler);
        }
    };
    dg.receivers = [];
    function V$(e = "", _ = 10) {
        let r = "";
        for(let t = 0; t < _; t++)r += Math.floor(Math.random() * 10);
        return e + r;
    }
    var T$ = class {
        constructor(_){
            this.target = _, this.handlers = new Set;
        }
        removeMessageHandler(_) {
            _.messageChannel && (_.messageChannel.port1.removeEventListener("message", _.onMessage), _.messageChannel.port1.close()), this.handlers.delete(_);
        }
        async _send(_, r, t = 50) {
            let n = typeof MessageChannel < "u" ? new MessageChannel : null;
            if (!n) throw new Error("connection_unavailable");
            let s, c;
            return new Promise((i, d)=>{
                let v = V$("", 20);
                n.port1.start();
                let b = setTimeout(()=>{
                    d(new Error("unsupported_event"));
                }, t);
                c = {
                    messageChannel: n,
                    onMessage (p) {
                        let u = p;
                        if (u.data.eventId === v) switch(u.data.status){
                            case "ack":
                                clearTimeout(b), s = setTimeout(()=>{
                                    d(new Error("timeout"));
                                }, 3e3);
                                break;
                            case "done":
                                clearTimeout(s), i(u.data.response);
                                break;
                            default:
                                clearTimeout(b), clearTimeout(s), d(new Error("invalid_response"));
                                break;
                        }
                    }
                }, this.handlers.add(c), n.port1.addEventListener("message", c.onMessage), this.target.postMessage({
                    eventType: _,
                    eventId: v,
                    data: r
                }, [
                    n.port2
                ]);
            }).finally(()=>{
                c && this.removeMessageHandler(c);
            });
        }
    };
    function In() {
        return window;
    }
    function uL(e) {
        In().location.href = e;
    }
    function ek() {
        return typeof In().WorkerGlobalScope < "u" && typeof In().importScripts == "function";
    }
    async function gL() {
        if (!navigator?.serviceWorker) return null;
        try {
            return (await navigator.serviceWorker.ready).active;
        } catch  {
            return null;
        }
    }
    function bL() {
        var e;
        return ((e = navigator?.serviceWorker) === null || e === void 0 ? void 0 : e.controller) || null;
    }
    function pL() {
        return ek() ? self : null;
    }
    var ok = "firebaseLocalStorageDb", fL = 1, vg = "firebaseLocalStorage", rk = "fbase_key", Ic = class {
        constructor(_){
            this.request = _;
        }
        toPromise() {
            return new Promise((_, r)=>{
                this.request.addEventListener("success", ()=>{
                    _(this.request.result);
                }), this.request.addEventListener("error", ()=>{
                    r(this.request.error);
                });
            });
        }
    };
    function kg(e, _) {
        return e.transaction([
            vg
        ], _ ? "readwrite" : "readonly").objectStore(vg);
    }
    function mL() {
        let e = indexedDB.deleteDatabase(ok);
        return new Ic(e).toPromise();
    }
    function G$() {
        let e = indexedDB.open(ok, fL);
        return new Promise((_, r)=>{
            e.addEventListener("error", ()=>{
                r(e.error);
            }), e.addEventListener("upgradeneeded", ()=>{
                let t = e.result;
                try {
                    t.createObjectStore(vg, {
                        keyPath: rk
                    });
                } catch (n) {
                    r(n);
                }
            }), e.addEventListener("success", async ()=>{
                let t = e.result;
                t.objectStoreNames.contains(vg) ? _(t) : (t.close(), await mL(), _(await G$()));
            });
        });
    }
    async function $R(e, _, r) {
        let t = kg(e, !0).put({
            [rk]: _,
            value: r
        });
        return new Ic(t).toPromise();
    }
    async function $L(e, _) {
        let r = kg(e, !1).get(_), t = await new Ic(r).toPromise();
        return t === void 0 ? null : t.value;
    }
    function hR(e, _) {
        let r = kg(e, !0).delete(_);
        return new Ic(r).toPromise();
    }
    var hL = 800, yL = 3, ug = class {
        constructor(){
            this.type = "LOCAL", this._shouldAllowMigration = !0, this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.pendingWrites = 0, this.receiver = null, this.sender = null, this.serviceWorkerReceiverAvailable = !1, this.activeServiceWorker = null, this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
        }
        async _openDb() {
            return this.db ? this.db : (this.db = await G$(), this.db);
        }
        async _withRetries(_) {
            let r = 0;
            for(;;)try {
                let t = await this._openDb();
                return await _(t);
            } catch (t) {
                if (r++ > yL) throw t;
                this.db && (this.db.close(), this.db = void 0);
            }
        }
        async initializeServiceWorkerMessaging() {
            return ek() ? this.initializeReceiver() : this.initializeSender();
        }
        async initializeReceiver() {
            this.receiver = dg._getInstance(pL()), this.receiver._subscribe("keyChanged", async (_, r)=>({
                    keyProcessed: (await this._poll()).includes(r.key)
                })), this.receiver._subscribe("ping", async (_, r)=>[
                    "keyChanged"
                ]);
        }
        async initializeSender() {
            var _, r;
            if (this.activeServiceWorker = await gL(), !this.activeServiceWorker) return;
            this.sender = new T$(this.activeServiceWorker);
            let t = await this.sender._send("ping", {}, 800);
            t && !((_ = t[0]) === null || _ === void 0) && _.fulfilled && !((r = t[0]) === null || r === void 0) && r.value.includes("keyChanged") && (this.serviceWorkerReceiverAvailable = !0);
        }
        async notifyServiceWorker(_) {
            if (!(!this.sender || !this.activeServiceWorker || bL() !== this.activeServiceWorker)) try {
                await this.sender._send("keyChanged", {
                    key: _
                }, this.serviceWorkerReceiverAvailable ? 800 : 50);
            } catch  {}
        }
        async _isAvailable() {
            try {
                if (!indexedDB) return !1;
                let _ = await G$();
                return await $R(_, cg, "1"), await hR(_, cg), !0;
            } catch  {}
            return !1;
        }
        async _withPendingWrite(_) {
            this.pendingWrites++;
            try {
                await _();
            } finally{
                this.pendingWrites--;
            }
        }
        async _set(_, r) {
            return this._withPendingWrite(async ()=>(await this._withRetries((t)=>$R(t, _, r)), this.localCache[_] = r, this.notifyServiceWorker(_)));
        }
        async _get(_) {
            let r = await this._withRetries((t)=>$L(t, _));
            return this.localCache[_] = r, r;
        }
        async _remove(_) {
            return this._withPendingWrite(async ()=>(await this._withRetries((r)=>hR(r, _)), delete this.localCache[_], this.notifyServiceWorker(_)));
        }
        async _poll() {
            let _ = await this._withRetries((n)=>{
                let s = kg(n, !1).getAll();
                return new Ic(s).toPromise();
            });
            if (!_) return [];
            if (this.pendingWrites !== 0) return [];
            let r = [], t = new Set;
            if (_.length !== 0) for (let { fbase_key: n , value: s  } of _)t.add(n), JSON.stringify(this.localCache[n]) !== JSON.stringify(s) && (this.notifyListeners(n, s), r.push(n));
            for (let n of Object.keys(this.localCache))this.localCache[n] && !t.has(n) && (this.notifyListeners(n, null), r.push(n));
            return r;
        }
        notifyListeners(_, r) {
            this.localCache[_] = r;
            let t = this.listeners[_];
            if (t) for (let n of Array.from(t))n(r);
        }
        startPolling() {
            this.stopPolling(), this.pollTimer = setInterval(async ()=>this._poll(), hL);
        }
        stopPolling() {
            this.pollTimer && (clearInterval(this.pollTimer), this.pollTimer = null);
        }
        _addListener(_, r) {
            Object.keys(this.listeners).length === 0 && this.startPolling(), this.listeners[_] || (this.listeners[_] = new Set, this._get(_)), this.listeners[_].add(r);
        }
        _removeListener(_, r) {
            this.listeners[_] && (this.listeners[_].delete(r), this.listeners[_].size === 0 && delete this.listeners[_]), Object.keys(this.listeners).length === 0 && this.stopPolling();
        }
    };
    ug.type = "LOCAL";
    var tk = ug;
    function DL(e, _) {
        return Rr(e, "POST", "/v2/accounts/mfaSignIn:start", Zo(e, _));
    }
    function wL(e, _) {
        return Rr(e, "POST", "/v2/accounts/mfaSignIn:finalize", Zo(e, _));
    }
    function RL(e, _) {
        return Rr(e, "POST", "/v2/accounts/mfaSignIn:finalize", Zo(e, _));
    }
    var Io_ = WR("rcb"), xo_ = new Dc(3e4, 6e4);
    var kL = "recaptcha";
    async function SL(e, _, r) {
        var t;
        let n = await r.verify();
        try {
            M_(typeof n == "string", e, "argument-error"), M_(r.type === kL, e, "argument-error");
            let s;
            if (typeof _ == "string" ? s = {
                phoneNumber: _
            } : s = _, "session" in s) {
                let c = s.session;
                if ("phoneNumber" in s) return M_(c.type === "enroll", e, "internal-error"), (await nL(e, {
                    idToken: c.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: s.phoneNumber,
                        recaptchaToken: n
                    }
                })).phoneSessionInfo.sessionInfo;
                {
                    M_(c.type === "signin", e, "internal-error");
                    let i = ((t = s.multiFactorHint) === null || t === void 0 ? void 0 : t.uid) || s.multiFactorUid;
                    return M_(i, e, "missing-multi-factor-info"), (await DL(e, {
                        mfaPendingCredential: c.credential,
                        mfaEnrollmentId: i,
                        phoneSignInInfo: {
                            recaptchaToken: n
                        }
                    })).phoneResponseInfo.sessionInfo;
                }
            } else {
                let { sessionInfo: c  } = await KP(e, {
                    phoneNumber: s.phoneNumber,
                    recaptchaToken: n
                });
                return c;
            }
        } finally{
            r._reset();
        }
    }
    var Cd = class e {
        constructor(_){
            this.providerId = e.PROVIDER_ID, this.auth = Ec(_);
        }
        verifyPhoneNumber(_, r) {
            return SL(this.auth, _, mo(r));
        }
        static credential(_, r) {
            return Sd._fromVerification(_, r);
        }
        static credentialFromResult(_) {
            let r = _;
            return e.credentialFromTaggedObject(r);
        }
        static credentialFromError(_) {
            return e.credentialFromTaggedObject(_.customData || {});
        }
        static credentialFromTaggedObject({ _tokenResponse: _  }) {
            if (!_) return null;
            let { phoneNumber: r , temporaryProof: t  } = _;
            return r && t ? Sd._fromTokenResponse(r, t) : null;
        }
    };
    Cd.PROVIDER_ID = "phone";
    Cd.PHONE_SIGN_IN_METHOD = "phone";
    function IL(e, _) {
        return _ ? l0(_) : (M_(e._popupRedirectResolver, e, "argument-error"), e._popupRedirectResolver);
    }
    var Ad = class extends wc {
        constructor(_){
            super("custom", "custom"), this.params = _;
        }
        _getIdTokenResponse(_) {
            return ei(_, this._buildIdpRequest());
        }
        _linkToIdToken(_, r) {
            return ei(_, this._buildIdpRequest(r));
        }
        _getReauthenticationResolver(_) {
            return ei(_, this._buildIdpRequest());
        }
        _buildIdpRequest(_) {
            let r = {
                requestUri: this.params.requestUri,
                sessionId: this.params.sessionId,
                postBody: this.params.postBody,
                tenantId: this.params.tenantId,
                pendingToken: this.params.pendingToken,
                returnSecureToken: !0,
                returnIdpCredential: !0
            };
            return _ && (r.idToken = _), r;
        }
    };
    function xL(e) {
        return QR(e.auth, new Ad(e), e.bypassAuthState);
    }
    function EL(e) {
        let { auth: _ , user: r  } = e;
        return M_(r, _, "internal-error"), rL(r, new Ad(e), e.bypassAuthState);
    }
    async function TL(e) {
        let { auth: _ , user: r  } = e;
        return M_(r, _, "internal-error"), oL(r, new Ad(e), e.bypassAuthState);
    }
    var gg = class {
        constructor(_, r, t, n, s = !1){
            this.auth = _, this.resolver = t, this.user = n, this.bypassAuthState = s, this.pendingPromise = null, this.eventManager = null, this.filter = Array.isArray(r) ? r : [
                r
            ];
        }
        execute() {
            return new Promise(async (_, r)=>{
                this.pendingPromise = {
                    resolve: _,
                    reject: r
                };
                try {
                    this.eventManager = await this.resolver._initialize(this.auth), await this.onExecution(), this.eventManager.registerConsumer(this);
                } catch (t) {
                    this.reject(t);
                }
            });
        }
        async onAuthEvent(_) {
            let { urlResponse: r , sessionId: t , postBody: n , tenantId: s , error: c , type: i  } = _;
            if (c) {
                this.reject(c);
                return;
            }
            let d = {
                auth: this.auth,
                requestUri: r,
                sessionId: t,
                tenantId: s || void 0,
                postBody: n || void 0,
                user: this.user,
                bypassAuthState: this.bypassAuthState
            };
            try {
                this.resolve(await this.getIdpTask(i)(d));
            } catch (v) {
                this.reject(v);
            }
        }
        onError(_) {
            this.reject(_);
        }
        getIdpTask(_) {
            switch(_){
                case "signInViaPopup":
                case "signInViaRedirect":
                    return xL;
                case "linkViaPopup":
                case "linkViaRedirect":
                    return TL;
                case "reauthViaPopup":
                case "reauthViaRedirect":
                    return EL;
                default:
                    Vt(this.auth, "internal-error");
            }
        }
        resolve(_) {
            d0(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.resolve(_), this.unregisterAndCleanUp();
        }
        reject(_) {
            d0(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.reject(_), this.unregisterAndCleanUp();
        }
        unregisterAndCleanUp() {
            this.eventManager && this.eventManager.unregisterConsumer(this), this.pendingPromise = null, this.cleanUp();
        }
    };
    var GL = new Dc(2e3, 1e4);
    var C$ = class e extends gg {
        constructor(_, r, t, n, s){
            super(_, r, n, s), this.provider = t, this.authWindow = null, this.pollId = null, e.currentPopupAction && e.currentPopupAction.cancel(), e.currentPopupAction = this;
        }
        async executeNotNull() {
            let _ = await this.execute();
            return M_(_, this.auth, "internal-error"), _;
        }
        async onExecution() {
            d0(this.filter.length === 1, "Popup operations only handle one event");
            let _ = V$();
            this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], _), this.authWindow.associatedEvent = _, this.resolver._originValidation(this.auth).catch((r)=>{
                this.reject(r);
            }), this.resolver._isIframeWebStorageSupported(this.auth, (r)=>{
                r || this.reject(Sn(this.auth, "web-storage-unsupported"));
            }), this.pollUserCancellation();
        }
        get eventId() {
            var _;
            return ((_ = this.authWindow) === null || _ === void 0 ? void 0 : _.associatedEvent) || null;
        }
        cancel() {
            this.reject(Sn(this.auth, "cancelled-popup-request"));
        }
        cleanUp() {
            this.authWindow && this.authWindow.close(), this.pollId && window.clearTimeout(this.pollId), this.authWindow = null, this.pollId = null, e.currentPopupAction = null;
        }
        pollUserCancellation() {
            let _ = ()=>{
                var r, t;
                if (!((t = (r = this.authWindow) === null || r === void 0 ? void 0 : r.window) === null || t === void 0) && t.closed) {
                    this.pollId = window.setTimeout(()=>{
                        this.pollId = null, this.reject(Sn(this.auth, "popup-closed-by-user"));
                    }, 8e3);
                    return;
                }
                this.pollId = window.setTimeout(_, GL.get());
            };
            _();
        }
    };
    C$.currentPopupAction = null;
    var CL = "pendingRedirect", Y1 = new Map, A$ = class extends gg {
        constructor(_, r, t = !1){
            super(_, [
                "signInViaRedirect",
                "linkViaRedirect",
                "reauthViaRedirect",
                "unknown"
            ], r, void 0, t), this.eventId = null;
        }
        async execute() {
            let _ = Y1.get(this.auth._key());
            if (!_) {
                try {
                    let t = await AL(this.resolver, this.auth) ? await super.execute() : null;
                    _ = ()=>Promise.resolve(t);
                } catch (r) {
                    _ = ()=>Promise.reject(r);
                }
                Y1.set(this.auth._key(), _);
            }
            return this.bypassAuthState || Y1.set(this.auth._key(), ()=>Promise.resolve(null)), _();
        }
        async onAuthEvent(_) {
            if (_.type === "signInViaRedirect") return super.onAuthEvent(_);
            if (_.type === "unknown") {
                this.resolve(null);
                return;
            }
            if (_.eventId) {
                let r = await this.auth._redirectUserForId(_.eventId);
                if (r) return this.user = r, super.onAuthEvent(_);
                this.resolve(null);
            }
        }
        async onExecution() {}
        cleanUp() {}
    };
    async function AL(e, _) {
        let r = ML(_), t = FL(e);
        if (!await t._isAvailable()) return !1;
        let n = await t._get(r) === "true";
        return await t._remove(r), n;
    }
    function NL(e, _) {
        Y1.set(e._key(), _);
    }
    function FL(e) {
        return l0(e._redirectPersistence);
    }
    function ML(e) {
        return Q1(CL, e.config.apiKey, e.name);
    }
    async function PL(e, _, r = !1) {
        if (ln(e.app)) return Promise.reject(bs(e));
        let t = Ec(e), n = IL(t, _), c = await new A$(t, n, r).execute();
        return c && !r && (delete c.user._redirectEventId, await t._persistUserIfCurrent(c.user), await t._setRedirectUser(null, _)), c;
    }
    var LL = 600000, N$ = class {
        constructor(_){
            this.auth = _, this.cachedEventUids = new Set, this.consumers = new Set, this.queuedRedirectEvent = null, this.hasHandledPotentialRedirect = !1, this.lastProcessedEventTime = Date.now();
        }
        registerConsumer(_) {
            this.consumers.add(_), this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, _) && (this.sendToConsumer(this.queuedRedirectEvent, _), this.saveEventToCache(this.queuedRedirectEvent), this.queuedRedirectEvent = null);
        }
        unregisterConsumer(_) {
            this.consumers.delete(_);
        }
        onEvent(_) {
            if (this.hasEventBeenHandled(_)) return !1;
            let r = !1;
            return this.consumers.forEach((t)=>{
                this.isEventForConsumer(_, t) && (r = !0, this.sendToConsumer(_, t), this.saveEventToCache(_));
            }), this.hasHandledPotentialRedirect || !zL(_) || (this.hasHandledPotentialRedirect = !0, r || (this.queuedRedirectEvent = _, r = !0)), r;
        }
        sendToConsumer(_, r) {
            var t;
            if (_.error && !nk(_)) {
                let n = ((t = _.error.code) === null || t === void 0 ? void 0 : t.split("auth/")[1]) || "internal-error";
                r.onError(Sn(this.auth, n));
            } else r.onAuthEvent(_);
        }
        isEventForConsumer(_, r) {
            let t = r.eventId === null || !!_.eventId && _.eventId === r.eventId;
            return r.filter.includes(_.type) && t;
        }
        hasEventBeenHandled(_) {
            return Date.now() - this.lastProcessedEventTime >= LL && this.cachedEventUids.clear(), this.cachedEventUids.has(yR(_));
        }
        saveEventToCache(_) {
            this.cachedEventUids.add(yR(_)), this.lastProcessedEventTime = Date.now();
        }
    };
    function yR(e) {
        return [
            e.type,
            e.eventId,
            e.sessionId,
            e.tenantId
        ].filter((_)=>_).join("-");
    }
    function nk({ type: e , error: _  }) {
        return e === "unknown" && _?.code === "auth/no-auth-event";
    }
    function zL(e) {
        switch(e.type){
            case "signInViaRedirect":
            case "linkViaRedirect":
            case "reauthViaRedirect":
                return !0;
            case "unknown":
                return nk(e);
            default:
                return !1;
        }
    }
    async function OL(e, _ = {}) {
        return Rr(e, "GET", "/v1/projects", _);
    }
    var UL = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, BL = /^https?/;
    async function JL(e) {
        if (e.config.emulator) return;
        let { authorizedDomains: _  } = await OL(e);
        for (let r of _)try {
            if (VL(r)) return;
        } catch  {}
        Vt(e, "unauthorized-domain");
    }
    function VL(e) {
        let _ = h$(), { protocol: r , hostname: t  } = new URL(_);
        if (e.startsWith("chrome-extension://")) {
            let c = new URL(e);
            return c.hostname === "" && t === "" ? r === "chrome-extension:" && e.replace("chrome-extension://", "") === _.replace("chrome-extension://", "") : r === "chrome-extension:" && c.hostname === t;
        }
        if (!BL.test(r)) return !1;
        if (UL.test(e)) return t === e;
        let n = e.replace(/\./g, "\\.");
        return new RegExp("^(.+\\." + n + "|" + n + ")$", "i").test(t);
    }
    var qL = new Dc(3e4, 6e4);
    function DR() {
        let e = In().___jsl;
        if (e?.H) {
            for (let _ of Object.keys(e.H))if (e.H[_].r = e.H[_].r || [], e.H[_].L = e.H[_].L || [], e.H[_].r = [
                ...e.H[_].L
            ], e.CP) for(let r = 0; r < e.CP.length; r++)e.CP[r] = null;
        }
    }
    function WL(e) {
        return new Promise((_, r)=>{
            var t, n, s;
            function c() {
                DR(), gapi.load("gapi.iframes", {
                    callback: ()=>{
                        _(gapi.iframes.getContext());
                    },
                    ontimeout: ()=>{
                        DR(), r(Sn(e, "network-request-failed"));
                    },
                    timeout: qL.get()
                });
            }
            if (!((n = (t = In().gapi) === null || t === void 0 ? void 0 : t.iframes) === null || n === void 0) && n.Iframe) _(gapi.iframes.getContext());
            else if (!((s = In().gapi) === null || s === void 0) && s.load) c();
            else {
                let i = WR("iframefcb");
                return In()[i] = ()=>{
                    gapi.load ? c() : r(Sn(e, "network-request-failed"));
                }, qR(`${LP()}?onload=${i}`).catch((d)=>r(d));
            }
        }).catch((_)=>{
            throw X1 = null, _;
        });
    }
    var X1 = null;
    function HL(e) {
        return X1 = X1 || WL(e), X1;
    }
    var jL = new Dc(5e3, 15e3), KL = "__/auth/iframe", QL = "emulator/auth/iframe", YL = {
        style: {
            position: "absolute",
            top: "-100px",
            width: "1px",
            height: "1px"
        },
        "aria-hidden": "true",
        tabindex: "-1"
    }, XL = new Map([
        [
            "identitytoolkit.googleapis.com",
            "p"
        ],
        [
            "staging-identitytoolkit.sandbox.googleapis.com",
            "s"
        ],
        [
            "test-identitytoolkit.sandbox.googleapis.com",
            "t"
        ]
    ]);
    function ZL(e) {
        let _ = e.config;
        M_(_.authDomain, e, "auth-domain-config-required");
        let r = _.emulator ? z$(_, QL) : `https://${e.config.authDomain}/${KL}`, t = {
            apiKey: _.apiKey,
            appName: e.name,
            v: q0
        }, n = XL.get(e.config.apiHost);
        n && (t.eid = n);
        let s = e._getFrameworks();
        return s.length && (t.fw = s.join(",")), `${r}?${da(t).slice(1)}`;
    }
    async function _z(e) {
        let _ = await HL(e), r = In().gapi;
        return M_(r, e, "internal-error"), _.open({
            where: document.body,
            url: ZL(e),
            messageHandlersFilter: r.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
            attributes: YL,
            dontclear: !0
        }, (t)=>new Promise(async (n, s)=>{
                await t.restyle({
                    setHideOnLeave: !1
                });
                let c = Sn(e, "network-request-failed"), i = In().setTimeout(()=>{
                    s(c);
                }, jL.get());
                function d() {
                    In().clearTimeout(i), n(t);
                }
                t.ping(d).then(d, ()=>{
                    s(c);
                });
            }));
    }
    var ez = {
        location: "yes",
        resizable: "yes",
        statusbar: "yes",
        toolbar: "no"
    }, oz = 500, rz = 600, tz = "_blank", nz = "http://localhost", bg = class {
        constructor(_){
            this.window = _, this.associatedEvent = null;
        }
        close() {
            if (this.window) try {
                this.window.close();
            } catch  {}
        }
    };
    function sz(e, _, r, t = oz, n = rz) {
        let s = Math.max((window.screen.availHeight - n) / 2, 0).toString(), c = Math.max((window.screen.availWidth - t) / 2, 0).toString(), i = "", d = Object.assign(Object.assign({}, ez), {
            width: t.toString(),
            height: n.toString(),
            top: s,
            left: c
        }), v = Wo().toLowerCase();
        r && (i = LR(v) ? tz : r), PR(v) && (_ = _ || nz, d.scrollbars = "yes");
        let b = Object.entries(d).reduce((u, [m, z])=>`${u}${m}=${z},`, "");
        if (GP(v) && i !== "_self") return cz(_ || "", i), new bg(null);
        let p = window.open(_ || "", i, b);
        M_(p, e, "popup-blocked");
        try {
            p.focus();
        } catch  {}
        return new bg(p);
    }
    function cz(e, _) {
        let r = document.createElement("a");
        r.href = e, r.target = _;
        let t = document.createEvent("MouseEvent");
        t.initMouseEvent("click", !0, !0, window, 1, 0, 0, 0, 0, !1, !1, !1, !1, 1, null), r.dispatchEvent(t);
    }
    var az = "__/auth/handler", iz = "emulator/auth/handler", lz = encodeURIComponent("fac");
    async function wR(e, _, r, t, n, s) {
        M_(e.config.authDomain, e, "auth-domain-config-required"), M_(e.config.apiKey, e, "invalid-api-key");
        let c = {
            apiKey: e.config.apiKey,
            appName: e.name,
            authType: r,
            redirectUrl: t,
            v: q0,
            eventId: n
        };
        if (_ instanceof sg) {
            _.setDefaultLanguage(e.languageCode), c.providerId = _.providerId || "", C9(_.getCustomParameters()) || (c.customParameters = JSON.stringify(_.getCustomParameters()));
            for (let [b, p] of Object.entries(s || {}))c[b] = p;
        }
        if (_ instanceof Sc) {
            let b = _.getScopes().filter((p)=>p !== "");
            b.length > 0 && (c.scopes = b.join(","));
        }
        e.tenantId && (c.tid = e.tenantId);
        let i = c;
        for (let b of Object.keys(i))i[b] === void 0 && delete i[b];
        let d = await e._getAppCheckToken(), v = d ? `#${lz}=${encodeURIComponent(d)}` : "";
        return `${dz(e)}?${da(i).slice(1)}${v}`;
    }
    function dz({ config: e  }) {
        return e.emulator ? z$(e, iz) : `https://${e.authDomain}/${az}`;
    }
    var $$ = "webStorageSupport", F$ = class {
        constructor(){
            this.eventManagers = {}, this.iframes = {}, this.originValidationPromises = {}, this._redirectPersistence = J$, this._completeRedirectFn = PL, this._overrideRedirectResult = NL;
        }
        async _openPopup(_, r, t, n) {
            var s;
            d0((s = this.eventManagers[_._key()]) === null || s === void 0 ? void 0 : s.manager, "_initialize() not called before _openPopup()");
            let c = await wR(_, r, t, h$(), n);
            return sz(_, c, V$());
        }
        async _openRedirect(_, r, t, n) {
            await this._originValidation(_);
            let s = await wR(_, r, t, h$(), n);
            return uL(s), new Promise(()=>{});
        }
        _initialize(_) {
            let r = _._key();
            if (this.eventManagers[r]) {
                let { manager: n , promise: s  } = this.eventManagers[r];
                return n ? Promise.resolve(n) : (d0(s, "If manager is not set, promise should be"), s);
            }
            let t = this.initAndGetManager(_);
            return this.eventManagers[r] = {
                promise: t
            }, t.catch(()=>{
                delete this.eventManagers[r];
            }), t;
        }
        async initAndGetManager(_) {
            let r = await _z(_), t = new N$(_);
            return r.register("authEvent", (n)=>(M_(n?.authEvent, _, "invalid-auth-event"), {
                    status: t.onEvent(n.authEvent) ? "ACK" : "ERROR"
                }), gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER), this.eventManagers[_._key()] = {
                manager: t
            }, this.iframes[_._key()] = r, t;
        }
        _isIframeWebStorageSupported(_, r) {
            this.iframes[_._key()].send($$, {
                type: $$
            }, (n)=>{
                var s;
                let c = (s = n?.[0]) === null || s === void 0 ? void 0 : s[$$];
                c !== void 0 && r(!!c), Vt(_, "internal-error");
            }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        }
        _originValidation(_) {
            let r = _._key();
            return this.originValidationPromises[r] || (this.originValidationPromises[r] = JL(_)), this.originValidationPromises[r];
        }
        get _shouldInitProactively() {
            return JR() || U$() || yg();
        }
    }, sk = F$, pg = class {
        constructor(_){
            this.factorId = _;
        }
        _process(_, r, t) {
            switch(r.type){
                case "enroll":
                    return this._finalizeEnroll(_, r.credential, t);
                case "signin":
                    return this._finalizeSignIn(_, r.credential);
                default:
                    return kn("unexpected MultiFactorSessionType");
            }
        }
    }, M$ = class e extends pg {
        constructor(_){
            super("phone"), this.credential = _;
        }
        static _fromCredential(_) {
            return new e(_);
        }
        _finalizeEnroll(_, r, t) {
            return sL(_, {
                idToken: r,
                displayName: t,
                phoneVerificationInfo: this.credential._makeVerificationRequest()
            });
        }
        _finalizeSignIn(_, r) {
            return wL(_, {
                mfaPendingCredential: r,
                phoneVerificationInfo: this.credential._makeVerificationRequest()
            });
        }
    }, fg = class {
        constructor(){}
        static assertion(_) {
            return M$._fromCredential(_);
        }
    };
    fg.FACTOR_ID = "phone";
    var mg = class {
        static assertionForEnrollment(_, r) {
            return $g._fromSecret(_, r);
        }
        static assertionForSignIn(_, r) {
            return $g._fromEnrollmentId(_, r);
        }
        static async generateSecret(_) {
            var r;
            let t = _;
            M_(typeof ((r = t.user) === null || r === void 0 ? void 0 : r.auth) < "u", "internal-error");
            let n = await cL(t.user.auth, {
                idToken: t.credential,
                totpEnrollmentInfo: {}
            });
            return hg._fromStartTotpMfaEnrollmentResponse(n, t.user.auth);
        }
    };
    mg.FACTOR_ID = "totp";
    var $g = class e extends pg {
        constructor(_, r, t){
            super("totp"), this.otp = _, this.enrollmentId = r, this.secret = t;
        }
        static _fromSecret(_, r) {
            return new e(r, void 0, _);
        }
        static _fromEnrollmentId(_, r) {
            return new e(r, _);
        }
        async _finalizeEnroll(_, r, t) {
            return M_(typeof this.secret < "u", _, "argument-error"), aL(_, {
                idToken: r,
                displayName: t,
                totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
            });
        }
        async _finalizeSignIn(_, r) {
            M_(this.enrollmentId !== void 0 && this.otp !== void 0, _, "argument-error");
            let t = {
                verificationCode: this.otp
            };
            return RL(_, {
                mfaPendingCredential: r,
                mfaEnrollmentId: this.enrollmentId,
                totpVerificationInfo: t
            });
        }
    }, hg = class e {
        constructor(_, r, t, n, s, c, i){
            this.sessionInfo = c, this.auth = i, this.secretKey = _, this.hashingAlgorithm = r, this.codeLength = t, this.codeIntervalSeconds = n, this.enrollmentCompletionDeadline = s;
        }
        static _fromStartTotpMfaEnrollmentResponse(_, r) {
            return new e(_.totpSessionInfo.sharedSecretKey, _.totpSessionInfo.hashingAlgorithm, _.totpSessionInfo.verificationCodeLength, _.totpSessionInfo.periodSec, new Date(_.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), _.totpSessionInfo.sessionInfo, r);
        }
        _makeTotpVerificationInfo(_) {
            return {
                sessionInfo: this.sessionInfo,
                verificationCode: _
            };
        }
        generateQrCodeUrl(_, r) {
            var t;
            let n = !1;
            return (j1(_) || j1(r)) && (n = !0), n && (j1(_) && (_ = ((t = this.auth.currentUser) === null || t === void 0 ? void 0 : t.email) || "unknownuser"), j1(r) && (r = this.auth.name)), `otpauth://totp/${r}:${_}?secret=${this.secretKey}&issuer=${r}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
        }
    };
    function j1(e) {
        return typeof e > "u" || e?.length === 0;
    }
    var RR = "@firebase/auth", kR = "1.7.5";
    var P$ = class {
        constructor(_){
            this.auth = _, this.internalListeners = new Map;
        }
        getUid() {
            var _;
            return this.assertAuthConfigured(), ((_ = this.auth.currentUser) === null || _ === void 0 ? void 0 : _.uid) || null;
        }
        async getToken(_) {
            return this.assertAuthConfigured(), await this.auth._initializationPromise, this.auth.currentUser ? {
                accessToken: await this.auth.currentUser.getIdToken(_)
            } : null;
        }
        addAuthTokenListener(_) {
            if (this.assertAuthConfigured(), this.internalListeners.has(_)) return;
            let r = this.auth.onIdTokenChanged((t)=>{
                _(t?.stsTokenManager.accessToken || null);
            });
            this.internalListeners.set(_, r), this.updateProactiveRefresh();
        }
        removeAuthTokenListener(_) {
            this.assertAuthConfigured();
            let r = this.internalListeners.get(_);
            r && (this.internalListeners.delete(_), r(), this.updateProactiveRefresh());
        }
        assertAuthConfigured() {
            M_(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth");
        }
        updateProactiveRefresh() {
            this.internalListeners.size > 0 ? this.auth._startProactiveRefresh() : this.auth._stopProactiveRefresh();
        }
    };
    function vz(e) {
        switch(e){
            case "Node":
                return "node";
            case "ReactNative":
                return "rn";
            case "Worker":
                return "webworker";
            case "Cordova":
                return "cordova";
            case "WebExtension":
                return "web-extension";
            default:
                return;
        }
    }
    function uz(e) {
        an(new Kr("auth", (_, { options: r  })=>{
            let t = _.getProvider("app").getImmediate(), n = _.getProvider("heartbeat"), s = _.getProvider("app-check-internal"), { apiKey: c , authDomain: i  } = t.options;
            M_(c && !c.includes(":"), "invalid-api-key", {
                appName: t.name
            });
            let d = {
                apiKey: c,
                authDomain: i,
                clientPlatform: e,
                apiHost: "identitytoolkit.googleapis.com",
                tokenApiHost: "securetoken.googleapis.com",
                apiScheme: "https",
                sdkClientVersion: VR(e)
            }, v = new I$(t, n, s, d);
            return UP(v, r), v;
        }, "PUBLIC").setInstantiationMode("EXPLICIT").setInstanceCreatedCallback((_, r, t)=>{
            _.getProvider("auth-internal").initialize();
        })), an(new Kr("auth-internal", (_)=>{
            let r = Ec(_.getProvider("auth").getImmediate());
            return ((t)=>new P$(t))(r);
        }, "PRIVATE").setInstantiationMode("EXPLICIT")), Qr(RR, kR, vz(e)), Qr(RR, kR, "esm2017");
    }
    var gz = 300, bz = Zp("authIdTokenMaxAge") || gz, SR = null, pz = (e)=>async (_)=>{
            let r = _ && await _.getIdTokenResult(), t = r && (new Date().getTime() - Date.parse(r.issuedAtTime)) / 1e3;
            if (t && t > bz) return;
            let n = r?.token;
            SR !== n && (SR = n, await fetch(e, {
                method: n ? "POST" : "DELETE",
                headers: n ? {
                    Authorization: `Bearer ${n}`
                } : {}
            }));
        };
    function Nd(e = W0()) {
        let _ = Ys(e, "auth");
        if (_.isInitialized()) return _.getImmediate();
        let r = HR(e, {
            popupRedirectResolver: sk,
            persistence: [
                tk,
                _k,
                J$
            ]
        }), t = Zp("authTokenSyncURL");
        if (t && typeof isSecureContext == "boolean" && isSecureContext) {
            let s = new URL(t, location.origin);
            if (location.origin === s.origin) {
                let c = pz(s.toString());
                ZR(r, c, ()=>c(r.currentUser)), XR(r, (i)=>c(i));
            }
        }
        let n = Yp("auth");
        return n && wg(r, `http://${n}`), r;
    }
    function fz() {
        var e, _;
        return (_ = (e = document.getElementsByTagName("head")) === null || e === void 0 ? void 0 : e[0]) !== null && _ !== void 0 ? _ : document;
    }
    MP({
        loadJS (e) {
            return new Promise((_, r)=>{
                let t = document.createElement("script");
                t.setAttribute("src", e), t.onload = _, t.onerror = (n)=>{
                    let s = Sn("internal-error");
                    s.customData = n, r(s);
                }, t.type = "text/javascript", t.charset = "UTF-8", fz().appendChild(t);
            });
        },
        gapiScript: "https://apis.google.com/js/api.js",
        recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
        recaptchaEnterpriseScript: "https://www.google.com/recaptcha/enterprise.js?render="
    });
    uz("Browser");
    var q$ = (e)=>(_)=>(r)=>function() {
                    return B$(e, _, r).catch((t)=>{
                        throw new Error(t.code);
                    });
                };
    var W$ = function() {
        return Nd();
    }, H$ = (e)=>function() {
            return e.signOut();
        }, j$ = (e)=>function() {
            let _ = "_onAuthStateChanged";
            if (window.firebaseSubscriptionState[_] == null) {
                let r = Rg(e, (t)=>{
                    let n = JSON.stringify({
                        firebaseUser: t
                    });
                    document.dispatchEvent(new CustomEvent("AuthStateChanged", {
                        detail: n
                    }));
                });
                window.firebaseSubscriptionState[_] = r;
            }
            return _;
        }, K$ = (e)=>(_)=>(r)=>function() {
                    return new Promise((t)=>{
                        let n = Rg(r, (s)=>{
                            n(), t(s == null ? _ : e(s));
                        });
                    });
                };
    var ri = jr(aR);
    var cr = (e, _)=>({
            tag: e,
            _1: _
        }), ck = cr("UNAUTHORIZED"), ak = cr("INVALID_MAX_SLOTS"), ik = cr("INVALID_USER_NAME"), Sg = cr("INVALID_START_BOOKING"), Ig = cr("INVALID_BOOKING_PERMISSION"), lk = cr("EMAIL_EXISTED"), dk = cr("USERNAME_EXISTED"), vk = cr("CANNOT_CREATE_AUTH"), uk = cr("CANNOT_CREATE_USER"), gk = cr("CANNOT_GENERATE_TOKEN"), bk = cr("CANNOT_CREATE_TOKEN"), pk = cr("CANNOT_SEND_MAIL");
    var Y$ = (e)=>cr("DecodeDocError", e), hz = {
        to: (e)=>{
            if (e.tag === "Inl") return ck;
            if (e.tag === "Inr") {
                if (e._1.tag === "Inl") return ak;
                if (e._1.tag === "Inr") {
                    if (e._1._1.tag === "Inl") return ik;
                    if (e._1._1.tag === "Inr") {
                        if (e._1._1._1.tag === "Inl") return Sg;
                        if (e._1._1._1.tag === "Inr") {
                            if (e._1._1._1._1.tag === "Inl") return Ig;
                            if (e._1._1._1._1.tag === "Inr") {
                                if (e._1._1._1._1._1.tag === "Inl") return lk;
                                if (e._1._1._1._1._1.tag === "Inr") {
                                    if (e._1._1._1._1._1._1.tag === "Inl") return dk;
                                    if (e._1._1._1._1._1._1.tag === "Inr") {
                                        if (e._1._1._1._1._1._1._1.tag === "Inl") return vk;
                                        if (e._1._1._1._1._1._1._1.tag === "Inr") {
                                            if (e._1._1._1._1._1._1._1._1.tag === "Inl") return uk;
                                            if (e._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                if (e._1._1._1._1._1._1._1._1._1.tag === "Inl") return gk;
                                                if (e._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                    if (e._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return bk;
                                                    if (e._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                        if (e._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return pk;
                                                        if (e._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return cr("DecodeError", e._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                            if (e._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") return cr("DecodeDocError", e._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                            l();
                                                        }
                                                        l();
                                                    }
                                                    l();
                                                }
                                                l();
                                            }
                                            l();
                                        }
                                        l();
                                    }
                                    l();
                                }
                                l();
                            }
                            l();
                        }
                        l();
                    }
                    l();
                }
                l();
            }
            l();
        },
        from: (e)=>{
            if (e.tag === "UNAUTHORIZED") return o("Inl", P);
            if (e.tag === "INVALID_MAX_SLOTS") return o("Inr", o("Inl", P));
            if (e.tag === "INVALID_USER_NAME") return o("Inr", o("Inr", o("Inl", P)));
            if (e.tag === "INVALID_START_BOOKING") return o("Inr", o("Inr", o("Inr", o("Inl", P))));
            if (e.tag === "INVALID_BOOKING_PERMISSION") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))));
            if (e.tag === "EMAIL_EXISTED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))));
            if (e.tag === "USERNAME_EXISTED") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))));
            if (e.tag === "CANNOT_CREATE_AUTH") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))));
            if (e.tag === "CANNOT_CREATE_USER") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))));
            if (e.tag === "CANNOT_GENERATE_TOKEN") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))));
            if (e.tag === "CANNOT_CREATE_TOKEN") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))))));
            if (e.tag === "CANNOT_SEND_MAIL") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))))))));
            if (e.tag === "DecodeError") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", e._1)))))))))))));
            if (e.tag === "DecodeDocError") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", e._1)))))))))))));
            l();
        }
    }, fk = {
        show: (()=>{
            let e = U(V)({
                reflectSymbol: ()=>"UNAUTHORIZED"
            }), _ = U(V)({
                reflectSymbol: ()=>"INVALID_MAX_SLOTS"
            }), r = U(V)({
                reflectSymbol: ()=>"INVALID_USER_NAME"
            }), t = U(V)({
                reflectSymbol: ()=>"INVALID_START_BOOKING"
            }), n = U(V)({
                reflectSymbol: ()=>"INVALID_BOOKING_PERMISSION"
            }), s = U(V)({
                reflectSymbol: ()=>"EMAIL_EXISTED"
            }), c = U(V)({
                reflectSymbol: ()=>"USERNAME_EXISTED"
            }), i = U(V)({
                reflectSymbol: ()=>"CANNOT_CREATE_AUTH"
            }), d = U(V)({
                reflectSymbol: ()=>"CANNOT_CREATE_USER"
            }), v = U(V)({
                reflectSymbol: ()=>"CANNOT_GENERATE_TOKEN"
            }), b = U(V)({
                reflectSymbol: ()=>"CANNOT_CREATE_TOKEN"
            }), p = U(V)({
                reflectSymbol: ()=>"CANNOT_SEND_MAIL"
            }), u = U({
                genericShowArgs: (z)=>[
                        ge.show(z)
                    ]
            })({
                reflectSymbol: ()=>"DecodeError"
            }), m = U({
                genericShowArgs: (z)=>[
                        ge.show(z)
                    ]
            })({
                reflectSymbol: ()=>"DecodeDocError"
            });
            return (z)=>{
                let L = hz.from(z);
                if (L.tag === "Inl") return e["genericShow'"](L._1);
                if (L.tag === "Inr") {
                    if (L._1.tag === "Inl") return _["genericShow'"](L._1._1);
                    if (L._1.tag === "Inr") {
                        if (L._1._1.tag === "Inl") return r["genericShow'"](L._1._1._1);
                        if (L._1._1.tag === "Inr") {
                            if (L._1._1._1.tag === "Inl") return t["genericShow'"](L._1._1._1._1);
                            if (L._1._1._1.tag === "Inr") {
                                if (L._1._1._1._1.tag === "Inl") return n["genericShow'"](L._1._1._1._1._1);
                                if (L._1._1._1._1.tag === "Inr") {
                                    if (L._1._1._1._1._1.tag === "Inl") return s["genericShow'"](L._1._1._1._1._1._1);
                                    if (L._1._1._1._1._1.tag === "Inr") {
                                        if (L._1._1._1._1._1._1.tag === "Inl") return c["genericShow'"](L._1._1._1._1._1._1._1);
                                        if (L._1._1._1._1._1._1.tag === "Inr") {
                                            if (L._1._1._1._1._1._1._1.tag === "Inl") return i["genericShow'"](L._1._1._1._1._1._1._1._1);
                                            if (L._1._1._1._1._1._1._1.tag === "Inr") {
                                                if (L._1._1._1._1._1._1._1._1.tag === "Inl") return d["genericShow'"](L._1._1._1._1._1._1._1._1._1);
                                                if (L._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                    if (L._1._1._1._1._1._1._1._1._1.tag === "Inl") return v["genericShow'"](L._1._1._1._1._1._1._1._1._1._1);
                                                    if (L._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                        if (L._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return b["genericShow'"](L._1._1._1._1._1._1._1._1._1._1._1);
                                                        if (L._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                            if (L._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return p["genericShow'"](L._1._1._1._1._1._1._1._1._1._1._1._1);
                                                            if (L._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                                                if (L._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") return u["genericShow'"](L._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                if (L._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") return m["genericShow'"](L._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                                                l();
                                                            }
                                                            l();
                                                        }
                                                        l();
                                                    }
                                                    l();
                                                }
                                                l();
                                            }
                                            l();
                                        }
                                        l();
                                    }
                                    l();
                                }
                                l();
                            }
                            l();
                        }
                        l();
                    }
                    l();
                }
                l();
            };
        })()
    }, yz = {
        decodeJson: (e)=>F_.bind(Q_((_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), I_, (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), e))((_)=>S("Right", (()=>_ === "UNAUTHORIZED" ? ck : _ === "INVALID_MAX_SLOTS" ? ak : _ === "INVALID_USER_NAME" ? ik : _ === "INVALID_START_BOOKING" ? Sg : _ === "INVALID_BOOKING_PERMISSION" ? Ig : _ === "EMAIL_EXISTED" ? lk : _ === "USERNAME_EXISTED" ? dk : _ === "CANNOT_CREATE_AUTH" ? vk : _ === "CANNOT_CREATE_USER" ? uk : _ === "CANNOT_GENERATE_TOKEN" ? gk : _ === "CANNOT_CREATE_TOKEN" ? bk : _ === "CANNOT_SEND_MAIL" ? pk : cr("DecodeError", H("UnexpectedValue", e)))()))
    }, Dz = (e)=>{
        let _ = yz.decodeJson(e);
        if (_.tag === "Left") return cr("DecodeError", _._1);
        if (_.tag === "Right") return _._1;
        l();
    }, mk = {
        mapAffError: (e)=>Dz(No(e))
    };
    var ps = (e, _)=>({
            tag: e,
            _1: _
        }), $k = ps("UNAUTHORIZED"), hk = ps("USER_NOT_FOUND"), yk = ps("CANNOT_DELETE_USER");
    var Dk = (e)=>ps("DecodeDocError", e), wz = {
        to: (e)=>{
            if (e.tag === "Inl") return $k;
            if (e.tag === "Inr") {
                if (e._1.tag === "Inl") return hk;
                if (e._1.tag === "Inr") {
                    if (e._1._1.tag === "Inl") return yk;
                    if (e._1._1.tag === "Inr") {
                        if (e._1._1._1.tag === "Inl") return ps("DecodeError", e._1._1._1._1);
                        if (e._1._1._1.tag === "Inr") return ps("DecodeDocError", e._1._1._1._1);
                        l();
                    }
                    l();
                }
                l();
            }
            l();
        },
        from: (e)=>{
            if (e.tag === "UNAUTHORIZED") return o("Inl", P);
            if (e.tag === "USER_NOT_FOUND") return o("Inr", o("Inl", P));
            if (e.tag === "CANNOT_DELETE_USER") return o("Inr", o("Inr", o("Inl", P)));
            if (e.tag === "DecodeError") return o("Inr", o("Inr", o("Inr", o("Inl", e._1))));
            if (e.tag === "DecodeDocError") return o("Inr", o("Inr", o("Inr", o("Inr", e._1))));
            l();
        }
    }, wk = {
        show: (()=>{
            let e = U(V)({
                reflectSymbol: ()=>"UNAUTHORIZED"
            }), _ = U(V)({
                reflectSymbol: ()=>"USER_NOT_FOUND"
            }), r = U(V)({
                reflectSymbol: ()=>"CANNOT_DELETE_USER"
            }), t = U({
                genericShowArgs: (s)=>[
                        ge.show(s)
                    ]
            })({
                reflectSymbol: ()=>"DecodeError"
            }), n = U({
                genericShowArgs: (s)=>[
                        ge.show(s)
                    ]
            })({
                reflectSymbol: ()=>"DecodeDocError"
            });
            return (s)=>{
                let c = wz.from(s);
                if (c.tag === "Inl") return e["genericShow'"](c._1);
                if (c.tag === "Inr") {
                    if (c._1.tag === "Inl") return _["genericShow'"](c._1._1);
                    if (c._1.tag === "Inr") {
                        if (c._1._1.tag === "Inl") return r["genericShow'"](c._1._1._1);
                        if (c._1._1.tag === "Inr") {
                            if (c._1._1._1.tag === "Inl") return t["genericShow'"](c._1._1._1._1);
                            if (c._1._1._1.tag === "Inr") return n["genericShow'"](c._1._1._1._1);
                            l();
                        }
                        l();
                    }
                    l();
                }
                l();
            };
        })()
    }, Rz = {
        decodeJson: (e)=>F_.bind(Q_((_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), I_, (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), e))((_)=>S("Right", (()=>_ === "UNAUTHORIZED" ? $k : _ === "USER_NOT_FOUND" ? hk : _ === "CANNOT_DELETE_USER" ? yk : ps("DecodeError", H("UnexpectedValue", e)))()))
    }, kz = (e)=>{
        let _ = Rz.decodeJson(e);
        if (_.tag === "Left") return ps("DecodeError", _._1);
        if (_.tag === "Right") return _._1;
        l();
    }, Rk = {
        mapAffError: (e)=>kz(No(e))
    };
    var ti = (e, _)=>({
            tag: e,
            _1: _
        }), Sz = ti("USER_NOT_FOUND"), Iz = ti("CANNOT_GENERATE_TOKEN"), xz = ti("CANNOT_CREATE_TOKEN"), Ez = ti("CANNOT_SEND_MAIL");
    var Tz = {
        decodeJson: (e)=>F_.bind(Q_((_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), I_, (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), e))((_)=>S("Right", (()=>_ === "USER_NOT_FOUND" ? Sz : _ === "CANNOT_GENERATE_TOKEN" ? Iz : _ === "CANNOT_CREATE_TOKEN" ? xz : _ === "CANNOT_SEND_MAIL" ? Ez : ti("DecodeError", H("UnexpectedValue", e)))()))
    }, Gz = (e)=>{
        let _ = Tz.decodeJson(e);
        if (_.tag === "Left") return ti("DecodeError", _._1);
        if (_.tag === "Right") return _._1;
        l();
    }, Sk = {
        mapAffError: (e)=>Gz(No(e))
    };
    var ni = (e, _)=>({
            tag: e,
            _1: _
        }), Az = ni("USER_NOT_FOUND"), Nz = ni("INVALID_PASSWORD"), Fz = ni("INVALID_TOKEN"), Mz = ni("CANNOT_UPDATE_PASSWORD");
    var Pz = {
        decodeJson: (e)=>F_.bind(Q_((_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), I_, (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), e))((_)=>S("Right", (()=>_ === "USER_NOT_FOUND" ? Az : _ === "INVALID_PASSWORD" ? Nz : _ === "INVALID_TOKEN" ? Fz : _ === "CANNOT_UPDATE_PASSWORD" ? Mz : ni("DecodeError", H("UnexpectedValue", e)))()))
    }, Lz = (e)=>{
        let _ = Pz.decodeJson(e);
        if (_.tag === "Left") return ni("DecodeError", _._1);
        if (_.tag === "Right") return _._1;
        l();
    }, Ik = {
        mapAffError: (e)=>Lz(No(e))
    };
    var Z$ = (e)=>({
            tag: e
        }), xg = jr(Ik), Eg = jr(Sk), xk = jr(mk), Ek = {
        reflectSymbol: ()=>"username"
    }, _h = z_(oo)($r)(Ek)(), Tk = {
        reflectSymbol: ()=>"uid"
    }, eh = {
        reflectSymbol: ()=>"startBooking"
    }, oh = {
        reflectSymbol: ()=>"schoolName"
    }, rh = {
        reflectSymbol: ()=>"remark"
    }, th = {
        reflectSymbol: ()=>"pax"
    }, nh = {
        reflectSymbol: ()=>"maxSlots"
    }, sh = {
        reflectSymbol: ()=>"isAdmin"
    }, ch = {
        reflectSymbol: ()=>"email"
    }, ah = {
        reflectSymbol: ()=>"bookingPermission"
    }, Oz = jr(Rk), si = Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", Q_((_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), I_, (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), e._1)) : D
    }), Uz = Z$("Only4D"), Bz = Z$("Only3D"), Jz = Z$("BookAll");
    var Gk = {
        encodeJson: (e)=>{
            if (e.tag === "Only4D") return "Only4D";
            if (e.tag === "Only3D") return "Only3D";
            if (e.tag === "BookAll") return "BookAll";
            l();
        }
    }, Vz = (()=>{
        let e = z_(Gk)(z_(oo)(z_(Lp)(z_(Ar)(z_(Ar)(z_(oo)(z_(oo)(z_(oo)(z_(oo)(_h)(Tk)())(eh)())(oh)())(rh)())(th)())(nh)())(sh)())(ch)())(ah)();
        return (_)=>e.gEncodeJson(_)(q);
    })(), qz = (()=>{
        let e = z_(Gk)(z_(oo)(z_(Lp)(z_(Ar)(z_(Ar)(z_(oo)(z_(oo)(z_(oo)(_h)(eh)())(oh)())(rh)())(th)())(nh)())(sh)())(ch)())(ah)();
        return (_)=>e.gEncodeJson(_)(q);
    })();
    var Fd = (e)=>e === "Only4D" ? R("Just", Uz) : e === "Only3D" ? R("Just", Bz) : e === "BookAll" ? R("Just", Jz) : D, ih = {
        decodeJson: (e)=>{
            let _ = Q_((t)=>D, (t)=>D, (t)=>D, f_, (t)=>D, (t)=>D, e), r = (()=>{
                if (_.tag === "Just") return Fd(_._1);
                if (_.tag === "Nothing") return D;
                l();
            })();
            if (r.tag === "Nothing") return S("Left", H("TypeMismatch", "Invalid Booking Permission"));
            if (r.tag === "Just") return S("Right", r._1);
            l();
        }
    }, lh = So(Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", ih.decodeJson(e._1)) : D
    })(si(Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", Q_((_)=>S("Left", H("TypeMismatch", "Boolean")), I_, (_)=>S("Left", H("TypeMismatch", "Boolean")), (_)=>S("Left", H("TypeMismatch", "Boolean")), (_)=>S("Left", H("TypeMismatch", "Boolean")), (_)=>S("Left", H("TypeMismatch", "Boolean")), e._1)) : D
    })(Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", Qn(e._1)) : D
    })(Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", Qn(e._1)) : D
    })(si(si(si(si(si(tr)(Ek)()())(Tk)()())(eh)()())(oh)()())(rh)()())(th)()())(nh)()())(sh)()())(ch)()())(ah)()())(), dh = Y("Cons", Ka, Y("Cons", Co("Placeholder", "-"), Y("Cons", ss, Y("Cons", Co("Placeholder", "-"), Y("Cons", cs, Y("Cons", Co("Placeholder", " "), Y("Cons", G1, Y("Cons", Co("Placeholder", ":"), Y("Cons", C1, y_)))))))));
    var Tg = (e)=>{
        let _ = C3(dh)(e);
        if (_.tag === "Left") return D;
        if (_.tag === "Right") {
            let r = Ja(_i)(-8)(_._1);
            if (r.tag === "Just") {
                let t = qr(Pt(".")(jc(w1(r._1))));
                if (t.tag === "Just") return R("Just", t._1.head);
                if (t.tag === "Nothing") return D;
                l();
            }
            if (r.tag === "Nothing") return D;
            l();
        }
        l();
    }, Ck = (e)=>(_)=>{
            if (e.isAdmin) {
                if (!_.isAdmin) return E_;
                if (_.isAdmin) return Ko.compare(e.username)(_.username);
                l();
            }
            if (!e.isAdmin) {
                if (_.isAdmin) return T_;
                if (!_.isAdmin) return Ko.compare(e.startBooking)(_.startBooking);
                l();
            }
            l();
        };
    var Ak = (e)=>(_)=>{
            let r = e, t = _, n = !0, s;
            for(; n;){
                let c = r, i = t;
                if (i.tag === "Nil") {
                    n = !1, s = D;
                    continue;
                }
                if (i.tag === "Cons") {
                    if (i._1.username === c) {
                        n = !1, s = R("Just", i._1);
                        continue;
                    }
                    r = c, t = i._2;
                    continue;
                }
                l();
            }
            return s;
        }, Gg = (e)=>Qo.bind(xk(H3(Vz(e))))((_)=>Ws(fe.bimap(Y$)(re)(Q_((r)=>S("Right", void 0), (r)=>S("Left", H("TypeMismatch", "null")), (r)=>S("Left", H("TypeMismatch", "null")), (r)=>S("Left", H("TypeMismatch", "null")), (r)=>S("Left", H("TypeMismatch", "null")), (r)=>S("Left", H("TypeMismatch", "null")), _)))), Cg = (e)=>Qo.bind(Oz(j3(_h.gEncodeJson({
            username: e
        })(q))))((_)=>Ws(fe.bimap(Dk)(re)(Q_((r)=>S("Right", void 0), (r)=>S("Left", H("TypeMismatch", "null")), (r)=>S("Left", H("TypeMismatch", "null")), (r)=>S("Left", H("TypeMismatch", "null")), (r)=>S("Left", H("TypeMismatch", "null")), (r)=>S("Left", H("TypeMismatch", "null")), _)))), ci = (e)=>Qo.bind(xk(W3(qz(e))))((_)=>Ws(fe.bimap(Y$)(re)(lh.decodeJson(_))));
    var Nk = (e)=>(_)=>Qo.bind(Gm(lh)(e)("/users")(P0(_.displayName)))((r)=>Io(so(S("Right", r._2)))), Fk = (e)=>(_)=>(r)=>(t)=>Qo.bind(nn.bimap((n)=>({
                            type: "dbError",
                            value: n
                        }))(re)(Gm(lh)(e)("/users")(P0(r))))((n)=>{
                        let s = n._2;
                        return Qo.bind(nn.bimap((c)=>({
                                type: "authError",
                                value: c
                            }))(re)(ri(q$(_)(s.email)(t))))(()=>Io(so(S("Right", s))));
                    });
    var Ag = function(e) {
        return function() {
            console.log(e);
        };
    };
    var fs = function(e) {
        return function() {
            console.error(e);
        };
    };
    var Md = (e)=>(_)=>function() {
                let r = new Blob([
                    _
                ], {
                    type: "text/csv"
                }), t = URL.createObjectURL(r), n = document.createElement("a");
                document.body.appendChild(n), n.style = "display:none", n.href = t, n.download = e, n.click(), n.remove(), URL.revokeObjectURL(t);
            };
    var vh = (e)=>async function() {
            let { workYear: _ , columnWidths: r , cellData: t  } = e, n = new ExcelJS.Workbook, s = n.addWorksheet(`Calendar ${_}`);
            return s.views = [
                {
                    state: "frozen",
                    xSplit: 5,
                    ySplit: 1
                }
            ], Hz(s, r), jz(s, t), n.xlsx.writeBuffer().then((c)=>Qz(`oalc-calendar-${_}.xlsx`, c));
        };
    function Hz(e, _) {
        _.forEach((r, t)=>{
            let n = e.getColumn(t + 1);
            n.width = r;
        });
    }
    function jz(e, _) {
        let r = Kz(e);
        _.forEach((t)=>{
            let { value: n , rowIndex: s , colIndex: c , merge: i , style: d  } = t, v = r(s, c);
            if (n === "" || isNaN(Number(n)) ? v.value = n : v.value = Number(n), i != null) switch(i._t){
                case "MergeRight":
                    let b = r(s, c + i.value - 1);
                    e.mergeCells(`${v._address}:${b._address}`);
                    break;
                case "MergeBottom":
                    let p = r(s + i.value - 1, c);
                    e.mergeCells(`${v._address}:${p._address}`);
                    break;
                default:
                    let u = `Invalid merge type: ${JSON.stringify(i)}`;
                    throw console.error(u), new Error(u);
            }
            v.font = {
                size: d.textSize,
                color: {
                    argb: d.color
                }
            }, v.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                    argb: d.bgColor
                }
            }, v.alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: !0
            }, v.border = {
                top: {
                    style: "thin"
                },
                left: {
                    style: "thin"
                },
                bottom: {
                    style: "thin"
                },
                right: {
                    style: "thin"
                }
            };
        });
    }
    function Kz(e) {
        return function(_, r) {
            return e.getRow(_ + 1).getCell(r + 1);
        };
    }
    function Qz(e, _) {
        let r = new Blob([
            _
        ], {
            type: "application/vnd.ms-excel"
        }), t = URL.createObjectURL(r), n = document.createElement("a");
        document.body.appendChild(n), n.style = "display:none", n.href = t, n.download = e, n.click(), n.remove(), URL.revokeObjectURL(t);
    }
    var Lk = LE(Pk(), 1);
    async function Xz(e) {
        return new Promise((_, r)=>{
            let t = document.getElementById(e);
            if (t == null) {
                _("");
                return;
            }
            let n = t.files[0];
            if (t.value = null, n == null) {
                r("No file uploaded.");
                return;
            }
            let s = new FileReader;
            s.onload = function(c) {
                let i = c.target.result;
                _(i);
            }, s.onerror = function(c) {
                console.error(c), r("File reader error");
            }, s.readAsText(n);
        });
    }
    var Pd = (e)=>function() {
            return new Promise(async (_, r)=>{
                let t = await Xz(e);
                Lk.default.parse(t.trim(), {
                    header: !0,
                    transformHeader: (n, s)=>[
                            "username",
                            "schoolName",
                            "email",
                            "maxSlots",
                            "pax",
                            "remark",
                            "bookingPermission",
                            "startBooking"
                        ][s],
                    error: (n)=>{
                        console.error(n), r(n);
                    },
                    complete: (n)=>{
                        console.log(n), _({
                            rows: n.data,
                            errors: n.error == null ? [] : n.error.map((s)=>({
                                    rowNum: s.row,
                                    message: s.type + ":" + s.code + " " + message
                                }))
                        });
                    }
                });
            });
        };
    var Fg = jr(la);
    var bh = (e)=>(_)=>function() {
                return setInterval(()=>{
                    let r = JSON.stringify({
                        now: String(Date.now())
                    });
                    document.dispatchEvent(new CustomEvent(_, {
                        detail: r
                    }));
                }, e);
            }, ai = (e)=>function() {
            return clearInterval(e);
        };
    window.firebaseSubscriptionState = {};
    window.firebaseFunctionsRegion = "asia-southeast1";
    var ph = (e)=>({ useEmulator: _  })=>function() {
                let r = b5(e), t = z1(r, window.firebaseFunctionsRegion);
                if (_ === !0) {
                    let n = Nd(), s = e1();
                    wg(n, "http://127.0.0.1:9099"), Dm(s, "127.0.0.1", 8080), s$(t, "127.0.0.1", 3002);
                }
                return r;
            }, fh = (e)=>function() {
            let _ = window.firebaseSubscriptionState[e];
            _ != null && (window.firebaseSubscriptionState[e] = null, _());
        };
    var Uk = (()=>pl(la).liftEffect)();
    var Jk = {
        bifoldMap: (e)=>{
            let _ = e.Semigroup0().append;
            return (r)=>(t)=>(n)=>_(r(n._1))(t(n._2));
        },
        bifoldr: (e)=>(_)=>(r)=>(t)=>e(t._1)(_(t._2)(r)),
        bifoldl: (e)=>(_)=>(r)=>(t)=>_(e(r)(t._1))(t._2)
    };
    var mh = {
        bitraverse: (e)=>{
            let _ = e.Apply0(), r = _.Functor0().map;
            return (t)=>(n)=>(s)=>_.apply(r(qo)(t(s._1)))(n(s._2));
        },
        bisequence: (e)=>{
            let _ = e.Apply0(), r = _.Functor0().map;
            return (t)=>_.apply(r(qo)(t._1))(t._2);
        },
        Bifunctor0: ()=>Hv,
        Bifoldable1: ()=>Jk
    };
    function nO(e) {
        return e.replace(/[!'()*]/g, function(_) {
            return "%" + _.charCodeAt(0).toString(16);
        });
    }
    function ii(e, _, r) {
        try {
            return _(nO(encodeURIComponent(r)));
        } catch (t) {
            return e(t);
        }
    }
    function Tc(e, _, r) {
        try {
            return _(decodeURIComponent(r));
        } catch (t) {
            return e(t);
        }
    }
    var $h = (e)=>ii((_)=>D, f_, e);
    var ms = (e, _, r)=>({
            tag: e,
            _1: _,
            _2: r
        }), Ho = (e, _, r)=>({
            tag: e,
            _1: _,
            _2: r
        }), _t = (e, _, r)=>({
            tag: e,
            _1: _,
            _2: r
        }), qk = (()=>mh.bitraverse(_n))(), Mg = (()=>lt.traverse(_n))();
    var yh = ms("EndOfPath");
    var Dh = Ho("Chomp", (e)=>{
        let _ = qr(e.segments);
        return _.tag === "Just" ? _t("Success", {
            segments: _._1.tail,
            params: e.params,
            hash: e.hash
        }, _._1.head) : _t("Fail", yh);
    });
    var sO = (()=>{
        let e = mh.bitraverse(_n)((()=>{
            let _ = qk((r)=>{
                let t = r === "" ? [] : Pt("/")(r);
                return t.length === 2 ? t[0] === "" ? t[1] === "" ? S("Right", [
                    ""
                ]) : Mg((n)=>{
                    let s = Tc((c)=>D, f_, n);
                    if (s.tag === "Nothing") return S("Left", ms("MalformedURIComponent", n));
                    if (s.tag === "Just") return S("Right", s._1);
                    l();
                })(t) : Mg((n)=>{
                    let s = Tc((c)=>D, f_, n);
                    if (s.tag === "Nothing") return S("Left", ms("MalformedURIComponent", n));
                    if (s.tag === "Just") return S("Right", s._1);
                    l();
                })(t) : Mg((n)=>{
                    let s = Tc((c)=>D, f_, n);
                    if (s.tag === "Nothing") return S("Left", ms("MalformedURIComponent", n));
                    if (s.tag === "Just") return S("Right", s._1);
                    l();
                })(t);
            })((()=>{
                let r = Mg((()=>{
                    let t = qk((n)=>{
                        let s = Tc((c)=>D, f_, n);
                        if (s.tag === "Nothing") return S("Left", ms("MalformedURIComponent", n));
                        if (s.tag === "Just") return S("Right", s._1);
                        l();
                    })((n)=>{
                        let s = Tc((c)=>D, f_, n);
                        if (s.tag === "Nothing") return S("Left", ms("MalformedURIComponent", n));
                        if (s.tag === "Just") return S("Right", s._1);
                        l();
                    });
                    return (n)=>t((()=>{
                            let s = _l("=")(n);
                            if (s.tag === "Just") return E(Js(s._1)(n), it(s._1 + Vr("=") | 0)(n));
                            if (s.tag === "Nothing") return E(n, "");
                            l();
                        })());
                })());
                return (t)=>r(t === "" ? [] : Pt("&")(t));
            })());
            return (r)=>_((()=>{
                    let t = _l("?")(r);
                    if (t.tag === "Just") return E(Js(t._1)(r), it(t._1 + Vr("?") | 0)(r));
                    if (t.tag === "Nothing") return E(r, "");
                    l();
                })());
        })())(I_);
        return (_)=>{
            let r = _l("#")(_), t = e((()=>{
                if (r.tag === "Just") return E(Js(r._1)(_), it(r._1 + Vr("#") | 0)(_));
                if (r.tag === "Nothing") return E(_, "");
                l();
            })());
            if (t.tag === "Left") return S("Left", t._1);
            if (t.tag === "Right") return S("Right", {
                segments: t._1._1._1,
                params: t._1._1._2,
                hash: t._1._2
            });
            l();
        };
    })();
    var Wk = {
        map: (e)=>(_)=>{
                if (_.tag === "Fail") return _t("Fail", _._1);
                if (_.tag === "Success") return _t("Success", _._1, e(_._2));
                l();
            }
    }, bt = {
        map: (e)=>(_)=>{
                if (_.tag === "Alt") return Ho("Alt", te(bt.map(e))(_._1));
                if (_.tag === "Chomp") return Ho("Chomp", (r)=>Wk.map(e)(_._1(r)));
                if (_.tag === "Prefix") return Ho("Prefix", _._1, bt.map(e)(_._2));
                l();
            }
    };
    var Hk = Ho("Chomp", (e)=>{
        let _ = Wr(e.segments)(0);
        if (_.tag === "Nothing") return _t("Success", e, void 0);
        if (_.tag === "Just") return _t("Fail", ms("ExpectedEndOfPath", _._1));
        l();
    }), cO = (e)=>(_)=>{
            let r = Wr(_.segments)(0);
            return r.tag === "Just" ? e === r._1 ? _t("Success", {
                segments: ea(1)(_.segments.length)(_.segments),
                params: _.params,
                hash: _.hash
            }, void 0) : _t("Fail", ms("Expected", e, r._1)) : _t("Fail", yh);
        }, jk = Wi(()=>(_)=>(r)=>{
                let t = _, n = r, s = !0, c;
                for(; s;){
                    let i = t, d = n;
                    if (d.tag === "Alt") {
                        s = !1, c = Vn((v)=>(b)=>v.tag === "Fail" ? jk()(i)(b) : v)(_t("Fail", yh))(d._1);
                        continue;
                    }
                    if (d.tag === "Chomp") {
                        s = !1, c = d._1(i);
                        continue;
                    }
                    if (d.tag === "Prefix") {
                        let v = cO(d._1)(i);
                        if (v.tag === "Fail") {
                            s = !1, c = _t("Fail", v._1);
                            continue;
                        }
                        if (v.tag === "Success") {
                            t = v._1, n = d._2;
                            continue;
                        }
                        l();
                    }
                    l();
                }
                return c;
            }), hh = jk();
    var li = (e)=>(_)=>F_.bind(sO(_))((r)=>{
                let t = hh(r)(e);
                if (t.tag === "Fail") return S("Left", t._1);
                if (t.tag === "Success") return S("Right", t._2);
                l();
            });
    var Pg = {
        apply: (e)=>(_)=>Ho("Chomp", (r)=>{
                    let t = hh(r)(e);
                    if (t.tag === "Fail") return _t("Fail", t._1);
                    if (t.tag === "Success") return Wk.map(t._2)(hh(t._1)(_));
                    l();
                }),
        Functor0: ()=>bt
    };
    var aO = (e)=>(_)=>{
            if (_.tag === "Prefix") {
                let r = Wr(e)(e.length - 1 | 0), t = (()=>{
                    if (r.tag === "Just") return r._1;
                    l();
                })();
                if (t.tag === "Prefix") {
                    if (_._1 === t._1) {
                        let n = hp(e);
                        return Ft((()=>{
                            if (n.tag === "Just") return n._1;
                            l();
                        })())(Ho("Prefix", _._1, Gc.alt(t._2)(_._2)));
                    }
                    return Ft(e)(_);
                }
                return Ft(e)(_);
            }
            return Ft(e)(_);
        }, Gc = {
        alt: (e)=>(_)=>e.tag === "Alt" ? _.tag === "Alt" ? Ho("Alt", Kk(e._1)(_._1)) : Ho("Alt", aO(e._1)(_)) : _.tag === "Alt" ? Ho("Alt", iO(e)(_._1)) : e.tag === "Prefix" ? _.tag === "Prefix" ? e._1 === _._1 ? Ho("Prefix", e._1, Gc.alt(e._2)(_._2)) : Ho("Alt", [
                    e,
                    _
                ]) : Ho("Alt", [
                    e,
                    _
                ]) : Ho("Alt", [
                    e,
                    _
                ]),
        Functor0: ()=>bt
    }, iO = (e)=>(_)=>{
            if (e.tag === "Prefix") {
                let r = Wr(_)(0), t = (()=>{
                    if (r.tag === "Just") return r._1;
                    l();
                })();
                if (t.tag === "Prefix") {
                    if (e._1 === t._1) {
                        let n = $p(_);
                        return ne([
                            Ho("Prefix", e._1, Gc.alt(e._2)(t._2))
                        ])((()=>{
                            if (n.tag === "Just") return n._1;
                            l();
                        })());
                    }
                    return ne([
                        e
                    ])(_);
                }
                return ne([
                    e
                ])(_);
            }
            return ne([
                e
            ])(_);
        }, Kk = (e)=>(_)=>{
            let r = Wr(e)(e.length - 1 | 0), t = (()=>{
                if (r.tag === "Just") return r._1;
                l();
            })();
            if (t.tag === "Prefix") {
                let n = Wr(_)(0), s = (()=>{
                    if (n.tag === "Just") return n._1;
                    l();
                })();
                if (s.tag === "Prefix") {
                    if (t._1 === s._1) {
                        let c = $p(_), i = ne([
                            Ho("Prefix", t._1, Gc.alt(t._2)(s._2))
                        ])((()=>{
                            if (c.tag === "Just") return c._1;
                            l();
                        })()), d = hp(e), v = (()=>{
                            if (d.tag === "Just") return d._1;
                            l();
                        })();
                        return v.length > 0 ? Kk(v)(i) : i;
                    }
                    return ne(e)(_);
                }
                return ne(e)(_);
            }
            return ne(e)(_);
        };
    var di = {
        segments: [],
        params: [],
        hash: ""
    };
    var Qk = (()=>w2(Kv).append)();
    var lO = {
        append: (e)=>(_)=>(r)=>_(e(r))
    }, wh = (e)=>(_)=>({
                segments: Ft(_.segments)(e),
                params: _.params,
                hash: _.hash
            }), zd = (e)=>(()=>e.segments.length === 1 ? e.segments[0] === "" ? "/" : Hr("/")(oa($h)(e.segments)) : Hr("/")(oa($h)(e.segments)))() + (e.params.length === 0 ? "" : "?" + Hr("&")(oa((_)=>_._2 === "" ? ii((r)=>D, f_, _._1) : Qk(ii((r)=>D, f_, _._1))(Qk(R("Just", "="))(ii((r)=>D, f_, _._2))))(e.params))) + (e.hash === "" ? "" : "#" + e.hash);
    var Yk = {
        mempty: (e)=>e,
        Semigroup0: ()=>lO
    };
    var xt = (e, _)=>({
            tag: "RouteDuplex",
            _1: e,
            _2: _
        });
    var dO = (e)=>(_)=>xt(e, _);
    var Xk = {
        dimap: (e)=>(_)=>(r)=>xt((t)=>r._1(e(t)), bt.map(_)(r._2))
    };
    var vO = (e)=>(_)=>xt((r)=>{
                let t = _._1(r);
                return (n)=>t({
                        segments: Ft(n.segments)(e),
                        params: n.params,
                        hash: n.hash
                    });
            }, Ho("Prefix", e, _._2)), qt = (()=>{
        let e = Tr(vO), _ = Pt("/");
        return (r)=>{
            let t = _(r);
            return (n)=>e(n)(t);
        };
    })(), Zk = qt("");
    var uO = {
        map: (e)=>(_)=>xt(_._1, bt.map(e)(_._2))
    };
    var _S = (e)=>xt(e._1, Pg.apply(bt.map(Hc)(e._2))(Hk));
    var gO = {
        apply: (e)=>(_)=>xt((r)=>{
                    let t = e._1(r), n = _._1(r);
                    return (s)=>n(t(s));
                }, Pg.apply(e._2)(_._2)),
        Functor0: ()=>uO
    }, eS = {
        pure: (()=>{
            let e = dO((_)=>Yk.mempty);
            return (_)=>e(Ho("Chomp", (r)=>_t("Success", r, _)));
        })(),
        Apply0: ()=>gO
    };
    var bO = (e)=>e, xn = (()=>eS.pure(P))();
    var En = {
        gRouteDuplexCtr: bO
    };
    var Tn = (e)=>(_)=>({
                gRouteDuplex: (r)=>(t)=>{
                        let n = e.gRouteDuplex(r)(t), s = _.gRouteDuplex(r)(t);
                        return xt((c)=>{
                            if (c.tag === "Inl") return n._1(c._1);
                            if (c.tag === "Inr") return s._1(c._1);
                            l();
                        }, Gc.alt(bt.map($2)(n._2))(bt.map(h2)(s._2)));
                    }
            }), rS = (e)=>{
        let _ = e.from, r = e.to;
        return (t)=>{
            let n = t.gRouteDuplex(_S);
            return (s)=>Xk.dimap(_)(r)(n(s));
        };
    };
    var Wt = (e)=>()=>(_)=>({
                    gRouteDuplex: (r)=>(t)=>{
                            let n = r(_.gRouteDuplexCtr(Vo(e.reflectSymbol(q))(t)));
                            return xt((s)=>n._1(s), bt.map(y2)(n._2));
                        }
                });
    var tS = {
        gRouteDuplexCtr: (e)=>xt((_)=>e._1(_), bt.map(D2)(e._2))
    };
    var Gn = (e, _)=>({
            tag: e,
            _1: _
        }), fO = {
        reflectSymbol: ()=>"CalendarRoute"
    }, mO = {
        reflectSymbol: ()=>"UserCreateRoute"
    }, $O = {
        reflectSymbol: ()=>"UserEditRoute"
    }, hO = {
        reflectSymbol: ()=>"UserImportRoute"
    }, yO = {
        reflectSymbol: ()=>"UsersRoute"
    }, DO = {
        reflectSymbol: ()=>"NotFoundRoute"
    }, wO = {
        reflectSymbol: ()=>"ResetPasswordRoute"
    }, RO = {
        reflectSymbol: ()=>"ForgotPasswordRoute"
    }, kO = {
        reflectSymbol: ()=>"LoginRoute"
    }, SO = {
        reflectSymbol: ()=>"LogoutRoute"
    }, Cc = Gn("CalendarRoute"), Rh = Gn("UserCreateRoute"), kh = Gn("UserEditRoute"), Sh = Gn("UserImportRoute"), Od = Gn("UsersRoute"), Ud = Gn("NotFoundRoute");
    var Ih = Gn("ForgotPasswordRoute"), Et = Gn("LoginRoute"), vi = Gn("LogoutRoute"), IO = {
        to: (e)=>{
            if (e.tag === "Inl") return Cc;
            if (e.tag === "Inr") {
                if (e._1.tag === "Inl") return Rh;
                if (e._1.tag === "Inr") {
                    if (e._1._1.tag === "Inl") return kh;
                    if (e._1._1.tag === "Inr") {
                        if (e._1._1._1.tag === "Inl") return Sh;
                        if (e._1._1._1.tag === "Inr") {
                            if (e._1._1._1._1.tag === "Inl") return Od;
                            if (e._1._1._1._1.tag === "Inr") {
                                if (e._1._1._1._1._1.tag === "Inl") return Ud;
                                if (e._1._1._1._1._1.tag === "Inr") {
                                    if (e._1._1._1._1._1._1.tag === "Inl") return Gn("ResetPasswordRoute", e._1._1._1._1._1._1._1);
                                    if (e._1._1._1._1._1._1.tag === "Inr") {
                                        if (e._1._1._1._1._1._1._1.tag === "Inl") return Ih;
                                        if (e._1._1._1._1._1._1._1.tag === "Inr") {
                                            if (e._1._1._1._1._1._1._1._1.tag === "Inl") return Et;
                                            if (e._1._1._1._1._1._1._1._1.tag === "Inr") return vi;
                                            l();
                                        }
                                        l();
                                    }
                                    l();
                                }
                                l();
                            }
                            l();
                        }
                        l();
                    }
                    l();
                }
                l();
            }
            l();
        },
        from: (e)=>{
            if (e.tag === "CalendarRoute") return o("Inl", P);
            if (e.tag === "UserCreateRoute") return o("Inr", o("Inl", P));
            if (e.tag === "UserEditRoute") return o("Inr", o("Inr", o("Inl", P)));
            if (e.tag === "UserImportRoute") return o("Inr", o("Inr", o("Inr", o("Inl", P))));
            if (e.tag === "UsersRoute") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))));
            if (e.tag === "NotFoundRoute") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))));
            if (e.tag === "ResetPasswordRoute") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", e._1)))))));
            if (e.tag === "ForgotPasswordRoute") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P))))))));
            if (e.tag === "LoginRoute") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inl", P)))))))));
            if (e.tag === "LogoutRoute") return o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", o("Inr", P)))))))));
            l();
        }
    };
    var $s = Zk(rS(IO)(Tn(Wt(fO)()(En))(Tn(Wt(mO)()(En))(Tn(Wt($O)()(En))(Tn(Wt(hO)()(En))(Tn(Wt(yO)()(En))(Tn(Wt(DO)()(En))(Tn(Wt(wO)()(tS))(Tn(Wt(RO)()(En))(Tn(Wt(kO)()(En))(Wt(SO)()(En)))))))))))({
        CalendarRoute: xn,
        UserCreateRoute: qt("user/create")(xn),
        UserEditRoute: qt("user/edit")(xn),
        UserImportRoute: qt("user/import")(xn),
        UsersRoute: qt("users")(xn),
        NotFoundRoute: qt("404")(xn),
        ResetPasswordRoute: qt("reset-password")(xt(wh, Dh)),
        ForgotPasswordRoute: qt("forgot-password")(xn),
        LoginRoute: qt("login")(xn),
        LogoutRoute: qt("logout")(xn)
    }));
    function Ac(e, _, r) {
        return e == null ? _ : r(e);
    }
    function Og(e) {
        return function() {
            return e.preventDefault();
        };
    }
    function xh(e) {
        return function(_) {
            return function() {
                return _.go(e);
            };
        };
    }
    function sS(e) {
        return function(_) {
            return function(r) {
                return function(t) {
                    return function() {
                        return t.pushState(e, _, r);
                    };
                };
            };
        };
    }
    function Ug(e) {
        return function() {
            return e.pathname;
        };
    }
    var TO = (()=>Vp(la).liftAff)();
    var Jd = Jb(ou);
    var et = (()=>{
        let e = Jb(ou);
        return {
            ask: ru.pure,
            Monad0: ()=>e
        };
    })(), Vd = {
        map: (e)=>(_)=>(r)=>sn.apply(Io(so(S("Right", e))))(_(r))
    }, v_ = Hi(Qo);
    var ae = (()=>{
        let e = {
            map: (r)=>(t)=>(n)=>sn.apply(Io(so(S("Right", r))))(t(n))
        }, _ = {
            apply: (r)=>(t)=>(n)=>sn.apply(r(n))(t(n)),
            Functor0: ()=>e
        };
        return {
            pure: (r)=>{
                let t = Io(so(S("Right", r)));
                return (n)=>t;
            },
            Apply0: ()=>_
        };
    })(), aS = Wi(()=>({
            noop: (e)=>ae.pure(D),
            noop_: ae.pure(D),
            emit: (e)=>(_)=>ae.pure(R("Just", e(_))),
            emit_: (e)=>ae.pure(R("Just", e)),
            when_: (e)=>(_)=>e ? _ : aS().noop_
        })), ue = aS(), Th = (e)=>(_)=>(r)=>Os((t)=>{
                    if (t.tag === "Left") return _(t._1);
                    if (t.tag === "Right") return t._1;
                    l();
                })(r(e)._1);
    var ar = (()=>({
            getFirebaseServices: Vd.map((e)=>e.firebaseServices)(et.ask),
            unsubscribe: (e)=>{
                let _ = nn.bimap((r)=>({
                        type: "uncaughtError",
                        value: r
                    }))(re)(Uk(fh(e)));
                return (r)=>_;
            },
            Monad0: ()=>Jd
        }))(), GO = {
        liftEffect: (e)=>J_.liftAff(he(e)),
        Monad0: ()=>Jd
    }, J_ = {
        liftAff: (e)=>{
            let _ = nn.bimap((r)=>({
                    type: "uncaughtError",
                    value: r
                }))(re)(TO(e));
            return (r)=>_;
        },
        MonadEffect0: ()=>GO
    }, Eh = (e)=>v_.bind(Vd.map((_)=>_.history)(et.ask))((_)=>J_.liftAff(he(e(_)))), Cn = {
        back: (e)=>Eh(xh(-e)),
        forward: (e)=>Eh(xh(e)),
        goto: (e)=>v_.bind(Eh(sS("")("")(zd($s._1(e)(di)))))(()=>ae.pure(e)),
        Monad0: ()=>Jd
    }, Pr = (()=>({
            subscribeTimer: J_.liftAff(he(bh(1e3)("OnTimer"))),
            unsubscribeTimer: (e)=>J_.liftAff(he(ai(e))),
            subscribeCalendar: v_.bind(et.ask)((e)=>{
                let _ = e.workYear;
                return v_.bind(ar.getFirebaseServices)((r)=>J_.liftAff(he(Vl(r.db)("OnWeeks")("/workYears")(__(_)))));
            }),
            subscribeRemarks: v_.bind(et.ask)((e)=>{
                let _ = e.workYear;
                return v_.bind(ar.getFirebaseServices)((r)=>J_.liftAff(he(_s(r.db)("OnRemarks")("/workYears/" + __(_) + "/remarks"))));
            }),
            subscribeSlots: v_.bind(et.ask)((e)=>{
                let _ = e.workYear;
                return v_.bind(ar.getFirebaseServices)((r)=>J_.liftAff(he(_s(r.db)("OnSlots")("/workYears/" + __(_) + "/slots"))));
            }),
            setBookingPhase: (e)=>v_.bind(et.ask)((_)=>{
                    let r = _.workYear;
                    return v_.bind(ar.getFirebaseServices)((t)=>J_.liftAff(VD(t.db)("/workYears")(__(r))({
                            bookingPhase: e
                        })._1));
                }),
            setRemark: (e)=>(_)=>v_.bind(et.ask)((r)=>{
                        let t = r.workYear;
                        return v_.bind(ar.getFirebaseServices)((n)=>J_.liftAff(N3(n.db)(t)(e)(_)._1));
                    }),
            generateSlotID: v_.bind(et.ask)((e)=>{
                let _ = e.workYear;
                return v_.bind(ar.getFirebaseServices)((r)=>J_.liftAff(Tm(r.db)("/workYears/" + __(_) + "/slots")._1));
            }),
            setSlot: (e)=>(_)=>v_.bind(et.ask)((r)=>{
                        let t = r.workYear;
                        return v_.bind(ar.getFirebaseServices)((n)=>J_.liftAff(n8(n.db)(t)(e)(_)._1));
                    }),
            bookSlot: (e)=>(_)=>(r)=>(t)=>v_.bind(et.ask)((n)=>J_.liftAff(i8(n.workYear)(e)(_)(r)(t)._1)),
            cancelSlot: (e)=>v_.bind(et.ask)((_)=>J_.liftAff(a8(_.workYear)(e)._1)),
            deleteRemark: (e)=>v_.bind(et.ask)((_)=>{
                    let r = _.workYear;
                    return v_.bind(ar.getFirebaseServices)((t)=>J_.liftAff(F3(t.db)(r)(e)._1));
                }),
            deleteSlot: (e)=>v_.bind(et.ask)((_)=>{
                    let r = _.workYear;
                    return v_.bind(ar.getFirebaseServices)((t)=>J_.liftAff(Jl(t.db)("/workYears/" + __(r) + "/slots")(e)._1));
                })
        }))();
    var u0 = (()=>({
            subscribeAuthStateChanged: v_.bind(ar.getFirebaseServices)((e)=>J_.liftAff(he(j$(e.auth)))),
            subscribeAllUsersChanged: v_.bind(ar.getFirebaseServices)((e)=>J_.liftAff(he(_s(e.db)("OnAllUsers")("/users")))),
            subscribeUser: (e)=>v_.bind(ar.getFirebaseServices)((_)=>J_.liftAff(he(Vl(_.db)("OnUser")("/users")(e.username)))),
            loadUser: (e)=>v_.bind(ar.getFirebaseServices)((_)=>J_.liftAff(nn.bimap((r)=>({
                            type: "dbError",
                            value: r
                        }))(re)(Nk(_.db)(e))._1)),
            createUser: (e)=>J_.liftAff(ci(e)._1),
            editUser: (e)=>J_.liftAff(Gg(e)._1),
            deleteUser: (e)=>J_.liftAff(Cg(e)._1),
            forgotPassword: (e)=>J_.liftAff(Eg(vd(e))._1),
            resetPassword: (e)=>(_)=>J_.liftAff(xg(ud(e)(_))._1),
            loginUser: (e)=>(_)=>v_.bind(ar.getFirebaseServices)((r)=>v_.bind(J_.liftAff(Fk(r.db)(r.auth)(e)(_)._1))((t)=>ae.pure((()=>{
                                if (t.tag === "Left") return D;
                                if (t.tag === "Right") return R("Just", t._1);
                                l();
                            })()))),
            signOutUser: v_.bind(ar.getFirebaseServices)((e)=>{
                let _ = nn.bimap((r)=>({
                        type: "authError",
                        value: r
                    }))(re)(ri(H$(e.auth)));
                return (r)=>_;
            }),
            Monad0: ()=>Jd
        }))(), Bg = (()=>({
            currentUrl: v_.bind(Vd.map((e)=>e.location)(et.ask))((e)=>J_.liftAff(he(Ug(e)))),
            preventDefault: (e)=>J_.liftAff(he(Og(e))),
            downloadCSVFile: (e)=>J_.liftAff(he(Md(e.filename)(e.content))),
            downloadCalendarFile: (e)=>J_.liftAff(fr(he(vh(e)))(el(ol))),
            importUserFile: (e)=>J_.liftAff(Fg(Pd(e))._1),
            Monad0: ()=>Jd
        }))();
    var CO = (e)=>({
            tag: e
        }), AO = CO("Production");
    var Jg = {
        nodeEnv: AO,
        useFirebaseEmulator: !1,
        firebaseConfig: {
            apiKey: "AIzaSyDmchQIfcuzixejoomPaLsd1h7K_HcN1L0",
            authDomain: "oalc-booking-production.firebaseapp.com",
            projectId: "oalc-booking-production",
            storageBucket: "oalc-booking-production.appspot.com",
            messagingSenderId: "1075259712551",
            appId: "1:1075259712551:web:032bedb6d5570f25039a02"
        },
        workYear: 2025
    };
    var Nc = function(_) {
        return function(r) {
            return function() {
                return _(r);
            };
        };
    }, ui = function(_) {
        return function(r) {
            return function(t) {
                return function() {
                    return _(r, t);
                };
            };
        };
    };
    var Gh = function(_) {
        return function(r) {
            return function(t) {
                return function(n) {
                    return function(s) {
                        return function() {
                            return _(r, t, n, s);
                        };
                    };
                };
            };
        };
    };
    function Vg(e) {
        return document.querySelector(e);
    }
    function iS(e, _) {
        window.addEventListener(e, function(r) {
            _(r)();
        });
    }
    function lS(e, _) {
        document.addEventListener(e, function(r) {
            _(r)();
        });
    }
    function dS(e, _) {
        document.addEventListener(e, function(r) {
            _(r.detail)();
        });
    }
    var vS = ui(iS), uS = ui(lS), Ch = ui(dS);
    var MO = 2, PO = 3, LO = 4;
    function jt(e) {
        return function(_) {
            return [
                PO,
                e,
                _
            ];
        };
    }
    function Te(e) {
        return function(_) {
            return [
                LO,
                e,
                _
            ];
        };
    }
    function gS(e) {
        return [
            MO,
            e
        ];
    }
    var Wg = {
        to: (()=>{
            let e = mp((r)=>r !== ""), _ = Pt(" ");
            return (r)=>e(_(r));
        })()
    };
    var bS = Te("width");
    var Do = jt("value");
    var g0 = jt("type");
    var pS = jt("target");
    var fS = jt("src");
    var Ah = jt("name");
    var Fc = jt("id");
    var Hg = Te("href"), mS = Te("height");
    var Wd = Te("for");
    var OO = (e)=>{
        if (e === Cp(e)) return P0(e);
        let _ = L0(e), r = (()=>{
            if (_.tag === "Just") return _._1;
            l();
        })();
        return P0(ll(r.head)) + d3((()=>{
            let t = Ha("[A-Z]")(Km);
            if (t.tag === "Right") return t._1;
            if (t.tag === "Left") return Ie(Se(t._1));
            l();
        })())((t)=>{
            let n = "-" + P0(t);
            return (s)=>n;
        })(r.tail);
    }, jg = (e)=>{
        let _ = te(OO);
        return (r)=>gS(_(e.to(r)));
    };
    var b0 = (()=>{
        let e = jt("disabled");
        return (_)=>e(_ ? "true" : "");
    })();
    var hs = (()=>{
        let e = jt("selected");
        return (_)=>e(_ ? "true" : "");
    })();
    var Nh = 1, Kg = 2, BO = 3;
    var JO = 1, VO = 2, qO = 3, WO = 4, HO = 7;
    function N(e) {
        return function(_) {
            return function(r) {
                let t = r, n;
                return r.length === 1 && r[0].nodeType == Nh && (t = void 0, n = r[0].text), {
                    nodeType: Kg,
                    node: void 0,
                    tag: e,
                    nodeData: hS(_),
                    children: t,
                    text: n
                };
            };
        };
    }
    function kr(e) {
        return function(_) {
            let r = _, t;
            return _.length === 1 && _[0].nodeType == Nh && (r = void 0, t = _[0].text), {
                nodeType: Kg,
                node: void 0,
                tag: e,
                nodeData: {},
                children: r,
                text: t
            };
        };
    }
    function Kt(e) {
        return function(_) {
            return {
                nodeType: Kg,
                node: void 0,
                tag: e,
                nodeData: hS(_)
            };
        };
    }
    function $S(e) {
        return {
            nodeType: e.trim().toLowerCase() === "svg" ? BO : Kg,
            node: void 0,
            tag: e,
            nodeData: {}
        };
    }
    function M(e) {
        return {
            nodeType: Nh,
            node: void 0,
            text: e
        };
    }
    function hS(e) {
        let _ = {};
        if (e !== void 0) for (let r of e){
            let t = r[1];
            switch(r[0]){
                case JO:
                    _.styles === void 0 && (_.styles = {});
                    for(let n in t)_.styles[n] = t[n];
                    break;
                case VO:
                    _.classes === void 0 && (_.classes = []), _.classes = _.classes.concat(t);
                    break;
                case qO:
                    _.properties === void 0 && (_.properties = {}), _.properties[t] = r[2];
                    break;
                case WO:
                    _.attributes === void 0 && (_.attributes = {}), _.attributes[t] = r[2];
                    break;
                case HO:
                    _.key = t;
                    break;
                default:
                    _.events === void 0 && (_.events = {}), _.events[t] === void 0 && (_.events[t] = []), _.events[t].push(r[2]);
            }
        }
        return _;
    }
    var Ue = $S("br");
    var jO = /[&<>"']/g, W0_ = RegExp(jO.source);
    function Fh(e) {
        return function(_) {
            return e === _;
        };
    }
    var XO = "http://www.w3.org/2000/svg", Lh = "__flame_", zh = "updater", Hd = 1, ZO = 2, DS = 3, p0 = 4, jd = 5, gi = 6, wS = [
        "focus",
        "blur",
        "scroll",
        "load",
        "unload"
    ];
    function RS(e, _, r, t) {
        return new ro(e, _, r, t, !1);
    }
    function kS(e, _, r, t) {
        return new ro(e, _, r, t, !0);
    }
    function SS(e, _) {
        e.resume(_);
    }
    function ro(e, _, r, t, n) {
        this.eventWrapper = e, this.applicationEvents = new Map, this.root = _, this.updater = r, this.cachedHtml = t.node === void 0 ? t : bi(t), n ? this.hydrate(this.root, this.cachedHtml) : this.createAllNodes(this.root, this.cachedHtml);
    }
    ro.prototype.hydrate = function(e, _, r) {
        switch(_.nodeType){
            case jd:
                _.node = e, _.rendered = _.render(_.arg), _.render = void 0, this.hydrate(e, _.rendered);
                break;
            case Hd:
                _.node = e;
                break;
            case gi:
                this.createAllNodes(e, _, r);
                break;
            default:
                _.nodeType === p0 ? _.node = document.createDocumentFragment() : (_.node = e, _.nodeData.events !== void 0 && this.createAllEvents(e, _));
                let t;
                if (_.text === void 0 && _.children !== void 0 && (t = _.children.length) > 0) {
                    let n = e.childNodes;
                    for(let s = 0, c = 0; s < t; ++s, ++c){
                        let i = _.children[s] = _.children[s].node === void 0 ? _.children[s] : bi(_.children[s]);
                        if (n[c] === void 0) this.createAllNodes(e, i);
                        else if (i.nodeType === p0) {
                            let d = i.children.length;
                            i.node = document.createDocumentFragment();
                            for(let v = 0; v < d; ++v){
                                let b = i.children[v] = i.children[v].node === void 0 ? i.children[v] : bi(i.children[v]);
                                this.hydrate(n[c++], b);
                            }
                            c--;
                        } else i.nodeType === gi ? this.hydrate(e, i, n[c]) : this.hydrate(n[c], i);
                    }
                }
        }
    };
    function bi(e) {
        switch(e.nodeType){
            case Hd:
                return {
                    nodeType: Hd,
                    node: void 0,
                    text: e.text
                };
            case p0:
                return {
                    nodeType: p0,
                    node: void 0,
                    children: e.children
                };
            case jd:
                return {
                    nodeType: jd,
                    node: void 0,
                    nodeData: e.nodeData,
                    render: e.render,
                    arg: e.arg,
                    rendered: void 0,
                    messageMapper: e.messageMapper
                };
            case gi:
                return {
                    nodeType: gi,
                    node: void 0,
                    nodeData: e.nodeData,
                    createNode: e.createNode,
                    updateNode: e.updateNode,
                    arg: e.arg,
                    messageMapper: e.messageMapper
                };
            default:
                return {
                    nodeType: e.nodeType,
                    node: void 0,
                    tag: e.tag,
                    nodeData: e.nodeData,
                    children: e.children,
                    text: e.text,
                    messageMapper: e.messageMapper
                };
        }
    }
    ro.prototype.createAllNodes = function(e, _, r) {
        let t = this.createNode(_);
        _.text !== void 0 ? t.textContent = _.text : _.children !== void 0 ? this.createChildrenNodes(t, _.children) : _.rendered !== void 0 && (_.messageMapper !== void 0 && Oh(_.messageMapper, _.rendered), _.rendered.text !== void 0 ? t.textContent = _.rendered.text : _.rendered.children !== void 0 && this.createChildrenNodes(t, _.rendered.children)), e.insertBefore(t, r);
    };
    ro.prototype.checkCreateAllNodes = function(e, _, r) {
        return _.node !== void 0 && (_ = bi(_)), this.createAllNodes(e, _, r), _;
    };
    ro.prototype.createChildrenNodes = function(e, _) {
        let r = _.length;
        for(let t = 0; t < r; ++t){
            let n = _[t] = _[t].node === void 0 ? _[t] : bi(_[t]);
            this.checkCreateAllNodes(e, n, null);
        }
    };
    ro.prototype.createNode = function(e) {
        switch(e.nodeType){
            case jd:
                return e.rendered = e.render(e.arg), e.render = void 0, e.node = this.createNode(e.rendered);
            case Hd:
                return e.node = document.createTextNode(e.text);
            case ZO:
                return e.node = this.createElement(e);
            case DS:
                return e.node = this.createSvg(e);
            case p0:
                return e.node = document.createDocumentFragment();
            case gi:
                return e.node = this.createManagedNode(e);
        }
    };
    ro.prototype.createElement = function(e) {
        let _ = document.createElement(e.tag);
        return this.createNodeData(_, e, !1), _;
    };
    ro.prototype.createSvg = function(e) {
        let _ = document.createElementNS(XO, e.tag);
        return this.createNodeData(_, e, !0), _;
    };
    ro.prototype.createManagedNode = function(e) {
        let _ = e.createNode(e.arg)();
        return e.createNode = void 0, this.createNodeData(_, e, _ instanceof SVGElement || _.nodeName.toLowerCase() === "svg"), _;
    };
    ro.prototype.createNodeData = function(e, _, r) {
        if (_.nodeData.styles !== void 0 && IS(e, _.nodeData.styles), _.nodeData.classes !== void 0 && _.nodeData.classes.length > 0 && Mh(e, _.nodeData.classes, r), _.nodeData.attributes !== void 0 && xS(e, _.nodeData.attributes), _.nodeData.properties !== void 0) for(let t in _.nodeData.properties)e[t] = _.nodeData.properties[t];
        _.nodeData.events !== void 0 && this.createAllEvents(e, _);
    };
    function IS(e, _) {
        for(let r in _)e.style.setProperty(r, _[r]);
    }
    function Mh(e, _, r) {
        let t = _.join(" ");
        r ? e.setAttribute("class", t) : e.className = t;
    }
    function xS(e, _) {
        for(let r in _)e.setAttribute(r, _[r]);
    }
    ro.prototype.createAllEvents = function(e, _) {
        for(let r in _.nodeData.events)this.createEvent(e, r, _);
    };
    ro.prototype.createEvent = function(e, _, r) {
        let t = r.nodeData.events[_], n = Lh + _;
        if (wS.includes(_)) {
            let s = this.runNonBubblingEvent(t, r.messageMapper);
            e[n] = s, e.addEventListener(_, s, !1);
        } else {
            e[n] = t, r.messageMapper !== void 0 && (e[n + zh] = r.messageMapper);
            let s = this.applicationEvents.get(_);
            if (s === void 0) {
                let c = this.runEvent.bind(this);
                this.root.addEventListener(_, c, !1), this.applicationEvents.set(_, {
                    count: 1,
                    handler: c
                });
            } else s.count++;
        }
    };
    ro.prototype.runNonBubblingEvent = function(e, _) {
        return (function(r) {
            this.runHandlers(e, _, r);
        }).bind(this);
    };
    ro.prototype.runEvent = function(e) {
        let _ = e.target, r = Lh + e.type;
        for(; _ !== this.root;){
            let t = _[r];
            if (t !== void 0) {
                this.runHandlers(t, _[r + zh], e);
                return;
            }
            _ = _.parentNode;
        }
    };
    ro.prototype.runHandlers = function(e, _, r) {
        let t = e.length;
        for(let n = 0; n < t; ++n){
            let s = e[n], c = typeof s == "function" ? s(r)() : this.eventWrapper(s);
            this.updater(_ === void 0 ? c : _(c))();
        }
        r.stopPropagation();
    };
    ro.prototype.resume = function(e) {
        this.cachedHtml = this.updateAllNodes(this.root, this.cachedHtml, e);
    };
    ro.prototype.updateAllNodes = function(e, _, r) {
        if (r.node !== void 0 && (r = bi(r)), _.tag !== r.tag || _.nodeType !== r.nodeType) _.nodeType === p0 ? (this.createAllNodes(e, r, ES(_.children)), TS(e, _.children)) : (this.createAllNodes(e, r, _.node), e.removeChild(_.node));
        else switch(r.node = _.node, r.nodeType){
            case jd:
                r.arg !== _.arg ? (r.rendered = r.render(r.arg), r.messageMapper !== void 0 && Oh(r.messageMapper, r.rendered), this.updateAllNodes(e, _.rendered, r.rendered)) : r.rendered = _.rendered, r.render = void 0;
                break;
            case gi:
                let t = r.updateNode(_.node)(_.arg)(r.arg)(), n = t instanceof SVGElement || t.nodeName.toLowerCase() === "svg";
                t !== _.node || t.nodeType !== _.node.nodeType || t.nodeName !== _.node.nodeName ? (this.createNodeData(t, r, n), e.insertBefore(t, _.node), e.removeChild(_.node)) : this.updateNodeData(t, _.nodeData, r, n), r.node = t;
                break;
            case Hd:
                r.text !== _.text && (r.node.textContent = r.text);
                break;
            case p0:
                this.updateChildrenNodes(e, _, r);
                break;
            default:
                this.updateNodeData(_.node, _.nodeData, r, r.nodeType == DS), (r.text !== void 0 || r.children === void 0 && _.text != null) && !Ph(r.nodeData) && r.text != _.node.textContent ? _.node.textContent = r.text : this.updateChildrenNodes(_.node, _, r);
        }
        return r;
    };
    function ES(e) {
        let _ = e.length;
        for(let r = 0; r < _; ++r)return e[r].nodeType === p0 ? ES(e[r].children) : e[r].node;
    }
    function TS(e, _) {
        let r = _.length;
        for(let t = 0; t < r; ++t)_[t].nodeType === p0 ? TS(_[t].children) : e.removeChild(_[t].node);
    }
    function yS(e) {
        e.textContent = "";
    }
    ro.prototype.updateChildrenNodes = function(e, _, r) {
        let t = _.children, n = r.children;
        if (t === void 0 || t.length === 0) {
            let s;
            if (n !== void 0 && (s = n.length) > 0) {
                (_.text !== void 0 || Ph(_.nodeData)) && yS(e);
                for(let c = 0; c < s; ++c)n[c] = this.checkCreateAllNodes(e, n[c]);
            }
        } else n === void 0 || n.length === 0 ? t !== void 0 && (t.length > 0 || _.text !== void 0) && !Ph(r.nodeData) && yS(e) : t[0].nodeData !== void 0 && t[0].nodeData.key !== void 0 && n[0].nodeData !== void 0 && n[0].nodeData.key !== void 0 ? this.updateKeyedChildrenNodes(e, t, n) : this.updateNonKeyedChildrenNodes(e, t, n);
    };
    function Ph(e) {
        return e !== void 0 && e.properties !== void 0 && e.properties.innerHTML !== void 0;
    }
    ro.prototype.updateKeyedChildrenNodes = function(e, _, r) {
        let t = 0, n = 0, s = _.length - 1, c = r.length - 1, i, d = _[t].node, v = d, b = _[s].node, p = !0;
        _: for(; p;){
            p = !1;
            let u = _[t], m = r[n];
            for(; u.nodeData.key === m.nodeData.key;){
                if (m = this.updateAllNodes(e, u, m), v = d = u.node.nextSibling, t++, n++, s < t || c < n) break _;
                u = _[t], m = r[n];
            }
            for(u = _[s], m = r[c]; u.nodeData.key === m.nodeData.key;){
                if (m = this.updateAllNodes(e, u, m), i = b, b = b.previousSibling, s--, c--, s < t || c < n) break _;
                u = _[s], m = r[c];
            }
            for(u = _[s], m = r[n]; u.nodeData.key === m.nodeData.key;){
                if (p = !0, m = this.updateAllNodes(e, u, m), b = u.node.previousSibling, e.insertBefore(u.node, v), n++, s--, s < t || c < n) break _;
                u = _[s], m = r[n];
            }
            for(u = _[t], m = r[c]; u.nodeData.key === m.nodeData.key;){
                if (p = !0, m = this.updateAllNodes(e, u, m), e.insertBefore(u.node, i), i = u.node, t++, c--, s < t || c < n) break _;
                u = _[t], m = r[c];
            }
        }
        if (c < n) for(; t <= s;)e.removeChild(_[s].node), s--;
        else if (s < t) for(; n <= c;)r[n] = this.checkCreateAllNodes(e, r[n], i), n++;
        else {
            let u = new Int32Array(c + 1 - n), m = new Map;
            for(let J = n; J <= c; J++)u[J] = -1, m.set(r[J].nodeData.key, J);
            let z = n + r.length - 1 - c, L = [];
            for(let J = t; J <= s; J++)m.has(_[J].nodeData.key) ? (u[m.get(_[J].nodeData.key)] = J, z++) : L.push(J);
            if (z === 0) {
                e.textContent = "";
                for(let J = n; J <= c; J++)r[J] = this.checkCreateAllNodes(e, r[J]);
            } else {
                let J = L.length;
                for(let W = 0; W < J; W++)e.removeChild(_[L[W]].node);
                let c_ = _U(u, n), t_ = c_.length - 1;
                for(let W = c; W >= n; W--)c_[t_] === W ? (currentHtml = _[u[c_[t_]]], r[W] = this.updateAllNodes(e, currentHtml, r[W]), i = currentHtml.node, t_--) : u[W] === -1 ? (r[W] = this.checkCreateAllNodes(e, r[W], i), i = r[W].node) : (currentHtml = _[u[W]], r[W] = this.updateAllNodes(e, currentHtml, r[W]), e.insertBefore(currentHtml.node, i), i = currentHtml.node);
            }
        }
    };
    function _U(e, _) {
        let r = [], t = [], n = -1, s, c, i = new Int32Array(e.length);
        for(s = _, c = e.length; s < c; s++){
            let d = e[s];
            if (d < 0) continue;
            let v = eU(r, d);
            v !== -1 && (i[s] = t[v]), v === n ? (n++, r[n] = d, t[n] = s) : d < r[v + 1] && (r[v + 1] = d, t[v + 1] = s);
        }
        for(s = t[n]; n >= 0; s = i[s], n--)r[n] = s;
        return r;
    }
    function eU(e, _) {
        let r = -1, t = e.length;
        if (t > 0 && e[t - 1] <= _) return t - 1;
        for(; t - r > 1;){
            let n = Math.floor((r + t) / 2);
            e[n] > _ ? t = n : r = n;
        }
        return r;
    }
    ro.prototype.updateNonKeyedChildrenNodes = function(e, _, r) {
        let t = _.length, n = r.length, s = Math.min(t, n);
        for(let c = 0; c < s; ++c)r[c] = this.updateAllNodes(e, _[c], r[c]);
        if (t < n) for(let c = s; c < n; ++c)r[c] = this.checkCreateAllNodes(e, r[c]);
        else if (t > n) for(let c = s; c < t; ++c)e.removeChild(_[c].node);
    };
    ro.prototype.updateNodeData = function(e, _, r, t) {
        oU(e, _.styles, r.nodeData.styles), tU(e, _.attributes, r.nodeData.attributes), rU(e, _.classes, r.nodeData.classes, t), nU(e, _.properties, r.nodeData.properties), this.updateEvents(e, _.events, r);
    };
    function oU(e, _, r) {
        if (_ === void 0) r !== void 0 && IS(e, r);
        else if (r === void 0) _ !== void 0 && e.removeAttribute("style");
        else {
            let t = 0;
            for(let c in _){
                let i = _[c], d = r[c], v = r[c] !== void 0;
                v && t++, i !== d && (v ? e.style.setProperty(c, d) : e.style.removeProperty(c));
            }
            let n = Object.keys(r), s = n.length;
            for(let c = 0; t < s && c < s; ++c){
                let i = n[c];
                if (_[i] === void 0) {
                    let d = r[i];
                    ++t, e.style.setProperty(i, d);
                }
            }
        }
    }
    function rU(e, _, r, t) {
        let n = r !== void 0 && r.length > 0;
        _ !== void 0 && _.length > 0 && !n ? Mh(e, [], t) : n && Mh(e, r, t);
    }
    function tU(e, _, r) {
        if (_ === void 0) r !== void 0 && xS(e, r);
        else if (r === void 0) {
            if (_ !== void 0) for(let t in _)e.removeAttribute(t);
        } else {
            let t = 0;
            for(let c in _){
                let i = _[c], d = r[c], v = d !== void 0;
                v && t++, i !== d && (v ? e.setAttribute(c, d) : e.removeAttribute(c));
            }
            let n = Object.keys(r), s = n.length;
            for(let c = 0; t < s && c < s; ++c){
                let i = n[c];
                if (_[i] === void 0) {
                    let d = r[i];
                    ++t, e.setAttribute(i, d);
                }
            }
        }
    }
    function nU(e, _, r) {
        let t = _ === void 0, n = r === void 0;
        if (t) {
            if (!n) for(let s in r)e[s] = r[s];
        } else if (n) {
            if (!t) for(let s in _)e.removeAttribute(s);
        } else {
            let s = 0;
            for(let d in _){
                let v = _[d], b = r[d], p = b !== void 0;
                p && s++, v !== b && (p ? e[d] = b : e.removeAttribute(d));
            }
            let c = Object.keys(r), i = c.length;
            for(let d = 0; s < i && d < i; ++d){
                let v = c[d];
                if (_[v] === void 0) {
                    let b = r[v];
                    ++s, e[v] = b;
                }
            }
        }
    }
    ro.prototype.updateEvents = function(e, _, r) {
        let t = r.nodeData.events;
        if (_ === void 0) t !== void 0 && this.createAllEvents(e, r);
        else if (t === void 0) {
            if (_ !== void 0) for(let n in _)this.removeEvent(e, n);
        } else {
            let n = 0;
            for(let i in _){
                let d = _[i], v = t[i], b = !1;
                if (v === void 0) this.removeEvent(e, i);
                else {
                    let p = d.length, u = v.length;
                    if (p != u) b = !0;
                    else for(let m = 0; m < p; ++m)if (d[m] != v[m]) {
                        b = !0;
                        break;
                    }
                }
                b && (n++, this.removeEvent(e, i), this.createEvent(e, i, r));
            }
            let s = Object.keys(t), c = s.length;
            for(let i = 0; n < c && i < c; ++i){
                let d = s[i];
                _[d] === void 0 && (++n, this.createEvent(e, d, r));
            }
        }
    };
    ro.prototype.removeEvent = function(e, _) {
        let r = Lh + _;
        if (wS.includes(_)) {
            let t = e[r];
            e.removeEventListener(_, t, !1);
        } else --this.applicationEvents.get(_).count === 0 && (this.root.removeEventListener(_, this.applicationEvents.get(_).handler, !1), this.applicationEvents.delete(_));
        e[r + zh] = void 0, e[r] = void 0;
    };
    function Oh(e, _) {
        if (_.messageMapper = e, _.children !== void 0 && _.children.length > 0) for(let r = 0; r < _.children.length; ++r)Oh(e, _.children[r]);
    }
    var GS = ui(SS), CS = (e)=>(_)=>Gh(RS)(f_)(e)((r)=>r.tag === "Just" ? _(r._1) : ()=>{}), AS = (e)=>(_)=>Gh(kS)(f_)(e)((r)=>r.tag === "Just" ? _(r._1) : ()=>{});
    var NS = new Set;
    function FS(e) {
        if (NS.has(e)) throw `Error mounting application: id ${e} already registered!`;
        NS.add(e);
    }
    var MS = (e)=>(_)=>{
            if (_._1.tag === "Window") return vS(_._2._1)((r)=>e(_._2._2._1(r)));
            if (_._1.tag === "Document") return uS(_._2._1)((r)=>e(_._2._2._1(r)));
            if (_._1.tag === "Custom") return Ch(_._2._1)((r)=>e(_._2._2._1(r)));
            l();
        }, cU = Nc(FS), PS = (e)=>(_)=>{
            let r = cU(e);
            return ()=>(r(), Ch(e)((t)=>_(t))());
        };
    var iU = Yi(Mv)(eo), lU = Qi(Mv)(eo), dU = (e)=>(_)=>(r)=>(t)=>{
                    let n = t.init._2, s = t.init._1, c = t.subscribe;
                    return ()=>{
                        let i = s, d = 21, v = (u)=>()=>{
                                let m = i, z = t.update(m)(u);
                                return Fh(m)(z._1) || (GS(d)(t.view(z._1))(), i = z._1), b(z._2)();
                            }, b = (u)=>iU(u)(U2((m)=>m.tag === "Left" ? Ag(No(m._1)) : m.tag === "Right" ? m._1.tag === "Just" ? v(m._1._1) : ()=>{} : ()=>{}));
                        return d = _ ? AS(e)(v)(t.view(s))() : CS(e)(v)(t.view(s))(), b(n)(), r.tag === "Nothing" || (r.tag === "Just" ? PS(r._1)(v)() : l()), lU(MS(v))(c)();
                    };
                };
    var LS = (e)=>(_)=>(r)=>(t)=>()=>{
                        let n = Vg(_), s = Ac(n, D, f_);
                        if (s.tag === "Just") return dU(s._1)(!1)(r.tag === "Just" ? R("Just", e.show(r._1)) : D)(t)();
                        if (s.tag === "Nothing") return Ki(T0("Error mounting application"))();
                        l();
                    };
    var Yg = (e)=>({
            tag: e
        }), Qg = Yg("CannotBook"), Uh = Yg("CanBookAfterStartTime"), uU = Yg("CanBookVendorRunOnly"), Bh = Yg("CanBook");
    var Kd = (e)=>(_)=>{
            if (_.tag === "Nothing") return !1;
            if (_.tag === "Just") {
                let r = wn(_._1);
                if (r.tag === "Just") {
                    let t = wn(e);
                    if (t.tag === "Just") return D1.compare(t._1)(r._1).tag !== "GT";
                    if (t.tag === "Nothing") return !1;
                    l();
                }
                if (r.tag === "Nothing") return !1;
                l();
            }
            l();
        };
    var zS = (e)=>(_)=>{
            if (_.bookingPhase.tag === "ClosedPhase") return Qg;
            if (_.bookingPhase.tag === "OpenPhase") return Bh;
            if (_.bookingPhase.tag === "Phase1") return e.camp.tag !== "InSourceCamp" && e.camp.tag === "AwaitUserCamp" && _.bookingStatus.userBookedCount < _.maxSlots && (()=>{
                if (_.bookingPermission.tag === "Only4D") return e.days.length === 4 || _.bookingStatus.available4D3NCamp <= 0;
                if (_.bookingPermission.tag === "Only3D") return e.days.length === 3;
                if (_.bookingPermission.tag === "BookAll") return !0;
                l();
            })() && (()=>_.pax <= 240 || _.pax >= 321 ? !0 : _.pax >= 281 ? e.location.tag === "CCOALC" || e.location.tag === "DFOALC" ? !1 : e.location.tag === "JBOALC" : _.pax >= 241 ? e.location.tag === "CCOALC" || e.location.tag !== "DFOALC" : !0)() ? Kd(_.startBooking)(_.currentTimeStr) ? Bh : Uh : Qg;
            if (_.bookingPhase.tag === "Phase2") return _.bookingStatus.userBookedCount < _.maxSlots && (()=>{
                if (_.bookingPermission.tag === "Only4D") return e.days.length === 4 || _.bookingStatus.available4D3NCamp <= 0;
                if (_.bookingPermission.tag === "Only3D") return e.days.length === 3;
                if (_.bookingPermission.tag === "BookAll") return !0;
                l();
            })() && (()=>_.pax <= 240 || _.pax >= 321 ? !0 : _.pax >= 281 ? e.location.tag === "CCOALC" || e.location.tag === "DFOALC" ? !1 : e.location.tag === "JBOALC" : _.pax >= 241 ? e.location.tag === "CCOALC" || e.location.tag !== "DFOALC" : !0)() ? Kd(_.startBooking)(_.currentTimeStr) ? uU : Uh : Qg;
            if (_.bookingPhase.tag === "Phase3") return _.bookingStatus.userBookedCount < _.maxSlots ? Kd(_.startBooking)(_.currentTimeStr) ? Bh : Uh : Qg;
            l();
        };
    var US = {
        dimap: (e)=>(_)=>(r)=>(t)=>r(e(t))
    }, f0 = {
        first: (e)=>(_)=>e(_._1),
        second: (e)=>(_)=>e(_._2),
        Profunctor0: ()=>US
    };
    var ir = (e)=>{
        let _ = e.mempty;
        return {
            left: (r)=>(t)=>{
                    if (t.tag === "Left") return r(t._1);
                    if (t.tag === "Right") return _;
                    l();
                },
            right: (r)=>(t)=>{
                    if (t.tag === "Left") return _;
                    if (t.tag === "Right") return r(t._1);
                    l();
                },
            Profunctor0: ()=>US
        };
    }, Sr = (e)=>{
        let _ = o7(e), r = ir(e);
        return {
            wander: (t)=>(n)=>t(_)(n),
            Strong0: ()=>f0,
            Choice1: ()=>r
        };
    };
    var An = (()=>({
            left: (e)=>(_)=>{
                    if (_.tag === "Left") return S("Left", e(_._1));
                    if (_.tag === "Right") return S("Right", _._1);
                    l();
                },
            right: x0.map,
            Profunctor0: ()=>P1
        }))();
    var Bo = {
        wander: (e)=>e(Qb),
        Strong0: ()=>O_,
        Choice1: ()=>An
    };
    var Ee = (e)=>Zm(f_)((_)=>{
            if (_.tag === "Nothing") return S("Left", D);
            if (_.tag === "Just") return S("Right", _._1);
            l();
        })(e);
    var BS = (e)=>(_)=>(t)=>(n)=>{
                    let s = t, c = n, i = !0, d;
                    for(; i;){
                        let v = s, b = c;
                        if (v.tag === "Cons") {
                            if (b.tag === "Cons") {
                                if (v._1 === _) {
                                    i = !1, d = b._1;
                                    continue;
                                }
                                s = v._2, c = b._2;
                                continue;
                            }
                            i = !1, d = Ie("Data.Variant: impossible `" + e + "`");
                            continue;
                        }
                        i = !1, d = Ie("Data.Variant: impossible `" + e + "`");
                    }
                    return d;
                };
    var JS = ()=>(e)=>(_)=>({
                    show: (r)=>"(inj @" + Se(r.type) + " " + BS("show")(r.type)(e.variantTags(q))(_.variantShows(q))(r.value) + ")"
                });
    var Zg = (e, _)=>({
            tag: e,
            _1: _
        });
    var _b = Zg("NoSelection");
    var X = (e, _, r)=>({
            tag: e,
            _1: _,
            _2: r
        });
    var VS = X("OnPopstate"), qS = (e)=>(_)=>X("OnClickLink", e, _), Fn = (e)=>X("ChangeRoute", e), Mc = (e)=>X("OnSubscription", e);
    var WS = (e)=>X("OnTimerSubscription", e);
    var eb = X("DoLogout");
    var Jh = (e)=>{
        let _ = e.Strong0(), r = m_({
            reflectSymbol: ()=>"auth"
        })()()(q)(_), t = Ee(e.Choice1()), n = m_({
            reflectSymbol: ()=>"calendar"
        })()()(q)(_);
        return (s)=>r(t(n(s)));
    }, HS = (e)=>{
        let _ = e.Strong0(), r = Ee(e.Choice1()), t = m_({
            reflectSymbol: ()=>"auth"
        })()()(q)(_), n = m_({
            reflectSymbol: ()=>"timer"
        })()()(q)(_);
        return (s)=>t(r(n(r(_.first(s)))));
    }, fi = (e)=>{
        let _ = e.Strong0(), r = Ee(e.Choice1()), t = m_({
            reflectSymbol: ()=>"auth"
        })()()(q)(_), n = m_({
            reflectSymbol: ()=>"timer"
        })()()(q)(_);
        return (s)=>t(r(n(r(_.second(s)))));
    }, jS = (e)=>{
        let _ = e.Strong0(), r = m_({
            reflectSymbol: ()=>"auth"
        })()()(q)(_), t = Ee(e.Choice1()), n = m_({
            reflectSymbol: ()=>"user"
        })()()(q)(_);
        return (s)=>r(t(n(s)));
    }, ob = (e)=>{
        let _ = e.Strong0(), r = m_({
            reflectSymbol: ()=>"auth"
        })()()(q)(_), t = Ee(e.Choice1()), n = m_({
            reflectSymbol: ()=>"userCreate"
        })()()(q)(_);
        return (s)=>r(t(n(s)));
    }, Vh = (e)=>{
        let _ = e.Strong0(), r = m_({
            reflectSymbol: ()=>"auth"
        })()()(q)(_), t = Ee(e.Choice1()), n = m_({
            reflectSymbol: ()=>"userImport"
        })()()(q)(_);
        return (s)=>r(t(n(s)));
    };
    var KS = (e)=>{
        let _ = e.Strong0(), r = m_({
            reflectSymbol: ()=>"auth"
        })()()(q)(_), t = Ee(e.Choice1()), n = m_({
            reflectSymbol: ()=>"allUsers"
        })()()(q)(_);
        return (s)=>r(t(n(s)));
    }, QS = (e)=>{
        let _ = e.Strong0(), r = m_({
            reflectSymbol: ()=>"auth"
        })()()(q)(_), t = Ee(e.Choice1()), n = m_({
            reflectSymbol: ()=>"allUsers"
        })()()(q)(_), s = m_({
            reflectSymbol: ()=>"deleteUser"
        })()()(q)(_);
        return (c)=>r(t(n(s(c))));
    }, YS = (e)=>{
        let _ = e.Strong0(), r = m_({
            reflectSymbol: ()=>"auth"
        })()()(q)(_), t = Ee(e.Choice1()), n = m_({
            reflectSymbol: ()=>"allUsers"
        })()()(q)(_), s = m_({
            reflectSymbol: ()=>"userList"
        })()()(q)(_);
        return (c)=>r(t(n(s(c))));
    };
    var Ds = (e, _)=>({
            tag: e,
            _1: _
        });
    var mU = KS(Bo), $U = m_({
        reflectSymbol: ()=>"errors"
    })()()(q)(O_), Wh = YS(Bo), rb = QS(Bo), ZS = (e)=>(_)=>{
            if (_.tag === "Nil") return y_;
            if (_.tag === "Cons") return e.uid === _._1.uid ? _._2 : Y("Cons", _._1, ZS(e)(_._2));
            l();
        }, _I = (e)=>(_)=>{
            if (_.tag === "Nil") return y_;
            if (_.tag === "Cons") return e.uid === _._1.uid ? Y("Cons", e, _._2) : Y("Cons", _._1, _I(e)(_._2));
            l();
        }, eI = {
        userList: y_,
        errors: y_,
        deleteUser: _b
    }, hU = (e)=>(_)=>Tp(Ck)(e)(_), XS = (e)=>(_)=>(r)=>mU($U(no(e.show(_))))(r), oI = (e)=>(_)=>(r)=>{
                if (_.tag === "OnUserChanged") {
                    if (_._1.tag === "Left") return E(XS(ge)(_._1._1)(e), []);
                    if (_._1.tag === "Right") {
                        if (_._1._1.changeType.tag === "Added") return E(Wh(hU(_._1._1.docData))(e), []);
                        if (_._1._1.changeType.tag === "Modified") return E(Wh(_I(_._1._1.docData))(e), []);
                        if (_._1._1.changeType.tag === "Removed") return E(Wh(ZS(_._1._1.docData))(e), []);
                        l();
                    }
                    l();
                }
                if (_.tag === "OnUserDelete") return E(rb((t)=>Zg("Selected", _._1))(e), []);
                if (_.tag === "OnUserDeleteConfirmed") return E(rb((t)=>Zg("SelectedProcessing", _._1))(e), [
                    v_.bind(J_.liftAff(Cg(_._1)._1))((t)=>ae.pure(R("Just", X("OnAllUsers", Ds("OnUserDeleteCompleted", t)))))
                ]);
                if (_.tag === "OnUserDeleteCompleted") {
                    if (_._1.tag === "Right") return E(rb((t)=>_b)(e), []);
                    if (_._1.tag === "Left") return E(XS(wk)(_._1._1)(rb((t)=>_b)(e)), []);
                    l();
                }
                l();
            };
    var Mn = (e)=>e, Hh = {
        userBookedCount: 0,
        total4D3NCamp: 0,
        available4D3NCamp: 0,
        total3D2NCamp: 0,
        available3D2NCamp: 0,
        total1DCamp: 0,
        available1DCamp: 0
    };
    var DU = m_({
        reflectSymbol: ()=>"userBookedCount"
    })()()(q)(O_);
    var wU = m_({
        reflectSymbol: ()=>"total4D3NCamp"
    })()()(q)(O_);
    var RU = m_({
        reflectSymbol: ()=>"total3D2NCamp"
    })()()(q)(O_);
    var kU = m_({
        reflectSymbol: ()=>"total1DCamp"
    })()()(q)(O_);
    var SU = m_({
        reflectSymbol: ()=>"available4D3NCamp"
    })()()(q)(O_);
    var IU = m_({
        reflectSymbol: ()=>"available3D2NCamp"
    })()()(q)(O_);
    var xU = m_({
        reflectSymbol: ()=>"available1DCamp"
    })()()(q)(O_), rI = (e)=>(_)=>((t)=>(n)=>(s)=>{
                        let c = t, i = n, d = s, v = !0, b;
                        for(; v;){
                            let p = c, u = i, m = d;
                            if (u.tag === "Nil") {
                                v = !1, b = m;
                                continue;
                            }
                            if (u.tag === "Cons") {
                                let z = q1.eq(u._1.booking)(St), L = u._1.days.length;
                                c = p, i = u._2, d = xU(L === 1 && z ? (J)=>1 + J | 0 : Mn)(kU(!q1.eq(u._1.booking)(J1) && !q1.eq(u._1.booking)(V1) && L === 1 ? (J)=>1 + J | 0 : Mn)(IU(L === 3 && z ? (J)=>1 + J | 0 : Mn)(RU(L === 3 ? (J)=>1 + J | 0 : Mn)(SU(L === 4 && z ? (J)=>1 + J | 0 : Mn)(wU(L === 4 ? (J)=>1 + J | 0 : Mn)(DU((()=>{
                                    if (u._1.booking.tag === "HQ" || u._1.booking.tag === "PD" || u._1.booking.tag === "Available") return Mn;
                                    if (u._1.booking.tag === "Booked") return u._1.booking._1.username === p.username ? (J)=>1 + J | 0 : Mn;
                                    l();
                                })())(m)))))));
                                continue;
                            }
                            l();
                        }
                        return b;
                    })(e)(_)(Hh);
    var tI = [
        {
            weekNum: 1,
            title: "T1W0"
        },
        {
            weekNum: 2,
            title: "T1W1"
        },
        {
            weekNum: 3,
            title: "T1W2"
        },
        {
            weekNum: 4,
            title: "T1W3"
        },
        {
            weekNum: 5,
            title: "T1W4"
        },
        {
            weekNum: 6,
            title: "T1W5"
        },
        {
            weekNum: 7,
            title: "T1W6"
        },
        {
            weekNum: 8,
            title: "T1W7"
        },
        {
            weekNum: 9,
            title: "T1W8"
        },
        {
            weekNum: 10,
            title: "T1W9"
        },
        {
            weekNum: 11,
            title: "T1W10"
        },
        {
            weekNum: 12,
            title: "Mar Hol"
        },
        {
            weekNum: 13,
            title: "T2W1"
        },
        {
            weekNum: 14,
            title: "T2W2"
        },
        {
            weekNum: 15,
            title: "T2W3"
        },
        {
            weekNum: 16,
            title: "T2W4"
        },
        {
            weekNum: 17,
            title: "T2W5"
        },
        {
            weekNum: 18,
            title: "T2W6"
        },
        {
            weekNum: 19,
            title: "T2W7"
        },
        {
            weekNum: 20,
            title: "T2W8"
        },
        {
            weekNum: 21,
            title: "T2W9"
        },
        {
            weekNum: 22,
            title: "T2W10"
        },
        {
            weekNum: 23,
            title: "Jun Hols W1"
        },
        {
            weekNum: 24,
            title: "Jun Hols W2"
        },
        {
            weekNum: 25,
            title: "Jun Hols W3"
        },
        {
            weekNum: 26,
            title: "Jun Hols W4"
        },
        {
            weekNum: 27,
            title: "T3W1"
        },
        {
            weekNum: 28,
            title: "T3W2"
        },
        {
            weekNum: 29,
            title: "T3W3"
        },
        {
            weekNum: 30,
            title: "T3W4"
        },
        {
            weekNum: 31,
            title: "T3W5"
        },
        {
            weekNum: 32,
            title: "T3W6"
        },
        {
            weekNum: 33,
            title: "T3W7"
        },
        {
            weekNum: 34,
            title: "T3W8"
        },
        {
            weekNum: 35,
            title: "T3W9"
        },
        {
            weekNum: 36,
            title: "T3W10"
        },
        {
            weekNum: 37,
            title: "Sep Hol"
        },
        {
            weekNum: 38,
            title: "T4W1"
        },
        {
            weekNum: 39,
            title: "T4W2"
        },
        {
            weekNum: 40,
            title: "T4W3"
        },
        {
            weekNum: 41,
            title: "T4W4"
        },
        {
            weekNum: 42,
            title: "T4W5"
        },
        {
            weekNum: 43,
            title: "T4W6"
        },
        {
            weekNum: 44,
            title: "T4W7"
        },
        {
            weekNum: 45,
            title: "T4W8"
        },
        {
            weekNum: 46,
            title: "T4W9"
        },
        {
            weekNum: 47,
            title: "T4W10"
        },
        {
            weekNum: 48,
            title: "Nov/Dec Hol Wk 1"
        },
        {
            weekNum: 49,
            title: "Nov/Dec Hol Wk 2"
        },
        {
            weekNum: 50,
            title: "Nov/Dec Hol Wk 3"
        },
        {
            weekNum: 51,
            title: "Nov/Dec Hol Wk 4"
        },
        {
            weekNum: 52,
            title: "Nov/Dec Hol Wk 5"
        },
        {
            weekNum: 53,
            title: "Nov/Dec Hol Wk 6"
        }
    ];
    var tb = (e)=>{
        let _ = e >= -271820 && e <= 275759 ? R("Just", e) : D;
        if (_.tag === "Just") {
            let r = Yr.toEnum(1);
            if (r.tag === "Just") {
                let t = Ba(_._1)(r._1)(1);
                if (t.tag === "Just") {
                    let n = Ua(t._1);
                    if (n.tag === "Monday") return R("Just", t._1);
                    if (n.tag === "Tuesday") {
                        let s = Xo(Pe(-1))(t._1);
                        return s.tag === "Just" ? R("Just", s._1) : D;
                    }
                    if (n.tag === "Wednesday") {
                        let s = Xo(Pe(-2))(t._1);
                        return s.tag === "Just" ? R("Just", s._1) : D;
                    }
                    if (n.tag === "Thursday") {
                        let s = Xo(Pe(-3))(t._1);
                        return s.tag === "Just" ? R("Just", s._1) : D;
                    }
                    if (n.tag === "Friday") {
                        let s = Xo(Pe(3))(t._1);
                        return s.tag === "Just" ? R("Just", s._1) : D;
                    }
                    if (n.tag === "Saturday") {
                        let s = Xo(Pe(2))(t._1);
                        return s.tag === "Just" ? R("Just", s._1) : D;
                    }
                    if (n.tag === "Sunday") {
                        let s = Xo(Pe(1))(t._1);
                        return s.tag === "Just" ? R("Just", s._1) : D;
                    }
                    l();
                }
                if (t.tag === "Nothing") return D;
                l();
            }
            if (r.tag === "Nothing") return D;
            l();
        }
        if (_.tag === "Nothing") return D;
        l();
    }, TU = (e)=>e <= 0 ? Pe(0) : Pe((e - 1 | 0) * 7 | 0), nb = (e)=>(_)=>{
            let r = TU(e), t = Xo(r)(_);
            if (t.tag === "Just") {
                let n = Xo(r + Pe(1))(_);
                if (n.tag === "Just") {
                    let s = Xo(r + Pe(2))(_);
                    if (s.tag === "Just") {
                        let c = Xo(r + Pe(3))(_);
                        if (c.tag === "Just") {
                            let i = Xo(r + Pe(4))(_);
                            if (i.tag === "Just") {
                                let d = Xo(r + Pe(5))(_);
                                if (d.tag === "Just") {
                                    let v = Xo(r + Pe(6))(_);
                                    if (v.tag === "Just") return R("Just", [
                                        t._1,
                                        n._1,
                                        s._1,
                                        c._1,
                                        i._1,
                                        d._1,
                                        v._1
                                    ]);
                                    if (v.tag === "Nothing") return D;
                                    l();
                                }
                                if (d.tag === "Nothing") return D;
                                l();
                            }
                            if (i.tag === "Nothing") return D;
                            l();
                        }
                        if (c.tag === "Nothing") return D;
                        l();
                    }
                    if (s.tag === "Nothing") return D;
                    l();
                }
                if (n.tag === "Nothing") return D;
                l();
            }
            if (t.tag === "Nothing") return D;
            l();
        };
    var nI = {
        identity: (e)=>e,
        Semigroupoid0: ()=>Vb
    };
    var AU = O3(nI)(O_);
    var sI = (e)=>(_)=>(r)=>(t)=>{
                    let n = AU(e)(_), s = t.Profunctor0().dimap;
                    return (c)=>s(n)((i)=>{
                            if (i._2.tag === "Left") return i._2._1;
                            if (i._2.tag === "Right") return i._1(i._2._1);
                            l();
                        })(r.second(t.right(c)));
                };
    var cI = (e)=>({
            ix: (_)=>(r)=>(t)=>sI((n)=>(s)=>U7(e)((c)=>R("Just", s))(_)(n))((n)=>{
                            let s = vt(e)(_)(n);
                            if (s.tag === "Nothing") return S("Left", n);
                            if (s.tag === "Just") return S("Right", s._1);
                            l();
                        })(r)(t)
        });
    var mi = (e)=>{
        let _ = cI(e);
        return {
            at: (r)=>(t)=>dd(vt(e)(r))((n)=>(s)=>{
                            if (s.tag === "Nothing") return _u(e)(r)(n);
                            if (s.tag === "Just") return N0(e)(r)(s._1)(n);
                            l();
                        })(t),
            Index0: ()=>_
        };
    };
    var $i = (()=>mi(p$).at)(), hi = (()=>mi(Eo).at)(), iI = Tr(no)(y_), lI = sl(p$)(eo)([
        E(bc, be),
        E(pc, be),
        E(fc, be),
        E(mc, be),
        E($c, be),
        E(hc, be)
    ]), dI = (e)=>(_)=>{
            let r = _.Strong0(), t = $i(mc)(r), n = Ee(_.Choice1()), s = hi(e)(r);
            return (c)=>t(n(s(c)));
        }, vI = (e)=>(_)=>{
            let r = _.Strong0(), t = $i(fc)(r), n = Ee(_.Choice1()), s = hi(e)(r);
            return (c)=>t(n(s(c)));
        }, uI = (e)=>(_)=>{
            let r = _.Strong0(), t = $i(pc)(r), n = Ee(_.Choice1()), s = hi(e)(r);
            return (c)=>t(n(s(c)));
        }, gI = (e)=>(_)=>{
            let r = _.Strong0(), t = $i(hc)(r), n = Ee(_.Choice1()), s = hi(e)(r);
            return (c)=>t(n(s(c)));
        }, bI = (e)=>(_)=>{
            let r = _.Strong0(), t = $i(bc)(r), n = Ee(_.Choice1()), s = hi(e)(r);
            return (c)=>t(n(s(c)));
        }, pI = (e)=>(_)=>{
            let r = _.Strong0(), t = $i($c)(r), n = Ee(_.Choice1()), s = hi(e)(r);
            return (c)=>t(n(s(c)));
        }, Qd = (e)=>(_)=>(r)=>{
                if (e.tag === "CCOALC") return bI(_)(r);
                if (e.tag === "CCOALC2") return pI(_)(r);
                if (e.tag === "DFOALC2") return gI(_)(r);
                if (e.tag === "DFOALC") return uI(_)(r);
                if (e.tag === "JBOALC") return vI(_)(r);
                if (e.tag === "LOALC") return dI(_)(r);
                l();
            }, fI = (e)=>(_)=>(r)=>(t)=>(n)=>{
                        let s = e, c = _, i = r, d = t, v = n, b = !0, p;
                        for(; b;){
                            let u = s, m = c, z = i, L = d, J = v;
                            if (u.tag === "Nil") {
                                b = !1, p = J;
                                continue;
                            }
                            if (u.tag === "Cons") {
                                s = u._2, c = m, i = z, d = L, v = (()=>{
                                    let c_ = Em(m), t_ = L.tag === "Just" ? R("Just", c_(De("Resource", L._1))) : D;
                                    return Qd(z)(u._1)(Bo)((W)=>t_)(J);
                                })();
                                continue;
                            }
                            l();
                        }
                        return p;
                    }, mI = (e)=>(_)=>(r)=>(t)=>{
                    let n = Em(e), s = r.tag === "Just" ? R("Just", n(De("Holiday", r._1))) : D, c = It(De("Holiday", _));
                    return dI(c)(Bo)((i)=>s)(vI(c)(Bo)((i)=>s)(gI(c)(Bo)((i)=>s)(uI(c)(Bo)((i)=>s)(pI(c)(Bo)((i)=>s)(bI(c)(Bo)((i)=>s)(t))))));
                }, Yd = (e)=>{
        if (e._2.tag === "Holiday") return mI(e._1)(e._2._1)(R("Just", e._2._1));
        if (e._2.tag === "Resource") return fI(br(pr)(iI(e._2._1.days)))(e._1)(e._2._1.location)(R("Just", e._2._1));
        l();
    }, Xd = (e)=>{
        if (e._2.tag === "Holiday") return mI(e._1)(e._2._1)(D);
        if (e._2.tag === "Resource") return fI(br(pr)(iI(e._2._1.days)))(e._1)(e._2._1.location)(D);
        l();
    };
    var Qh = (e)=>({
            tag: e
        }), zU = Qh("Added"), OU = Qh("Modified"), UU = Qh("Removed");
    var Zd = {
        decodeJson: (e)=>{
            let _ = Q_((r)=>D, (r)=>D, (r)=>D, f_, (r)=>D, (r)=>D, e);
            if (_.tag === "Nothing") return S("Left", H("TypeMismatch", "Invalid ChangeType"));
            if (_.tag === "Just") return _._1 === "added" ? S("Right", zU) : _._1 === "modified" ? S("Right", OU) : _._1 === "removed" ? S("Right", UU) : S("Left", H("TypeMismatch", "Invalid ChangeType: " + _._1));
            l();
        }
    }, Yh = (e)=>{
        if (e.changeType.tag === "Added") return R("Just", e.docData);
        if (e.changeType.tag === "Modified") return R("Just", e.docData);
        if (e.changeType.tag === "Removed") return D;
        l();
    };
    var K_ = (e, _, r)=>({
            tag: e,
            _1: _,
            _2: r
        });
    var Xh = K_("OnBookingPhaseCancel");
    var hI = K_("OnRemarkCancel"), yI = K_("OnRemarkEditSubmit"), DI = (e)=>(_)=>K_("OnRemarkEditSubmitResult", e, _);
    var wI = K_("OnSlotCreateCancel");
    var RI = (e)=>(_)=>K_("OnSlotCreateSubmitResult", e, _);
    var Zh = K_("OnSlotEditBookingAvailable"), _y = K_("OnSlotEditCancel"), ey = K_("OnSlotEditSubmit"), kI = (e)=>(_)=>K_("OnSlotEditSubmitResult", e, _);
    var SI = K_("OnExportCalendar"), oy = K_("OnExportCalendarEnd");
    var II = K_("OnExportBooking"), xI = K_("OnExportBookingEnd");
    var ry = K_("OnUserBookSlotCancel"), EI = K_("OnUserBookSlotSubmit"), TI = (e)=>(_)=>K_("OnUserBookSlotSubmitResult", e, _);
    var GI = K_("OnUserCancelSlotCancel"), CI = K_("OnUserCancelSlotSubmit");
    var BU = (e)=>Hr(",")([
            e._Booking_No,
            e._Booking_Date,
            e._School_Level,
            e._School_Name,
            e._School_Number,
            e._Class_Number,
            e._Camp_IC_Name,
            e._Camp_IC_Email,
            e._Camp_IC_Designation,
            e._Camp_IC_Phone_Number,
            e._Camp_2IC_Name,
            e._Camp_2IC_Email,
            e._Camp_2IC_Designation,
            e._Camp_2IC_Phone_Number,
            e._Pax,
            e._P_Email,
            e._KP_Email,
            e._Camp_Days,
            e._Camp_Type,
            e._Duration,
            e._Start_Date,
            e._End_Date,
            e._OALC,
            e._Changi_Coast_OALC,
            e._Dairy_Farm_OALC,
            e._Labrador_OALC,
            e._Jalan_Bahtera_OALC
        ]), JU = (e)=>(_)=>Eo.compare(It(De("Resource", e._2)))(It(De("Resource", _._2))), VU = (e)=>{
        let _ = (r)=>(t)=>{
                let n = r, s = t, c = !0, i;
                for(; c;){
                    let d = n, v = s;
                    if (v.tag === "Cons") {
                        if (v._1._2.tag === "Holiday") {
                            n = d, s = v._2;
                            continue;
                        }
                        if (v._1._2.tag === "Resource") {
                            n = Y("Cons", E(v._1._1, v._1._2._1), d), s = v._2;
                            continue;
                        }
                        l();
                    }
                    if (v.tag === "Nil") {
                        c = !1, i = d;
                        continue;
                    }
                    l();
                }
                return i;
            };
        return F7(JU)(_(y_)(z7(Ov)(e)));
    }, qU = (e)=>(_)=>{
            let r = z0(6)(e);
            if (_.tag === "ClosedPhase") return "CP-" + r;
            if (_.tag === "Phase1") return "PP-" + r;
            if (_.tag === "Phase2") return "PA-" + r;
            if (_.tag === "Phase3") return "PB-" + r;
            if (_.tag === "OpenPhase") return "OP-" + r;
            l();
        }, WU = (e)=>(_)=>{
            if (_._2.booking.tag === "Booked") {
                let r = Ak(_._2.booking._1.username)(e), t = Qm("/")(It(De("Resource", _._2)));
                return R("Just", {
                    _Booking_No: qU(_._1)(_._2.booking._1.phase),
                    _Booking_Date: "",
                    _School_Level: "",
                    _School_Name: r.tag === "Just" ? r._1.schoolName : "USER_NOT_FOUND",
                    _School_Number: _._2.booking._1.username,
                    _Class_Number: "",
                    _Camp_IC_Name: "",
                    _Camp_IC_Email: "",
                    _Camp_IC_Designation: "",
                    _Camp_IC_Phone_Number: "",
                    _Camp_2IC_Name: "",
                    _Camp_2IC_Email: "",
                    _Camp_2IC_Designation: "",
                    _Camp_2IC_Phone_Number: "",
                    _Pax: r.tag === "Just" ? __(r._1.pax) : "USER_NOT_FOUND",
                    _P_Email: r.tag === "Just" ? r._1.email : "USER_NOT_FOUND",
                    _KP_Email: "",
                    _Camp_Days: __(_._2.days.length),
                    _Camp_Type: (()=>{
                        if (_._2.booking._1.camp.tag === "InSourceCamp") return "MOE OAE-run Camp";
                        if (_._2.booking._1.camp.tag === "VendorRunCamp") return "Vendor-run Camp";
                        if (_._2.booking._1.camp.tag === "SelfRunCamp") return "Self-run Camp";
                        if (_._2.booking._1.camp.tag === "AwaitUserCamp") return "AwaitUserCamp";
                        l();
                    })(),
                    _Duration: _._2.title,
                    _Start_Date: t,
                    _End_Date: Qm("/")(s8(De("Resource", _._2))),
                    _OALC: (()=>{
                        if (_._2.location.tag === "CCOALC") return "Changi Coast OALC";
                        if (_._2.location.tag === "DFOALC") return "Dairy Farm OALC";
                        if (_._2.location.tag === "JBOALC") return "Jalan Bahtera OALC";
                        if (_._2.location.tag === "LOALC") return "Labrador OALC";
                        if (_._2.location.tag === "CCOALC2") return "Changi Coast OALC";
                        if (_._2.location.tag === "DFOALC2") return "Dairy Farm OALC";
                        l();
                    })(),
                    _Changi_Coast_OALC: _._2.location.tag === "CCOALC" ? t : "",
                    _Dairy_Farm_OALC: _._2.location.tag !== "CCOALC" && _._2.location.tag === "DFOALC" ? t : "",
                    _Labrador_OALC: (()=>_._2.location.tag === "CCOALC" || _._2.location.tag === "DFOALC" || _._2.location.tag === "JBOALC" ? !1 : _._2.location.tag === "LOALC")() ? t : "",
                    _Jalan_Bahtera_OALC: (()=>_._2.location.tag === "CCOALC" || _._2.location.tag === "DFOALC" ? !1 : _._2.location.tag === "JBOALC")() ? t : ""
                });
            }
            return D;
        }, HU = (()=>Hr(",")([
            "_Booking_No",
            "_Booking_Date",
            "_School_Level",
            "_School_Name",
            "_School_Number",
            "_Class_Number",
            "_Camp_IC_Name",
            "_Camp_IC_Email",
            "_Camp_IC_Designation",
            "_Camp_IC_Phone_Number",
            "_Camp_2IC_Name",
            "_Camp_2IC_Email",
            "_Camp_2IC_Designation",
            "_Camp_2IC_Phone_Number",
            "_Pax",
            "_P_Email",
            "_KP_Email",
            "_Camp_Days",
            "_Camp_Type",
            "_Duration",
            "_Start_Date",
            "_End_Date",
            "_OALC",
            "_Changi_Coast_OALC",
            "_Dairy_Farm_OALC",
            "_Labrador_OALC",
            "_Jalan_Bahtera_OALC"
        ]) + `
`)(), AI = (e)=>(_)=>E(_, [
                v_.bind(J_.liftAff(he(Md("Booking.csv")((()=>HU + ((t)=>(n)=>{
                            let s = t, c = n, i = !0, d;
                            for(; i;){
                                let v = s, b = c;
                                if (b.tag === "Nil") {
                                    i = !1, d = v;
                                    continue;
                                }
                                if (b.tag === "Cons") {
                                    s = v.init ? {
                                        init: !1,
                                        acc: b._1
                                    } : {
                                        init: !1,
                                        acc: v.acc + `
` + b._1
                                    }, c = b._2;
                                    continue;
                                }
                                l();
                            }
                            return d;
                        })({
                        init: !0,
                        acc: ""
                    })(br(BU)(M7(WU(e.allUsers.userList))(VU(e.calendar.slots)))).acc)()))))((r)=>ae.pure(R("Just", X("OnCalendar", xI))))
            ]);
    var _v = (e, _)=>({
            tag: e,
            _1: _
        }), MI = {
        reflectSymbol: ()=>"value"
    }, NI = (()=>{
        let e = z_(oo)(z_(Ar)($r)(MI)())({
            reflectSymbol: ()=>"_t"
        })();
        return (_)=>e.gEncodeJson(_)(q);
    })(), KU = sl(Eo)(eo), QU = (()=>Hn(Ro.foldr))();
    var YU = {
        encodeJson: (e)=>{
            if (e.tag === "MergeRight") return NI({
                _t: "MergeRight",
                value: e._1
            });
            if (e.tag === "MergeBottom") return NI({
                _t: "MergeBottom",
                value: e._1
            });
            l();
        }
    }, XU = (()=>{
        let e = z_(zp((()=>{
            let _ = z_(Ar)(z_({
                encodeJson: Pp(YU.encodeJson)
            })(z_(Ar)(z_((()=>{
                let r = z_(oo)(z_(oo)(z_(Ar)($r)({
                    reflectSymbol: ()=>"textSize"
                })())({
                    reflectSymbol: ()=>"color"
                })())({
                    reflectSymbol: ()=>"bgColor"
                })();
                return {
                    encodeJson: (t)=>r.gEncodeJson(t)(q)
                };
            })())(z_(oo)($r)(MI)())({
                reflectSymbol: ()=>"style"
            })())({
                reflectSymbol: ()=>"rowIndex"
            })())({
                reflectSymbol: ()=>"merge"
            })())({
                reflectSymbol: ()=>"colIndex"
            })();
            return {
                encodeJson: (r)=>_.gEncodeJson(r)(q)
            };
        })()))(z_(zp(Ar))(z_(Ar)($r)({
            reflectSymbol: ()=>"workYear"
        })())({
            reflectSymbol: ()=>"columnWidths"
        })())({
            reflectSymbol: ()=>"cellData"
        })();
        return (_)=>e.gEncodeJson(_)(q);
    })(), ZU = (e)=>(_)=>{
            if (_.booking.tag === "Booked") {
                let r = _.booking._1.username;
                return Hr(`
`)([
                    _.title,
                    (()=>{
                        if (_.booking._1.camp.tag === "InSourceCamp") return "MOE OAE-run Camp";
                        if (_.booking._1.camp.tag === "VendorRunCamp") return "Vendor-run Camp";
                        if (_.booking._1.camp.tag === "SelfRunCamp") return "Self-run Camp";
                        if (_.booking._1.camp.tag === "AwaitUserCamp") return "AwaitUserCamp";
                        l();
                    })(),
                    (()=>{
                        let t = Uv(Ro)((n)=>n.username === r)(e);
                        return t.tag === "Just" ? t._1.schoolName : "ERROR";
                    })()
                ]);
            }
            return _.title;
        }, _B = (e)=>(_)=>Qv(te((r)=>{
                let t = nb(r.weekNum)(e);
                return t.tag === "Just" ? t._1 : [];
            })(_)), me = {
        month: {
            title: "Month",
            colIndex: 0,
            columnWidth: 8,
            textSize: 12
        },
        week: {
            title: "Week",
            colIndex: 1,
            columnWidth: 6,
            textSize: 12
        },
        termWeek: {
            title: "Term Week",
            colIndex: 2,
            columnWidth: 8,
            textSize: 12
        },
        day: {
            title: "Day",
            colIndex: 3,
            columnWidth: 6,
            textSize: 12
        },
        date: {
            title: "Date",
            colIndex: 4,
            columnWidth: 6,
            textSize: 12
        },
        ccoalc: {
            title: "CCOALC",
            colIndex: 5,
            columnWidth: 20,
            textSize: 16
        },
        ccoalc2: {
            title: "CCOALC2",
            colIndex: 6,
            columnWidth: 20,
            textSize: 16
        },
        dfoalc: {
            title: "DFOALC",
            colIndex: 7,
            columnWidth: 20,
            textSize: 16
        },
        dfoalc2: {
            title: "DFOALC2",
            colIndex: 8,
            columnWidth: 20,
            textSize: 16
        },
        jboalc: {
            title: "JBOALC",
            colIndex: 9,
            columnWidth: 30,
            textSize: 16
        },
        loalc: {
            title: "LOALC",
            colIndex: 10,
            columnWidth: 30,
            textSize: 16
        },
        remark: {
            title: "Remarks",
            colIndex: 11,
            columnWidth: 30,
            textSize: 16
        }
    }, FI = (()=>ra.foldlWithIndex((e)=>(_)=>(r)=>({
                        columnWidths: ne(_.columnWidths)([
                            r.columnWidth
                        ]),
                        cellData: ne(_.cellData)([
                            {
                                value: r.title,
                                rowIndex: 0,
                                colIndex: e,
                                merge: D,
                                style: {
                                    color: "FFFFFFFF",
                                    bgColor: "FF000000",
                                    textSize: r.textSize
                                }
                            }
                        ])
                    }))({
            columnWidths: [],
            cellData: []
        })([
            me.month,
            me.week,
            me.termWeek,
            me.day,
            me.date,
            me.ccoalc,
            me.ccoalc2,
            me.dfoalc,
            me.dfoalc2,
            me.jboalc,
            me.loalc,
            me.remark
        ]))(), eB = (e)=>Cr((_)=>(r)=>({
                    value: Qa(r),
                    rowIndex: _ + 1 | 0,
                    colIndex: me.date.colIndex,
                    merge: D,
                    style: {
                        color: "FF000000",
                        bgColor: "FFFFFFFF",
                        textSize: 12
                    }
                }))(e), oB = (e)=>{
        let _ = {
            color: "FF000000",
            bgColor: "FFFFFFFF",
            textSize: 12
        };
        return Qv(Cr((r)=>(t)=>[
                    {
                        value: "Mon",
                        rowIndex: (r * 7 | 0) + 1 | 0,
                        colIndex: me.day.colIndex,
                        merge: D,
                        style: _
                    },
                    {
                        value: "Tue",
                        rowIndex: (r * 7 | 0) + 2 | 0,
                        colIndex: me.day.colIndex,
                        merge: D,
                        style: _
                    },
                    {
                        value: "Wed",
                        rowIndex: (r * 7 | 0) + 3 | 0,
                        colIndex: me.day.colIndex,
                        merge: D,
                        style: _
                    },
                    {
                        value: "Thu",
                        rowIndex: (r * 7 | 0) + 4 | 0,
                        colIndex: me.day.colIndex,
                        merge: D,
                        style: _
                    },
                    {
                        value: "Fri",
                        rowIndex: (r * 7 | 0) + 5 | 0,
                        colIndex: me.day.colIndex,
                        merge: D,
                        style: _
                    },
                    {
                        value: "Sat",
                        rowIndex: (r * 7 | 0) + 6 | 0,
                        colIndex: me.day.colIndex,
                        merge: D,
                        style: _
                    },
                    {
                        value: "Sun",
                        rowIndex: (r * 7 | 0) + 7 | 0,
                        colIndex: me.day.colIndex,
                        merge: D,
                        style: _
                    }
                ])(e));
    }, rB = (e)=>{
        let _ = e.length;
        return oa((r)=>r)(Cr((r)=>(t)=>t._3 === 1 ? R("Just", {
                    value: cd(t),
                    rowIndex: r + 1 | 0,
                    merge: R("Just", _v("MergeBottom", (()=>{
                        let n = vc(t._1)(t._2);
                        return (n + r | 0) > _ ? _ - r | 0 : n;
                    })())),
                    colIndex: me.month.colIndex,
                    style: {
                        color: "FF000000",
                        bgColor: "FFFFFFFF",
                        textSize: 12
                    }
                }) : D)(e));
    }, tB = (e)=>(_)=>{
            let r = {
                color: "FF000000",
                bgColor: "FFFFFFFF",
                textSize: 14
            };
            return Cr((t)=>(n)=>{
                    let s = vt(Eo)(n)(e);
                    if (s.tag === "Just") return {
                        value: s._1.title,
                        rowIndex: t + 1 | 0,
                        colIndex: me.remark.colIndex,
                        merge: D,
                        style: r
                    };
                    if (s.tag === "Nothing") return {
                        rowIndex: t + 1 | 0,
                        colIndex: me.remark.colIndex,
                        merge: D,
                        style: r,
                        value: ""
                    };
                    l();
                })(_);
        }, nB = (e)=>{
        let _ = {
            color: "FF000000",
            bgColor: "FFFFFFFF",
            textSize: 14
        };
        return Qv(Cr((r)=>(t)=>[
                    {
                        rowIndex: r + 1 | 0,
                        colIndex: me.ccoalc.colIndex,
                        merge: D,
                        style: _,
                        value: ""
                    },
                    {
                        rowIndex: r + 1 | 0,
                        colIndex: me.ccoalc2.colIndex,
                        merge: D,
                        style: _,
                        value: ""
                    },
                    {
                        rowIndex: r + 1 | 0,
                        colIndex: me.dfoalc.colIndex,
                        merge: D,
                        style: _,
                        value: ""
                    },
                    {
                        rowIndex: r + 1 | 0,
                        colIndex: me.dfoalc2.colIndex,
                        merge: D,
                        style: _,
                        value: ""
                    },
                    {
                        rowIndex: r + 1 | 0,
                        colIndex: me.jboalc.colIndex,
                        merge: D,
                        style: _,
                        value: ""
                    },
                    {
                        rowIndex: r + 1 | 0,
                        colIndex: me.loalc.colIndex,
                        merge: D,
                        style: _,
                        value: ""
                    }
                ])(e));
    }, sB = (e)=>Cr((_)=>(r)=>({
                    value: r.title,
                    rowIndex: (_ * 7 | 0) + 1 | 0,
                    colIndex: me.termWeek.colIndex,
                    merge: R("Just", _v("MergeBottom", 7)),
                    style: {
                        color: "FF000000",
                        bgColor: "FFFFFFFF",
                        textSize: 12
                    }
                }))(e), cB = (e)=>Cr((_)=>(r)=>({
                    value: __(r.weekNum),
                    rowIndex: (_ * 7 | 0) + 1 | 0,
                    colIndex: me.week.colIndex,
                    merge: R("Just", _v("MergeBottom", 7)),
                    style: {
                        color: "FF000000",
                        bgColor: "FFFFFFFF",
                        textSize: 12
                    }
                }))(e), aB = (e)=>(_)=>(r)=>{
                let t = KU(Cr((n)=>(s)=>E(s, n + 1 | 0))(_));
                return te((n)=>{
                    let s = vt(Eo)(It(n))(t), c = (()=>{
                        if (s.tag === "Nothing") return 0;
                        if (s.tag === "Just") return s._1;
                        l();
                    })(), i = (()=>{
                        if (n.tag === "Holiday" || n.tag === "Resource") return n._1.days.length;
                        l();
                    })();
                    if (n.tag === "Holiday") return {
                        value: n._1.title,
                        rowIndex: c,
                        colIndex: me.ccoalc.colIndex,
                        merge: R("Just", _v("MergeRight", 4)),
                        style: (()=>{
                            if (n.tag === "Holiday") return {
                                color: "FF000000",
                                bgColor: "FF22C55E",
                                textSize: 14
                            };
                            if (n.tag === "Resource") {
                                if (n._1.booking.tag === "Booked") return {
                                    color: "FFF3F4F6",
                                    bgColor: "FF374151",
                                    textSize: 14
                                };
                                if (n._1.booking.tag === "PD") return {
                                    color: "FF000000",
                                    bgColor: "FFd1d5DB",
                                    textSize: 14
                                };
                                if (n._1.booking.tag === "HQ") return {
                                    color: "FF000000",
                                    bgColor: "FFfef9C3",
                                    textSize: 14
                                };
                                if (n._1.booking.tag === "Available") return n._1.camp.tag === "InSourceCamp" ? {
                                    color: "FF000000",
                                    bgColor: "FFFED7AA",
                                    textSize: 14
                                } : {
                                    color: "FF000000",
                                    bgColor: "FFbfDBFE",
                                    textSize: 14
                                };
                                l();
                            }
                            l();
                        })()
                    };
                    if (n.tag === "Resource") return {
                        value: ZU(e)(n._1),
                        rowIndex: c,
                        merge: R("Just", _v("MergeBottom", i)),
                        colIndex: (()=>{
                            if (n._1.location.tag === "CCOALC") return me.ccoalc.colIndex;
                            if (n._1.location.tag === "CCOALC2") return me.ccoalc2.colIndex;
                            if (n._1.location.tag === "DFOALC") return me.dfoalc.colIndex;
                            if (n._1.location.tag === "DFOALC2") return me.dfoalc2.colIndex;
                            if (n._1.location.tag === "JBOALC") return me.jboalc.colIndex;
                            if (n._1.location.tag === "LOALC") return me.loalc.colIndex;
                            l();
                        })(),
                        style: (()=>{
                            if (n.tag === "Holiday") return {
                                color: "FF000000",
                                bgColor: "FF22C55E",
                                textSize: 14
                            };
                            if (n.tag === "Resource") {
                                if (n._1.booking.tag === "Booked") return {
                                    color: "FFF3F4F6",
                                    bgColor: "FF374151",
                                    textSize: 14
                                };
                                if (n._1.booking.tag === "PD") return {
                                    color: "FF000000",
                                    bgColor: "FFd1d5DB",
                                    textSize: 14
                                };
                                if (n._1.booking.tag === "HQ") return {
                                    color: "FF000000",
                                    bgColor: "FFfef9C3",
                                    textSize: 14
                                };
                                if (n._1.booking.tag === "Available") return n._1.camp.tag === "InSourceCamp" ? {
                                    color: "FF000000",
                                    bgColor: "FFFED7AA",
                                    textSize: 14
                                } : {
                                    color: "FF000000",
                                    bgColor: "FFbfDBFE",
                                    textSize: 14
                                };
                                l();
                            }
                            l();
                        })()
                    };
                    l();
                })(r);
            }, iB = (e)=>(_)=>(r)=>{
                let t = _B(_)(r.calendar.weeks);
                return {
                    workYear: e,
                    columnWidths: FI.columnWidths,
                    cellData: ne(FI.cellData)(ne(rB(t))(ne(cB(r.calendar.weeks))(ne(sB(r.calendar.weeks))(ne(oB(r.calendar.weeks))(ne(eB(t))(ne(nB(t))(ne(aB(r.allUsers.userList)(t)(QU(ko.foldr(no)(y_)(r.calendar.slots))))(tB(r.calendar.remarks)(t)))))))))
                };
            }, PI = (e)=>(_)=>{
            let r = tb(_.env.workYear);
            if (r.tag === "Nothing") return E(_, [
                ae.pure(R("Just", X("OnCalendar", oy)))
            ]);
            if (r.tag === "Just") return E(_, [
                v_.bind(Bg.downloadCalendarFile(XU(iB(_.env.workYear)(r._1)(e))))((t)=>ae.pure(R("Just", X("OnCalendar", oy))))
            ]);
            l();
        };
    var LI = (()=>((_)=>(r)=>{
                let t = _, n = r, s = !0, c;
                for(; s;){
                    let i = t, d = n;
                    if (d.tag === "Nil") {
                        s = !1, c = i;
                        continue;
                    }
                    if (d.tag === "Cons") {
                        t = N0(Eo)(d._1)()(i), n = d._2;
                        continue;
                    }
                    l();
                }
                return c;
            })(be))(), _e = Jh(Bo), dB = m_({
        reflectSymbol: ()=>"slots"
    })()()(q)(O_), vB = (()=>mi(Ko).at)(), qI = m_({
        reflectSymbol: ()=>"calendar"
    })()()(q)(O_), yi = m_({
        reflectSymbol: ()=>"slotTable"
    })()()(q)(O_), ay = m_({
        reflectSymbol: ()=>"remarks"
    })()()(q)(O_), lb = (()=>mi(Eo).at)(), iy = is(Q6)((e)=>e.tag === "Resource" ? R("Just", e._1) : D)(An), WI = m_(pd)()()(q)(O_), Qt = m_({
        reflectSymbol: ()=>"slotEditForm"
    })()()(q)(O_), uB = m_({
        reflectSymbol: ()=>"bookingStatus"
    })()()(q)(O_), zI = m_({
        reflectSymbol: ()=>"auth"
    })()()(q)(O_), gB = m_({
        reflectSymbol: ()=>"isLoading"
    })()()(q)(O_), OI = m_({
        reflectSymbol: ()=>"bookingPhaseForm"
    })()()(q)(O_), sb = m_({
        reflectSymbol: ()=>"remarkForm"
    })()()(q)(O_), ty = Ee(ir(je)), Ir = Ee(An), bB = m_({
        reflectSymbol: ()=>"remark"
    })()()(q)(O_), ny = m_({
        reflectSymbol: ()=>"title"
    })()()(q)(O_), cb = m_({
        reflectSymbol: ()=>"slotCreateForm"
    })()()(q)(O_), sy = m_({
        reflectSymbol: ()=>"error"
    })()()(q)(O_), cy = m_({
        reflectSymbol: ()=>"slot"
    })()()(q)(O_), pB = is(K6)((e)=>e.tag === "Holiday" ? R("Just", e._1) : D)(An), UI = m_({
        reflectSymbol: ()=>"bookingCamp"
    })()()(q)(O_), BI = m_({
        reflectSymbol: ()=>"bookingUsername"
    })()()(q)(O_), ab = m_({
        reflectSymbol: ()=>"isExporting"
    })()()(q)(O_), Pc = m_({
        reflectSymbol: ()=>"bookSlotForm"
    })()()(q)(O_), fB = m_(us)()()(q)(O_), JI = Jh(Sr(je)), mB = m_({
        reflectSymbol: ()=>"bookSlotForm"
    })()()(q)(f0), VI = m_({
        reflectSymbol: ()=>"isSubmitting"
    })()()(q)(O_), ib = m_({
        reflectSymbol: ()=>"cancelSlotForm"
    })()()(q)(O_), $B = m_({
        reflectSymbol: ()=>"cancelSlotForm"
    })()()(q)(f0), hB = (e)=>(_)=>{
            let r = (t)=>(n)=>{
                    if (t.tag === "Nil") return !1;
                    if (t.tag === "Cons") {
                        let s = vt(Eo)(t._1)(n);
                        return (()=>{
                            if (s.tag === "Nothing") return !1;
                            if (s.tag === "Just") return !0;
                            l();
                        })() || r(t._2)(n);
                    }
                    l();
                };
            if (M3((()=>{
                if (e.tag === "Holiday" || e.tag === "Resource") return e._1.days;
                l();
            })())) {
                if (e.tag === "Holiday") return r($d(e))(LI(ji.bind(br($d)(ko.foldr(no)(y_)(_)))(Ip)));
                if (e.tag === "Resource") {
                    let t = e._1.location;
                    return r($d(e))(LI(ji.bind(br($d)(P7((n)=>{
                        if (n.tag === "Holiday") return !0;
                        if (n.tag === "Resource") return n._1.location.tag === "CCOALC" ? t.tag === "CCOALC" : n._1.location.tag === "DFOALC" ? t.tag === "DFOALC" : n._1.location.tag === "JBOALC" ? t.tag === "JBOALC" : n._1.location.tag === "LOALC" ? t.tag === "LOALC" : n._1.location.tag === "CCOALC2" ? t.tag === "CCOALC2" : n._1.location.tag === "DFOALC2" ? t.tag === "DFOALC2" : !1;
                        l();
                    })(ko.foldr(no)(y_)(_))))(Ip)));
                }
                l();
            }
            return !0;
        }, yB = (e)=>(_)=>{
            let r = Yh(e);
            return _e(dB(vB(e.id)(O_)((t)=>r)))(_);
        }, DB = (e)=>(_)=>{
            let r = e.changeType;
            return qI(yi((t)=>{
                if (r.tag === "Added") return Yd(Dr(e.id, e.docData))(t);
                if (r.tag === "Modified") return Yd(Dr(e.id, e.docData))(t);
                if (r.tag === "Removed") return Xd(Dr(e.id, e.docData))(t);
                l();
            }))(_);
        }, wB = (e)=>(_)=>{
            let r = Xm(e.id);
            if (r.tag === "Nothing") return E(_, [
                v_.bind(J_.liftAff(he(fs("[ERR] Invalid shortDate " + e.id))))(ue.noop)
            ]);
            if (r.tag === "Just") return E((()=>{
                let t = Yh(e);
                return _e(ay(lb(r._1)(O_)((n)=>t)))(_);
            })(), []);
            l();
        }, ot = (e)=>(_)=>v_.bind(J_.liftAff(he(fs("[ERR] " + e.show(_)))))(ue.noop), RB = (e)=>(_)=>{
            if (_.calendar.slotEditForm.tag === "Nothing") return E(e, [
                ot(Qc)("Missing Slot Edit Form")
            ]);
            if (_.calendar.slotEditForm.tag === "Just") {
                let r = _.calendar.slotEditForm._1.id, t = _.calendar.slotEditForm._1.slot, n = wo.apply((()=>{
                    let c = _.calendar.slotEditForm._1.bookingCamp;
                    return c.tag === "Just" ? R("Just", (()=>{
                        let i = c._1;
                        return (d)=>Ya("Booked", {
                                phase: _.calendar.bookingPhase,
                                camp: i,
                                username: d
                            });
                    })()) : D;
                })())(_.calendar.slotEditForm._1.bookingUsername), s = (()=>{
                    if (n.tag === "Nothing") return t;
                    if (n.tag === "Just") {
                        let c = n._1;
                        return iy(WI((i)=>c))(t);
                    }
                    l();
                })();
                return E(_e(yi(Yd(Dr(r, s))))(_e(Qt((c)=>D))(e)), [
                    v_.bind(Pr.setSlot(r)(s))(ue.emit((()=>{
                        let c = kI(Dr(r, s));
                        return (i)=>X("OnCalendar", c(i));
                    })()))
                ]);
            }
            l();
        }, kB = (e)=>{
        let _ = {
            id: e._1,
            slot: e._2,
            bookingCamp: D,
            bookingUsername: D,
            error: D
        };
        if (e._2.tag === "Holiday") return _;
        if (e._2.tag === "Resource") return e._2._1.booking.tag === "Booked" ? {
            id: _.id,
            slot: _.slot,
            bookingCamp: R("Just", e._2._1.booking._1.camp),
            bookingUsername: R("Just", e._2._1.booking._1.username),
            error: _.error
        } : e._2._1.camp.tag === "InSourceCamp" ? {
            id: _.id,
            slot: _.slot,
            bookingCamp: R("Just", bd),
            bookingUsername: _.bookingUsername,
            error: _.error
        } : _;
        l();
    };
    var HI = {
        isLoading: !0,
        isExporting: !1,
        weeks: [],
        bookingPhase: Pa,
        slots: be,
        remarks: be,
        bookingPhaseForm: D,
        remarkForm: D,
        slotCreateForm: D,
        slotEditForm: D,
        bookSlotForm: D,
        cancelSlotForm: D,
        slotTable: lI,
        bookingStatus: Hh
    }, SB = (e)=>{
        let _ = rI(e.user)(c8(ko.foldr(no)(y_)(e.calendar.slots)));
        return qI(uB((r)=>_))(e);
    }, jI = (e)=>(_)=>(r)=>{
                if (_.tag === "OnRemarkSync") {
                    if (_._1.tag === "Left") return E(e, [
                        ot(ge)(_._1._1)
                    ]);
                    if (_._1.tag === "Right") return wB(_._1._1)(e);
                    l();
                }
                if (_.tag === "OnCalendarSync") {
                    if (_._1.tag === "Left") return E(e, [
                        ot(ge)(_._1._1)
                    ]);
                    if (_._1.tag === "Right") {
                        let t = _._1._1.docData.bookingPhase;
                        return E(_e((n)=>({
                                isLoading: n.isLoading,
                                isExporting: n.isExporting,
                                weeks: tI,
                                bookingPhase: t,
                                slots: n.slots,
                                remarks: n.remarks,
                                bookingPhaseForm: n.bookingPhaseForm,
                                remarkForm: n.remarkForm,
                                slotCreateForm: n.slotCreateForm,
                                slotEditForm: n.slotEditForm,
                                bookSlotForm: n.bookSlotForm,
                                cancelSlotForm: n.cancelSlotForm,
                                slotTable: n.slotTable,
                                bookingStatus: n.bookingStatus
                            }))(e), []);
                    }
                    l();
                }
                if (_.tag === "OnSlotSync") {
                    if (_._1.tag === "Left") return E(e, [
                        ot(ge)(_._1._1)
                    ]);
                    if (_._1.tag === "Right") return E(zI((t)=>wo.apply(R("Just", DB(_._1._1)))(t))(zI((t)=>wo.apply(R("Just", SB))(t))(_e(gB((t)=>!1))(yB(_._1._1)(e)))), []);
                    l();
                }
                if (_.tag === "OnBookingPhaseSelect") return E((()=>{
                    let t = R("Just", _._1);
                    return _e(OI((n)=>t))(e);
                })(), []);
                if (_.tag === "OnBookingPhaseCancel") return E(_e(OI((t)=>D))(e), []);
                if (_.tag === "OnBookingPhaseConfirmed") return E(e, [
                    v_.bind(Pr.setBookingPhase(_._1))(ue.noop)
                ]);
                if (_.tag === "OnRemarkEdit") return E((()=>{
                    let t = R("Just", {
                        date: _._1,
                        remark: (()=>{
                            let n = lb(_._1)(f0)(ty((s)=>R("Just", s)))(r.calendar.remarks);
                            if (n.tag === "Nothing") return {
                                title: ""
                            };
                            if (n.tag === "Just") return n._1;
                            l();
                        })()
                    });
                    return _e(sb((n)=>t))(e);
                })(), []);
                if (_.tag === "OnRemarkEditTitle") return E((()=>{
                    let t = _._1;
                    return _e(sb(Ir(bB(ny((n)=>t)))))(e);
                })(), []);
                if (_.tag === "OnRemarkEditSubmit") {
                    if (r.calendar.remarkForm.tag === "Nothing") return E(e, [
                        ot(Qc)("Missing Remark Form")
                    ]);
                    if (r.calendar.remarkForm.tag === "Just") {
                        let t = r.calendar.remarkForm._1.date, n = r.calendar.remarkForm._1.remark;
                        return E(_e(ay(lb(t)(O_)(Ir((s)=>n))))(_e(sb((s)=>D))(e)), [
                            v_.bind(Pr.setRemark(t)(n))(ue.emit((()=>{
                                let s = DI(t);
                                return (c)=>X("OnCalendar", s(c));
                            })()))
                        ]);
                    }
                    l();
                }
                if (_.tag === "OnRemarkEditSubmitResult") {
                    if (_._2.tag === "Right") return E(e, []);
                    if (_._2.tag === "Left") return E(_e(ay(lb(_._1)(O_)((t)=>D)))(e), [
                        ot(Hs)(_._2._1)
                    ]);
                    l();
                }
                if (_.tag === "OnRemarkCancel") return E(_e(sb((t)=>D))(e), []);
                if (_.tag === "OnRemarkDelete") return E(e, [
                    v_.bind(Pr.deleteRemark(_._1))(ue.noop)
                ]);
                if (_.tag === "OnSlotCreate") return E(_e(cb((t)=>R("Just", {
                        location: _._1,
                        date: _._2,
                        error: D
                    })))(e), []);
                if (_.tag === "OnSlotCreateCancel") return E(_e(cb((t)=>D))(e), []);
                if (_.tag === "OnSlotCreateSubmit") {
                    if (r.calendar.slotCreateForm.tag === "Nothing") return E(e, [
                        ot(Qc)("Missing Slot Create Form")
                    ]);
                    if (r.calendar.slotCreateForm.tag === "Just") {
                        let t = l8(r.calendar.slotCreateForm._1.location)(r.calendar.slotCreateForm._1.date)(_._1);
                        return hB(t)(r.calendar.slots) ? E(_e(cb(Ir(sy((n)=>R("Just", "Conflicting dates with another slot.")))))(e), []) : E(_e(cb((n)=>D))(e), [
                            v_.bind(Pr.generateSlotID)((n)=>{
                                if (n.tag === "Left") return ot(Hs)(n._1);
                                if (n.tag === "Right") return ae.pure(R("Just", X("OnCalendar", K_("OnSlotCreateSubmitWithID", Dr(n._1, t)))));
                                l();
                            })
                        ]);
                    }
                    l();
                }
                if (_.tag === "OnSlotCreateSubmitWithID") return E(_e(yi(Yd(_._1)))(e), [
                    v_.bind(Pr.setSlot(_._1._1)(_._1._2))(ue.emit((()=>{
                        let t = RI(_._1);
                        return (n)=>X("OnCalendar", t(n));
                    })()))
                ]);
                if (_.tag === "OnSlotCreateSubmitResult") {
                    if (_._2.tag === "Right") return E(e, []);
                    if (_._2.tag === "Left") return E(_e(yi(Xd(_._1)))(e), [
                        ot(Hs)(_._2._1)
                    ]);
                    l();
                }
                if (_.tag === "OnSlotEdit") return E((()=>{
                    let t = R("Just", kB(_._1));
                    return _e(Qt((n)=>t))(e);
                })(), []);
                if (_.tag === "OnSlotEditTitle") return E((()=>{
                    let t = _._1 === "" ? R("Just", "Title cannot be empty.") : D;
                    return _e(Qt(Ir(sy((n)=>t))))((()=>{
                        let n = _._1;
                        return _e(Qt(Ir(cy(iy(ny((s)=>n))))))((()=>{
                            let s = _._1;
                            return _e(Qt(Ir(cy(pB(ny((c)=>s))))))(e);
                        })());
                    })());
                })(), []);
                if (_.tag === "OnSlotEditBookingCamp") return E((()=>{
                    let t = R("Just", _._1);
                    return _e(Qt(Ir(UI((n)=>t))))(e);
                })(), []);
                if (_.tag === "OnSlotEditBookingUsername") return E((()=>{
                    let t = R("Just", _._1);
                    return _e(Qt(Ir(BI((n)=>t))))(e);
                })(), []);
                if (_.tag === "OnSlotEditBookingAvailable") return E(_e(Qt(Ir(cy(iy(WI((t)=>St))))))(_e(Qt(Ir(BI((t)=>D))))(_e(Qt(Ir(UI((t)=>D))))(e))), []);
                if (_.tag === "OnSlotEditCancel") return E(_e(Qt((t)=>D))(e), []);
                if (_.tag === "OnSlotEditSubmit") return RB(e)(r);
                if (_.tag === "OnSlotEditSubmitResult") {
                    if (_._2.tag === "Right") return E(e, []);
                    if (_._2.tag === "Left") return E(_e(yi(Xd(_._1)))(e), [
                        ot(Hs)(_._2._1)
                    ]);
                    l();
                }
                if (_.tag === "OnSlotDelete") return E(_e(yi(Xd(_._1)))(e), [
                    v_.bind(Pr.deleteSlot(_._1._1))(ue.noop)
                ]);
                if (_.tag === "OnExportCalendarStart") return E(_e(ab((t)=>!0))(e), []);
                if (_.tag === "OnExportCalendar") return PI(r)(e);
                if (_.tag === "OnExportCalendarEnd") return E(_e(ab((t)=>!1))(e), []);
                if (_.tag === "OnExportBookingStart") return E(_e(ab((t)=>!0))(e), []);
                if (_.tag === "OnExportBooking") return AI(r)(e);
                if (_.tag === "OnExportBookingEnd") return E(_e(ab((t)=>!1))(e), []);
                if (_.tag === "OnUserBookSlotStart") return E(_e(Pc((t)=>R("Just", {
                        id: _._1,
                        camp: _._2.camp,
                        error: D,
                        isSubmitting: !1
                    })))(e), []);
                if (_.tag === "OnUserBookSlotCamp") return E((()=>{
                    let t = _._1;
                    return _e(Pc(Ir(fB((n)=>t))))(e);
                })(), []);
                if (_.tag === "OnUserBookSlotCancel") return E(_e(Pc((t)=>D))(e), []);
                if (_.tag === "OnUserBookSlotSubmit") {
                    let t = JI(mB(ty((n)=>R("Just", n))))(e);
                    if (t.tag === "Nothing") return E(e, [
                        ot(Qc)("No book slot form found")
                    ]);
                    if (t.tag === "Just") return t._1.camp.tag !== "InSourceCamp" && t._1.camp.tag === "AwaitUserCamp" ? E(_e(Pc(Ir(sy((n)=>R("Just", "Please select the type of camp.")))))(e), []) : E(_e(Pc(Ir(VI((n)=>!0))))(e), [
                        v_.bind(Pr.bookSlot(r.calendar.bookingPhase)(r.user)(t._1.camp)(t._1.id))(ue.emit((()=>{
                            let n = TI(t._1.id);
                            return (s)=>X("OnCalendar", n(s));
                        })()))
                    ]);
                    l();
                }
                if (_.tag === "OnUserBookSlotSubmitResult") {
                    if (_._2.tag === "Right") return E(_e(Pc((t)=>D))(e), []);
                    if (_._2.tag === "Left") {
                        let t = _._1, n = _._2._1;
                        return E(_e(Pc(Ir((s)=>s.id === t ? {
                                id: s.id,
                                camp: s.camp,
                                error: R("Just", c$.show(n)),
                                isSubmitting: !1
                            } : s)))(e), [
                            ot(c$)(n)
                        ]);
                    }
                    l();
                }
                if (_.tag === "OnUserCancelSlot") return E(_e(ib((t)=>R("Just", {
                        id: _._1,
                        confirm: !1,
                        isSubmitting: !1
                    })))(e), []);
                if (_.tag === "OnUserCancelSlotCancel") return E(_e(ib((t)=>D))(e), []);
                if (_.tag === "OnUserCancelSlotSubmit") {
                    let t = JI($B(ty((n)=>R("Just", n))))(e);
                    if (t.tag === "Nothing") return E(e, [
                        ot(Qc)("No cancel slot form found")
                    ]);
                    if (t.tag === "Just") return E(_e(ib(Ir(VI((n)=>!0))))(e), [
                        v_.bind(Pr.cancelSlot(t._1.id))((n)=>ae.pure(R("Just", X("OnCalendar", K_("OnUserCancelSlotSubmitResult", n)))))
                    ]);
                    l();
                }
                if (_.tag === "OnUserCancelSlotSubmitResult") return E(_e(ib((t)=>D))(e), [
                    (()=>{
                        if (_._1.tag === "Left") return ot(d6)(_._1._1);
                        if (_._1.tag === "Right") return ue.noop_;
                        l();
                    })()
                ]);
                l();
            };
    var Tt = (e, _)=>({
            tag: e,
            _1: _
        }), db = (e)=>({
            tag: e
        }), mt = db("InitForm"), KI = db("FormError"), Di = db("Submitting"), Lc = db("Submitted"), xB = Tt("Pristine");
    var io = Tt("Valid");
    var ly = (e)=>(_)=>{
            let r = Wr(te((t)=>t(_))(e))(0);
            if (r.tag === "Nothing") return io;
            if (r.tag === "Just") return r._1;
            l();
        }, dy = (e)=>e === "" ? Tt("Invalid", "Not empty field") : io, EB = (e)=>(_)=>{
            let r = ct(_);
            if (r.tag === "Nothing") return Tt("Invalid", "Must be a number");
            if (r.tag === "Just") return r._1 > e ? io : Tt("Invalid", "Must be greater than " + __(e));
            l();
        }, QI = (e)=>{
        let _ = EB(0)(e);
        return _.tag === "Invalid" ? Tt("Invalid", "Must be a positive number") : _;
    };
    var YI = (e)=>il(e).length > 5 ? io : Tt("Invalid", "Password must be at least 6 characters"), XI = (e)=>{
        let _ = Ha(".+\\@.+\\..+")(jm);
        if (_.tag === "Left") return Tt("Invalid", "Invalid email format");
        if (_.tag === "Right") return i3(_._1)(e) ? io : Tt("Invalid", "Invalid email format");
        l();
    }, rt = {
        value: "",
        status: xB
    };
    var ev = (e, _)=>({
            tag: e,
            _1: _
        }), ZI = ev("OnSubmit");
    var ex = (e)=>(_)=>{
            let r = (t)=>({
                    forgotPassword: t(e.forgotPassword),
                    auth: e.auth,
                    env: e.env,
                    login: e.login,
                    resetPassword: e.resetPassword,
                    route: e.route
                });
            if (_.tag === "OnFields") {
                let t = _._1;
                return E(r((n)=>({
                        fields: t,
                        apiError: n.apiError,
                        status: n.status
                    })), []);
            }
            if (_.tag === "OnSubmit") return E(r((t)=>({
                    fields: t.fields,
                    apiError: t.apiError,
                    status: Di
                })), [
                v_.bind(J_.liftAff(Eg(vd(e.forgotPassword.fields.email.value))._1))((t)=>ae.pure(R("Just", X("OnForgotPassword", ev("OnSubmitResult", t)))))
            ]);
            if (_.tag === "OnSubmitResult") {
                if (_._1.tag === "Left") {
                    let t = _._1._1;
                    return E(r((n)=>({
                            fields: n.fields,
                            apiError: R("Just", t),
                            status: mt
                        })), []);
                }
                if (_._1.tag === "Right") return E(r((t)=>({
                        fields: t.fields,
                        apiError: D,
                        status: Lc
                    })), []);
                l();
            }
            l();
        }, ox = {
        fields: {
            email: rt
        },
        status: mt,
        apiError: D
    };
    var Ri = (e, _)=>({
            tag: e,
            _1: _
        }), rx = Ri("OnSubmit");
    var nx = (e)=>(_)=>(r)=>{
                let t = (n)=>({
                        login: n(_.login),
                        auth: _.auth,
                        env: _.env,
                        forgotPassword: _.forgotPassword,
                        resetPassword: _.resetPassword,
                        route: _.route
                    });
                if (r.tag === "OnFields") {
                    let n = r._1;
                    return E(t((s)=>({
                            fields: n,
                            status: s.status
                        })), []);
                }
                if (r.tag === "OnSubmit") return E(_, [
                    v_.bind(u0.loginUser(_.login.fields.username.value)(_.login.fields.password.value))((n)=>ae.pure(R("Just", X("OnLogin", Ri("OnSubmitResult", n)))))
                ]);
                if (r.tag === "OnSubmitResult") {
                    if (r._1.tag === "Nothing") return E(t((n)=>({
                            fields: n.fields,
                            status: KI
                        })), []);
                    if (r._1.tag === "Just") return e(r._1._1);
                    l();
                }
                l();
            }, sx = {
        fields: {
            username: rt,
            password: rt
        },
        status: mt
    };
    var ki = (e, _)=>({
            tag: e,
            _1: _
        });
    var ax = (e)=>(_)=>{
            let r = (t)=>({
                    resetPassword: t(e.resetPassword),
                    auth: e.auth,
                    env: e.env,
                    forgotPassword: e.forgotPassword,
                    login: e.login,
                    route: e.route
                });
            if (_.tag === "OnFields") {
                let t = _._1;
                return E(r((n)=>({
                        fields: t,
                        apiError: n.apiError,
                        status: n.status
                    })), []);
            }
            if (_.tag === "OnSubmit") return E(r((t)=>({
                    fields: t.fields,
                    apiError: t.apiError,
                    status: Di
                })), [
                v_.bind(J_.liftAff(xg(ud(_._1)(e.resetPassword.fields.password.value))._1))((t)=>ae.pure(R("Just", X("OnResetPassword", ki("OnSubmitResult", t)))))
            ]);
            if (_.tag === "OnSubmitResult") {
                if (_._1.tag === "Left") {
                    let t = _._1._1;
                    return E(r((n)=>({
                            fields: n.fields,
                            apiError: R("Just", t),
                            status: mt
                        })), []);
                }
                if (_._1.tag === "Right") return E(r((t)=>({
                        fields: t.fields,
                        apiError: D,
                        status: Lc
                    })), [
                    v_.bind(Cn.goto(Et))(ue.emit(Fn))
                ]);
                l();
            }
            l();
        }, ix = {
        fields: {
            password: rt,
            password2: rt
        },
        status: mt,
        apiError: D
    };
    var Jo = (e, _)=>({
            tag: e,
            _1: _
        }), lx = Jo("OnCreateUser");
    var dx = Jo("OnSubmit");
    var Rs = ob(Bo), AB = m_({
        reflectSymbol: ()=>"status"
    })()()(q)(O_), NB = m_({
        reflectSymbol: ()=>"fields"
    })()()(q)(O_), FB = (e)=>(_)=>{
            let r = e.value + " " + _.value;
            return (()=>e.status.tag === "Pristine" || e.status.tag === "Invalid" ? !1 : e.status.tag === "Valid")() && (()=>_.status.tag === "Pristine" || _.status.tag === "Invalid" ? !1 : _.status.tag === "Valid")() ? Tg(r) : D;
        }, MB = (e)=>(_)=>{
            let r = FB(e.userCreate.fields.startBookingDate)(e.userCreate.fields.startBookingTime), t = Fd(e.userCreate.fields.bookingPermissionStr.value);
            if (r.tag === "Nothing") return E(_, [
                ae.pure(R("Just", X("OnUserCreate", Jo("OnSubmitResult", S("Left", Sg)))))
            ]);
            if (t.tag === "Nothing") return E(_, [
                ae.pure(R("Just", X("OnUserCreate", Jo("OnSubmitResult", S("Left", Ig)))))
            ]);
            if (r.tag === "Just") {
                if (t.tag === "Just") {
                    let n = {
                        username: e.userCreate.fields.username.value,
                        schoolName: e.userCreate.fields.schoolName.value,
                        email: e.userCreate.fields.email.value,
                        maxSlots: (()=>{
                            let s = ct(e.userCreate.fields.maxSlots.value);
                            if (s.tag === "Nothing") return 1;
                            if (s.tag === "Just") return s._1;
                            l();
                        })(),
                        remark: e.userCreate.fields.remark.value,
                        startBooking: r._1,
                        bookingPermission: t._1,
                        isAdmin: e.userCreate.fields.isAdmin.value === "yes",
                        pax: (()=>{
                            let s = ct(e.userCreate.fields.pax.value);
                            if (s.tag === "Nothing") return 0;
                            if (s.tag === "Just") return s._1;
                            l();
                        })()
                    };
                    return E(Rs(AB((s)=>Di))(_), [
                        (()=>{
                            if (e.userCreate.uid.tag === "Nothing") return v_.bind(J_.liftAff(ci(n)._1))((s)=>ae.pure(R("Just", X("OnUserCreate", Jo("OnSubmitResult", s)))));
                            if (e.userCreate.uid.tag === "Just") return v_.bind(J_.liftAff(Gg({
                                uid: e.userCreate.uid._1,
                                username: n.username,
                                schoolName: n.schoolName,
                                email: n.email,
                                remark: n.remark,
                                maxSlots: n.maxSlots,
                                startBooking: n.startBooking,
                                bookingPermission: n.bookingPermission,
                                isAdmin: n.isAdmin,
                                pax: n.pax
                            })._1))((s)=>ae.pure(R("Just", X("OnUserCreate", Jo("OnUpdateResult", s)))));
                            l();
                        })()
                    ]);
                }
                l();
            }
            l();
        }, PB = (e)=>{
        let _ = wn(e);
        if (_.tag === "Just") {
            let r = Ja(_i)(8)(_._1);
            if (r.tag === "Just") {
                let t = qr(ea(0)(2)(Pt(" ")(yn(Dn(r._1))(dh))));
                if (t.tag === "Just") {
                    let n = qr(t._1.tail);
                    if (n.tag === "Just") return E(t._1.head, n._1.head);
                    if (n.tag === "Nothing") return E("", "00:00");
                    l();
                }
                if (t.tag === "Nothing") return E("", "00:00");
                l();
            }
            if (r.tag === "Nothing") return E("", "00:00");
            l();
        }
        if (_.tag === "Nothing") return E("", "00:00");
        l();
    }, vb = (e)=>{
        if (e.tag === "Just") {
            let _ = PB(e._1.startBooking);
            return {
                uid: R("Just", e._1.uid),
                fields: {
                    username: {
                        value: e._1.username,
                        status: io
                    },
                    schoolName: {
                        value: e._1.schoolName,
                        status: io
                    },
                    email: {
                        value: e._1.email,
                        status: io
                    },
                    maxSlots: {
                        value: __(e._1.maxSlots),
                        status: io
                    },
                    remark: {
                        value: e._1.remark,
                        status: io
                    },
                    startBookingDate: {
                        value: _._1,
                        status: io
                    },
                    startBookingTime: {
                        value: _._2,
                        status: io
                    },
                    bookingPermissionStr: {
                        value: (()=>{
                            if (e._1.bookingPermission.tag === "Only4D") return "Only4D";
                            if (e._1.bookingPermission.tag === "Only3D") return "Only3D";
                            if (e._1.bookingPermission.tag === "BookAll") return "BookAll";
                            l();
                        })(),
                        status: io
                    },
                    isAdmin: {
                        value: e._1.isAdmin ? "yes" : "no",
                        status: io
                    },
                    pax: {
                        value: __(e._1.pax),
                        status: io
                    }
                },
                status: mt,
                apiError: D
            };
        }
        if (e.tag === "Nothing") return {
            uid: D,
            fields: {
                username: rt,
                schoolName: rt,
                email: rt,
                maxSlots: rt,
                remark: {
                    value: "",
                    status: io
                },
                startBookingDate: rt,
                startBookingTime: {
                    value: "00:00",
                    status: io
                },
                bookingPermissionStr: {
                    value: "Only4D",
                    status: io
                },
                isAdmin: {
                    value: "no",
                    status: io
                },
                pax: {
                    value: "1",
                    status: io
                }
            },
            status: mt,
            apiError: D
        };
        l();
    }, vx = (e)=>(_)=>(r)=>{
                if (_.tag === "OnCreateUser") return E((()=>{
                    let t = vb(D);
                    return Rs((n)=>t)(e);
                })(), [
                    v_.bind(Cn.goto(Rh))(ue.emit(Fn))
                ]);
                if (_.tag === "OnEditUser") return E((()=>{
                    let t = vb(R("Just", _._1));
                    return Rs((n)=>t)(e);
                })(), [
                    v_.bind(Cn.goto(kh))(ue.emit(Fn))
                ]);
                if (_.tag === "OnFields") return E((()=>{
                    let t = _._1;
                    return Rs(NB((n)=>t))(e);
                })(), []);
                if (_.tag === "OnSubmit") return MB(r)(e);
                if (_.tag === "OnSubmitResult") {
                    if (_._1.tag === "Left") {
                        let t = _._1._1;
                        return E(Rs((n)=>({
                                uid: n.uid,
                                fields: n.fields,
                                status: mt,
                                apiError: R("Just", t)
                            }))(e), []);
                    }
                    if (_._1.tag === "Right") return E(Rs((t)=>({
                            uid: t.uid,
                            fields: t.fields,
                            status: Lc,
                            apiError: D
                        }))(e), []);
                    l();
                }
                if (_.tag === "OnUpdateResult") {
                    if (_._1.tag === "Left") {
                        let t = _._1._1;
                        return E(Rs((n)=>({
                                uid: n.uid,
                                fields: n.fields,
                                status: mt,
                                apiError: R("Just", t)
                            }))(e), []);
                    }
                    if (_._1.tag === "Right") return E(Rs((t)=>({
                            uid: t.uid,
                            fields: t.fields,
                            status: Lc,
                            apiError: D
                        }))(e), []);
                    l();
                }
                l();
            };
    var m0 = (e, _, r)=>({
            tag: e,
            _1: _,
            _2: r
        }), ov = (e, _)=>({
            tag: e,
            _1: _
        }), ks = (e, _)=>({
            tag: e,
            _1: _
        }), ux = ov("OnFileSelected");
    var rv = ov("CreateNextUser");
    var uy = ks("NoImportState"), gx = ks("ParsingImportState");
    var gy = (e)=>ks("ImportSuccessState", e), bx = (e)=>F_.bind((()=>{
            let _ = ct(e.maxSlots);
            if (_.tag === "Nothing") return S("Left", "Invalid integer max slots.");
            if (_.tag === "Just") return S("Right", _._1);
            l();
        })())((_)=>F_.bind((()=>{
                let r = ct(e.pax);
                if (r.tag === "Nothing") return S("Left", "Invalid integer pax.");
                if (r.tag === "Just") return S("Right", r._1);
                l();
            })())((r)=>F_.bind((()=>{
                    let t = Fd(e.bookingPermission);
                    if (t.tag === "Nothing") return S("Left", "Invalid booking permission.");
                    if (t.tag === "Just") return S("Right", t._1);
                    l();
                })())((t)=>F_.bind((()=>{
                        let n = Tg(e.startBooking);
                        if (n.tag === "Nothing") return S("Left", "Invalid start booking date.");
                        if (n.tag === "Just") return S("Right", n._1);
                        l();
                    })())((n)=>S("Right", {
                            username: e.username,
                            schoolName: e.schoolName,
                            email: e.email,
                            remark: e.remark,
                            maxSlots: _,
                            startBooking: n,
                            bookingPermission: t,
                            isAdmin: !1,
                            pax: r
                        })))));
    var px = (e)=>(_)=>m0("RowCreateError", (()=>{
                if (_.tag === "RowPending" || _.tag === "RowDecodeError" || _.tag === "RowCreating" || _.tag === "RowCreateError" || _.tag === "RowCreated") return _._1;
                l();
            })(), e), fx = (e)=>m0("RowCreated", (()=>{
            if (e.tag === "RowPending" || e.tag === "RowDecodeError" || e.tag === "RowCreating" || e.tag === "RowCreateError" || e.tag === "RowCreated") return e._1;
            l();
        })()), mx = (e)=>m0("RowCreating", (()=>{
            if (e.tag === "RowPending" || e.tag === "RowDecodeError" || e.tag === "RowCreating" || e.tag === "RowCreateError" || e.tag === "RowCreated") return e._1;
            l();
        })()), $x = (e)=>(_)=>m0("RowDecodeError", (()=>{
                if (_.tag === "RowPending" || _.tag === "RowDecodeError" || _.tag === "RowCreating" || _.tag === "RowCreateError" || _.tag === "RowCreated") return _._1;
                l();
            })(), e);
    var $0 = Vh(Bo), h0 = Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", Q_((_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), I_, (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), e._1)) : D
    }), zB = (()=>So(Re((()=>{
            let e = eu(So(h0(Re({
                decodeJsonField: (_)=>_.tag === "Just" ? R("Just", Qn(_._1)) : D
            })(tr)({
                reflectSymbol: ()=>"rowNum"
            })()())({
                reflectSymbol: ()=>"message"
            })()())().decodeJson);
            return {
                decodeJsonField: (_)=>_.tag === "Just" ? R("Just", e(_._1)) : D
            };
        })())(Re((()=>{
            let e = eu(So(h0(h0(h0(h0(h0(h0(h0(h0(tr)({
                reflectSymbol: ()=>"username"
            })()())({
                reflectSymbol: ()=>"startBooking"
            })()())({
                reflectSymbol: ()=>"schoolName"
            })()())({
                reflectSymbol: ()=>"remark"
            })()())({
                reflectSymbol: ()=>"pax"
            })()())({
                reflectSymbol: ()=>"maxSlots"
            })()())({
                reflectSymbol: ()=>"email"
            })()())({
                reflectSymbol: ()=>"bookingPermission"
            })()())().decodeJson);
            return {
                decodeJsonField: (_)=>_.tag === "Just" ? R("Just", e(_._1)) : D
            };
        })())(tr)({
            reflectSymbol: ()=>"rows"
        })()())({
            reflectSymbol: ()=>"errors"
        })()())().decodeJson)(), OB = Vh(Sr(je)), UB = is(gy)((e)=>e.tag === "ImportSuccessState" ? R("Just", e._1) : D)(ir(je)), ub = is(gy)((e)=>e.tag === "ImportSuccessState" ? R("Just", e._1) : D)(An), py = (e)=>{
        let _ = qr(e.unprocessed);
        if (_.tag === "Just") return {
            processed: Ft(e.processed)(e.current),
            current: m0("RowPending", _._1.head),
            unprocessed: _._1.tail,
            errors: e.errors
        };
        if (_.tag === "Nothing") return e;
        l();
    };
    var hx = (e)=>(_)=>(r)=>{
                if (_.tag === "OnFileSelected") return E($0((t)=>gx)(e), [
                    v_.bind(J_.liftAff(Fg(Pd("user-import-file-id"))._1))((t)=>ae.pure(R("Just", X("OnUserImport", ov("OnFileSelectedCSV", t)))))
                ]);
                if (_.tag === "OnFileSelectedCSV") {
                    if (_._1.tag === "Left") return E((()=>{
                        let t = ks("ImportErrorState", No(_._1._1));
                        return $0((n)=>t)(e);
                    })(), []);
                    if (_._1.tag === "Right") {
                        let t = zB(_._1._1);
                        if (t.tag === "Left") return E((()=>{
                            let n = ks("ImportErrorState", ge.show(t._1));
                            return $0((s)=>n)(e);
                        })(), []);
                        if (t.tag === "Right") {
                            let n = qr(t._1.rows);
                            if (n.tag === "Nothing") return E($0((s)=>ks("ImportErrorState", "No rows found in CSV."))(e), []);
                            if (n.tag === "Just") return E($0((s)=>ks("ImportSuccessState", {
                                    processed: [],
                                    current: m0("RowPending", n._1.head),
                                    unprocessed: n._1.tail,
                                    errors: t._1.errors
                                }))(e), [
                                ae.pure(R("Just", X("OnUserImport", rv)))
                            ]);
                            l();
                        }
                        l();
                    }
                    l();
                }
                if (_.tag === "CreateNextUser") {
                    let t = OB(UB((n)=>R("Just", n)))(e);
                    if (t.tag === "Nothing") return E(e, []);
                    if (t.tag === "Just") {
                        if (t._1.current.tag === "RowPending") {
                            let n = bx(t._1.current._1);
                            if (n.tag === "Left") return E((()=>{
                                let s = py({
                                    processed: t._1.processed,
                                    current: $x(n._1)(t._1.current),
                                    unprocessed: t._1.unprocessed,
                                    errors: t._1.errors
                                });
                                return $0(ub((c)=>s))(e);
                            })(), [
                                ae.pure(R("Just", X("OnUserImport", rv)))
                            ]);
                            if (n.tag === "Right") return E((()=>{
                                let s = {
                                    processed: t._1.processed,
                                    current: mx(t._1.current),
                                    unprocessed: t._1.unprocessed,
                                    errors: t._1.errors
                                };
                                return $0(ub((c)=>s))(e);
                            })(), [
                                v_.bind(J_.liftAff(ci(n._1)._1))((s)=>ae.pure(R("Just", X("OnUserImport", ov("OnCreateUserResult", s)))))
                            ]);
                            l();
                        }
                        return E(e, []);
                    }
                    l();
                }
                if (_.tag === "OnCreateUserResult") {
                    if (_._1.tag === "Left") return E($0(ub((t)=>py({
                            processed: t.processed,
                            current: px(_._1._1)(t.current),
                            unprocessed: t.unprocessed,
                            errors: t.errors
                        })))(e), [
                        ae.pure(R("Just", X("OnUserImport", rv)))
                    ]);
                    if (_._1.tag === "Right") return E($0(ub((t)=>py({
                            processed: t.processed,
                            current: fx(t.current),
                            unprocessed: t.unprocessed,
                            errors: t.errors
                        })))(e), [
                        ae.pure(R("Just", X("OnUserImport", rv)))
                    ]);
                    l();
                }
                l();
            };
    var JB = m_({
        reflectSymbol: ()=>"auth"
    })()()(q)(f0), VB = Ee(ir(je)), qB = (()=>lt.traverse(ae)(_a))(), yx = Sr(je), Dx = HS(yx), WB = (()=>JS()({
            variantTags: (e)=>Y("Cons", "authError", Y("Cons", "dbError", Y("Cons", "uncaughtError", y_)))
        })({
            variantShows: (e)=>Y("Cons", cR.show, Y("Cons", Hs.show, Y("Cons", ep, y_)))
        }).show)(), fy = m_({
        reflectSymbol: ()=>"auth"
    })()()(q)(O_), my = Ee(An), HB = m_({
        reflectSymbol: ()=>"subscriptions"
    })()()(q)(O_), jB = fi(Bo), KB = jS(yx), QB = m_({
        reflectSymbol: ()=>"timer"
    })()()(q)(O_), YB = m_({
        reflectSymbol: ()=>"user"
    })()()(q)(O_), XB = (e)=>{
        let _ = JB(VB((r)=>R("Just", r)))(e);
        if (_.tag === "Nothing") return ue.noop_;
        if (_.tag === "Just") return v_.bind(qB(te(ar.unsubscribe)(_._1.subscriptions)))(()=>v_.bind((()=>{
                let r = ae.pure(), t = Dx((n)=>R("Just", n))(e);
                return t.tag === "Just" ? J_.liftAff(he(ai(t._1))) : r;
            })())(()=>ue.noop_));
        l();
    }, wx = (e)=>(_)=>{
            if (e.tag === "Nothing") return _.tag === "LoginRoute" ? D : _.tag === "LogoutRoute" ? D : _.tag === "ForgotPasswordRoute" ? D : _.tag === "ResetPasswordRoute" ? D : R("Just", Et);
            if (e.tag === "Just") return _.tag === "LoginRoute" ? R("Just", Cc) : _.tag === "ForgotPasswordRoute" ? R("Just", Cc) : _.tag === "ResetPasswordRoute" ? R("Just", Cc) : D;
            l();
        };
    var bb = (e)=>(_)=>(r)=>{
                let t = wx(r)(_), n = t.tag === "Just" ? v_.bind(Cn.goto(t._1))(ue.emit(Fn)) : ue.noop_, s = {
                    route: (()=>{
                        if (t.tag === "Nothing") return _;
                        if (t.tag === "Just") return t._1;
                        l();
                    })(),
                    env: e,
                    resetPassword: ix,
                    forgotPassword: ox,
                    login: sx,
                    auth: D
                };
                if (r.tag === "Nothing") return E(s, [
                    n
                ]);
                if (r.tag === "Just") return E({
                    auth: R("Just", {
                        user: r._1,
                        allUsers: eI,
                        calendar: HI,
                        subscriptions: [],
                        timer: D,
                        userCreate: vb(D),
                        userImport: uy
                    }),
                    env: s.env,
                    forgotPassword: s.forgotPassword,
                    login: s.login,
                    resetPassword: s.resetPassword,
                    route: s.route
                }, [
                    n,
                    v_.bind(u0.subscribeAuthStateChanged)(ue.emit(Mc)),
                    v_.bind(u0.subscribeUser(r._1))(ue.emit(Mc)),
                    v_.bind(Pr.subscribeCalendar)(ue.emit(Mc)),
                    v_.bind(Pr.subscribeSlots)(ue.emit(Mc)),
                    (()=>{
                        let c = v_.bind(Pr.subscribeRemarks)(ue.emit(Mc));
                        return r._1.isAdmin ? c : ue.noop_;
                    })(),
                    (()=>{
                        let c = v_.bind(u0.subscribeAllUsersChanged)(ue.emit(Mc));
                        return r._1.isAdmin ? c : ue.noop_;
                    })(),
                    (()=>{
                        let c = v_.bind(Pr.subscribeTimer)(ue.emit(WS));
                        return r._1.isAdmin ? ue.noop_ : c;
                    })()
                ]);
                l();
            }, gb = (e)=>(_)=>{
            if (e.auth.tag === "Nothing") return E(e, []);
            if (e.auth.tag === "Just") return _(e.auth._1);
            l();
        }, Rx = (e)=>(_)=>{
            if (_.tag === "AppError") return E(e, [
                v_.bind(J_.liftAff(he(fs("[ERR] " + WB(_._1)))))(ue.noop)
            ]);
            if (_.tag === "OnPopstate") return E(e, [
                v_.bind(Bg.currentUrl)((r)=>{
                    let t = li($s._2)(r);
                    return ae.pure(R("Just", X("ChangeRoute", t.tag === "Right" ? t._1 : Ud)));
                })
            ]);
            if (_.tag === "OnClickLink") return E(e, [
                v_.bind(J_.liftAff(he(Og(_._2))))((()=>{
                    let r = v_.bind(Cn.goto(_._1))(ue.emit(Fn));
                    return (t)=>r;
                })())
            ]);
            if (_.tag === "ChangeRoute") {
                let r = wx(e.auth.tag === "Just" ? R("Just", e.auth._1.user) : D)(_._1);
                if (r.tag === "Nothing") return E({
                    route: _._1,
                    auth: e.auth,
                    env: e.env,
                    forgotPassword: e.forgotPassword,
                    login: e.login,
                    resetPassword: e.resetPassword
                }, [
                    (()=>{
                        let t = ae.pure(R("Just", eb));
                        return (()=>_._1.tag === "CalendarRoute" || _._1.tag === "UserCreateRoute" || _._1.tag === "UserEditRoute" || _._1.tag === "UserImportRoute" || _._1.tag === "UsersRoute" || _._1.tag === "NotFoundRoute" || _._1.tag === "ResetPasswordRoute" || _._1.tag === "ForgotPasswordRoute" || _._1.tag === "LoginRoute" ? !1 : _._1.tag === "LogoutRoute")() ? t : ue.noop_;
                    })()
                ]);
                if (r.tag === "Just") return E(e, [
                    v_.bind(Cn.goto(r._1))(ue.emit(Fn))
                ]);
                l();
            }
            if (_.tag === "OnSubscription") return E(fy(my(HB(D7(_._1))))(e), []);
            if (_.tag === "OnTimer") return E(jB((r)=>R("Just", _._1))(e), [
                (()=>{
                    if ((()=>{
                        let r = KB((t)=>R("Just", t))(e);
                        return r.tag === "Just" ? Kd(r._1.startBooking)(R("Just", _._1)) : !1;
                    })()) {
                        let r = Dx((t)=>R("Just", t))(e);
                        return r.tag === "Just" ? v_.bind(J_.liftAff(he(ai(r._1))))(ue.noop) : ue.noop_;
                    }
                    return ue.noop_;
                })()
            ]);
            if (_.tag === "OnTimerSubscription") return E((()=>{
                let r = R("Just", E(_._1, D));
                return fy(my(QB((t)=>r)))(e);
            })(), []);
            if (_.tag === "OnCurrentUserChanged") {
                if (_._1.tag === "Left") return E(e, [
                    ae.pure(R("Just", eb)),
                    v_.bind(J_.liftAff(he(fs("[ERR] " + ge.show(_._1._1)))))(ue.noop)
                ]);
                if (_._1.tag === "Right") return E((()=>{
                    let r = _._1._1.docData;
                    return fy(my(YB((t)=>r)))(e);
                })(), []);
                l();
            }
            if (_.tag === "OnAuthStateChanged") {
                if (_._1.tag === "Just") return E(e, []);
                if (_._1.tag === "Nothing") return E(e, [
                    ae.pure(R("Just", eb))
                ]);
                l();
            }
            if (_.tag === "OnResetPassword") return ax(e)(_._1);
            if (_.tag === "OnForgotPassword") return ex(e)(_._1);
            if (_.tag === "OnLogin") return nx((r)=>bb(e.env)(Et)(R("Just", r)))(e)(_._1);
            if (_.tag === "OnUserCreate") return gb(e)(vx(e)(_._1));
            if (_.tag === "OnUserImport") return gb(e)(hx(e)(_._1));
            if (_.tag === "OnAllUsers") return gb(e)(oI(e)(_._1));
            if (_.tag === "OnCalendar") return gb(e)(jI(e)(_._1));
            if (_.tag === "DoLogout") {
                if (e.route.tag === "CalendarRoute" || e.route.tag === "UserCreateRoute" || e.route.tag === "UserEditRoute" || e.route.tag === "UserImportRoute" || e.route.tag === "UsersRoute" || e.route.tag === "NotFoundRoute" || e.route.tag === "ResetPasswordRoute" || e.route.tag === "ForgotPasswordRoute" || e.route.tag === "LoginRoute" || e.route.tag !== "LogoutRoute") return E(e, [
                    v_.bind(Cn.goto(vi))(ue.emit(Fn))
                ]);
                let r = bb(e.env)(vi)(D);
                return E(r._1, ne(r._2)([
                    v_.bind(u0.signOutUser)(ue.noop),
                    XB(e)
                ]));
            }
            l();
        };
    function Pn(e, _, r) {
        try {
            return _(JSON.parse(r));
        } catch (t) {
            return e(t.message);
        }
    }
    var kx = (e)=>(_)=>{
            let r = e.unserialize(_);
            if (r.tag === "Right") return r._1;
            if (r.tag === "Left") return Ie(Se(r._1));
            l();
        };
    var fb = (e)=>{
        let _ = So(e)().decodeJson;
        return ()=>({
                unserialize: (r)=>fe.bimap(A7)(re)(F_.bind(fe.bimap((t)=>H("TypeMismatch", "JSON"))(re)(Pn(Ao, I_, r)))((t)=>_(t)))
            });
    };
    var Ix = (e)=>({
            tag: e
        }), xx = Ix("Window");
    var Ex = Ix("Custom");
    var mb = (e)=>(_)=>(r)=>E(Ex, E(_, E((t)=>r(kx(e)(t)), void 0)));
    var Gt = Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", Q_((_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), I_, (_)=>S("Left", H("TypeMismatch", "String")), (_)=>S("Left", H("TypeMismatch", "String")), e._1)) : D
    }), Gx = Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", Q_((_)=>S("Left", H("TypeMismatch", "Boolean")), I_, (_)=>S("Left", H("TypeMismatch", "Boolean")), (_)=>S("Left", H("TypeMismatch", "Boolean")), (_)=>S("Left", H("TypeMismatch", "Boolean")), (_)=>S("Left", H("TypeMismatch", "Boolean")), e._1)) : D
    }), Cx = {
        reflectSymbol: ()=>"uid"
    }, Ax = {
        reflectSymbol: ()=>"email"
    }, $b = Gt(tr)({
        reflectSymbol: ()=>"id"
    })()(), hb = {
        reflectSymbol: ()=>"docData"
    }, yb = {
        reflectSymbol: ()=>"changeType"
    }, Nx = (()=>So(Re({
            decodeJsonField: (e)=>e.tag === "Just" ? R("Just", Zd.decodeJson(e._1)) : D
        })(Re((()=>{
            let e = So(Re({
                decodeJsonField: (_)=>_.tag === "Just" ? R("Just", ih.decodeJson(_._1)) : D
            })(Gt(Gx(Re({
                decodeJsonField: (_)=>_.tag === "Just" ? R("Just", Qn(_._1)) : D
            })(Re({
                decodeJsonField: (_)=>_.tag === "Just" ? R("Just", Qn(_._1)) : D
            })(Gt(Gt(Gt(Gt(Gt(tr)({
                reflectSymbol: ()=>"username"
            })()())(Cx)()())({
                reflectSymbol: ()=>"startBooking"
            })()())({
                reflectSymbol: ()=>"schoolName"
            })()())({
                reflectSymbol: ()=>"remark"
            })()())({
                reflectSymbol: ()=>"pax"
            })()())({
                reflectSymbol: ()=>"maxSlots"
            })()())({
                reflectSymbol: ()=>"isAdmin"
            })()())(Ax)()())({
                reflectSymbol: ()=>"bookingPermission"
            })()())();
            return {
                decodeJsonField: (_)=>_.tag === "Just" ? R("Just", e.decodeJson(_._1)) : D
            };
        })())($b)(hb)()())(yb)()())().decodeJson)(), eJ = (()=>So(Re({
            decodeJsonField: (e)=>e.tag === "Just" ? R("Just", Zd.decodeJson(e._1)) : D
        })(Re({
            decodeJsonField: (e)=>e.tag === "Just" ? R("Just", t8(e._1)) : D
        })($b)(hb)()())(yb)()())().decodeJson)(), oJ = (()=>So(Re({
            decodeJsonField: (e)=>e.tag === "Just" ? R("Just", Zd.decodeJson(e._1)) : D
        })(Re((()=>{
            let e = So(Gt(tr)({
                reflectSymbol: ()=>"title"
            })()())();
            return {
                decodeJsonField: (_)=>_.tag === "Just" ? R("Just", e.decodeJson(_._1)) : D
            };
        })())($b)(hb)()())(yb)()())().decodeJson)(), rJ = (()=>So(Re({
            decodeJsonField: (e)=>e.tag === "Just" ? R("Just", Zd.decodeJson(e._1)) : D
        })(Re((()=>{
            let e = So(Re({
                decodeJsonField: (_)=>_.tag === "Just" ? R("Just", za.decodeJson(_._1)) : D
            })(tr)({
                reflectSymbol: ()=>"bookingPhase"
            })()())();
            return {
                decodeJsonField: (_)=>_.tag === "Just" ? R("Just", e.decodeJson(_._1)) : D
            };
        })())($b)(hb)()())(yb)()())().decodeJson)(), tv = mb(fb(Re({
        decodeJsonField: (e)=>e.tag === "Just" ? R("Just", S("Right", e._1)) : D
    })(tr)({
        reflectSymbol: ()=>"docSnapshot"
    })()())()), tJ = (e)=>X("OnCurrentUserChanged", Nx(e.docSnapshot)), nJ = (e)=>X("OnTimer", e.now), sJ = (e)=>X("OnCalendar", K_("OnSlotSync", eJ(e.docSnapshot))), cJ = (e)=>X("OnCalendar", K_("OnRemarkSync", oJ(e.docSnapshot))), aJ = (e)=>X("OnCalendar", K_("OnCalendarSync", rJ(e.docSnapshot))), iJ = (e)=>X("OnAuthStateChanged", e.firebaseUser), lJ = (e)=>X("OnAllUsers", Ds("OnUserChanged", Nx(e.docSnapshot))), Fx = [
        E(xx, E("popstate", E((e)=>VS, void 0))),
        mb(fb(Re(e9(So(Gt(Gt(Gx(Gt(tr)(Cx)()())({
            reflectSymbol: ()=>"emailVerified"
        })()())(Ax)()())({
            reflectSymbol: ()=>"displayName"
        })()())()))(tr)({
            reflectSymbol: ()=>"firebaseUser"
        })()())())("AuthStateChanged")(iJ),
        tv("OnRemarks")(cJ),
        tv("OnSlots")(sJ),
        tv("OnWeeks")(aJ),
        tv("OnAllUsers")(lJ),
        tv("OnUser")(tJ),
        mb(fb(Gt(tr)({
            reflectSymbol: ()=>"now"
        })()())())("OnTimer")(nJ)
    ];
    var vJ = 5, uJ = 6;
    function ze(e) {
        return function(_) {
            return [
                vJ,
                e,
                _
            ];
        };
    }
    function nv(e) {
        return function(_) {
            return [
                uJ,
                e,
                _
            ];
        };
    }
    function Mx(e) {
        return e.target.contentEditable === !0 || e.target.contentEditable === "true" || e.target.contentEditable === "" ? e.target.innerText : e.target.value;
    }
    function Px(e) {
        e.preventDefault();
    }
    var gJ = Nc(Px), bJ = Nc(Mx);
    var Lr = (e)=>nv("input")((_)=>{
            let r = bJ(_);
            return ()=>{
                let t = r();
                return R("Just", e(t));
            };
        });
    var Lx = (e)=>nv("submit")((_)=>{
            let r = gJ(_);
            return ()=>(r(), R("Just", e));
        });
    var O = jg(Wg);
    var pJ = (e)=>N("button")($([
            O("rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500"),
            ze("click")(e)
        ])(h))($([
            M("save")
        ])(h)), Si = (e)=>N("div")($([
            O("absolute top-0 right-0 w-8 h-8 text-red-500 opacity-0 hover:opacity-100 hover:underline"),
            ze("click")(X("OnCalendar", e))
        ])(h))($([
            M("[X]")
        ])(h)), $y = (e)=>N("button")($([
            O("text-xs ml-4"),
            ze("click")(e)
        ])(h))($([
            M("cancel")
        ])(h)), sv = (e)=>N("div")($([
            O("my-1")
        ])(h))($([
            pJ(X("OnCalendar", e.saveMsg)),
            $y(X("OnCalendar", e.cancelMsg))
        ])(h)), zx = (e)=>N("button")($([
            O("rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500"),
            ze("click")(e)
        ])(h))($([
            M("book")
        ])(h));
    var fJ = (e)=>N("td")($([
            O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2")
        ])(h))($([
            Kt("input")($([
                g0("text"),
                Lr((_)=>X("OnCalendar", K_("OnRemarkEditTitle", _))),
                O("block w-full text-sm leading-6 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600"),
                Do(e.remark.title)
            ])(h)),
            sv({
                saveMsg: yI,
                cancelMsg: hI
            })
        ])(h)), mJ = (e)=>N("td")($([
            O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 cursor-pointer"),
            ze("click")(X("OnCalendar", K_("OnRemarkEdit", e)))
        ])(h))($([
            M("")
        ])(h)), $J = (e)=>(_)=>N("td")($([
                O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 cursor-pointer"),
                ze("click")(X("OnCalendar", K_("OnRemarkEdit", e)))
            ])(h))($([
                M(_),
                Si(K_("OnRemarkDelete", e))
            ])(h)), yy = (e)=>(_)=>(r)=>{
                let t = ()=>{
                    let n = vt(Eo)(e)(r);
                    if (n.tag === "Nothing") return mJ(e);
                    if (n.tag === "Just") return $J(e)(n._1.title);
                    l();
                };
                return _.tag === "Just" && wr.eq(_._1.date)(e) ? fJ(_._1) : t();
            };
    var Yt = (e)=>{
        if (e.tag === "Holiday") return O("bg-green-500");
        if (e.tag === "Resource") {
            if (e._1.booking.tag === "Booked") return O("bg-gray-700 text-white/70");
            if (e._1.booking.tag === "PD") return O("bg-gray-300");
            if (e._1.booking.tag === "HQ") return O("bg-yellow-100");
            if (e._1.booking.tag === "Available") return e._1.camp.tag === "InSourceCamp" ? O("bg-orange-200") : O("bg-blue-200");
            l();
        }
        l();
    };
    var Ii = (e)=>{
        if (e.tag === "Nothing") return M("");
        if (e.tag === "Just") return N("div")($([
            O("text-red-500")
        ])(h))($([
            M(e._1)
        ])(h));
        l();
    };
    var yJ = (()=>Hn(Ro.foldr))(), DJ = Sr(je), wJ = Ee(ir(je));
    var Ss = (e)=>{
        let _ = Do(dt(Z6(e)));
        if (e.tag === "Camp4D3N") return N("option")($([
            _
        ])(h))($([
            M("4D3N Camp")
        ])(h));
        if (e.tag === "Camp3D2N") return N("option")($([
            _
        ])(h))($([
            M("3D2N Camp")
        ])(h));
        if (e.tag === "Camp1D") return N("option")($([
            _
        ])(h))($([
            M("1D Camp")
        ])(h));
        if (e.tag === "InSource4D3N") return N("option")($([
            _
        ])(h))($([
            M("4D3N In-source")
        ])(h));
        if (e.tag === "InSource3D2N") return N("option")($([
            _
        ])(h))($([
            M("3D2N In-source")
        ])(h));
        if (e.tag === "AsHoliday") return N("option")($([
            _
        ])(h))($([
            M("Holiday")
        ])(h));
        if (e.tag === "AsPD") return N("option")($([
            _
        ])(h))($([
            M("PD")
        ])(h));
        if (e.tag === "AsHQ") return N("option")($([
            _
        ])(h))($([
            M("HQ")
        ])(h));
        l();
    }, RJ = N("select")($([
        Lr((e)=>{
            let _ = F_.bind(Pn(Ao, I_, e))((r)=>fe.bimap(ge.show)(re)(_8(r)));
            if (_.tag === "Left") return X("OnCalendar", wI);
            if (_.tag === "Right") return X("OnCalendar", K_("OnSlotCreateSubmit", _._1));
            l();
        })
    ])(h))($([
        N("option")($([
            Do("")
        ])(h))($([
            M("-- select --")
        ])(h)),
        Ss(a$),
        Ss(i$),
        Ss(l$),
        Ss(d$),
        Ss(v$),
        Ss(u$),
        Ss(g$),
        Ss(b$),
        N("option")($([
            Do("")
        ])(h))($([
            M("-- cancel --")
        ])(h))
    ])(h)), kJ = (e)=>(_)=>(r)=>N("td")($([
                    Yt(De("Resource", r)),
                    O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 cursor-pointer"),
                    Te("rowspan")(__(r.days.length)),
                    ze("click")(X("OnCalendar", K_("OnSlotEdit", Dr(_, De("Resource", r)))))
                ])(h))($((()=>{
                    if (r.booking.tag === "Booked") {
                        let t = r.booking._1.username;
                        return [
                            M(r.title),
                            Ue,
                            M((()=>{
                                if (r.booking._1.camp.tag === "InSourceCamp") return "MOE OAE-run Camp";
                                if (r.booking._1.camp.tag === "VendorRunCamp") return "Vendor-run Camp";
                                if (r.booking._1.camp.tag === "SelfRunCamp") return "Self-run Camp";
                                if (r.booking._1.camp.tag === "AwaitUserCamp") return "AwaitUserCamp";
                                l();
                            })()),
                            Ue,
                            M((()=>{
                                let n = Uv(Ro)((s)=>s.username === t)(e);
                                return n.tag === "Just" ? n._1.schoolName : "ERROR";
                            })()),
                            Si(K_("OnSlotDelete", Dr(_, De("Resource", r))))
                        ];
                    }
                    return [
                        M(r.title),
                        Si(K_("OnSlotDelete", Dr(_, De("Resource", r))))
                    ];
                })())(h)), SJ = (e)=>(_)=>N("td")($([
                O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 cursor-pointer"),
                Yt(De("Holiday", _)),
                Te("colspan")("6"),
                ze("click")(X("OnCalendar", K_("OnSlotEdit", Dr(e, De("Holiday", _)))))
            ])(h))($([
                M(_.title),
                Si(K_("OnSlotDelete", Dr(e, De("Holiday", _))))
            ])(h)), Ux = (e)=>(_)=>(r)=>{
                if (r._2.tag === "Holiday") return _ ? SJ(r._1)(r._2._1) : M("");
                if (r._2.tag === "Resource") return kJ(e)(r._1)(r._2._1);
                l();
            }, IJ = (e)=>(_)=>(r)=>e ? N("td")($([
                    O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2"),
                    Yt(De("Holiday", r)),
                    Te("colspan")("6")
                ])(h))($([
                    N("div")($([
                        O("flex flex-col py-2")
                    ])(h))($([
                        Ii(_),
                        Kt("input")($([
                            g0("text"),
                            Lr((t)=>X("OnCalendar", K_("OnSlotEditTitle", t))),
                            O("block mx-4 text-sm leading-4 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600"),
                            Do(r.title)
                        ])(h)),
                        sv({
                            saveMsg: ey,
                            cancelMsg: _y
                        })
                    ])(h))
                ])(h)) : M(""), xJ = (e)=>(_)=>(r)=>{
                let t = ()=>N("td")($([
                        O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 bg-white cursor-pointer"),
                        ze("click")(X("OnCalendar", K_("OnSlotCreate", e, _)))
                    ])(h))($([
                        M("")
                    ])(h));
                return r.tag === "Just" && (()=>r._1.location.tag === "CCOALC" ? e.tag === "CCOALC" : r._1.location.tag === "DFOALC" ? e.tag === "DFOALC" : r._1.location.tag === "JBOALC" ? e.tag === "JBOALC" : r._1.location.tag === "LOALC" ? e.tag === "LOALC" : r._1.location.tag === "CCOALC2" ? e.tag === "CCOALC2" : r._1.location.tag === "DFOALC2" ? e.tag === "DFOALC2" : !1)() && wr.eq(r._1.date)(_) ? N("td")($([
                    O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 bg-white cursor-pointer")
                ])(h))($([
                    Ii(r._1.error),
                    RJ
                ])(h)) : t();
            }, Bx = (e)=>(_)=>N("select")($([
                Lr((r)=>r === "" ? X("OnCalendar", Zh) : X("OnCalendar", K_("OnSlotEditBookingUsername", r))),
                O("text-black")
            ])(h))($(yJ(Y("Cons", N("option")($([
                Do("")
            ])(h))($([
                M("-- select user --")
            ])(h)), br((r)=>r.isAdmin ? M("") : N("option")($([
                    Do(r.username),
                    hs((()=>{
                        if (e.tag === "Nothing") return !1;
                        if (e.tag === "Just") return r.username === e._1;
                        l();
                    })())
                ])(h))($([
                    M(r.schoolName)
                ])(h)))(_))))(h)), Jx = (e)=>N("select")($([
            Lr((_)=>{
                let r = F_.bind(Pn(Ao, I_, _))((t)=>fe.bimap(ge.show)(re)(Za(t)));
                if (r.tag === "Left") return X("OnCalendar", Zh);
                if (r.tag === "Right") return X("OnCalendar", K_("OnSlotEditBookingCamp", r._1));
                l();
            }),
            O("text-black")
        ])(h))($([
            N("option")($([
                Do("")
            ])(h))($([
                M("Available")
            ])(h)),
            N("option")($([
                Do(dt(yc(fd))),
                hs((()=>{
                    if (e.tag === "Nothing") return !1;
                    if (e.tag === "Just") return e._1.tag === "VendorRunCamp";
                    l();
                })())
            ])(h))($([
                M("Vendor-run Camp")
            ])(h)),
            N("option")($([
                Do(dt(yc(md))),
                hs((()=>{
                    if (e.tag === "Nothing") return !1;
                    if (e.tag === "Just") return e._1.tag === "SelfRunCamp";
                    l();
                })())
            ])(h))($([
                M("Self-run Camp")
            ])(h))
        ])(h)), EJ = (e)=>(_)=>(r)=>{
                if (e.booking.tag === "PD") return M("");
                if (e.booking.tag === "HQ") return M("");
                if (e.camp.tag === "InSourceCamp") return Bx(r.bookingUsername)(_);
                if (r.bookingCamp.tag === "Nothing") return kr("div")($([
                    Jx(D)
                ])(h));
                if (r.bookingCamp.tag === "Just") return kr("div")($([
                    Jx(R("Just", r.bookingCamp._1)),
                    Bx(r.bookingUsername)(_)
                ])(h));
                l();
            }, TJ = (e)=>(_)=>(r)=>N("td")($([
                    O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2"),
                    Yt(De("Resource", r)),
                    Te("rowspan")(__(r.days.length))
                ])(h))($([
                    N("div")($([
                        O("flex flex-col py-2")
                    ])(h))($([
                        Ii(_.error),
                        N("textarea")($([
                            Lr((t)=>X("OnCalendar", K_("OnSlotEditTitle", t))),
                            O("block mx-4 text-sm leading-4 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600")
                        ])(h))($([
                            M(r.title)
                        ])(h)),
                        EJ(r)(e)(_),
                        sv({
                            saveMsg: ey,
                            cancelMsg: _y
                        })
                    ])(h))
                ])(h)), GJ = (e)=>(_)=>(r)=>{
                if (r.slot.tag === "Holiday") return IJ(e)(r.error)(r.slot._1);
                if (r.slot.tag === "Resource") return TJ(_)(r)(r.slot._1);
                l();
            }, Vx = (e)=>{
        let _ = Qd(e.location)(e.date)(DJ)(wJ((r)=>R("Just", r)))(e.slotTable);
        if (_.tag === "Nothing") return xJ(e.location)(e.date)(e.slotCreateForm);
        if (_.tag === "Just") return wr.eq(It(_._1._2))(e.date) ? e.slotEditForm.tag === "Just" && e.slotEditForm._1.id === _._1._1 ? GJ(e.shouldRenderHoliday)(e.userList)(e.slotEditForm._1) : Ux(e.userList)(e.shouldRenderHoliday)(_._1) : M("");
        l();
    };
    var AJ = Sr(je), NJ = Ee(ir(je));
    var FJ = (e)=>(_)=>(r)=>(t)=>(n)=>{
                        let s = ()=>N("td")($([
                                O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 bg-purple-700 text-white/70"),
                                Te("rowspan")(__(n.days.length))
                            ])(h))($([
                                M(n.title),
                                Ue,
                                M((()=>{
                                    if (r.tag === "InSourceCamp") return "MOE OAE-run Camp";
                                    if (r.tag === "VendorRunCamp") return "Vendor-run Camp";
                                    if (r.tag === "SelfRunCamp") return "Self-run Camp";
                                    if (r.tag === "AwaitUserCamp") return "AwaitUserCamp";
                                    l();
                                })()),
                                Ue,
                                M("Booked By You"),
                                Ue,
                                e.tag === "Phase1" || e.tag === "Phase2" || e.tag === "Phase3" ? N("div")($([
                                    O("cursor-pointer hover:text-red-500"),
                                    ze("click")(X("OnCalendar", K_("OnUserCancelSlot", t)))
                                ])(h))($([
                                    M("[cancel]")
                                ])(h)) : M("")
                            ])(h));
                        return _.tag === "Just" && _._1.id === t && !_._1.confirm ? N("td")($([
                            O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 bg-purple-700 text-white/70"),
                            Te("rowspan")(__(n.days.length))
                        ])(h))($(ne([
                            M(n.title),
                            Ue
                        ])(_._1.isSubmitting ? [
                            M("Canceling your booking...")
                        ] : [
                            M("Are you sure you want to cancel this booking?"),
                            Ue,
                            N("div")($([
                                O("flex justify-around mt-2")
                            ])(h))($([
                                N("div")($([
                                    O("cursor-pointer hover:text-red-500"),
                                    ze("click")(X("OnCalendar", CI))
                                ])(h))($([
                                    M("[ Yes ]")
                                ])(h)),
                                N("div")($([
                                    O("cursor-pointer hover:text-red-500"),
                                    ze("click")(X("OnCalendar", GI))
                                ])(h))($([
                                    M("[ No ]")
                                ])(h))
                            ])(h))
                        ]))(h)) : s();
                    }, MJ = (e)=>e.camp.tag === "InSourceCamp" ? [
            M(e.title),
            Ue,
            M("MOE OAE-run Camp")
        ] : [
            M(e.title)
        ], PJ = (e)=>N("td")($([
            O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2"),
            Yt(De("Holiday", e)),
            Te("colspan")("6")
        ])(h))($([
            M(e.title)
        ])(h)), LJ = (e)=>N("td")($([
            O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 bg-gray-700 text-white/20"),
            Te("rowspan")(__(e.days.length))
        ])(h))($([
            M("")
        ])(h)), zJ = (e)=>N("td")($([
            O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 bg-yellow-100"),
            Te("rowspan")(__(e.days.length))
        ])(h))($([
            M(e.title)
        ])(h)), OJ = (e)=>(_)=>(r)=>(t)=>(n)=>(s)=>(c)=>t === n.username ? FJ(e)(_)(r)(s)(c) : N("td")($([
                                    O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 text-white/20"),
                                    Yt(De("Resource", c)),
                                    Te("rowspan")(__(c.days.length))
                                ])(h))($([
                                    M(c.title),
                                    Ue,
                                    M("Taken")
                                ])(h)), UJ = (e)=>N("select")($([
            Lr((_)=>{
                let r = F_.bind(Pn(Ao, I_, _))((t)=>fe.bimap(ge.show)(re)(Za(t)));
                if (r.tag === "Left") return X("OnCalendar", ry);
                if (r.tag === "Right") return X("OnCalendar", K_("OnUserBookSlotCamp", r._1));
                l();
            }),
            b0(e.isSubmitting)
        ])(h))($([
            N("option")($([
                Do("")
            ])(h))($([
                M("-- select camp --")
            ])(h)),
            N("option")($([
                Do(dt(yc(fd)))
            ])(h))($([
                M("Vendor-run Camp")
            ])(h)),
            N("option")($([
                Do(dt(yc(md))),
                b0(e.vendorRunCampOnly)
            ])(h))($([
                M("Self-run Camp")
            ])(h))
        ])(h)), BJ = (e)=>(_)=>(r)=>N("td")($([
                    O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 cursor-pointer"),
                    Yt(De("Resource", r)),
                    Te("rowspan")(__(r.days.length))
                ])(h))($([
                    N("div")($([
                        O("flex flex-col py-2")
                    ])(h))($([
                        Ii(_.error),
                        M("Click Book to confirm booking."),
                        N("div")($([
                            O("my-2 text-sm")
                        ])(h))($([
                            M(r.title)
                        ])(h)),
                        r.camp.tag === "InSourceCamp" ? M("") : UJ({
                            vendorRunCampOnly: e,
                            isSubmitting: _.isSubmitting
                        }),
                        _.isSubmitting ? N("div")($([
                            O("flex justify-center mt-2")
                        ])(h))($([
                            M("Booking slot...")
                        ])(h)) : N("div")($([
                            O("flex justify-center mt-2")
                        ])(h))($([
                            zx(X("OnCalendar", EI)),
                            $y(X("OnCalendar", ry))
                        ])(h))
                    ])(h))
                ])(h)), JJ = (e)=>(_)=>(r)=>(t)=>{
                    let n = (c)=>{
                        let i = ()=>N("td")($([
                                Yt(De("Resource", t)),
                                O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 cursor-pointer"),
                                Te("rowspan")(__(t.days.length)),
                                ze("click")(X("OnCalendar", K_("OnUserBookSlotStart", r, t)))
                            ])(h))($(MJ(t))(h));
                        return e.tag === "Just" && e._1.id === r ? BJ(c)(e._1)(t) : i();
                    }, s = zS(t)(_);
                    if (s.tag === "CannotBook") return N("td")($([
                        O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 bg-gray-700 text-white/20"),
                        Te("rowspan")(__(t.days.length))
                    ])(h))($([
                        M(t.title)
                    ])(h));
                    if (s.tag === "CanBookAfterStartTime") return N("td")($([
                        Yt(De("Resource", t)),
                        O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 opacity-30"),
                        Te("rowspan")(__(t.days.length))
                    ])(h))($([
                        M(t.title)
                    ])(h));
                    if (s.tag === "CanBookVendorRunOnly") return n(!0);
                    if (s.tag === "CanBook") return n(!1);
                    l();
                }, VJ = (e)=>(_)=>(r)=>{
                if (r.tag === "Holiday") return e.shouldRenderHoliday ? PJ(r._1) : M("");
                if (r.tag === "Resource") {
                    if (r._1.booking.tag === "PD") return LJ(r._1);
                    if (r._1.booking.tag === "HQ") return zJ(r._1);
                    if (r._1.booking.tag === "Booked") return OJ(e.rules.bookingPhase)(e.cancelSlotForm)(r._1.booking._1.camp)(r._1.booking._1.username)(e.user)(_)(r._1);
                    if (r._1.booking.tag === "Available") return JJ(e.bookSlotForm)(e.rules)(_)(r._1);
                    l();
                }
                l();
            }, qx = (e)=>{
        let _ = Qd(e.location)(e.date)(AJ)(NJ((r)=>R("Just", r)))(e.slotTable);
        if (_.tag === "Nothing") return N("td")($([
            O("border border-gray-500 text-center text-sm leading-4 relative hover:border-blue-500 hover:border-2 bg-white")
        ])(h))($([
            M("")
        ])(h));
        if (_.tag === "Just") return wr.eq(It(_._1._2))(e.date) ? VJ(e)(_._1._1)(_._1._2) : M("");
        l();
    };
    var Wx = (e)=>e ? N("td")($([
            O("bg-gray-900"),
            Te("colspan")("7")
        ])(h))($([
            M("")
        ])(h)) : M(""), $t = (e)=>(_)=>(r)=>(t)=>(n)=>(s)=>(c)=>{
                                let i = n.tag === "CCOALC";
                                return r.weekNum === 1 && (()=>t._2.tag === "January" || t._2.tag === "February" || t._2.tag === "March" || t._2.tag === "April" || t._2.tag === "May" || t._2.tag === "June" || t._2.tag === "July" || t._2.tag === "August" || t._2.tag === "September" || t._2.tag === "October" || t._2.tag === "November" ? !1 : t._2.tag === "December")() || (r.weekNum === 52 || r.weekNum === 53) && t._2.tag === "January" ? Wx(i) : _.isAdmin ? Vx({
                                    date: t,
                                    location: n,
                                    shouldRenderHoliday: i,
                                    userList: s,
                                    slotTable: c.slotTable,
                                    slotCreateForm: c.slotCreateForm,
                                    slotEditForm: c.slotEditForm
                                }) : qx({
                                    date: t,
                                    location: n,
                                    rules: {
                                        bookingPhase: c.bookingPhase,
                                        bookingStatus: c.bookingStatus,
                                        bookingPermission: _.bookingPermission,
                                        startBooking: _.startBooking,
                                        currentTimeStr: e,
                                        maxSlots: _.maxSlots,
                                        pax: _.pax
                                    },
                                    user: _,
                                    shouldRenderHoliday: i,
                                    bookSlotForm: c.bookSlotForm,
                                    cancelSlotForm: c.cancelSlotForm,
                                    slotTable: c.slotTable
                                });
                            };
    var HJ = (e)=>(_)=>e.tag === "Nothing" ? _.tag === "Nothing" : e.tag === "Just" && _.tag === "Just" ? wr.eq(e._1)(_._1) : !1, jJ = fi(Sr(je)), KJ = Ee(ir(je)), Dy = (e)=>(_)=>_._3 === 1 ? N("td")($([
                O("bg-white border border-gray-500 text-center text-xs break-words"),
                Te("rowspan")(__(vc(_._1)(_._2)))
            ])(h))($([
                M(cd(_))
            ])(h)) : HJ(R("Just", _))(e.tag === "Just" ? R("Just", e._1) : D) ? N("td")($([
                O("bg-white border border-gray-500 text-center text-xs break-words"),
                Te("rowspan")(__((31 - _._3 | 0) + 1 | 0))
            ])(h))($([
                M(cd(_))
            ])(h)) : M(""), cv = (e)=>(_)=>(r)=>(t)=>(n)=>(s)=>N("tr")($([
                                O("border border-gray-500")
                            ])(h))($([
                                Dy(D)(s),
                                M(""),
                                M(""),
                                N("td")($([
                                    O("bg-white border border-gray-500 text-center text-xs break-words")
                                ])(h))($([
                                    M(N1(s))
                                ])(h)),
                                N("td")($([
                                    O("bg-white border border-gray-500 text-center text-xs break-words")
                                ])(h))($([
                                    M(Qa(s))
                                ])(h)),
                                $t(e)(r)(_)(s)(bc)(t)(n),
                                $t(e)(r)(_)(s)($c)(t)(n),
                                $t(e)(r)(_)(s)(pc)(t)(n),
                                $t(e)(r)(_)(s)(hc)(t)(n),
                                $t(e)(r)(_)(s)(fc)(t)(n),
                                $t(e)(r)(_)(s)(mc)(t)(n),
                                (()=>{
                                    let c = yy(s)(n.remarkForm)(n.remarks);
                                    return r.isAdmin ? c : M("");
                                })()
                            ])(h)), QJ = (e)=>N("tr")($([
            O("border border-gray-500")
        ])(h))($([
            Dy(D)(e),
            M(""),
            M(""),
            N("td")($([
                O("bg-white border border-gray-500 text-center text-xs break-words")
            ])(h))($([
                M(N1(e))
            ])(h)),
            N("td")($([
                O("bg-white border border-gray-500 text-center text-xs break-words")
            ])(h))($([
                M(Qa(e))
            ])(h)),
            N("td")($([
                O("bg-gray-900"),
                Te("colspan")("7")
            ])(h))($([
                M("")
            ])(h))
        ])(h)), YJ = (e)=>(_)=>(r)=>(t)=>(n)=>(s)=>(c)=>N("tr")($([
                                    O("border border-gray-500")
                                ])(h))($([
                                    Dy(r)(t),
                                    N("td")($([
                                        O("bg-white border border-gray-500 text-center text-xs break-words"),
                                        Te("rowspan")("7")
                                    ])(h))($([
                                        M(__(_.weekNum - 1 | 0))
                                    ])(h)),
                                    N("td")($([
                                        O("bg-white border border-gray-500 text-center text-xs break-words"),
                                        Te("rowspan")("7")
                                    ])(h))($([
                                        M(_.title)
                                    ])(h)),
                                    N("td")($([
                                        O("bg-white border border-gray-500 text-center text-xs break-words")
                                    ])(h))($([
                                        M(N1(t))
                                    ])(h)),
                                    N("td")($([
                                        O("bg-white border border-gray-500 text-center text-xs break-words")
                                    ])(h))($([
                                        M(Qa(t))
                                    ])(h)),
                                    $t(e)(n)(_)(t)(bc)(s)(c),
                                    $t(e)(n)(_)(t)($c)(s)(c),
                                    $t(e)(n)(_)(t)(pc)(s)(c),
                                    $t(e)(n)(_)(t)(hc)(s)(c),
                                    $t(e)(n)(_)(t)(fc)(s)(c),
                                    $t(e)(n)(_)(t)(mc)(s)(c),
                                    (()=>{
                                        let i = yy(t)(c.remarkForm)(c.remarks);
                                        return n.isAdmin ? i : M("");
                                    })()
                                ])(h)), XJ = (e)=>(_)=>(r)=>(t)=>(n)=>(s)=>{
                            let c = nb(s.weekNum)(_);
                            return c.tag === "Just" ? c._1.length === 7 ? [
                                YJ(e)(s)(R("Just", _))(c._1[0])(r)(t)(n),
                                cv(e)(s)(r)(t)(n)(c._1[1]),
                                cv(e)(s)(r)(t)(n)(c._1[2]),
                                cv(e)(s)(r)(t)(n)(c._1[3]),
                                cv(e)(s)(r)(t)(n)(c._1[4]),
                                cv(e)(s)(r)(t)(n)(c._1[5]),
                                QJ(c._1[6])
                            ] : [
                                M("ERROR")
                            ] : [
                                M("ERROR")
                            ];
                        }, Hx = (e)=>(_)=>{
            let r = jJ(KJ((n)=>R("Just", n)))(e);
            if (_.calendar.isLoading) return N("div")($([
                O("flex flex-col justify-center items-center mt-20 pb-20 text-center")
            ])(h))($([
                Kt("img")($([
                    fS("https://www.oalc-booking.com/images/loading.gif"),
                    bS("100px"),
                    mS("100px")
                ])(h)),
                Ue,
                Ue,
                M("Syncing Booking Slots ..."),
                Ue,
                M("Please wait a while for the calendar to load.")
            ])(h));
            let t = tb(e.env.workYear);
            if (t.tag === "Nothing") return M("Something went wrong.");
            if (t.tag === "Just") return N("table")($([
                O("relative border border-gray-500 min-w-full")
            ])(h))($($([
                [
                    N("tr")($([
                        O("border border-gray-500")
                    ])(h))($([
                        N("th")($([
                            O("sticky top-0 z-30 w-1 bg-black border border-gray-500 text-center text-xs text-white")
                        ])(h))($([
                            M("Month")
                        ])(h)),
                        N("th")($([
                            O("sticky top-0 z-30 w-1 bg-black border border-gray-500 text-center text-xs text-white")
                        ])(h))($([
                            M("Week")
                        ])(h)),
                        N("th")($([
                            O("sticky top-0 z-30 w-1 bg-black border border-gray-500 text-center text-xs text-white")
                        ])(h))($([
                            M("Term Week")
                        ])(h)),
                        N("th")($([
                            O("sticky top-0 z-30 w-1 bg-black border border-gray-500 text-center text-xs text-white")
                        ])(h))($([
                            M("Day")
                        ])(h)),
                        N("th")($([
                            O("sticky top-0 z-30 w-1 bg-black border border-gray-500 text-center text-xs text-white")
                        ])(h))($([
                            M("Date")
                        ])(h)),
                        N("th")($([
                            O("sticky top-0 z-30 w-1/5 bg-black border border-gray-500 font-bold text-center text-white"),
                            Te("colspan")("2")
                        ])(h))($([
                            M("CCOALC")
                        ])(h)),
                        N("th")($([
                            O("sticky top-0 z-30 w-1/5 bg-black border border-gray-500 font-bold text-center text-white"),
                            Te("colspan")("2")
                        ])(h))($([
                            M("DFOALC")
                        ])(h)),
                        N("th")($([
                            O("sticky top-0 z-30 w-1/5 bg-black border border-gray-500 font-bold text-center text-white")
                        ])(h))($([
                            M("JBOALC")
                        ])(h)),
                        N("th")($([
                            O("sticky top-0 z-30 w-1/5 bg-black border border-gray-500 font-bold text-center text-white")
                        ])(h))($([
                            M("LOALC")
                        ])(h)),
                        (()=>{
                            let n = N("td")($([
                                O("sticky top-0 z-30 w-1/5 bg-black border border-gray-500 font-bold text-center text-white")
                            ])(h))($([
                                M("Remarks")
                            ])(h));
                            return _.user.isAdmin ? n : M("");
                        })()
                    ])(h))
                ],
                $(te(XJ(r)(t._1)(_.user)(_.allUsers.userList)(_.calendar))(_.calendar.weeks))(qb)
            ])(qb))(h));
            l();
        };
    var jx = jt("data-useless")("na");
    var Kx = (e)=>[
            (()=>{
                let _ = qS(e);
                return nv("click")((r)=>{
                    let t = R("Just", _(r));
                    return ()=>t;
                });
            })(),
            Hg(zd($s._1(e)(di)))
        ], Db = (e)=>(_)=>N("a")($(ne([
                O("text-xl text-white hover:text-indigo-500")
            ])(Kx(e)))(h))([
                M(_)
            ]), Ct = (e)=>(_)=>N("a")($(ne([
                O("underline hover:text-indigo-500")
            ])(Kx(e)))(h))([
                M(_)
            ]), xi = (e)=>N("h2")($([
            O("my-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900")
        ])(h))([
            M(e)
        ]);
    var lr = jg(Wg);
    var Or = (e)=>N("h1")($([
            lr("text-3xl font-bold tracking-tight text-white")
        ])(h))([
            M(e)
        ]), _V = (e)=>N("div")($([
            lr("bg-gray-800")
        ])(h))($([
            N("div")($([
                lr("px-6")
            ])(h))($([
                N("div")($([
                    lr("border-b border-gray-700")
                ])(h))($([
                    N("div")($([
                        lr("flex items-center h-16 px-0 w-full")
                    ])(h))($([
                        N("div")($([
                            lr("text-2xl text-indigo-500")
                        ])(h))($([
                            M("OALC Booking")
                        ])(h)),
                        N("div")($([
                            lr("ml-10 flex justify-between items-baseline flex-grow")
                        ])(h))($((()=>{
                            if (e.auth.tag === "Nothing") return [];
                            if (e.auth.tag === "Just") return [
                                N("div")($([
                                    lr("flex space-x-4")
                                ])(h))($([
                                    Db(Cc)("Calendar"),
                                    (()=>{
                                        let _ = Db(Od)("Users");
                                        return e.auth._1.user.isAdmin ? _ : M("");
                                    })(),
                                    Db(vi)("Logout")
                                ])(h)),
                                N("div")($([
                                    lr("text-white")
                                ])(h))([
                                    M(e.auth._1.user.schoolName + " (" + e.auth._1.user.username + ")")
                                ])
                            ];
                            l();
                        })())(h))
                    ])(h))
                ])(h))
            ])(h))
        ])(h)), Oc = (e)=>(_)=>(r)=>N("div")($([
                    lr("min-h-full")
                ])(h))($([
                    N("div")($([
                        lr("bg-gray-800 pb-32")
                    ])(h))($([
                        _V(e),
                        N("header")($([
                            lr("py-10")
                        ])(h))($([
                            N("div")($([
                                lr("px-6")
                            ])(h))($([
                                _
                            ])(h))
                        ])(h))
                    ])(h)),
                    N("main")($([
                        lr("-mt-32")
                    ])(h))($([
                        N("div")($([
                            lr("px-6 pb-12")
                        ])(h))($([
                            N("div")($([
                                lr("min-h-[50vh] p-4 shadow rounded-lg bg-white")
                            ])(h))([
                                r
                            ])
                        ])(h))
                    ])(h)),
                    N("div")($([
                        lr("px-6 pb-6 text-right text-xs text-gray-300")
                    ])(h))($([
                        M("Build 2.0.0")
                    ])(h))
                ])(h));
    var eV = fi(Sr(je)), oV = Ee(ir(je)), rV = (e)=>(_)=>{
            let r = (()=>{
                if (_.tag === "Nothing") return e;
                if (_.tag === "Just") return _._1;
                l();
            })();
            return N("div")($([
                O("flex")
            ])(h))($([
                N("select")($([
                    O("ml-2"),
                    Lr((t)=>{
                        let n = F_.bind(Pn(Ao, I_, t))((s)=>fe.bimap(ge.show)(re)(za.decodeJson(s)));
                        if (n.tag === "Left") return X("OnCalendar", Xh);
                        if (n.tag === "Right") return X("OnCalendar", K_("OnBookingPhaseSelect", n._1));
                        l();
                    })
                ])(h))($(te((t)=>N("option")($([
                        Do(dt(La.encodeJson(t))),
                        hs((()=>t.tag === "ClosedPhase" ? r.tag === "ClosedPhase" : t.tag === "Phase1" ? r.tag === "Phase1" : t.tag === "Phase2" ? r.tag === "Phase2" : t.tag === "Phase3" ? r.tag === "Phase3" : t.tag === "OpenPhase" ? r.tag === "OpenPhase" : !1)())
                    ])(h))($([
                        M((()=>{
                            if (t.tag === "ClosedPhase") return "Closed Phase";
                            if (t.tag === "Phase1") return "Preliminary Booking Phase";
                            if (t.tag === "Phase2") return "Main Booking Phase A";
                            if (t.tag === "Phase3") return "Main Booking Phase B";
                            if (t.tag === "OpenPhase") return "Open Phase";
                            l();
                        })())
                    ])(h)))([
                    Cm,
                    Pa,
                    Am,
                    Nm,
                    Fm
                ]))(h)),
                (()=>{
                    if (_.tag === "Nothing") return M("");
                    if (_.tag === "Just") return (()=>_._1.tag === "ClosedPhase" ? e.tag === "ClosedPhase" : _._1.tag === "Phase1" ? e.tag === "Phase1" : _._1.tag === "Phase2" ? e.tag === "Phase2" : _._1.tag === "Phase3" ? e.tag === "Phase3" : _._1.tag === "OpenPhase" ? e.tag === "OpenPhase" : !1)() ? M("") : N("div")($([
                        O("ml-2")
                    ])(h))($([
                        N("button")($([
                            O("px-3 py-2 self-end rounded-md bg-indigo-600 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 bg-red-600 hover:bg-red-500"),
                            ze("click")(X("OnCalendar", K_("OnBookingPhaseConfirmed", _._1)))
                        ])(h))($([
                            M((()=>{
                                if (_._1.tag === "ClosedPhase") return "Change to Closed Phase?";
                                if (_._1.tag === "Phase1") return "Change to Preliminary Booking Phase?";
                                if (_._1.tag === "Phase2") return "Change to Main Booking Phase A?";
                                if (_._1.tag === "Phase3") return "Change to Main Booking Phase B?";
                                if (_._1.tag === "OpenPhase") return "Change to Open Phase?";
                                l();
                            })())
                        ])(h)),
                        N("button")($([
                            O("px-3 py-2 self-end rounded-md bg-indigo-600 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 ml-2"),
                            ze("click")(X("OnCalendar", Xh))
                        ])(h))($([
                            M("Cancel")
                        ])(h))
                    ])(h));
                    l();
                })()
            ])(h));
        }, tV = (e)=>(_)=>{
            let r = A3(d8)(Lm(y1(e), y1(_)) / 1e3);
            return "Available in " + Hr(" ")([
                r.days <= 0 ? "" : __(r.days) + "d",
                r.hours <= 0 ? "" : __(r.hours) + "h",
                r.minutes <= 0 ? "" : __(r.minutes) + "m",
                r.seconds <= 0 ? "" : __(r.seconds) + "s"
            ]);
        }, nV = (e)=>(_)=>{
            if (_.tag === "Nothing") return "";
            if (_.tag === "Just") {
                let r = wn(_._1);
                if (r.tag === "Just") {
                    let t = wn(e);
                    if (t.tag === "Just") return D1.compare(t._1)(r._1).tag === "GT" ? tV(t._1)(r._1) : "Available to book";
                    if (t.tag === "Nothing") return "Error in Time";
                    l();
                }
                if (r.tag === "Nothing") return "Error in Time";
                l();
            }
            l();
        }, Ry = (e)=>(_)=>(r)=>{
                let t = (()=>{
                    if (e.bookingPermission.tag === "Only4D") return _.bookingStatus.available4D3NCamp <= 0 ? "Any Camp" : "4D3N Camp";
                    if (e.bookingPermission.tag === "Only3D") return "3D2N Camp";
                    if (e.bookingPermission.tag === "BookAll") return "All Camp";
                    l();
                })();
                return _.bookingStatus.available4D3NCamp + _.bookingStatus.available3D2NCamp | 0 ? "(" + Hr(" - ")([
                    __(_.bookingStatus.userBookedCount) + "/" + __(e.maxSlots) + " bookings",
                    t,
                    nV(e.startBooking)(r)
                ]) + ")" : "(Fully Booked)";
            }, sV = (e)=>(_)=>(r)=>(t)=>Or("Calendar " + __(e) + (()=>{
                        if (r.bookingPhase.tag === "ClosedPhase") return " (Booking is closed)";
                        if (r.bookingPhase.tag === "Phase1" || r.bookingPhase.tag === "Phase2" || r.bookingPhase.tag === "Phase3") return " " + Ry(_)(r)(t);
                        if (r.bookingPhase.tag === "OpenPhase") return " (All booking available)";
                        l();
                    })()), cV = (e)=>(_)=>N("div")($([
                O("flex justify-between")
            ])(h))($([
                N("div")($([
                    O("@@@")
                ])(h))($([
                    N("div")($([
                        O("flex")
                    ])(h))($([
                        Or("Calendar " + __(e) + " "),
                        rV(_.bookingPhase)(_.bookingPhaseForm)
                    ])(h)),
                    N("div")($([
                        O("text-white")
                    ])(h))($([
                        M((()=>{
                            if (_.bookingPhase.tag === "ClosedPhase") return "No booking can be made";
                            if (_.bookingPhase.tag === "Phase1" || _.bookingPhase.tag === "Phase2") return "Booking is subjected to max slots and camp type";
                            if (_.bookingPhase.tag === "Phase3") return "Booking is subjected to max slots";
                            if (_.bookingPhase.tag === "OpenPhase") return "Users can book any slots";
                            l();
                        })())
                    ])(h)),
                    N("div")($([
                        O("flex text-white")
                    ])(h))($([
                        N("div")($([
                            O("@@@")
                        ])(h))($([
                            M("Available 4D3N Camps: " + __(_.bookingStatus.available4D3NCamp) + "/" + __(_.bookingStatus.total4D3NCamp))
                        ])(h)),
                        N("div")($([
                            O("ml-2")
                        ])(h))($([
                            M("Available 3D2N Camps: " + __(_.bookingStatus.available3D2NCamp) + "/" + __(_.bookingStatus.total3D2NCamp))
                        ])(h)),
                        N("div")($([
                            O("ml-2")
                        ])(h))($([
                            M("Available 1D Camps: " + __(_.bookingStatus.available1DCamp) + "/" + __(_.bookingStatus.total1DCamp))
                        ])(h))
                    ])(h))
                ])(h)),
                N("div")($([
                    O("flex gap-2")
                ])(h))($([
                    N("button")($([
                        O("rounded bg-green-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-green-500 h-10"),
                        ze("click")(X("OnCalendar", SI)),
                        b0(_.isExporting)
                    ])(h))($([
                        M(_.isExporting ? "---" : "Export Calendar")
                    ])(h)),
                    N("button")($([
                        O("rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 h-10"),
                        ze("click")(X("OnCalendar", II)),
                        b0(_.isExporting)
                    ])(h))($([
                        M(_.isExporting ? "---" : "Export Bookings")
                    ])(h))
                ])(h))
            ])(h)), Qx = (e)=>{
        if (e.auth.tag === "Nothing") return Or("Calendar " + __(e.env.workYear));
        if (e.auth.tag === "Just") return e.auth._1.user.isAdmin ? cV(e.env.workYear)(e.auth._1.calendar) : sV(e.env.workYear)(e.auth._1.user)(e.auth._1.calendar)(eV(oV((_)=>R("Just", _)))(e));
        l();
    };
    var iV = (()=>{
        let e = {
            append: (r)=>(t)=>r && t
        }, _ = E7({
            mempty: !0,
            Semigroup0: ()=>e
        });
        return (r)=>_((t)=>r);
    })(), ky = {
        inputType: "text",
        placeholder: "",
        disabled: !1,
        validators: []
    }, av = {
        inputType: "text",
        placeholder: "",
        disabled: !1,
        validators: [
            dy
        ]
    };
    var Is = ()=>(e)=>(_)=>{
                let r = _.tag === "Submitting";
                return N("button")($([
                    O("flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:bg-gray-300"),
                    g0("submit"),
                    b0(!iV((t)=>t.status.tag === "Pristine" || t.status.tag === "Invalid" ? !1 : t.status.tag === "Valid")(e) || r)
                ])(h))($([
                    M(r ? "Submitting" : "Submit")
                ])(h));
            }, wb = (e)=>(_)=>(r)=>()=>(t)=>(n)=>(s)=>{
                                let c = r.reflectSymbol(t), i = Vo(r.reflectSymbol(t))(n);
                                return kr("div")($([
                                    N("label")($([
                                        Wd(c),
                                        O("block text-sm font-medium leading-6 text-gray-900")
                                    ])(h))([
                                        M(_)
                                    ]),
                                    N("div")($([
                                        O("mt-2")
                                    ])(h))([
                                        N("select")($([
                                            Ah(c),
                                            Lr((d)=>e(Ur(r.reflectSymbol(t))({
                                                    value: d,
                                                    status: ly(s.validators)(d)
                                                })(n))),
                                            O("block w-full text-sm leading-6 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600"),
                                            Do(i.value),
                                            Fc(c)
                                        ])(h))($(te((d)=>N("option")($([
                                                Do(d.value),
                                                hs(d.value === i.value)
                                            ])(h))($([
                                                M(d.label)
                                            ])(h)))(s.options))(h))
                                    ]),
                                    i.status.tag === "Invalid" ? N("span")($([
                                        O("text-red-700 text-sm")
                                    ])(h))([
                                        M(i.status._1)
                                    ]) : M("")
                                ])(h));
                            };
    var Yx = {
        validators: [
            dy
        ],
        options: []
    }, Sy = {
        inputType: "number",
        placeholder: "",
        disabled: !1,
        validators: [
            QI
        ]
    };
    var Rb = {
        inputType: "password",
        placeholder: "",
        disabled: !1,
        validators: [
            YI
        ]
    }, xr = (e)=>(_)=>(r)=>()=>(t)=>(n)=>(s)=>{
                                let c = r.reflectSymbol(t), i = Vo(r.reflectSymbol(t))(n);
                                return kr("div")($([
                                    N("label")($([
                                        Wd(c),
                                        O("block text-sm font-medium leading-6 text-gray-900")
                                    ])(h))([
                                        M(_)
                                    ]),
                                    N("div")($([
                                        O("mt-2")
                                    ])(h))([
                                        Kt("input")($([
                                            g0(s.inputType),
                                            Ah(c),
                                            Lr((d)=>e(Ur(r.reflectSymbol(t))({
                                                    value: d,
                                                    status: ly(s.validators)(d)
                                                })(n))),
                                            O("block w-full text-sm leading-6 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600"),
                                            Do(i.value),
                                            b0(s.disabled),
                                            Fc(c)
                                        ])(h))
                                    ]),
                                    i.status.tag === "Invalid" ? N("span")($([
                                        O("text-red-700 text-sm")
                                    ])(h))([
                                        M(i.status._1)
                                    ]) : M("")
                                ])(h));
                            }, Ei = (e)=>(_)=>e.tag === "Submitted" ? N("div")($([
                O("p-4 rounded-md bg-green-50 text-green-700 text-sm")
            ])(h))($([
                M(_)
            ])(h)) : M("");
    var Xx = (e)=>(_)=>e.tag === "FormError" ? N("div")($([
                O("p-4 rounded-md bg-red-50 text-red-700 text-sm")
            ])(h))($([
                M(_)
            ])(h)) : M(""), xs = (e)=>(_)=>N("form")($([
                O("space-y-6"),
                Lx(e)
            ])(h))($(_)(h)), kb = {
        inputType: "email",
        placeholder: "",
        disabled: !1,
        validators: [
            XI
        ]
    }, Ti = (e)=>(_)=>{
            if (_.tag === "Nothing") return M("");
            if (_.tag === "Just") return N("div")($([
                O("p-4 rounded-md bg-red-50 text-red-700 text-sm")
            ])(h))($([
                M(e(_._1))
            ])(h));
            l();
        };
    var lV = {
        reflectSymbol: ()=>"email"
    };
    var dV = (e)=>e.tag === "USER_NOT_FOUND" ? "User not found" : e.tag === "CANNOT_GENERATE_TOKEN" ? "Cannot generate token for reset password" : e.tag === "CANNOT_CREATE_TOKEN" ? "Cannot create token for reset password" : e.tag === "CANNOT_SEND_MAIL" ? "Cannot send forgot password email" : "Something went wrong! Please retry again!", Zx = (e)=>N("div")($([
            O("mt-10 mx-auto w-full max-w-sm")
        ])(h))($([
            xi("Forgot password"),
            xs(X("OnForgotPassword", ZI))([
                Ti(dV)(e.forgotPassword.apiError),
                Ei(e.forgotPassword.status)("The email to reset your password has been successfully sent to your inbox."),
                xr((_)=>X("OnForgotPassword", ev("OnFields", _)))("Email")(lV)()(q)(e.forgotPassword.fields)(kb),
                Is()(e.forgotPassword.fields)(e.forgotPassword.status)
            ]),
            N("div")($([
                O("mt-4")
            ])(h))([
                Ct(Et)("Back to login")
            ])
        ])(h));
    var uV = {
        reflectSymbol: ()=>"username"
    }, gV = {
        reflectSymbol: ()=>"password"
    };
    var _E = (e)=>N("div")($([
            O("mt-10 mx-auto w-full max-w-sm")
        ])(h))($([
            xi("Sign in to your account"),
            xs(X("OnLogin", rx))([
                Xx(e.login.status)("Invalid username/password. Please try again."),
                xr((_)=>X("OnLogin", Ri("OnFields", _)))("UserID")(uV)()(q)(e.login.fields)(av),
                xr((_)=>X("OnLogin", Ri("OnFields", _)))("Password")(gV)()(q)(e.login.fields)(Rb),
                Is()(e.login.fields)(e.login.status)
            ]),
            N("div")($([
                O("mt-4")
            ])(h))([
                Ct(Ih)("Forgot Password?")
            ])
        ])(h));
    var eE = N("div")($([
        O("flex flex-col items-center justify-center my-20")
    ])(h))($([
        kr("p")([
            M("You have logged out successfully.")
        ]),
        N("div")($([
            O("mt-4")
        ])(h))([
            Ct(Et)("Login again")
        ])
    ])(h));
    var oE = N("div")($([
        O("flex flex-col items-center justify-center my-20")
    ])(h))($([
        kr("p")([
            M("The page you are looking for is not available.")
        ]),
        kr("p")([
            M("Please check your url again.")
        ])
    ])(h));
    var mV = {
        reflectSymbol: ()=>"password"
    }, $V = {
        reflectSymbol: ()=>"password2"
    };
    var hV = (e)=>e.tag === "USER_NOT_FOUND" ? "User not found" : e.tag === "INVALID_PASSWORD" ? "Invalid password" : e.tag === "INVALID_TOKEN" ? "Invalid token" : e.tag === "CANNOT_UPDATE_PASSWORD" ? "Cannot update password" : "Something went wrong! Please retry again!", rE = (e)=>(_)=>N("div")($([
                O("mt-10 mx-auto w-full max-w-sm")
            ])(h))($([
                xi("Reset password"),
                xs(X("OnResetPassword", ki("OnSubmit", e)))([
                    Ti(hV)(_.resetPassword.apiError),
                    Ei(_.resetPassword.status)("Your password has been successfully reset."),
                    xr((r)=>X("OnResetPassword", ki("OnFields", r)))("New Password")(mV)()(q)(_.resetPassword.fields)(Rb),
                    xr((r)=>X("OnResetPassword", ki("OnFields", r)))("New Confirmation Password")($V)()(q)(_.resetPassword.fields)({
                        inputType: "password",
                        placeholder: "",
                        disabled: !1,
                        validators: [
                            (r)=>{
                                let t = _.resetPassword.fields.password.value === r ? io : Tt("Invalid", "Must be same value");
                                return t.tag === "Invalid" ? Tt("Invalid", "Confirmation password must matches new password") : t;
                            }
                        ]
                    }),
                    Is()(_.resetPassword.fields)(_.resetPassword.status)
                ]),
                N("div")($([
                    O("my-4")
                ])(h))([
                    Ct(Et)("Back to login")
                ])
            ])(h));
    var DV = yp(Wv()((()=>{
        let e = {
            eqRecord: (_)=>(r)=>(t)=>r.label === t.label && r.value === t.value
        };
        return {
            compareRecord: (_)=>(r)=>(t)=>{
                        let n = Ko.compare(r.label)(t.label);
                        if (n.tag === "LT" || n.tag === "GT" || n.tag !== "EQ") return n;
                        let s = Ko.compare(r.value)(t.value);
                        return s.tag === "LT" || s.tag === "GT" || s.tag !== "EQ" ? s : X_;
                    },
            EqRecord0: ()=>e
        };
    })())), wV = ob(Sr(je)), RV = m_({
        reflectSymbol: ()=>"uid"
    })()()(q)(f0), kV = Ee(ir(je)), SV = {
        reflectSymbol: ()=>"username"
    }, IV = {
        reflectSymbol: ()=>"schoolName"
    }, xV = {
        reflectSymbol: ()=>"email"
    }, EV = {
        reflectSymbol: ()=>"maxSlots"
    }, TV = {
        reflectSymbol: ()=>"pax"
    }, GV = {
        reflectSymbol: ()=>"remark"
    }, CV = {
        reflectSymbol: ()=>"startBookingDate"
    }, AV = {
        reflectSymbol: ()=>"startBookingTime"
    }, NV = {
        reflectSymbol: ()=>"isAdmin"
    }, FV = {
        reflectSymbol: ()=>"bookingPermissionStr"
    };
    var MV = (e)=>(_)=>{
            let r = e, t = _, n = !0, s;
            for(; n;){
                let c = r, i = t;
                if (c === 1440) {
                    n = !1, s = i;
                    continue;
                }
                let d = at(Jr(c / 60)), v = at(Jr(tp(c)(60))), b = d < 10 ? "0" + __(d) + (v < 10 ? ":0" + __(v) : ":" + __(v)) : __(d) + (v < 10 ? ":0" + __(v) : ":" + __(v));
                r = c + 5, t = DV({
                    value: b,
                    label: b
                })(i);
            }
            return s;
        }, Iy = (e)=>{
        let _ = wV(RV(kV((r)=>R("Just", r))))(e);
        if (_.tag === "Nothing") return Or("Create New User");
        if (_.tag === "Just") return Or("Update User");
        l();
    }, PV = [
        {
            value: "Only4D",
            label: "Only 4D3N Camp"
        },
        {
            value: "Only3D",
            label: "Only 3D2N Camp"
        },
        {
            value: "BookAll",
            label: "Any Camp"
        }
    ], LV = (e)=>e.tag === "UNAUTHORIZED" ? "Unauthorized request" : e.tag === "INVALID_MAX_SLOTS" ? "Invalid max slots" : e.tag === "INVALID_USER_NAME" ? "Invalid user name" : e.tag === "INVALID_START_BOOKING" ? "Invalid start booking date/time" : e.tag === "EMAIL_EXISTED" ? "Email existed" : e.tag === "USERNAME_EXISTED" ? "Username existed" : e.tag === "CANNOT_CREATE_AUTH" ? "Cannot create auth" : e.tag === "CANNOT_CREATE_USER" ? "Cannot create user" : e.tag === "CANNOT_GENERATE_TOKEN" ? "Cannot generate token" : e.tag === "CANNOT_CREATE_TOKEN" ? "Cannot create token" : e.tag === "CANNOT_SEND_MAIL" ? "Cannot send mail" : "Something went wrong! Please retry again!", xy = (e)=>(_)=>N("div")($([
                O("m-5 w-full max-w-sm")
            ])(h))([
                N("div")($([
                    O("m-5 w-full max-w-sm")
                ])(h))($([
                    xs(X("OnUserCreate", dx))([
                        Ti(LV)(_.userCreate.apiError),
                        Ei(_.userCreate.status)(_.userCreate.uid.tag === "Nothing" ? "Create user successfully." : "Update user successfully"),
                        xr((r)=>X("OnUserCreate", Jo("OnFields", r)))("Username *")(SV)()(q)(_.userCreate.fields)({
                            inputType: "text",
                            placeholder: "",
                            disabled: _.userCreate.uid.tag !== "Nothing",
                            validators: av.validators
                        }),
                        xr((r)=>X("OnUserCreate", Jo("OnFields", r)))("School Name *")(IV)()(q)(_.userCreate.fields)(ky),
                        xr((r)=>X("OnUserCreate", Jo("OnFields", r)))("Email *")(xV)()(q)(_.userCreate.fields)(kb),
                        xr((r)=>X("OnUserCreate", Jo("OnFields", r)))("Max slots *")(EV)()(q)(_.userCreate.fields)(Sy),
                        xr((r)=>X("OnUserCreate", Jo("OnFields", r)))("Pax *")(TV)()(q)(_.userCreate.fields)(Sy),
                        xr((r)=>X("OnUserCreate", Jo("OnFields", r)))("Remark")(GV)()(q)(_.userCreate.fields)(ky),
                        N("div")($([
                            O("flex gap-2")
                        ])(h))($([
                            xr((r)=>X("OnUserCreate", Jo("OnFields", r)))("Start booking date *")(CV)()(q)(_.userCreate.fields)({
                                inputType: "date",
                                placeholder: "",
                                disabled: !1,
                                validators: av.validators
                            }),
                            wb((r)=>X("OnUserCreate", Jo("OnFields", r)))("Start booking time *")(AV)()(q)(_.userCreate.fields)({
                                validators: Yx.validators,
                                options: MV(0)([])
                            })
                        ])(h)),
                        kr("div")($([
                            M("Booking time zone is Singapore +0800")
                        ])(h)),
                        wb((r)=>X("OnUserCreate", Jo("OnFields", r)))("Administrator *")(NV)()(q)(_.userCreate.fields)({
                            validators: [],
                            options: [
                                {
                                    value: "no",
                                    label: "No"
                                },
                                {
                                    value: "yes",
                                    label: "Yes"
                                }
                            ]
                        }),
                        wb((r)=>X("OnUserCreate", Jo("OnFields", r)))("Permission *")(FV)()(q)(_.userCreate.fields)({
                            validators: [],
                            options: PV
                        }),
                        N("div")($([
                            O("flex justify-between align-text-bottom")
                        ])(h))($([
                            N("div")($([
                                O("w-40 mr-4")
                            ])(h))($([
                                Is()(_.userCreate.fields)(_.userCreate.status)
                            ])(h)),
                            Ct(Od)("Back")
                        ])(h))
                    ])
                ])(h))
            ]);
    var iv = (e)=>"{ bookingPermission: " + Se(e.bookingPermission) + ", email: " + Se(e.email) + ", maxSlots: " + Se(e.maxSlots) + ", pax: " + Se(e.pax) + ", remark: " + Se(e.remark) + ", schoolName: " + Se(e.schoolName) + ", startBooking: " + Se(e.startBooking) + ", username: " + Se(e.username) + " }";
    var Ey = (e)=>{
        if (e.tag === "RowPending") return N("div")($([
            O("p-4 bg-yellow-100")
        ])(h))($([
            M("⏳ Pending Create"),
            Ue,
            M(iv(e._1))
        ])(h));
        if (e.tag === "RowCreating") return N("div")($([
            O("p-4 bg-yellow-100")
        ])(h))($([
            M("\uD83D\uDC83\uD83D\uDD7A Creating User..."),
            Ue,
            M(iv(e._1))
        ])(h));
        if (e.tag === "RowDecodeError") return N("div")($([
            O("p-4 bg-red-100")
        ])(h))($([
            M("❌ Data Error"),
            Ue,
            M(e._2),
            Ue,
            M(iv(e._1))
        ])(h));
        if (e.tag === "RowCreateError") return N("div")($([
            O("p-4 bg-red-100")
        ])(h))($([
            M("❌ Create Error"),
            Ue,
            M(fk.show(e._2)),
            Ue,
            M(iv(e._1))
        ])(h));
        if (e.tag === "RowCreated") return N("div")($([
            O("p-4 bg-green-100")
        ])(h))($([
            M("✅ Success"),
            Ue,
            M(iv(e._1))
        ])(h));
        l();
    }, OV = (e)=>N("div")($([
            O("p-4 bg-red-100")
        ])(h))($([
            M("❌ Error in File Row " + __(e.rowNum) + ": " + e.message)
        ])(h)), UV = (e)=>N("div")($([
            O("mt-4")
        ])(h))($([
            N("div")($([
                O("flex flex-col gap-y-2")
            ])(h))($(ne(te(OV)(e.errors))(ne(te(Ey)(e.processed))(ne([
                Ey(e.current)
            ])(te((_)=>Ey(m0("RowPending", _)))(e.unprocessed)))))(h))
        ])(h)), tE = (e)=>(_)=>N("div")($([
                O("m-5 flex flex-col")
            ])(h))($([
                kr("div")($([
                    N("label")($([
                        Wd("user-import-file-id"),
                        O("block font-medium leading-6 text-gray-900")
                    ])(h))([
                        M("Select User CSV File")
                    ]),
                    N("div")($([
                        O("mt-2")
                    ])(h))([
                        Kt("input")($([
                            g0("file"),
                            Fc("user-import-file-id"),
                            ze("change")(X("OnUserImport", ux))
                        ])(h))
                    ])
                ])(h)),
                (()=>{
                    if (_.userImport.tag === "NoImportState") return N("div")($([
                        O("mt-4")
                    ])(h))($([
                        M("You can download the sample CSV template "),
                        N("a")($([
                            Hg("https://www.oalc-booking.com/downloads/user-import.csv"),
                            O("underline hover:text-indigo-500"),
                            pS("_blank")
                        ])(h))($([
                            M("here")
                        ])(h)),
                        M("."),
                        Ue,
                        M("NOTE! Excel may auto format the 'Start Booking' column so please set the format of that column to Text.")
                    ])(h));
                    if (_.userImport.tag === "ParsingImportState") return N("div")($([
                        O("mt-4")
                    ])(h))($([
                        M("Parsing CSV... Please wait.")
                    ])(h));
                    if (_.userImport.tag === "ImportErrorState") return N("div")($([
                        O("mt-4")
                    ])(h))($([
                        M("Error: " + _.userImport._1)
                    ])(h));
                    if (_.userImport.tag === "ImportSuccessState") return UV(_.userImport._1);
                    l();
                })()
            ])(h));
    var nE = (()=>Hn(Ro.foldr))();
    var JV = (e)=>{
        if (e.tag === "Nil") return M("");
        if (e.tag === "Cons") return N("div")($([
            O("text-red-700 text-sm")
        ])(h))($(y7(Ue)(nE(br((_)=>M("Error loading user: " + Se(_)))(e))))(h));
        l();
    };
    var Ib = (e)=>(_)=>N("button")($([
                O("px-3 py-2 self-end rounded-md bg-indigo-600 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 bg-red-600 hover:bg-red-500"),
                (()=>{
                    if (_.tag === "Just") return ze("click")(_._1);
                    if (_.tag === "Nothing") return jx;
                    l();
                })()
            ])(h))($([
                M(e)
            ])(h)), VV = (e)=>(_)=>(r)=>N("tr")($([
                    O("border-b hover:bg-neutral-100")
                ])(h))($([
                    N("td")($([
                        O("px-6 py-4 whitespace-nowrap")
                    ])(h))($([
                        M(r.username)
                    ])(h)),
                    N("td")($([
                        O("px-6 py-4 whitespace-nowrap")
                    ])(h))($([
                        M("(" + r.schoolName + ")"),
                        Ue,
                        M(r.email)
                    ])(h)),
                    N("td")($([
                        O("px-6 py-4 whitespace-nowrap")
                    ])(h))($([
                        M((()=>{
                            if (r.bookingPermission.tag === "Only4D") return "Only4D";
                            if (r.bookingPermission.tag === "Only3D") return "Only3D";
                            if (r.bookingPermission.tag === "BookAll") return "BookAll";
                            l();
                        })() + " - " + __(r.maxSlots)),
                        Ue,
                        M("Pax: " + __(r.pax))
                    ])(h)),
                    N("td")($([
                        O("px-6 py-4 whitespace-nowrap")
                    ])(h))($([
                        M((()=>{
                            let t = wn(r.startBooking);
                            if (t.tag === "Just") {
                                let n = Ja(_i)(8)(t._1);
                                if (n.tag === "Just") return yn(Dn(n._1))(Y("Cons", Ka, Y("Cons", Co("Placeholder", "-"), Y("Cons", ss, Y("Cons", Co("Placeholder", "-"), Y("Cons", cs, Y("Cons", Co("Placeholder", " "), Y("Cons", G1, Y("Cons", Co("Placeholder", ":"), Y("Cons", C1, y_))))))))));
                                if (n.tag === "Nothing") return "Invalid date";
                                l();
                            }
                            if (t.tag === "Nothing") return "Invalid date";
                            l();
                        })())
                    ])(h)),
                    N("td")($([
                        O("px-6 py-4 whitespace-nowrap")
                    ])(h))($([
                        M(r.isAdmin ? "Yes" : "No")
                    ])(h)),
                    N("td")($([
                        O("px-6 py-4 whitespace-nowrap")
                    ])(h))($([
                        N("div")($([
                            O("flex gap-2")
                        ])(h))($([
                            N("button")($([
                                O("px-3 py-2 self-end rounded-md bg-indigo-600 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 bg-green-600 hover:bg-green-500"),
                                ze("click")(X("OnUserCreate", Jo("OnEditUser", r)))
                            ])(h))($([
                                M("Edit")
                            ])(h)),
                            (()=>{
                                if (r.username === e.username) return M("");
                                if ((()=>{
                                    if (_.tag === "NoSelection") return !1;
                                    if (_.tag === "Selected" || _.tag === "SelectedProcessing") return r.username === _._1;
                                    l();
                                })()) {
                                    if (_.tag === "NoSelection") return Ib("Delete")(R("Just", X("OnAllUsers", Ds("OnUserDelete", r.username))));
                                    if (_.tag === "Selected") return Ib("Confirm Delete?")(R("Just", X("OnAllUsers", Ds("OnUserDeleteConfirmed", r.username))));
                                    if (_.tag === "SelectedProcessing") return Ib("Deleting...")(D);
                                    l();
                                }
                                return Ib("Delete")(R("Just", X("OnAllUsers", Ds("OnUserDelete", r.username))));
                            })()
                        ])(h))
                    ])(h))
                ])(h)), sE = (e)=>(_)=>N("div")($([
                O("flex flex-col p-5 w-full")
            ])(h))($([
                N("div")($([
                    O("flex justify-end items-end gap-2")
                ])(h))($([
                    N("button")($([
                        O("px-3 py-2 self-end rounded-md bg-indigo-600 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 w-40"),
                        ze("click")(X("OnUserCreate", lx))
                    ])(h))($([
                        M("Create User")
                    ])(h)),
                    M(" or "),
                    Ct(Sh)("import users")
                ])(h)),
                JV(_.allUsers.errors),
                N("table")($([
                    O("mt-4 w-full table-auto text-left text-sm font-light")
                ])(h))($([
                    N("thead")($([
                        O("border-b font-medium border-neutral-500")
                    ])(h))($([
                        N("tr")($([
                            O("@@@")
                        ])(h))($([
                            N("th")($([
                                O("px-6 py-4")
                            ])(h))($([
                                M("UserID")
                            ])(h)),
                            N("th")($([
                                O("px-6 py-4")
                            ])(h))($([
                                M("School Name - Email")
                            ])(h)),
                            N("th")($([
                                O("px-6 py-4")
                            ])(h))($([
                                M("Max slots")
                            ])(h)),
                            N("th")($([
                                O("px-6 py-4")
                            ])(h))($([
                                M("Start booking")
                            ])(h)),
                            N("th")($([
                                O("px-6 py-4")
                            ])(h))($([
                                M("Admin")
                            ])(h)),
                            N("th")($([
                                O("px-6 py-4")
                            ])(h))($([
                                M("Action")
                            ])(h))
                        ])(h))
                    ])(h)),
                    N("tbody")($([
                        O("@@@")
                    ])(h))($(nE(br(VV(_.user)(_.allUsers.deleteUser))(_.allUsers.userList)))(h))
                ])(h))
            ])(h));
    var cE = (e)=>{
        let _ = Oc(e)(Or("Login"))(_E(e)), r = (t, n)=>e.auth.tag === "Just" ? Oc(e)(t)(n(e.auth._1)) : _;
        if (e.route.tag === "CalendarRoute") return r(Qx(e), Hx(e));
        if (e.route.tag === "UserCreateRoute") return r(Iy(e), xy(e));
        if (e.route.tag === "UserEditRoute") return r(Iy(e), xy(e));
        if (e.route.tag === "UserImportRoute") return r(Or("Import Users"), tE(e));
        if (e.route.tag === "UsersRoute") return r(Or("Users"), sE(e));
        if (e.route.tag === "NotFoundRoute") return Oc(e)(Or("Page Not Found"))(oE);
        if (e.route.tag === "ForgotPasswordRoute") return Oc(e)(Or("Forgot Password"))(Zx(e));
        if (e.route.tag === "ResetPasswordRoute") return Oc(e)(Or("Reset Password"))(rE(e.route._1)(e));
        if (e.route.tag === "LoginRoute") return _;
        if (e.route.tag === "LogoutRoute") return Oc(e)(Or("Logout"))(eE);
        l();
    };
    var aE = function() {
        return window;
    };
    function iE(e) {
        return function() {
            return e.location;
        };
    }
    function lE(e) {
        return function() {
            return e.history;
        };
    }
    var QV = he((()=>{
        let e = ph(Jg.firebaseConfig)({
            useEmulator: !1
        });
        return ()=>{
            e();
            let _ = W$(), r = xm(), t = aE(), n = lE(t)(), s = iE(t)();
            return {
                firebaseServices: {
                    auth: _,
                    db: r
                },
                history: n,
                location: s,
                ...Jg
            };
        };
    })()), dE = (()=>{
        let e = Bv(rp, fr(QV)((_)=>fr(Th(_)((r)=>D)(v_.bind((()=>{
                let r = nn.bimap((t)=>({
                        type: "authError",
                        value: t
                    }))(re)(ri(K$(f_)(D)(_.firebaseServices.auth)));
                return (t)=>r;
            })())((r)=>{
                if (r.tag === "Nothing") return ae.pure(D);
                if (r.tag === "Just") return Vd.map(R2)(u0.loadUser(r._1));
                l();
            })))((r)=>he((()=>{
                    let t = Ug(_.location);
                    return ()=>{
                        let n = t(), s = li($s._2)(n), c = Hv.bimap(re)(te(Th(_)((i)=>R("Just", X("AppError", i)))));
                        return LS(Hb)("body")(D)({
                            init: c(bb(Jg)(s.tag === "Right" ? s._1 : Ud)(r)),
                            view: cE,
                            update: (i)=>(d)=>c(Rx(i)(d)),
                            subscribe: Fx
                        })();
                    };
                })()))));
        return ()=>{
            e().run();
        };
    })();
    dE();
})(); /*! Bundled license information:

papaparse/papaparse.min.js:
  (* @license
  Papa Parse
  v5.4.1
  https://github.com/mholt/PapaParse
  License: MIT
  *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2021 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/util/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/component/dist/esm/index.esm2017.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/logger/dist/esm/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/app/dist/esm/index.esm2017.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/app/dist/esm/index.esm2017.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2023 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/app/dist/esm/index.esm2017.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/app/dist/esm/index.esm2017.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/webchannel-wrapper/dist/bloom-blob/esm/bloom_blob_es2018.js:
  (** @license
  Copyright The Closure Library Authors.
  SPDX-License-Identifier: Apache-2.0
  *)
  (** @license
  
   Copyright The Closure Library Authors.
   SPDX-License-Identifier: Apache-2.0
  *)

@firebase/webchannel-wrapper/dist/webchannel-blob/esm/webchannel_blob_es2018.js:
  (** @license
  Copyright The Closure Library Authors.
  SPDX-License-Identifier: Apache-2.0
  *)
  (** @license
  
   Copyright The Closure Library Authors.
   SPDX-License-Identifier: Apache-2.0
  *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
  * @license
  * Copyright 2020 Google LLC
  *
  * Licensed under the Apache License, Version 2.0 (the "License");
  * you may not use this file except in compliance with the License.
  * You may obtain a copy of the License at
  *
  *   http://www.apache.org/licenses/LICENSE-2.0
  *
  * Unless required by applicable law or agreed to in writing, software
  * distributed under the License is distributed on an "AS IS" BASIS,
  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  * See the License for the specific language governing permissions and
  * limitations under the License.
  *)
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2021 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2018 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2023 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2018 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2023 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2023 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2018 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2023 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2023 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2023 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2023 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/firestore/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2023 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

firebase/app/dist/esm/index.esm.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/functions/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/functions/dist/index.esm2017.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2022 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2023 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2020 Google LLC.
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2021 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2019 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)

@firebase/auth/dist/esm2017/index-54738136.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2020 Google LLC.
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
  (**
   * @license
   * Copyright 2021 Google LLC
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *)
*/ 


//# sourceMappingURL=index.2efcebe0.js.map
